(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e0b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e0b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cYS4f", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $9735075334ef484d$export$ffb0004e005737fa, (v) => $9735075334ef484d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $9735075334ef484d$export$34b9dba7ce09269b, (v) => $9735075334ef484d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $9735075334ef484d$export$25062201e9e25d76, (v) => $9735075334ef484d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9735075334ef484d$export$ffb0004e005737fa;
var $9735075334ef484d$export$34b9dba7ce09269b;
var $9735075334ef484d$export$25062201e9e25d76;
'use strict';

(function() {
    'use strict';
    var React = (parcelRequire("63Xef"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = '' + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = '' + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    var didWarnAboutKeySpread = {};
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (hasOwnProperty.call(props, 'key')) {
            var componentName = getComponentNameFromType(type);
            var keys = Object.keys(props).filter(function(k) {
                return k !== 'key';
            });
            var beforeExample = keys.length > 0 ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}' : '{key: someKey}';
            if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}';
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $9735075334ef484d$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $9735075334ef484d$export$34b9dba7ce09269b = jsx;
    $9735075334ef484d$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("63Xef", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bBxtA"));

});
parcelRegister("bBxtA", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = '18.3.1';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ''; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || '';
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, 'forceUpdate');
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, 'replaceState');
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, 'setState');
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== 'object' && typeof partialState !== 'function' && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, 'setState');
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
    };
    var deprecatedAPIs = {
        isMounted: [
            'isMounted',
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            'replaceState',
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = '' + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = '' + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = '.';
    var SUBSEPARATOR = ':';
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            '=': '=0',
            ':': '=2'
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return '$' + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, '$&/');
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === 'object' && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape('' + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === 'undefined' || type === 'boolean') // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case 'string':
            case 'number':
                invokeCallback = true;
                break;
            case 'object':
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = '';
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + '/';
                mapIntoArray(mappedChild, array, escapedChildKey, '', function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === 'function') {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === 'object') {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, '', '', function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error('React.Children.only expected to receive a single React element child.');
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!('default' in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'defaultProps', {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'propTypes', {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== 'function') error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
        else if (render.length !== 0 && render.length !== 2) error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? 'null' : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, 'type', {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, 'type', {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ('require' + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, 'timers').setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === 'undefined') error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === 'object' && typeof result.then === 'function') {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== 'undefined') // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.act = act;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("pGDnY", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $04d368305abc3094$export$ae55be85d98224ed, (v) => $04d368305abc3094$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $04d368305abc3094$export$d39a5bbd09211389, (v) => $04d368305abc3094$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $04d368305abc3094$export$882461b6382ed46c, (v) => $04d368305abc3094$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $04d368305abc3094$export$466bfc07425424d5, (v) => $04d368305abc3094$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $04d368305abc3094$export$cd75ccfd720a3cd4, (v) => $04d368305abc3094$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $04d368305abc3094$export$fa8d919ba61d84db, (v) => $04d368305abc3094$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $04d368305abc3094$export$757ceba2d55c277e, (v) => $04d368305abc3094$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $04d368305abc3094$export$b3890eb0ae9dca99, (v) => $04d368305abc3094$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $04d368305abc3094$export$502457920280e6be, (v) => $04d368305abc3094$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $04d368305abc3094$export$c78a37762a8d58e1, (v) => $04d368305abc3094$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $04d368305abc3094$export$dc54d992c10e8a18, (v) => $04d368305abc3094$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $04d368305abc3094$export$83d89fbfd8236492, (v) => $04d368305abc3094$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $04d368305abc3094$export$ae55be85d98224ed;
var $04d368305abc3094$export$d39a5bbd09211389;
var $04d368305abc3094$export$882461b6382ed46c;
var $04d368305abc3094$export$466bfc07425424d5;
var $04d368305abc3094$export$cd75ccfd720a3cd4;
var $04d368305abc3094$export$fa8d919ba61d84db;
var $04d368305abc3094$export$757ceba2d55c277e;
var $04d368305abc3094$export$b3890eb0ae9dca99;
var $04d368305abc3094$export$502457920280e6be;
var $04d368305abc3094$export$c78a37762a8d58e1;
var $04d368305abc3094$export$dc54d992c10e8a18;
var $04d368305abc3094$export$83d89fbfd8236492;
'use strict';


(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("63Xef"));
    var Scheduler = (parcelRequire("ijJaq"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning('warn', format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning('error', format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = true; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + 'Capture', dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === 'onDoubleClick') possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error('Invalid attribute name: `%s`', attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case 'function':
            case 'symbol':
                // eslint-disable-line
                return true;
            case 'boolean':
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== 'data-' && prefix !== 'aria-';
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        'children',
        'dangerouslySetInnerHTML',
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue',
        'defaultChecked',
        'innerHTML',
        'suppressContentEditableWarning',
        'suppressHydrationWarning',
        'style'
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            'acceptCharset',
            'accept-charset'
        ],
        [
            'className',
            'class'
        ],
        [
            'htmlFor',
            'for'
        ],
        [
            'httpEquiv',
            'http-equiv'
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        'contentEditable',
        'draggable',
        'spellCheck',
        'value'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        'autoReverse',
        'externalResourcesRequired',
        'focusable',
        'preserveAlpha'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        'allowFullScreen',
        'async',
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus',
        'autoPlay',
        'controls',
        'default',
        'defer',
        'disabled',
        'disablePictureInPicture',
        'disableRemotePlayback',
        'formNoValidate',
        'hidden',
        'loop',
        'noModule',
        'noValidate',
        'open',
        'playsInline',
        'readOnly',
        'required',
        'reversed',
        'scoped',
        'seamless',
        'itemScope'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        'checked',
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple',
        'muted',
        'selected' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        'capture',
        'download' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        'cols',
        'rows',
        'size',
        'span' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        'rowSpan',
        'start'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        'accent-height',
        'alignment-baseline',
        'arabic-form',
        'baseline-shift',
        'cap-height',
        'clip-path',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'dominant-baseline',
        'enable-background',
        'fill-opacity',
        'fill-rule',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'horiz-adv-x',
        'horiz-origin-x',
        'image-rendering',
        'letter-spacing',
        'lighting-color',
        'marker-end',
        'marker-mid',
        'marker-start',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'pointer-events',
        'rendering-intent',
        'shape-rendering',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'underline-position',
        'underline-thickness',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'v-hanging',
        'v-ideographic',
        'v-mathematical',
        'vector-effect',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'word-spacing',
        'writing-mode',
        'xmlns:xlink',
        'x-height' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
    }); // String SVG attributes with the xml namespace.
    [
        'xml:base',
        'xml:lang',
        'xml:space' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        'tabIndex',
        'crossOrigin'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = 'xlinkHref';
    properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
    [
        'src',
        'href',
        'action',
        'formAction'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL('' + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === '') return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === '' + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === '' + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === '' + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, '' + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : '';
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = '';
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = '' + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_SCOPE_TYPE = Symbol.for('react.scope');
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for('react.debug_trace_mode');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for('react.legacy_hidden');
    var REACT_CACHE_TYPE = Symbol.for('react.cache');
    var REACT_TRACING_MARKER_TYPE = Symbol.for('react.tracing_marker');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame('Lazy');
            case SuspenseComponent:
                return describeBuiltInComponentFrame('Suspense');
            case SuspenseListComponent:
                return describeBuiltInComponentFrame('SuspenseList');
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return '';
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = '';
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return '\nError generating stack: ' + x.message + '\n' + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || 'Context';
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return 'Cache';
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + '.Consumer';
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + '.Provider';
            case DehydratedFragment:
                return 'DehydratedFragment';
            case ForwardRef:
                return getWrappedName$1(type, type.render, 'ForwardRef');
            case Fragment:
                return 'Fragment';
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return 'Portal';
            case HostRoot:
                return 'Root';
            case HostText:
                return 'Text';
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return 'StrictMode';
                return 'Mode';
            case OffscreenComponent:
                return 'Offscreen';
            case Profiler:
                return 'Profiler';
            case ScopeComponent:
                return 'Scope';
            case SuspenseComponent:
                return 'Suspense';
            case SuspenseListComponent:
                return 'SuspenseList';
            case TracingMarkerComponent:
                return 'TracingMarker';
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === 'function') return type.displayName || type.name || null;
                if (typeof type === 'string') return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== 'undefined') return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return '';
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case 'boolean':
            case 'number':
            case 'string':
            case 'undefined':
                return value;
            case 'object':
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return '';
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = '';
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? 'true' : 'false';
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = '' + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = '' + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);
        if (typeof doc === 'undefined') return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps('input', props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, 'checked', checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === 'number') {
                if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === 'submit' || type === 'reset') {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute('value');
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty('value')) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty('defaultValue')) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
            var type = props.type;
            var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== '') node.name = '';
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== '') node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === 'radio' && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, 'name');
            var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === 'object' && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === 'string' || typeof child === 'number') return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute('value', toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return '\n\nCheck the render method of `' + ownerName + '`.';
        return '';
    }
    var valuePropNames = [
        'value',
        'defaultValue'
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps('select', props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue['$' + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty('$' + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error('`dangerouslySetInnerHTML` does not make sense on <textarea>.');
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps('textarea', props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error('If you supply `defaultValue` on a <textarea>, do not pass children.');
                if (isArray(children)) {
                    if (children.length > 1) throw new Error('<textarea> can only have at most one child.');
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = '';
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== '' && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg'; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case 'svg':
                return SVG_NAMESPACE;
            case 'math':
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!('innerHTML' in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement('div');
                reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            'animationDelay',
            'animationDirection',
            'animationDuration',
            'animationFillMode',
            'animationIterationCount',
            'animationName',
            'animationPlayState',
            'animationTimingFunction'
        ],
        background: [
            'backgroundAttachment',
            'backgroundClip',
            'backgroundColor',
            'backgroundImage',
            'backgroundOrigin',
            'backgroundPositionX',
            'backgroundPositionY',
            'backgroundRepeat',
            'backgroundSize'
        ],
        backgroundPosition: [
            'backgroundPositionX',
            'backgroundPositionY'
        ],
        border: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth',
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth',
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth',
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth',
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderBlockEnd: [
            'borderBlockEndColor',
            'borderBlockEndStyle',
            'borderBlockEndWidth'
        ],
        borderBlockStart: [
            'borderBlockStartColor',
            'borderBlockStartStyle',
            'borderBlockStartWidth'
        ],
        borderBottom: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth'
        ],
        borderColor: [
            'borderBottomColor',
            'borderLeftColor',
            'borderRightColor',
            'borderTopColor'
        ],
        borderImage: [
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth'
        ],
        borderInlineEnd: [
            'borderInlineEndColor',
            'borderInlineEndStyle',
            'borderInlineEndWidth'
        ],
        borderInlineStart: [
            'borderInlineStartColor',
            'borderInlineStartStyle',
            'borderInlineStartWidth'
        ],
        borderLeft: [
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth'
        ],
        borderRadius: [
            'borderBottomLeftRadius',
            'borderBottomRightRadius',
            'borderTopLeftRadius',
            'borderTopRightRadius'
        ],
        borderRight: [
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth'
        ],
        borderStyle: [
            'borderBottomStyle',
            'borderLeftStyle',
            'borderRightStyle',
            'borderTopStyle'
        ],
        borderTop: [
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderWidth: [
            'borderBottomWidth',
            'borderLeftWidth',
            'borderRightWidth',
            'borderTopWidth'
        ],
        columnRule: [
            'columnRuleColor',
            'columnRuleStyle',
            'columnRuleWidth'
        ],
        columns: [
            'columnCount',
            'columnWidth'
        ],
        flex: [
            'flexBasis',
            'flexGrow',
            'flexShrink'
        ],
        flexFlow: [
            'flexDirection',
            'flexWrap'
        ],
        font: [
            'fontFamily',
            'fontFeatureSettings',
            'fontKerning',
            'fontLanguageOverride',
            'fontSize',
            'fontSizeAdjust',
            'fontStretch',
            'fontStyle',
            'fontVariant',
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition',
            'fontWeight',
            'lineHeight'
        ],
        fontVariant: [
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition'
        ],
        gap: [
            'columnGap',
            'rowGap'
        ],
        grid: [
            'gridAutoColumns',
            'gridAutoFlow',
            'gridAutoRows',
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        gridArea: [
            'gridColumnEnd',
            'gridColumnStart',
            'gridRowEnd',
            'gridRowStart'
        ],
        gridColumn: [
            'gridColumnEnd',
            'gridColumnStart'
        ],
        gridColumnGap: [
            'columnGap'
        ],
        gridGap: [
            'columnGap',
            'rowGap'
        ],
        gridRow: [
            'gridRowEnd',
            'gridRowStart'
        ],
        gridRowGap: [
            'rowGap'
        ],
        gridTemplate: [
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        listStyle: [
            'listStyleImage',
            'listStylePosition',
            'listStyleType'
        ],
        margin: [
            'marginBottom',
            'marginLeft',
            'marginRight',
            'marginTop'
        ],
        marker: [
            'markerEnd',
            'markerMid',
            'markerStart'
        ],
        mask: [
            'maskClip',
            'maskComposite',
            'maskImage',
            'maskMode',
            'maskOrigin',
            'maskPositionX',
            'maskPositionY',
            'maskRepeat',
            'maskSize'
        ],
        maskPosition: [
            'maskPositionX',
            'maskPositionY'
        ],
        outline: [
            'outlineColor',
            'outlineStyle',
            'outlineWidth'
        ],
        overflow: [
            'overflowX',
            'overflowY'
        ],
        padding: [
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'paddingTop'
        ],
        placeContent: [
            'alignContent',
            'justifyContent'
        ],
        placeItems: [
            'alignItems',
            'justifyItems'
        ],
        placeSelf: [
            'alignSelf',
            'justifySelf'
        ],
        textDecoration: [
            'textDecorationColor',
            'textDecorationLine',
            'textDecorationStyle'
        ],
        textEmphasis: [
            'textEmphasisColor',
            'textEmphasisStyle'
        ],
        transition: [
            'transitionDelay',
            'transitionDuration',
            'transitionProperty',
            'transitionTimingFunction'
        ],
        wordWrap: [
            'overflowWrap'
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        'Webkit',
        'ms',
        'Moz',
        'O'
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === 'boolean' || value === '';
        if (isEmpty) return '';
        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ('' + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported style property %s. Did you mean %s?', name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, 'ms-')));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error('`NaN` is an invalid value for the `%s` css style property.', name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error('`Infinity` is an invalid value for the `%s` css style property.', name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf('-') > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === 'number') {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = '';
        var delimiter = '';
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf('--') === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ';';
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf('--') === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === 'float') styleName = 'cssFloat';
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + ',' + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = '__html';
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + 'use `dangerouslySetInnerHTML`.');
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
            if (typeof props.dangerouslySetInnerHTML !== 'object' || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== 'object') throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) return typeof props.is === 'string';
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        class: 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        default: 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        disableremoteplayback: 'disableRemotePlayback',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        enterkeyhint: 'enterKeyHint',
        for: 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        imagesizes: 'imageSizes',
        imagesrcset: 'imageSrcSet',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        // SVG
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        in: 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        typeof: 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
    };
    var ariaProperties = {
        'aria-current': 0,
        // state
        'aria-description': 0,
        'aria-details': 0,
        'aria-disabled': 0,
        // state
        'aria-hidden': 0,
        // state
        'aria-invalid': 0,
        // state
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        // Widget Attributes
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        // Live Region Attributes
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        // Drag-and-Drop Attributes
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        // Relationship Attributes
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== 'input' && type !== 'textarea' && type !== 'select') return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === 'select' && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error('Unknown event handler property `%s`. It will be ignored.', name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === 'innerhtml') {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'aria') {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'number' && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== 'function') throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== 'function') throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, 'passive', {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
        var fakeNode = document.createElement('react');
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === 'undefined' || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent('Event');
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === 'object') try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers
            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, 'event', windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener('error', handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || 'A component');
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error('Unable to find node on an unmounted component.');
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error('Unable to find node on an unmounted component.');
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error('Unable to find node on an unmounted component.');
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error('Unable to find node on an unmounted component.');
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error('React instrumentation encountered an error: %s.', err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === 'function') try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === 'function') {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === 'function') try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === 'function') injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === 'function') injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === 'function') injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === 'function') injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === 'function') injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === 'function') injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === 'function') injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === 'function') injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === 'function') injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === 'function') injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === 'function') injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === 'function') injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === 'function') injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === 'function') injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === 'function') injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === 'function') injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === 'function') injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === 'function') injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === 'function') injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === 'function') injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === 'function') injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === 'function') injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === 'function') injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === 'function') injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return 'Sync';
        if (lane & InputContinuousHydrationLane) return 'InputContinuousHydration';
        if (lane & InputContinuousLane) return 'InputContinuous';
        if (lane & DefaultHydrationLane) return 'DefaultHydration';
        if (lane & DefaultLane) return 'Default';
        if (lane & TransitionHydrationLane) return 'TransitionHydration';
        if (lane & TransitionLanes) return 'Transition';
        if (lane & RetryLanes) return 'Retry';
        if (lane & SelectiveHydrationLane) return 'SelectiveHydration';
        if (lane & IdleHydrationLane) return 'IdleHydration';
        if (lane & IdleLane) return 'Idle';
        if (lane & OffscreenLane) return 'Offscreen';
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error('Should have found matching lanes. This is a bug in React.');
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error('Should have found matching lanes. This is a bug in React.');
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        'mousedown',
        'mouseup',
        'touchcancel',
        'touchend',
        'touchstart',
        'auxclick',
        'dblclick',
        'pointercancel',
        'pointerdown',
        'pointerup',
        'dragend',
        'dragstart',
        'drop',
        'compositionend',
        'compositionstart',
        'keydown',
        'keypress',
        'keyup',
        'input',
        'textInput',
        'copy',
        'cut',
        'paste',
        'click',
        'change',
        'contextmenu',
        'reset',
        'submit'
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case 'focusin':
            case 'focusout':
                queuedFocus = null;
                break;
            case 'dragenter':
            case 'dragleave':
                queuedDrag = null;
                break;
            case 'mouseover':
            case 'mouseout':
                queuedMouse = null;
                break;
            case 'pointerover':
            case 'pointerout':
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case 'focusin':
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case 'dragenter':
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case 'mouseover':
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case 'pointerover':
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case 'gotpointercapture':
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case 'cancel':
            case 'click':
            case 'close':
            case 'contextmenu':
            case 'copy':
            case 'cut':
            case 'auxclick':
            case 'dblclick':
            case 'dragend':
            case 'dragstart':
            case 'drop':
            case 'focusin':
            case 'focusout':
            case 'input':
            case 'invalid':
            case 'keydown':
            case 'keypress':
            case 'keyup':
            case 'mousedown':
            case 'mouseup':
            case 'paste':
            case 'pause':
            case 'play':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
            case 'ratechange':
            case 'reset':
            case 'resize':
            case 'seeked':
            case 'submit':
            case 'touchcancel':
            case 'touchend':
            case 'touchstart':
            case 'volumechange':
            // eslint-disable-next-line no-fallthrough
            case 'change':
            case 'selectionchange':
            case 'textInput':
            case 'compositionstart':
            case 'compositionend':
            case 'compositionupdate':
            // eslint-disable-next-line no-fallthrough
            case 'beforeblur':
            case 'afterblur':
            // eslint-disable-next-line no-fallthrough
            case 'beforeinput':
            case 'blur':
            case 'fullscreenchange':
            case 'focus':
            case 'hashchange':
            case 'popstate':
            case 'select':
            case 'selectstart':
                return DiscreteEventPriority;
            case 'drag':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'mousemove':
            case 'mouseout':
            case 'mouseover':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'scroll':
            case 'toggle':
            case 'touchmove':
            case 'wheel':
            // eslint-disable-next-line no-fallthrough
            case 'mouseenter':
            case 'mouseleave':
            case 'pointerenter':
            case 'pointerleave':
                return ContinuousEventPriority;
            case 'message':
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ('value' in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ('charCode' in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== 'unknown') event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== 'unknown') // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === 'mousemove') {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ('movementX' in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ('movementY' in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== 'Unidentified') return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === 'keypress') {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        return '';
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === 'keypress') return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === 'keypress') return getEventCharCode(event);
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return 'deltaX' in event ? event.deltaX : 'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return 'deltaY' in event ? event.deltaY : 'wheelDeltaY' in event ? -event.wheelDeltaY : 'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
    var documentMode = null;
    if (canUseDOM && 'documentMode' in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste'
        ]);
        registerTwoPhaseEvent('onCompositionEnd', [
            'compositionend',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionStart', [
            'compositionstart',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionUpdate', [
            'compositionupdate',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case 'compositionstart':
                return 'onCompositionStart';
            case 'compositionend':
                return 'onCompositionEnd';
            case 'compositionupdate':
                return 'onCompositionUpdate';
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case 'keyup':
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case 'keydown':
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === 'object' && 'data' in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = 'onCompositionStart';
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = 'onCompositionEnd';
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === 'onCompositionStart') isComposing = initialize(nativeEventTarget);
            else if (eventType === 'onCompositionEnd') {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case 'compositionend':
                return getDataFromCustomEvent(nativeEvent);
            case 'keypress':
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case 'textInput':
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case 'paste':
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case 'keypress':
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case 'compositionend':
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === 'input') return !!supportedInputTypes[elem.type];
        if (nodeName === 'textarea') return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = 'on' + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent('onChange', [
            'change',
            'click',
            'focusin',
            'focusout',
            'input',
            'keydown',
            'keyup',
            'selectionchange'
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, 'onChange');
        if (listeners.length > 0) {
            var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === 'change') return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === 'focusin') {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === 'focusout') stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === 'click') return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === 'input' || domEventName === 'change') return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== 'number') return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, 'number', node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === 'focusout') handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent('onMouseEnter', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onMouseLeave', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onPointerEnter', [
            'pointerout',
            'pointerover'
        ]);
        registerDirectEvent('onPointerLeave', [
            'pointerout',
            'pointerover'
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
        var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = 'onMouseLeave';
        var enterEventType = 'onMouseEnter';
        var eventTypePrefix = 'mouse';
        if (domEventName === 'pointerout' || domEventName === 'pointerover') {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = 'onPointerLeave';
            enterEventType = 'onPointerEnter';
            eventTypePrefix = 'pointer';
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === 'function' ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ('contains' in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === 'function') priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ('selectionStart' in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ('selectionStart' in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent('onSelect', [
            'focusout',
            'contextmenu',
            'dragend',
            'focusin',
            'keydown',
            'keyup',
            'mousedown',
            'mouseup',
            'selectionchange'
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');
            if (listeners.length > 0) {
                var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case 'focusin':
                if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case 'focusout':
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case 'mousedown':
                mouseDown = true;
                break;
            case 'contextmenu':
            case 'mouseup':
            case 'dragend':
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case 'selectionchange':
                if (skipSelectionChangeEvent) break;
            // falls through
            case 'keydown':
            case 'keyup':
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!('AnimationEvent' in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!('TransitionEvent' in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName('animationend');
    var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
    var ANIMATION_START = getVendorPrefixedEventName('animationstart');
    var TRANSITION_END = getVendorPrefixedEventName('transitionend');
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        'abort',
        'auxClick',
        'cancel',
        'canPlay',
        'canPlayThrough',
        'click',
        'close',
        'contextMenu',
        'copy',
        'cut',
        'drag',
        'dragEnd',
        'dragEnter',
        'dragExit',
        'dragLeave',
        'dragOver',
        'dragStart',
        'drop',
        'durationChange',
        'emptied',
        'encrypted',
        'ended',
        'error',
        'gotPointerCapture',
        'input',
        'invalid',
        'keyDown',
        'keyPress',
        'keyUp',
        'load',
        'loadedData',
        'loadedMetadata',
        'loadStart',
        'lostPointerCapture',
        'mouseDown',
        'mouseMove',
        'mouseOut',
        'mouseOver',
        'mouseUp',
        'paste',
        'pause',
        'play',
        'playing',
        'pointerCancel',
        'pointerDown',
        'pointerMove',
        'pointerOut',
        'pointerOver',
        'pointerUp',
        'progress',
        'rateChange',
        'reset',
        'resize',
        'seeked',
        'seeking',
        'stalled',
        'submit',
        'suspend',
        'timeUpdate',
        'touchCancel',
        'touchEnd',
        'touchStart',
        'volumeChange',
        'scroll',
        'toggle',
        'touchMove',
        'waiting',
        'wheel'
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, 'on' + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, 'onAnimationEnd');
        registerSimpleEvent(ANIMATION_ITERATION, 'onAnimationIteration');
        registerSimpleEvent(ANIMATION_START, 'onAnimationStart');
        registerSimpleEvent('dblclick', 'onDoubleClick');
        registerSimpleEvent('focusin', 'onFocus');
        registerSimpleEvent('focusout', 'onBlur');
        registerSimpleEvent(TRANSITION_END, 'onTransitionEnd');
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case 'keypress':
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case 'keydown':
            case 'keyup':
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case 'focusin':
                reactEventType = 'focus';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'focusout':
                reactEventType = 'blur';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'beforeblur':
            case 'afterblur':
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'click':
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case 'auxclick':
            case 'dblclick':
            case 'mousedown':
            case 'mousemove':
            case 'mouseup':
            /* falls through */ case 'mouseout':
            case 'mouseover':
            case 'contextmenu':
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case 'drag':
            case 'dragend':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'dragstart':
            case 'drop':
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case 'touchcancel':
            case 'touchend':
            case 'touchmove':
            case 'touchstart':
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case 'scroll':
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case 'wheel':
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case 'copy':
            case 'cut':
            case 'paste':
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerup':
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === 'scroll';
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        'abort',
        'canplay',
        'canplaythrough',
        'durationchange',
        'emptied',
        'encrypted',
        'ended',
        'error',
        'loadeddata',
        'loadedmetadata',
        'loadstart',
        'pause',
        'play',
        'playing',
        'progress',
        'ratechange',
        'resize',
        'seeked',
        'seeking',
        'stalled',
        'suspend',
        'timeupdate',
        'volumechange',
        'waiting'
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        'cancel',
        'close',
        'invalid',
        'load',
        'scroll',
        'toggle'
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || 'unknown-event';
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== 'selectionchange') {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent('selectionchange', false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + 'Capture' : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + 'Capture';
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? 'capture' : 'bubble');
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
    var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
    var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
    var AUTOFOCUS = 'autoFocus';
    var CHILDREN = 'children';
    var STYLE = 'style';
    var HTML$1 = '__html';
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error('Extra attributes from the server: %s', names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === 'string' ? markup : '' + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error('Text content does not match server-rendered HTML.');
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string') {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== 'textarea' || nextProp !== '';
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === 'number') setTextContent(domElement, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === 'script') {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement('div');
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === 'string') // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === 'select') {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                props = rawProps;
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                props = rawProps;
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                props = rawProps;
                break;
            case 'input':
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'option':
                postMountWrapper$1(domElement, rawProps);
                break;
            case 'select':
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case 'input':
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'select':
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'textarea':
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = '';
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = '';
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string' || typeof nextProp === 'number') (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case 'input':
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case 'textarea':
                updateWrapper$1(domElement, nextRawProps);
                break;
            case 'select':
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                break;
            case 'input':
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case 'value':
                    break;
                case 'checked':
                    break;
                case 'selected':
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === 'string') {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === 'number') {
                    if (domElement.textContent !== '' + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            '' + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === 'boolean') {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute('style');
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'select':
            case 'option':
                break;
            default:
                if (typeof rawProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === '') // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case 'input':
                restoreControlledState(domElement, props);
                return;
            case 'textarea':
                restoreControlledState$2(domElement, props);
                return;
            case 'select':
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        'address',
        'applet',
        'area',
        'article',
        'aside',
        'base',
        'basefont',
        'bgsound',
        'blockquote',
        'body',
        'br',
        'button',
        'caption',
        'center',
        'col',
        'colgroup',
        'dd',
        'details',
        'dir',
        'div',
        'dl',
        'dt',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'iframe',
        'img',
        'input',
        'isindex',
        'li',
        'link',
        'listing',
        'main',
        'marquee',
        'menu',
        'menuitem',
        'meta',
        'nav',
        'noembed',
        'noframes',
        'noscript',
        'object',
        'ol',
        'p',
        'param',
        'plaintext',
        'pre',
        'script',
        'section',
        'select',
        'source',
        'style',
        'summary',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'title',
        'tr',
        'track',
        'ul',
        'wbr',
        'xmp'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        'applet',
        'caption',
        'html',
        'table',
        'td',
        'th',
        'marquee',
        'object',
        'template',
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        'foreignObject',
        'desc',
        'title'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        'button'
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        'dd',
        'dt',
        'li',
        'option',
        'optgroup',
        'p',
        'rp',
        'rt'
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === 'form') ancestorInfo.formTag = info;
        if (tag === 'a') ancestorInfo.aTagInScope = info;
        if (tag === 'button') ancestorInfo.buttonTagInScope = info;
        if (tag === 'nobr') ancestorInfo.nobrTagInScope = info;
        if (tag === 'p') ancestorInfo.pTagInButtonScope = info;
        if (tag === 'li') ancestorInfo.listItemTagAutoclosing = info;
        if (tag === 'dd' || tag === 'dt') ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case 'select':
                return tag === 'option' || tag === 'optgroup' || tag === '#text';
            case 'optgroup':
                return tag === 'option' || tag === '#text';
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case 'option':
                return tag === '#text';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case 'tr':
                return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case 'tbody':
            case 'thead':
            case 'tfoot':
                return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case 'colgroup':
                return tag === 'col' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case 'table':
                return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case 'head':
                return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case 'html':
                return tag === 'head' || tag === 'body' || tag === 'frameset';
            case 'frameset':
                return tag === 'frame';
            case '#document':
                return tag === 'html';
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
            case 'rp':
            case 'rt':
                return impliedEndTags.indexOf(parentTag) === -1;
            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return ancestorInfo.pTagInButtonScope;
            case 'form':
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case 'li':
                return ancestorInfo.listItemTagAutoclosing;
            case 'dd':
            case 'dt':
                return ancestorInfo.dlItemTagAutoclosing;
            case 'button':
                return ancestorInfo.buttonTagInScope;
            case 'a':
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case 'nobr':
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error('validateDOMNesting: when childText is passed, childTag should be null');
            childTag = '#text';
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = '';
        if (childTag === '#text') {
            if (/\S/.test(childText)) tagDisplayName = 'Text nodes';
            else {
                tagDisplayName = 'Whitespace text nodes';
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = '<' + childTag + '>';
        if (invalidParent) {
            var info = '';
            if (ancestorTag === 'table' && childTag === 'tr') info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
    var SUSPENSE_START_DATA = '$';
    var SUSPENSE_END_DATA = '/$';
    var SUSPENSE_PENDING_START_DATA = '$?';
    var SUSPENSE_FALLBACK_START_DATA = '$!';
    var STYLE$1 = 'style';
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, '');
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                return !!props.autoFocus;
            case 'img':
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === 'function' ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === 'function' ? queueMicrotask : typeof localPromise !== 'undefined' ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                if (newProps.autoFocus) domElement.focus();
                return;
            case 'img':
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, '');
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === 'function') style.setProperty('display', 'none', 'important');
        else style.display = 'none';
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = '';
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== 'head' && parentType !== 'body';
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error('An error occurred during hydration. The server HTML was replaced with client content in <%s>.', parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = '__reactFiber$' + randomKey;
    var internalPropsKey = '__reactProps$' + randomKey;
    var internalContainerInstanceKey = '__reactContainer$' + randomKey;
    var internalEventHandlersKey = '__reactEvents$' + randomKey;
    var internalEventHandlerListenersKey = '__reactListeners$' + randomKey;
    var internalEventHandlesSetKey = '__reactHandles$' + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error('getNodeFromInstance: Invalid argument.');
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error('Unexpected pop.');
            return;
        }
        if (fiber !== fiberStack[index]) error('Unexpected Fiber popped.');
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || 'Unknown';
        checkPropTypes(contextTypes, context, 'context', name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== 'function') {
            var componentName = getComponentNameFromFiber(fiber) || 'Unknown';
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
        }
        var name = getComponentNameFromFiber(fiber) || 'Unknown';
        checkPropTypes(childContextTypes, childContext, 'child context', name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = '';
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error('We should not be hydrating here. This is a bug in React. Please file a bug.');
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(', ');
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === 'function') pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === 'function') pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== 'object') return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== 'object') throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function isReactClass(type) {
        return type.prototype && type.prototype.isReactComponent;
    }
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self) && // Will already throw with "Function components cannot have string refs"
            !(element._owner && element._owner.tag !== ClassComponent) && // Will already warn with "Function components cannot be given refs"
            !(typeof element.type === 'function' && !isReactClass(element.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
            element._owner) {
                var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
                if (!didWarnAboutStringRefs[componentName]) {
                    error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + 'bug in React. Please file an issue.');
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, 'ref');
                var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== 'string') throw new Error('Expected ref to be a function, a string, an object returned by React.createRef(), or null.');
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + ' the following reasons:\n' + '1. You may be adding a ref to a function component\n' + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + '3. You have multiple copies of React loaded\n' + 'See https://reactjs.org/link/refs-must-have-owner for more information.');
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : childString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== 'object' || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== 'string') break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== 'function') throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error('An iterable object provided no iterator.');
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error('Resuming work not yet implemented.');
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error('We just came from a parent so we must have had a parent. This is a bug in React.');
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== 'function') throw new Error('Invalid argument passed as callback. Expected a function. Instead ' + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = '';
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += ' ';
                    row += newHookName + '\n';
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error('Rendered more hooks than during the previous render.');
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error('The result of getServerSnapshot should be cached to avoid an infinite loop');
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error('The result of getSnapshot should be cached to avoid an infinite loop');
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error('The result of getSnapshot should be cached to avoid an infinite loop');
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty('current')) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ':' + identifierPrefix + 'R' + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += 'H' + localId.toString(32);
            id += ':';
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ':' + identifierPrefix + 'r' + globalClientId.toString(32) + ':';
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    var didWarnAboutLegacyContext$1;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    didWarnAboutLegacyContext$1 = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === 'function') return;
        var key = callerName + '_' + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, '_processChildContext', {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'setState');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'replaceState');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'forceUpdate');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || 'Component');
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || 'Component';
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (ctor.childContextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead\n\n.Learn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (ctor.contextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === 'function') error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || 'A pure component');
        if (typeof instance.componentDidUnmount === 'function') error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === 'function') error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === 'function') error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === 'function') error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === 'function') error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === 'function') error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== 'object' || isArray(_state))) error('%s.state: must be set to an object or null', name);
        if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ('contextType' in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = '';
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== 'object') addendum = ' However, it is set to a ' + typeof contextType + '.';
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = ' Did you accidentally pass the Context.Provider instead?';
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
                else addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || 'Component', addendum);
            }
        }
        if (typeof contextType === 'object' && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentNameFromType(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = 'componentWillMount';
            else if (typeof instance.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = 'componentWillReceiveProps';
            else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = 'componentWillUpdate';
            else if (typeof instance.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || 'Component';
                var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || 'Component');
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === 'function') instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = {};
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === 'function') {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
                if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === 'function') {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
                if (typeof instance.componentWillUpdate === 'function') instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === 'function') instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === 'function') workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === 'function') workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ''; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console['error'](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || 'Anonymous';
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console['error'](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== 'function') // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ''
            });
            if (typeof getDerivedStateFromError !== 'function') // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || 'Unknown');
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    var didWarnAboutDefaultPropsOnFunctionComponent;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    didWarnAboutDefaultPropsOnFunctionComponent = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(type));
            if (Component.defaultProps !== undefined) {
                var componentName = getComponentNameFromType(type) || 'Unknown';
                if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                    error("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", componentName);
                    didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
                }
            }
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === 'hidden' || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error('Simulated error coming from DevTools');
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || 'a component');
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error('Should have a current fiber. This is a bug in React.');
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = '';
        if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) hint = ' Did you wrap a component in React.lazy() more than once?';
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
        }
        if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
            var warningKey = ownerName || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (Component.defaultProps !== undefined) {
            var componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                error("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
                didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
            }
        }
        if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName3 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error('%s: Function components do not support contextType.', _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: 'visible',
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') switch(revealOrder.toLowerCase()){
                case 'together':
                case 'forwards':
                case 'backwards':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case 'forward':
                case 'backward':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === 'function';
        if (isAnArray || isIterable) {
            var type = isAnArray ? 'array' : 'iterable';
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === 'function') {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case 'forwards':
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case 'backwards':
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case 'together':
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!('value' in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== 'function') error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error('Cannot swap the root fiber.');
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error('Expected parent to have a child.');
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error('Expected to find the previous sibling.');
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case 'hidden':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case 'collapsed':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== 'string') {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === 'function') {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === 'function') error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== 'function') {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = 'useLayoutEffect';
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = 'useInsertionEffect';
                        else hookName = 'useEffect';
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === 'function') addendum = '\n\nIt looks like you wrote ' + hookName + '(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + hookName + '(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
                        else addendum = ' You returned: ' + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? 'mount' : 'update';
                if (isCurrentUpdateNested()) phase = 'nested-update';
                if (typeof onPostCommit === 'function') onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? 'mount' : 'update';
                if (isCurrentUpdateNested()) phase = 'nested-update';
                if (typeof onRender === 'function') onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === 'function') onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === 'function') safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === 'function') {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === 'function') error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty('current')) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error('Expected finished root and lanes to be set. This is a bug in React.');
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor('selector.component');
        HAS_PSEUDO_CLASS_TYPE = symbolFor('selector.has_pseudo_class');
        ROLE_TYPE = symbolFor('selector.role');
        TEST_NAME_TYPE = symbolFor('selector.test_id');
        TEXT_TYPE = symbolFor('selector.text');
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== 'undefined';
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error('useInsertionEffect must not schedule updates.');
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error('Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.');
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error('Root did not complete. This is a bug in React.');
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error('Unknown root exit status.');
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error('Root did not complete. This is a bug in React.');
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === 'object' && typeof thrownValue.then === 'function') {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Cannot flush passive effects while already rendering.');
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || 'ReactComponent';
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === 'object' && replayError !== null && replayError._suppressLogging && typeof originalError === 'object' && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || 'Unknown';
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== 'function') return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error('Expected resolveFamily to be set during hot reload.');
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error('Expected to reach root first.');
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === 'function') {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === 'string') fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === 'object' && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = '';
                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== 'string') error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = 'DELETED';
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? 'hydrateRoot()' : 'createRoot()';
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? 'hydrate()' : 'render()';
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = '18.3.1';
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : '' + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === 'function') throw new Error('Unable to find node on an unmounted component.');
            else {
                var keys = Object.keys(component).join(',');
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || 'Component';
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || 'Unknown');
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== 'function') error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn('copyWithRename() expects paths of the same length');
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn('copyWithRename() expects paths to be the same except for the deepest key');
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === 'function' ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console['error'](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error('Cannot update an unmounted root.');
        if (typeof arguments[1] === 'function') error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== 'undefined') error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === 'function') error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error('createRoot(...): Target container is not a DOM element.');
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn('hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.');
            else if (typeof options === 'object' && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error('hydrateRoot(...): Target container is not a DOM element.');
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, '', noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === 'function') {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, '', noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== 'function') error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    var didWarnAboutFindDOMNode = false;
    function findDOMNode(componentOrElement) {
        if (!didWarnAboutFindDOMNode) {
            didWarnAboutFindDOMNode = true;
            error("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node");
        }
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || 'A component');
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error('Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error('Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error('Target container is not a DOM element.');
        if (parentComponent == null || !has(parentComponent)) throw new Error('parentComponent must be a valid React Component');
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    var didWarnAboutUnmountComponentAtNode = false;
    function unmountComponentAtNode(container) {
        if (!didWarnAboutUnmountComponentAtNode) {
            didWarnAboutUnmountComponentAtNode = true;
            error("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot");
        }
        if (!isValidContainerLegacy(container)) throw new Error('unmountComponentAtNode(...): Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error('Target container is not a DOM element.');
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === 'file:' ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ''), 'font-weight:bold');
        }
    }
    $04d368305abc3094$export$ae55be85d98224ed = Internals;
    $04d368305abc3094$export$d39a5bbd09211389 = createPortal$1;
    $04d368305abc3094$export$882461b6382ed46c = createRoot$1;
    $04d368305abc3094$export$466bfc07425424d5 = findDOMNode;
    $04d368305abc3094$export$cd75ccfd720a3cd4 = flushSync$1;
    $04d368305abc3094$export$fa8d919ba61d84db = hydrate;
    $04d368305abc3094$export$757ceba2d55c277e = hydrateRoot$1;
    $04d368305abc3094$export$b3890eb0ae9dca99 = render;
    $04d368305abc3094$export$502457920280e6be = unmountComponentAtNode;
    $04d368305abc3094$export$c78a37762a8d58e1 = batchedUpdates$1;
    $04d368305abc3094$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $04d368305abc3094$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("ijJaq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lCiQQ"));

});
parcelRegister("lCiQQ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $fbcbc511669e7c2c$export$c4744153514ff05d, (v) => $fbcbc511669e7c2c$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $fbcbc511669e7c2c$export$3e506c1ccc9cc1a7, (v) => $fbcbc511669e7c2c$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $fbcbc511669e7c2c$export$e26fe2ed2fa76875, (v) => $fbcbc511669e7c2c$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $fbcbc511669e7c2c$export$502329bbf4b505b1, (v) => $fbcbc511669e7c2c$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $fbcbc511669e7c2c$export$6e3807111c4874c4, (v) => $fbcbc511669e7c2c$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $fbcbc511669e7c2c$export$c27134553091fb3a, (v) => $fbcbc511669e7c2c$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $fbcbc511669e7c2c$export$33ee1acdc04fd2a2, (v) => $fbcbc511669e7c2c$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $fbcbc511669e7c2c$export$b00a404bbd5edef2, (v) => $fbcbc511669e7c2c$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $fbcbc511669e7c2c$export$8352ce38b91d0c62, (v) => $fbcbc511669e7c2c$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $fbcbc511669e7c2c$export$d66a1c1c77bd778b, (v) => $fbcbc511669e7c2c$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $fbcbc511669e7c2c$export$d3dfb8e4810cb555, (v) => $fbcbc511669e7c2c$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $fbcbc511669e7c2c$export$839f9183b0465a69, (v) => $fbcbc511669e7c2c$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $fbcbc511669e7c2c$export$72fdf0e06517287b, (v) => $fbcbc511669e7c2c$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $fbcbc511669e7c2c$export$4b844e58a3e414b4, (v) => $fbcbc511669e7c2c$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $fbcbc511669e7c2c$export$816d2913ae6b83b1, (v) => $fbcbc511669e7c2c$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $fbcbc511669e7c2c$export$61bcfe829111a1d0, (v) => $fbcbc511669e7c2c$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $fbcbc511669e7c2c$export$7ee8c9beb337bc3f, (v) => $fbcbc511669e7c2c$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $fbcbc511669e7c2c$export$b5836b71941fa3ed, (v) => $fbcbc511669e7c2c$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $fbcbc511669e7c2c$export$cf845f2c119da08a, (v) => $fbcbc511669e7c2c$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fbcbc511669e7c2c$export$c4744153514ff05d;
var $fbcbc511669e7c2c$export$3e506c1ccc9cc1a7;
var $fbcbc511669e7c2c$export$e26fe2ed2fa76875;
var $fbcbc511669e7c2c$export$502329bbf4b505b1;
var $fbcbc511669e7c2c$export$6e3807111c4874c4;
var $fbcbc511669e7c2c$export$c27134553091fb3a;
var $fbcbc511669e7c2c$export$33ee1acdc04fd2a2;
var $fbcbc511669e7c2c$export$b00a404bbd5edef2;
var $fbcbc511669e7c2c$export$8352ce38b91d0c62;
var $fbcbc511669e7c2c$export$d66a1c1c77bd778b;
var $fbcbc511669e7c2c$export$d3dfb8e4810cb555;
var $fbcbc511669e7c2c$export$839f9183b0465a69;
var $fbcbc511669e7c2c$export$72fdf0e06517287b;
var $fbcbc511669e7c2c$export$4b844e58a3e414b4;
var $fbcbc511669e7c2c$export$816d2913ae6b83b1;
var $fbcbc511669e7c2c$export$61bcfe829111a1d0;
var $fbcbc511669e7c2c$export$7ee8c9beb337bc3f;
var $fbcbc511669e7c2c$export$b5836b71941fa3ed;
var $fbcbc511669e7c2c$export$cf845f2c119da08a;
'use strict';
(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $fbcbc511669e7c2c$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $fbcbc511669e7c2c$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === 'function' ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === 'function' ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== 'undefined' ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== 'undefined' && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $fbcbc511669e7c2c$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === 'function') {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $fbcbc511669e7c2c$export$c4744153514ff05d();
                if (typeof continuationCallback === 'function') currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $fbcbc511669e7c2c$export$c4744153514ff05d();
        var startTime;
        if (typeof options === 'object' && options !== null) {
            var delay = options.delay;
            if (typeof delay === 'number' && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $fbcbc511669e7c2c$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console['error']("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $fbcbc511669e7c2c$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === 'function') // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== 'undefined') {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($fbcbc511669e7c2c$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $fbcbc511669e7c2c$export$3e506c1ccc9cc1a7 = IdlePriority;
    $fbcbc511669e7c2c$export$e26fe2ed2fa76875 = ImmediatePriority;
    $fbcbc511669e7c2c$export$502329bbf4b505b1 = LowPriority;
    $fbcbc511669e7c2c$export$6e3807111c4874c4 = NormalPriority;
    $fbcbc511669e7c2c$export$c27134553091fb3a = unstable_Profiling;
    $fbcbc511669e7c2c$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $fbcbc511669e7c2c$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $fbcbc511669e7c2c$export$8352ce38b91d0c62 = unstable_continueExecution;
    $fbcbc511669e7c2c$export$d66a1c1c77bd778b = forceFrameRate;
    $fbcbc511669e7c2c$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $fbcbc511669e7c2c$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $fbcbc511669e7c2c$export$72fdf0e06517287b = unstable_next;
    $fbcbc511669e7c2c$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $fbcbc511669e7c2c$export$816d2913ae6b83b1 = unstable_requestPaint;
    $fbcbc511669e7c2c$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $fbcbc511669e7c2c$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $fbcbc511669e7c2c$export$b5836b71941fa3ed = shouldYieldToHost;
    $fbcbc511669e7c2c$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("6uGhf", function(module, exports) {

$parcel$export(module.exports, "color", () => (parcelRequire("7zw1L")).default);
$parcel$export(module.exports, "scaleDiverging", () => (parcelRequire("wUwgT")).default);
$parcel$export(module.exports, "scaleLinear", () => (parcelRequire("aSvrg")).default);

var $5Dc83 = parcelRequire("5Dc83");


parcelRequire("3v9pd");


var $7zw1L = parcelRequire("7zw1L");

















var $wUwgT = parcelRequire("wUwgT");
var $aSvrg = parcelRequire("aSvrg");






parcelRequire("8czdG");
parcelRequire("eFMgS");

});
parcelRegister("5Dc83", function(module, exports) {
var $419a00d4b2a81f4e$export$a8ff84c12d48cfa6 = "d3";
var $419a00d4b2a81f4e$export$83d89fbfd8236492 = "6.7.0";
var $419a00d4b2a81f4e$export$6d59db4903f20f7d = "Data-Driven Documents";
var $419a00d4b2a81f4e$export$eebaaf2b24d91f63 = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var $419a00d4b2a81f4e$export$4cec2234a9c7ce6d = "https://d3js.org";
var $419a00d4b2a81f4e$export$7ff87ebdb8ccbf20 = "BSD-3-Clause";
var $419a00d4b2a81f4e$export$571b02044ddb2ab3 = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var $419a00d4b2a81f4e$export$f22da7240b7add18 = "dist/d3.node.js";
var $419a00d4b2a81f4e$export$101358e655b23e68 = "dist/d3.min.js";
var $419a00d4b2a81f4e$export$a2877c4988dda7ec = "dist/d3.min.js";
var $419a00d4b2a81f4e$export$130be424786e852f = "index.js";
var $419a00d4b2a81f4e$export$69a68d0c8baaec49 = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var $419a00d4b2a81f4e$export$3a444357c5f65f65 = [
    "dist/**/*.js",
    "index.js"
];
var $419a00d4b2a81f4e$export$e0fef70db1fd3806 = {
    "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "yarn test",
    "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v${npm_package_version%%.*}.js && cp ../d3/dist/d3.min.js d3.v${npm_package_version%%.*}.min.js && git add d3.v${npm_package_version%%.*}.js d3.v${npm_package_version%%.*}.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"
};
var $419a00d4b2a81f4e$export$6dbeb9fdb5a4bbaa = {
    "json2module": "0.0",
    "rimraf": "3",
    "rollup": "2",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "5",
    "rollup-plugin-terser": "7",
    "tape": "4",
    "tape-await": "0.1"
};
var $419a00d4b2a81f4e$export$b74ff737e0e298b5 = {
    "d3-array": "2",
    "d3-axis": "2",
    "d3-brush": "2",
    "d3-chord": "2",
    "d3-color": "2",
    "d3-contour": "2",
    "d3-delaunay": "5",
    "d3-dispatch": "2",
    "d3-drag": "2",
    "d3-dsv": "2",
    "d3-ease": "2",
    "d3-fetch": "2",
    "d3-force": "2",
    "d3-format": "2",
    "d3-geo": "2",
    "d3-hierarchy": "2",
    "d3-interpolate": "2",
    "d3-path": "2",
    "d3-polygon": "2",
    "d3-quadtree": "2",
    "d3-random": "2",
    "d3-scale": "3",
    "d3-scale-chromatic": "2",
    "d3-selection": "2",
    "d3-shape": "2",
    "d3-time": "2",
    "d3-time-format": "3",
    "d3-timer": "2",
    "d3-transition": "2",
    "d3-zoom": "2"
};

});

parcelRegister("3v9pd", function(module, exports) {

var $fwQUo = parcelRequire("fwQUo");

});
parcelRegister("fwQUo", function(module, exports) {

var $7cJ51 = parcelRequire("7cJ51");

var $bN3To = parcelRequire("bN3To");

var $8skJo = parcelRequire("8skJo");

var $6xNHt = parcelRequire("6xNHt");
var $8mHRd = parcelRequire("8mHRd");
parcelRequire("8czdG");
var $96buf = parcelRequire("96buf");

var $kiEPI = parcelRequire("kiEPI");

var $gVpv3 = parcelRequire("gVpv3");

var $dV7fx = parcelRequire("dV7fx");
var $b4e2e2bc2c6f9d22$var$MODE_DRAG = {
    name: "drag"
}, $b4e2e2bc2c6f9d22$var$MODE_SPACE = {
    name: "space"
}, $b4e2e2bc2c6f9d22$var$MODE_HANDLE = {
    name: "handle"
}, $b4e2e2bc2c6f9d22$var$MODE_CENTER = {
    name: "center"
};
const { abs: $b4e2e2bc2c6f9d22$var$abs, max: $b4e2e2bc2c6f9d22$var$max, min: $b4e2e2bc2c6f9d22$var$min } = Math;
function $b4e2e2bc2c6f9d22$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $b4e2e2bc2c6f9d22$var$number2(e) {
    return [
        $b4e2e2bc2c6f9d22$var$number1(e[0]),
        $b4e2e2bc2c6f9d22$var$number1(e[1])
    ];
}
var $b4e2e2bc2c6f9d22$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($b4e2e2bc2c6f9d22$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $b4e2e2bc2c6f9d22$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($b4e2e2bc2c6f9d22$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $b4e2e2bc2c6f9d22$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($b4e2e2bc2c6f9d22$var$type),
    input: function(xy) {
        return xy == null ? null : $b4e2e2bc2c6f9d22$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $b4e2e2bc2c6f9d22$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $b4e2e2bc2c6f9d22$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $b4e2e2bc2c6f9d22$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $b4e2e2bc2c6f9d22$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $b4e2e2bc2c6f9d22$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $b4e2e2bc2c6f9d22$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $b4e2e2bc2c6f9d22$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $b4e2e2bc2c6f9d22$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $b4e2e2bc2c6f9d22$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $b4e2e2bc2c6f9d22$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $b4e2e2bc2c6f9d22$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $b4e2e2bc2c6f9d22$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $b4e2e2bc2c6f9d22$export$979ace6c88860aa8() {
    return $b4e2e2bc2c6f9d22$var$brush($b4e2e2bc2c6f9d22$var$X);
}
function $b4e2e2bc2c6f9d22$export$468748b530991c54() {
    return $b4e2e2bc2c6f9d22$var$brush($b4e2e2bc2c6f9d22$var$Y);
}
function $b4e2e2bc2c6f9d22$export$2e2bcd8739ae039() {
    return $b4e2e2bc2c6f9d22$var$brush($b4e2e2bc2c6f9d22$var$XY);
}
function $b4e2e2bc2c6f9d22$var$brush(dim) {
    var extent = $b4e2e2bc2c6f9d22$var$defaultExtent, filter = $b4e2e2bc2c6f9d22$var$defaultFilter, touchable = $b4e2e2bc2c6f9d22$var$defaultTouchable, keys = true, listeners = (0, $7cJ51.default)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $b4e2e2bc2c6f9d22$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $b4e2e2bc2c6f9d22$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $b4e2e2bc2c6f9d22$var$local(this).extent;
            (0, $8mHRd.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $b4e2e2bc2c6f9d22$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $b4e2e2bc2c6f9d22$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $b4e2e2bc2c6f9d22$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $8skJo.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $96buf.default)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, $8mHRd.default)(this), selection = $b4e2e2bc2c6f9d22$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $8mHRd.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $gVpv3.default)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $b4e2e2bc2c6f9d22$var$MODE_DRAG : keys && event.altKey ? $b4e2e2bc2c6f9d22$var$MODE_CENTER : $b4e2e2bc2c6f9d22$var$MODE_HANDLE, signX = dim === $b4e2e2bc2c6f9d22$var$Y ? null : $b4e2e2bc2c6f9d22$var$signsX[type], signY = dim === $b4e2e2bc2c6f9d22$var$X ? null : $b4e2e2bc2c6f9d22$var$signsY[type], state = $b4e2e2bc2c6f9d22$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $6xNHt.default)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $b4e2e2bc2c6f9d22$var$Y ? W : $b4e2e2bc2c6f9d22$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $b4e2e2bc2c6f9d22$var$X ? N : $b4e2e2bc2c6f9d22$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $b4e2e2bc2c6f9d22$var$Y ? E : $b4e2e2bc2c6f9d22$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $b4e2e2bc2c6f9d22$var$X ? S : $b4e2e2bc2c6f9d22$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move();
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $8mHRd.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $b4e2e2bc2c6f9d22$var$cursors[type]);
        (0, $96buf.default)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $8mHRd.default)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $bN3To.default)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $6xNHt.default)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($b4e2e2bc2c6f9d22$var$abs(point.cur[0] - point[0]) > $b4e2e2bc2c6f9d22$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $dV7fx.default)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $b4e2e2bc2c6f9d22$var$MODE_SPACE:
                case $b4e2e2bc2c6f9d22$var$MODE_DRAG:
                    if (signX) dx = $b4e2e2bc2c6f9d22$var$max(W - w0, $b4e2e2bc2c6f9d22$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $b4e2e2bc2c6f9d22$var$max(N - n0, $b4e2e2bc2c6f9d22$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $b4e2e2bc2c6f9d22$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $b4e2e2bc2c6f9d22$var$max(W, $b4e2e2bc2c6f9d22$var$min(E, points[0][0])), e1 = $b4e2e2bc2c6f9d22$var$max(W, $b4e2e2bc2c6f9d22$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $b4e2e2bc2c6f9d22$var$max(N, $b4e2e2bc2c6f9d22$var$min(S, points[0][1])), s1 = $b4e2e2bc2c6f9d22$var$max(N, $b4e2e2bc2c6f9d22$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $b4e2e2bc2c6f9d22$var$max(W - w0, $b4e2e2bc2c6f9d22$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $b4e2e2bc2c6f9d22$var$max(W - e0, $b4e2e2bc2c6f9d22$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $b4e2e2bc2c6f9d22$var$max(N - n0, $b4e2e2bc2c6f9d22$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $b4e2e2bc2c6f9d22$var$max(N - s0, $b4e2e2bc2c6f9d22$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $b4e2e2bc2c6f9d22$var$MODE_CENTER:
                    if (signX) w1 = $b4e2e2bc2c6f9d22$var$max(W, $b4e2e2bc2c6f9d22$var$min(E, w0 - dx * signX)), e1 = $b4e2e2bc2c6f9d22$var$max(W, $b4e2e2bc2c6f9d22$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $b4e2e2bc2c6f9d22$var$max(N, $b4e2e2bc2c6f9d22$var$min(S, n0 - dy * signY)), s1 = $b4e2e2bc2c6f9d22$var$max(N, $b4e2e2bc2c6f9d22$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $b4e2e2bc2c6f9d22$var$flipX) overlay.attr("cursor", $b4e2e2bc2c6f9d22$var$cursors[type = $b4e2e2bc2c6f9d22$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $b4e2e2bc2c6f9d22$var$flipY) overlay.attr("cursor", $b4e2e2bc2c6f9d22$var$cursors[type = $b4e2e2bc2c6f9d22$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $dV7fx.nopropagation)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $bN3To.yesdrag)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $b4e2e2bc2c6f9d22$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($b4e2e2bc2c6f9d22$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $b4e2e2bc2c6f9d22$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $b4e2e2bc2c6f9d22$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $b4e2e2bc2c6f9d22$var$MODE_HANDLE || mode === $b4e2e2bc2c6f9d22$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $b4e2e2bc2c6f9d22$var$MODE_SPACE;
                        overlay.attr("cursor", $b4e2e2bc2c6f9d22$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $dV7fx.default)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $b4e2e2bc2c6f9d22$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $b4e2e2bc2c6f9d22$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $b4e2e2bc2c6f9d22$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $b4e2e2bc2c6f9d22$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $b4e2e2bc2c6f9d22$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $b4e2e2bc2c6f9d22$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $dV7fx.default)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $b4e2e2bc2c6f9d22$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $kiEPI.default)($b4e2e2bc2c6f9d22$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $kiEPI.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $kiEPI.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});
parcelRegister("7cJ51", function(module, exports) {

$parcel$export(module.exports, "default", () => $53ec9f59ff2a30f7$export$2e2bcd8739ae039);
var $53ec9f59ff2a30f7$var$noop = {
    value: ()=>{}
};
function $53ec9f59ff2a30f7$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $53ec9f59ff2a30f7$var$Dispatch(_);
}
function $53ec9f59ff2a30f7$var$Dispatch(_) {
    this._ = _;
}
function $53ec9f59ff2a30f7$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$53ec9f59ff2a30f7$var$Dispatch.prototype = $53ec9f59ff2a30f7$var$dispatch.prototype = {
    constructor: $53ec9f59ff2a30f7$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $53ec9f59ff2a30f7$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $53ec9f59ff2a30f7$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $53ec9f59ff2a30f7$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $53ec9f59ff2a30f7$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $53ec9f59ff2a30f7$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $53ec9f59ff2a30f7$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $53ec9f59ff2a30f7$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $53ec9f59ff2a30f7$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $53ec9f59ff2a30f7$export$2e2bcd8739ae039 = $53ec9f59ff2a30f7$var$dispatch;

});

parcelRegister("bN3To", function(module, exports) {

$parcel$export(module.exports, "default", () => $89574a449119d685$export$2e2bcd8739ae039);
$parcel$export(module.exports, "yesdrag", () => $89574a449119d685$export$833237748009e1e1);

var $8mHRd = parcelRequire("8mHRd");

var $kGaLr = parcelRequire("kGaLr");
function $89574a449119d685$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $8mHRd.default)(view).on("dragstart.drag", (0, $kGaLr.default), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $kGaLr.default), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $89574a449119d685$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $8mHRd.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $kGaLr.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("8mHRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $617265ee89f19b9c$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");
function $617265ee89f19b9c$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $huCkF.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $huCkF.Selection)([
        [
            selector
        ]
    ], (0, $huCkF.root));
}

});
parcelRegister("huCkF", function(module, exports) {

$parcel$export(module.exports, "root", () => $cbc2f9074fd32ba1$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $cbc2f9074fd32ba1$export$52baac22726c72bf);
$parcel$export(module.exports, "default", () => $cbc2f9074fd32ba1$export$2e2bcd8739ae039);

var $6NfqU = parcelRequire("6NfqU");

var $3Y8o7 = parcelRequire("3Y8o7");

var $kAD22 = parcelRequire("kAD22");

var $eCxxI = parcelRequire("eCxxI");

var $4Pi2i = parcelRequire("4Pi2i");

var $h5HKd = parcelRequire("h5HKd");

var $kHYOR = parcelRequire("kHYOR");

var $2XFOa = parcelRequire("2XFOa");

var $15CaR = parcelRequire("15CaR");

var $4OoC5 = parcelRequire("4OoC5");

var $gXnFg = parcelRequire("gXnFg");

var $gbffG = parcelRequire("gbffG");

var $92hlm = parcelRequire("92hlm");

var $jwSPQ = parcelRequire("jwSPQ");

var $j8s0U = parcelRequire("j8s0U");

var $apkDe = parcelRequire("apkDe");

var $3sEiE = parcelRequire("3sEiE");

var $4LYTM = parcelRequire("4LYTM");

var $3eieK = parcelRequire("3eieK");

var $i3en0 = parcelRequire("i3en0");

var $4WWCx = parcelRequire("4WWCx");

var $gOFo4 = parcelRequire("gOFo4");

var $7SJLD = parcelRequire("7SJLD");

var $4F70Z = parcelRequire("4F70Z");

var $9tTd9 = parcelRequire("9tTd9");

var $03FZI = parcelRequire("03FZI");

var $2M2aA = parcelRequire("2M2aA");

var $4SRr6 = parcelRequire("4SRr6");

var $jbUsu = parcelRequire("jbUsu");

var $1iHDq = parcelRequire("1iHDq");

var $94MCY = parcelRequire("94MCY");

var $erlQE = parcelRequire("erlQE");

var $5fP5z = parcelRequire("5fP5z");

var $7opxH = parcelRequire("7opxH");
var $cbc2f9074fd32ba1$export$e8e78c978b129247 = [
    null
];
function $cbc2f9074fd32ba1$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $cbc2f9074fd32ba1$var$selection() {
    return new $cbc2f9074fd32ba1$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $cbc2f9074fd32ba1$export$e8e78c978b129247);
}
function $cbc2f9074fd32ba1$var$selection_selection() {
    return this;
}
$cbc2f9074fd32ba1$export$52baac22726c72bf.prototype = $cbc2f9074fd32ba1$var$selection.prototype = {
    constructor: $cbc2f9074fd32ba1$export$52baac22726c72bf,
    select: (0, $6NfqU.default),
    selectAll: (0, $3Y8o7.default),
    selectChild: (0, $kAD22.default),
    selectChildren: (0, $eCxxI.default),
    filter: (0, $4Pi2i.default),
    data: (0, $h5HKd.default),
    enter: (0, $kHYOR.default),
    exit: (0, $2XFOa.default),
    join: (0, $15CaR.default),
    merge: (0, $4OoC5.default),
    selection: $cbc2f9074fd32ba1$var$selection_selection,
    order: (0, $gXnFg.default),
    sort: (0, $gbffG.default),
    call: (0, $92hlm.default),
    nodes: (0, $jwSPQ.default),
    node: (0, $j8s0U.default),
    size: (0, $apkDe.default),
    empty: (0, $3sEiE.default),
    each: (0, $4LYTM.default),
    attr: (0, $3eieK.default),
    style: (0, $i3en0.default),
    property: (0, $4WWCx.default),
    classed: (0, $gOFo4.default),
    text: (0, $7SJLD.default),
    html: (0, $4F70Z.default),
    raise: (0, $9tTd9.default),
    lower: (0, $03FZI.default),
    append: (0, $2M2aA.default),
    insert: (0, $4SRr6.default),
    remove: (0, $jbUsu.default),
    clone: (0, $1iHDq.default),
    datum: (0, $94MCY.default),
    on: (0, $erlQE.default),
    dispatch: (0, $5fP5z.default),
    [Symbol.iterator]: (0, $7opxH.default)
};
var $cbc2f9074fd32ba1$export$2e2bcd8739ae039 = $cbc2f9074fd32ba1$var$selection;

});
parcelRegister("6NfqU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f234a5c8349576c$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");

var $fTXhD = parcelRequire("fTXhD");
function $4f234a5c8349576c$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $fTXhD.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $huCkF.Selection)(subgroups, this._parents);
}

});
parcelRegister("fTXhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b939fa8b637116ea$export$2e2bcd8739ae039);
function $b939fa8b637116ea$var$none() {}
function $b939fa8b637116ea$export$2e2bcd8739ae039(selector) {
    return selector == null ? $b939fa8b637116ea$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("3Y8o7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e3d7b663146cfb8$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");

var $1duY9 = parcelRequire("1duY9");

var $jj2Ac = parcelRequire("jj2Ac");
function $2e3d7b663146cfb8$var$arrayAll(select) {
    return function() {
        var group = select.apply(this, arguments);
        return group == null ? [] : (0, $1duY9.default)(group);
    };
}
function $2e3d7b663146cfb8$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $2e3d7b663146cfb8$var$arrayAll(select);
    else select = (0, $jj2Ac.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $huCkF.Selection)(subgroups, parents);
}

});
parcelRegister("1duY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e2f07281d839937$export$2e2bcd8739ae039);
function $0e2f07281d839937$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("jj2Ac", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0e1cb901e603ac5$export$2e2bcd8739ae039);
function $e0e1cb901e603ac5$var$empty() {
    return [];
}
function $e0e1cb901e603ac5$export$2e2bcd8739ae039(selector) {
    return selector == null ? $e0e1cb901e603ac5$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("kAD22", function(module, exports) {

$parcel$export(module.exports, "default", () => $efd5725935674ffd$export$2e2bcd8739ae039);

var $aaEMv = parcelRequire("aaEMv");
var $efd5725935674ffd$var$find = Array.prototype.find;
function $efd5725935674ffd$var$childFind(match) {
    return function() {
        return $efd5725935674ffd$var$find.call(this.children, match);
    };
}
function $efd5725935674ffd$var$childFirst() {
    return this.firstElementChild;
}
function $efd5725935674ffd$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $efd5725935674ffd$var$childFirst : $efd5725935674ffd$var$childFind(typeof match === "function" ? match : (0, $aaEMv.childMatcher)(match)));
}

});
parcelRegister("aaEMv", function(module, exports) {

$parcel$export(module.exports, "default", () => $767a78df28c36f94$export$2e2bcd8739ae039);
$parcel$export(module.exports, "childMatcher", () => $767a78df28c36f94$export$90c2759c036528);
function $767a78df28c36f94$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $767a78df28c36f94$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

});


parcelRegister("eCxxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa4ea233e25cfd7b$export$2e2bcd8739ae039);

var $aaEMv = parcelRequire("aaEMv");
var $aa4ea233e25cfd7b$var$filter = Array.prototype.filter;
function $aa4ea233e25cfd7b$var$children() {
    return this.children;
}
function $aa4ea233e25cfd7b$var$childrenFilter(match) {
    return function() {
        return $aa4ea233e25cfd7b$var$filter.call(this.children, match);
    };
}
function $aa4ea233e25cfd7b$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $aa4ea233e25cfd7b$var$children : $aa4ea233e25cfd7b$var$childrenFilter(typeof match === "function" ? match : (0, $aaEMv.childMatcher)(match)));
}

});

parcelRegister("4Pi2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $3839ea6eaf2564fb$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");

var $aaEMv = parcelRequire("aaEMv");
function $3839ea6eaf2564fb$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $aaEMv.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $huCkF.Selection)(subgroups, this._parents);
}

});

parcelRegister("h5HKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c714d60c5f9e1d2b$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");

var $kHYOR = parcelRequire("kHYOR");

var $1duY9 = parcelRequire("1duY9");

var $bRUqH = parcelRequire("bRUqH");
function $c714d60c5f9e1d2b$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $kHYOR.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $c714d60c5f9e1d2b$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $kHYOR.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $c714d60c5f9e1d2b$var$datum(node) {
    return node.__data__;
}
function $c714d60c5f9e1d2b$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $c714d60c5f9e1d2b$var$datum);
    var bind = key ? $c714d60c5f9e1d2b$var$bindKey : $c714d60c5f9e1d2b$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $bRUqH.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = (0, $1duY9.default)(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $huCkF.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("kHYOR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f13700404476db39$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $f13700404476db39$export$67b01759a14cf6a4);

var $8EaPc = parcelRequire("8EaPc");

var $huCkF = parcelRequire("huCkF");
function $f13700404476db39$export$2e2bcd8739ae039() {
    return new (0, $huCkF.Selection)(this._enter || this._groups.map((0, $8EaPc.default)), this._parents);
}
function $f13700404476db39$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$f13700404476db39$export$67b01759a14cf6a4.prototype = {
    constructor: $f13700404476db39$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("8EaPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ba74b71c73d1e0$export$2e2bcd8739ae039);
function $64ba74b71c73d1e0$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("bRUqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a406ab2db09d134$export$2e2bcd8739ae039);
function $8a406ab2db09d134$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("2XFOa", function(module, exports) {

$parcel$export(module.exports, "default", () => $228185ad1cc96e13$export$2e2bcd8739ae039);

var $8EaPc = parcelRequire("8EaPc");

var $huCkF = parcelRequire("huCkF");
function $228185ad1cc96e13$export$2e2bcd8739ae039() {
    return new (0, $huCkF.Selection)(this._exit || this._groups.map((0, $8EaPc.default)), this._parents);
}

});

parcelRegister("15CaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cb3deaead1198d9$export$2e2bcd8739ae039);
function $0cb3deaead1198d9$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("4OoC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $380eeca35c54fa2f$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");
function $380eeca35c54fa2f$export$2e2bcd8739ae039(selection) {
    if (!(selection instanceof (0, $huCkF.Selection))) throw new Error("invalid merge");
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $huCkF.Selection)(merges, this._parents);
}

});

parcelRegister("gXnFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c58483526176ce71$export$2e2bcd8739ae039);
function $c58483526176ce71$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("gbffG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc79812204b4572f$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");
function $bc79812204b4572f$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $bc79812204b4572f$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $huCkF.Selection)(sortgroups, this._parents).order();
}
function $bc79812204b4572f$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("92hlm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6941c1024554ae7f$export$2e2bcd8739ae039);
function $6941c1024554ae7f$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("jwSPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37b8a9d231832ad$export$2e2bcd8739ae039);
function $e37b8a9d231832ad$export$2e2bcd8739ae039() {
    return Array.from(this);
}

});

parcelRegister("j8s0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $dee47e9c37232794$export$2e2bcd8739ae039);
function $dee47e9c37232794$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("apkDe", function(module, exports) {

$parcel$export(module.exports, "default", () => $793c3e3be87954b3$export$2e2bcd8739ae039);
function $793c3e3be87954b3$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}

});

parcelRegister("3sEiE", function(module, exports) {

$parcel$export(module.exports, "default", () => $28533f59a8b60696$export$2e2bcd8739ae039);
function $28533f59a8b60696$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("4LYTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $379aca6520fc2ad9$export$2e2bcd8739ae039);
function $379aca6520fc2ad9$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("3eieK", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a0d35835f0b709$export$2e2bcd8739ae039);

var $6hmKI = parcelRequire("6hmKI");
function $25a0d35835f0b709$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $25a0d35835f0b709$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $25a0d35835f0b709$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $25a0d35835f0b709$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $25a0d35835f0b709$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $25a0d35835f0b709$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $25a0d35835f0b709$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $6hmKI.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $25a0d35835f0b709$var$attrRemoveNS : $25a0d35835f0b709$var$attrRemove : typeof value === "function" ? fullname.local ? $25a0d35835f0b709$var$attrFunctionNS : $25a0d35835f0b709$var$attrFunction : fullname.local ? $25a0d35835f0b709$var$attrConstantNS : $25a0d35835f0b709$var$attrConstant)(fullname, value));
}

});
parcelRegister("6hmKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $012e082c833723b3$export$2e2bcd8739ae039);

var $jjAYx = parcelRequire("jjAYx");
function $012e082c833723b3$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $jjAYx.default).hasOwnProperty(prefix) ? {
        space: (0, $jjAYx.default)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}

});
parcelRegister("jjAYx", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $e0fc7936b51b9af5$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $e0fc7936b51b9af5$export$2e2bcd8739ae039);
var $e0fc7936b51b9af5$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $e0fc7936b51b9af5$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $e0fc7936b51b9af5$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("i3en0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d243a764aee7cc25$export$2e2bcd8739ae039);
$parcel$export(module.exports, "styleValue", () => $d243a764aee7cc25$export$5e3cec964f0b5efd);

var $kDvmX = parcelRequire("kDvmX");
function $d243a764aee7cc25$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d243a764aee7cc25$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $d243a764aee7cc25$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $d243a764aee7cc25$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $d243a764aee7cc25$var$styleRemove : typeof value === "function" ? $d243a764aee7cc25$var$styleFunction : $d243a764aee7cc25$var$styleConstant)(name, value, priority == null ? "" : priority)) : $d243a764aee7cc25$export$5e3cec964f0b5efd(this.node(), name);
}
function $d243a764aee7cc25$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $kDvmX.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("kDvmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f05fc874f484bee7$export$2e2bcd8739ae039);
function $f05fc874f484bee7$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("4WWCx", function(module, exports) {

$parcel$export(module.exports, "default", () => $39aa0d0172b12aba$export$2e2bcd8739ae039);
function $39aa0d0172b12aba$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $39aa0d0172b12aba$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $39aa0d0172b12aba$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $39aa0d0172b12aba$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $39aa0d0172b12aba$var$propertyRemove : typeof value === "function" ? $39aa0d0172b12aba$var$propertyFunction : $39aa0d0172b12aba$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("gOFo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3e16b79e4b3c1b1$export$2e2bcd8739ae039);
function $c3e16b79e4b3c1b1$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $c3e16b79e4b3c1b1$var$classList(node) {
    return node.classList || new $c3e16b79e4b3c1b1$var$ClassList(node);
}
function $c3e16b79e4b3c1b1$var$ClassList(node) {
    this._node = node;
    this._names = $c3e16b79e4b3c1b1$var$classArray(node.getAttribute("class") || "");
}
$c3e16b79e4b3c1b1$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $c3e16b79e4b3c1b1$var$classedAdd(node, names) {
    var list = $c3e16b79e4b3c1b1$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $c3e16b79e4b3c1b1$var$classedRemove(node, names) {
    var list = $c3e16b79e4b3c1b1$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $c3e16b79e4b3c1b1$var$classedTrue(names) {
    return function() {
        $c3e16b79e4b3c1b1$var$classedAdd(this, names);
    };
}
function $c3e16b79e4b3c1b1$var$classedFalse(names) {
    return function() {
        $c3e16b79e4b3c1b1$var$classedRemove(this, names);
    };
}
function $c3e16b79e4b3c1b1$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $c3e16b79e4b3c1b1$var$classedAdd : $c3e16b79e4b3c1b1$var$classedRemove)(this, names);
    };
}
function $c3e16b79e4b3c1b1$export$2e2bcd8739ae039(name, value) {
    var names = $c3e16b79e4b3c1b1$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $c3e16b79e4b3c1b1$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $c3e16b79e4b3c1b1$var$classedFunction : value ? $c3e16b79e4b3c1b1$var$classedTrue : $c3e16b79e4b3c1b1$var$classedFalse)(names, value));
}

});

parcelRegister("7SJLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bd113f738be0adf$export$2e2bcd8739ae039);
function $5bd113f738be0adf$var$textRemove() {
    this.textContent = "";
}
function $5bd113f738be0adf$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $5bd113f738be0adf$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $5bd113f738be0adf$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $5bd113f738be0adf$var$textRemove : (typeof value === "function" ? $5bd113f738be0adf$var$textFunction : $5bd113f738be0adf$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("4F70Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $36506ecc1b1c59fd$export$2e2bcd8739ae039);
function $36506ecc1b1c59fd$var$htmlRemove() {
    this.innerHTML = "";
}
function $36506ecc1b1c59fd$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $36506ecc1b1c59fd$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $36506ecc1b1c59fd$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $36506ecc1b1c59fd$var$htmlRemove : (typeof value === "function" ? $36506ecc1b1c59fd$var$htmlFunction : $36506ecc1b1c59fd$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("9tTd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e71a64943bb84fe$export$2e2bcd8739ae039);
function $6e71a64943bb84fe$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $6e71a64943bb84fe$export$2e2bcd8739ae039() {
    return this.each($6e71a64943bb84fe$var$raise);
}

});

parcelRegister("03FZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b0db284e4403f2$export$2e2bcd8739ae039);
function $00b0db284e4403f2$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $00b0db284e4403f2$export$2e2bcd8739ae039() {
    return this.each($00b0db284e4403f2$var$lower);
}

});

parcelRegister("2M2aA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2051bf5bebcff7e5$export$2e2bcd8739ae039);

var $lF6vr = parcelRequire("lF6vr");
function $2051bf5bebcff7e5$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $lF6vr.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("lF6vr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc52794a0428514e$export$2e2bcd8739ae039);

var $6hmKI = parcelRequire("6hmKI");

var $jjAYx = parcelRequire("jjAYx");
function $fc52794a0428514e$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $jjAYx.xhtml) && document.documentElement.namespaceURI === (0, $jjAYx.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $fc52794a0428514e$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $fc52794a0428514e$export$2e2bcd8739ae039(name) {
    var fullname = (0, $6hmKI.default)(name);
    return (fullname.local ? $fc52794a0428514e$var$creatorFixed : $fc52794a0428514e$var$creatorInherit)(fullname);
}

});


parcelRegister("4SRr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $38e5a7dd1f6de5e4$export$2e2bcd8739ae039);

var $lF6vr = parcelRequire("lF6vr");

var $fTXhD = parcelRequire("fTXhD");
function $38e5a7dd1f6de5e4$var$constantNull() {
    return null;
}
function $38e5a7dd1f6de5e4$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $lF6vr.default)(name), select = before == null ? $38e5a7dd1f6de5e4$var$constantNull : typeof before === "function" ? before : (0, $fTXhD.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("jbUsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $df8ad6e702ae825a$export$2e2bcd8739ae039);
function $df8ad6e702ae825a$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $df8ad6e702ae825a$export$2e2bcd8739ae039() {
    return this.each($df8ad6e702ae825a$var$remove);
}

});

parcelRegister("1iHDq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2951e34bbb132b$export$2e2bcd8739ae039);
function $0f2951e34bbb132b$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $0f2951e34bbb132b$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $0f2951e34bbb132b$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $0f2951e34bbb132b$var$selection_cloneDeep : $0f2951e34bbb132b$var$selection_cloneShallow);
}

});

parcelRegister("94MCY", function(module, exports) {

$parcel$export(module.exports, "default", () => $69ba35384ab7b4ab$export$2e2bcd8739ae039);
function $69ba35384ab7b4ab$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("erlQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a83488e78265bcb8$export$2e2bcd8739ae039);
function $a83488e78265bcb8$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $a83488e78265bcb8$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $a83488e78265bcb8$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $a83488e78265bcb8$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $a83488e78265bcb8$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $a83488e78265bcb8$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $a83488e78265bcb8$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $a83488e78265bcb8$var$onAdd : $a83488e78265bcb8$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}

});

parcelRegister("5fP5z", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d35fba8300eda05$export$2e2bcd8739ae039);

var $kDvmX = parcelRequire("kDvmX");
function $3d35fba8300eda05$var$dispatchEvent(node, type, params) {
    var window = (0, $kDvmX.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $3d35fba8300eda05$var$dispatchConstant(type, params) {
    return function() {
        return $3d35fba8300eda05$var$dispatchEvent(this, type, params);
    };
}
function $3d35fba8300eda05$var$dispatchFunction(type, params) {
    return function() {
        return $3d35fba8300eda05$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $3d35fba8300eda05$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $3d35fba8300eda05$var$dispatchFunction : $3d35fba8300eda05$var$dispatchConstant)(type, params));
}

});

parcelRegister("7opxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $561e967e90ff8d94$export$2e2bcd8739ae039);
function* $561e967e90ff8d94$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}

});



parcelRegister("kGaLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0e01475a53a4f0f$export$2e2bcd8739ae039);
function $f0e01475a53a4f0f$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $f0e01475a53a4f0f$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});


parcelRegister("8skJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $62810504b810be74$export$2e2bcd8739ae039);

var $7zw1L = parcelRequire("7zw1L");

var $7T5jl = parcelRequire("7T5jl");

var $6kDMI = parcelRequire("6kDMI");

var $dsSuN = parcelRequire("dsSuN");

var $htN5h = parcelRequire("htN5h");

var $js7bn = parcelRequire("js7bn");

var $3A4bH = parcelRequire("3A4bH");

var $f0hIq = parcelRequire("f0hIq");

var $3vwHA = parcelRequire("3vwHA");
function $62810504b810be74$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $f0hIq.default)(b) : (t === "number" ? (0, $htN5h.default) : t === "string" ? (c = (0, $7zw1L.default)(b)) ? (b = c, $7T5jl.default) : (0, $3A4bH.default) : b instanceof (0, $7zw1L.default) ? (0, $7T5jl.default) : b instanceof Date ? (0, $dsSuN.default) : (0, $3vwHA.isNumberArray)(b) ? (0, $3vwHA.default) : Array.isArray(b) ? (0, $6kDMI.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $js7bn.default) : (0, $htN5h.default))(a, b);
}

});
parcelRegister("7zw1L", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bFdKO = parcelRequire("bFdKO");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bFdKO.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bFdKO.default)(Rgb, rgb, (0, $bFdKO.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bFdKO.default)(Hsl, hsl, (0, $bFdKO.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bFdKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $87de3155f9d735d3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $87de3155f9d735d3$export$8b58be045bf06082);
function $87de3155f9d735d3$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $87de3155f9d735d3$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("7T5jl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be1ca1ac84d1a6e$export$2e2bcd8739ae039);

var $7zw1L = parcelRequire("7zw1L");

var $b6gbg = parcelRequire("b6gbg");

var $9lYTG = parcelRequire("9lYTG");

var $ahvgE = parcelRequire("ahvgE");
var $5be1ca1ac84d1a6e$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $ahvgE.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $7zw1L.rgb)(start)).r, (end = (0, $7zw1L.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $ahvgE.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $5be1ca1ac84d1a6e$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $7zw1L.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $5be1ca1ac84d1a6e$export$2c0e28f2e2852d3f = $5be1ca1ac84d1a6e$var$rgbSpline((0, $b6gbg.default));
var $5be1ca1ac84d1a6e$export$53d5214f625ccd4c = $5be1ca1ac84d1a6e$var$rgbSpline((0, $9lYTG.default));

});
parcelRegister("b6gbg", function(module, exports) {

$parcel$export(module.exports, "basis", () => $814cce61c6a43719$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $814cce61c6a43719$export$2e2bcd8739ae039);
function $814cce61c6a43719$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $814cce61c6a43719$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $814cce61c6a43719$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("9lYTG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf5501fbd41fd25$export$2e2bcd8739ae039);

var $b6gbg = parcelRequire("b6gbg");
function $6cf5501fbd41fd25$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $b6gbg.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("ahvgE", function(module, exports) {

$parcel$export(module.exports, "gamma", () => $77c3befc81f3cf1f$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $77c3befc81f3cf1f$export$2e2bcd8739ae039);

var $f0hIq = parcelRequire("f0hIq");
function $77c3befc81f3cf1f$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $77c3befc81f3cf1f$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $77c3befc81f3cf1f$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $77c3befc81f3cf1f$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $f0hIq.default)(isNaN(a) ? b : a);
}
function $77c3befc81f3cf1f$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $77c3befc81f3cf1f$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $77c3befc81f3cf1f$var$exponential(a, b, y) : (0, $f0hIq.default)(isNaN(a) ? b : a);
    };
}
function $77c3befc81f3cf1f$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $77c3befc81f3cf1f$var$linear(a, d) : (0, $f0hIq.default)(isNaN(a) ? b : a);
}

});
parcelRegister("f0hIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $aec49909c3ef4399$export$2e2bcd8739ae039);
var $aec49909c3ef4399$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("6kDMI", function(module, exports) {

$parcel$export(module.exports, "genericArray", () => $49c378bf74e25e4c$export$15d09067c6a5ee49);

var $8skJo = parcelRequire("8skJo");

var $3vwHA = parcelRequire("3vwHA");
function $49c378bf74e25e4c$export$2e2bcd8739ae039(a, b) {
    return ((0, $3vwHA.isNumberArray)(b) ? (0, $3vwHA.default) : $49c378bf74e25e4c$export$15d09067c6a5ee49)(a, b);
}
function $49c378bf74e25e4c$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8skJo.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("3vwHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $28dda2443946d247$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $28dda2443946d247$export$5cd576d1827d40c8);
function $28dda2443946d247$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $28dda2443946d247$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("dsSuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cd8299f9981db0b$export$2e2bcd8739ae039);
function $9cd8299f9981db0b$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("htN5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb9b382b237fe129$export$2e2bcd8739ae039);
function $cb9b382b237fe129$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("js7bn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e296341fec01fd27$export$2e2bcd8739ae039);

var $8skJo = parcelRequire("8skJo");
function $e296341fec01fd27$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $8skJo.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("3A4bH", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b7fb7bdb66e407$export$2e2bcd8739ae039);

var $htN5h = parcelRequire("htN5h");
var $29b7fb7bdb66e407$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $29b7fb7bdb66e407$var$reB = new RegExp($29b7fb7bdb66e407$var$reA.source, "g");
function $29b7fb7bdb66e407$var$zero(b) {
    return function() {
        return b;
    };
}
function $29b7fb7bdb66e407$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $29b7fb7bdb66e407$export$2e2bcd8739ae039(a, b) {
    var bi = $29b7fb7bdb66e407$var$reA.lastIndex = $29b7fb7bdb66e407$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $29b7fb7bdb66e407$var$reA.exec(a)) && (bm = $29b7fb7bdb66e407$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $htN5h.default)(am, bm)
            });
        }
        bi = $29b7fb7bdb66e407$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $29b7fb7bdb66e407$var$one(q[0].x) : $29b7fb7bdb66e407$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("6xNHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c3c60970bdea43e$export$2e2bcd8739ae039);

var $4x7IF = parcelRequire("4x7IF");
function $4c3c60970bdea43e$export$2e2bcd8739ae039(event, node) {
    event = (0, $4x7IF.default)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}

});
parcelRegister("4x7IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $34d03b635d6a2f1a$export$2e2bcd8739ae039);
function $34d03b635d6a2f1a$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}

});


parcelRegister("8czdG", function(module, exports) {

$parcel$export(module.exports, "interrupt", () => (parcelRequire("96buf")).default);
parcelRequire("gALVo");

var $leops = parcelRequire("leops");

var $4dVnM = parcelRequire("4dVnM");

var $96buf = parcelRequire("96buf");

});
parcelRegister("gALVo", function(module, exports) {

var $huCkF = parcelRequire("huCkF");

var $fmUkD = parcelRequire("fmUkD");

var $6ubzV = parcelRequire("6ubzV");
(0, $huCkF.default).prototype.interrupt = (0, $fmUkD.default);
(0, $huCkF.default).prototype.transition = (0, $6ubzV.default);

});
parcelRegister("fmUkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3049b709ccae3c4$export$2e2bcd8739ae039);

var $96buf = parcelRequire("96buf");
function $b3049b709ccae3c4$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $96buf.default)(this, name);
    });
}

});
parcelRegister("96buf", function(module, exports) {

$parcel$export(module.exports, "default", () => $69fd95a8fd5213ef$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $69fd95a8fd5213ef$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $lp6Kl.STARTING) && schedule.state < (0, $lp6Kl.ENDING);
        schedule.state = (0, $lp6Kl.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("lp6Kl", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED", () => $f9512a7ebdd9e68c$export$584530fe98d14a84);
$parcel$export(module.exports, "STARTING", () => $f9512a7ebdd9e68c$export$a5d151aee16efd42);
$parcel$export(module.exports, "ENDING", () => $f9512a7ebdd9e68c$export$a2e792214ded83b2);
$parcel$export(module.exports, "ENDED", () => $f9512a7ebdd9e68c$export$9d38167254403955);
$parcel$export(module.exports, "default", () => $f9512a7ebdd9e68c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "init", () => $f9512a7ebdd9e68c$export$2cd8252107eb640b);
$parcel$export(module.exports, "get", () => $f9512a7ebdd9e68c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $f9512a7ebdd9e68c$export$adaa4cf7ef1b65be);

var $7cJ51 = parcelRequire("7cJ51");

var $aDSqO = parcelRequire("aDSqO");
var $0a0BW = parcelRequire("0a0BW");
var $f9512a7ebdd9e68c$var$emptyOn = (0, $7cJ51.default)("start", "end", "cancel", "interrupt");
var $f9512a7ebdd9e68c$var$emptyTween = [];
var $f9512a7ebdd9e68c$export$ff39ebd4bb12b718 = 0;
var $f9512a7ebdd9e68c$export$584530fe98d14a84 = 1;
var $f9512a7ebdd9e68c$export$a5d151aee16efd42 = 2;
var $f9512a7ebdd9e68c$export$fb935ab5849a0db9 = 3;
var $f9512a7ebdd9e68c$export$1573e22b087389af = 4;
var $f9512a7ebdd9e68c$export$a2e792214ded83b2 = 5;
var $f9512a7ebdd9e68c$export$9d38167254403955 = 6;
function $f9512a7ebdd9e68c$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $f9512a7ebdd9e68c$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $f9512a7ebdd9e68c$var$emptyOn,
        tween: $f9512a7ebdd9e68c$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $f9512a7ebdd9e68c$export$ff39ebd4bb12b718
    });
}
function $f9512a7ebdd9e68c$export$2cd8252107eb640b(node, id) {
    var schedule = $f9512a7ebdd9e68c$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $f9512a7ebdd9e68c$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $f9512a7ebdd9e68c$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $f9512a7ebdd9e68c$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $f9512a7ebdd9e68c$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $f9512a7ebdd9e68c$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $f9512a7ebdd9e68c$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $0a0BW.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $f9512a7ebdd9e68c$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $f9512a7ebdd9e68c$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $f9512a7ebdd9e68c$export$fb935ab5849a0db9) return (0, $aDSqO.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $f9512a7ebdd9e68c$export$1573e22b087389af) {
                o.state = $f9512a7ebdd9e68c$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $f9512a7ebdd9e68c$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $aDSqO.default)(function() {
            if (self.state === $f9512a7ebdd9e68c$export$fb935ab5849a0db9) {
                self.state = $f9512a7ebdd9e68c$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $f9512a7ebdd9e68c$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $f9512a7ebdd9e68c$export$a5d151aee16efd42) return; // interrupted
        self.state = $f9512a7ebdd9e68c$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $f9512a7ebdd9e68c$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $f9512a7ebdd9e68c$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $f9512a7ebdd9e68c$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("aDSqO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf7c4de278f7c00$export$2e2bcd8739ae039);

var $0a0BW = parcelRequire("0a0BW");
function $7bf7c4de278f7c00$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $0a0BW.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("0a0BW", function(module, exports) {

$parcel$export(module.exports, "now", () => $0007c3c06f3e7c65$export$461939dd4422153);
$parcel$export(module.exports, "Timer", () => $0007c3c06f3e7c65$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "timer", () => $0007c3c06f3e7c65$export$9dc4ecf953986f04);
var $0007c3c06f3e7c65$var$frame = 0, $0007c3c06f3e7c65$var$timeout = 0, $0007c3c06f3e7c65$var$interval = 0, $0007c3c06f3e7c65$var$pokeDelay = 1000, $0007c3c06f3e7c65$var$taskHead, $0007c3c06f3e7c65$var$taskTail, $0007c3c06f3e7c65$var$clockLast = 0, $0007c3c06f3e7c65$var$clockNow = 0, $0007c3c06f3e7c65$var$clockSkew = 0, $0007c3c06f3e7c65$var$clock = typeof performance === "object" && performance.now ? performance : Date, $0007c3c06f3e7c65$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $0007c3c06f3e7c65$export$461939dd4422153() {
    return $0007c3c06f3e7c65$var$clockNow || ($0007c3c06f3e7c65$var$setFrame($0007c3c06f3e7c65$var$clearNow), $0007c3c06f3e7c65$var$clockNow = $0007c3c06f3e7c65$var$clock.now() + $0007c3c06f3e7c65$var$clockSkew);
}
function $0007c3c06f3e7c65$var$clearNow() {
    $0007c3c06f3e7c65$var$clockNow = 0;
}
function $0007c3c06f3e7c65$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$0007c3c06f3e7c65$export$c57e9b2d8b9e4de.prototype = $0007c3c06f3e7c65$export$9dc4ecf953986f04.prototype = {
    constructor: $0007c3c06f3e7c65$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $0007c3c06f3e7c65$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $0007c3c06f3e7c65$var$taskTail !== this) {
            if ($0007c3c06f3e7c65$var$taskTail) $0007c3c06f3e7c65$var$taskTail._next = this;
            else $0007c3c06f3e7c65$var$taskHead = this;
            $0007c3c06f3e7c65$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $0007c3c06f3e7c65$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $0007c3c06f3e7c65$var$sleep();
        }
    }
};
function $0007c3c06f3e7c65$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $0007c3c06f3e7c65$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $0007c3c06f3e7c65$export$d60154c1d7f3990e() {
    $0007c3c06f3e7c65$export$461939dd4422153(); // Get the current time, if not already set.
    ++$0007c3c06f3e7c65$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $0007c3c06f3e7c65$var$taskHead, e;
    while(t){
        if ((e = $0007c3c06f3e7c65$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$0007c3c06f3e7c65$var$frame;
}
function $0007c3c06f3e7c65$var$wake() {
    $0007c3c06f3e7c65$var$clockNow = ($0007c3c06f3e7c65$var$clockLast = $0007c3c06f3e7c65$var$clock.now()) + $0007c3c06f3e7c65$var$clockSkew;
    $0007c3c06f3e7c65$var$frame = $0007c3c06f3e7c65$var$timeout = 0;
    try {
        $0007c3c06f3e7c65$export$d60154c1d7f3990e();
    } finally{
        $0007c3c06f3e7c65$var$frame = 0;
        $0007c3c06f3e7c65$var$nap();
        $0007c3c06f3e7c65$var$clockNow = 0;
    }
}
function $0007c3c06f3e7c65$var$poke() {
    var now = $0007c3c06f3e7c65$var$clock.now(), delay = now - $0007c3c06f3e7c65$var$clockLast;
    if (delay > $0007c3c06f3e7c65$var$pokeDelay) $0007c3c06f3e7c65$var$clockSkew -= delay, $0007c3c06f3e7c65$var$clockLast = now;
}
function $0007c3c06f3e7c65$var$nap() {
    var t0, t1 = $0007c3c06f3e7c65$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $0007c3c06f3e7c65$var$taskHead = t2;
    }
    $0007c3c06f3e7c65$var$taskTail = t0;
    $0007c3c06f3e7c65$var$sleep(time);
}
function $0007c3c06f3e7c65$var$sleep(time) {
    if ($0007c3c06f3e7c65$var$frame) return; // Soonest alarm already set, or will be.
    if ($0007c3c06f3e7c65$var$timeout) $0007c3c06f3e7c65$var$timeout = clearTimeout($0007c3c06f3e7c65$var$timeout);
    var delay = time - $0007c3c06f3e7c65$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $0007c3c06f3e7c65$var$timeout = setTimeout($0007c3c06f3e7c65$var$wake, time - $0007c3c06f3e7c65$var$clock.now() - $0007c3c06f3e7c65$var$clockSkew);
        if ($0007c3c06f3e7c65$var$interval) $0007c3c06f3e7c65$var$interval = clearInterval($0007c3c06f3e7c65$var$interval);
    } else {
        if (!$0007c3c06f3e7c65$var$interval) $0007c3c06f3e7c65$var$clockLast = $0007c3c06f3e7c65$var$clock.now(), $0007c3c06f3e7c65$var$interval = setInterval($0007c3c06f3e7c65$var$poke, $0007c3c06f3e7c65$var$pokeDelay);
        $0007c3c06f3e7c65$var$frame = 1, $0007c3c06f3e7c65$var$setFrame($0007c3c06f3e7c65$var$wake);
    }
}

});





parcelRegister("6ubzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b8e86a3a39a5d2a$export$2e2bcd8739ae039);

var $leops = parcelRequire("leops");

var $lp6Kl = parcelRequire("lp6Kl");

var $brLW1 = parcelRequire("brLW1");

var $0a0BW = parcelRequire("0a0BW");
var $4b8e86a3a39a5d2a$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $brLW1.cubicInOut)
};
function $4b8e86a3a39a5d2a$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $4b8e86a3a39a5d2a$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $leops.Transition)) id = name._id, name = name._name;
    else id = (0, $leops.newId)(), (timing = $4b8e86a3a39a5d2a$var$defaultTiming).time = (0, $0a0BW.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $lp6Kl.default)(node, name, id, i, group, timing || $4b8e86a3a39a5d2a$var$inherit(node, id));
    }
    return new (0, $leops.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("leops", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $f74dd700e6e6d3f4$export$be58926105124dd4);
$parcel$export(module.exports, "newId", () => $f74dd700e6e6d3f4$export$9ffd10a3fbdc175b);

var $huCkF = parcelRequire("huCkF");

var $9rgcg = parcelRequire("9rgcg");

var $2dt77 = parcelRequire("2dt77");

var $8xmuw = parcelRequire("8xmuw");

var $4ufDs = parcelRequire("4ufDs");

var $g4lNs = parcelRequire("g4lNs");

var $c4Nme = parcelRequire("c4Nme");

var $69TaT = parcelRequire("69TaT");

var $gjur0 = parcelRequire("gjur0");

var $jcvOK = parcelRequire("jcvOK");

var $ggTER = parcelRequire("ggTER");

var $fq2F3 = parcelRequire("fq2F3");

var $45gkY = parcelRequire("45gkY");

var $8Hpkq = parcelRequire("8Hpkq");

var $iQYBW = parcelRequire("iQYBW");

var $9Y295 = parcelRequire("9Y295");

var $5PNsE = parcelRequire("5PNsE");

var $9Ea32 = parcelRequire("9Ea32");

var $cpVXF = parcelRequire("cpVXF");

var $f7PDQ = parcelRequire("f7PDQ");

var $edwJZ = parcelRequire("edwJZ");
var $f74dd700e6e6d3f4$var$id = 0;
function $f74dd700e6e6d3f4$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $f74dd700e6e6d3f4$export$2e2bcd8739ae039(name) {
    return (0, $huCkF.default)().transition(name);
}
function $f74dd700e6e6d3f4$export$9ffd10a3fbdc175b() {
    return ++$f74dd700e6e6d3f4$var$id;
}
var $f74dd700e6e6d3f4$var$selection_prototype = (0, $huCkF.default).prototype;
$f74dd700e6e6d3f4$export$be58926105124dd4.prototype = $f74dd700e6e6d3f4$export$2e2bcd8739ae039.prototype = {
    constructor: $f74dd700e6e6d3f4$export$be58926105124dd4,
    select: (0, $fq2F3.default),
    selectAll: (0, $45gkY.default),
    filter: (0, $69TaT.default),
    merge: (0, $gjur0.default),
    selection: (0, $8Hpkq.default),
    transition: (0, $cpVXF.default),
    call: $f74dd700e6e6d3f4$var$selection_prototype.call,
    nodes: $f74dd700e6e6d3f4$var$selection_prototype.nodes,
    node: $f74dd700e6e6d3f4$var$selection_prototype.node,
    size: $f74dd700e6e6d3f4$var$selection_prototype.size,
    empty: $f74dd700e6e6d3f4$var$selection_prototype.empty,
    each: $f74dd700e6e6d3f4$var$selection_prototype.each,
    on: (0, $jcvOK.default),
    attr: (0, $9rgcg.default),
    attrTween: (0, $2dt77.default),
    style: (0, $iQYBW.default),
    styleTween: (0, $9Y295.default),
    text: (0, $5PNsE.default),
    textTween: (0, $9Ea32.default),
    remove: (0, $ggTER.default),
    tween: (0, $f7PDQ.default),
    delay: (0, $8xmuw.default),
    duration: (0, $4ufDs.default),
    ease: (0, $g4lNs.default),
    easeVarying: (0, $c4Nme.default),
    end: (0, $edwJZ.default),
    [Symbol.iterator]: $f74dd700e6e6d3f4$var$selection_prototype[Symbol.iterator]
};

});
parcelRegister("9rgcg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df3330ba39617b0$export$2e2bcd8739ae039);

var $3Aif9 = parcelRequire("3Aif9");

var $6hmKI = parcelRequire("6hmKI");

var $f7PDQ = parcelRequire("f7PDQ");

var $aIbJE = parcelRequire("aIbJE");
function $6df3330ba39617b0$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $6df3330ba39617b0$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $6df3330ba39617b0$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $6df3330ba39617b0$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $6df3330ba39617b0$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $6df3330ba39617b0$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $6df3330ba39617b0$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $6hmKI.default)(name), i = fullname === "transform" ? (0, $3Aif9.interpolateTransformSvg) : (0, $aIbJE.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $6df3330ba39617b0$var$attrFunctionNS : $6df3330ba39617b0$var$attrFunction)(fullname, i, (0, $f7PDQ.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $6df3330ba39617b0$var$attrRemoveNS : $6df3330ba39617b0$var$attrRemove)(fullname) : (fullname.local ? $6df3330ba39617b0$var$attrConstantNS : $6df3330ba39617b0$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("3Aif9", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", () => $29c2e2ab21710ad5$export$56bec7123bb3589a);
$parcel$export(module.exports, "interpolateTransformSvg", () => $29c2e2ab21710ad5$export$da8cba906d64c082);

var $htN5h = parcelRequire("htN5h");

var $4qaDl = parcelRequire("4qaDl");
function $29c2e2ab21710ad5$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $htN5h.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $htN5h.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $htN5h.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $htN5h.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $htN5h.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $htN5h.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $29c2e2ab21710ad5$export$56bec7123bb3589a = $29c2e2ab21710ad5$var$interpolateTransform((0, $4qaDl.parseCss), "px, ", "px)", "deg)");
var $29c2e2ab21710ad5$export$da8cba906d64c082 = $29c2e2ab21710ad5$var$interpolateTransform((0, $4qaDl.parseSvg), ", ", ")", ")");

});
parcelRegister("4qaDl", function(module, exports) {

$parcel$export(module.exports, "parseCss", () => $3381d6bd383a1118$export$59ad369bf4938177);
$parcel$export(module.exports, "parseSvg", () => $3381d6bd383a1118$export$f9ef43f9a1d89a18);

var $92H5S = parcelRequire("92H5S");
var $3381d6bd383a1118$var$svgNode;
function $3381d6bd383a1118$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $92H5S.identity) : (0, $92H5S.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $3381d6bd383a1118$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $92H5S.identity;
    if (!$3381d6bd383a1118$var$svgNode) $3381d6bd383a1118$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $3381d6bd383a1118$var$svgNode.setAttribute("transform", value);
    if (!(value = $3381d6bd383a1118$var$svgNode.transform.baseVal.consolidate())) return 0, $92H5S.identity;
    value = value.matrix;
    return (0, $92H5S.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("92H5S", function(module, exports) {

$parcel$export(module.exports, "identity", () => $6955ba823262b394$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $6955ba823262b394$export$2e2bcd8739ae039);
var $6955ba823262b394$var$degrees = 180 / Math.PI;
var $6955ba823262b394$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $6955ba823262b394$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $6955ba823262b394$var$degrees,
        skewX: Math.atan(skewX) * $6955ba823262b394$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("f7PDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b02f9169704b8a5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tweenValue", () => $b02f9169704b8a5a$export$f78ce6ab10405d82);

var $lp6Kl = parcelRequire("lp6Kl");
function $b02f9169704b8a5a$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $lp6Kl.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $b02f9169704b8a5a$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $lp6Kl.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $b02f9169704b8a5a$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $lp6Kl.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $b02f9169704b8a5a$var$tweenRemove : $b02f9169704b8a5a$var$tweenFunction)(id, name, value));
}
function $b02f9169704b8a5a$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $lp6Kl.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $lp6Kl.get)(node, id).value[name];
    };
}

});

parcelRegister("aIbJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc71dd6abbe2d85$export$2e2bcd8739ae039);

var $7zw1L = parcelRequire("7zw1L");

var $htN5h = parcelRequire("htN5h");
var $7T5jl = parcelRequire("7T5jl");
var $3A4bH = parcelRequire("3A4bH");
function $7cc71dd6abbe2d85$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $htN5h.default) : b instanceof (0, $7zw1L.default) ? (0, $7T5jl.default) : (c = (0, $7zw1L.default)(b)) ? (b = c, $7T5jl.default) : (0, $3A4bH.default))(a, b);
}

});


parcelRegister("2dt77", function(module, exports) {

$parcel$export(module.exports, "default", () => $19d3610d91eac892$export$2e2bcd8739ae039);

var $6hmKI = parcelRequire("6hmKI");
function $19d3610d91eac892$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $19d3610d91eac892$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $19d3610d91eac892$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $19d3610d91eac892$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $19d3610d91eac892$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $19d3610d91eac892$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $19d3610d91eac892$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $6hmKI.default)(name);
    return this.tween(key, (fullname.local ? $19d3610d91eac892$var$attrTweenNS : $19d3610d91eac892$var$attrTween)(fullname, value));
}

});

parcelRegister("8xmuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6372da1b33409b0c$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $6372da1b33409b0c$var$delayFunction(id, value) {
    return function() {
        (0, $lp6Kl.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $6372da1b33409b0c$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $lp6Kl.init)(this, id).delay = value;
    };
}
function $6372da1b33409b0c$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $6372da1b33409b0c$var$delayFunction : $6372da1b33409b0c$var$delayConstant)(id, value)) : (0, $lp6Kl.get)(this.node(), id).delay;
}

});

parcelRegister("4ufDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3446179eea101172$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $3446179eea101172$var$durationFunction(id, value) {
    return function() {
        (0, $lp6Kl.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $3446179eea101172$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $lp6Kl.set)(this, id).duration = value;
    };
}
function $3446179eea101172$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $3446179eea101172$var$durationFunction : $3446179eea101172$var$durationConstant)(id, value)) : (0, $lp6Kl.get)(this.node(), id).duration;
}

});

parcelRegister("g4lNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb2ded6b6415a353$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $bb2ded6b6415a353$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $lp6Kl.set)(this, id).ease = value;
    };
}
function $bb2ded6b6415a353$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($bb2ded6b6415a353$var$easeConstant(id, value)) : (0, $lp6Kl.get)(this.node(), id).ease;
}

});

parcelRegister("c4Nme", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cac2526ee9e1ca9$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $8cac2526ee9e1ca9$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $lp6Kl.set)(this, id).ease = v;
    };
}
function $8cac2526ee9e1ca9$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($8cac2526ee9e1ca9$var$easeVarying(this._id, value));
}

});

parcelRegister("69TaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $47be61e6cfe05bcf$export$2e2bcd8739ae039);

var $aaEMv = parcelRequire("aaEMv");

var $leops = parcelRequire("leops");
function $47be61e6cfe05bcf$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $aaEMv.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $leops.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("gjur0", function(module, exports) {

$parcel$export(module.exports, "default", () => $be06075b70f591f1$export$2e2bcd8739ae039);

var $leops = parcelRequire("leops");
function $be06075b70f591f1$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $leops.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("jcvOK", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa7d1a18c74d7ce$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $dfa7d1a18c74d7ce$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $dfa7d1a18c74d7ce$var$onFunction(id, name, listener) {
    var on0, on1, sit = $dfa7d1a18c74d7ce$var$start(name) ? (0, $lp6Kl.init) : (0, $lp6Kl.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $dfa7d1a18c74d7ce$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $lp6Kl.get)(this.node(), id).on.on(name) : this.each($dfa7d1a18c74d7ce$var$onFunction(id, name, listener));
}

});

parcelRegister("ggTER", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8950781d1621f0$export$2e2bcd8739ae039);
function $bd8950781d1621f0$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $bd8950781d1621f0$export$2e2bcd8739ae039() {
    return this.on("end.remove", $bd8950781d1621f0$var$removeFunction(this._id));
}

});

parcelRegister("fq2F3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b39b59274b919b95$export$2e2bcd8739ae039);

var $fTXhD = parcelRequire("fTXhD");

var $leops = parcelRequire("leops");

var $lp6Kl = parcelRequire("lp6Kl");
function $b39b59274b919b95$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $fTXhD.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $lp6Kl.default)(subgroup[i], name, id, i, subgroup, (0, $lp6Kl.get)(node, id));
        }
    }
    return new (0, $leops.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("45gkY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f944d477a4ff0a1$export$2e2bcd8739ae039);

var $jj2Ac = parcelRequire("jj2Ac");

var $leops = parcelRequire("leops");

var $lp6Kl = parcelRequire("lp6Kl");
function $2f944d477a4ff0a1$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $jj2Ac.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $lp6Kl.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $lp6Kl.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $leops.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("8Hpkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6555fc9ab5e01e93$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");
var $6555fc9ab5e01e93$var$Selection = (0, $huCkF.default).prototype.constructor;
function $6555fc9ab5e01e93$export$2e2bcd8739ae039() {
    return new $6555fc9ab5e01e93$var$Selection(this._groups, this._parents);
}

});

parcelRegister("iQYBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9c1965b96c4625$export$2e2bcd8739ae039);

var $3Aif9 = parcelRequire("3Aif9");

var $i3en0 = parcelRequire("i3en0");

var $lp6Kl = parcelRequire("lp6Kl");

var $f7PDQ = parcelRequire("f7PDQ");

var $aIbJE = parcelRequire("aIbJE");
function $db9c1965b96c4625$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $i3en0.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $i3en0.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $db9c1965b96c4625$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $db9c1965b96c4625$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $i3en0.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $db9c1965b96c4625$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $i3en0.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $i3en0.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $db9c1965b96c4625$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $lp6Kl.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $db9c1965b96c4625$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $db9c1965b96c4625$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $3Aif9.interpolateTransformCss) : (0, $aIbJE.default);
    return value == null ? this.styleTween(name, $db9c1965b96c4625$var$styleNull(name, i)).on("end.style." + name, $db9c1965b96c4625$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $db9c1965b96c4625$var$styleFunction(name, i, (0, $f7PDQ.tweenValue)(this, "style." + name, value))).each($db9c1965b96c4625$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $db9c1965b96c4625$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("9Y295", function(module, exports) {

$parcel$export(module.exports, "default", () => $741b61b8d63a6914$export$2e2bcd8739ae039);
function $741b61b8d63a6914$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $741b61b8d63a6914$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $741b61b8d63a6914$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $741b61b8d63a6914$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $741b61b8d63a6914$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("5PNsE", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f81522a0032ac6$export$2e2bcd8739ae039);

var $f7PDQ = parcelRequire("f7PDQ");
function $43f81522a0032ac6$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $43f81522a0032ac6$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $43f81522a0032ac6$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $43f81522a0032ac6$var$textFunction((0, $f7PDQ.tweenValue)(this, "text", value)) : $43f81522a0032ac6$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("9Ea32", function(module, exports) {

$parcel$export(module.exports, "default", () => $705fa4d4f686bf7a$export$2e2bcd8739ae039);
function $705fa4d4f686bf7a$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $705fa4d4f686bf7a$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $705fa4d4f686bf7a$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $705fa4d4f686bf7a$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $705fa4d4f686bf7a$var$textTween(value));
}

});

parcelRegister("cpVXF", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a4c7bd9b302d92$export$2e2bcd8739ae039);

var $leops = parcelRequire("leops");

var $lp6Kl = parcelRequire("lp6Kl");
function $90a4c7bd9b302d92$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $leops.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $lp6Kl.get)(node, id0);
            (0, $lp6Kl.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $leops.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("edwJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a59bad37f396d212$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $a59bad37f396d212$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $lp6Kl.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}

});


parcelRegister("brLW1", function(module, exports) {

$parcel$export(module.exports, "cubicInOut", () => $8557663587796bd4$export$89238d3bc79d3ada);
function $8557663587796bd4$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $8557663587796bd4$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $8557663587796bd4$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});



parcelRegister("4dVnM", function(module, exports) {

var $leops = parcelRequire("leops");

var $lp6Kl = parcelRequire("lp6Kl");
var $3134e34a2931fb90$var$root = [
    null
];
function $3134e34a2931fb90$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $lp6Kl.SCHEDULED) && schedule.name === name) return new (0, $leops.Transition)([
                [
                    node
                ]
            ], $3134e34a2931fb90$var$root, name, +i);
        }
    }
    return null;
}

});


parcelRegister("kiEPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec7529b5bc1eeb68$export$2e2bcd8739ae039);
var $ec7529b5bc1eeb68$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("gVpv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c525bff5c15ae1c1$export$2e2bcd8739ae039);
function $c525bff5c15ae1c1$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("dV7fx", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $a22638d87ba06a09$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $a22638d87ba06a09$export$2e2bcd8739ae039);
function $a22638d87ba06a09$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $a22638d87ba06a09$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});



parcelRegister("wUwgT", function(module, exports) {

$parcel$export(module.exports, "default", () => $062ed4def101d7fa$export$2e2bcd8739ae039);

var $6JuYh = parcelRequire("6JuYh");
var $bmlMK = parcelRequire("bmlMK");
var $9M96w = parcelRequire("9M96w");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $aSvrg = parcelRequire("aSvrg");

var $lh0D1 = parcelRequire("lh0D1");

var $cUX6y = parcelRequire("cUX6y");

var $gGeSO = parcelRequire("gGeSO");

var $3xref = parcelRequire("3xref");
function $062ed4def101d7fa$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $aNOl6.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $9M96w.default)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $6JuYh.default));
    scale.rangeRound = range((0, $bmlMK.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $062ed4def101d7fa$export$2e2bcd8739ae039() {
    var scale = (0, $aSvrg.linearish)($062ed4def101d7fa$var$transformer()((0, $aNOl6.identity)));
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$2e2bcd8739ae039());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$5f0266a9159c47fb() {
    var scale = (0, $lh0D1.loggish)($062ed4def101d7fa$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$50b3da713cf557c6() {
    var scale = (0, $gGeSO.symlogish)($062ed4def101d7fa$var$transformer());
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$d6cedcc63bf26e7e() {
    var scale = (0, $3xref.powish)($062ed4def101d7fa$var$transformer());
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$33ddefb5c4ab9e9c() {
    return $062ed4def101d7fa$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}

});
parcelRegister("6JuYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e6ef844ac4b3a47$export$2e2bcd8739ae039);

var $e1U5l = parcelRequire("e1U5l");

var $dFDiJ = parcelRequire("dFDiJ");

var $3IkHg = parcelRequire("3IkHg");

var $fw8eO = parcelRequire("fw8eO");

var $fxmGQ = parcelRequire("fxmGQ");

var $9oPd3 = parcelRequire("9oPd3");

var $dNfKS = parcelRequire("dNfKS");

var $lFlsW = parcelRequire("lFlsW");

var $k994c = parcelRequire("k994c");
function $4e6ef844ac4b3a47$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $lFlsW.default)(b) : (t === "number" ? (0, $fxmGQ.default) : t === "string" ? (c = (0, $e1U5l.default)(b)) ? (b = c, $dFDiJ.default) : (0, $dNfKS.default) : b instanceof (0, $e1U5l.default) ? (0, $dFDiJ.default) : b instanceof Date ? (0, $fw8eO.default) : (0, $k994c.isNumberArray)(b) ? (0, $k994c.default) : Array.isArray(b) ? (0, $3IkHg.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $9oPd3.default) : (0, $fxmGQ.default))(a, b);
}

});
parcelRegister("e1U5l", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $ioX81 = parcelRequire("ioX81");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $ioX81.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $ioX81.default)(Rgb, rgb, (0, $ioX81.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $ioX81.default)(Hsl, hsl, (0, $ioX81.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("ioX81", function(module, exports) {

$parcel$export(module.exports, "default", () => $037509a362c79022$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $037509a362c79022$export$8b58be045bf06082);
function $037509a362c79022$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $037509a362c79022$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("dFDiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f3d9714057a674e$export$2e2bcd8739ae039);

var $e1U5l = parcelRequire("e1U5l");

var $etJnf = parcelRequire("etJnf");

var $e5IXz = parcelRequire("e5IXz");

var $kKoo2 = parcelRequire("kKoo2");
var $9f3d9714057a674e$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $kKoo2.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $e1U5l.rgb)(start)).r, (end = (0, $e1U5l.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $kKoo2.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $9f3d9714057a674e$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $e1U5l.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $9f3d9714057a674e$export$2c0e28f2e2852d3f = $9f3d9714057a674e$var$rgbSpline((0, $etJnf.default));
var $9f3d9714057a674e$export$53d5214f625ccd4c = $9f3d9714057a674e$var$rgbSpline((0, $e5IXz.default));

});
parcelRegister("etJnf", function(module, exports) {

$parcel$export(module.exports, "basis", () => $a8a6f872a67f9f91$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $a8a6f872a67f9f91$export$2e2bcd8739ae039);
function $a8a6f872a67f9f91$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $a8a6f872a67f9f91$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $a8a6f872a67f9f91$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("e5IXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4246869a2b2013d$export$2e2bcd8739ae039);

var $etJnf = parcelRequire("etJnf");
function $a4246869a2b2013d$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $etJnf.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("kKoo2", function(module, exports) {

$parcel$export(module.exports, "gamma", () => $f1ab053cfa8196f9$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $f1ab053cfa8196f9$export$2e2bcd8739ae039);

var $lFlsW = parcelRequire("lFlsW");
function $f1ab053cfa8196f9$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $f1ab053cfa8196f9$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $f1ab053cfa8196f9$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $f1ab053cfa8196f9$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $lFlsW.default)(isNaN(a) ? b : a);
}
function $f1ab053cfa8196f9$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $f1ab053cfa8196f9$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $f1ab053cfa8196f9$var$exponential(a, b, y) : (0, $lFlsW.default)(isNaN(a) ? b : a);
    };
}
function $f1ab053cfa8196f9$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $f1ab053cfa8196f9$var$linear(a, d) : (0, $lFlsW.default)(isNaN(a) ? b : a);
}

});
parcelRegister("lFlsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc5e13f4bdfeecbb$export$2e2bcd8739ae039);
var $fc5e13f4bdfeecbb$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("3IkHg", function(module, exports) {

$parcel$export(module.exports, "genericArray", () => $2b45891ca744d3db$export$15d09067c6a5ee49);

var $6JuYh = parcelRequire("6JuYh");

var $k994c = parcelRequire("k994c");
function $2b45891ca744d3db$export$2e2bcd8739ae039(a, b) {
    return ((0, $k994c.isNumberArray)(b) ? (0, $k994c.default) : $2b45891ca744d3db$export$15d09067c6a5ee49)(a, b);
}
function $2b45891ca744d3db$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $6JuYh.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("k994c", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaabae5aec58682c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $eaabae5aec58682c$export$5cd576d1827d40c8);
function $eaabae5aec58682c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $eaabae5aec58682c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("fw8eO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c03c06faca7439$export$2e2bcd8739ae039);
function $b4c03c06faca7439$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("fxmGQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4fb89d7e21add48$export$2e2bcd8739ae039);
function $b4fb89d7e21add48$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("9oPd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d7e141c27bcdec9$export$2e2bcd8739ae039);

var $6JuYh = parcelRequire("6JuYh");
function $6d7e141c27bcdec9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $6JuYh.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("dNfKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0ac1293c2d5ecbd$export$2e2bcd8739ae039);

var $fxmGQ = parcelRequire("fxmGQ");
var $a0ac1293c2d5ecbd$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $a0ac1293c2d5ecbd$var$reB = new RegExp($a0ac1293c2d5ecbd$var$reA.source, "g");
function $a0ac1293c2d5ecbd$var$zero(b) {
    return function() {
        return b;
    };
}
function $a0ac1293c2d5ecbd$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $a0ac1293c2d5ecbd$export$2e2bcd8739ae039(a, b) {
    var bi = $a0ac1293c2d5ecbd$var$reA.lastIndex = $a0ac1293c2d5ecbd$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $a0ac1293c2d5ecbd$var$reA.exec(a)) && (bm = $a0ac1293c2d5ecbd$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $fxmGQ.default)(am, bm)
            });
        }
        bi = $a0ac1293c2d5ecbd$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $a0ac1293c2d5ecbd$var$one(q[0].x) : $a0ac1293c2d5ecbd$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("bmlMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8452a5df9255c68e$export$2e2bcd8739ae039);
function $8452a5df9255c68e$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("9M96w", function(module, exports) {

$parcel$export(module.exports, "default", () => $71dfa8a5df6ac0fc$export$2e2bcd8739ae039);

var $6JuYh = parcelRequire("6JuYh");
function $71dfa8a5df6ac0fc$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $6JuYh.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("aNOl6", function(module, exports) {

$parcel$export(module.exports, "identity", () => $7dd587536c83aff7$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $7dd587536c83aff7$export$784d13d8ee351f07);
$parcel$export(module.exports, "transformer", () => $7dd587536c83aff7$export$6b468dcfb64c653c);
$parcel$export(module.exports, "default", () => $7dd587536c83aff7$export$2e2bcd8739ae039);

var $cB7hd = parcelRequire("cB7hd");

var $6JuYh = parcelRequire("6JuYh");
var $fxmGQ = parcelRequire("fxmGQ");
var $bmlMK = parcelRequire("bmlMK");

var $84Czd = parcelRequire("84Czd");

var $6sY3H = parcelRequire("6sY3H");
var $7dd587536c83aff7$var$unit = [
    0,
    1
];
function $7dd587536c83aff7$export$f0954fd7d5368655(x) {
    return x;
}
function $7dd587536c83aff7$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $84Czd.default)(isNaN(b) ? NaN : 0.5);
}
function $7dd587536c83aff7$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $7dd587536c83aff7$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $7dd587536c83aff7$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $7dd587536c83aff7$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $7dd587536c83aff7$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $7dd587536c83aff7$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $cB7hd.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $7dd587536c83aff7$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $7dd587536c83aff7$export$6b468dcfb64c653c() {
    var domain = $7dd587536c83aff7$var$unit, range = $7dd587536c83aff7$var$unit, interpolate = (0, $6JuYh.default), transform, untransform, unknown, clamp = $7dd587536c83aff7$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $7dd587536c83aff7$export$f0954fd7d5368655) clamp = $7dd587536c83aff7$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $7dd587536c83aff7$var$polymap : $7dd587536c83aff7$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $fxmGQ.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $6sY3H.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $bmlMK.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $7dd587536c83aff7$export$f0954fd7d5368655, rescale()) : clamp !== $7dd587536c83aff7$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $7dd587536c83aff7$export$2e2bcd8739ae039() {
    return $7dd587536c83aff7$export$6b468dcfb64c653c()($7dd587536c83aff7$export$f0954fd7d5368655, $7dd587536c83aff7$export$f0954fd7d5368655);
}

});
parcelRegister("cB7hd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92be95bfb77a34dd$export$2e2bcd8739ae039);

var $733O4 = parcelRequire("733O4");

var $1xmrF = parcelRequire("1xmrF");

var $30m79 = parcelRequire("30m79");
const $92be95bfb77a34dd$var$ascendingBisect = (0, $1xmrF.default)((0, $733O4.default));
const $92be95bfb77a34dd$export$4d945ad3ad5751b0 = $92be95bfb77a34dd$var$ascendingBisect.right;
const $92be95bfb77a34dd$export$df7d25c84ebd12a5 = $92be95bfb77a34dd$var$ascendingBisect.left;
const $92be95bfb77a34dd$export$c1cb828b1117c77b = (0, $1xmrF.default)((0, $30m79.default)).center;
var $92be95bfb77a34dd$export$2e2bcd8739ae039 = $92be95bfb77a34dd$export$4d945ad3ad5751b0;

});
parcelRegister("733O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $521bc42303c41d3f$export$2e2bcd8739ae039);
function $521bc42303c41d3f$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("1xmrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $11ea48af9b87e2dd$export$2e2bcd8739ae039);

var $733O4 = parcelRequire("733O4");
function $11ea48af9b87e2dd$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $11ea48af9b87e2dd$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $11ea48af9b87e2dd$var$ascendingComparator(f) {
    return (d, x)=>(0, $733O4.default)(f(d), x);
}

});

parcelRegister("30m79", function(module, exports) {

$parcel$export(module.exports, "default", () => $230286a6954ff4a3$export$2e2bcd8739ae039);
function $230286a6954ff4a3$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $230286a6954ff4a3$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("84Czd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e0c9d0e02557db5$export$2e2bcd8739ae039);
function $5e0c9d0e02557db5$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("6sY3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b53f1fd03e1a986$export$2e2bcd8739ae039);
function $4b53f1fd03e1a986$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("iGmDW", function(module, exports) {

$parcel$export(module.exports, "initRange", () => $d99db6b9f4809fde$export$23c7bb9e6558da2a);
$parcel$export(module.exports, "initInterpolator", () => $d99db6b9f4809fde$export$7d6b419e59e83f3d);
function $d99db6b9f4809fde$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $d99db6b9f4809fde$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("aSvrg", function(module, exports) {

$parcel$export(module.exports, "linearish", () => $7eb7559767ab28a3$export$16a5d4b4a61a274d);
$parcel$export(module.exports, "default", () => $7eb7559767ab28a3$export$2e2bcd8739ae039);

var $3um73 = parcelRequire("3um73");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $edgk5 = parcelRequire("edgk5");
function $7eb7559767ab28a3$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $3um73.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $edgk5.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $3um73.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $7eb7559767ab28a3$export$2e2bcd8739ae039() {
    var scale = (0, $aNOl6.default)();
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $7eb7559767ab28a3$export$2e2bcd8739ae039());
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return $7eb7559767ab28a3$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("3um73", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a55395a79a6785$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $28a55395a79a6785$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $28a55395a79a6785$export$81087d9b915d4ede);
var $28a55395a79a6785$var$e10 = Math.sqrt(50), $28a55395a79a6785$var$e5 = Math.sqrt(10), $28a55395a79a6785$var$e2 = Math.sqrt(2);
function $28a55395a79a6785$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $28a55395a79a6785$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $28a55395a79a6785$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $28a55395a79a6785$var$e10 ? 10 : error >= $28a55395a79a6785$var$e5 ? 5 : error >= $28a55395a79a6785$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $28a55395a79a6785$var$e10 ? 10 : error >= $28a55395a79a6785$var$e5 ? 5 : error >= $28a55395a79a6785$var$e2 ? 2 : 1);
}
function $28a55395a79a6785$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $28a55395a79a6785$var$e10) step1 *= 10;
    else if (error >= $28a55395a79a6785$var$e5) step1 *= 5;
    else if (error >= $28a55395a79a6785$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("edgk5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58ef0ffdff81f44$export$2e2bcd8739ae039);

var $3um73 = parcelRequire("3um73");

var $2Znxj = parcelRequire("2Znxj");
var $eHEu2 = parcelRequire("eHEu2");
var $5FDlc = parcelRequire("5FDlc");
var $81T5G = parcelRequire("81T5G");
var $djxyw = parcelRequire("djxyw");
function $a58ef0ffdff81f44$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $3um73.tickStep)(start, stop, count), precision;
    specifier = (0, $eHEu2.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $81T5G.default)(step, value))) specifier.precision = precision;
            return (0, $2Znxj.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $djxyw.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $5FDlc.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $2Znxj.format)(specifier);
}

});
parcelRegister("2Znxj", function(module, exports) {

$parcel$export(module.exports, "format", () => $22d3891b0a8207dc$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $22d3891b0a8207dc$export$8d85692a469dde6f);

var $6jrXW = parcelRequire("6jrXW");
var $22d3891b0a8207dc$var$locale;
var $22d3891b0a8207dc$export$d9468344d3651243;
var $22d3891b0a8207dc$export$8d85692a469dde6f;
$22d3891b0a8207dc$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $22d3891b0a8207dc$export$2e2bcd8739ae039(definition) {
    $22d3891b0a8207dc$var$locale = (0, $6jrXW.default)(definition);
    $22d3891b0a8207dc$export$d9468344d3651243 = $22d3891b0a8207dc$var$locale.format;
    $22d3891b0a8207dc$export$8d85692a469dde6f = $22d3891b0a8207dc$var$locale.formatPrefix;
    return $22d3891b0a8207dc$var$locale;
}

});
parcelRegister("6jrXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $498a35d68f49e7e2$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");

var $7wwOm = parcelRequire("7wwOm");

var $2fbAQ = parcelRequire("2fbAQ");

var $eHEu2 = parcelRequire("eHEu2");

var $aW3cW = parcelRequire("aW3cW");

var $7XVtR = parcelRequire("7XVtR");

var $4j2D3 = parcelRequire("4j2D3");

var $cFVbY = parcelRequire("cFVbY");
var $498a35d68f49e7e2$var$map = Array.prototype.map, $498a35d68f49e7e2$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $498a35d68f49e7e2$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $cFVbY.default) : (0, $7wwOm.default)($498a35d68f49e7e2$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $cFVbY.default) : (0, $2fbAQ.default)($498a35d68f49e7e2$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $eHEu2.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $7XVtR.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $7XVtR.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $aW3cW.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $498a35d68f49e7e2$var$prefixes[8 + (0, $4j2D3.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $eHEu2.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $KN7ee.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $498a35d68f49e7e2$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("KN7ee", function(module, exports) {

$parcel$export(module.exports, "default", () => $08ca65535483c84a$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");
function $08ca65535483c84a$export$2e2bcd8739ae039(x) {
    return x = (0, $7IWiR.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("7IWiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f9de4283371c3d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $59f9de4283371c3d$export$8f8e23dd27dc19f5);
function $59f9de4283371c3d$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $59f9de4283371c3d$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("7wwOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $57a4f9340c729126$export$2e2bcd8739ae039);
function $57a4f9340c729126$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("2fbAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a25f9af2d42035d$export$2e2bcd8739ae039);
function $1a25f9af2d42035d$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("eHEu2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab447c01a5372829$export$2e2bcd8739ae039);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $ab447c01a5372829$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $ab447c01a5372829$export$2e2bcd8739ae039(specifier) {
    if (!(match = $ab447c01a5372829$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $ab447c01a5372829$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$ab447c01a5372829$export$2e2bcd8739ae039.prototype = $ab447c01a5372829$export$963aac351db36ed4.prototype; // instanceof
function $ab447c01a5372829$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$ab447c01a5372829$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("aW3cW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f61cf24ddaee9e2$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $7f61cf24ddaee9e2$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("7XVtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ccaa18de028dacc$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");

var $4j2D3 = parcelRequire("4j2D3");

var $bb5Zx = parcelRequire("bb5Zx");
var $5ccaa18de028dacc$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $7IWiR.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $bb5Zx.default)(x * 100, p),
    "r": (0, $bb5Zx.default),
    "s": (0, $4j2D3.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("4j2D3", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $322af9d78239adb9$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $322af9d78239adb9$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");
var $322af9d78239adb9$export$6863724d9a42263;
function $322af9d78239adb9$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7IWiR.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($322af9d78239adb9$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $7IWiR.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("bb5Zx", function(module, exports) {

$parcel$export(module.exports, "default", () => $82355e931f5c47fe$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");
function $82355e931f5c47fe$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7IWiR.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("cFVbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a5ad840c97a223$export$2e2bcd8739ae039);
function $93a5ad840c97a223$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("5FDlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $420f4c647bf8858f$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");
function $420f4c647bf8858f$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $KN7ee.default)(Math.abs(step)));
}

});

parcelRegister("81T5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d89269b2b96d903$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");
function $5d89269b2b96d903$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $KN7ee.default)(value) / 3))) * 3 - (0, $KN7ee.default)(Math.abs(step)));
}

});

parcelRegister("djxyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b17143390a46e38$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");
function $9b17143390a46e38$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $KN7ee.default)(max) - (0, $KN7ee.default)(step)) + 1;
}

});



parcelRegister("lh0D1", function(module, exports) {

$parcel$export(module.exports, "loggish", () => $f7cbac45ef330d6b$export$860836db074028f0);

var $3um73 = parcelRequire("3um73");

var $2Znxj = parcelRequire("2Znxj");

var $7vI1J = parcelRequire("7vI1J");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");
function $f7cbac45ef330d6b$var$transformLog(x) {
    return Math.log(x);
}
function $f7cbac45ef330d6b$var$transformExp(x) {
    return Math.exp(x);
}
function $f7cbac45ef330d6b$var$transformLogn(x) {
    return -Math.log(-x);
}
function $f7cbac45ef330d6b$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $f7cbac45ef330d6b$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $f7cbac45ef330d6b$var$powp(base) {
    return base === 10 ? $f7cbac45ef330d6b$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $f7cbac45ef330d6b$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $f7cbac45ef330d6b$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $f7cbac45ef330d6b$export$860836db074028f0(transform) {
    var scale = transform($f7cbac45ef330d6b$var$transformLog, $f7cbac45ef330d6b$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $f7cbac45ef330d6b$var$logp(base), pows = $f7cbac45ef330d6b$var$powp(base);
        if (domain()[0] < 0) {
            logs = $f7cbac45ef330d6b$var$reflect(logs), pows = $f7cbac45ef330d6b$var$reflect(pows);
            transform($f7cbac45ef330d6b$var$transformLogn, $f7cbac45ef330d6b$var$transformExpn);
        } else transform($f7cbac45ef330d6b$var$transformLog, $f7cbac45ef330d6b$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $3um73.default)(u, v, n);
        } else z = (0, $3um73.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $2Znxj.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $7vI1J.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $f7cbac45ef330d6b$export$2e2bcd8739ae039() {
    var scale = $f7cbac45ef330d6b$export$860836db074028f0((0, $aNOl6.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $f7cbac45ef330d6b$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("7vI1J", function(module, exports) {

$parcel$export(module.exports, "default", () => $577d948182c6aae1$export$2e2bcd8739ae039);
function $577d948182c6aae1$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("cUX6y", function(module, exports) {

$parcel$export(module.exports, "copy", () => $96788ff93b613852$export$784d13d8ee351f07);

var $6JuYh = parcelRequire("6JuYh");
var $bmlMK = parcelRequire("bmlMK");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $aSvrg = parcelRequire("aSvrg");

var $lh0D1 = parcelRequire("lh0D1");

var $gGeSO = parcelRequire("gGeSO");

var $3xref = parcelRequire("3xref");
function $96788ff93b613852$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $aNOl6.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $6JuYh.default));
    scale.rangeRound = range((0, $bmlMK.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $96788ff93b613852$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $96788ff93b613852$export$2e2bcd8739ae039() {
    var scale = (0, $aSvrg.linearish)($96788ff93b613852$var$transformer()((0, $aNOl6.identity)));
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$2e2bcd8739ae039());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$6843e08bf2ff981f() {
    var scale = (0, $lh0D1.loggish)($96788ff93b613852$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$9d4af4de62c81941() {
    var scale = (0, $gGeSO.symlogish)($96788ff93b613852$var$transformer());
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$de9f78581b4f2405() {
    var scale = (0, $3xref.powish)($96788ff93b613852$var$transformer());
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$413d935127ed466e() {
    return $96788ff93b613852$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}

});
parcelRegister("gGeSO", function(module, exports) {

$parcel$export(module.exports, "symlogish", () => $c24c1d0768db7e3c$export$4602684e614eba38);

var $aSvrg = parcelRequire("aSvrg");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");
function $c24c1d0768db7e3c$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $c24c1d0768db7e3c$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $c24c1d0768db7e3c$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($c24c1d0768db7e3c$var$transformSymlog(c), $c24c1d0768db7e3c$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($c24c1d0768db7e3c$var$transformSymlog(c = +_), $c24c1d0768db7e3c$var$transformSymexp(c)) : c;
    };
    return (0, $aSvrg.linearish)(scale);
}
function $c24c1d0768db7e3c$export$2e2bcd8739ae039() {
    var scale = $c24c1d0768db7e3c$export$4602684e614eba38((0, $aNOl6.transformer)());
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $c24c1d0768db7e3c$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $iGmDW.initRange).apply(scale, arguments);
}

});

parcelRegister("3xref", function(module, exports) {

$parcel$export(module.exports, "powish", () => $29399341a46df5cd$export$34695211ec403a46);

var $aSvrg = parcelRequire("aSvrg");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");
function $29399341a46df5cd$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $29399341a46df5cd$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $29399341a46df5cd$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $29399341a46df5cd$export$34695211ec403a46(transform) {
    var scale = transform((0, $aNOl6.identity), (0, $aNOl6.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $aNOl6.identity), (0, $aNOl6.identity)) : exponent === 0.5 ? transform($29399341a46df5cd$var$transformSqrt, $29399341a46df5cd$var$transformSquare) : transform($29399341a46df5cd$var$transformPow(exponent), $29399341a46df5cd$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $aSvrg.linearish)(scale);
}
function $29399341a46df5cd$export$2e2bcd8739ae039() {
    var scale = $29399341a46df5cd$export$34695211ec403a46((0, $aNOl6.transformer)());
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $29399341a46df5cd$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return scale;
}
function $29399341a46df5cd$export$eba8049fb5020b81() {
    return $29399341a46df5cd$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("eFMgS", function(module, exports) {

var $fakZL = parcelRequire("fakZL");

var $7iDKc = parcelRequire("7iDKc");

});
parcelRegister("fakZL", function(module, exports) {

var $7cJ51 = parcelRequire("7cJ51");

var $bN3To = parcelRequire("bN3To");

var $8u0ed = parcelRequire("8u0ed");

var $6xNHt = parcelRequire("6xNHt");
var $8mHRd = parcelRequire("8mHRd");
parcelRequire("8czdG");
var $96buf = parcelRequire("96buf");

var $4Es4f = parcelRequire("4Es4f");

var $eUaWk = parcelRequire("eUaWk");

var $7iDKc = parcelRequire("7iDKc");

var $4U5Zm = parcelRequire("4U5Zm");
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $b0a81369feaadb1e$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $b0a81369feaadb1e$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $b0a81369feaadb1e$var$defaultTransform() {
    return this.__zoom || (0, $7iDKc.identity);
}
function $b0a81369feaadb1e$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $b0a81369feaadb1e$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $b0a81369feaadb1e$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $b0a81369feaadb1e$export$2e2bcd8739ae039() {
    var filter = $b0a81369feaadb1e$var$defaultFilter, extent = $b0a81369feaadb1e$var$defaultExtent, constrain = $b0a81369feaadb1e$var$defaultConstrain, wheelDelta = $b0a81369feaadb1e$var$defaultWheelDelta, touchable = $b0a81369feaadb1e$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $8u0ed.default), listeners = (0, $7cJ51.default)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $b0a81369feaadb1e$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $b0a81369feaadb1e$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $7iDKc.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $7iDKc.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $7iDKc.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $7iDKc.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $8mHRd.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $eUaWk.default)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $6xNHt.default)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $96buf.default)(this);
            g.start();
        }
        (0, $4U5Zm.default)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, args, true).event(event), v = (0, $8mHRd.default)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $6xNHt.default)(event, currentTarget), currentTarget = event.currentTarget, x0 = event.clientX, y0 = event.clientY;
        (0, $bN3To.default)(event.view);
        (0, $4U5Zm.nopropagation)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $96buf.default)(this);
        g.start();
        function mousemoved(event) {
            (0, $4U5Zm.default)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $6xNHt.default)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $bN3To.yesdrag)(event.view, g.moved);
            (0, $4U5Zm.default)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $6xNHt.default)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $4U5Zm.default)(event);
        if (duration > 0) (0, $8mHRd.default)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $8mHRd.default)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $4U5Zm.nopropagation)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $6xNHt.default)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $96buf.default)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $4U5Zm.default)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $6xNHt.default)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $4U5Zm.nopropagation)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $6xNHt.default)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $8mHRd.default)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $4Es4f.default)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4Es4f.default)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4Es4f.default)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4Es4f.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}

});
parcelRegister("8u0ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d14d651755ad24$export$2e2bcd8739ae039);
var $62d14d651755ad24$var$epsilon2 = 1e-12;
function $62d14d651755ad24$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $62d14d651755ad24$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $62d14d651755ad24$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $62d14d651755ad24$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $62d14d651755ad24$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $62d14d651755ad24$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $62d14d651755ad24$var$tanh(rho * s + r0) - $62d14d651755ad24$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $62d14d651755ad24$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

});

parcelRegister("4Es4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $3630ab73f6216cd0$export$2e2bcd8739ae039);
var $3630ab73f6216cd0$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("eUaWk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9ec80ebe6e1438$export$2e2bcd8739ae039);
function $ad9ec80ebe6e1438$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("7iDKc", function(module, exports) {

$parcel$export(module.exports, "Transform", () => $55090b392153f0d5$export$563a914cafbdc389);
$parcel$export(module.exports, "identity", () => $55090b392153f0d5$export$f0954fd7d5368655);
function $55090b392153f0d5$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$55090b392153f0d5$export$563a914cafbdc389.prototype = {
    constructor: $55090b392153f0d5$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $55090b392153f0d5$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $55090b392153f0d5$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $55090b392153f0d5$export$f0954fd7d5368655 = new $55090b392153f0d5$export$563a914cafbdc389(1, 0, 0);
$55090b392153f0d5$export$2e2bcd8739ae039.prototype = $55090b392153f0d5$export$563a914cafbdc389.prototype;
function $55090b392153f0d5$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $55090b392153f0d5$export$f0954fd7d5368655;
    return node.__zoom;
}

});

parcelRegister("4U5Zm", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $392109a37f19436b$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $392109a37f19436b$export$2e2bcd8739ae039);
function $392109a37f19436b$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $392109a37f19436b$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});




parcelRegister("bxlao", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $81PUJ = parcelRequire("81PUJ");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $81PUJ.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $81PUJ.default)(Rgb, rgb, (0, $81PUJ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $81PUJ.default)(Hsl, hsl, (0, $81PUJ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("81PUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d86afbecc899f0f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $5d86afbecc899f0f$export$8b58be045bf06082);
function $5d86afbecc899f0f$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $5d86afbecc899f0f$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


/* eslint-disable import/no-extraneous-dependencies */ var $d297014a5c3795d0$exports = {};
'use strict';

$d297014a5c3795d0$exports = (parcelRequire("cYS4f"));


parcelRequire("63Xef");
var $8bad1b53a8edf91c$exports = {};

$parcel$export($8bad1b53a8edf91c$exports, "createRoot", () => $8bad1b53a8edf91c$export$882461b6382ed46c, (v) => $8bad1b53a8edf91c$export$882461b6382ed46c = v);
$parcel$export($8bad1b53a8edf91c$exports, "hydrateRoot", () => $8bad1b53a8edf91c$export$757ceba2d55c277e, (v) => $8bad1b53a8edf91c$export$757ceba2d55c277e = v);
var $8bad1b53a8edf91c$export$882461b6382ed46c;
var $8bad1b53a8edf91c$export$757ceba2d55c277e;
'use strict';
var $6b3cbfe7ceb06ab6$exports = {};
'use strict';
function $6b3cbfe7ceb06ab6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

$6b3cbfe7ceb06ab6$exports = (parcelRequire("pGDnY"));


var $8bad1b53a8edf91c$var$i = $6b3cbfe7ceb06ab6$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$8bad1b53a8edf91c$export$882461b6382ed46c = function(c, o) {
    $8bad1b53a8edf91c$var$i.usingClientEntryPoint = true;
    try {
        return $6b3cbfe7ceb06ab6$exports.createRoot(c, o);
    } finally{
        $8bad1b53a8edf91c$var$i.usingClientEntryPoint = false;
    }
};
$8bad1b53a8edf91c$export$757ceba2d55c277e = function(c, h, o) {
    $8bad1b53a8edf91c$var$i.usingClientEntryPoint = true;
    try {
        return $6b3cbfe7ceb06ab6$exports.hydrateRoot(c, h, o);
    } finally{
        $8bad1b53a8edf91c$var$i.usingClientEntryPoint = false;
    }
};


/* eslint-disable no-param-reassign */ /* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable jsx-a11y/label-has-associated-control */ // eslint-disable-next-line import/no-extraneous-dependencies


var $63Xef = parcelRequire("63Xef");
const $b9c7b02947e449f9$export$9a758514bd1283e0 = [
    'pitch_run_value',
    'pitch_velo',
    'pitch_usage',
    'pitch_spin',
    'pitch_whiff_percent',
    'pitch_break_x',
    'pitch_break_z',
    'pitch_break_z_induced',
    'pitch_extension'
];
const $b9c7b02947e449f9$export$dc30e34250fc57de = [
    'pitch_usage',
    'pitch_spin',
    'pitch_break_x',
    'pitch_break_z',
    'pitch_break_z_induced'
];
const $b9c7b02947e449f9$export$c6722944e73e432c = [
    'ff',
    'si',
    'fc',
    'ch',
    'fs',
    'fo',
    'sc',
    'cu',
    'sl',
    'st',
    'sv',
    'kn'
];
// const armsidePitchTypes: string[] = ['ff', 'si', 'ch', 'fs', 'fo', 'sc']
const $b9c7b02947e449f9$var$dropPitchTypes = [
    'si',
    'fc',
    'ch',
    'fs',
    'fo',
    'sc',
    'cu',
    'sl',
    'st',
    'sv'
];
const $b9c7b02947e449f9$export$5be31645a946ce43 = $b9c7b02947e449f9$export$c6722944e73e432c.map((type)=>{
    const pitchPctArr = [];
    $b9c7b02947e449f9$export$9a758514bd1283e0.forEach((category)=>{
        pitchPctArr.push(`${type}_percent_rank_${category}`);
    });
    return pitchPctArr;
}).flat();
const $b9c7b02947e449f9$export$4fe8a8e93e7610e3 = [
    'percent_rank_swing_take_run_value',
    'percent_rank_fielding_run_value',
    'percent_rank_runner_run_value',
    'percent_rank_pitch_run_value_fastball',
    'percent_rank_pitch_run_value_breaking',
    'percent_rank_pitch_run_value_offspeed',
    'percent_rank_xwoba',
    'percent_rank_xera',
    'percent_rank_woba',
    'percent_rank_xwobacon',
    'percent_rank_wobacon',
    'percent_rank_xba',
    'percent_rank_ba',
    'percent_rank_xobp',
    'percent_rank_obp',
    'percent_rank_xslg',
    'percent_rank_slg',
    'percent_rank_bacon',
    'percent_rank_xbacon',
    'percent_rank_babip',
    'percent_rank_xiso',
    'percent_rank_iso',
    'percent_rank_exit_velocity_avg',
    'percent_rank_exit_velocity_max',
    'percent_rank_distance_hr_avg',
    'percent_rank_xhr',
    'percent_rank_barrel',
    'percent_rank_barrel_batted_rate',
    'percent_rank_launch_angle_avg',
    'percent_rank_hard_hit_percent',
    'percent_rank_sweet_spot_percent',
    'percent_rank_swing_speed',
    'percent_rank_swing_length',
    'percent_rank_squared_up_swing',
    'percent_rank_blasts_swing',
    'percent_rank_chase_percent',
    'percent_rank_whiff_percent',
    'percent_rank_k_percent',
    'percent_rank_bb_percent',
    'percent_rank_groundballs_percent',
    'percent_rank_airballs_percent',
    'percent_rank_pull_percent_airballs',
    'percent_rank_avg_hyper_speed',
    'percent_rank_avg_best_speed',
    'percent_rank_attack_angle',
    'percent_rank_vertical_swing_path',
    // 'percent_rank_acceleration',
    'percent_rank_ideal_angle_rate',
    'percent_rank_oaa',
    'percent_rank_fielding_run_value_arm',
    'percent_rank_arm_overall',
    'percent_rank_arm_max',
    'percent_rank_jump',
    'percent_rank_blocks_above_average',
    'percent_rank_cs_above_average',
    'percent_rank_fielding_run_value_framing',
    'percent_rank_pop_2b',
    'percent_rank_arm_cs_2b',
    'percent_rank_speed_order',
    'percent_rank_runner_runs_sb',
    'percent_rank_runner_runs_xb',
    ...$b9c7b02947e449f9$export$5be31645a946ce43
];
const $b9c7b02947e449f9$var$validSplitKeys = new Set($b9c7b02947e449f9$export$4fe8a8e93e7610e3.map((key)=>key.replace('percent_rank_', '')));
function $b9c7b02947e449f9$var$isPlayerRowKey(s) {
    return $b9c7b02947e449f9$var$validSplitKeys.has(s);
}
function $b9c7b02947e449f9$export$46118f863c8123c6(d) {
    if (d.split('percent_rank').length > 0 && d.split('percent_rank')[0] !== '') {
        const [pitch, stat] = d.split('_percent_rank_');
        return `${pitch}_${stat}`;
    }
    const splitKey = d.split('percent_rank_')[1];
    switch(splitKey){
        case 'chase_percent':
            return 'oz_swing_percent';
        case 'oaa':
            return 'outs_above_average';
        case 'framing':
            return 'fielding_run_value_framing';
        case 'jump':
            return 'jump_v_avg';
        case 'cu_spin':
            return 'curveball_spin';
        case 'arm_max':
            return 'max_arm_strength';
        case 'swing_speed':
            return 'avg_swing_speed';
        case 'swing_length':
            return 'avg_swing_length';
        case 'speed_order':
            return 'sprint_speed';
        default:
            if ($b9c7b02947e449f9$var$isPlayerRowKey(splitKey)) return splitKey;
            throw new Error(`Unknown percentile key: ${d}`);
    }
}
const $b9c7b02947e449f9$export$138ac6cd166d22dc = [
    'ba',
    'xba',
    'est_ba',
    'obp',
    'xobp',
    'est_obp',
    'slg',
    'xslg',
    'est_slg',
    'iso',
    'xiso',
    'est_iso',
    'ops',
    'babip',
    'est_babip',
    'woba',
    'xwoba',
    'est_woba',
    'wobacon',
    'xwobacon',
    'est_wobacon',
    'bacon',
    'xbacon',
    'est_bacon'
];
const $b9c7b02947e449f9$export$453fe672ce4b2f38 = [
    'pitch_run_value_fastball',
    'pitch_run_value_breaking',
    'pitch_run_value_offspeed'
];
const $b9c7b02947e449f9$export$2ce867a7e1378570 = [
    'avg_hyper_speed',
    'avg_best_speed',
    'era',
    'xera',
    'k_percent',
    'bb_percent',
    'exit_velocity_avg',
    'exit_velocity_max',
    'whiff_percent',
    'chase_percent',
    'oz_swing_percent',
    'launch_angle_avg',
    'groundballs_percent',
    'airballs_percent',
    'pull_percent_airballs',
    'attack_angle',
    'vertical_swing_path',
    // 'acceleration',
    'ideal_angle_rate',
    'arm_overall',
    'arm_max',
    'max_arm_strength',
    'jump',
    'xhr',
    'sprint_speed',
    'pop_2b',
    'arm_cs_2b',
    'avg_swing_speed',
    ...$b9c7b02947e449f9$export$9a758514bd1283e0
];
const $b9c7b02947e449f9$export$d7b39d8a41476f9 = [
    'percent_rank_k_percent',
    'percent_rank_whiff_percent',
    'percent_rank_chase_percent',
    'percent_rank_groundballs_percent',
    // 'percent_rank_swing_length',
    // 'percent_rank_vertical_swing_path',
    'percent_rank_pop_2b',
    ...$b9c7b02947e449f9$export$c6722944e73e432c.map((type)=>`${type}_percent_rank_pitch_whiff_percent`)
];
const $b9c7b02947e449f9$export$f861e6885e7b9ed2 = [
    'percent_rank_xera',
    'percent_rank_xwoba',
    'percent_rank_woba',
    'percent_rank_xwobacon',
    'percent_rank_wobacon',
    'percent_rank_xba',
    'percent_rank_ba',
    'percent_rank_xobp',
    'percent_rank_obp',
    'percent_rank_xslg',
    'percent_rank_slg',
    'percent_rank_bacon',
    'percent_rank_xbacon',
    'percent_rank_babip',
    'percent_rank_xiso',
    'percent_rank_iso',
    'percent_rank_exit_velocity_avg',
    'percent_rank_exit_velocity_max',
    'percent_rank_distance_hr_avg',
    'percent_rank_xhr',
    'percent_rank_barrel',
    'percent_rank_barrel_batted_rate',
    'percent_rank_launch_angle_avg',
    'percent_rank_hard_hit_percent',
    'percent_rank_sweet_spot_percent',
    'percent_rank_swing_speed',
    'percent_rank_squared_up_swing',
    'percent_rank_bb_percent',
    'percent_rank_airballs_percent',
    'percent_rank_pull_percent_airballs',
    'percent_rank_avg_hyper_speed',
    'percent_rank_avg_best_speed',
    'percent_rank_attack_angle',
    'percent_rank_swing_length',
    'percent_rank_vertical_swing_path',
    // 'percent_rank_acceleration',
    'percent_rank_ideal_angle_rate',
    'percent_rank_blasts_swing',
    // ...armsidePitchTypes.map((type) => `${type}_percent_rank_pitch_break_x`),
    // ...dropPitchTypes.map((type) => `${type}_percent_rank_pitch_break_z`),
    ...$b9c7b02947e449f9$var$dropPitchTypes.map((type)=>`${type}_percent_rank_pitch_break_z_induced`)
];
const $b9c7b02947e449f9$export$e390961395122d59 = [
    'percent_rank_swing_take_run_value',
    'percent_rank_runner_run_value',
    'percent_rank_fielding_run_value',
    'percent_rank_xwoba',
    'percent_rank_xba',
    'percent_rank_xslg',
    'percent_rank_exit_velocity_avg',
    'percent_rank_barrel_batted_rate',
    'percent_rank_hard_hit_percent',
    'percent_rank_sweet_spot_percent',
    'percent_rank_swing_speed',
    'percent_rank_squared_up_swing',
    'percent_rank_chase_percent',
    'percent_rank_whiff_percent',
    'percent_rank_k_percent',
    'percent_rank_bb_percent',
    'percent_rank_oaa',
    'percent_rank_fielding_run_value_arm',
    'percent_rank_arm_overall',
    'percent_rank_speed_order'
];
const $b9c7b02947e449f9$export$6566ad5760f0adbd = [
    'percent_rank_swing_take_run_value',
    'percent_rank_pitch_run_value_fastball',
    'percent_rank_pitch_run_value_breaking',
    'percent_rank_pitch_run_value_offspeed',
    'percent_rank_xera',
    'percent_rank_xba',
    'percent_rank_xslg',
    'percent_rank_chase_percent',
    'percent_rank_whiff_percent',
    'percent_rank_k_percent',
    'percent_rank_bb_percent',
    'percent_rank_exit_velocity_avg',
    'percent_rank_barrel_batted_rate',
    'percent_rank_hard_hit_percent',
    'percent_rank_sweet_spot_percent',
    'percent_rank_groundballs_percent',
    'ff_percent_rank_pitch_velo',
    'ff_percent_rank_pitch_run_value',
    'fc_percent_rank_pitch_run_value',
    'si_percent_rank_pitch_run_value',
    'sl_percent_rank_pitch_run_value',
    'st_percent_rank_pitch_run_value',
    'ch_percent_rank_pitch_run_value',
    'fs_percent_rank_pitch_run_value',
    'cu_percent_rank_pitch_run_value'
];
const $b9c7b02947e449f9$export$774c5be6702fcac5 = [
    'percent_rank_swing_take_run_value',
    'percent_rank_runner_run_value',
    'percent_rank_fielding_run_value',
    'percent_rank_xwoba',
    'percent_rank_xba',
    'percent_rank_xslg',
    'percent_rank_exit_velocity_avg',
    'percent_rank_barrel_batted_rate',
    'percent_rank_hard_hit_percent',
    'percent_rank_sweet_spot_percent',
    'percent_rank_swing_speed',
    'percent_rank_squared_up_swing',
    'percent_rank_chase_percent',
    'percent_rank_whiff_percent',
    'percent_rank_k_percent',
    'percent_rank_bb_percent',
    'percent_rank_blocks_above_average',
    'percent_rank_cs_above_average',
    'percent_rank_fielding_run_value_framing',
    'percent_rank_pop_2b',
    'percent_rank_arm_cs_2b',
    'percent_rank_speed_order'
];
const $b9c7b02947e449f9$export$172289f43f05fe38 = [
    'percent_rank_swing_length',
    'percent_rank_attack_angle',
    'percent_rank_vertical_swing_path',
    ...$b9c7b02947e449f9$export$c6722944e73e432c.flatMap((type)=>$b9c7b02947e449f9$export$dc30e34250fc57de.map((category)=>`${type}_percent_rank_${category}`))
];



var $63Xef = parcelRequire("63Xef");
var $c60338eb080e669a$var$i = Symbol.for("preact-signals");
function $c60338eb080e669a$var$t() {
    if (!($c60338eb080e669a$var$s > 1)) {
        var i, t = !1;
        !function() {
            var i = $c60338eb080e669a$var$c;
            $c60338eb080e669a$var$c = void 0;
            while(void 0 !== i){
                if (i.S.v === i.v) i.S.i = i.i;
                i = i.o;
            }
        }();
        while(void 0 !== $c60338eb080e669a$var$h){
            var n = $c60338eb080e669a$var$h;
            $c60338eb080e669a$var$h = void 0;
            $c60338eb080e669a$var$v++;
            while(void 0 !== n){
                var r = n.u;
                n.u = void 0;
                n.f &= -3;
                if (!(8 & n.f) && $c60338eb080e669a$var$w(n)) try {
                    n.c();
                } catch (n) {
                    if (!t) {
                        i = n;
                        t = !0;
                    }
                }
                n = r;
            }
        }
        $c60338eb080e669a$var$v = 0;
        $c60338eb080e669a$var$s--;
        if (t) throw i;
    } else $c60338eb080e669a$var$s--;
}
function $c60338eb080e669a$export$712ea50be43a7858(i) {
    if ($c60338eb080e669a$var$s > 0) return i();
    $c60338eb080e669a$var$e = ++$c60338eb080e669a$var$u;
    $c60338eb080e669a$var$s++;
    try {
        return i();
    } finally{
        $c60338eb080e669a$var$t();
    }
}
var $c60338eb080e669a$var$r = void 0;
function $c60338eb080e669a$export$8c437e4d572e2f99(i) {
    var t = $c60338eb080e669a$var$r;
    $c60338eb080e669a$var$r = void 0;
    try {
        return i();
    } finally{
        $c60338eb080e669a$var$r = t;
    }
}
var $c60338eb080e669a$var$f, $c60338eb080e669a$var$h = void 0, $c60338eb080e669a$var$s = 0, $c60338eb080e669a$var$v = 0, $c60338eb080e669a$var$u = 0, $c60338eb080e669a$var$e = 0, $c60338eb080e669a$var$c = void 0, $c60338eb080e669a$var$d = 0;
function $c60338eb080e669a$var$a(i) {
    if (void 0 !== $c60338eb080e669a$var$r) {
        var t = i.n;
        if (void 0 === t || t.t !== $c60338eb080e669a$var$r) {
            t = {
                i: 0,
                S: i,
                p: $c60338eb080e669a$var$r.s,
                n: void 0,
                t: $c60338eb080e669a$var$r,
                e: void 0,
                x: void 0,
                r: t
            };
            if (void 0 !== $c60338eb080e669a$var$r.s) $c60338eb080e669a$var$r.s.n = t;
            $c60338eb080e669a$var$r.s = t;
            i.n = t;
            if (32 & $c60338eb080e669a$var$r.f) i.S(t);
            return t;
        } else if (-1 === t.i) {
            t.i = 0;
            if (void 0 !== t.n) {
                t.n.p = t.p;
                if (void 0 !== t.p) t.p.n = t.n;
                t.p = $c60338eb080e669a$var$r.s;
                t.n = void 0;
                $c60338eb080e669a$var$r.s.n = t;
                $c60338eb080e669a$var$r.s = t;
            }
            return t;
        }
    }
}
function $c60338eb080e669a$export$8210dfe1863c478(i, t) {
    this.v = i;
    this.i = 0;
    this.n = void 0;
    this.t = void 0;
    this.l = 0;
    this.W = null == t ? void 0 : t.watched;
    this.Z = null == t ? void 0 : t.unwatched;
    this.name = null == t ? void 0 : t.name;
}
$c60338eb080e669a$export$8210dfe1863c478.prototype.brand = $c60338eb080e669a$var$i;
$c60338eb080e669a$export$8210dfe1863c478.prototype.h = function() {
    return !0;
};
$c60338eb080e669a$export$8210dfe1863c478.prototype.S = function(i) {
    var t = this, n = this.t;
    if (n !== i && void 0 === i.e) {
        i.x = n;
        this.t = i;
        if (void 0 !== n) n.e = i;
        else $c60338eb080e669a$export$8c437e4d572e2f99(function() {
            var i;
            null == (i = t.W) || i.call(t);
        });
    }
};
$c60338eb080e669a$export$8210dfe1863c478.prototype.U = function(i) {
    var t = this;
    if (void 0 !== this.t) {
        var n = i.e, r = i.x;
        if (void 0 !== n) {
            n.x = r;
            i.e = void 0;
        }
        if (void 0 !== r) {
            r.e = n;
            i.x = void 0;
        }
        if (i === this.t) {
            this.t = r;
            if (void 0 === r) $c60338eb080e669a$export$8c437e4d572e2f99(function() {
                var i;
                null == (i = t.Z) || i.call(t);
            });
        }
    }
};
$c60338eb080e669a$export$8210dfe1863c478.prototype.subscribe = function(i) {
    var t = this;
    return $c60338eb080e669a$export$dc573d8a6576cdb3(function() {
        var n = t.value;
        $c60338eb080e669a$export$8c437e4d572e2f99(function() {
            return i(n);
        });
    }, {
        name: "sub"
    });
};
$c60338eb080e669a$export$8210dfe1863c478.prototype.valueOf = function() {
    return this.value;
};
$c60338eb080e669a$export$8210dfe1863c478.prototype.toString = function() {
    return this.value + "";
};
$c60338eb080e669a$export$8210dfe1863c478.prototype.toJSON = function() {
    return this.value;
};
$c60338eb080e669a$export$8210dfe1863c478.prototype.peek = function() {
    var i = this;
    return $c60338eb080e669a$export$8c437e4d572e2f99(function() {
        return i.value;
    });
};
Object.defineProperty($c60338eb080e669a$export$8210dfe1863c478.prototype, "value", {
    get: function() {
        var i = $c60338eb080e669a$var$a(this);
        if (void 0 !== i) i.i = this.i;
        return this.v;
    },
    set: function(i) {
        if (i !== this.v) {
            if ($c60338eb080e669a$var$v > 100) throw new Error("Cycle detected");
            !function(i) {
                if (0 !== $c60338eb080e669a$var$s && 0 === $c60338eb080e669a$var$v) {
                    if (i.l !== $c60338eb080e669a$var$e) {
                        i.l = $c60338eb080e669a$var$e;
                        $c60338eb080e669a$var$c = {
                            S: i,
                            v: i.v,
                            i: i.i,
                            o: $c60338eb080e669a$var$c
                        };
                    }
                }
            }(this);
            this.v = i;
            this.i++;
            $c60338eb080e669a$var$d++;
            $c60338eb080e669a$var$s++;
            try {
                for(var n = this.t; void 0 !== n; n = n.x)n.t.N();
            } finally{
                $c60338eb080e669a$var$t();
            }
        }
    }
});
function $c60338eb080e669a$export$e2ef10f86a8d60e8(i, t) {
    return new $c60338eb080e669a$export$8210dfe1863c478(i, t);
}
function $c60338eb080e669a$var$w(i) {
    for(var t = i.s; void 0 !== t; t = t.n)if (t.S.i !== t.i || !t.S.h() || t.S.i !== t.i) return !0;
    return !1;
}
function $c60338eb080e669a$var$_(i) {
    for(var t = i.s; void 0 !== t; t = t.n){
        var n = t.S.n;
        if (void 0 !== n) t.r = n;
        t.S.n = t;
        t.i = -1;
        if (void 0 === t.n) {
            i.s = t;
            break;
        }
    }
}
function $c60338eb080e669a$var$b(i) {
    var t = i.s, n = void 0;
    while(void 0 !== t){
        var r = t.p;
        if (-1 === t.i) {
            t.S.U(t);
            if (void 0 !== r) r.n = t.n;
            if (void 0 !== t.n) t.n.p = r;
        } else n = t;
        t.S.n = t.r;
        if (void 0 !== t.r) t.r = void 0;
        t = r;
    }
    i.s = n;
}
function $c60338eb080e669a$export$836eee5a40e84ba8(i, t) {
    $c60338eb080e669a$export$8210dfe1863c478.call(this, void 0, t);
    this.x = i;
    this.s = void 0;
    this.g = $c60338eb080e669a$var$d - 1;
    this.f = 4;
}
$c60338eb080e669a$export$836eee5a40e84ba8.prototype = new $c60338eb080e669a$export$8210dfe1863c478;
$c60338eb080e669a$export$836eee5a40e84ba8.prototype.h = function() {
    this.f &= -3;
    if (1 & this.f) return !1;
    if (32 == (36 & this.f)) return !0;
    this.f &= -5;
    if (this.g === $c60338eb080e669a$var$d) return !0;
    this.g = $c60338eb080e669a$var$d;
    this.f |= 1;
    if (this.i > 0 && !$c60338eb080e669a$var$w(this)) {
        this.f &= -2;
        return !0;
    }
    var i = $c60338eb080e669a$var$r;
    try {
        $c60338eb080e669a$var$_(this);
        $c60338eb080e669a$var$r = this;
        var t = this.x();
        if (16 & this.f || this.v !== t || 0 === this.i) {
            this.v = t;
            this.f &= -17;
            this.i++;
        }
    } catch (i) {
        this.v = i;
        this.f |= 16;
        this.i++;
    }
    $c60338eb080e669a$var$r = i;
    $c60338eb080e669a$var$b(this);
    this.f &= -2;
    return !0;
};
$c60338eb080e669a$export$836eee5a40e84ba8.prototype.S = function(i) {
    if (void 0 === this.t) {
        this.f |= 36;
        for(var t = this.s; void 0 !== t; t = t.n)t.S.S(t);
    }
    $c60338eb080e669a$export$8210dfe1863c478.prototype.S.call(this, i);
};
$c60338eb080e669a$export$836eee5a40e84ba8.prototype.U = function(i) {
    if (void 0 !== this.t) {
        $c60338eb080e669a$export$8210dfe1863c478.prototype.U.call(this, i);
        if (void 0 === this.t) {
            this.f &= -33;
            for(var t = this.s; void 0 !== t; t = t.n)t.S.U(t);
        }
    }
};
$c60338eb080e669a$export$836eee5a40e84ba8.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 6;
        for(var i = this.t; void 0 !== i; i = i.x)i.t.N();
    }
};
Object.defineProperty($c60338eb080e669a$export$836eee5a40e84ba8.prototype, "value", {
    get: function() {
        if (1 & this.f) throw new Error("Cycle detected");
        var i = $c60338eb080e669a$var$a(this);
        this.h();
        if (void 0 !== i) i.i = this.i;
        if (16 & this.f) throw this.v;
        return this.v;
    }
});
function $c60338eb080e669a$export$2983e091f1a1e8e2(i, t) {
    return new $c60338eb080e669a$export$836eee5a40e84ba8(i, t);
}
function $c60338eb080e669a$var$S(i) {
    var n = i.m;
    i.m = void 0;
    if ("function" == typeof n) {
        $c60338eb080e669a$var$s++;
        var o = $c60338eb080e669a$var$r;
        $c60338eb080e669a$var$r = void 0;
        try {
            n();
        } catch (t) {
            i.f &= -2;
            i.f |= 8;
            $c60338eb080e669a$var$m(i);
            throw t;
        } finally{
            $c60338eb080e669a$var$r = o;
            $c60338eb080e669a$var$t();
        }
    }
}
function $c60338eb080e669a$var$m(i) {
    for(var t = i.s; void 0 !== t; t = t.n)t.S.U(t);
    i.x = void 0;
    i.s = void 0;
    $c60338eb080e669a$var$S(i);
}
function $c60338eb080e669a$var$x(i) {
    if ($c60338eb080e669a$var$r !== this) throw new Error("Out-of-order effect");
    $c60338eb080e669a$var$b(this);
    $c60338eb080e669a$var$r = i;
    this.f &= -2;
    if (8 & this.f) $c60338eb080e669a$var$m(this);
    $c60338eb080e669a$var$t();
}
function $c60338eb080e669a$export$a32b0b1c1ac59d04(i, t) {
    this.x = i;
    this.m = void 0;
    this.s = void 0;
    this.u = void 0;
    this.f = 32;
    this.name = null == t ? void 0 : t.name;
    if ($c60338eb080e669a$var$f) $c60338eb080e669a$var$f.push(this);
}
$c60338eb080e669a$export$a32b0b1c1ac59d04.prototype.c = function() {
    var i = this.S();
    try {
        if (8 & this.f) return;
        if (void 0 === this.x) return;
        var t = this.x();
        if ("function" == typeof t) this.m = t;
    } finally{
        i();
    }
};
$c60338eb080e669a$export$a32b0b1c1ac59d04.prototype.S = function() {
    if (1 & this.f) throw new Error("Cycle detected");
    this.f |= 1;
    this.f &= -9;
    $c60338eb080e669a$var$S(this);
    $c60338eb080e669a$var$_(this);
    $c60338eb080e669a$var$s++;
    var i = $c60338eb080e669a$var$r;
    $c60338eb080e669a$var$r = this;
    return $c60338eb080e669a$var$x.bind(this, i);
};
$c60338eb080e669a$export$a32b0b1c1ac59d04.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 2;
        this.u = $c60338eb080e669a$var$h;
        $c60338eb080e669a$var$h = this;
    }
};
$c60338eb080e669a$export$a32b0b1c1ac59d04.prototype.d = function() {
    this.f |= 8;
    if (!(1 & this.f)) $c60338eb080e669a$var$m(this);
};
$c60338eb080e669a$export$a32b0b1c1ac59d04.prototype.dispose = function() {
    this.d();
};
function $c60338eb080e669a$export$dc573d8a6576cdb3(i, t) {
    var n = new $c60338eb080e669a$export$a32b0b1c1ac59d04(i, t);
    try {
        n.c();
    } catch (i) {
        n.d();
        throw i;
    }
    var r = n.d.bind(n);
    r[Symbol.dispose] = r;
    return r;
}
function $c60338eb080e669a$export$31eb53bd5b582a97(i) {
    return function() {
        var t = arguments, r = this;
        return $c60338eb080e669a$export$712ea50be43a7858(function() {
            return $c60338eb080e669a$export$8c437e4d572e2f99(function() {
                return i.apply(r, [].slice.call(t));
            });
        });
    };
}
function $c60338eb080e669a$var$O() {
    var i = $c60338eb080e669a$var$f;
    $c60338eb080e669a$var$f = [];
    return function() {
        var t = $c60338eb080e669a$var$f;
        if ($c60338eb080e669a$var$f && i) i = i.concat($c60338eb080e669a$var$f);
        $c60338eb080e669a$var$f = i;
        return t;
    };
}
var $c60338eb080e669a$var$k = function(i) {
    for(var t in i){
        var n = i[t];
        if ("function" == typeof n) i[t] = $c60338eb080e669a$export$31eb53bd5b582a97(n);
        else if ("object" == typeof n && null !== n && !("brand" in n)) $c60338eb080e669a$var$k(n);
    }
};
function $c60338eb080e669a$export$2f453c7f7b0d002b(i) {
    return function() {
        var t, n, r = $c60338eb080e669a$var$O();
        try {
            n = i.apply(void 0, [].slice.call(arguments));
        } catch (i) {
            $c60338eb080e669a$var$f = void 0;
            throw i;
        } finally{
            t = r();
        }
        $c60338eb080e669a$var$k(n);
        n[Symbol.dispose] = $c60338eb080e669a$export$31eb53bd5b582a97(function() {
            if (t) for(var i = 0; i < t.length; i++)t[i].dispose();
            t = void 0;
        });
        return n;
    };
}


var $eb0d2ed00918af28$var$__create = Object.create;
var $eb0d2ed00918af28$var$__defProp = Object.defineProperty;
var $eb0d2ed00918af28$var$__defProps = Object.defineProperties;
var $eb0d2ed00918af28$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $eb0d2ed00918af28$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $eb0d2ed00918af28$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $eb0d2ed00918af28$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $eb0d2ed00918af28$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $eb0d2ed00918af28$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $eb0d2ed00918af28$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $eb0d2ed00918af28$var$__defNormalProp = (obj, key, value)=>key in obj ? $eb0d2ed00918af28$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $eb0d2ed00918af28$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($eb0d2ed00918af28$var$__hasOwnProp.call(b, prop)) $eb0d2ed00918af28$var$__defNormalProp(a, prop, b[prop]);
    if ($eb0d2ed00918af28$var$__getOwnPropSymbols) {
        for (var prop of $eb0d2ed00918af28$var$__getOwnPropSymbols(b))if ($eb0d2ed00918af28$var$__propIsEnum.call(b, prop)) $eb0d2ed00918af28$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $eb0d2ed00918af28$var$__spreadProps = (a, b)=>$eb0d2ed00918af28$var$__defProps(a, $eb0d2ed00918af28$var$__getOwnPropDescs(b));
var $eb0d2ed00918af28$var$__name = (target, value)=>$eb0d2ed00918af28$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $eb0d2ed00918af28$var$__decoratorStart = (base)=>{
    var _a2;
    return [
        ,
        ,
        ,
        $eb0d2ed00918af28$var$__create((_a2 = base == null ? void 0 : base[$eb0d2ed00918af28$var$__knownSymbol("metadata")]) != null ? _a2 : null)
    ];
};
var $eb0d2ed00918af28$var$__decoratorStrings = [
    "class",
    "method",
    "getter",
    "setter",
    "accessor",
    "field",
    "value",
    "get",
    "set"
];
var $eb0d2ed00918af28$var$__expectFn = (fn)=>fn !== void 0 && typeof fn !== "function" ? $eb0d2ed00918af28$var$__typeError("Function expected") : fn;
var $eb0d2ed00918af28$var$__decoratorContext = (kind, name, done, metadata, fns)=>({
        kind: $eb0d2ed00918af28$var$__decoratorStrings[kind],
        name: name,
        metadata: metadata,
        addInitializer: (fn)=>done._ ? $eb0d2ed00918af28$var$__typeError("Already initialized") : fns.push($eb0d2ed00918af28$var$__expectFn(fn || null))
    });
var $eb0d2ed00918af28$var$__decoratorMetadata = (array, target)=>$eb0d2ed00918af28$var$__defNormalProp(target, $eb0d2ed00918af28$var$__knownSymbol("metadata"), array[3]);
var $eb0d2ed00918af28$var$__runInitializers = (array, flags, self, value)=>{
    for(var i = 0, fns = array[flags >> 1], n = fns && fns.length; i < n; i++)flags & 1 ? fns[i].call(self) : value = fns[i].call(self, value);
    return value;
};
var $eb0d2ed00918af28$var$__decorateElement = (array, flags, name, decorators, target, extra)=>{
    var fn, it, done, ctx, access, k = flags & 7, s = !!(flags & 8), p = !!(flags & 16);
    var j = k > 3 ? array.length + 1 : k ? s ? 1 : 2 : 0, key = $eb0d2ed00918af28$var$__decoratorStrings[k + 5];
    var initializers = k > 3 && (array[j - 1] = []), extraInitializers = array[j] || (array[j] = []);
    var desc = k && (!p && !s && (target = target.prototype), k < 5 && (k > 3 || !p) && $eb0d2ed00918af28$var$__getOwnPropDesc(k < 4 ? target : {
        get [name] () {
            return $eb0d2ed00918af28$var$__privateGet(this, extra);
        },
        set [name] (x){
            return $eb0d2ed00918af28$var$__privateSet(this, extra, x);
        }
    }, name));
    k ? p && k < 4 && $eb0d2ed00918af28$var$__name(extra, (k > 2 ? "set " : k > 1 ? "get " : "") + name) : $eb0d2ed00918af28$var$__name(target, name);
    for(var i = decorators.length - 1; i >= 0; i--){
        ctx = $eb0d2ed00918af28$var$__decoratorContext(k, name, done = {}, array[3], extraInitializers);
        if (k) {
            ctx.static = s, ctx.private = p, access = ctx.access = {
                has: p ? (x1)=>$eb0d2ed00918af28$var$__privateIn(target, x1) : (x1)=>name in x1
            };
            if (k ^ 3) access.get = p ? (x1)=>(k ^ 1 ? $eb0d2ed00918af28$var$__privateGet : $eb0d2ed00918af28$var$__privateMethod)(x1, target, k ^ 4 ? extra : desc.get) : (x1)=>x1[name];
            if (k > 2) access.set = p ? (x1, y)=>$eb0d2ed00918af28$var$__privateSet(x1, target, y, k ^ 4 ? extra : desc.set) : (x1, y)=>x1[name] = y;
        }
        it = (0, decorators[i])(k ? k < 4 ? p ? extra : desc[key] : k > 4 ? void 0 : {
            get: desc.get,
            set: desc.set
        } : target, ctx), done._ = 1;
        if (k ^ 4 || it === void 0) $eb0d2ed00918af28$var$__expectFn(it) && (k > 4 ? initializers.unshift(it) : k ? p ? extra = it : desc[key] = it : target = it);
        else if (typeof it !== "object" || it === null) $eb0d2ed00918af28$var$__typeError("Object expected");
        else $eb0d2ed00918af28$var$__expectFn(fn = it.get) && (desc.get = fn), $eb0d2ed00918af28$var$__expectFn(fn = it.set) && (desc.set = fn), $eb0d2ed00918af28$var$__expectFn(fn = it.init) && initializers.unshift(fn);
    }
    return k || $eb0d2ed00918af28$var$__decoratorMetadata(array, target), desc && $eb0d2ed00918af28$var$__defProp(target, name, desc), p ? k ^ 4 ? extra : desc : target;
};
var $eb0d2ed00918af28$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $eb0d2ed00918af28$var$__typeError("Cannot " + msg);
var $eb0d2ed00918af28$var$__privateIn = (member, obj)=>Object(obj) !== obj ? $eb0d2ed00918af28$var$__typeError('Cannot use the "in" operator on this value') : member.has(obj);
var $eb0d2ed00918af28$var$__privateGet = (obj, member, getter)=>($eb0d2ed00918af28$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $eb0d2ed00918af28$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $eb0d2ed00918af28$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $eb0d2ed00918af28$var$__privateSet = (obj, member, value, setter)=>($eb0d2ed00918af28$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $eb0d2ed00918af28$var$__privateMethod = (obj, member, method)=>($eb0d2ed00918af28$var$__accessCheck(obj, member, "access private method"), method);
function $eb0d2ed00918af28$export$2983e091f1a1e8e2(compute, comparator) {
    if (comparator) {
        let previousValue;
        return (0, $c60338eb080e669a$export$2983e091f1a1e8e2)(()=>{
            const value = compute();
            if (value && previousValue && comparator(previousValue, value)) return previousValue;
            previousValue = value;
            return value;
        });
    }
    return (0, $c60338eb080e669a$export$2983e091f1a1e8e2)(compute);
}
// src/comparators.ts
function $eb0d2ed00918af28$export$9cb4719e2e525b7a(a, b) {
    if (Object.is(a, b)) return true;
    if (a === null || b === null) return false;
    if (typeof a === "function" && typeof b === "function") return a === b;
    if (a instanceof Set && b instanceof Set) {
        if (a.size !== b.size) return false;
        for (const value of a){
            if (!b.has(value)) return false;
        }
        return true;
    }
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        const hasDifferentValues = a.some((value, index)=>!$eb0d2ed00918af28$export$9cb4719e2e525b7a(value, b[index]));
        return !hasDifferentValues;
    }
    if (typeof a === "object" && typeof b === "object") {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        const hasDifferentValues = aKeys.some((key)=>!$eb0d2ed00918af28$export$9cb4719e2e525b7a(a[key], b[key]));
        return !hasDifferentValues;
    }
    return false;
}
function $eb0d2ed00918af28$export$90a44edba14e47be({ get: get }, _) {
    return {
        init (value) {
            return (0, $c60338eb080e669a$export$e2ef10f86a8d60e8)(value);
        },
        get () {
            const current = get.call(this);
            return current.value;
        },
        set (newValue) {
            const current = get.call(this);
            if (current.peek() === newValue) return;
            current.value = newValue;
        }
    };
}
function $eb0d2ed00918af28$export$90b0b54dab0a340a(target, _) {
    const map = /* @__PURE__ */ new WeakMap();
    return function() {
        let result = map.get(this);
        if (!result) {
            result = $eb0d2ed00918af28$export$2983e091f1a1e8e2(target.bind(this));
            map.set(this, result);
        }
        return result.value;
    };
}
function $eb0d2ed00918af28$export$a989dfaf975e3717(enumerable2 = true) {
    return function(_value, context) {
        context.addInitializer(function() {
            const host = context.kind === "field" ? this : context.static ? this : Object.getPrototypeOf(this);
            const descriptor = Object.getOwnPropertyDescriptor(host, context.name);
            if (descriptor) Object.defineProperty(host, context.name, $eb0d2ed00918af28$var$__spreadProps($eb0d2ed00918af28$var$__spreadValues({}, descriptor), {
                enumerable: enumerable2
            }));
        });
    };
}
function $eb0d2ed00918af28$export$fb4689499fb20c56(...entries) {
    const effects2 = entries.map((fn)=>(0, $c60338eb080e669a$export$dc573d8a6576cdb3)(fn));
    return ()=>effects2.forEach((cleanup)=>cleanup());
}
var $eb0d2ed00918af28$var$_previous_dec, $eb0d2ed00918af28$var$_initial_dec, $eb0d2ed00918af28$var$_current_dec, $eb0d2ed00918af28$var$_current_dec2, $eb0d2ed00918af28$var$_previous_dec2, $eb0d2ed00918af28$var$_initial_dec2, $eb0d2ed00918af28$var$_init, $eb0d2ed00918af28$var$_initial, $eb0d2ed00918af28$var$_a, $eb0d2ed00918af28$var$initial_get, $eb0d2ed00918af28$var$initial_set, $eb0d2ed00918af28$var$_ValueHistory_instances, $eb0d2ed00918af28$var$_previous, $eb0d2ed00918af28$var$_b, $eb0d2ed00918af28$var$previous_get, $eb0d2ed00918af28$var$previous_set, $eb0d2ed00918af28$var$_current, $eb0d2ed00918af28$var$_c, $eb0d2ed00918af28$var$current_get, $eb0d2ed00918af28$var$current_set;
$eb0d2ed00918af28$var$_initial_dec2 = [
    $eb0d2ed00918af28$export$90a44edba14e47be
], $eb0d2ed00918af28$var$_previous_dec2 = [
    $eb0d2ed00918af28$export$90a44edba14e47be
], $eb0d2ed00918af28$var$_current_dec2 = [
    $eb0d2ed00918af28$export$90a44edba14e47be
], $eb0d2ed00918af28$var$_current_dec = [
    $eb0d2ed00918af28$export$a989dfaf975e3717()
], $eb0d2ed00918af28$var$_initial_dec = [
    $eb0d2ed00918af28$export$a989dfaf975e3717()
], $eb0d2ed00918af28$var$_previous_dec = [
    $eb0d2ed00918af28$export$a989dfaf975e3717()
];
var $eb0d2ed00918af28$export$b054dd6fcf79fa19 = class {
    constructor(defaultValue, equals = Object.is){
        this.defaultValue = defaultValue;
        this.equals = equals;
        $eb0d2ed00918af28$var$__runInitializers($eb0d2ed00918af28$var$_init, 5, this);
        $eb0d2ed00918af28$var$__privateAdd(this, $eb0d2ed00918af28$var$_ValueHistory_instances);
        // @ts-ignore
        $eb0d2ed00918af28$var$__privateAdd(this, $eb0d2ed00918af28$var$_initial, $eb0d2ed00918af28$var$__runInitializers($eb0d2ed00918af28$var$_init, 8, this)), $eb0d2ed00918af28$var$__runInitializers($eb0d2ed00918af28$var$_init, 11, this);
        // @ts-ignore
        $eb0d2ed00918af28$var$__privateAdd(this, $eb0d2ed00918af28$var$_previous, $eb0d2ed00918af28$var$__runInitializers($eb0d2ed00918af28$var$_init, 12, this)), $eb0d2ed00918af28$var$__runInitializers($eb0d2ed00918af28$var$_init, 15, this);
        // @ts-ignore
        $eb0d2ed00918af28$var$__privateAdd(this, $eb0d2ed00918af28$var$_current, $eb0d2ed00918af28$var$__runInitializers($eb0d2ed00918af28$var$_init, 16, this)), $eb0d2ed00918af28$var$__runInitializers($eb0d2ed00918af28$var$_init, 19, this);
        this.reset = this.reset.bind(this);
        this.reset();
    }
    get current() {
        return $eb0d2ed00918af28$var$__privateGet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, $eb0d2ed00918af28$var$current_get);
    }
    get initial() {
        return $eb0d2ed00918af28$var$__privateGet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, $eb0d2ed00918af28$var$initial_get);
    }
    get previous() {
        return $eb0d2ed00918af28$var$__privateGet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, $eb0d2ed00918af28$var$previous_get);
    }
    /** Set the current value */ set current(value) {
        const current = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>$eb0d2ed00918af28$var$__privateGet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, $eb0d2ed00918af28$var$current_get));
        if (value && current && this.equals(current, value)) return;
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            if (!$eb0d2ed00918af28$var$__privateGet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, $eb0d2ed00918af28$var$initial_get)) $eb0d2ed00918af28$var$__privateSet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, value, $eb0d2ed00918af28$var$initial_set);
            $eb0d2ed00918af28$var$__privateSet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, current, $eb0d2ed00918af28$var$previous_set);
            $eb0d2ed00918af28$var$__privateSet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, value, $eb0d2ed00918af28$var$current_set);
        });
    }
    /** Reset the state to the initial value */ reset(value = this.defaultValue) {
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            $eb0d2ed00918af28$var$__privateSet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, void 0, $eb0d2ed00918af28$var$previous_set);
            $eb0d2ed00918af28$var$__privateSet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, value, $eb0d2ed00918af28$var$initial_set);
            $eb0d2ed00918af28$var$__privateSet(this, $eb0d2ed00918af28$var$_ValueHistory_instances, value, $eb0d2ed00918af28$var$current_set);
        });
    }
};
$eb0d2ed00918af28$var$_init = $eb0d2ed00918af28$var$__decoratorStart(null);
$eb0d2ed00918af28$var$_initial = new WeakMap();
$eb0d2ed00918af28$var$_ValueHistory_instances = new WeakSet();
$eb0d2ed00918af28$var$_previous = new WeakMap();
$eb0d2ed00918af28$var$_current = new WeakMap();
$eb0d2ed00918af28$var$_a = $eb0d2ed00918af28$var$__decorateElement($eb0d2ed00918af28$var$_init, 20, "#initial", $eb0d2ed00918af28$var$_initial_dec2, $eb0d2ed00918af28$var$_ValueHistory_instances, $eb0d2ed00918af28$var$_initial), $eb0d2ed00918af28$var$initial_get = $eb0d2ed00918af28$var$_a.get, $eb0d2ed00918af28$var$initial_set = $eb0d2ed00918af28$var$_a.set;
$eb0d2ed00918af28$var$_b = $eb0d2ed00918af28$var$__decorateElement($eb0d2ed00918af28$var$_init, 20, "#previous", $eb0d2ed00918af28$var$_previous_dec2, $eb0d2ed00918af28$var$_ValueHistory_instances, $eb0d2ed00918af28$var$_previous), $eb0d2ed00918af28$var$previous_get = $eb0d2ed00918af28$var$_b.get, $eb0d2ed00918af28$var$previous_set = $eb0d2ed00918af28$var$_b.set;
$eb0d2ed00918af28$var$_c = $eb0d2ed00918af28$var$__decorateElement($eb0d2ed00918af28$var$_init, 20, "#current", $eb0d2ed00918af28$var$_current_dec2, $eb0d2ed00918af28$var$_ValueHistory_instances, $eb0d2ed00918af28$var$_current), $eb0d2ed00918af28$var$current_get = $eb0d2ed00918af28$var$_c.get, $eb0d2ed00918af28$var$current_set = $eb0d2ed00918af28$var$_c.set;
$eb0d2ed00918af28$var$__decorateElement($eb0d2ed00918af28$var$_init, 2, "current", $eb0d2ed00918af28$var$_current_dec, $eb0d2ed00918af28$export$b054dd6fcf79fa19);
$eb0d2ed00918af28$var$__decorateElement($eb0d2ed00918af28$var$_init, 2, "initial", $eb0d2ed00918af28$var$_initial_dec, $eb0d2ed00918af28$export$b054dd6fcf79fa19);
$eb0d2ed00918af28$var$__decorateElement($eb0d2ed00918af28$var$_init, 2, "previous", $eb0d2ed00918af28$var$_previous_dec, $eb0d2ed00918af28$export$b054dd6fcf79fa19);
$eb0d2ed00918af28$var$__decoratorMetadata($eb0d2ed00918af28$var$_init, $eb0d2ed00918af28$export$b054dd6fcf79fa19);
function $eb0d2ed00918af28$export$b8801ea43165ed7d(value) {
    return (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
        const output = {};
        for(const key in value)output[key] = value[key];
        return output;
    });
}
// src/store.ts
var $eb0d2ed00918af28$var$_store;
var $eb0d2ed00918af28$export$b62288191c5a7f4 = class {
    constructor(){
        $eb0d2ed00918af28$var$__privateAdd(this, $eb0d2ed00918af28$var$_store, /* @__PURE__ */ new WeakMap());
    }
    get(key, id) {
        var _a2;
        return key ? (_a2 = $eb0d2ed00918af28$var$__privateGet(this, $eb0d2ed00918af28$var$_store).get(key)) == null ? void 0 : _a2.get(id) : void 0;
    }
    set(key, id, value) {
        var _a2;
        if (!key) return;
        if (!$eb0d2ed00918af28$var$__privateGet(this, $eb0d2ed00918af28$var$_store).has(key)) $eb0d2ed00918af28$var$__privateGet(this, $eb0d2ed00918af28$var$_store).set(key, /* @__PURE__ */ new Map());
        return (_a2 = $eb0d2ed00918af28$var$__privateGet(this, $eb0d2ed00918af28$var$_store).get(key)) == null ? void 0 : _a2.set(id, value);
    }
    clear(key) {
        var _a2;
        return key ? (_a2 = $eb0d2ed00918af28$var$__privateGet(this, $eb0d2ed00918af28$var$_store).get(key)) == null ? void 0 : _a2.clear() : void 0;
    }
};
$eb0d2ed00918af28$var$_store = new WeakMap();



var $ce41d7a96a1e68fd$var$__create = Object.create;
var $ce41d7a96a1e68fd$var$__defProp = Object.defineProperty;
var $ce41d7a96a1e68fd$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $ce41d7a96a1e68fd$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ce41d7a96a1e68fd$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ce41d7a96a1e68fd$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ce41d7a96a1e68fd$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $ce41d7a96a1e68fd$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $ce41d7a96a1e68fd$var$__pow = Math.pow;
var $ce41d7a96a1e68fd$var$__defNormalProp = (obj, key, value)=>key in obj ? $ce41d7a96a1e68fd$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ce41d7a96a1e68fd$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ce41d7a96a1e68fd$var$__hasOwnProp.call(b, prop)) $ce41d7a96a1e68fd$var$__defNormalProp(a, prop, b[prop]);
    if ($ce41d7a96a1e68fd$var$__getOwnPropSymbols) {
        for (var prop of $ce41d7a96a1e68fd$var$__getOwnPropSymbols(b))if ($ce41d7a96a1e68fd$var$__propIsEnum.call(b, prop)) $ce41d7a96a1e68fd$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ce41d7a96a1e68fd$var$__name = (target, value)=>$ce41d7a96a1e68fd$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $ce41d7a96a1e68fd$var$__decoratorStart = (base)=>{
    var _a2;
    return [
        ,
        ,
        ,
        $ce41d7a96a1e68fd$var$__create((_a2 = base == null ? void 0 : base[$ce41d7a96a1e68fd$var$__knownSymbol("metadata")]) != null ? _a2 : null)
    ];
};
var $ce41d7a96a1e68fd$var$__decoratorStrings = [
    "class",
    "method",
    "getter",
    "setter",
    "accessor",
    "field",
    "value",
    "get",
    "set"
];
var $ce41d7a96a1e68fd$var$__expectFn = (fn)=>fn !== void 0 && typeof fn !== "function" ? $ce41d7a96a1e68fd$var$__typeError("Function expected") : fn;
var $ce41d7a96a1e68fd$var$__decoratorContext = (kind, name, done, metadata, fns)=>({
        kind: $ce41d7a96a1e68fd$var$__decoratorStrings[kind],
        name: name,
        metadata: metadata,
        addInitializer: (fn)=>done._ ? $ce41d7a96a1e68fd$var$__typeError("Already initialized") : fns.push($ce41d7a96a1e68fd$var$__expectFn(fn || null))
    });
var $ce41d7a96a1e68fd$var$__decoratorMetadata = (array, target)=>$ce41d7a96a1e68fd$var$__defNormalProp(target, $ce41d7a96a1e68fd$var$__knownSymbol("metadata"), array[3]);
var $ce41d7a96a1e68fd$var$__runInitializers = (array, flags, self, value)=>{
    for(var i = 0, fns = array[flags >> 1], n = fns && fns.length; i < n; i++)flags & 1 ? fns[i].call(self) : value = fns[i].call(self, value);
    return value;
};
var $ce41d7a96a1e68fd$var$__decorateElement = (array, flags, name, decorators, target, extra)=>{
    var fn, it, done, ctx, access, k = flags & 7, s = !!(flags & 8), p = !!(flags & 16);
    var j = k > 3 ? array.length + 1 : k ? s ? 1 : 2 : 0, key = $ce41d7a96a1e68fd$var$__decoratorStrings[k + 5];
    var initializers = k > 3 && (array[j - 1] = []), extraInitializers = array[j] || (array[j] = []);
    var desc = k && (!p && !s && (target = target.prototype), k < 5 && (k > 3 || !p) && $ce41d7a96a1e68fd$var$__getOwnPropDesc(k < 4 ? target : {
        get [name] () {
            return $ce41d7a96a1e68fd$var$__privateGet(this, extra);
        },
        set [name] (x){
            return $ce41d7a96a1e68fd$var$__privateSet(this, extra, x);
        }
    }, name));
    k ? p && k < 4 && $ce41d7a96a1e68fd$var$__name(extra, (k > 2 ? "set " : k > 1 ? "get " : "") + name) : $ce41d7a96a1e68fd$var$__name(target, name);
    for(var i = decorators.length - 1; i >= 0; i--){
        ctx = $ce41d7a96a1e68fd$var$__decoratorContext(k, name, done = {}, array[3], extraInitializers);
        if (k) {
            ctx.static = s, ctx.private = p, access = ctx.access = {
                has: p ? (x1)=>$ce41d7a96a1e68fd$var$__privateIn(target, x1) : (x1)=>name in x1
            };
            if (k ^ 3) access.get = p ? (x1)=>(k ^ 1 ? $ce41d7a96a1e68fd$var$__privateGet : $ce41d7a96a1e68fd$var$__privateMethod)(x1, target, k ^ 4 ? extra : desc.get) : (x1)=>x1[name];
            if (k > 2) access.set = p ? (x1, y)=>$ce41d7a96a1e68fd$var$__privateSet(x1, target, y, k ^ 4 ? extra : desc.set) : (x1, y)=>x1[name] = y;
        }
        it = (0, decorators[i])(k ? k < 4 ? p ? extra : desc[key] : k > 4 ? void 0 : {
            get: desc.get,
            set: desc.set
        } : target, ctx), done._ = 1;
        if (k ^ 4 || it === void 0) $ce41d7a96a1e68fd$var$__expectFn(it) && (k > 4 ? initializers.unshift(it) : k ? p ? extra = it : desc[key] = it : target = it);
        else if (typeof it !== "object" || it === null) $ce41d7a96a1e68fd$var$__typeError("Object expected");
        else $ce41d7a96a1e68fd$var$__expectFn(fn = it.get) && (desc.get = fn), $ce41d7a96a1e68fd$var$__expectFn(fn = it.set) && (desc.set = fn), $ce41d7a96a1e68fd$var$__expectFn(fn = it.init) && initializers.unshift(fn);
    }
    return k || $ce41d7a96a1e68fd$var$__decoratorMetadata(array, target), desc && $ce41d7a96a1e68fd$var$__defProp(target, name, desc), p ? k ^ 4 ? extra : desc : target;
};
var $ce41d7a96a1e68fd$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $ce41d7a96a1e68fd$var$__typeError("Cannot " + msg);
var $ce41d7a96a1e68fd$var$__privateIn = (member, obj)=>Object(obj) !== obj ? $ce41d7a96a1e68fd$var$__typeError('Cannot use the "in" operator on this value') : member.has(obj);
var $ce41d7a96a1e68fd$var$__privateGet = (obj, member, getter)=>($ce41d7a96a1e68fd$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $ce41d7a96a1e68fd$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $ce41d7a96a1e68fd$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $ce41d7a96a1e68fd$var$__privateSet = (obj, member, value, setter)=>($ce41d7a96a1e68fd$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $ce41d7a96a1e68fd$var$__privateMethod = (obj, member, method)=>($ce41d7a96a1e68fd$var$__accessCheck(obj, member, "access private method"), method);
// src/point/Point.ts
var $ce41d7a96a1e68fd$export$baf26146a414f24a = class _Point {
    /**
   * @param {number} Coordinate of the point on the horizontal axis
   * @param {number} Coordinate of the point on the vertical axis
   */ constructor(x1, y){
        this.x = x1;
        this.y = y;
    }
    /**
   * Returns the delta between this point and another point.
   *
   * @param {Point} a - A point
   * @param {Point} b - Another point
   */ static delta(a, b) {
        return new _Point(a.x - b.x, a.y - b.y);
    }
    /**
   * Returns the distance (hypotenuse) between this point and another point.
   *
   * @param {Point} a - A point
   * @param {Point} b - Another point
   */ static distance(a, b) {
        return Math.hypot(a.x - b.x, a.y - b.y);
    }
    /**
   * Returns true if both points are equal.
   *
   * @param {Point} a - A point
   * @param {Point} b - Another point
   */ static equals(a, b) {
        return a.x === b.x && a.y === b.y;
    }
    static from({ x: x1, y: y }) {
        return new _Point(x1, y);
    }
};
// src/shapes/Rectangle.ts
var $ce41d7a96a1e68fd$export$4617fb02663045ef = class _Rectangle {
    constructor(left, top, width, height){
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
        this.scale = {
            x: 1,
            y: 1
        };
    }
    get inverseScale() {
        return {
            x: 1 / this.scale.x,
            y: 1 / this.scale.y
        };
    }
    translate(x1, y) {
        const { top: top, left: left, width: width, height: height, scale: scale } = this;
        const newShape = new _Rectangle(left + x1, top + y, width, height);
        newShape.scale = $ce41d7a96a1e68fd$var$__spreadValues({}, scale);
        return newShape;
    }
    get boundingRectangle() {
        const { width: width, height: height, left: left, top: top, right: right, bottom: bottom } = this;
        return {
            width: width,
            height: height,
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    get center() {
        const { left: left, top: top, right: right, bottom: bottom } = this;
        return new $ce41d7a96a1e68fd$export$baf26146a414f24a((left + right) / 2, (top + bottom) / 2);
    }
    get area() {
        const { width: width, height: height } = this;
        return width * height;
    }
    equals(shape) {
        if (!(shape instanceof _Rectangle)) return false;
        const { left: left, top: top, width: width, height: height } = this;
        return left === shape.left && top === shape.top && width === shape.width && height === shape.height;
    }
    containsPoint(point) {
        const { top: top, left: left, bottom: bottom, right: right } = this;
        return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
    }
    intersectionArea(shape) {
        if (shape instanceof _Rectangle) return $ce41d7a96a1e68fd$var$rectangleRectangleIntersection(this, shape);
        return 0;
    }
    intersectionRatio(shape) {
        const { area: area } = this;
        const intersectionArea = this.intersectionArea(shape);
        const intersectionRatio = intersectionArea / (shape.area + area - intersectionArea);
        return intersectionRatio;
    }
    get bottom() {
        const { top: top, height: height } = this;
        return top + height;
    }
    get right() {
        const { left: left, width: width } = this;
        return left + width;
    }
    get aspectRatio() {
        const { width: width, height: height } = this;
        return width / height;
    }
    get corners() {
        return [
            {
                x: this.left,
                y: this.top
            },
            {
                x: this.right,
                y: this.top
            },
            {
                x: this.left,
                y: this.bottom
            },
            {
                x: this.right,
                y: this.bottom
            }
        ];
    }
    static from({ top: top, left: left, width: width, height: height }) {
        return new _Rectangle(left, top, width, height);
    }
    static delta(a, b, alignment = {
        x: "center",
        y: "center"
    }) {
        const getCoordinate = (rect, axis)=>{
            const align = alignment[axis];
            const start = axis === "x" ? rect.left : rect.top;
            const size = axis === "x" ? rect.width : rect.height;
            if (align == "start") return start;
            if (align == "end") return start + size;
            return start + size / 2;
        };
        return $ce41d7a96a1e68fd$export$baf26146a414f24a.delta({
            x: getCoordinate(a, "x"),
            y: getCoordinate(a, "y")
        }, {
            x: getCoordinate(b, "x"),
            y: getCoordinate(b, "y")
        });
    }
    static intersectionRatio(a, b) {
        return _Rectangle.from(a).intersectionRatio(_Rectangle.from(b));
    }
};
function $ce41d7a96a1e68fd$var$rectangleRectangleIntersection(a, b) {
    const top = Math.max(b.top, a.top);
    const left = Math.max(b.left, a.left);
    const right = Math.min(b.left + b.width, a.left + a.width);
    const bottom = Math.min(b.top + b.height, a.top + a.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const intersectionArea = width * height;
        return intersectionArea;
    }
    return 0;
}
var $ce41d7a96a1e68fd$var$_direction_dec, $ce41d7a96a1e68fd$var$_delta_dec, $ce41d7a96a1e68fd$var$_a, $ce41d7a96a1e68fd$var$_timestamp, $ce41d7a96a1e68fd$var$_init;
var $ce41d7a96a1e68fd$export$13807d9ee5a34a42 = class extends ($ce41d7a96a1e68fd$var$_a = (0, $eb0d2ed00918af28$export$b054dd6fcf79fa19), $ce41d7a96a1e68fd$var$_delta_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $ce41d7a96a1e68fd$var$_direction_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $ce41d7a96a1e68fd$var$_a) {
    constructor(initialValue){
        const point = $ce41d7a96a1e68fd$export$baf26146a414f24a.from(initialValue);
        super(point, (a, b)=>$ce41d7a96a1e68fd$export$baf26146a414f24a.equals(a, b));
        $ce41d7a96a1e68fd$var$__runInitializers($ce41d7a96a1e68fd$var$_init, 5, this);
        $ce41d7a96a1e68fd$var$__privateAdd(this, $ce41d7a96a1e68fd$var$_timestamp, 0);
        this.velocity = {
            x: 0,
            y: 0
        };
    }
    get delta() {
        return $ce41d7a96a1e68fd$export$baf26146a414f24a.delta(this.current, this.initial);
    }
    get direction() {
        const { current: current, previous: previous } = this;
        if (!previous) return null;
        const delta = {
            x: current.x - previous.x,
            y: current.y - previous.y
        };
        if (!delta.x && !delta.y) return null;
        if (Math.abs(delta.x) > Math.abs(delta.y)) return delta.x > 0 ? "right" : "left";
        return delta.y > 0 ? "down" : "up";
    }
    get current() {
        return super.current;
    }
    set current(coordinates) {
        const { current: current } = this;
        const point = $ce41d7a96a1e68fd$export$baf26146a414f24a.from(coordinates);
        const delta = {
            x: point.x - current.x,
            y: point.y - current.y
        };
        const timestamp = Date.now();
        const timeDelta = timestamp - $ce41d7a96a1e68fd$var$__privateGet(this, $ce41d7a96a1e68fd$var$_timestamp);
        const velocity = (delta2)=>Math.round(delta2 / timeDelta * 100);
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            $ce41d7a96a1e68fd$var$__privateSet(this, $ce41d7a96a1e68fd$var$_timestamp, timestamp);
            this.velocity = {
                x: velocity(delta.x),
                y: velocity(delta.y)
            };
            super.current = point;
        });
    }
    reset(coordinates = this.defaultValue) {
        super.reset($ce41d7a96a1e68fd$export$baf26146a414f24a.from(coordinates));
        this.velocity = {
            x: 0,
            y: 0
        };
    }
};
$ce41d7a96a1e68fd$var$_init = $ce41d7a96a1e68fd$var$__decoratorStart($ce41d7a96a1e68fd$var$_a);
$ce41d7a96a1e68fd$var$_timestamp = new WeakMap();
$ce41d7a96a1e68fd$var$__decorateElement($ce41d7a96a1e68fd$var$_init, 2, "delta", $ce41d7a96a1e68fd$var$_delta_dec, $ce41d7a96a1e68fd$export$13807d9ee5a34a42);
$ce41d7a96a1e68fd$var$__decorateElement($ce41d7a96a1e68fd$var$_init, 2, "direction", $ce41d7a96a1e68fd$var$_direction_dec, $ce41d7a96a1e68fd$export$13807d9ee5a34a42);
$ce41d7a96a1e68fd$var$__decoratorMetadata($ce41d7a96a1e68fd$var$_init, $ce41d7a96a1e68fd$export$13807d9ee5a34a42);
// src/distance/distance.ts
function $ce41d7a96a1e68fd$export$5f766be895d17cfc({ x: x1, y: y }, distance) {
    const dx = Math.abs(x1);
    const dy = Math.abs(y);
    if (typeof distance === "number") return Math.sqrt($ce41d7a96a1e68fd$var$__pow(dx, 2) + $ce41d7a96a1e68fd$var$__pow(dy, 2)) > distance;
    if ("x" in distance && "y" in distance) return dx > distance.x && dy > distance.y;
    if ("x" in distance) return dx > distance.x;
    if ("y" in distance) return dy > distance.y;
    return false;
}
// src/types/axis.ts
var $ce41d7a96a1e68fd$export$d06866a9fb0606da = /* @__PURE__ */ ((Axis2)=>{
    Axis2["Horizontal"] = "x";
    Axis2["Vertical"] = "y";
    return Axis2;
})($ce41d7a96a1e68fd$export$d06866a9fb0606da || {});
var $ce41d7a96a1e68fd$export$387a78ab20784494 = Object.values($ce41d7a96a1e68fd$export$d06866a9fb0606da);


var $9636818b04ce7da6$var$__create = Object.create;
var $9636818b04ce7da6$var$__defProp = Object.defineProperty;
var $9636818b04ce7da6$var$__defProps = Object.defineProperties;
var $9636818b04ce7da6$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $9636818b04ce7da6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $9636818b04ce7da6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9636818b04ce7da6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9636818b04ce7da6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9636818b04ce7da6$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $9636818b04ce7da6$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $9636818b04ce7da6$var$__defNormalProp = (obj, key, value)=>key in obj ? $9636818b04ce7da6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9636818b04ce7da6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9636818b04ce7da6$var$__hasOwnProp.call(b, prop)) $9636818b04ce7da6$var$__defNormalProp(a, prop, b[prop]);
    if ($9636818b04ce7da6$var$__getOwnPropSymbols) {
        for (var prop of $9636818b04ce7da6$var$__getOwnPropSymbols(b))if ($9636818b04ce7da6$var$__propIsEnum.call(b, prop)) $9636818b04ce7da6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9636818b04ce7da6$var$__spreadProps = (a, b)=>$9636818b04ce7da6$var$__defProps(a, $9636818b04ce7da6$var$__getOwnPropDescs(b));
var $9636818b04ce7da6$var$__name = (target, value)=>$9636818b04ce7da6$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $9636818b04ce7da6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($9636818b04ce7da6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $9636818b04ce7da6$var$__getOwnPropSymbols) {
        for (var prop of $9636818b04ce7da6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $9636818b04ce7da6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $9636818b04ce7da6$var$__decoratorStart = (base)=>{
    var _a;
    return [
        ,
        ,
        ,
        $9636818b04ce7da6$var$__create((_a = base == null ? void 0 : base[$9636818b04ce7da6$var$__knownSymbol("metadata")]) != null ? _a : null)
    ];
};
var $9636818b04ce7da6$var$__decoratorStrings = [
    "class",
    "method",
    "getter",
    "setter",
    "accessor",
    "field",
    "value",
    "get",
    "set"
];
var $9636818b04ce7da6$var$__expectFn = (fn)=>fn !== void 0 && typeof fn !== "function" ? $9636818b04ce7da6$var$__typeError("Function expected") : fn;
var $9636818b04ce7da6$var$__decoratorContext = (kind, name, done, metadata, fns)=>({
        kind: $9636818b04ce7da6$var$__decoratorStrings[kind],
        name: name,
        metadata: metadata,
        addInitializer: (fn)=>done._ ? $9636818b04ce7da6$var$__typeError("Already initialized") : fns.push($9636818b04ce7da6$var$__expectFn(fn || null))
    });
var $9636818b04ce7da6$var$__decoratorMetadata = (array, target)=>$9636818b04ce7da6$var$__defNormalProp(target, $9636818b04ce7da6$var$__knownSymbol("metadata"), array[3]);
var $9636818b04ce7da6$var$__runInitializers = (array, flags, self, value)=>{
    for(var i = 0, fns = array[flags >> 1], n = fns && fns.length; i < n; i++)flags & 1 ? fns[i].call(self) : value = fns[i].call(self, value);
    return value;
};
var $9636818b04ce7da6$var$__decorateElement = (array, flags, name, decorators, target, extra)=>{
    var fn, it, done, ctx, access, k = flags & 7, s = !!(flags & 8), p = !!(flags & 16);
    var j = k > 3 ? array.length + 1 : k ? s ? 1 : 2 : 0, key = $9636818b04ce7da6$var$__decoratorStrings[k + 5];
    var initializers = k > 3 && (array[j - 1] = []), extraInitializers = array[j] || (array[j] = []);
    var desc = k && (!p && !s && (target = target.prototype), k < 5 && (k > 3 || !p) && $9636818b04ce7da6$var$__getOwnPropDesc(k < 4 ? target : {
        get [name] () {
            return $9636818b04ce7da6$var$__privateGet(this, extra);
        },
        set [name] (x){
            return $9636818b04ce7da6$var$__privateSet(this, extra, x);
        }
    }, name));
    k ? p && k < 4 && $9636818b04ce7da6$var$__name(extra, (k > 2 ? "set " : k > 1 ? "get " : "") + name) : $9636818b04ce7da6$var$__name(target, name);
    for(var i = decorators.length - 1; i >= 0; i--){
        ctx = $9636818b04ce7da6$var$__decoratorContext(k, name, done = {}, array[3], extraInitializers);
        if (k) {
            ctx.static = s, ctx.private = p, access = ctx.access = {
                has: p ? (x1)=>$9636818b04ce7da6$var$__privateIn(target, x1) : (x1)=>name in x1
            };
            if (k ^ 3) access.get = p ? (x1)=>(k ^ 1 ? $9636818b04ce7da6$var$__privateGet : $9636818b04ce7da6$var$__privateMethod)(x1, target, k ^ 4 ? extra : desc.get) : (x1)=>x1[name];
            if (k > 2) access.set = p ? (x1, y)=>$9636818b04ce7da6$var$__privateSet(x1, target, y, k ^ 4 ? extra : desc.set) : (x1, y)=>x1[name] = y;
        }
        it = (0, decorators[i])(k ? k < 4 ? p ? extra : desc[key] : k > 4 ? void 0 : {
            get: desc.get,
            set: desc.set
        } : target, ctx), done._ = 1;
        if (k ^ 4 || it === void 0) $9636818b04ce7da6$var$__expectFn(it) && (k > 4 ? initializers.unshift(it) : k ? p ? extra = it : desc[key] = it : target = it);
        else if (typeof it !== "object" || it === null) $9636818b04ce7da6$var$__typeError("Object expected");
        else $9636818b04ce7da6$var$__expectFn(fn = it.get) && (desc.get = fn), $9636818b04ce7da6$var$__expectFn(fn = it.set) && (desc.set = fn), $9636818b04ce7da6$var$__expectFn(fn = it.init) && initializers.unshift(fn);
    }
    return k || $9636818b04ce7da6$var$__decoratorMetadata(array, target), desc && $9636818b04ce7da6$var$__defProp(target, name, desc), p ? k ^ 4 ? extra : desc : target;
};
var $9636818b04ce7da6$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $9636818b04ce7da6$var$__typeError("Cannot " + msg);
var $9636818b04ce7da6$var$__privateIn = (member, obj)=>Object(obj) !== obj ? $9636818b04ce7da6$var$__typeError('Cannot use the "in" operator on this value') : member.has(obj);
var $9636818b04ce7da6$var$__privateGet = (obj, member, getter)=>($9636818b04ce7da6$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $9636818b04ce7da6$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $9636818b04ce7da6$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $9636818b04ce7da6$var$__privateSet = (obj, member, value, setter)=>($9636818b04ce7da6$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $9636818b04ce7da6$var$__privateMethod = (obj, member, method)=>($9636818b04ce7da6$var$__accessCheck(obj, member, "access private method"), method);
// src/core/plugins/utilities.ts
function $9636818b04ce7da6$export$8d21e34596265fa2(plugin, options) {
    return {
        plugin: plugin,
        options: options
    };
}
function $9636818b04ce7da6$export$adf416f00cca6418(plugin) {
    return (options)=>{
        return $9636818b04ce7da6$export$8d21e34596265fa2(plugin, options);
    };
}
function $9636818b04ce7da6$export$480024ae1501d25a(plugin) {
    if (typeof plugin === "function") return {
        plugin: plugin,
        options: void 0
    };
    return plugin;
}
// src/core/plugins/plugin.ts
var $9636818b04ce7da6$var$_disabled_dec, $9636818b04ce7da6$var$_init, $9636818b04ce7da6$var$_disabled, $9636818b04ce7da6$var$_cleanupFunctions;
$9636818b04ce7da6$var$_disabled_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
];
var $9636818b04ce7da6$export$901cf72dabf2112a = class {
    /**
   * Creates a new plugin instance.
   *
   * @param manager - The drag and drop manager that owns this plugin
   * @param options - Optional configuration for the plugin
   */ constructor(manager, options){
        this.manager = manager;
        this.options = options;
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_disabled, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init, 8, this, false)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init, 11, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_cleanupFunctions, /* @__PURE__ */ new Set());
    }
    /**
   * Enables a disabled plugin instance.
   *
   * @remarks
   * This method triggers effects when called.
   */ enable() {
        this.disabled = false;
    }
    /**
   * Disables an enabled plugin instance.
   *
   * @remarks
   * This method triggers effects when called.
   */ disable() {
        this.disabled = true;
    }
    /**
   * Checks if the plugin instance is disabled.
   *
   * @returns true if the plugin is disabled
   * @remarks
   * This method does not trigger effects when accessed.
   */ isDisabled() {
        return (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
            return this.disabled;
        });
    }
    /**
   * Configures a plugin instance with new options.
   *
   * @param options - The new options to apply
   */ configure(options) {
        this.options = options;
    }
    /**
   * Registers an effect that will be cleaned up when the plugin is destroyed.
   *
   * @param callback - The effect callback to register
   * @returns A function to dispose of the effect
   */ registerEffect(callback) {
        const dispose = (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(callback.bind(this));
        $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_cleanupFunctions).add(dispose);
        return dispose;
    }
    /**
   * Destroys a plugin instance and cleans up its resources.
   *
   * @remarks
   * This method:
   * - Calls all registered cleanup functions
   * - Should be overridden by subclasses to clean up additional resources
   */ destroy() {
        $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_cleanupFunctions).forEach((cleanup)=>cleanup());
    }
    /**
   * Configures a plugin constructor with options.
   *
   * @param options - The options to configure the constructor with
   * @returns The configured plugin constructor
   *
   * @remarks
   * This method is used to configure the options that the
   * plugin constructor will use to create plugin instances.
   */ static configure(options) {
        return $9636818b04ce7da6$export$8d21e34596265fa2(this, options);
    }
};
$9636818b04ce7da6$var$_init = $9636818b04ce7da6$var$__decoratorStart(null);
$9636818b04ce7da6$var$_disabled = new WeakMap();
$9636818b04ce7da6$var$_cleanupFunctions = new WeakMap();
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init, 4, "disabled", $9636818b04ce7da6$var$_disabled_dec, $9636818b04ce7da6$export$901cf72dabf2112a, $9636818b04ce7da6$var$_disabled);
$9636818b04ce7da6$var$__decoratorMetadata($9636818b04ce7da6$var$_init, $9636818b04ce7da6$export$901cf72dabf2112a);
var $9636818b04ce7da6$export$18cc238caa2b61f6 = class extends $9636818b04ce7da6$export$901cf72dabf2112a {
};
// src/core/plugins/registry.ts
var $9636818b04ce7da6$var$_previousValues;
var $9636818b04ce7da6$export$b4b52655520fdbf0 = class {
    /**
   * Creates a new plugin registry.
   *
   * @param manager - The drag and drop manager that owns this registry
   */ constructor(manager){
        this.manager = manager;
        this.instances = /* @__PURE__ */ new Map();
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_previousValues, []);
    }
    /**
   * Gets all registered plugin instances.
   *
   * @returns An array of all active plugin instances
   */ get values() {
        return Array.from(this.instances.values());
    }
    /**
   * Sets the list of plugins to be used by the registry.
   *
   * @param entries - Array of plugin constructors or descriptors
   * @remarks
   * This method:
   * - Filters out duplicate plugins
   * - Unregisters plugins that are no longer in use
   * - Registers new plugins with their options
   */ set values(entries) {
        const descriptors = entries.map($9636818b04ce7da6$export$480024ae1501d25a).reduce((acc, descriptor2)=>{
            const existing = acc.find(({ plugin: plugin })=>plugin === descriptor2.plugin);
            if (existing) {
                existing.options = descriptor2.options;
                return acc;
            }
            return [
                ...acc,
                descriptor2
            ];
        }, []);
        const constructors = descriptors.map(({ plugin: plugin })=>plugin);
        for (const plugin of $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_previousValues))if (!constructors.includes(plugin)) {
            if (plugin.prototype instanceof $9636818b04ce7da6$export$18cc238caa2b61f6) continue;
            this.unregister(plugin);
        }
        for (const { plugin: plugin, options: options } of descriptors)this.register(plugin, options);
        $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_previousValues, constructors);
    }
    /**
   * Gets a plugin instance by its constructor.
   *
   * @param plugin - The plugin constructor to look up
   * @returns The plugin instance or undefined if not found
   */ get(plugin) {
        const instance = this.instances.get(plugin);
        return instance;
    }
    /**
   * Registers a new plugin instance.
   *
   * @param plugin - The plugin constructor to register
   * @param options - Optional configuration for the plugin
   * @returns The registered plugin instance
   * @remarks
   * If the plugin is already registered, its options will be updated
   * and the existing instance will be returned.
   */ register(plugin, options) {
        const existingInstance = this.instances.get(plugin);
        if (existingInstance) {
            if (existingInstance.options !== options) existingInstance.options = options;
            return existingInstance;
        }
        const instance = new plugin(this.manager, options);
        this.instances.set(plugin, instance);
        return instance;
    }
    /**
   * Unregisters a plugin instance.
   *
   * @param plugin - The plugin constructor to unregister
   * @remarks
   * This method:
   * - Destroys the plugin instance
   * - Removes it from the registry
   */ unregister(plugin) {
        const instance = this.instances.get(plugin);
        if (instance) {
            instance.destroy();
            this.instances.delete(plugin);
        }
    }
    /**
   * Destroys all registered plugin instances.
   *
   * @remarks
   * This method:
   * - Calls destroy() on all plugin instances
   * - Clears the registry
   */ destroy() {
        for (const plugin of this.instances.values())plugin.destroy();
        this.instances.clear();
    }
};
$9636818b04ce7da6$var$_previousValues = new WeakMap();
// src/core/collision/utilities.ts
function $9636818b04ce7da6$export$3add4507379093fa(a, b) {
    if (a.priority === b.priority) {
        if (a.type === b.type) return b.value - a.value;
        return b.type - a.type;
    }
    return b.priority - a.priority;
}
// src/core/collision/observer.ts
var $9636818b04ce7da6$var$DEFAULT_VALUE = [];
var $9636818b04ce7da6$var$_previousCoordinates, $9636818b04ce7da6$var$_collisions;
var $9636818b04ce7da6$var$CollisionObserver = class extends $9636818b04ce7da6$export$901cf72dabf2112a {
    /**
   * Creates a new CollisionObserver instance.
   *
   * @param manager - The drag drop manager instance
   */ constructor(manager){
        super(manager);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_previousCoordinates);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_collisions);
        this.computeCollisions = this.computeCollisions.bind(this);
        $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_collisions, (0, $c60338eb080e669a$export$e2ef10f86a8d60e8)($9636818b04ce7da6$var$DEFAULT_VALUE));
        this.destroy = (0, $eb0d2ed00918af28$export$fb4689499fb20c56)(()=>{
            const collisions = this.computeCollisions();
            const coordinates = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>this.manager.dragOperation.position.current);
            if (collisions !== $9636818b04ce7da6$var$DEFAULT_VALUE) {
                const previousCoordinates = $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_previousCoordinates);
                $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_previousCoordinates, coordinates);
                if (previousCoordinates && coordinates.x == previousCoordinates.x && coordinates.y == previousCoordinates.y) return;
            } else $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_previousCoordinates, void 0);
            $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_collisions).value = collisions;
        }, ()=>{
            const { dragOperation: dragOperation } = this.manager;
            if (dragOperation.status.initialized) this.forceUpdate();
        });
    }
    /**
   * Forces an immediate update of collision detection.
   *
   * @param immediate - If true, updates collisions immediately. If false, resets previous coordinates.
   */ forceUpdate(immediate = true) {
        (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
            if (immediate) $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_collisions).value = this.computeCollisions();
            else $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_previousCoordinates, void 0);
        });
    }
    /**
   * Computes collisions between draggable and droppable elements.
   *
   * @param entries - Optional array of droppable elements to check. If not provided, uses all registered droppables.
   * @param collisionDetector - Optional custom collision detector function
   * @returns Array of detected collisions, sorted by priority
   */ computeCollisions(entries, collisionDetector) {
        const { registry: registry, dragOperation: dragOperation } = this.manager;
        const { source: source, shape: shape, status: status } = dragOperation;
        if (!status.initialized || !shape) return $9636818b04ce7da6$var$DEFAULT_VALUE;
        const collisions = [];
        const potentialTargets = [];
        for (const entry of entries != null ? entries : registry.droppables){
            if (entry.disabled) continue;
            if (source && !entry.accepts(source)) continue;
            const detectCollision = collisionDetector != null ? collisionDetector : entry.collisionDetector;
            if (!detectCollision) continue;
            potentialTargets.push(entry);
            entry.shape;
            const collision = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>detectCollision({
                    droppable: entry,
                    dragOperation: dragOperation
                }));
            if (collision) {
                if (entry.collisionPriority != null) collision.priority = entry.collisionPriority;
                collisions.push(collision);
            }
        }
        if (potentialTargets.length === 0) return $9636818b04ce7da6$var$DEFAULT_VALUE;
        collisions.sort($9636818b04ce7da6$export$3add4507379093fa);
        return collisions;
    }
    /**
   * Gets the current collisions signal value.
   */ get collisions() {
        return $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_collisions).value;
    }
};
$9636818b04ce7da6$var$_previousCoordinates = new WeakMap();
$9636818b04ce7da6$var$_collisions = new WeakMap();
var $9636818b04ce7da6$var$_disabled_dec2, $9636818b04ce7da6$var$_data_dec, $9636818b04ce7da6$var$_manager_dec, $9636818b04ce7da6$var$_Entity_static, $9636818b04ce7da6$var$flushIdChanges_fn, $9636818b04ce7da6$var$_init2, $9636818b04ce7da6$var$_manager, $9636818b04ce7da6$var$_idSignal, $9636818b04ce7da6$var$_data, $9636818b04ce7da6$var$_disabled2;
$9636818b04ce7da6$var$_manager_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_data_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_disabled_dec2 = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
];
var $9636818b04ce7da6$var$_Entity = class _Entity {
    /**
   * Creates a new instance of the `Entity` class.
   *
   * @param input - An object containing the initial properties of the entity.
   * @param manager - The manager that controls the drag and drop operations.
   */ constructor(input, manager){
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_manager, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init2, 8, this)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init2, 11, this);
        /**
     * The unique identifier of the entity.
     *
     * Setting this property defers the signal update to a microtask,
     * batching multiple id changes together atomically. This ensures
     * that when entities swap ids (e.g. during sorting with virtualization),
     * all registry updates happen in a single transaction.
     */ $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_idSignal);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_data, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init2, 12, this)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init2, 15, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_disabled2, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init2, 16, this)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init2, 19, this);
        const { effects: effects6, id: id, data: data = {}, disabled: disabled = false, register: register = true } = input;
        let previousId = id;
        $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_idSignal, (0, $c60338eb080e669a$export$e2ef10f86a8d60e8)(id));
        this.manager = manager;
        this.data = data;
        this.disabled = disabled;
        this.effects = ()=>{
            var _a;
            return [
                ()=>{
                    const { id: id2, manager: manager2 } = this;
                    if (id2 === previousId) return;
                    previousId = id2;
                    manager2 == null || manager2.registry.register(this);
                    return ()=>manager2 == null ? void 0 : manager2.registry.unregister(this);
                },
                ...(_a = effects6 == null ? void 0 : effects6()) != null ? _a : []
            ];
        };
        this.register = this.register.bind(this);
        this.unregister = this.unregister.bind(this);
        this.destroy = this.destroy.bind(this);
        if (manager && register) queueMicrotask(this.register);
    }
    get id() {
        var _a, _b;
        const signalValue = $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_idSignal).value;
        return (_b = (_a = _Entity.pendingIdChanges) == null ? void 0 : _a.get(this)) != null ? _b : signalValue;
    }
    set id(value) {
        var _a, _b;
        const current = (_b = (_a = _Entity.pendingIdChanges) == null ? void 0 : _a.get(this)) != null ? _b : $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_idSignal).peek();
        if (value === current) return;
        if (!_Entity.pendingIdChanges) {
            _Entity.pendingIdChanges = /* @__PURE__ */ new Map();
            queueMicrotask(()=>{
                var _a2;
                return $9636818b04ce7da6$var$__privateMethod(_a2 = _Entity, $9636818b04ce7da6$var$_Entity_static, $9636818b04ce7da6$var$flushIdChanges_fn).call(_a2);
            });
        }
        _Entity.pendingIdChanges.set(this, value);
    }
    /**
   * A method that registers the entity with the manager.
   * @returns CleanupFunction | void
   */ register() {
        var _a;
        return (_a = this.manager) == null ? void 0 : _a.registry.register(this);
    }
    /**
   * A method that unregisters the entity from the manager.
   * @returns void
   */ unregister() {
        var _a;
        (_a = this.manager) == null || _a.registry.unregister(this);
    }
    /**
   * A method that cleans up the entity when it is no longer needed.
   * @returns void
   */ destroy() {
        var _a;
        (_a = this.manager) == null || _a.registry.unregister(this);
    }
};
$9636818b04ce7da6$var$_init2 = $9636818b04ce7da6$var$__decoratorStart(null);
$9636818b04ce7da6$var$_Entity_static = new WeakSet();
$9636818b04ce7da6$var$flushIdChanges_fn = function() {
    const changes = $9636818b04ce7da6$var$_Entity.pendingIdChanges;
    $9636818b04ce7da6$var$_Entity.pendingIdChanges = null;
    if (changes) (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
        for (const [entity, id] of changes)$9636818b04ce7da6$var$__privateGet(entity, $9636818b04ce7da6$var$_idSignal).value = id;
    });
};
$9636818b04ce7da6$var$_manager = new WeakMap();
$9636818b04ce7da6$var$_idSignal = new WeakMap();
$9636818b04ce7da6$var$_data = new WeakMap();
$9636818b04ce7da6$var$_disabled2 = new WeakMap();
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init2, 4, "manager", $9636818b04ce7da6$var$_manager_dec, $9636818b04ce7da6$var$_Entity, $9636818b04ce7da6$var$_manager);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init2, 4, "data", $9636818b04ce7da6$var$_data_dec, $9636818b04ce7da6$var$_Entity, $9636818b04ce7da6$var$_data);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init2, 4, "disabled", $9636818b04ce7da6$var$_disabled_dec2, $9636818b04ce7da6$var$_Entity, $9636818b04ce7da6$var$_disabled2);
$9636818b04ce7da6$var$__privateAdd($9636818b04ce7da6$var$_Entity, $9636818b04ce7da6$var$_Entity_static);
$9636818b04ce7da6$var$__decoratorMetadata($9636818b04ce7da6$var$_init2, $9636818b04ce7da6$var$_Entity);
$9636818b04ce7da6$var$_Entity.pendingIdChanges = null;
var $9636818b04ce7da6$var$Entity = $9636818b04ce7da6$var$_Entity;
var $9636818b04ce7da6$var$EntityRegistry = class {
    constructor(){
        this.map = (0, $c60338eb080e669a$export$e2ef10f86a8d60e8)(/* @__PURE__ */ new Map());
        this.cleanupFunctions = /* @__PURE__ */ new WeakMap();
        /**
     * Registers a entity in the registry.
     * @param key - The unique identifier of the entity.
     * @param value - The entity to register.
     * @returns A function that unregisters the entity.
     */ this.register = (key, value)=>{
            const current = this.map.peek();
            const currentValue = current.get(key);
            const unregister = ()=>this.unregister(key, value);
            if (currentValue === value) return unregister;
            if (currentValue) {
                if (currentValue.id === key) {
                    const cleanup2 = this.cleanupFunctions.get(currentValue);
                    cleanup2 == null || cleanup2();
                    this.cleanupFunctions.delete(currentValue);
                }
            }
            const updatedMap = new Map(current);
            for (const [existingKey, existingValue] of current)if (existingValue === value && existingKey !== key) {
                updatedMap.delete(existingKey);
                break;
            }
            updatedMap.set(key, value);
            this.map.value = updatedMap;
            const cleanup = (0, $eb0d2ed00918af28$export$fb4689499fb20c56)(...value.effects());
            this.cleanupFunctions.set(value, cleanup);
            return unregister;
        };
        /**
     * Unregisters an entity from the registry.
     * @param key - The unique identifier of the entity.
     * @param value - The entity instance to unregister.
     */ this.unregister = (key, value)=>{
            const current = this.map.peek();
            if (current.get(key) !== value) return;
            const cleanup = this.cleanupFunctions.get(value);
            cleanup == null || cleanup();
            this.cleanupFunctions.delete(value);
            const updatedMap = new Map(current);
            updatedMap.delete(key);
            this.map.value = updatedMap;
        };
    }
    /**
   * Iterator for the EntityRegistry class.
   * @returns An iterator for the values in the map.
   */ [Symbol.iterator]() {
        return this.map.peek().values();
    }
    get value() {
        return this.map.value.values();
    }
    /**
   * Checks if a entity with the given identifier exists in the registry.
   * @param identifier - The unique identifier of the entity.
   * @returns True if the entity exists, false otherwise.
   */ has(identifier) {
        return this.map.value.has(identifier);
    }
    /**
   * Retrieves a entity from the registry using its identifier.
   * @param identifier - The unique identifier of the entity.
   * @returns The entity if it exists, undefined otherwise.
   */ get(identifier) {
        return this.map.value.get(identifier);
    }
    /**
   * Destroys all entries in the registry and clears the registry.
   */ destroy() {
        for (const entry of this){
            const cleanup = this.cleanupFunctions.get(entry);
            cleanup == null || cleanup();
            entry.destroy();
        }
        this.map.value = /* @__PURE__ */ new Map();
    }
};
var $9636818b04ce7da6$var$_isDragSource_dec, $9636818b04ce7da6$var$_isDragging_dec, $9636818b04ce7da6$var$_isDropping_dec, $9636818b04ce7da6$var$_status_dec, $9636818b04ce7da6$var$_modifiers_dec, $9636818b04ce7da6$var$_type_dec, $9636818b04ce7da6$var$_c, $9636818b04ce7da6$var$_init3, $9636818b04ce7da6$var$_type, $9636818b04ce7da6$var$_modifiers, $9636818b04ce7da6$var$_status;
var $9636818b04ce7da6$export$f2a139e5d18b9882 = class extends ($9636818b04ce7da6$var$_c = $9636818b04ce7da6$var$Entity, $9636818b04ce7da6$var$_type_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_modifiers_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_status_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_isDropping_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_isDragging_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_isDragSource_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_c) {
    constructor(_a, manager){
        var _b = _a, { modifiers: modifiers, type: type, sensors: sensors, plugins: plugins, effects: effects6 } = _b, input = $9636818b04ce7da6$var$__objRest(_b, [
            "modifiers",
            "type",
            "sensors",
            "plugins",
            "effects"
        ]);
        super($9636818b04ce7da6$var$__spreadProps($9636818b04ce7da6$var$__spreadValues({}, input), {
            effects: ()=>{
                var _a2;
                return [
                    ...(_a2 = effects6 == null ? void 0 : effects6()) != null ? _a2 : [],
                    ()=>{
                        const { manager: manager2, plugins: plugins2 } = this;
                        if (!manager2 || !plugins2) return;
                        for (const entry of plugins2){
                            const { plugin: plugin } = $9636818b04ce7da6$export$480024ae1501d25a(entry);
                            manager2.registry.plugins.register(plugin);
                        }
                    }
                ];
            }
        }), manager);
        $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init3, 5, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_type, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init3, 8, this)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init3, 11, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_modifiers, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init3, 12, this)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init3, 15, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_status, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init3, 16, this, this.isDragSource ? "dragging" : "idle")), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init3, 19, this);
        this.type = type;
        this.sensors = sensors;
        this.modifiers = modifiers;
        this.alignment = input.alignment;
        this.plugins = plugins;
    }
    /**
   * Look up per-entity options for a given plugin constructor.
   */ pluginConfig(plugin) {
        if (!this.plugins) return void 0;
        for (const entry of this.plugins){
            const desc = $9636818b04ce7da6$export$480024ae1501d25a(entry);
            if (desc.plugin === plugin) return desc.options;
        }
        return void 0;
    }
    get isDropping() {
        return this.status === "dropping" && this.isDragSource;
    }
    get isDragging() {
        return this.status === "dragging" && this.isDragSource;
    }
    get isDragSource() {
        var _a, _b;
        return ((_b = (_a = this.manager) == null ? void 0 : _a.dragOperation.source) == null ? void 0 : _b.id) === this.id;
    }
};
$9636818b04ce7da6$var$_init3 = $9636818b04ce7da6$var$__decoratorStart($9636818b04ce7da6$var$_c);
$9636818b04ce7da6$var$_type = new WeakMap();
$9636818b04ce7da6$var$_modifiers = new WeakMap();
$9636818b04ce7da6$var$_status = new WeakMap();
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init3, 4, "type", $9636818b04ce7da6$var$_type_dec, $9636818b04ce7da6$export$f2a139e5d18b9882, $9636818b04ce7da6$var$_type);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init3, 4, "modifiers", $9636818b04ce7da6$var$_modifiers_dec, $9636818b04ce7da6$export$f2a139e5d18b9882, $9636818b04ce7da6$var$_modifiers);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init3, 4, "status", $9636818b04ce7da6$var$_status_dec, $9636818b04ce7da6$export$f2a139e5d18b9882, $9636818b04ce7da6$var$_status);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init3, 2, "isDropping", $9636818b04ce7da6$var$_isDropping_dec, $9636818b04ce7da6$export$f2a139e5d18b9882);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init3, 2, "isDragging", $9636818b04ce7da6$var$_isDragging_dec, $9636818b04ce7da6$export$f2a139e5d18b9882);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init3, 2, "isDragSource", $9636818b04ce7da6$var$_isDragSource_dec, $9636818b04ce7da6$export$f2a139e5d18b9882);
$9636818b04ce7da6$var$__decoratorMetadata($9636818b04ce7da6$var$_init3, $9636818b04ce7da6$export$f2a139e5d18b9882);
var $9636818b04ce7da6$var$_isDropTarget_dec, $9636818b04ce7da6$var$_shape_dec, $9636818b04ce7da6$var$_collisionPriority_dec, $9636818b04ce7da6$var$_collisionDetector_dec, $9636818b04ce7da6$var$_type_dec2, $9636818b04ce7da6$var$_accept_dec, $9636818b04ce7da6$var$_c2, $9636818b04ce7da6$var$_init4, $9636818b04ce7da6$var$_accept, $9636818b04ce7da6$var$_type2, $9636818b04ce7da6$var$_collisionDetector, $9636818b04ce7da6$var$_collisionPriority, $9636818b04ce7da6$var$_shape;
var $9636818b04ce7da6$export$423ec2075359570a = class extends ($9636818b04ce7da6$var$_c2 = $9636818b04ce7da6$var$Entity, $9636818b04ce7da6$var$_accept_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_type_dec2 = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_collisionDetector_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_collisionPriority_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_shape_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_isDropTarget_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_c2) {
    constructor(_a, manager){
        var _b = _a, { accept: accept, collisionDetector: collisionDetector, collisionPriority: collisionPriority, type: type } = _b, input = $9636818b04ce7da6$var$__objRest(_b, [
            "accept",
            "collisionDetector",
            "collisionPriority",
            "type"
        ]);
        super(input, manager);
        $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 5, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_accept, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 8, this)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 11, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_type2, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 12, this)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 15, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_collisionDetector, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 16, this)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 19, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_collisionPriority, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 20, this)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 23, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_shape, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 24, this)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init4, 27, this);
        this.accept = accept;
        this.collisionDetector = collisionDetector;
        this.collisionPriority = collisionPriority;
        this.type = type;
    }
    /**
   * Checks whether or not the droppable accepts a given draggable.
   *
   * @param draggable - The draggable to check
   * @returns true if the draggable can be dropped here
   */ accepts(draggable) {
        const { accept: accept } = this;
        if (!accept) return true;
        if (typeof accept === "function") return accept(draggable);
        if (!draggable.type) return false;
        if (Array.isArray(accept)) return accept.includes(draggable.type);
        return draggable.type === accept;
    }
    get isDropTarget() {
        var _a, _b;
        return ((_b = (_a = this.manager) == null ? void 0 : _a.dragOperation.target) == null ? void 0 : _b.id) === this.id;
    }
};
$9636818b04ce7da6$var$_init4 = $9636818b04ce7da6$var$__decoratorStart($9636818b04ce7da6$var$_c2);
$9636818b04ce7da6$var$_accept = new WeakMap();
$9636818b04ce7da6$var$_type2 = new WeakMap();
$9636818b04ce7da6$var$_collisionDetector = new WeakMap();
$9636818b04ce7da6$var$_collisionPriority = new WeakMap();
$9636818b04ce7da6$var$_shape = new WeakMap();
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init4, 4, "accept", $9636818b04ce7da6$var$_accept_dec, $9636818b04ce7da6$export$423ec2075359570a, $9636818b04ce7da6$var$_accept);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init4, 4, "type", $9636818b04ce7da6$var$_type_dec2, $9636818b04ce7da6$export$423ec2075359570a, $9636818b04ce7da6$var$_type2);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init4, 4, "collisionDetector", $9636818b04ce7da6$var$_collisionDetector_dec, $9636818b04ce7da6$export$423ec2075359570a, $9636818b04ce7da6$var$_collisionDetector);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init4, 4, "collisionPriority", $9636818b04ce7da6$var$_collisionPriority_dec, $9636818b04ce7da6$export$423ec2075359570a, $9636818b04ce7da6$var$_collisionPriority);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init4, 4, "shape", $9636818b04ce7da6$var$_shape_dec, $9636818b04ce7da6$export$423ec2075359570a, $9636818b04ce7da6$var$_shape);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init4, 2, "isDropTarget", $9636818b04ce7da6$var$_isDropTarget_dec, $9636818b04ce7da6$export$423ec2075359570a);
$9636818b04ce7da6$var$__decoratorMetadata($9636818b04ce7da6$var$_init4, $9636818b04ce7da6$export$423ec2075359570a);
// src/core/manager/events.ts
var $9636818b04ce7da6$var$Monitor = class {
    constructor(){
        this.registry = /* @__PURE__ */ new Map();
    }
    /**
   * Adds an event listener for the specified event type.
   *
   * @param name - The name of the event to listen for
   * @param handler - The function to call when the event occurs
   * @returns A function to remove the event listener
   */ addEventListener(name, handler) {
        const { registry: registry } = this;
        const listeners = new Set(registry.get(name));
        listeners.add(handler);
        registry.set(name, listeners);
        return ()=>this.removeEventListener(name, handler);
    }
    /**
   * Removes an event listener for the specified event type.
   *
   * @param name - The name of the event
   * @param handler - The function to remove
   */ removeEventListener(name, handler) {
        const { registry: registry } = this;
        const listeners = new Set(registry.get(name));
        listeners.delete(handler);
        registry.set(name, listeners);
    }
    /**
   * Dispatches an event to all registered listeners.
   *
   * @param name - The name of the event to dispatch
   * @param args - Arguments to pass to the event handlers
   */ dispatch(name, ...args) {
        const { registry: registry } = this;
        const listeners = registry.get(name);
        if (!listeners) return;
        for (const listener of listeners)listener(...args);
    }
};
var $9636818b04ce7da6$var$DragDropMonitor = class extends $9636818b04ce7da6$var$Monitor {
    /**
   * Creates a new drag and drop monitor.
   *
   * @param manager - The drag and drop manager to monitor
   */ constructor(manager){
        super();
        this.manager = manager;
    }
    /**
   * Dispatches a drag and drop event.
   *
   * @param type - The type of event to dispatch
   * @param event - The event data to dispatch
   */ dispatch(type, event) {
        const args = [
            event,
            this.manager
        ];
        super.dispatch(type, ...args);
    }
};
function $9636818b04ce7da6$var$defaultPreventable(event, cancelable = true) {
    let defaultPrevented = false;
    return $9636818b04ce7da6$var$__spreadProps($9636818b04ce7da6$var$__spreadValues({}, event), {
        cancelable: cancelable,
        get defaultPrevented () {
            return defaultPrevented;
        },
        preventDefault () {
            if (!cancelable) return;
            defaultPrevented = true;
        }
    });
}
// src/core/collision/notifier.ts
var $9636818b04ce7da6$var$CollisionNotifier = class extends $9636818b04ce7da6$export$18cc238caa2b61f6 {
    constructor(manager){
        super(manager);
        const isEqual = (a, b)=>a.map(({ id: id })=>id).join("") === b.map(({ id: id })=>id).join("");
        let previousCollisions = [];
        this.destroy = (0, $eb0d2ed00918af28$export$fb4689499fb20c56)(()=>{
            const { dragOperation: dragOperation, collisionObserver: collisionObserver } = manager;
            if (dragOperation.status.initializing) {
                previousCollisions = [];
                collisionObserver.enable();
            }
        }, ()=>{
            const { collisionObserver: collisionObserver, monitor: monitor } = manager;
            const { collisions: collisions } = collisionObserver;
            if (collisionObserver.isDisabled()) return;
            if ($9636818b04ce7da6$var$Entity.pendingIdChanges) return;
            const event = $9636818b04ce7da6$var$defaultPreventable({
                collisions: collisions
            });
            monitor.dispatch("collision", event);
            if (event.defaultPrevented) return;
            if (isEqual(collisions, previousCollisions)) return;
            else previousCollisions = collisions;
            const [firstCollision] = collisions;
            (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
                var _a;
                if ((firstCollision == null ? void 0 : firstCollision.id) !== ((_a = manager.dragOperation.target) == null ? void 0 : _a.id)) {
                    collisionObserver.disable();
                    manager.actions.setDropTarget(firstCollision == null ? void 0 : firstCollision.id).then(()=>{
                        collisionObserver.enable();
                    });
                }
            });
        });
    }
};
// src/core/collision/types.ts
var $9636818b04ce7da6$export$f477ca1dcaa3e6e6 = /* @__PURE__ */ ((CollisionPriority2)=>{
    CollisionPriority2[CollisionPriority2["Lowest"] = 0] = "Lowest";
    CollisionPriority2[CollisionPriority2["Low"] = 1] = "Low";
    CollisionPriority2[CollisionPriority2["Normal"] = 2] = "Normal";
    CollisionPriority2[CollisionPriority2["High"] = 3] = "High";
    CollisionPriority2[CollisionPriority2["Highest"] = 4] = "Highest";
    return CollisionPriority2;
})($9636818b04ce7da6$export$f477ca1dcaa3e6e6 || {});
var $9636818b04ce7da6$export$ddb2ed749236e720 = /* @__PURE__ */ ((CollisionType2)=>{
    CollisionType2[CollisionType2["Collision"] = 0] = "Collision";
    CollisionType2[CollisionType2["ShapeIntersection"] = 1] = "ShapeIntersection";
    CollisionType2[CollisionType2["PointerIntersection"] = 2] = "PointerIntersection";
    return CollisionType2;
})($9636818b04ce7da6$export$ddb2ed749236e720 || {});
var $9636818b04ce7da6$var$_dropped_dec, $9636818b04ce7da6$var$_dragging_dec, $9636818b04ce7da6$var$_initialized_dec, $9636818b04ce7da6$var$_initializing_dec, $9636818b04ce7da6$var$_idle_dec, $9636818b04ce7da6$var$_current_dec, $9636818b04ce7da6$var$_value_dec, $9636818b04ce7da6$var$_init5, $9636818b04ce7da6$var$_value;
$9636818b04ce7da6$var$_value_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_current_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_idle_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_initializing_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_initialized_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_dragging_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_dropped_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
];
var $9636818b04ce7da6$export$a170efc9e0947f3f = class {
    constructor(){
        $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init5, 5, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_value, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init5, 8, this, "idle" /* Idle */ )), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init5, 11, this);
    }
    get current() {
        return this.value;
    }
    get idle() {
        return this.value === "idle" /* Idle */ ;
    }
    get initializing() {
        return this.value === "initializing" /* Initializing */ ;
    }
    get initialized() {
        const { value: value } = this;
        return value !== "idle" /* Idle */  && value !== "initialization-pending" /* InitializationPending */ ;
    }
    get dragging() {
        return this.value === "dragging" /* Dragging */ ;
    }
    get dropped() {
        return this.value === "dropped" /* Dropped */ ;
    }
    /**
   * Sets the current status value.
   *
   * @param value - The new status value
   */ set(value) {
        this.value = value;
    }
};
$9636818b04ce7da6$var$_init5 = $9636818b04ce7da6$var$__decoratorStart(null);
$9636818b04ce7da6$var$_value = new WeakMap();
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init5, 4, "value", $9636818b04ce7da6$var$_value_dec, $9636818b04ce7da6$export$a170efc9e0947f3f, $9636818b04ce7da6$var$_value);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init5, 2, "current", $9636818b04ce7da6$var$_current_dec, $9636818b04ce7da6$export$a170efc9e0947f3f);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init5, 2, "idle", $9636818b04ce7da6$var$_idle_dec, $9636818b04ce7da6$export$a170efc9e0947f3f);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init5, 2, "initializing", $9636818b04ce7da6$var$_initializing_dec, $9636818b04ce7da6$export$a170efc9e0947f3f);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init5, 2, "initialized", $9636818b04ce7da6$var$_initialized_dec, $9636818b04ce7da6$export$a170efc9e0947f3f);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init5, 2, "dragging", $9636818b04ce7da6$var$_dragging_dec, $9636818b04ce7da6$export$a170efc9e0947f3f);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init5, 2, "dropped", $9636818b04ce7da6$var$_dropped_dec, $9636818b04ce7da6$export$a170efc9e0947f3f);
$9636818b04ce7da6$var$__decoratorMetadata($9636818b04ce7da6$var$_init5, $9636818b04ce7da6$export$a170efc9e0947f3f);
// src/core/manager/actions.ts
var $9636818b04ce7da6$var$DragActions = class {
    /**
   * Creates a new instance of drag actions.
   *
   * @param manager - The drag and drop manager instance
   */ constructor(manager){
        this.manager = manager;
    }
    /**
   * Sets the source of the drag operation.
   *
   * @param source - The draggable entity or its unique identifier
   */ setDragSource(source) {
        const { dragOperation: dragOperation } = this.manager;
        dragOperation.sourceIdentifier = typeof source === "string" || typeof source === "number" ? source : source.id;
    }
    /**
   * Sets the target of the drop operation.
   *
   * @param identifier - The unique identifier of the droppable entity or null/undefined
   * @returns A promise that resolves to true if the drop was prevented
   */ setDropTarget(identifier) {
        return (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
            const { dragOperation: dragOperation } = this.manager;
            const id = identifier != null ? identifier : null;
            if (dragOperation.targetIdentifier === id) return Promise.resolve(false);
            dragOperation.targetIdentifier = id;
            const event = $9636818b04ce7da6$var$defaultPreventable({
                operation: dragOperation.snapshot()
            });
            if (dragOperation.status.dragging) this.manager.monitor.dispatch("dragover", event);
            return this.manager.renderer.rendering.then(()=>event.defaultPrevented);
        });
    }
    /**
   * Starts a new drag operation.
   *
   * @param args - Configuration for the drag operation
   * @param args.event - The event that initiated the drag
   * @param args.source - The source draggable entity or its identifier
   * @param args.coordinates - The initial coordinates of the drag
   * @returns true if the drag operation started successfully
   * @throws {Error} If there is no drag source or another operation is active
   */ start(args) {
        return (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
            const { dragOperation: dragOperation } = this.manager;
            if (args.source != null) this.setDragSource(args.source);
            const sourceInstance = dragOperation.source;
            if (!sourceInstance) throw new Error("Cannot start a drag operation without a drag source");
            if (!dragOperation.status.idle) throw new Error("Cannot start a drag operation while another is active");
            const controller = new AbortController();
            const { event: nativeEvent, coordinates: coordinates } = args;
            (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
                dragOperation.status.set("initialization-pending" /* InitializationPending */ );
                dragOperation.shape = null;
                dragOperation.canceled = false;
                dragOperation.activatorEvent = nativeEvent != null ? nativeEvent : null;
                dragOperation.position.reset(coordinates);
            });
            const beforeStartEvent = $9636818b04ce7da6$var$defaultPreventable({
                operation: dragOperation.snapshot()
            });
            this.manager.monitor.dispatch("beforedragstart", beforeStartEvent);
            if (beforeStartEvent.defaultPrevented) {
                dragOperation.reset();
                controller.abort();
                return controller;
            }
            dragOperation.status.set("initializing" /* Initializing */ );
            dragOperation.controller = controller;
            this.manager.renderer.rendering.then(()=>{
                if (controller.signal.aborted) return;
                const { status: status } = dragOperation;
                if (status.current !== "initializing" /* Initializing */ ) return;
                (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
                    dragOperation.status.set("dragging" /* Dragging */ );
                    this.manager.monitor.dispatch("dragstart", {
                        nativeEvent: nativeEvent,
                        operation: dragOperation.snapshot(),
                        cancelable: false
                    });
                });
            });
            return controller;
        });
    }
    /**
   * Moves the dragged entity to a new position.
   *
   * @param args - Configuration for the move operation
   * @param args.by - Relative coordinates to move by
   * @param args.to - Absolute coordinates to move to
   * @param args.event - The event that triggered the move
   * @param args.cancelable - Whether the move can be canceled
   * @param args.propagate - Whether to dispatch dragmove events
   */ move(args) {
        return (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
            var _a, _b;
            const { dragOperation: dragOperation } = this.manager;
            const { status: status, controller: controller } = dragOperation;
            if (!status.dragging || !controller || controller.signal.aborted) return;
            const event = $9636818b04ce7da6$var$defaultPreventable({
                nativeEvent: args.event,
                operation: dragOperation.snapshot(),
                by: args.by,
                to: args.to
            }, (_a = args.cancelable) != null ? _a : true);
            if ((_b = args.propagate) != null ? _b : true) this.manager.monitor.dispatch("dragmove", event);
            queueMicrotask(()=>{
                var _a2, _b2, _c3, _d, _e;
                if (event.defaultPrevented) return;
                const coordinates = (_e = args.to) != null ? _e : {
                    x: dragOperation.position.current.x + ((_b2 = (_a2 = args.by) == null ? void 0 : _a2.x) != null ? _b2 : 0),
                    y: dragOperation.position.current.y + ((_d = (_c3 = args.by) == null ? void 0 : _c3.y) != null ? _d : 0)
                };
                dragOperation.position.current = coordinates;
            });
        });
    }
    /**
   * Stops the current drag operation.
   *
   * @param args - Configuration for stopping the operation
   * @param args.event - The event that triggered the stop
   * @param args.canceled - Whether the operation was canceled
   * @remarks
   * This method:
   * - Dispatches a dragend event
   * - Allows suspension of the operation
   * - Handles cleanup of the operation state
   */ stop(args = {}) {
        return (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
            var _a, _b;
            const { dragOperation: dragOperation } = this.manager;
            const { controller: controller } = dragOperation;
            if (!controller || controller.signal.aborted) return;
            let promise;
            const suspend = ()=>{
                const output = {
                    resume: ()=>{},
                    abort: ()=>{}
                };
                promise = new Promise((resolve, reject)=>{
                    output.resume = resolve;
                    output.abort = reject;
                });
                return output;
            };
            controller.abort();
            const end = ()=>{
                this.manager.renderer.rendering.then(()=>{
                    dragOperation.status.set("dropped" /* Dropped */ );
                    const dropping = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
                        var _a2;
                        return ((_a2 = dragOperation.source) == null ? void 0 : _a2.status) === "dropping";
                    });
                    const cleanup = ()=>{
                        if (dragOperation.controller === controller) dragOperation.controller = void 0;
                        dragOperation.reset();
                    };
                    if (dropping) {
                        const { source: source } = dragOperation;
                        const dispose = (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
                            if ((source == null ? void 0 : source.status) === "idle") {
                                dispose();
                                cleanup();
                            }
                        });
                    } else this.manager.renderer.rendering.then(cleanup);
                });
            };
            dragOperation.canceled = (_a = args.canceled) != null ? _a : false;
            this.manager.monitor.dispatch("dragend", {
                nativeEvent: args.event,
                operation: dragOperation.snapshot(),
                canceled: (_b = args.canceled) != null ? _b : false,
                suspend: suspend
            });
            if (promise) promise.then(end).catch(()=>dragOperation.reset());
            else end();
        });
    }
};
// src/core/sensors/sensor.ts
var $9636818b04ce7da6$export$f5fe6b3a9dfe845b = class extends $9636818b04ce7da6$export$901cf72dabf2112a {
    /**
   * Creates a new sensor instance.
   *
   * @param manager - The drag drop manager instance
   * @param options - Optional sensor configuration
   */ constructor(manager, options){
        super(manager, options);
        this.manager = manager;
        this.options = options;
    }
};
// src/core/sensors/activation.ts
var $9636818b04ce7da6$export$cc3d5f129cc7a240 = class extends AbortController {
    constructor(constraints, onActivate){
        super();
        this.constraints = constraints;
        this.onActivate = onActivate;
        this.activated = false;
        for (const constraint of constraints != null ? constraints : [])constraint.controller = this;
    }
    onEvent(event) {
        var _a;
        if (this.activated) return;
        if ((_a = this.constraints) == null ? void 0 : _a.length) for (const constraint of this.constraints)constraint.onEvent(event);
        else this.activate(event);
    }
    activate(event) {
        if (this.activated) return;
        this.activated = true;
        this.onActivate(event);
    }
    abort(event) {
        this.activated = false;
        super.abort(event);
    }
};
var $9636818b04ce7da6$var$_controller;
var $9636818b04ce7da6$export$6b6cd3704757e071 = class {
    constructor(options){
        this.options = options;
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_controller);
    }
    set controller(controller) {
        $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_controller, controller);
        controller.signal.addEventListener("abort", ()=>this.abort());
    }
    /**
   * Called when the activation is triggered.
   */ activate(event) {
        var _a;
        (_a = $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_controller)) == null || _a.activate(event);
    }
};
$9636818b04ce7da6$var$_controller = new WeakMap();
// src/core/modifiers/modifier.ts
var $9636818b04ce7da6$export$5acd5e6efc9671b7 = class extends $9636818b04ce7da6$export$901cf72dabf2112a {
    /**
   * Creates a new modifier instance.
   *
   * @param manager - The drag and drop manager that owns this modifier
   * @param options - Optional configuration for the modifier
   */ constructor(manager, options){
        super(manager, options);
        this.manager = manager;
        this.options = options;
    }
    /**
   * Applies the modifier to the current drag operation.
   *
   * @param operation - The current state of the drag operation
   * @returns The transformed coordinates
   *
   * @remarks
   * Override this method to implement custom transformation logic.
   * The default implementation returns the original transform unchanged.
   */ apply(operation) {
        return operation.transform;
    }
};
// src/core/manager/registry.ts
var $9636818b04ce7da6$var$DragDropRegistry = class {
    /**
   * Creates a new registry instance.
   *
   * @param manager - The drag and drop manager that owns this registry
   */ constructor(manager){
        /** Registry for draggable entities */ this.draggables = new $9636818b04ce7da6$var$EntityRegistry();
        /** Registry for droppable entities */ this.droppables = new $9636818b04ce7da6$var$EntityRegistry();
        this.plugins = new $9636818b04ce7da6$export$b4b52655520fdbf0(manager);
        this.sensors = new $9636818b04ce7da6$export$b4b52655520fdbf0(manager);
        this.modifiers = new $9636818b04ce7da6$export$b4b52655520fdbf0(manager);
    }
    register(input, options) {
        if (input instanceof $9636818b04ce7da6$export$f2a139e5d18b9882) return this.draggables.register(input.id, input);
        if (input instanceof $9636818b04ce7da6$export$423ec2075359570a) return this.droppables.register(input.id, input);
        if (input.prototype instanceof $9636818b04ce7da6$export$5acd5e6efc9671b7) return this.modifiers.register(input, options);
        if (input.prototype instanceof $9636818b04ce7da6$export$f5fe6b3a9dfe845b) return this.sensors.register(input, options);
        if (input.prototype instanceof $9636818b04ce7da6$export$901cf72dabf2112a) return this.plugins.register(input, options);
        throw new Error("Invalid instance type");
    }
    unregister(input) {
        if (input instanceof $9636818b04ce7da6$var$Entity) {
            if (input instanceof $9636818b04ce7da6$export$f2a139e5d18b9882) return this.draggables.unregister(input.id, input);
            if (input instanceof $9636818b04ce7da6$export$423ec2075359570a) return this.droppables.unregister(input.id, input);
            return ()=>{};
        }
        if (input.prototype instanceof $9636818b04ce7da6$export$5acd5e6efc9671b7) return this.modifiers.unregister(input);
        if (input.prototype instanceof $9636818b04ce7da6$export$f5fe6b3a9dfe845b) return this.sensors.unregister(input);
        if (input.prototype instanceof $9636818b04ce7da6$export$901cf72dabf2112a) return this.plugins.unregister(input);
        throw new Error("Invalid instance type");
    }
    /**
   * Destroys all registered entities and cleans up resources.
   *
   * @remarks
   * This method:
   * - Destroys all draggable and droppable entities
   * - Destroys all plugins, sensors, and modifiers
   * - Cleans up any associated resources
   */ destroy() {
        this.draggables.destroy();
        this.droppables.destroy();
        this.plugins.destroy();
        this.sensors.destroy();
        this.modifiers.destroy();
    }
};
var $9636818b04ce7da6$var$_transform_dec, $9636818b04ce7da6$var$_target_dec, $9636818b04ce7da6$var$_source_dec, $9636818b04ce7da6$var$_modifiers_dec2, $9636818b04ce7da6$var$_targetIdentifier_dec, $9636818b04ce7da6$var$_sourceIdentifier_dec, $9636818b04ce7da6$var$_activatorEvent_dec, $9636818b04ce7da6$var$_canceled_dec, $9636818b04ce7da6$var$_shape_dec2, $9636818b04ce7da6$var$_manager2, $9636818b04ce7da6$var$_previousSource, $9636818b04ce7da6$var$_shape2, $9636818b04ce7da6$var$_init6, $9636818b04ce7da6$var$_canceled, $9636818b04ce7da6$var$_activatorEvent, $9636818b04ce7da6$var$_sourceIdentifier, $9636818b04ce7da6$var$_targetIdentifier, $9636818b04ce7da6$var$_modifiers2, $9636818b04ce7da6$var$_transform;
$9636818b04ce7da6$var$_shape_dec2 = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_canceled_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_activatorEvent_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_sourceIdentifier_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_targetIdentifier_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_modifiers_dec2 = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $9636818b04ce7da6$var$_source_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_target_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $9636818b04ce7da6$var$_transform_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
];
var $9636818b04ce7da6$var$DragOperation = class {
    /**
   * Creates a new drag operation instance.
   *
   * @param manager - The drag and drop manager that owns this operation
   */ constructor(manager){
        $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 5, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_manager2);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_previousSource);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_shape2, new (0, $eb0d2ed00918af28$export$b054dd6fcf79fa19)(void 0, (a, b)=>a && b ? a.equals(b) : a === b));
        /** Current status of the drag operation */ this.status = new $9636818b04ce7da6$export$a170efc9e0947f3f();
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_canceled, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 8, this, false)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 11, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_activatorEvent, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 12, this, null)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 15, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_sourceIdentifier, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 16, this, null)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 19, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_targetIdentifier, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 20, this, null)), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 23, this);
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_modifiers2, $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 24, this, [])), $9636818b04ce7da6$var$__runInitializers($9636818b04ce7da6$var$_init6, 27, this);
        /** Current position of the dragged entity */ this.position = new (0, $ce41d7a96a1e68fd$export$13807d9ee5a34a42)({
            x: 0,
            y: 0
        });
        $9636818b04ce7da6$var$__privateAdd(this, $9636818b04ce7da6$var$_transform, {
            x: 0,
            y: 0
        });
        $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_manager2, manager);
    }
    get shape() {
        const { current: current, initial: initial, previous: previous } = $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_shape2);
        if (!current || !initial) return null;
        return {
            current: current,
            initial: initial,
            previous: previous
        };
    }
    /**
   * Sets the shape of the dragged entity.
   *
   * @param value - The new shape or null to reset
   */ set shape(value) {
        if (!value) $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_shape2).reset();
        else $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_shape2).current = value;
    }
    get source() {
        var _a;
        const identifier = this.sourceIdentifier;
        if (identifier == null) return null;
        const value = $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_manager2).registry.draggables.get(identifier);
        if (value) $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_previousSource, value);
        return (_a = value != null ? value : $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_previousSource)) != null ? _a : null;
    }
    get target() {
        var _a;
        const identifier = this.targetIdentifier;
        return identifier != null ? (_a = $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_manager2).registry.droppables.get(identifier)) != null ? _a : null : null;
    }
    get transform() {
        const { x: x1, y: y } = this.position.delta;
        let transform = {
            x: x1,
            y: y
        };
        for (const modifier of this.modifiers)transform = modifier.apply($9636818b04ce7da6$var$__spreadProps($9636818b04ce7da6$var$__spreadValues({}, this.snapshot()), {
            transform: transform
        }));
        $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_transform, transform);
        return transform;
    }
    /**
   * Creates a snapshot of the current drag operation state.
   *
   * @returns An immutable snapshot of the current operation state
   */ snapshot() {
        return (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>({
                source: this.source,
                target: this.target,
                activatorEvent: this.activatorEvent,
                transform: $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_transform),
                shape: this.shape ? (0, $eb0d2ed00918af28$export$b8801ea43165ed7d)(this.shape) : null,
                position: (0, $eb0d2ed00918af28$export$b8801ea43165ed7d)(this.position),
                status: (0, $eb0d2ed00918af28$export$b8801ea43165ed7d)(this.status),
                canceled: this.canceled
            }));
    }
    /**
   * Resets the drag operation to its initial state.
   *
   * @remarks
   * This method:
   * - Sets status to idle
   * - Clears source and target identifiers
   * - Resets shape history
   * - Resets position and transform
   * - Clears modifiers
   */ reset() {
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            this.status.set("idle" /* Idle */ );
            this.sourceIdentifier = null;
            this.targetIdentifier = null;
            $9636818b04ce7da6$var$__privateGet(this, $9636818b04ce7da6$var$_shape2).reset();
            this.position.reset({
                x: 0,
                y: 0
            });
            $9636818b04ce7da6$var$__privateSet(this, $9636818b04ce7da6$var$_transform, {
                x: 0,
                y: 0
            });
            this.modifiers = [];
        });
    }
};
$9636818b04ce7da6$var$_init6 = $9636818b04ce7da6$var$__decoratorStart(null);
$9636818b04ce7da6$var$_manager2 = new WeakMap();
$9636818b04ce7da6$var$_previousSource = new WeakMap();
$9636818b04ce7da6$var$_shape2 = new WeakMap();
$9636818b04ce7da6$var$_canceled = new WeakMap();
$9636818b04ce7da6$var$_activatorEvent = new WeakMap();
$9636818b04ce7da6$var$_sourceIdentifier = new WeakMap();
$9636818b04ce7da6$var$_targetIdentifier = new WeakMap();
$9636818b04ce7da6$var$_modifiers2 = new WeakMap();
$9636818b04ce7da6$var$_transform = new WeakMap();
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init6, 2, "shape", $9636818b04ce7da6$var$_shape_dec2, $9636818b04ce7da6$var$DragOperation);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init6, 4, "canceled", $9636818b04ce7da6$var$_canceled_dec, $9636818b04ce7da6$var$DragOperation, $9636818b04ce7da6$var$_canceled);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init6, 4, "activatorEvent", $9636818b04ce7da6$var$_activatorEvent_dec, $9636818b04ce7da6$var$DragOperation, $9636818b04ce7da6$var$_activatorEvent);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init6, 4, "sourceIdentifier", $9636818b04ce7da6$var$_sourceIdentifier_dec, $9636818b04ce7da6$var$DragOperation, $9636818b04ce7da6$var$_sourceIdentifier);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init6, 4, "targetIdentifier", $9636818b04ce7da6$var$_targetIdentifier_dec, $9636818b04ce7da6$var$DragOperation, $9636818b04ce7da6$var$_targetIdentifier);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init6, 4, "modifiers", $9636818b04ce7da6$var$_modifiers_dec2, $9636818b04ce7da6$var$DragOperation, $9636818b04ce7da6$var$_modifiers2);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init6, 2, "source", $9636818b04ce7da6$var$_source_dec, $9636818b04ce7da6$var$DragOperation);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init6, 2, "target", $9636818b04ce7da6$var$_target_dec, $9636818b04ce7da6$var$DragOperation);
$9636818b04ce7da6$var$__decorateElement($9636818b04ce7da6$var$_init6, 2, "transform", $9636818b04ce7da6$var$_transform_dec, $9636818b04ce7da6$var$DragOperation);
$9636818b04ce7da6$var$__decoratorMetadata($9636818b04ce7da6$var$_init6, $9636818b04ce7da6$var$DragOperation);
// src/core/manager/renderer.ts
var $9636818b04ce7da6$var$defaultRenderer = {
    get rendering () {
        return Promise.resolve();
    }
};
// src/core/manager/manager.ts
function $9636818b04ce7da6$export$7158c2daed5164d3(value, defaults) {
    if (typeof value === "function") return value(defaults);
    return value != null ? value : defaults;
}
var $9636818b04ce7da6$export$67a2a1e978b42388 = class {
    /**
   * Creates a new drag and drop manager instance.
   *
   * @param config - Optional configuration for plugins, sensors, modifiers, and renderer
   */ constructor(config){
        /**
     * Cleans up resources and stops any active drag operations.
     */ this.destroy = ()=>{
            if (!this.dragOperation.status.idle) this.actions.stop({
                canceled: true
            });
            this.dragOperation.modifiers.forEach((modifier)=>modifier.destroy());
            this.registry.destroy();
            this.collisionObserver.destroy();
        };
        var _a;
        const raw = config != null ? config : {};
        const plugins = $9636818b04ce7da6$export$7158c2daed5164d3(raw.plugins, []);
        const sensors = $9636818b04ce7da6$export$7158c2daed5164d3(raw.sensors, []);
        const modifiers = $9636818b04ce7da6$export$7158c2daed5164d3(raw.modifiers, []);
        const renderer = (_a = raw.renderer) != null ? _a : $9636818b04ce7da6$var$defaultRenderer;
        const monitor = new $9636818b04ce7da6$var$DragDropMonitor(this);
        const registry = new $9636818b04ce7da6$var$DragDropRegistry(this);
        this.registry = registry;
        this.monitor = monitor;
        this.renderer = renderer;
        this.actions = new $9636818b04ce7da6$var$DragActions(this);
        this.dragOperation = new $9636818b04ce7da6$var$DragOperation(this);
        this.collisionObserver = new $9636818b04ce7da6$var$CollisionObserver(this);
        this.plugins = [
            $9636818b04ce7da6$var$CollisionNotifier,
            ...plugins
        ];
        this.modifiers = modifiers;
        this.sensors = sensors;
        const { destroy: destroy } = this;
        const cleanup = (0, $eb0d2ed00918af28$export$fb4689499fb20c56)(()=>{
            var _a2, _b, _c3;
            const currentModifiers = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>this.dragOperation.modifiers);
            const managerModifiers = this.modifiers;
            for (const modifier of currentModifiers)if (!managerModifiers.includes(modifier)) modifier.destroy();
            this.dragOperation.modifiers = (_c3 = (_b = (_a2 = this.dragOperation.source) == null ? void 0 : _a2.modifiers) == null ? void 0 : _b.map((modifier)=>{
                const { plugin: plugin, options: options } = $9636818b04ce7da6$export$480024ae1501d25a(modifier);
                return new plugin(this, options);
            })) != null ? _c3 : managerModifiers;
        });
        this.destroy = ()=>{
            cleanup();
            destroy();
        };
    }
    /**
   * Gets the list of active plugins.
   *
   * @returns Array of active plugin instances
   */ get plugins() {
        return this.registry.plugins.values;
    }
    /**
   * Sets the list of plugins to be used by the manager.
   *
   * @param plugins - Array of plugin constructors or instances
   */ set plugins(plugins) {
        this.registry.plugins.values = plugins;
    }
    /**
   * Gets the list of active modifiers.
   *
   * @returns Array of active modifier instances
   */ get modifiers() {
        return this.registry.modifiers.values;
    }
    /**
   * Sets the list of modifiers to be used by the manager.
   *
   * @param modifiers - Array of modifier constructors or instances
   */ set modifiers(modifiers) {
        this.registry.modifiers.values = modifiers;
    }
    /**
   * Gets the list of active sensors.
   *
   * @returns Array of active sensor instances
   */ get sensors() {
        return this.registry.sensors.values;
    }
    /**
   * Sets the list of sensors to be used by the manager.
   *
   * @param sensors - Array of sensor constructors or instances
   */ set sensors(sensors) {
        this.registry.sensors.values = sensors;
    }
};
 //# sourceMappingURL=index.js.map



var $501f8c524dad2740$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $501f8c524dad2740$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $501f8c524dad2740$var$__typeError("Cannot " + msg);
var $501f8c524dad2740$var$__privateGet = (obj, member, getter)=>($501f8c524dad2740$var$__accessCheck(obj, member, "read from private field"), member.get(obj));
var $501f8c524dad2740$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $501f8c524dad2740$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $501f8c524dad2740$var$__privateSet = (obj, member, value, setter)=>($501f8c524dad2740$var$__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var $501f8c524dad2740$var$__privateMethod = (obj, member, method)=>($501f8c524dad2740$var$__accessCheck(obj, member, "access private method"), method);
// src/utilities/type-guards/isKeyframeEffect.ts
function $501f8c524dad2740$export$e92562c9028cd128(effect) {
    if (!effect) return false;
    if (effect instanceof KeyframeEffect) return true;
    return "getKeyframes" in effect && typeof effect.getKeyframes === "function";
}
// src/utilities/animations/getFinalKeyframe.ts
function $501f8c524dad2740$export$14de59408fad90b(element, match) {
    const animations2 = element.getAnimations();
    let result = null;
    for (const animation of animations2){
        if (animation.playState !== "running") continue;
        const { effect: effect } = animation;
        const keyframes = $501f8c524dad2740$export$e92562c9028cd128(effect) ? effect.getKeyframes() : [];
        const matchedKeyframes = keyframes.filter(match);
        if (matchedKeyframes.length > 0) result = [
            matchedKeyframes[matchedKeyframes.length - 1],
            animation
        ];
    }
    return result;
}
// src/utilities/bounding-rectangle/getBoundingRectangle.ts
function $501f8c524dad2740$export$50877a281fd7d4c4(element) {
    const { width: width, height: height, top: top, left: left, bottom: bottom, right: right } = element.getBoundingClientRect();
    return {
        width: width,
        height: height,
        top: top,
        left: left,
        bottom: bottom,
        right: right
    };
}
// src/utilities/type-guards/isWindow.ts
function $501f8c524dad2740$var$isWindow(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
    elementString === "[object global]";
}
// src/utilities/type-guards/isNode.ts
function $501f8c524dad2740$var$isNode(node) {
    return "nodeType" in node;
}
// src/utilities/execution-context/getWindow.ts
function $501f8c524dad2740$export$38b2d434cce3ea22(target) {
    var _a, _b, _c;
    if (!target) return window;
    if ($501f8c524dad2740$var$isWindow(target)) return target;
    if (!$501f8c524dad2740$var$isNode(target)) return window;
    if ("defaultView" in target) return (_a = target.defaultView) != null ? _a : window;
    return (_c = (_b = target.ownerDocument) == null ? void 0 : _b.defaultView) != null ? _c : window;
}
// src/utilities/type-guards/isDocument.ts
function $501f8c524dad2740$export$62858bae88b53fd0(node) {
    const { Document: Document2 } = $501f8c524dad2740$export$38b2d434cce3ea22(node);
    return node instanceof Document2 || "nodeType" in node && node.nodeType === Node.DOCUMENT_NODE;
}
// src/utilities/type-guards/isHTMLElement.ts
function $501f8c524dad2740$export$1b3bfaa9684536aa(node) {
    if (!node || $501f8c524dad2740$var$isWindow(node)) return false;
    return node instanceof $501f8c524dad2740$export$38b2d434cce3ea22(node).HTMLElement || "namespaceURI" in node && typeof node.namespaceURI === "string" && node.namespaceURI.endsWith("html");
}
// src/utilities/type-guards/isSVGElement.ts
function $501f8c524dad2740$var$isSVGElement(node) {
    return node instanceof $501f8c524dad2740$export$38b2d434cce3ea22(node).SVGElement || "namespaceURI" in node && typeof node.namespaceURI === "string" && node.namespaceURI.endsWith("svg");
}
// src/utilities/execution-context/getDocument.ts
function $501f8c524dad2740$export$f65ca476c09acec0(target) {
    if (!target) return document;
    if ($501f8c524dad2740$var$isWindow(target)) return target.document;
    if (!$501f8c524dad2740$var$isNode(target)) return document;
    if ($501f8c524dad2740$export$62858bae88b53fd0(target)) return target;
    if ($501f8c524dad2740$export$1b3bfaa9684536aa(target) || $501f8c524dad2740$var$isSVGElement(target)) return target.ownerDocument;
    return document;
}
// src/utilities/bounding-rectangle/getViewportBoundingRectangle.ts
function $501f8c524dad2740$export$89e37bf39ea801ef(element) {
    var _a, _b, _c, _d;
    const { documentElement: documentElement } = $501f8c524dad2740$export$f65ca476c09acec0(element);
    const vv = $501f8c524dad2740$export$38b2d434cce3ea22(element).visualViewport;
    const width = (_a = vv == null ? void 0 : vv.width) != null ? _a : documentElement.clientWidth;
    const height = (_b = vv == null ? void 0 : vv.height) != null ? _b : documentElement.clientHeight;
    const top = (_c = vv == null ? void 0 : vv.offsetTop) != null ? _c : 0;
    const left = (_d = vv == null ? void 0 : vv.offsetLeft) != null ? _d : 0;
    return {
        top: top,
        left: left,
        right: left + width,
        bottom: top + height,
        width: width,
        height: height
    };
}
// src/utilities/bounding-rectangle/isOverflowVisible.ts
function $501f8c524dad2740$var$isOverflowVisible(element, style) {
    if ($501f8c524dad2740$var$isDetailsElement(element) && element.open === false) return false;
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = getComputedStyle(element);
    return overflow === "visible" && overflowX === "visible" && overflowY === "visible";
}
function $501f8c524dad2740$var$isDetailsElement(element) {
    return element.tagName === "DETAILS";
}
// src/utilities/bounding-rectangle/getVisibleBoundingRectangle.ts
function $501f8c524dad2740$export$6b7c986976ac6b22(element, boundingClientRect = element.getBoundingClientRect(), margin = 0) {
    var _a, _b, _c, _d, _e;
    let rect = boundingClientRect;
    const { ownerDocument: ownerDocument } = element;
    const ownerWindow = (_a = ownerDocument.defaultView) != null ? _a : window;
    let ancestor = element.parentElement;
    while(ancestor && ancestor !== ownerDocument.documentElement){
        if (!$501f8c524dad2740$var$isOverflowVisible(ancestor)) {
            const ancestorRect = ancestor.getBoundingClientRect();
            const marginTop = margin * (ancestorRect.bottom - ancestorRect.top);
            const marginRight = margin * (ancestorRect.right - ancestorRect.left);
            const marginBottom = margin * (ancestorRect.bottom - ancestorRect.top);
            const marginLeft = margin * (ancestorRect.right - ancestorRect.left);
            rect = {
                top: Math.max(rect.top, ancestorRect.top - marginTop),
                right: Math.min(rect.right, ancestorRect.right + marginRight),
                bottom: Math.min(rect.bottom, ancestorRect.bottom + marginBottom),
                left: Math.max(rect.left, ancestorRect.left - marginLeft),
                width: 0,
                // Will be calculated next
                height: 0
            };
            rect.width = rect.right - rect.left;
            rect.height = rect.bottom - rect.top;
        }
        ancestor = ancestor.parentElement;
    }
    const vv = ownerWindow.visualViewport;
    const viewportTop = (_b = vv == null ? void 0 : vv.offsetTop) != null ? _b : 0;
    const viewportLeft = (_c = vv == null ? void 0 : vv.offsetLeft) != null ? _c : 0;
    const viewportWidth = (_d = vv == null ? void 0 : vv.width) != null ? _d : ownerWindow.innerWidth;
    const viewportHeight = (_e = vv == null ? void 0 : vv.height) != null ? _e : ownerWindow.innerHeight;
    const viewportMarginY = margin * viewportHeight;
    const viewportMarginX = margin * viewportWidth;
    rect = {
        top: Math.max(rect.top, viewportTop - viewportMarginY),
        right: Math.min(rect.right, viewportLeft + viewportWidth + viewportMarginX),
        bottom: Math.min(rect.bottom, viewportTop + viewportHeight + viewportMarginY),
        left: Math.max(rect.left, viewportLeft - viewportMarginX),
        width: 0,
        // Will be calculated next
        height: 0
    };
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    if (rect.width < 0) rect.width = 0;
    if (rect.height < 0) rect.height = 0;
    return rect;
}
// src/utilities/coordinates/getEventCoordinates.ts
function $501f8c524dad2740$export$36195c8aa1517e04(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
// src/utilities/execution-context/canUseDOM.ts
var $501f8c524dad2740$export$71594e8a50f746f4 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
// src/utilities/execution-context/getDocuments.ts
function $501f8c524dad2740$export$782f6f8dc0feb7b3(rootDoc = document, seen = /* @__PURE__ */ new Set()) {
    if (seen.has(rootDoc)) return [];
    seen.add(rootDoc);
    const docs = [
        rootDoc
    ];
    for (const frame of Array.from(rootDoc.querySelectorAll("iframe, frame")))try {
        const childDoc = frame.contentDocument;
        if (childDoc && !seen.has(childDoc)) docs.push(...$501f8c524dad2740$export$782f6f8dc0feb7b3(childDoc, seen));
    } catch (e) {}
    try {
        const win = rootDoc.defaultView;
        if (win && win !== window.top) {
            const parentWin = win.parent;
            if (parentWin && parentWin.document && parentWin.document !== rootDoc) docs.push(...$501f8c524dad2740$export$782f6f8dc0feb7b3(parentWin.document, seen));
        }
    } catch (e) {}
    return docs;
}
// src/utilities/execution-context/isSafari.ts
function $501f8c524dad2740$export$95df08bae54cb4df() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
// src/utilities/execution-context/getFixedPositionOffset.ts
function $501f8c524dad2740$export$e38b62dce8b396f0() {
    var _a, _b;
    const vv = $501f8c524dad2740$export$95df08bae54cb4df() ? window.visualViewport : null;
    return {
        x: (_a = vv == null ? void 0 : vv.offsetLeft) != null ? _a : 0,
        y: (_b = vv == null ? void 0 : vv.offsetTop) != null ? _b : 0
    };
}
// src/utilities/type-guards/isShadowRoot.ts
function $501f8c524dad2740$export$af51f0f06c0f328a(target) {
    if (!target || !$501f8c524dad2740$var$isNode(target)) return false;
    return target instanceof $501f8c524dad2740$export$38b2d434cce3ea22(target).ShadowRoot;
}
// src/utilities/execution-context/getRoot.ts
function $501f8c524dad2740$export$31e4419873013369(target) {
    if (target && $501f8c524dad2740$var$isNode(target)) {
        let root = target.getRootNode();
        if ($501f8c524dad2740$export$af51f0f06c0f328a(root)) return root;
        else if (root instanceof Document) return root;
    }
    return $501f8c524dad2740$export$f65ca476c09acec0(target);
}
// src/utilities/execution-context/prefersReducedMotion.ts
function $501f8c524dad2740$export$ff7706047246b98b(window2) {
    return window2.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
// src/utilities/element/cloneElement.ts
function $501f8c524dad2740$export$e530037191fcd5d7(element) {
    const selector = "input, textarea, select, canvas, [contenteditable]";
    const clonedElement = element.cloneNode(true);
    const fields = Array.from(element.querySelectorAll(selector));
    const clonedFields = Array.from(clonedElement.querySelectorAll(selector));
    clonedFields.forEach((field, index)=>{
        const originalField = fields[index];
        if ($501f8c524dad2740$var$isField(field) && $501f8c524dad2740$var$isField(originalField)) {
            if (field.type !== "file") field.value = originalField.value;
            if (field.type === "radio" && field.name) field.name = `Cloned__${field.name}`;
        }
        if ($501f8c524dad2740$var$isCanvasElement(field) && $501f8c524dad2740$var$isCanvasElement(originalField) && originalField.width > 0 && originalField.height > 0) {
            const destCtx = field.getContext("2d");
            destCtx == null || destCtx.drawImage(originalField, 0, 0);
        }
    });
    return clonedElement;
}
function $501f8c524dad2740$var$isField(element) {
    return "value" in element;
}
function $501f8c524dad2740$var$isCanvasElement(element) {
    return element.tagName === "CANVAS";
}
// src/utilities/element/getElementFromPoint.ts
function $501f8c524dad2740$export$7ec1070137f7ab66(root, { x: x, y: y }) {
    const element = root.elementFromPoint(x, y);
    if ($501f8c524dad2740$var$isIFrameElement(element)) {
        const { contentDocument: contentDocument } = element;
        if (contentDocument) {
            const { left: left, top: top } = element.getBoundingClientRect();
            return $501f8c524dad2740$export$7ec1070137f7ab66(contentDocument, {
                x: x - left,
                y: y - top
            });
        }
    }
    return element;
}
function $501f8c524dad2740$var$isIFrameElement(element) {
    return (element == null ? void 0 : element.tagName) === "IFRAME";
}
// src/utilities/element/proxiedElements.ts
var $501f8c524dad2740$export$83d4521ded5863e3 = /* @__PURE__ */ new WeakMap();
// src/utilities/element/isInteractiveElement.ts
function $501f8c524dad2740$export$3dee5e4542c672d9(element) {
    return Boolean(element.closest(`
      input:not([disabled]),
      select:not([disabled]),
      textarea:not([disabled]),
      button:not([disabled]),
      a[href],
      [contenteditable]:not([contenteditable="false"])
    `));
}
// src/utilities/event-listeners/Listeners.ts
var $501f8c524dad2740$export$3bcecaeba2732bae = class {
    constructor(){
        this.entries = /* @__PURE__ */ new Set();
        this.clear = ()=>{
            for (const entry of this.entries){
                const [target, { type: type, listener: listener, options: options }] = entry;
                target.removeEventListener(type, listener, options);
            }
            this.entries.clear();
        };
    }
    bind(target, input) {
        const eventTargets = Array.isArray(target) ? target : [
            target
        ];
        const listeners = Array.isArray(input) ? input : [
            input
        ];
        const entries = [];
        for (const target2 of eventTargets)for (const descriptor of listeners){
            const { type: type, listener: listener, options: options } = descriptor;
            const entry = [
                target2,
                descriptor
            ];
            target2.addEventListener(type, listener, options);
            this.entries.add(entry);
            entries.push(entry);
        }
        const allEntries = this.entries;
        return function cleanup() {
            for (const entry of entries){
                const [target2, { type: type, listener: listener, options: options }] = entry;
                target2.removeEventListener(type, listener, options);
                allEntries.delete(entry);
            }
        };
    }
};
// src/utilities/frame/getFrameElement.ts
function $501f8c524dad2740$export$7bf1f8740e3e34af(el) {
    const refWindow = el == null ? void 0 : el.ownerDocument.defaultView;
    if (refWindow && refWindow.self !== refWindow.parent) return refWindow.frameElement;
}
// src/utilities/frame/getFrameElements.ts
function $501f8c524dad2740$var$getFrameElements(el) {
    const frames = /* @__PURE__ */ new Set();
    let frame = $501f8c524dad2740$export$7bf1f8740e3e34af(el);
    while(frame){
        frames.add(frame);
        frame = $501f8c524dad2740$export$7bf1f8740e3e34af(frame);
    }
    return frames;
}
// src/utilities/scheduling/timeout.ts
function $501f8c524dad2740$export$83e74882c5df8fe1(callback, duration) {
    const id = setTimeout(callback, duration);
    return ()=>clearTimeout(id);
}
// src/utilities/scheduling/throttle.ts
function $501f8c524dad2740$var$throttle(func, limit) {
    const time = ()=>performance.now();
    let cancel;
    let lastRan;
    return function(...args) {
        const context = this;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = time();
        } else {
            cancel == null || cancel();
            cancel = $501f8c524dad2740$export$83e74882c5df8fe1(()=>{
                func.apply(context, args);
                lastRan = time();
            }, limit - (time() - lastRan));
        }
    };
}
// src/utilities/bounding-rectangle/isRectEqual.ts
function $501f8c524dad2740$var$isRectEqual(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return a.top == b.top && a.left == b.left && a.right == b.right && a.bottom == b.bottom;
}
// src/utilities/bounding-rectangle/isVisible.ts
function $501f8c524dad2740$var$isVisible(element, boundingClientRect = element.getBoundingClientRect()) {
    const { width: width, height: height } = $501f8c524dad2740$export$6b7c986976ac6b22(element, boundingClientRect);
    return width > 0 && height > 0;
}
// src/utilities/observers/ResizeNotifier.ts
var $501f8c524dad2740$var$Observer = $501f8c524dad2740$export$71594e8a50f746f4 ? ResizeObserver : class MockResizeObserver {
    observe() {}
    unobserve() {}
    disconnect() {}
};
var $501f8c524dad2740$var$_initialized;
var $501f8c524dad2740$export$b31816913d29b4b6 = class extends $501f8c524dad2740$var$Observer {
    constructor(callback){
        super((entries)=>{
            if (!$501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_initialized)) {
                $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_initialized, true);
                return;
            }
            callback(entries, this);
        });
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_initialized, false);
    }
};
$501f8c524dad2740$var$_initialized = new WeakMap();
// src/utilities/observers/PositionObserver.ts
var $501f8c524dad2740$var$threshold = Array.from({
    length: 100
}, (_, index)=>index / 100);
var $501f8c524dad2740$var$THROTTLE_INTERVAL = 75;
var $501f8c524dad2740$var$_visible, $501f8c524dad2740$var$_previousBoundingClientRect, $501f8c524dad2740$var$_resizeObserver, $501f8c524dad2740$var$_positionObserver, $501f8c524dad2740$var$_visibilityObserver, $501f8c524dad2740$var$_debug, $501f8c524dad2740$var$_disconnected, $501f8c524dad2740$var$_observePosition, $501f8c524dad2740$var$_PositionObserver_instances, $501f8c524dad2740$var$notify_fn, $501f8c524dad2740$var$updateDebug_fn;
var $501f8c524dad2740$var$PositionObserver = class {
    constructor(element, callback, options = {
        debug: false,
        skipInitial: false
    }){
        this.element = element;
        this.callback = callback;
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_PositionObserver_instances);
        this.disconnect = ()=>{
            var _a, _b, _c;
            $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_disconnected, true);
            (_a = $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_resizeObserver)) == null || _a.disconnect();
            (_b = $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_positionObserver)) == null || _b.disconnect();
            $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_visibilityObserver).disconnect();
            (_c = $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug)) == null || _c.remove();
        };
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_visible, true);
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_previousBoundingClientRect);
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_resizeObserver);
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_positionObserver);
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_visibilityObserver);
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_debug);
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_disconnected, false);
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_observePosition, $501f8c524dad2740$var$throttle(()=>{
            var _a, _b, _c;
            const { element: element } = this;
            (_a = $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_positionObserver)) == null || _a.disconnect();
            if ($501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_disconnected) || !$501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_visible) || !element.isConnected) return;
            const root = (_b = element.ownerDocument) != null ? _b : document;
            const { innerHeight: innerHeight, innerWidth: innerWidth } = (_c = root.defaultView) != null ? _c : window;
            const clientRect = element.getBoundingClientRect();
            const visibleRect = $501f8c524dad2740$export$6b7c986976ac6b22(element, clientRect);
            const { top: top, left: left, bottom: bottom, right: right } = visibleRect;
            const insetTop = -Math.floor(top);
            const insetLeft = -Math.floor(left);
            const insetRight = -Math.floor(innerWidth - right);
            const insetBottom = -Math.floor(innerHeight - bottom);
            const rootMargin = `${insetTop}px ${insetRight}px ${insetBottom}px ${insetLeft}px`;
            this.boundingClientRect = clientRect;
            $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_positionObserver, new IntersectionObserver((entries)=>{
                const [entry] = entries;
                const { intersectionRect: intersectionRect } = entry;
                const intersectionRatio = entry.intersectionRatio !== 1 ? entry.intersectionRatio : (0, $ce41d7a96a1e68fd$export$4617fb02663045ef).intersectionRatio(intersectionRect, $501f8c524dad2740$export$6b7c986976ac6b22(element));
                if (intersectionRatio !== 1) $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_observePosition).call(this);
            }, {
                threshold: $501f8c524dad2740$var$threshold,
                rootMargin: rootMargin,
                root: root
            }));
            $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_positionObserver).observe(element);
            $501f8c524dad2740$var$__privateMethod(this, $501f8c524dad2740$var$_PositionObserver_instances, $501f8c524dad2740$var$notify_fn).call(this);
        }, $501f8c524dad2740$var$THROTTLE_INTERVAL));
        this.boundingClientRect = element.getBoundingClientRect();
        $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_visible, $501f8c524dad2740$var$isVisible(element, this.boundingClientRect));
        let initial = true;
        this.callback = (boundingClientRect)=>{
            if (initial) {
                initial = false;
                if (options.skipInitial) return;
            }
            callback(boundingClientRect);
        };
        const root = element.ownerDocument;
        if (options == null ? void 0 : options.debug) {
            $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_debug, document.createElement("div"));
            $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug).style.background = "rgba(0,0,0,0.15)";
            $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug).style.position = "fixed";
            $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug).style.pointerEvents = "none";
            root.body.appendChild($501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug));
        }
        $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_visibilityObserver, new IntersectionObserver((entries)=>{
            var _a, _b;
            const entry = entries[entries.length - 1];
            const { boundingClientRect: boundingClientRect, isIntersecting: visible } = entry;
            const { width: width, height: height } = boundingClientRect;
            const previousVisible = $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_visible);
            $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_visible, visible);
            if (!width && !height) return;
            if (previousVisible && !visible) {
                (_a = $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_positionObserver)) == null || _a.disconnect();
                this.callback(null);
                (_b = $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_resizeObserver)) == null || _b.disconnect();
                $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_resizeObserver, void 0);
                if ($501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug)) $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug).style.visibility = "hidden";
            } else $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_observePosition).call(this);
            if (visible && !$501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_resizeObserver)) {
                $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_resizeObserver, new $501f8c524dad2740$export$b31816913d29b4b6($501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_observePosition)));
                $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_resizeObserver).observe(element);
            }
        }, {
            threshold: $501f8c524dad2740$var$threshold,
            root: root
        }));
        if ($501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_visible) && !options.skipInitial) this.callback(this.boundingClientRect);
        $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_visibilityObserver).observe(element);
    }
};
$501f8c524dad2740$var$_visible = new WeakMap();
$501f8c524dad2740$var$_previousBoundingClientRect = new WeakMap();
$501f8c524dad2740$var$_resizeObserver = new WeakMap();
$501f8c524dad2740$var$_positionObserver = new WeakMap();
$501f8c524dad2740$var$_visibilityObserver = new WeakMap();
$501f8c524dad2740$var$_debug = new WeakMap();
$501f8c524dad2740$var$_disconnected = new WeakMap();
$501f8c524dad2740$var$_observePosition = new WeakMap();
$501f8c524dad2740$var$_PositionObserver_instances = new WeakSet();
$501f8c524dad2740$var$notify_fn = function() {
    if ($501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_disconnected)) return;
    $501f8c524dad2740$var$__privateMethod(this, $501f8c524dad2740$var$_PositionObserver_instances, $501f8c524dad2740$var$updateDebug_fn).call(this);
    if ($501f8c524dad2740$var$isRectEqual(this.boundingClientRect, $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_previousBoundingClientRect))) return;
    this.callback(this.boundingClientRect);
    $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_previousBoundingClientRect, this.boundingClientRect);
};
$501f8c524dad2740$var$updateDebug_fn = function() {
    if ($501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug)) {
        const { top: top, left: left, width: width, height: height } = $501f8c524dad2740$export$6b7c986976ac6b22(this.element);
        $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug).style.overflow = "hidden";
        $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug).style.visibility = "visible";
        $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug).style.top = `${Math.floor(top)}px`;
        $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug).style.left = `${Math.floor(left)}px`;
        $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug).style.width = `${Math.floor(width)}px`;
        $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_debug).style.height = `${Math.floor(height)}px`;
    }
};
// src/utilities/observers/FrameObserver.ts
var $501f8c524dad2740$var$framePositionObservers = /* @__PURE__ */ new WeakMap();
var $501f8c524dad2740$var$scrollListeners = /* @__PURE__ */ new WeakMap();
function $501f8c524dad2740$var$addFrameListener(frame, callback) {
    let cached = $501f8c524dad2740$var$framePositionObservers.get(frame);
    if (!cached) {
        const observer = new $501f8c524dad2740$var$PositionObserver(frame, (boundingClientRect)=>{
            const cached2 = $501f8c524dad2740$var$framePositionObservers.get(frame);
            if (!cached2) return;
            cached2.callbacks.forEach((callback2)=>callback2(boundingClientRect));
        }, {
            skipInitial: true
        });
        cached = {
            disconnect: observer.disconnect,
            callbacks: /* @__PURE__ */ new Set()
        };
    }
    cached.callbacks.add(callback);
    $501f8c524dad2740$var$framePositionObservers.set(frame, cached);
    return ()=>{
        cached.callbacks.delete(callback);
        if (cached.callbacks.size === 0) {
            $501f8c524dad2740$var$framePositionObservers.delete(frame);
            cached.disconnect();
        }
    };
}
function $501f8c524dad2740$var$observeParentFrames(frames, callback) {
    const cleanup = /* @__PURE__ */ new Set();
    for (const frame of frames){
        const remove = $501f8c524dad2740$var$addFrameListener(frame, callback);
        cleanup.add(remove);
    }
    return ()=>cleanup.forEach((remove)=>remove());
}
function $501f8c524dad2740$var$addScrollListener(element, callback) {
    var _a;
    const doc = element.ownerDocument;
    if (!$501f8c524dad2740$var$scrollListeners.has(doc)) {
        const controller = new AbortController();
        const listeners2 = /* @__PURE__ */ new Set();
        document.addEventListener("scroll", (event)=>listeners2.forEach((listener)=>listener(event)), {
            capture: true,
            passive: true,
            signal: controller.signal
        });
        $501f8c524dad2740$var$scrollListeners.set(doc, {
            disconnect: ()=>controller.abort(),
            listeners: listeners2
        });
    }
    const { listeners: listeners, disconnect: disconnect } = (_a = $501f8c524dad2740$var$scrollListeners.get(doc)) != null ? _a : {};
    if (!listeners || !disconnect) return ()=>{};
    listeners.add(callback);
    return ()=>{
        listeners.delete(callback);
        if (listeners.size === 0) {
            disconnect();
            $501f8c524dad2740$var$scrollListeners.delete(doc);
        }
    };
}
var $501f8c524dad2740$var$_elementObserver, $501f8c524dad2740$var$_disconnected2, $501f8c524dad2740$var$_frames, $501f8c524dad2740$var$_handleScroll;
var $501f8c524dad2740$export$4c9bdd7ce9d9c507 = class {
    constructor(element, callback, options){
        this.callback = callback;
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_elementObserver);
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_disconnected2, false);
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_frames);
        $501f8c524dad2740$var$__privateAdd(this, $501f8c524dad2740$var$_handleScroll, $501f8c524dad2740$var$throttle((event)=>{
            if ($501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_disconnected2)) return;
            if (!event.target) return;
            if ("contains" in event.target && typeof event.target.contains === "function") {
                for (const frame of $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_frames))if (event.target.contains(frame)) {
                    this.callback($501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_elementObserver).boundingClientRect);
                    break;
                }
            }
        }, $501f8c524dad2740$var$THROTTLE_INTERVAL));
        const frames = $501f8c524dad2740$var$getFrameElements(element);
        const unobserveParentFrames = $501f8c524dad2740$var$observeParentFrames(frames, callback);
        const removeScrollListener = $501f8c524dad2740$var$addScrollListener(element, $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_handleScroll));
        $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_frames, frames);
        $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_elementObserver, new $501f8c524dad2740$var$PositionObserver(element, callback, options));
        this.disconnect = ()=>{
            if ($501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_disconnected2)) return;
            $501f8c524dad2740$var$__privateSet(this, $501f8c524dad2740$var$_disconnected2, true);
            unobserveParentFrames();
            removeScrollListener();
            $501f8c524dad2740$var$__privateGet(this, $501f8c524dad2740$var$_elementObserver).disconnect();
        };
    }
};
$501f8c524dad2740$var$_elementObserver = new WeakMap();
$501f8c524dad2740$var$_disconnected2 = new WeakMap();
$501f8c524dad2740$var$_frames = new WeakMap();
$501f8c524dad2740$var$_handleScroll = new WeakMap();
// src/utilities/popover/supportsPopover.ts
function $501f8c524dad2740$export$1150b66d0ff92823(element) {
    return "showPopover" in element && "hidePopover" in element && typeof element.showPopover === "function" && typeof element.hidePopover === "function";
}
// src/utilities/popover/showPopover.ts
function $501f8c524dad2740$export$609054a8611e50dd(element) {
    try {
        if ($501f8c524dad2740$export$1150b66d0ff92823(element) && element.isConnected && element.hasAttribute("popover") && // This selector can throw an error in browsers that don't support it
        !element.matches(":popover-open")) element.showPopover();
    } catch (error) {}
}
// src/utilities/popover/hidePopover.ts
function $501f8c524dad2740$export$f932c2371bffebce(element) {
    try {
        if ($501f8c524dad2740$export$1150b66d0ff92823(element) && element.isConnected && element.hasAttribute("popover") && // This selector can throw an error in browsers that don't support it
        element.matches(":popover-open")) element.hidePopover();
    } catch (error) {}
}
// src/utilities/scroll/documentScrollingElement.ts
function $501f8c524dad2740$export$db8773f0857097d3(element) {
    if (!$501f8c524dad2740$export$71594e8a50f746f4 || !element) return false;
    return element === $501f8c524dad2740$export$f65ca476c09acec0(element).scrollingElement;
}
// src/utilities/scroll/getScrollPosition.ts
function $501f8c524dad2740$var$getScrollPosition(scrollableElement) {
    var _a, _b;
    const window2 = $501f8c524dad2740$export$38b2d434cce3ea22(scrollableElement);
    const rect = $501f8c524dad2740$export$db8773f0857097d3(scrollableElement) ? $501f8c524dad2740$export$89e37bf39ea801ef(scrollableElement) : $501f8c524dad2740$export$50877a281fd7d4c4(scrollableElement);
    const vv = window2.visualViewport;
    const dimensions = $501f8c524dad2740$export$db8773f0857097d3(scrollableElement) ? {
        height: (_a = vv == null ? void 0 : vv.height) != null ? _a : window2.innerHeight,
        width: (_b = vv == null ? void 0 : vv.width) != null ? _b : window2.innerWidth
    } : {
        height: scrollableElement.clientHeight,
        width: scrollableElement.clientWidth
    };
    const position = {
        current: {
            x: scrollableElement.scrollLeft,
            y: scrollableElement.scrollTop
        },
        max: {
            x: scrollableElement.scrollWidth - dimensions.width,
            y: scrollableElement.scrollHeight - dimensions.height
        }
    };
    const isTop = position.current.y <= 0;
    const isLeft = position.current.x <= 0;
    const isBottom = position.current.y >= position.max.y;
    const isRight = position.current.x >= position.max.x;
    return {
        rect: rect,
        position: position,
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight
    };
}
// src/utilities/scroll/canScroll.ts
function $501f8c524dad2740$export$49f2cecc68ed63a1(scrollableElement, by) {
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight, position: position } = $501f8c524dad2740$var$getScrollPosition(scrollableElement);
    const { x: x, y: y } = by != null ? by : {
        x: 0,
        y: 0
    };
    const top = !isTop && position.current.y + y > 0;
    const bottom = !isBottom && position.current.y + y < position.max.y;
    const left = !isLeft && position.current.x + x > 0;
    const right = !isRight && position.current.x + x < position.max.x;
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        x: left || right,
        y: top || bottom
    };
}
// src/utilities/scheduling/scheduler.ts
var $501f8c524dad2740$export$d3e54bb8584cda7c = class {
    constructor(scheduler4){
        this.scheduler = scheduler4;
        this.pending = false;
        this.tasks = /* @__PURE__ */ new Set();
        this.resolvers = /* @__PURE__ */ new Set();
        this.flush = ()=>{
            const { tasks: tasks, resolvers: resolvers } = this;
            this.pending = false;
            this.tasks = /* @__PURE__ */ new Set();
            this.resolvers = /* @__PURE__ */ new Set();
            for (const task of tasks)task();
            for (const resolve of resolvers)resolve();
        };
    }
    schedule(task) {
        this.tasks.add(task);
        if (!this.pending) {
            this.pending = true;
            this.scheduler(this.flush);
        }
        return new Promise((resolve)=>this.resolvers.add(resolve));
    }
};
var $501f8c524dad2740$export$d30788f2c20241cd = new $501f8c524dad2740$export$d3e54bb8584cda7c((callback)=>{
    if (typeof requestAnimationFrame === "function") requestAnimationFrame(callback);
    else callback();
});
// src/utilities/styles/getComputedStyles.ts
var $501f8c524dad2740$var$scheduler2 = new $501f8c524dad2740$export$d3e54bb8584cda7c((callback)=>setTimeout(callback, 50));
var $501f8c524dad2740$var$cachedStyles = /* @__PURE__ */ new Map();
var $501f8c524dad2740$var$clear = $501f8c524dad2740$var$cachedStyles.clear.bind($501f8c524dad2740$var$cachedStyles);
function $501f8c524dad2740$export$8ef593ce41855f7f(element, cached = false) {
    if (!cached) return $501f8c524dad2740$var$computeStyles(element);
    let styles = $501f8c524dad2740$var$cachedStyles.get(element);
    if (styles) return styles;
    styles = $501f8c524dad2740$var$computeStyles(element);
    $501f8c524dad2740$var$cachedStyles.set(element, styles);
    $501f8c524dad2740$var$scheduler2.schedule($501f8c524dad2740$var$clear);
    return styles;
}
function $501f8c524dad2740$var$computeStyles(element) {
    return $501f8c524dad2740$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
// src/utilities/scroll/isFixed.ts
function $501f8c524dad2740$var$isFixed(node, computedStyle = $501f8c524dad2740$export$8ef593ce41855f7f(node, true)) {
    return computedStyle.position === "fixed" || computedStyle.position === "sticky";
}
// src/utilities/scroll/isScrollable.ts
function $501f8c524dad2740$var$isScrollable(element, computedStyle = $501f8c524dad2740$export$8ef593ce41855f7f(element, true)) {
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        "overflow",
        "overflowX",
        "overflowY"
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === "string" ? overflowRegex.test(value) : false;
    });
}
// src/utilities/scroll/getScrollableAncestors.ts
var $501f8c524dad2740$var$defaultOptions = {
    excludeElement: true,
    escapeShadowDOM: true
};
function $501f8c524dad2740$export$e4864aa91b5ed091(element, options = $501f8c524dad2740$var$defaultOptions) {
    const { limit: limit, excludeElement: excludeElement, escapeShadowDOM: escapeShadowDOM } = options;
    const scrollParents = /* @__PURE__ */ new Set();
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.size >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ($501f8c524dad2740$export$62858bae88b53fd0(node) && node.scrollingElement != null && !scrollParents.has(node.scrollingElement)) {
            scrollParents.add(node.scrollingElement);
            return scrollParents;
        }
        if (escapeShadowDOM && $501f8c524dad2740$export$af51f0f06c0f328a(node)) return findScrollableAncestors(node.host);
        if (!$501f8c524dad2740$export$1b3bfaa9684536aa(node)) {
            if ($501f8c524dad2740$var$isSVGElement(node)) return findScrollableAncestors(node.parentElement);
            return scrollParents;
        }
        if (scrollParents.has(node)) return scrollParents;
        const computedStyle = $501f8c524dad2740$export$8ef593ce41855f7f(node, true);
        if (excludeElement && node === element) ;
        else if ($501f8c524dad2740$var$isScrollable(node, computedStyle)) scrollParents.add(node);
        if ($501f8c524dad2740$var$isFixed(node, computedStyle)) {
            const { scrollingElement: scrollingElement } = node.ownerDocument;
            if (scrollingElement) scrollParents.add(scrollingElement);
            return scrollParents;
        }
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $501f8c524dad2740$export$327d73f058fca947(node) {
    const [firstScrollableAncestor] = $501f8c524dad2740$export$e4864aa91b5ed091(node, {
        limit: 1
    });
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
// src/utilities/frame/getFrameTransform.ts
function $501f8c524dad2740$export$f7bade9204ccdfdf(el, boundary = window.frameElement) {
    const transform = {
        x: 0,
        y: 0,
        scaleX: 1,
        scaleY: 1
    };
    if (!el) return transform;
    let frame = $501f8c524dad2740$export$7bf1f8740e3e34af(el);
    while(frame){
        if (frame === boundary) return transform;
        const rect = $501f8c524dad2740$export$50877a281fd7d4c4(frame);
        const { x: scaleX, y: scaleY } = $501f8c524dad2740$var$getScale(frame, rect);
        transform.x = transform.x + rect.left;
        transform.y = transform.y + rect.top;
        transform.scaleX = transform.scaleX * scaleX;
        transform.scaleY = transform.scaleY * scaleY;
        frame = $501f8c524dad2740$export$7bf1f8740e3e34af(frame);
    }
    return transform;
}
function $501f8c524dad2740$var$getScale(element, boundingRectangle = $501f8c524dad2740$export$50877a281fd7d4c4(element)) {
    const width = Math.round(boundingRectangle.width);
    const height = Math.round(boundingRectangle.height);
    if ($501f8c524dad2740$export$1b3bfaa9684536aa(element)) return {
        x: width / element.offsetWidth,
        y: height / element.offsetHeight
    };
    const styles = $501f8c524dad2740$export$8ef593ce41855f7f(element, true);
    return {
        x: (parseFloat(styles.width) || width) / width,
        y: (parseFloat(styles.height) || height) / height
    };
}
// src/utilities/transform/parseScale.ts
function $501f8c524dad2740$var$parseScale(scale) {
    if (scale === "none") return null;
    const values = scale.split(" ");
    const x = parseFloat(values[0]);
    const y = parseFloat(values[1]);
    if (isNaN(x) && isNaN(y)) return null;
    return {
        x: isNaN(x) ? y : x,
        y: isNaN(y) ? x : y
    };
}
// src/utilities/transform/parseTranslate.ts
function $501f8c524dad2740$export$8ea33f091e4ee473(translate) {
    if (translate === "none") return null;
    const [x, y, z = "0"] = translate.split(" ");
    const output = {
        x: parseFloat(x),
        y: parseFloat(y),
        z: parseInt(z, 10)
    };
    if (isNaN(output.x) && isNaN(output.y)) return null;
    return {
        x: isNaN(output.x) ? 0 : output.x,
        y: isNaN(output.y) ? 0 : output.y,
        z: isNaN(output.z) ? 0 : output.z
    };
}
// src/utilities/transform/parseTransform.ts
function $501f8c524dad2740$export$99f660e5a014b917(computedStyles) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    const { scale: scale, transform: transform, translate: translate } = computedStyles;
    const parsedScale = $501f8c524dad2740$var$parseScale(scale);
    const parsedTranslate = $501f8c524dad2740$export$8ea33f091e4ee473(translate);
    const parsedMatrix = $501f8c524dad2740$var$parseTransformMatrix(transform);
    if (!parsedMatrix && !parsedScale && !parsedTranslate) return null;
    const normalizedScale = {
        x: (_a = parsedScale == null ? void 0 : parsedScale.x) != null ? _a : 1,
        y: (_b = parsedScale == null ? void 0 : parsedScale.y) != null ? _b : 1
    };
    const normalizedTranslate = {
        x: (_c = parsedTranslate == null ? void 0 : parsedTranslate.x) != null ? _c : 0,
        y: (_d = parsedTranslate == null ? void 0 : parsedTranslate.y) != null ? _d : 0
    };
    const normalizedMatrix = {
        x: (_e = parsedMatrix == null ? void 0 : parsedMatrix.x) != null ? _e : 0,
        y: (_f = parsedMatrix == null ? void 0 : parsedMatrix.y) != null ? _f : 0,
        scaleX: (_g = parsedMatrix == null ? void 0 : parsedMatrix.scaleX) != null ? _g : 1,
        scaleY: (_h = parsedMatrix == null ? void 0 : parsedMatrix.scaleY) != null ? _h : 1
    };
    return {
        x: normalizedTranslate.x + normalizedMatrix.x,
        y: normalizedTranslate.y + normalizedMatrix.y,
        z: (_i = parsedTranslate == null ? void 0 : parsedTranslate.z) != null ? _i : 0,
        scaleX: normalizedScale.x * normalizedMatrix.scaleX,
        scaleY: normalizedScale.y * normalizedMatrix.scaleY
    };
}
function $501f8c524dad2740$var$parseTransformMatrix(transform) {
    if (transform.startsWith("matrix3d(")) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith("matrix(")) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
// src/utilities/scroll/detectScrollIntent.ts
var $501f8c524dad2740$export$ef1760368e0f70e4 = /* @__PURE__ */ ((ScrollDirection2)=>{
    ScrollDirection2[ScrollDirection2["Idle"] = 0] = "Idle";
    ScrollDirection2[ScrollDirection2["Forward"] = 1] = "Forward";
    ScrollDirection2[ScrollDirection2["Reverse"] = -1] = "Reverse";
    return ScrollDirection2;
})($501f8c524dad2740$export$ef1760368e0f70e4 || {});
var $501f8c524dad2740$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
var $501f8c524dad2740$var$defaultTolerance = {
    x: 10,
    y: 10
};
function $501f8c524dad2740$export$68d0a9072bb41c7d(scrollableElement, coordinates, intent, acceleration = 25, thresholdPercentage = $501f8c524dad2740$var$defaultThreshold, tolerance = $501f8c524dad2740$var$defaultTolerance) {
    const { x: x, y: y } = coordinates;
    const { rect: rect, isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $501f8c524dad2740$var$getScrollPosition(scrollableElement);
    const frameTransform = $501f8c524dad2740$export$f7bade9204ccdfdf(scrollableElement);
    const computedStyles = $501f8c524dad2740$export$8ef593ce41855f7f(scrollableElement, true);
    const parsedTransform = $501f8c524dad2740$export$99f660e5a014b917(computedStyles);
    const isXAxisInverted = parsedTransform !== null ? (parsedTransform == null ? void 0 : parsedTransform.scaleX) < 0 : false;
    const isYAxisInverted = parsedTransform !== null ? (parsedTransform == null ? void 0 : parsedTransform.scaleY) < 0 : false;
    const scrollContainerRect = new (0, $ce41d7a96a1e68fd$export$4617fb02663045ef)(rect.left * frameTransform.scaleX + frameTransform.x, rect.top * frameTransform.scaleY + frameTransform.y, rect.width * frameTransform.scaleX, rect.height * frameTransform.scaleY);
    const direction = {
        x: 0 /* Idle */ ,
        y: 0 /* Idle */ 
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold2 = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (threshold2.height > 0 && (!isTop || isYAxisInverted && !isBottom) && y <= scrollContainerRect.top + threshold2.height && (intent == null ? void 0 : intent.y) !== 1 /* Forward */  && x >= scrollContainerRect.left - tolerance.x && x <= scrollContainerRect.right + tolerance.x) {
        direction.y = isYAxisInverted ? 1 /* Forward */  : -1 /* Reverse */ ;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold2.height - y) / threshold2.height);
    } else if (threshold2.height > 0 && (!isBottom || isYAxisInverted && !isTop) && y >= scrollContainerRect.bottom - threshold2.height && (intent == null ? void 0 : intent.y) !== -1 /* Reverse */  && x >= scrollContainerRect.left - tolerance.x && x <= scrollContainerRect.right + tolerance.x) {
        direction.y = isYAxisInverted ? -1 /* Reverse */  : 1 /* Forward */ ;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold2.height - y) / threshold2.height);
    }
    if (threshold2.width > 0 && (!isRight || isXAxisInverted && !isLeft) && x >= scrollContainerRect.right - threshold2.width && (intent == null ? void 0 : intent.x) !== -1 /* Reverse */  && y >= scrollContainerRect.top - tolerance.y && y <= scrollContainerRect.bottom + tolerance.y) {
        direction.x = isXAxisInverted ? -1 /* Reverse */  : 1 /* Forward */ ;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold2.width - x) / threshold2.width);
    } else if (threshold2.width > 0 && (!isLeft || isXAxisInverted && !isRight) && x <= scrollContainerRect.left + threshold2.width && (intent == null ? void 0 : intent.x) !== 1 /* Forward */  && y >= scrollContainerRect.top - tolerance.y && y <= scrollContainerRect.bottom + tolerance.y) {
        direction.x = isXAxisInverted ? 1 /* Forward */  : -1 /* Reverse */ ;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold2.width - x) / threshold2.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
// src/utilities/scroll/scrollIntoViewIfNeeded.ts
function $501f8c524dad2740$export$9657601bf1e130ee(el, { block: block = "nearest", inline: inline = "nearest" } = {}) {
    if (!$501f8c524dad2740$export$1b3bfaa9684536aa(el)) return;
    const scrollableAncestors = $501f8c524dad2740$export$e4864aa91b5ed091(el);
    const processedAncestors = [];
    for (const ancestor of scrollableAncestors){
        if (!$501f8c524dad2740$export$1b3bfaa9684536aa(ancestor)) continue;
        const { top: top, left: left } = $501f8c524dad2740$var$getOffsetRelativeTo(el, ancestor);
        let adjustedTop = top;
        let adjustedLeft = left;
        for (const inner of processedAncestors){
            adjustedTop -= inner.scrollTop;
            adjustedLeft -= inner.scrollLeft;
        }
        if (block !== "none") {
            const overTop = adjustedTop < ancestor.scrollTop;
            const overBottom = adjustedTop + el.offsetHeight > ancestor.scrollTop + ancestor.clientHeight;
            if (overTop !== overBottom) {
                if (block === "center") ancestor.scrollTop = adjustedTop - ancestor.clientHeight / 2 + el.offsetHeight / 2;
                else if (overTop) ancestor.scrollTop = adjustedTop;
                else ancestor.scrollTop = adjustedTop + el.offsetHeight - ancestor.clientHeight;
            }
        }
        if (inline !== "none") {
            const overLeft = adjustedLeft < ancestor.scrollLeft;
            const overRight = adjustedLeft + el.offsetWidth > ancestor.scrollLeft + ancestor.clientWidth;
            if (overLeft !== overRight) {
                if (inline === "center") ancestor.scrollLeft = adjustedLeft - ancestor.clientWidth / 2 + el.offsetWidth / 2;
                else if (overLeft) ancestor.scrollLeft = adjustedLeft;
                else ancestor.scrollLeft = adjustedLeft + el.offsetWidth - ancestor.clientWidth;
            }
        }
        processedAncestors.push(ancestor);
    }
}
function $501f8c524dad2740$var$getDocumentOffset(element) {
    let top = 0;
    let left = 0;
    let current = element;
    while(current){
        top += current.offsetTop;
        left += current.offsetLeft;
        const offsetParent = current.offsetParent;
        if (!$501f8c524dad2740$export$1b3bfaa9684536aa(offsetParent)) break;
        top += offsetParent.clientTop;
        left += offsetParent.clientLeft;
        current = offsetParent;
    }
    return {
        top: top,
        left: left
    };
}
function $501f8c524dad2740$var$getOffsetRelativeTo(element, ancestor) {
    const elOffset = $501f8c524dad2740$var$getDocumentOffset(element);
    const ancestorOffset = $501f8c524dad2740$var$getDocumentOffset(ancestor);
    return {
        top: elOffset.top - ancestorOffset.top - ancestor.clientTop,
        left: elOffset.left - ancestorOffset.left - ancestor.clientLeft
    };
}
// src/utilities/transform/applyTransform.ts
function $501f8c524dad2740$var$applyTransform(rect, parsedTransform, transformOrigin) {
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left + translateX + (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top + translateY + (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
    const w = scaleX ? rect.width * scaleX : rect.width;
    const h = scaleY ? rect.height * scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
// src/utilities/transform/inverseTransform.ts
function $501f8c524dad2740$export$258423732cecc204(rect, parsedTransform, transformOrigin) {
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
// src/utilities/transform/animateTransform.ts
function $501f8c524dad2740$export$729fc4eb9847864b({ element: element, keyframes: keyframes, options: options }) {
    return element.animate(keyframes, options).finished;
}
// src/utilities/transform/computeTranslate.ts
function $501f8c524dad2740$export$512056b882a0a591(element, translate = $501f8c524dad2740$export$8ef593ce41855f7f(element).translate, projected = true) {
    if (projected) {
        const keyframe = $501f8c524dad2740$export$14de59408fad90b(element, (keyframe2)=>"translate" in keyframe2);
        if (keyframe) {
            const { translate: translate2 = "" } = keyframe[0];
            if (typeof translate2 === "string") {
                const finalTranslate = $501f8c524dad2740$export$8ea33f091e4ee473(translate2);
                if (finalTranslate) return finalTranslate;
            }
        }
    }
    if (translate) {
        const finalTranslate = $501f8c524dad2740$export$8ea33f091e4ee473(translate);
        if (finalTranslate) return finalTranslate;
    }
    return {
        x: 0,
        y: 0,
        z: 0
    };
}
// src/utilities/animations/forceFinishAnimations.ts
var $501f8c524dad2740$var$scheduler3 = new $501f8c524dad2740$export$d3e54bb8584cda7c((callback)=>setTimeout(callback, 0));
var $501f8c524dad2740$var$animations = /* @__PURE__ */ new Map();
var $501f8c524dad2740$var$clear2 = $501f8c524dad2740$var$animations.clear.bind($501f8c524dad2740$var$animations);
function $501f8c524dad2740$var$getDocumentAnimations(element) {
    const document2 = element.ownerDocument;
    let documentAnimations = $501f8c524dad2740$var$animations.get(document2);
    if (documentAnimations) return documentAnimations;
    documentAnimations = document2.getAnimations();
    $501f8c524dad2740$var$animations.set(document2, documentAnimations);
    $501f8c524dad2740$var$scheduler3.schedule($501f8c524dad2740$var$clear2);
    const elementAnimations = documentAnimations.filter((animation)=>$501f8c524dad2740$export$e92562c9028cd128(animation.effect) && animation.effect.target === element);
    $501f8c524dad2740$var$animations.set(element, elementAnimations);
    return documentAnimations;
}
function $501f8c524dad2740$var$forceFinishAnimations(element, options) {
    const animations2 = $501f8c524dad2740$var$getDocumentAnimations(element).filter((animation)=>{
        var _a, _b;
        if ($501f8c524dad2740$export$e92562c9028cd128(animation.effect)) {
            const { target: target } = animation.effect;
            const isValidTarget = (_b = target && ((_a = options.isValidTarget) == null ? void 0 : _a.call(options, target))) != null ? _b : true;
            if (isValidTarget) return animation.effect.getKeyframes().some((keyframe)=>{
                for (const property of options.properties){
                    if (keyframe[property]) return true;
                }
            });
        }
    }).map((animation)=>{
        const { effect: effect, currentTime: currentTime } = animation;
        const duration = effect == null ? void 0 : effect.getComputedTiming().duration;
        if (animation.pending || animation.playState === "finished") return;
        if (typeof duration == "number" && typeof currentTime == "number" && currentTime < duration) {
            animation.currentTime = duration;
            return ()=>{
                animation.currentTime = currentTime;
            };
        }
    });
    if (animations2.length > 0) return ()=>animations2.forEach((reset)=>reset == null ? void 0 : reset());
}
// src/utilities/shapes/DOMRectangle.ts
var $501f8c524dad2740$export$9be488f2d210405c = class extends (0, $ce41d7a96a1e68fd$export$4617fb02663045ef) {
    constructor(element, options = {}){
        var _a, _b, _c, _d;
        const { frameTransform: frameTransform = $501f8c524dad2740$export$f7bade9204ccdfdf(element), ignoreTransforms: ignoreTransforms, getBoundingClientRect: getBoundingClientRect = $501f8c524dad2740$export$50877a281fd7d4c4 } = options;
        const resetAnimations = $501f8c524dad2740$var$forceFinishAnimations(element, {
            properties: [
                "transform",
                "translate",
                "scale",
                "width",
                "height"
            ],
            isValidTarget: (target)=>(target !== element || $501f8c524dad2740$export$95df08bae54cb4df()) && target.contains(element)
        });
        const boundingRectangle = getBoundingClientRect(element);
        let { top: top, left: left, width: width, height: height } = boundingRectangle;
        let updated;
        const computedStyles = $501f8c524dad2740$export$8ef593ce41855f7f(element);
        const parsedTransform = $501f8c524dad2740$export$99f660e5a014b917(computedStyles);
        const scale = {
            x: (_a = parsedTransform == null ? void 0 : parsedTransform.scaleX) != null ? _a : 1,
            y: (_b = parsedTransform == null ? void 0 : parsedTransform.scaleY) != null ? _b : 1
        };
        const projectedTransform = $501f8c524dad2740$var$getProjectedTransform(element, computedStyles);
        resetAnimations == null || resetAnimations();
        if (parsedTransform) {
            updated = $501f8c524dad2740$export$258423732cecc204(boundingRectangle, parsedTransform, computedStyles.transformOrigin);
            if (ignoreTransforms || projectedTransform) {
                top = updated.top;
                left = updated.left;
                width = updated.width;
                height = updated.height;
            }
        }
        const intrinsic = {
            width: (_c = updated == null ? void 0 : updated.width) != null ? _c : width,
            height: (_d = updated == null ? void 0 : updated.height) != null ? _d : height
        };
        if (projectedTransform && !ignoreTransforms && updated) {
            const projected = $501f8c524dad2740$var$applyTransform(updated, projectedTransform, computedStyles.transformOrigin);
            top = projected.top;
            left = projected.left;
            width = projected.width;
            height = projected.height;
            scale.x = projectedTransform.scaleX;
            scale.y = projectedTransform.scaleY;
        }
        if (frameTransform) {
            if (!ignoreTransforms) {
                left *= frameTransform.scaleX;
                width *= frameTransform.scaleX;
                top *= frameTransform.scaleY;
                height *= frameTransform.scaleY;
            }
            left += frameTransform.x;
            top += frameTransform.y;
        }
        super(left, top, width, height);
        this.scale = scale;
        this.intrinsicWidth = intrinsic.width;
        this.intrinsicHeight = intrinsic.height;
    }
};
function $501f8c524dad2740$var$getProjectedTransform(element, computedStyles) {
    const animations2 = element.getAnimations();
    if (!animations2.length) return null;
    let latestTransform;
    let latestTranslate;
    let latestScale;
    let hasAnimatedProperty = false;
    for (const animation of animations2){
        if (animation.playState !== "running") continue;
        const keyframes = $501f8c524dad2740$export$e92562c9028cd128(animation.effect) ? animation.effect.getKeyframes() : [];
        const keyframe = keyframes[keyframes.length - 1];
        if (!keyframe) continue;
        const { transform: transform, translate: translate, scale: scale } = keyframe;
        if (typeof transform === "string" && transform) {
            latestTransform = transform;
            hasAnimatedProperty = true;
        }
        if (typeof translate === "string" && translate) {
            latestTranslate = translate;
            hasAnimatedProperty = true;
        }
        if (typeof scale === "string" && scale) {
            latestScale = scale;
            hasAnimatedProperty = true;
        }
    }
    if (!hasAnimatedProperty) return null;
    return $501f8c524dad2740$export$99f660e5a014b917({
        transform: latestTransform != null ? latestTransform : computedStyles.transform,
        translate: latestTranslate != null ? latestTranslate : computedStyles.translate,
        scale: latestScale != null ? latestScale : computedStyles.scale
    });
}
// src/utilities/type-guards/supportsStyle.ts
function $501f8c524dad2740$export$10ef5a77b4923a6a(element) {
    return "style" in element && typeof element.style === "object" && element.style !== null && "setProperty" in element.style && "removeProperty" in element.style && typeof element.style.setProperty === "function" && typeof element.style.removeProperty === "function";
}
// src/utilities/styles/Styles.ts
var $501f8c524dad2740$export$e155666bf54a9f18 = class {
    constructor(element){
        this.element = element;
        this.initial = /* @__PURE__ */ new Map();
    }
    set(properties, prefix = "") {
        const { element: element } = this;
        if (!$501f8c524dad2740$export$10ef5a77b4923a6a(element)) return;
        for (const [key, value] of Object.entries(properties)){
            const property = `${prefix}${key}`;
            if (!this.initial.has(property)) this.initial.set(property, element.style.getPropertyValue(property));
            element.style.setProperty(property, typeof value === "string" ? value : `${value}px`);
        }
    }
    remove(properties, prefix = "") {
        const { element: element } = this;
        if (!$501f8c524dad2740$export$10ef5a77b4923a6a(element)) return;
        for (const key of properties){
            const property = `${prefix}${key}`;
            element.style.removeProperty(property);
        }
    }
    reset() {
        const { element: element } = this;
        if (!$501f8c524dad2740$export$10ef5a77b4923a6a(element)) return;
        for (const [key, value] of this.initial)element.style.setProperty(key, value);
        if (element.getAttribute("style") === "") element.removeAttribute("style");
    }
};
// src/utilities/type-guards/isElement.ts
function $501f8c524dad2740$export$45a5e7f76e0caa8d(target) {
    if (!target) return false;
    return target instanceof $501f8c524dad2740$export$38b2d434cce3ea22(target).Element || $501f8c524dad2740$var$isNode(target) && target.nodeType === Node.ELEMENT_NODE;
}
// src/utilities/type-guards/isKeyboardEvent.ts
function $501f8c524dad2740$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $501f8c524dad2740$export$38b2d434cce3ea22(event.target);
    return event instanceof KeyboardEvent;
}
// src/utilities/type-guards/isPointerEvent.ts
function $501f8c524dad2740$export$1d0a87a519049f8c(event) {
    if (!event) return false;
    const { PointerEvent: PointerEvent } = $501f8c524dad2740$export$38b2d434cce3ea22(event.target);
    return event instanceof PointerEvent;
}
// src/utilities/type-guards/supportsViewTransition.ts
function $501f8c524dad2740$export$adaf79f2a1f7416(document2) {
    return "startViewTransition" in document2;
}
// src/utilities/type-guards/isTextInput.ts
function $501f8c524dad2740$export$3e6057b9bf6b0bbb(target) {
    if (!$501f8c524dad2740$export$45a5e7f76e0caa8d(target)) return false;
    const { tagName: tagName } = target;
    return tagName === "INPUT" || tagName === "TEXTAREA" || $501f8c524dad2740$var$isContentEditable(target);
}
function $501f8c524dad2740$var$isContentEditable(element) {
    return element.hasAttribute("contenteditable") && element.getAttribute("contenteditable") !== "false";
}
// src/utilities/misc/generateUniqueId.ts
var $501f8c524dad2740$var$ids = {};
function $501f8c524dad2740$export$48da330df5248c4c(prefix) {
    const id = $501f8c524dad2740$var$ids[prefix] == null ? 0 : $501f8c524dad2740$var$ids[prefix] + 1;
    $501f8c524dad2740$var$ids[prefix] = id;
    return `${prefix}-${id}`;
}
 //# sourceMappingURL=utilities.js.map




// src/algorithms/pointerIntersection.ts


var $c970db14647306d6$export$ce3ef4e6170d9d28 = ({ dragOperation: dragOperation, droppable: droppable })=>{
    const pointerCoordinates = dragOperation.position.current;
    if (!pointerCoordinates) return null;
    const { id: id } = droppable;
    if (!droppable.shape) return null;
    if (droppable.shape.containsPoint(pointerCoordinates)) {
        const distance = (0, $ce41d7a96a1e68fd$export$baf26146a414f24a).distance(droppable.shape.center, pointerCoordinates);
        return {
            id: id,
            value: 1 / distance,
            type: (0, $9636818b04ce7da6$export$ddb2ed749236e720).PointerIntersection,
            priority: (0, $9636818b04ce7da6$export$f477ca1dcaa3e6e6).High
        };
    }
    return null;
};
var $c970db14647306d6$export$76604c06ae8aeaf1 = ({ dragOperation: dragOperation, droppable: droppable })=>{
    const { shape: shape } = dragOperation;
    if (!droppable.shape || !(shape == null ? void 0 : shape.current)) return null;
    const intersectionArea = shape.current.intersectionArea(droppable.shape);
    if (intersectionArea) {
        const { position: position } = dragOperation;
        const distance = (0, $ce41d7a96a1e68fd$export$baf26146a414f24a).distance(droppable.shape.center, position.current);
        const intersectionRatio = intersectionArea / (shape.current.area + droppable.shape.area - intersectionArea);
        const value = intersectionRatio / distance;
        return {
            id: droppable.id,
            value: value,
            type: (0, $9636818b04ce7da6$export$ddb2ed749236e720).ShapeIntersection,
            priority: (0, $9636818b04ce7da6$export$f477ca1dcaa3e6e6).Normal
        };
    }
    return null;
};
// src/algorithms/default.ts
var $c970db14647306d6$export$459d48c6d804bc59 = (args)=>{
    var _a;
    return (_a = $c970db14647306d6$export$ce3ef4e6170d9d28(args)) != null ? _a : $c970db14647306d6$export$76604c06ae8aeaf1(args);
};
var $c970db14647306d6$export$c3a6c1c7122b31c9 = (input)=>{
    const { dragOperation: dragOperation, droppable: droppable } = input;
    const { shape: shape, position: position } = dragOperation;
    if (!droppable.shape) return null;
    const shapeCorners = shape ? (0, $ce41d7a96a1e68fd$export$4617fb02663045ef).from(shape.current.boundingRectangle).corners : void 0;
    const distance = (0, $ce41d7a96a1e68fd$export$4617fb02663045ef).from(droppable.shape.boundingRectangle).corners.reduce((acc, corner, index)=>{
        var _a;
        return acc + (0, $ce41d7a96a1e68fd$export$baf26146a414f24a).distance((0, $ce41d7a96a1e68fd$export$baf26146a414f24a).from(corner), (_a = shapeCorners == null ? void 0 : shapeCorners[index]) != null ? _a : position.current);
    }, 0);
    const value = distance / 4;
    return {
        id: droppable.id,
        value: 1 / value,
        type: (0, $9636818b04ce7da6$export$ddb2ed749236e720).Collision,
        priority: (0, $9636818b04ce7da6$export$f477ca1dcaa3e6e6).Normal
    };
};
var $c970db14647306d6$export$c8e785ae6b74bab8 = (input)=>{
    var _a;
    const { dragOperation: dragOperation, droppable: droppable } = input;
    const { shape: shape, position: position } = dragOperation;
    if (!droppable.shape) return null;
    const collision = $c970db14647306d6$export$459d48c6d804bc59(input);
    if (collision) return collision;
    const distance = (0, $ce41d7a96a1e68fd$export$baf26146a414f24a).distance(droppable.shape.center, (_a = shape == null ? void 0 : shape.current.center) != null ? _a : position.current);
    const value = 1 / distance;
    return {
        id: droppable.id,
        value: value,
        type: (0, $9636818b04ce7da6$export$ddb2ed749236e720).Collision,
        priority: (0, $9636818b04ce7da6$export$f477ca1dcaa3e6e6).Normal
    };
};
var $c970db14647306d6$export$fa33afbdc7889471 = ({ dragOperation: dragOperation, droppable: droppable })=>{
    if (!droppable.shape) return null;
    const { position: position, shape: shape } = dragOperation;
    const { direction: direction } = position;
    if (!shape) return null;
    if (direction === null) return $c970db14647306d6$export$459d48c6d804bc59({
        dragOperation: dragOperation,
        droppable: droppable
    });
    const { center: center } = shape.current;
    const rect = droppable.shape.boundingRectangle;
    const isBelow = rect.bottom >= center.y;
    const isAbove = rect.top <= center.y;
    const isLeft = rect.left <= center.x;
    const isRight = rect.right >= center.x;
    if (direction === "down" && isBelow || direction === "up" && isAbove || direction === "left" && isLeft || direction === "right" && isRight) {
        const distance = (0, $ce41d7a96a1e68fd$export$baf26146a414f24a).distance(droppable.shape.center, center);
        const value = distance === 0 ? 1 : 1 / distance;
        return {
            id: droppable.id,
            value: value,
            type: (0, $9636818b04ce7da6$export$ddb2ed749236e720).Collision,
            priority: (0, $9636818b04ce7da6$export$f477ca1dcaa3e6e6).Normal
        };
    }
    return null;
};
var $c970db14647306d6$export$e1786f44af0208a7 = (input)=>{
    const { dragOperation: dragOperation, droppable: droppable } = input;
    const { position: position } = dragOperation;
    if (!droppable.shape) return null;
    const distance = (0, $ce41d7a96a1e68fd$export$baf26146a414f24a).distance(droppable.shape.center, position.current);
    const value = 1 / distance;
    return {
        id: droppable.id,
        value: value,
        type: (0, $9636818b04ce7da6$export$ddb2ed749236e720).Collision,
        priority: (0, $9636818b04ce7da6$export$f477ca1dcaa3e6e6).Normal
    };
};


var $4e1e107797f01458$var$__create = Object.create;
var $4e1e107797f01458$var$__defProp = Object.defineProperty;
var $4e1e107797f01458$var$__defProps = Object.defineProperties;
var $4e1e107797f01458$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $4e1e107797f01458$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4e1e107797f01458$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4e1e107797f01458$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4e1e107797f01458$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4e1e107797f01458$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $4e1e107797f01458$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $4e1e107797f01458$var$__defNormalProp = (obj, key, value)=>key in obj ? $4e1e107797f01458$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4e1e107797f01458$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4e1e107797f01458$var$__hasOwnProp.call(b, prop)) $4e1e107797f01458$var$__defNormalProp(a, prop, b[prop]);
    if ($4e1e107797f01458$var$__getOwnPropSymbols) {
        for (var prop of $4e1e107797f01458$var$__getOwnPropSymbols(b))if ($4e1e107797f01458$var$__propIsEnum.call(b, prop)) $4e1e107797f01458$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4e1e107797f01458$var$__spreadProps = (a, b)=>$4e1e107797f01458$var$__defProps(a, $4e1e107797f01458$var$__getOwnPropDescs(b));
var $4e1e107797f01458$var$__name = (target, value)=>$4e1e107797f01458$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $4e1e107797f01458$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4e1e107797f01458$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4e1e107797f01458$var$__getOwnPropSymbols) {
        for (var prop of $4e1e107797f01458$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4e1e107797f01458$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $4e1e107797f01458$var$__decoratorStart = (base)=>{
    var _a5;
    return [
        ,
        ,
        ,
        $4e1e107797f01458$var$__create((_a5 = base == null ? void 0 : base[$4e1e107797f01458$var$__knownSymbol("metadata")]) != null ? _a5 : null)
    ];
};
var $4e1e107797f01458$var$__decoratorStrings = [
    "class",
    "method",
    "getter",
    "setter",
    "accessor",
    "field",
    "value",
    "get",
    "set"
];
var $4e1e107797f01458$var$__expectFn = (fn)=>fn !== void 0 && typeof fn !== "function" ? $4e1e107797f01458$var$__typeError("Function expected") : fn;
var $4e1e107797f01458$var$__decoratorContext = (kind, name, done, metadata, fns)=>({
        kind: $4e1e107797f01458$var$__decoratorStrings[kind],
        name: name,
        metadata: metadata,
        addInitializer: (fn)=>done._ ? $4e1e107797f01458$var$__typeError("Already initialized") : fns.push($4e1e107797f01458$var$__expectFn(fn || null))
    });
var $4e1e107797f01458$var$__decoratorMetadata = (array, target)=>$4e1e107797f01458$var$__defNormalProp(target, $4e1e107797f01458$var$__knownSymbol("metadata"), array[3]);
var $4e1e107797f01458$var$__runInitializers = (array, flags, self, value)=>{
    for(var i = 0, fns = array[flags >> 1], n = fns && fns.length; i < n; i++)flags & 1 ? fns[i].call(self) : value = fns[i].call(self, value);
    return value;
};
var $4e1e107797f01458$var$__decorateElement = (array, flags, name, decorators, target, extra)=>{
    var fn, it, done, ctx, access, k = flags & 7, s = !!(flags & 8), p = !!(flags & 16);
    var j = k > 3 ? array.length + 1 : k ? s ? 1 : 2 : 0, key = $4e1e107797f01458$var$__decoratorStrings[k + 5];
    var initializers = k > 3 && (array[j - 1] = []), extraInitializers = array[j] || (array[j] = []);
    var desc = k && (!p && !s && (target = target.prototype), k < 5 && (k > 3 || !p) && $4e1e107797f01458$var$__getOwnPropDesc(k < 4 ? target : {
        get [name] () {
            return $4e1e107797f01458$var$__privateGet(this, extra);
        },
        set [name] (x){
            return $4e1e107797f01458$var$__privateSet(this, extra, x);
        }
    }, name));
    k ? p && k < 4 && $4e1e107797f01458$var$__name(extra, (k > 2 ? "set " : k > 1 ? "get " : "") + name) : $4e1e107797f01458$var$__name(target, name);
    for(var i = decorators.length - 1; i >= 0; i--){
        ctx = $4e1e107797f01458$var$__decoratorContext(k, name, done = {}, array[3], extraInitializers);
        if (k) {
            ctx.static = s, ctx.private = p, access = ctx.access = {
                has: p ? (x1)=>$4e1e107797f01458$var$__privateIn(target, x1) : (x1)=>name in x1
            };
            if (k ^ 3) access.get = p ? (x1)=>(k ^ 1 ? $4e1e107797f01458$var$__privateGet : $4e1e107797f01458$var$__privateMethod)(x1, target, k ^ 4 ? extra : desc.get) : (x1)=>x1[name];
            if (k > 2) access.set = p ? (x1, y)=>$4e1e107797f01458$var$__privateSet(x1, target, y, k ^ 4 ? extra : desc.set) : (x1, y)=>x1[name] = y;
        }
        it = (0, decorators[i])(k ? k < 4 ? p ? extra : desc[key] : k > 4 ? void 0 : {
            get: desc.get,
            set: desc.set
        } : target, ctx), done._ = 1;
        if (k ^ 4 || it === void 0) $4e1e107797f01458$var$__expectFn(it) && (k > 4 ? initializers.unshift(it) : k ? p ? extra = it : desc[key] = it : target = it);
        else if (typeof it !== "object" || it === null) $4e1e107797f01458$var$__typeError("Object expected");
        else $4e1e107797f01458$var$__expectFn(fn = it.get) && (desc.get = fn), $4e1e107797f01458$var$__expectFn(fn = it.set) && (desc.set = fn), $4e1e107797f01458$var$__expectFn(fn = it.init) && initializers.unshift(fn);
    }
    return k || $4e1e107797f01458$var$__decoratorMetadata(array, target), desc && $4e1e107797f01458$var$__defProp(target, name, desc), p ? k ^ 4 ? extra : desc : target;
};
var $4e1e107797f01458$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $4e1e107797f01458$var$__typeError("Cannot " + msg);
var $4e1e107797f01458$var$__privateIn = (member, obj)=>Object(obj) !== obj ? $4e1e107797f01458$var$__typeError('Cannot use the "in" operator on this value') : member.has(obj);
var $4e1e107797f01458$var$__privateGet = (obj, member, getter)=>($4e1e107797f01458$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $4e1e107797f01458$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $4e1e107797f01458$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $4e1e107797f01458$var$__privateSet = (obj, member, value, setter)=>($4e1e107797f01458$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $4e1e107797f01458$var$__privateMethod = (obj, member, method)=>($4e1e107797f01458$var$__accessCheck(obj, member, "access private method"), method);
// src/core/plugins/accessibility/defaults.ts
var $4e1e107797f01458$var$defaultAttributes = {
    role: "button",
    roleDescription: "draggable"
};
var $4e1e107797f01458$var$defaultDescriptionIdPrefix = `dnd-kit-description`;
var $4e1e107797f01458$var$defaultAnnouncementIdPrefix = `dnd-kit-announcement`;
var $4e1e107797f01458$var$defaultScreenReaderInstructions = {
    draggable: `To pick up a draggable item, press the space bar. While dragging, use the arrow keys to move the item in a given direction. Press space again to drop the item in its new position, or press escape to cancel.`
};
var $4e1e107797f01458$var$defaultAnnouncements = {
    dragstart ({ operation: { source: source } }) {
        if (!source) return;
        return `Picked up draggable item ${source.id}.`;
    },
    dragover ({ operation: { source: source, target: target } }) {
        if (!source || source.id === (target == null ? void 0 : target.id)) return;
        if (target) return `Draggable item ${source.id} was moved over droppable target ${target.id}.`;
        return `Draggable item ${source.id} is no longer over a droppable target.`;
    },
    dragend ({ operation: { source: source, target: target }, canceled: canceled }) {
        if (!source) return;
        if (canceled) return `Dragging was cancelled. Draggable item ${source.id} was dropped.`;
        if (target) return `Draggable item ${source.id} was dropped over droppable target ${target.id}`;
        return `Draggable item ${source.id} was dropped.`;
    }
};
// src/core/plugins/accessibility/utilities.ts
function $4e1e107797f01458$var$isFocusable(element) {
    const tagName = element.tagName.toLowerCase();
    return [
        "input",
        "select",
        "textarea",
        "a",
        "button"
    ].includes(tagName);
}
// src/core/plugins/accessibility/HiddenText.ts
function $4e1e107797f01458$var$createHiddenText(id, value) {
    const element = document.createElement("div");
    element.id = id;
    element.style.setProperty("display", "none");
    element.textContent = value;
    return element;
}
// src/core/plugins/accessibility/LiveRegion.ts
function $4e1e107797f01458$var$createLiveRegion(id) {
    const element = document.createElement("div");
    element.id = id;
    element.setAttribute("role", "status");
    element.setAttribute("aria-live", "polite");
    element.setAttribute("aria-atomic", "true");
    element.style.setProperty("position", "fixed");
    element.style.setProperty("width", "1px");
    element.style.setProperty("height", "1px");
    element.style.setProperty("margin", "-1px");
    element.style.setProperty("border", "0");
    element.style.setProperty("padding", "0");
    element.style.setProperty("overflow", "hidden");
    element.style.setProperty("clip", "rect(0 0 0 0)");
    element.style.setProperty("clip-path", "inset(100%)");
    element.style.setProperty("white-space", "nowrap");
    return element;
}
// src/core/plugins/accessibility/Accessibility.ts
var $4e1e107797f01458$var$debouncedEvents = [
    "dragover",
    "dragmove"
];
var $4e1e107797f01458$export$ea0f6181e3388ffd = class extends (0, $9636818b04ce7da6$export$901cf72dabf2112a) {
    constructor(manager, options){
        super(manager);
        const { id: id, idPrefix: { description: descriptionPrefix = $4e1e107797f01458$var$defaultDescriptionIdPrefix, announcement: announcementPrefix = $4e1e107797f01458$var$defaultAnnouncementIdPrefix } = {}, announcements: announcements = $4e1e107797f01458$var$defaultAnnouncements, screenReaderInstructions: screenReaderInstructions = $4e1e107797f01458$var$defaultScreenReaderInstructions, debounce: debounceMs = 500 } = options != null ? options : {};
        const descriptionId = id ? `${descriptionPrefix}-${id}` : (0, $501f8c524dad2740$export$48da330df5248c4c)(descriptionPrefix);
        const announcementId = id ? `${announcementPrefix}-${id}` : (0, $501f8c524dad2740$export$48da330df5248c4c)(announcementPrefix);
        let hiddenTextElement;
        let liveRegionElement;
        let liveRegionTextNode;
        let latestAnnouncement;
        const updateAnnouncement = (value = latestAnnouncement)=>{
            if (!liveRegionTextNode || !value) return;
            if ((liveRegionTextNode == null ? void 0 : liveRegionTextNode.nodeValue) !== value) liveRegionTextNode.nodeValue = value;
        };
        const scheduleUpdateAnnouncement = ()=>(0, $501f8c524dad2740$export$d30788f2c20241cd).schedule(updateAnnouncement);
        const debouncedUpdateAnnouncement = $4e1e107797f01458$var$debounce(scheduleUpdateAnnouncement, debounceMs);
        const eventListeners = Object.entries(announcements).map(([eventName, getAnnouncement])=>{
            return this.manager.monitor.addEventListener(eventName, (event, manager2)=>{
                const element = liveRegionTextNode;
                if (!element) return;
                const announcement = getAnnouncement == null ? void 0 : getAnnouncement(event, manager2);
                if (announcement && element.nodeValue !== announcement) {
                    latestAnnouncement = announcement;
                    if ($4e1e107797f01458$var$debouncedEvents.includes(eventName)) debouncedUpdateAnnouncement();
                    else {
                        scheduleUpdateAnnouncement();
                        debouncedUpdateAnnouncement.cancel();
                    }
                }
            });
        });
        const initialize = ()=>{
            let elements = [];
            if (!(hiddenTextElement == null ? void 0 : hiddenTextElement.isConnected)) {
                hiddenTextElement = $4e1e107797f01458$var$createHiddenText(descriptionId, screenReaderInstructions.draggable);
                elements.push(hiddenTextElement);
            }
            if (!(liveRegionElement == null ? void 0 : liveRegionElement.isConnected)) {
                liveRegionElement = $4e1e107797f01458$var$createLiveRegion(announcementId);
                liveRegionTextNode = document.createTextNode("");
                liveRegionElement.appendChild(liveRegionTextNode);
                elements.push(liveRegionElement);
            }
            if (elements.length > 0) document.body.append(...elements);
        };
        const mutations = /* @__PURE__ */ new Set();
        function executeMutations() {
            for (const operation of mutations)operation();
        }
        this.registerEffect(()=>{
            var _a5;
            mutations.clear();
            for (const draggable of this.manager.registry.draggables.value){
                const activator = (_a5 = draggable.handle) != null ? _a5 : draggable.element;
                if (activator) {
                    if (!hiddenTextElement || !liveRegionElement) mutations.add(initialize);
                    if ((!$4e1e107797f01458$var$isFocusable(activator) || (0, $501f8c524dad2740$export$95df08bae54cb4df)()) && !activator.hasAttribute("tabindex")) mutations.add(()=>activator.setAttribute("tabindex", "0"));
                    if (!activator.hasAttribute("role") && !(activator.tagName.toLowerCase() === "button")) mutations.add(()=>activator.setAttribute("role", $4e1e107797f01458$var$defaultAttributes.role));
                    if (!activator.hasAttribute("aria-roledescription")) mutations.add(()=>activator.setAttribute("aria-roledescription", $4e1e107797f01458$var$defaultAttributes.roleDescription));
                    if (!activator.hasAttribute("aria-describedby")) mutations.add(()=>activator.setAttribute("aria-describedby", descriptionId));
                    for (const key of [
                        "aria-pressed",
                        "aria-grabbed"
                    ]){
                        const value = String(draggable.isDragging);
                        if (activator.getAttribute(key) !== value) mutations.add(()=>activator.setAttribute(key, value));
                    }
                    const disabled = String(draggable.disabled);
                    if (activator.getAttribute("aria-disabled") !== disabled) mutations.add(()=>activator.setAttribute("aria-disabled", disabled));
                }
            }
            if (mutations.size > 0) (0, $501f8c524dad2740$export$d30788f2c20241cd).schedule(executeMutations);
        });
        this.destroy = ()=>{
            super.destroy();
            hiddenTextElement == null || hiddenTextElement.remove();
            liveRegionElement == null || liveRegionElement.remove();
            eventListeners.forEach((unsubscribe)=>unsubscribe());
        };
    }
};
function $4e1e107797f01458$var$debounce(fn, wait) {
    let timeout;
    const debounced = ()=>{
        clearTimeout(timeout);
        timeout = setTimeout(fn, wait);
    };
    debounced.cancel = ()=>clearTimeout(timeout);
    return debounced;
}
var $4e1e107797f01458$var$styleRegistry = /* @__PURE__ */ new Map();
var $4e1e107797f01458$var$_roots_dec, $4e1e107797f01458$var$_targetRoot_dec, $4e1e107797f01458$var$_sourceRoot_dec, $4e1e107797f01458$var$_additionalRoots_dec, $4e1e107797f01458$var$_a, $4e1e107797f01458$var$_registeredRules, $4e1e107797f01458$var$_init, $4e1e107797f01458$var$_additionalRoots, $4e1e107797f01458$var$_StyleInjector_instances, $4e1e107797f01458$var$syncStyles_fn, $4e1e107797f01458$var$inject_fn, $4e1e107797f01458$var$injectStyleElement_fn, $4e1e107797f01458$var$injectAdoptedSheet_fn;
var $4e1e107797f01458$var$_StyleInjector = class _StyleInjector extends ($4e1e107797f01458$var$_a = (0, $9636818b04ce7da6$export$18cc238caa2b61f6), $4e1e107797f01458$var$_additionalRoots_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $4e1e107797f01458$var$_sourceRoot_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $4e1e107797f01458$var$_targetRoot_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $4e1e107797f01458$var$_roots_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $4e1e107797f01458$var$_a) {
    constructor(manager, options){
        super(manager, options);
        $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init, 5, this);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_StyleInjector_instances);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_registeredRules, /* @__PURE__ */ new Set());
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_additionalRoots, $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init, 8, this, /* @__PURE__ */ new Set())), $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init, 11, this);
        this.registerEffect($4e1e107797f01458$var$__privateMethod(this, $4e1e107797f01458$var$_StyleInjector_instances, $4e1e107797f01458$var$syncStyles_fn));
    }
    /**
   * Registers CSS rules to be injected into the active drag operation's
   * document and shadow roots. The StyleInjector handles tracking
   * which roots need the styles and cleaning up when they're no longer needed.
   *
   * Returns a cleanup function that unregisters the rules.
   */ register(cssRules) {
        $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_registeredRules).add(cssRules);
        return ()=>{
            $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_registeredRules).delete(cssRules);
        };
    }
    /**
   * Adds an additional root to track for style injection.
   * Returns a cleanup function that removes the root.
   */ addRoot(root) {
        (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
            const roots = new Set(this.additionalRoots);
            roots.add(root);
            this.additionalRoots = roots;
        });
        return ()=>{
            (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
                const roots = new Set(this.additionalRoots);
                roots.delete(root);
                this.additionalRoots = roots;
            });
        };
    }
    get sourceRoot() {
        var _a5;
        const { source: source } = this.manager.dragOperation;
        return (0, $501f8c524dad2740$export$31e4419873013369)((_a5 = source == null ? void 0 : source.element) != null ? _a5 : null);
    }
    get targetRoot() {
        var _a5;
        const { target: target } = this.manager.dragOperation;
        return (0, $501f8c524dad2740$export$31e4419873013369)((_a5 = target == null ? void 0 : target.element) != null ? _a5 : null);
    }
    get roots() {
        const { status: status } = this.manager.dragOperation;
        if (status.initializing || status.initialized) {
            const roots = [
                this.sourceRoot,
                this.targetRoot
            ].filter((root)=>root != null);
            return /* @__PURE__ */ new Set([
                ...roots,
                ...this.additionalRoots
            ]);
        }
        return /* @__PURE__ */ new Set();
    }
};
$4e1e107797f01458$var$_init = $4e1e107797f01458$var$__decoratorStart($4e1e107797f01458$var$_a);
$4e1e107797f01458$var$_registeredRules = new WeakMap();
$4e1e107797f01458$var$_additionalRoots = new WeakMap();
$4e1e107797f01458$var$_StyleInjector_instances = new WeakSet();
$4e1e107797f01458$var$syncStyles_fn = function() {
    const { roots: roots } = this;
    const cleanups = [];
    for (const root of roots)for (const cssRules of $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_registeredRules))cleanups.push($4e1e107797f01458$var$__privateMethod(this, $4e1e107797f01458$var$_StyleInjector_instances, $4e1e107797f01458$var$inject_fn).call(this, root, cssRules));
    return ()=>{
        for (const cleanup of cleanups)cleanup();
    };
};
$4e1e107797f01458$var$inject_fn = function(root, cssRules) {
    let rootStyles = $4e1e107797f01458$var$styleRegistry.get(root);
    if (!rootStyles) {
        rootStyles = /* @__PURE__ */ new Map();
        $4e1e107797f01458$var$styleRegistry.set(root, rootStyles);
    }
    let registration = rootStyles.get(cssRules);
    if (!registration) {
        const created = (0, $501f8c524dad2740$export$62858bae88b53fd0)(root) ? $4e1e107797f01458$var$__privateMethod(this, $4e1e107797f01458$var$_StyleInjector_instances, $4e1e107797f01458$var$injectStyleElement_fn).call(this, root, rootStyles, cssRules) : $4e1e107797f01458$var$__privateMethod(this, $4e1e107797f01458$var$_StyleInjector_instances, $4e1e107797f01458$var$injectAdoptedSheet_fn).call(this, root, rootStyles, cssRules);
        if (!created) return ()=>{};
        registration = created;
        rootStyles.set(cssRules, registration);
    }
    registration.refCount++;
    let disposed = false;
    return ()=>{
        if (disposed) return;
        disposed = true;
        registration.refCount--;
        if (registration.refCount === 0) registration.cleanup();
    };
};
/**
 * For Document roots, prepend a <style> element to <head> so that any
 * @layer declarations appear before layers from regular stylesheets,
 * giving them the lowest cascade priority.
 */ $4e1e107797f01458$var$injectStyleElement_fn = function(root, rootStyles, cssRules) {
    var _a5;
    const style = root.createElement("style");
    const { nonce: nonce } = (_a5 = this.options) != null ? _a5 : {};
    if (nonce) style.setAttribute("nonce", nonce);
    style.textContent = cssRules;
    root.head.prepend(style);
    const observer = new MutationObserver((entries)=>{
        for (const entry of entries){
            for (const node of Array.from(entry.removedNodes))if (node === style) {
                root.head.prepend(style);
                return;
            }
        }
    });
    observer.observe(root.head, {
        childList: true
    });
    return {
        refCount: 0,
        cleanup: ()=>{
            observer.disconnect();
            style.remove();
            rootStyles.delete(cssRules);
            if (rootStyles.size === 0) $4e1e107797f01458$var$styleRegistry.delete(root);
        }
    };
};
/**
 * For ShadowRoot roots, use adoptedStyleSheets to avoid DOM side effects
 * like interfering with :first-child or :nth-child selectors.
 */ $4e1e107797f01458$var$injectAdoptedSheet_fn = function(root, rootStyles, cssRules) {
    if (!("adoptedStyleSheets" in root && Array.isArray(root.adoptedStyleSheets)) && true) console.error("Cannot inject styles: This browser doesn't support adoptedStyleSheets");
    const targetWindow = root.ownerDocument.defaultView;
    const { CSSStyleSheet: CSSStyleSheet } = targetWindow != null ? targetWindow : {};
    if (!CSSStyleSheet) {
        console.error("Cannot inject styles: CSSStyleSheet constructor not available");
        return null;
    }
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(cssRules);
    root.adoptedStyleSheets.push(sheet);
    return {
        refCount: 0,
        cleanup: ()=>{
            var _a5;
            if ((0, $501f8c524dad2740$export$af51f0f06c0f328a)(root) && ((_a5 = root.host) == null ? void 0 : _a5.isConnected)) {
                const index = root.adoptedStyleSheets.indexOf(sheet);
                if (index !== -1) root.adoptedStyleSheets.splice(index, 1);
            }
            rootStyles.delete(cssRules);
            if (rootStyles.size === 0) $4e1e107797f01458$var$styleRegistry.delete(root);
        }
    };
};
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init, 4, "additionalRoots", $4e1e107797f01458$var$_additionalRoots_dec, $4e1e107797f01458$var$_StyleInjector, $4e1e107797f01458$var$_additionalRoots);
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init, 2, "sourceRoot", $4e1e107797f01458$var$_sourceRoot_dec, $4e1e107797f01458$var$_StyleInjector);
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init, 2, "targetRoot", $4e1e107797f01458$var$_targetRoot_dec, $4e1e107797f01458$var$_StyleInjector);
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init, 2, "roots", $4e1e107797f01458$var$_roots_dec, $4e1e107797f01458$var$_StyleInjector);
$4e1e107797f01458$var$__decoratorMetadata($4e1e107797f01458$var$_init, $4e1e107797f01458$var$_StyleInjector);
$4e1e107797f01458$var$_StyleInjector.configure = (0, $9636818b04ce7da6$export$adf416f00cca6418)($4e1e107797f01458$var$_StyleInjector);
var $4e1e107797f01458$export$41faeb3470f9cb1 = $4e1e107797f01458$var$_StyleInjector;
// src/core/plugins/cursor/Cursor.ts
var $4e1e107797f01458$export$b6a79797ad180576 = class extends (0, $9636818b04ce7da6$export$901cf72dabf2112a) {
    constructor(manager, options){
        super(manager, options);
        this.manager = manager;
        const { cursor: cursor = "grabbing" } = options != null ? options : {};
        const styleInjector = manager.registry.plugins.get($4e1e107797f01458$export$41faeb3470f9cb1);
        const unregisterStyles = styleInjector == null ? void 0 : styleInjector.register(`* { cursor: ${cursor} !important; }`);
        if (unregisterStyles) {
            const originalDestroy = this.destroy.bind(this);
            this.destroy = ()=>{
                unregisterStyles();
                originalDestroy();
            };
        }
    }
};
// src/core/plugins/feedback/constants.ts
var $4e1e107797f01458$var$ATTR_PREFIX = "data-dnd-";
var $4e1e107797f01458$var$DROPPING_ATTRIBUTE = `${$4e1e107797f01458$var$ATTR_PREFIX}dropping`;
var $4e1e107797f01458$var$CSS_PREFIX = "--dnd-";
var $4e1e107797f01458$var$ATTRIBUTE = `${$4e1e107797f01458$var$ATTR_PREFIX}dragging`;
var $4e1e107797f01458$var$PLACEHOLDER_ATTRIBUTE = `${$4e1e107797f01458$var$ATTR_PREFIX}placeholder`;
var $4e1e107797f01458$var$IGNORED_ATTRIBUTES = [
    $4e1e107797f01458$var$ATTRIBUTE,
    $4e1e107797f01458$var$PLACEHOLDER_ATTRIBUTE,
    "popover",
    "aria-pressed",
    "aria-grabbing"
];
var $4e1e107797f01458$var$IGNORED_STYLES = [
    "view-transition-name"
];
var $4e1e107797f01458$var$CSS_RULES = `
  :is(:root,:host) [${$4e1e107797f01458$var$ATTRIBUTE}] {
    position: fixed !important;
    pointer-events: none !important;
    touch-action: none;
    z-index: calc(infinity);
    will-change: translate;
    top: var(${$4e1e107797f01458$var$CSS_PREFIX}top, 0px) !important;
    left: var(${$4e1e107797f01458$var$CSS_PREFIX}left, 0px) !important;
    right: unset !important;
    bottom: unset !important;
    width: var(${$4e1e107797f01458$var$CSS_PREFIX}width, auto);
    max-width: var(${$4e1e107797f01458$var$CSS_PREFIX}width, auto);
    height: var(${$4e1e107797f01458$var$CSS_PREFIX}height, auto);
    max-height: var(${$4e1e107797f01458$var$CSS_PREFIX}height, auto);
    transform: var(${$4e1e107797f01458$var$CSS_PREFIX}transform, none) !important;
    transition: var(${$4e1e107797f01458$var$CSS_PREFIX}transition) !important;
  }

  :is(:root,:host) [${$4e1e107797f01458$var$PLACEHOLDER_ATTRIBUTE}] {
    transition: none;
  }

  :is(:root,:host) [${$4e1e107797f01458$var$PLACEHOLDER_ATTRIBUTE}='hidden'] {
    visibility: hidden;
  }

  [${$4e1e107797f01458$var$ATTRIBUTE}] * {
    pointer-events: none !important;
  }

  [${$4e1e107797f01458$var$ATTRIBUTE}]:not([${$4e1e107797f01458$var$DROPPING_ATTRIBUTE}]) {
    translate: var(${$4e1e107797f01458$var$CSS_PREFIX}translate) !important;
  }

  [${$4e1e107797f01458$var$ATTRIBUTE}][style*='${$4e1e107797f01458$var$CSS_PREFIX}scale'] {
    scale: var(${$4e1e107797f01458$var$CSS_PREFIX}scale) !important;
    transform-origin: var(${$4e1e107797f01458$var$CSS_PREFIX}transform-origin) !important;
  }

  @layer dnd-kit {
    :where([${$4e1e107797f01458$var$ATTRIBUTE}][popover]) {
      overflow: visible;
      background: unset;
      border: unset;
      margin: unset;
      padding: unset;
      color: inherit;

      &:is(input, button) {
        border: revert;
        background: revert;
      }
    }
  }
  [${$4e1e107797f01458$var$ATTRIBUTE}]::backdrop, [${$4e1e107797f01458$var$ATTR_PREFIX}overlay]:not([${$4e1e107797f01458$var$ATTRIBUTE}]) {
    display: none;
    visibility: hidden;
  }
`.replace(/\n+/g, " ").replace(/\s+/g, " ").trim();
function $4e1e107797f01458$var$createPlaceholder(source, type = "hidden") {
    return (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
        const { element: element, manager: manager } = source;
        if (!element || !manager) return;
        const containedDroppables = $4e1e107797f01458$var$findContainedDroppables(element, manager.registry.droppables);
        const cleanup = [];
        const placeholder = (0, $501f8c524dad2740$export$e530037191fcd5d7)(element);
        const { remove: remove } = placeholder;
        $4e1e107797f01458$var$proxyDroppableElements(containedDroppables, placeholder, cleanup);
        $4e1e107797f01458$var$configurePlaceholder(placeholder, type);
        placeholder.remove = ()=>{
            cleanup.forEach((fn)=>fn());
            remove.call(placeholder);
        };
        return placeholder;
    });
}
function $4e1e107797f01458$var$findContainedDroppables(element, droppables) {
    const containedDroppables = /* @__PURE__ */ new Map();
    for (const droppable of droppables){
        if (!droppable.element) continue;
        if (element === droppable.element || element.contains(droppable.element)) {
            const identifierAttribute = `${$4e1e107797f01458$var$ATTR_PREFIX}${(0, $501f8c524dad2740$export$48da330df5248c4c)("dom-id")}`;
            droppable.element.setAttribute(identifierAttribute, "");
            containedDroppables.set(droppable, identifierAttribute);
        }
    }
    return containedDroppables;
}
function $4e1e107797f01458$var$proxyDroppableElements(containedDroppables, placeholder, cleanup) {
    for (const [droppable, identifierAttribute] of containedDroppables){
        if (!droppable.element) continue;
        const selector = `[${identifierAttribute}]`;
        const clonedElement = placeholder.matches(selector) ? placeholder : placeholder.querySelector(selector);
        droppable.element.removeAttribute(identifierAttribute);
        if (!clonedElement) continue;
        const originalElement = droppable.element;
        droppable.proxy = clonedElement;
        clonedElement.removeAttribute(identifierAttribute);
        (0, $501f8c524dad2740$export$83d4521ded5863e3).set(originalElement, clonedElement);
        cleanup.push(()=>{
            (0, $501f8c524dad2740$export$83d4521ded5863e3).delete(originalElement);
            droppable.proxy = void 0;
        });
    }
}
function $4e1e107797f01458$var$configurePlaceholder(placeholder, type = "hidden") {
    placeholder.setAttribute("inert", "true");
    placeholder.setAttribute("tab-index", "-1");
    placeholder.setAttribute("aria-hidden", "true");
    placeholder.setAttribute($4e1e107797f01458$var$PLACEHOLDER_ATTRIBUTE, type);
}
function $4e1e107797f01458$var$isSameFrame(element, target) {
    if (element === target) return true;
    return (0, $501f8c524dad2740$export$7bf1f8740e3e34af)(element) === (0, $501f8c524dad2740$export$7bf1f8740e3e34af)(target);
}
function $4e1e107797f01458$var$preventPopoverClose(event) {
    const { target: target } = event;
    if ("newState" in event && event.newState === "closed" && (0, $501f8c524dad2740$export$45a5e7f76e0caa8d)(target) && target.hasAttribute("popover")) requestAnimationFrame(()=>(0, $501f8c524dad2740$export$609054a8611e50dd)(target));
}
function $4e1e107797f01458$var$isTableRow(element) {
    return element.tagName === "TR";
}
function $4e1e107797f01458$var$createElementMutationObserver(element, placeholder, clone) {
    const observer = new MutationObserver((mutations)=>{
        let hasChildrenMutations = false;
        for (const mutation of mutations){
            if (mutation.target !== element) {
                hasChildrenMutations = true;
                continue;
            }
            if (mutation.type !== "attributes") continue;
            const attributeName = mutation.attributeName;
            if (attributeName.startsWith("aria-") || $4e1e107797f01458$var$IGNORED_ATTRIBUTES.includes(attributeName)) continue;
            const attributeValue = element.getAttribute(attributeName);
            if (attributeName === "style") {
                if ((0, $501f8c524dad2740$export$10ef5a77b4923a6a)(element) && (0, $501f8c524dad2740$export$10ef5a77b4923a6a)(placeholder)) {
                    const styles = element.style;
                    for (const key of Array.from(placeholder.style))if (styles.getPropertyValue(key) === "") placeholder.style.removeProperty(key);
                    for (const key of Array.from(styles)){
                        if ($4e1e107797f01458$var$IGNORED_STYLES.includes(key) || key.startsWith($4e1e107797f01458$var$CSS_PREFIX)) continue;
                        const value = styles.getPropertyValue(key);
                        placeholder.style.setProperty(key, value);
                    }
                }
            } else if (attributeValue !== null) placeholder.setAttribute(attributeName, attributeValue);
            else placeholder.removeAttribute(attributeName);
        }
        if (hasChildrenMutations && clone) placeholder.replaceChildren(...element.cloneNode(true).childNodes);
    });
    observer.observe(element, {
        attributes: true,
        subtree: true,
        childList: true
    });
    return observer;
}
function $4e1e107797f01458$var$createDocumentMutationObserver(element, placeholder, feedbackElement) {
    const observer = new MutationObserver((entries)=>{
        for (const entry of entries){
            if (entry.addedNodes.length === 0) continue;
            for (const node of Array.from(entry.addedNodes)){
                if (node.contains(element) && element.nextElementSibling !== placeholder) {
                    element.insertAdjacentElement("afterend", placeholder);
                    (0, $501f8c524dad2740$export$609054a8611e50dd)(feedbackElement);
                    return;
                }
                if (node.contains(placeholder) && placeholder.previousElementSibling !== element) {
                    placeholder.insertAdjacentElement("beforebegin", element);
                    (0, $501f8c524dad2740$export$609054a8611e50dd)(feedbackElement);
                    return;
                }
            }
        }
        if (element.isConnected && placeholder.isConnected && element.nextElementSibling !== placeholder) {
            element.insertAdjacentElement("afterend", placeholder);
            (0, $501f8c524dad2740$export$609054a8611e50dd)(feedbackElement);
        }
    });
    observer.observe(element.ownerDocument.body, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $4e1e107797f01458$var$createResizeObserver(ctx) {
    return new ResizeObserver(()=>{
        var _a5, _b2, _c3;
        const placeholderShape = new (0, $501f8c524dad2740$export$9be488f2d210405c)(ctx.placeholder, {
            frameTransform: ctx.frameTransform,
            ignoreTransforms: true
        });
        const origin = (_a5 = ctx.transformOrigin) != null ? _a5 : {
            x: 1,
            y: 1
        };
        const dX = (ctx.width - placeholderShape.width) * origin.x + ctx.delta.x;
        const dY = (ctx.height - placeholderShape.height) * origin.y + ctx.delta.y;
        const fixedOffset = (0, $501f8c524dad2740$export$e38b62dce8b396f0)();
        ctx.styles.set({
            width: placeholderShape.width - ctx.widthOffset,
            height: placeholderShape.height - ctx.heightOffset,
            top: ctx.top + dY + fixedOffset.y,
            left: ctx.left + dX + fixedOffset.x
        }, $4e1e107797f01458$var$CSS_PREFIX);
        (_b2 = ctx.getElementMutationObserver()) == null || _b2.takeRecords();
        if ($4e1e107797f01458$var$isTableRow(ctx.element) && $4e1e107797f01458$var$isTableRow(ctx.placeholder)) {
            const cells = Array.from(ctx.element.cells);
            const placeholderCells = Array.from(ctx.placeholder.cells);
            if (!ctx.getSavedCellWidths()) ctx.setSavedCellWidths(cells.map((cell)=>cell.style.width));
            for (const [index, cell] of cells.entries()){
                const placeholderCell = placeholderCells[index];
                cell.style.width = `${placeholderCell.getBoundingClientRect().width}px`;
            }
        }
        const translate = (_c3 = ctx.getTranslate()) != null ? _c3 : {
            x: 0,
            y: 0
        };
        const shapeLeft = ctx.left + dX + fixedOffset.x + translate.x;
        const shapeTop = ctx.top + dY + fixedOffset.y + translate.y;
        const shapeWidth = placeholderShape.width - ctx.widthOffset;
        const shapeHeight = placeholderShape.height - ctx.heightOffset;
        const ft = ctx.frameTransform;
        ctx.dragOperation.shape = new (0, $ce41d7a96a1e68fd$export$4617fb02663045ef)(shapeLeft * ft.scaleX + ft.x, shapeTop * ft.scaleY + ft.y, shapeWidth * ft.scaleX, shapeHeight * ft.scaleY);
    });
}
var $4e1e107797f01458$var$DEFAULT_DURATION = 250;
var $4e1e107797f01458$var$DEFAULT_EASING = "ease";
function $4e1e107797f01458$var$runDropAnimation(ctx) {
    var _a5, _b2, _c3, _d2;
    const { animation: animation } = ctx;
    if (typeof animation === "function") {
        const result = animation({
            source: ctx.source,
            element: ctx.element,
            feedbackElement: ctx.feedbackElement,
            placeholder: ctx.placeholder,
            translate: ctx.translate,
            moved: ctx.moved
        });
        Promise.resolve(result).then(()=>{
            ctx.cleanup();
            requestAnimationFrame(ctx.restoreFocus);
        });
        return;
    }
    const { duration: duration = $4e1e107797f01458$var$DEFAULT_DURATION, easing: easing = $4e1e107797f01458$var$DEFAULT_EASING } = animation != null ? animation : {};
    (0, $501f8c524dad2740$export$609054a8611e50dd)(ctx.feedbackElement);
    const [, runningAnimation] = (_a5 = (0, $501f8c524dad2740$export$14de59408fad90b)(ctx.feedbackElement, (keyframe)=>"translate" in keyframe)) != null ? _a5 : [];
    runningAnimation == null || runningAnimation.pause();
    const target = (_b2 = ctx.placeholder) != null ? _b2 : ctx.element;
    const options = {
        frameTransform: $4e1e107797f01458$var$isSameFrame(ctx.feedbackElement, target) ? null : void 0
    };
    const current = new (0, $501f8c524dad2740$export$9be488f2d210405c)(ctx.feedbackElement, options);
    const currentTranslate = (_c3 = (0, $501f8c524dad2740$export$8ea33f091e4ee473)((0, $501f8c524dad2740$export$8ef593ce41855f7f)(ctx.feedbackElement).translate)) != null ? _c3 : ctx.translate;
    const final = new (0, $501f8c524dad2740$export$9be488f2d210405c)(target, options);
    const delta = (0, $ce41d7a96a1e68fd$export$4617fb02663045ef).delta(current, final, ctx.alignment);
    const finalTranslate = {
        x: currentTranslate.x - delta.x,
        y: currentTranslate.y - delta.y
    };
    const heightKeyframes = Math.round(current.intrinsicHeight) !== Math.round(final.intrinsicHeight) ? {
        minHeight: [
            `${current.intrinsicHeight}px`,
            `${final.intrinsicHeight}px`
        ],
        maxHeight: [
            `${current.intrinsicHeight}px`,
            `${final.intrinsicHeight}px`
        ]
    } : {};
    const widthKeyframes = Math.round(current.intrinsicWidth) !== Math.round(final.intrinsicWidth) ? {
        minWidth: [
            `${current.intrinsicWidth}px`,
            `${final.intrinsicWidth}px`
        ],
        maxWidth: [
            `${current.intrinsicWidth}px`,
            `${final.intrinsicWidth}px`
        ]
    } : {};
    ctx.styles.set({
        transition: ctx.transition
    }, $4e1e107797f01458$var$CSS_PREFIX);
    ctx.feedbackElement.setAttribute($4e1e107797f01458$var$DROPPING_ATTRIBUTE, "");
    (_d2 = ctx.getElementMutationObserver()) == null || _d2.takeRecords();
    (0, $501f8c524dad2740$export$729fc4eb9847864b)({
        element: ctx.feedbackElement,
        keyframes: $4e1e107797f01458$var$__spreadProps($4e1e107797f01458$var$__spreadValues($4e1e107797f01458$var$__spreadValues({}, heightKeyframes), widthKeyframes), {
            translate: [
                `${currentTranslate.x}px ${currentTranslate.y}px 0`,
                `${finalTranslate.x}px ${finalTranslate.y}px 0`
            ]
        }),
        options: {
            duration: (0, $501f8c524dad2740$export$ff7706047246b98b)((0, $501f8c524dad2740$export$38b2d434cce3ea22)(ctx.feedbackElement)) ? 0 : ctx.moved || ctx.feedbackElement !== ctx.element ? duration : 0,
            easing: easing
        }
    }).then(()=>{
        ctx.feedbackElement.removeAttribute($4e1e107797f01458$var$DROPPING_ATTRIBUTE);
        runningAnimation == null || runningAnimation.finish();
        ctx.cleanup();
        requestAnimationFrame(ctx.restoreFocus);
    });
}
// src/core/plugins/feedback/Feedback.ts
var $4e1e107797f01458$var$_overlay_dec, $4e1e107797f01458$var$_a2, $4e1e107797f01458$var$_init2, $4e1e107797f01458$var$_overlay, $4e1e107797f01458$var$_Feedback_instances, $4e1e107797f01458$var$trackOverlayRoot_fn, $4e1e107797f01458$var$render_fn;
var $4e1e107797f01458$var$_Feedback = class _Feedback extends ($4e1e107797f01458$var$_a2 = (0, $9636818b04ce7da6$export$901cf72dabf2112a), $4e1e107797f01458$var$_overlay_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $4e1e107797f01458$var$_a2) {
    constructor(manager, options){
        super(manager, options);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_Feedback_instances);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_overlay, $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init2, 8, this)), $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init2, 11, this);
        this.state = {
            initial: {},
            current: {}
        };
        const styleInjector = manager.registry.plugins.get($4e1e107797f01458$export$41faeb3470f9cb1);
        const unregisterStyles = styleInjector == null ? void 0 : styleInjector.register($4e1e107797f01458$var$CSS_RULES);
        if (unregisterStyles) {
            const originalDestroy = this.destroy.bind(this);
            this.destroy = ()=>{
                unregisterStyles();
                originalDestroy();
            };
        }
        this.registerEffect($4e1e107797f01458$var$__privateMethod(this, $4e1e107797f01458$var$_Feedback_instances, $4e1e107797f01458$var$trackOverlayRoot_fn).bind(this, styleInjector));
        this.registerEffect($4e1e107797f01458$var$__privateMethod(this, $4e1e107797f01458$var$_Feedback_instances, $4e1e107797f01458$var$render_fn));
    }
};
$4e1e107797f01458$var$_init2 = $4e1e107797f01458$var$__decoratorStart($4e1e107797f01458$var$_a2);
$4e1e107797f01458$var$_overlay = new WeakMap();
$4e1e107797f01458$var$_Feedback_instances = new WeakSet();
$4e1e107797f01458$var$trackOverlayRoot_fn = function(styleInjector) {
    const { overlay: overlay } = this;
    if (!overlay || !styleInjector) return;
    const root = (0, $501f8c524dad2740$export$31e4419873013369)(overlay);
    if (!root) return;
    return styleInjector.addRoot(root);
};
$4e1e107797f01458$var$render_fn = function() {
    var _a5, _b2, _c3, _d2, _e, _f, _g;
    const { state: state, manager: manager, options: options } = this;
    const { dragOperation: dragOperation } = manager;
    const { position: position, source: source, status: status } = dragOperation;
    if (status.idle) {
        state.current = {};
        state.initial = {};
        return;
    }
    if (!source) return;
    const { element: element } = source;
    const entityOptions = source.pluginConfig($4e1e107797f01458$var$_Feedback);
    const feedbackOption = (_b2 = (_a5 = entityOptions == null ? void 0 : entityOptions.feedback) != null ? _a5 : options == null ? void 0 : options.feedback) != null ? _b2 : "default";
    const feedback = typeof feedbackOption === "function" ? feedbackOption(source, manager) : feedbackOption;
    if (!element || feedback === "none" || !status.initialized || status.initializing) return;
    const { initial: initial } = state;
    const feedbackElement = (_c3 = this.overlay) != null ? _c3 : element;
    const frameTransform = (0, $501f8c524dad2740$export$f7bade9204ccdfdf)(feedbackElement);
    const elementFrameTransform = (0, $501f8c524dad2740$export$f7bade9204ccdfdf)(element);
    const crossFrame = !$4e1e107797f01458$var$isSameFrame(element, feedbackElement);
    const shape = new (0, $501f8c524dad2740$export$9be488f2d210405c)(element, {
        frameTransform: crossFrame ? elementFrameTransform : null,
        ignoreTransforms: !crossFrame
    });
    const scaleDelta = {
        x: elementFrameTransform.scaleX / frameTransform.scaleX,
        y: elementFrameTransform.scaleY / frameTransform.scaleY
    };
    let { width: width, height: height, top: top, left: left } = shape;
    if (crossFrame) {
        width = width / scaleDelta.x;
        height = height / scaleDelta.y;
    }
    const styles = new (0, $501f8c524dad2740$export$e155666bf54a9f18)(feedbackElement);
    const elementStyles = (0, $501f8c524dad2740$export$8ef593ce41855f7f)(element);
    const { transition: transition, translate: translate, boxSizing: boxSizing, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, borderInlineStartWidth: borderInlineStartWidth, borderInlineEndWidth: borderInlineEndWidth, borderBlockStartWidth: borderBlockStartWidth, borderBlockEndWidth: borderBlockEndWidth } = elementStyles;
    const feedbackTransition = transition.split(",").filter((t)=>!/^\s*(transform|translate|scale)\b/.test(t)).join(",");
    const parsedTransform = (0, $501f8c524dad2740$export$99f660e5a014b917)(elementStyles);
    const initialTransformStyle = elementStyles.transform;
    const clone = feedback === "clone";
    const contentBox = boxSizing === "content-box";
    const widthOffset = contentBox ? parseInt(paddingInlineStart) + parseInt(paddingInlineEnd) + parseInt(borderInlineStartWidth) + parseInt(borderInlineEndWidth) : 0;
    const heightOffset = contentBox ? parseInt(paddingBlockStart) + parseInt(paddingBlockEnd) + parseInt(borderBlockStartWidth) + parseInt(borderBlockEndWidth) : 0;
    const placeholder = feedback !== "move" && !this.overlay ? $4e1e107797f01458$var$createPlaceholder(source, clone ? "clone" : "hidden") : null;
    const isKeyboardOperation = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>(0, $501f8c524dad2740$export$130b789831072f4c)(manager.dragOperation.activatorEvent));
    if (!initial.translate) {
        if (this.overlay && parsedTransform) initial.translate = {
            x: parsedTransform.x,
            y: parsedTransform.y
        };
        else if (translate !== "none") {
            const parsedTranslate = (0, $501f8c524dad2740$export$8ea33f091e4ee473)(translate);
            if (parsedTranslate) initial.translate = parsedTranslate;
        }
    }
    if (!initial.transformOrigin) {
        const current = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>position.current);
        const visualLeft = left + ((_d2 = parsedTransform == null ? void 0 : parsedTransform.x) != null ? _d2 : 0);
        const visualTop = top + ((_e = parsedTransform == null ? void 0 : parsedTransform.y) != null ? _e : 0);
        initial.transformOrigin = {
            x: (current.x - visualLeft * frameTransform.scaleX - frameTransform.x) / (width * frameTransform.scaleX),
            y: (current.y - visualTop * frameTransform.scaleY - frameTransform.y) / (height * frameTransform.scaleY)
        };
    }
    const { transformOrigin: transformOrigin } = initial;
    const relativeTop = top * frameTransform.scaleY + frameTransform.y;
    const relativeLeft = left * frameTransform.scaleX + frameTransform.x;
    if (!initial.coordinates) {
        initial.coordinates = {
            x: relativeLeft,
            y: relativeTop
        };
        if (scaleDelta.x !== 1 || scaleDelta.y !== 1) {
            const { scaleX: scaleX, scaleY: scaleY } = elementFrameTransform;
            const { x: tX2, y: tY2 } = transformOrigin;
            initial.coordinates.x += (width * scaleX - width) * tX2;
            initial.coordinates.y += (height * scaleY - height) * tY2;
        }
    }
    if (!initial.dimensions) initial.dimensions = {
        width: width,
        height: height
    };
    if (!initial.frameTransform) initial.frameTransform = frameTransform;
    const coordinatesDelta = {
        x: initial.coordinates.x - relativeLeft,
        y: initial.coordinates.y - relativeTop
    };
    const sizeDelta = {
        width: (initial.dimensions.width * initial.frameTransform.scaleX - width * frameTransform.scaleX) * transformOrigin.x,
        height: (initial.dimensions.height * initial.frameTransform.scaleY - height * frameTransform.scaleY) * transformOrigin.y
    };
    const delta = {
        x: coordinatesDelta.x / frameTransform.scaleX + sizeDelta.width,
        y: coordinatesDelta.y / frameTransform.scaleY + sizeDelta.height
    };
    const projected = {
        left: left + delta.x,
        top: top + delta.y
    };
    feedbackElement.setAttribute($4e1e107797f01458$var$ATTRIBUTE, "true");
    const transform = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>dragOperation.transform);
    const initialTranslate = (_f = initial.translate) != null ? _f : {
        x: 0,
        y: 0
    };
    const tX = transform.x * frameTransform.scaleX + initialTranslate.x;
    const tY = transform.y * frameTransform.scaleY + initialTranslate.y;
    const fixedOffset = (0, $501f8c524dad2740$export$e38b62dce8b396f0)();
    styles.set({
        width: width - widthOffset,
        height: height - heightOffset,
        top: projected.top + fixedOffset.y,
        left: projected.left + fixedOffset.x,
        translate: `${tX}px ${tY}px 0`,
        transform: this.overlay ? "none" : initialTransformStyle,
        transition: feedbackTransition ? `${feedbackTransition}, translate 0ms linear` : "translate 0ms linear",
        scale: crossFrame ? `${scaleDelta.x} ${scaleDelta.y}` : "",
        "transform-origin": `${transformOrigin.x * 100}% ${transformOrigin.y * 100}%`
    }, $4e1e107797f01458$var$CSS_PREFIX);
    if (placeholder) {
        element.insertAdjacentElement("afterend", placeholder);
        if (options == null ? void 0 : options.rootElement) {
            const root = typeof options.rootElement === "function" ? options.rootElement(source) : options.rootElement;
            root.appendChild(element);
        }
    }
    if ((0, $501f8c524dad2740$export$1150b66d0ff92823)(feedbackElement)) {
        if (!feedbackElement.hasAttribute("popover")) feedbackElement.setAttribute("popover", "manual");
        (0, $501f8c524dad2740$export$609054a8611e50dd)(feedbackElement);
        feedbackElement.addEventListener("beforetoggle", $4e1e107797f01458$var$preventPopoverClose);
    }
    let elementMutationObserver;
    let documentMutationObserver;
    let savedCellWidths;
    const resizeObserver = $4e1e107797f01458$var$createResizeObserver({
        placeholder: placeholder,
        element: element,
        feedbackElement: feedbackElement,
        frameTransform: frameTransform,
        transformOrigin: transformOrigin,
        width: width,
        height: height,
        top: top,
        left: left,
        widthOffset: widthOffset,
        heightOffset: heightOffset,
        delta: delta,
        styles: styles,
        dragOperation: dragOperation,
        getTranslate: ()=>state.current.translate,
        getElementMutationObserver: ()=>elementMutationObserver,
        getSavedCellWidths: ()=>savedCellWidths,
        setSavedCellWidths: (widths)=>{
            savedCellWidths = widths;
        }
    });
    const initialShape = new (0, $501f8c524dad2740$export$9be488f2d210405c)(feedbackElement);
    (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>dragOperation.shape = initialShape);
    const feedbackWindow = (0, $501f8c524dad2740$export$38b2d434cce3ea22)(feedbackElement);
    const handleWindowResize = (event)=>{
        this.manager.actions.stop({
            event: event
        });
    };
    const reducedMotion = (0, $501f8c524dad2740$export$ff7706047246b98b)(feedbackWindow);
    if (isKeyboardOperation) feedbackWindow.addEventListener("resize", handleWindowResize);
    if ((0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>source.status) === "idle") requestAnimationFrame(()=>source.status = "dragging");
    if (placeholder) {
        resizeObserver.observe(placeholder);
        elementMutationObserver = $4e1e107797f01458$var$createElementMutationObserver(element, placeholder, clone);
        documentMutationObserver = $4e1e107797f01458$var$createDocumentMutationObserver(element, placeholder, feedbackElement);
    }
    const id = (_g = manager.dragOperation.source) == null ? void 0 : _g.id;
    const restoreFocus = ()=>{
        var _a6;
        if (!isKeyboardOperation || id == null) return;
        const draggable = manager.registry.draggables.get(id);
        const focusTarget = (_a6 = draggable == null ? void 0 : draggable.handle) != null ? _a6 : draggable == null ? void 0 : draggable.element;
        if ((0, $501f8c524dad2740$export$1b3bfaa9684536aa)(focusTarget)) focusTarget.focus();
    };
    const cleanup = ()=>{
        var _a6;
        elementMutationObserver == null || elementMutationObserver.disconnect();
        documentMutationObserver == null || documentMutationObserver.disconnect();
        resizeObserver.disconnect();
        feedbackWindow.removeEventListener("resize", handleWindowResize);
        if ((0, $501f8c524dad2740$export$1150b66d0ff92823)(feedbackElement)) {
            feedbackElement.removeEventListener("beforetoggle", $4e1e107797f01458$var$preventPopoverClose);
            feedbackElement.removeAttribute("popover");
        }
        feedbackElement.removeAttribute($4e1e107797f01458$var$ATTRIBUTE);
        styles.reset();
        if (savedCellWidths && $4e1e107797f01458$var$isTableRow(element)) {
            const cells = Array.from(element.cells);
            for (const [index, cell] of cells.entries())cell.style.width = (_a6 = savedCellWidths[index]) != null ? _a6 : "";
        }
        source.status = "idle";
        const moved = state.current.translate != null;
        const isDragging = dragOperation.status.dragging;
        if (placeholder && (!isDragging && moved || placeholder.parentElement !== feedbackElement.parentElement) && feedbackElement.isConnected) placeholder.replaceWith(feedbackElement);
        placeholder == null || placeholder.remove();
    };
    const optionsDropAnimation = options == null ? void 0 : options.dropAnimation;
    const feedbackPlugin = this;
    const cleanupEffects = (0, $eb0d2ed00918af28$export$fb4689499fb20c56)(// Update transform on move
    ()=>{
        var _a6, _b3, _c4;
        const { transform: transform2, status: status2 } = dragOperation;
        if (!transform2.x && !transform2.y && !state.current.translate) return;
        if (status2.dragging) {
            const initialTranslate2 = (_a6 = initial.translate) != null ? _a6 : {
                x: 0,
                y: 0
            };
            const translate2 = {
                x: transform2.x / frameTransform.scaleX + initialTranslate2.x,
                y: transform2.y / frameTransform.scaleY + initialTranslate2.y
            };
            const previousTranslate = state.current.translate;
            const modifiers = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>dragOperation.modifiers);
            const currentShape = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
                var _a7;
                return (_a7 = dragOperation.shape) == null ? void 0 : _a7.current;
            });
            const keyboardTransition = options == null ? void 0 : options.keyboardTransition;
            const translateTransition = isKeyboardOperation && !reducedMotion && keyboardTransition !== null ? `${(_b3 = keyboardTransition == null ? void 0 : keyboardTransition.duration) != null ? _b3 : 250}ms ${(_c4 = keyboardTransition == null ? void 0 : keyboardTransition.easing) != null ? _c4 : "cubic-bezier(0.25, 1, 0.5, 1)"}` : "0ms linear";
            styles.set({
                transition: feedbackTransition ? `${feedbackTransition}, translate ${translateTransition}` : `translate ${translateTransition}`,
                translate: `${translate2.x}px ${translate2.y}px 0`
            }, $4e1e107797f01458$var$CSS_PREFIX);
            elementMutationObserver == null || elementMutationObserver.takeRecords();
            if (currentShape && currentShape !== initialShape && previousTranslate && !modifiers.length) {
                const delta2 = (0, $ce41d7a96a1e68fd$export$baf26146a414f24a).delta(translate2, previousTranslate);
                dragOperation.shape = (0, $ce41d7a96a1e68fd$export$4617fb02663045ef).from(currentShape.boundingRectangle).translate(delta2.x * frameTransform.scaleX, delta2.y * frameTransform.scaleY);
            } else dragOperation.shape = new (0, $501f8c524dad2740$export$9be488f2d210405c)(feedbackElement);
            state.current.translate = translate2;
        }
    }, // Drop animation
    function() {
        if (dragOperation.status.dropped) {
            this.dispose();
            source.status = "dropping";
            const dropAnimationConfig = (entityOptions == null ? void 0 : entityOptions.dropAnimation) !== void 0 ? entityOptions.dropAnimation : feedbackPlugin.dropAnimation !== void 0 ? feedbackPlugin.dropAnimation : optionsDropAnimation;
            let translate2 = state.current.translate;
            const moved = translate2 != null;
            if (!translate2 && element !== feedbackElement) translate2 = {
                x: 0,
                y: 0
            };
            if (!translate2 || dropAnimationConfig === null) {
                cleanup();
                return;
            }
            manager.renderer.rendering.then(()=>{
                $4e1e107797f01458$var$runDropAnimation({
                    source: source,
                    element: element,
                    feedbackElement: feedbackElement,
                    placeholder: placeholder,
                    translate: translate2,
                    moved: moved,
                    transition: transition,
                    alignment: source.alignment,
                    styles: styles,
                    animation: dropAnimationConfig != null ? dropAnimationConfig : void 0,
                    getElementMutationObserver: ()=>elementMutationObserver,
                    cleanup: cleanup,
                    restoreFocus: restoreFocus
                });
            });
        }
    });
    return ()=>{
        cleanup();
        cleanupEffects();
    };
};
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init2, 4, "overlay", $4e1e107797f01458$var$_overlay_dec, $4e1e107797f01458$var$_Feedback, $4e1e107797f01458$var$_overlay);
$4e1e107797f01458$var$__decoratorMetadata($4e1e107797f01458$var$_init2, $4e1e107797f01458$var$_Feedback);
$4e1e107797f01458$var$_Feedback.configure = (0, $9636818b04ce7da6$export$adf416f00cca6418)($4e1e107797f01458$var$_Feedback);
var $4e1e107797f01458$export$175e500a48a60fd2 = $4e1e107797f01458$var$_Feedback;
var $4e1e107797f01458$var$LOCKED = true;
var $4e1e107797f01458$var$UNLOCKED = false;
var $4e1e107797f01458$var$_dec, $4e1e107797f01458$var$_a3, $4e1e107797f01458$var$_dec2, $4e1e107797f01458$var$_b, $4e1e107797f01458$var$_init3, $4e1e107797f01458$var$__b, $4e1e107797f01458$var$__a;
$4e1e107797f01458$var$_b = ($4e1e107797f01458$var$_dec2 = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], (0, $501f8c524dad2740$export$ef1760368e0f70e4).Forward), $4e1e107797f01458$var$_a3 = ($4e1e107797f01458$var$_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], (0, $501f8c524dad2740$export$ef1760368e0f70e4).Reverse);
var $4e1e107797f01458$var$ScrollLock = class {
    constructor(){
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$__b, $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init3, 8, this, $4e1e107797f01458$var$LOCKED)), $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init3, 11, this);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$__a, $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init3, 12, this, $4e1e107797f01458$var$LOCKED)), $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init3, 15, this);
    }
    isLocked(direction) {
        if (direction === (0, $501f8c524dad2740$export$ef1760368e0f70e4).Idle) return false;
        if (direction == null) return this[(0, $501f8c524dad2740$export$ef1760368e0f70e4).Forward] === $4e1e107797f01458$var$LOCKED && this[(0, $501f8c524dad2740$export$ef1760368e0f70e4).Reverse] === $4e1e107797f01458$var$LOCKED;
        return this[direction] === $4e1e107797f01458$var$LOCKED;
    }
    unlock(direction) {
        if (direction === (0, $501f8c524dad2740$export$ef1760368e0f70e4).Idle) return;
        this[direction] = $4e1e107797f01458$var$UNLOCKED;
    }
};
$4e1e107797f01458$var$_init3 = $4e1e107797f01458$var$__decoratorStart(null);
$4e1e107797f01458$var$__b = new WeakMap();
$4e1e107797f01458$var$__a = new WeakMap();
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init3, 4, $4e1e107797f01458$var$_b, $4e1e107797f01458$var$_dec2, $4e1e107797f01458$var$ScrollLock, $4e1e107797f01458$var$__b);
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init3, 4, $4e1e107797f01458$var$_a3, $4e1e107797f01458$var$_dec, $4e1e107797f01458$var$ScrollLock, $4e1e107797f01458$var$__a);
$4e1e107797f01458$var$__decoratorMetadata($4e1e107797f01458$var$_init3, $4e1e107797f01458$var$ScrollLock);
// src/core/plugins/scrolling/ScrollIntent.ts
var $4e1e107797f01458$var$DIRECTIONS = [
    (0, $501f8c524dad2740$export$ef1760368e0f70e4).Forward,
    (0, $501f8c524dad2740$export$ef1760368e0f70e4).Reverse
];
var $4e1e107797f01458$var$ScrollIntent = class {
    constructor(){
        this.x = new $4e1e107797f01458$var$ScrollLock();
        this.y = new $4e1e107797f01458$var$ScrollLock();
    }
    isLocked() {
        return this.x.isLocked() && this.y.isLocked();
    }
};
var $4e1e107797f01458$var$ScrollIntentTracker = class extends (0, $9636818b04ce7da6$export$901cf72dabf2112a) {
    constructor(manager){
        super(manager);
        const scrollIntent = (0, $c60338eb080e669a$export$e2ef10f86a8d60e8)(new $4e1e107797f01458$var$ScrollIntent());
        let previousDelta = null;
        this.signal = scrollIntent;
        (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            const { status: status } = manager.dragOperation;
            if (!status.initialized) {
                previousDelta = null;
                scrollIntent.value = new $4e1e107797f01458$var$ScrollIntent();
                return;
            }
            const { delta: delta } = manager.dragOperation.position;
            if (previousDelta) {
                const directions = {
                    x: $4e1e107797f01458$var$getDirection(delta.x, previousDelta.x),
                    y: $4e1e107797f01458$var$getDirection(delta.y, previousDelta.y)
                };
                const intent = scrollIntent.peek();
                (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
                    for (const axis of (0, $ce41d7a96a1e68fd$export$387a78ab20784494)){
                        for (const direction of $4e1e107797f01458$var$DIRECTIONS)if (directions[axis] === direction) intent[axis].unlock(direction);
                    }
                    scrollIntent.value = intent;
                });
            }
            previousDelta = delta;
        });
    }
    get current() {
        return this.signal.peek();
    }
};
function $4e1e107797f01458$var$getDirection(a, b) {
    return Math.sign(a - b);
}
// src/core/plugins/scrolling/Scroller.ts
var $4e1e107797f01458$var$_autoScrolling_dec, $4e1e107797f01458$var$_a4, $4e1e107797f01458$var$_init4, $4e1e107797f01458$var$_autoScrolling, $4e1e107797f01458$var$_meta, $4e1e107797f01458$var$_scroll;
var $4e1e107797f01458$export$76d6749d1cf8513c = class extends ($4e1e107797f01458$var$_a4 = (0, $9636818b04ce7da6$export$18cc238caa2b61f6), $4e1e107797f01458$var$_autoScrolling_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $4e1e107797f01458$var$_a4) {
    constructor(manager){
        super(manager);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_autoScrolling, $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init4, 8, this, false)), $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init4, 11, this);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_meta);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_scroll, ()=>{
            if (!$4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_meta)) return;
            const { element: element, by: by } = $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_meta);
            if (by.y) element.scrollTop += by.y;
            if (by.x) element.scrollLeft += by.x;
        });
        this.scroll = (options, scrollOptions)=>{
            var _a5;
            if (this.disabled) return false;
            const elements = this.getScrollableElements();
            if (!elements) {
                $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_meta, void 0);
                return false;
            }
            const { position: position } = this.manager.dragOperation;
            const currentPosition = position == null ? void 0 : position.current;
            if (currentPosition) {
                const { by: by } = options != null ? options : {};
                const intent = by ? {
                    x: $4e1e107797f01458$var$getScrollIntent(by.x),
                    y: $4e1e107797f01458$var$getScrollIntent(by.y)
                } : void 0;
                const scrollIntent = intent ? void 0 : this.scrollIntentTracker.current;
                if (scrollIntent == null ? void 0 : scrollIntent.isLocked()) return false;
                for (const scrollableElement of elements){
                    const elementCanScroll = (0, $501f8c524dad2740$export$49f2cecc68ed63a1)(scrollableElement, by);
                    if (elementCanScroll.x || elementCanScroll.y) {
                        const { speed: speed, direction: direction } = (0, $501f8c524dad2740$export$68d0a9072bb41c7d)(scrollableElement, currentPosition, intent, scrollOptions == null ? void 0 : scrollOptions.acceleration, scrollOptions == null ? void 0 : scrollOptions.threshold);
                        if (scrollIntent) {
                            for (const axis of (0, $ce41d7a96a1e68fd$export$387a78ab20784494))if (scrollIntent[axis].isLocked(direction[axis])) {
                                speed[axis] = 0;
                                direction[axis] = 0;
                            }
                        }
                        if (direction.x || direction.y) {
                            const { x: x1, y: y } = by != null ? by : direction;
                            const scrollLeftBy = x1 * speed.x;
                            const scrollTopBy = y * speed.y;
                            if (scrollLeftBy || scrollTopBy) {
                                const previousScrollBy = (_a5 = $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_meta)) == null ? void 0 : _a5.by;
                                if (this.autoScrolling && previousScrollBy) {
                                    const scrollIntentMismatch = previousScrollBy.x && !scrollLeftBy || previousScrollBy.y && !scrollTopBy;
                                    if (scrollIntentMismatch) continue;
                                }
                                $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_meta, {
                                    element: scrollableElement,
                                    by: {
                                        x: scrollLeftBy,
                                        y: scrollTopBy
                                    }
                                });
                                (0, $501f8c524dad2740$export$d30788f2c20241cd).schedule($4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_scroll));
                                return true;
                            }
                        }
                    }
                }
            }
            $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_meta, void 0);
            return false;
        };
        let previousElementFromPoint = null;
        let previousScrollableElements = null;
        const elementFromPoint = (0, $eb0d2ed00918af28$export$2983e091f1a1e8e2)(()=>{
            const { position: position, source: source } = manager.dragOperation;
            if (!position) return null;
            const element = (0, $501f8c524dad2740$export$7ec1070137f7ab66)((0, $501f8c524dad2740$export$31e4419873013369)(source == null ? void 0 : source.element), position.current);
            if (element) previousElementFromPoint = element;
            return element != null ? element : previousElementFromPoint;
        });
        const scrollableElements = (0, $eb0d2ed00918af28$export$2983e091f1a1e8e2)(()=>{
            const element = elementFromPoint.value;
            const { documentElement: documentElement } = (0, $501f8c524dad2740$export$f65ca476c09acec0)(element);
            if (!element || element === documentElement) {
                const { target: target } = manager.dragOperation;
                const targetElement = target == null ? void 0 : target.element;
                if (targetElement) {
                    const elements = (0, $501f8c524dad2740$export$e4864aa91b5ed091)(targetElement, {
                        excludeElement: false
                    });
                    previousScrollableElements = elements;
                    return elements;
                }
            }
            if (element) {
                const elements = (0, $501f8c524dad2740$export$e4864aa91b5ed091)(element, {
                    excludeElement: false
                });
                if (this.autoScrolling && previousScrollableElements && elements.size < (previousScrollableElements == null ? void 0 : previousScrollableElements.size)) return previousScrollableElements;
                previousScrollableElements = elements;
                return elements;
            }
            previousScrollableElements = null;
            return null;
        }, (0, $eb0d2ed00918af28$export$9cb4719e2e525b7a));
        this.getScrollableElements = ()=>{
            return scrollableElements.value;
        };
        this.scrollIntentTracker = new $4e1e107797f01458$var$ScrollIntentTracker(manager);
        this.destroy = manager.monitor.addEventListener("dragmove", (event)=>{
            if (this.disabled || event.defaultPrevented || !(0, $501f8c524dad2740$export$130b789831072f4c)(manager.dragOperation.activatorEvent) || !event.by) return;
            if (this.scroll({
                by: event.by
            })) event.preventDefault();
        });
    }
};
$4e1e107797f01458$var$_init4 = $4e1e107797f01458$var$__decoratorStart($4e1e107797f01458$var$_a4);
$4e1e107797f01458$var$_autoScrolling = new WeakMap();
$4e1e107797f01458$var$_meta = new WeakMap();
$4e1e107797f01458$var$_scroll = new WeakMap();
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init4, 4, "autoScrolling", $4e1e107797f01458$var$_autoScrolling_dec, $4e1e107797f01458$export$76d6749d1cf8513c, $4e1e107797f01458$var$_autoScrolling);
$4e1e107797f01458$var$__decoratorMetadata($4e1e107797f01458$var$_init4, $4e1e107797f01458$export$76d6749d1cf8513c);
function $4e1e107797f01458$var$getScrollIntent(value) {
    if (value > 0) return (0, $501f8c524dad2740$export$ef1760368e0f70e4).Forward;
    if (value < 0) return (0, $501f8c524dad2740$export$ef1760368e0f70e4).Reverse;
    return (0, $501f8c524dad2740$export$ef1760368e0f70e4).Idle;
}
// src/utilities/scheduling/scheduler.ts
var $4e1e107797f01458$var$Scheduler = class {
    constructor(scheduler5){
        this.scheduler = scheduler5;
        this.pending = false;
        this.tasks = /* @__PURE__ */ new Set();
        this.resolvers = /* @__PURE__ */ new Set();
        this.flush = ()=>{
            const { tasks: tasks, resolvers: resolvers } = this;
            this.pending = false;
            this.tasks = /* @__PURE__ */ new Set();
            this.resolvers = /* @__PURE__ */ new Set();
            for (const task of tasks)task();
            for (const resolve of resolvers)resolve();
        };
    }
    schedule(task) {
        this.tasks.add(task);
        if (!this.pending) {
            this.pending = true;
            this.scheduler(this.flush);
        }
        return new Promise((resolve)=>this.resolvers.add(resolve));
    }
};
var $4e1e107797f01458$var$scheduler3 = new $4e1e107797f01458$var$Scheduler((callback)=>{
    if (typeof requestAnimationFrame === "function") requestAnimationFrame(callback);
    else callback();
});
// src/core/plugins/scrolling/AutoScroller.ts
var $4e1e107797f01458$var$AUTOSCROLL_INTERVAL = 10;
var $4e1e107797f01458$var$_AutoScroller = class _AutoScroller extends (0, $9636818b04ce7da6$export$901cf72dabf2112a) {
    constructor(manager, options){
        super(manager, options);
        const scroller = manager.registry.plugins.get($4e1e107797f01458$export$76d6749d1cf8513c);
        if (!scroller) throw new Error("AutoScroller plugin depends on Scroller plugin");
        this.destroy = (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            var _a5, _b2, _c3;
            if (this.disabled) return;
            const { position: _, status: status } = manager.dragOperation;
            if (status.dragging) {
                const scrollOptions = {
                    acceleration: (_a5 = this.options) == null ? void 0 : _a5.acceleration,
                    threshold: typeof ((_b2 = this.options) == null ? void 0 : _b2.threshold) === "number" ? {
                        x: this.options.threshold,
                        y: this.options.threshold
                    } : (_c3 = this.options) == null ? void 0 : _c3.threshold
                };
                const canScroll2 = scroller.scroll(void 0, scrollOptions);
                if (canScroll2) {
                    scroller.autoScrolling = true;
                    const interval = setInterval(()=>$4e1e107797f01458$var$scheduler3.schedule(()=>scroller.scroll(void 0, scrollOptions)), $4e1e107797f01458$var$AUTOSCROLL_INTERVAL);
                    return ()=>{
                        clearInterval(interval);
                    };
                } else scroller.autoScrolling = false;
            }
        });
    }
};
$4e1e107797f01458$var$_AutoScroller.configure = (0, $9636818b04ce7da6$export$adf416f00cca6418)($4e1e107797f01458$var$_AutoScroller);
var $4e1e107797f01458$export$305ce2ba97930a0b = $4e1e107797f01458$var$_AutoScroller;
var $4e1e107797f01458$var$listenerOptions = {
    capture: true,
    passive: true
};
var $4e1e107797f01458$var$_timeout;
var $4e1e107797f01458$export$1f8bfdc257fcba53 = class extends (0, $9636818b04ce7da6$export$18cc238caa2b61f6) {
    constructor(manager){
        super(manager);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_timeout);
        this.handleScroll = ()=>{
            if ($4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_timeout) == null) $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_timeout, setTimeout(()=>{
                this.manager.collisionObserver.forceUpdate(false);
                $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_timeout, void 0);
            }, 50));
        };
        const { dragOperation: dragOperation } = this.manager;
        this.destroy = (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            var _a5, _b2, _c3;
            const enabled = dragOperation.status.dragging;
            if (enabled) {
                const root = (_c3 = (_b2 = (_a5 = dragOperation.source) == null ? void 0 : _a5.element) == null ? void 0 : _b2.ownerDocument) != null ? _c3 : document;
                root.addEventListener("scroll", this.handleScroll, $4e1e107797f01458$var$listenerOptions);
                return ()=>{
                    root.removeEventListener("scroll", this.handleScroll, $4e1e107797f01458$var$listenerOptions);
                };
            }
        });
    }
};
$4e1e107797f01458$var$_timeout = new WeakMap();
var $4e1e107797f01458$var$CSS_RULES2 = "* { user-select: none !important; -webkit-user-select: none !important; }";
var $4e1e107797f01458$export$9fe7600bdd252902 = class extends (0, $9636818b04ce7da6$export$901cf72dabf2112a) {
    constructor(manager){
        super(manager);
        this.manager = manager;
        const styleInjector = manager.registry.plugins.get($4e1e107797f01458$export$41faeb3470f9cb1);
        const unregisterStyles = styleInjector == null ? void 0 : styleInjector.register($4e1e107797f01458$var$CSS_RULES2);
        this.destroy = (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            const { dragOperation: dragOperation } = this.manager;
            if (dragOperation.status.initialized) {
                $4e1e107797f01458$var$removeSelection();
                document.addEventListener("selectionchange", $4e1e107797f01458$var$removeSelection, {
                    capture: true
                });
                return ()=>{
                    document.removeEventListener("selectionchange", $4e1e107797f01458$var$removeSelection, {
                        capture: true
                    });
                };
            }
        });
        if (unregisterStyles) {
            const originalDestroy = this.destroy.bind(this);
            this.destroy = ()=>{
                unregisterStyles();
                originalDestroy();
            };
        }
    }
};
function $4e1e107797f01458$var$removeSelection() {
    var _a5;
    (_a5 = document.getSelection()) == null || _a5.removeAllRanges();
}
var $4e1e107797f01458$var$defaults = Object.freeze({
    offset: 10,
    keyboardCodes: {
        start: [
            "Space",
            "Enter"
        ],
        cancel: [
            "Escape"
        ],
        end: [
            "Space",
            "Enter",
            "Tab"
        ],
        up: [
            "ArrowUp"
        ],
        down: [
            "ArrowDown"
        ],
        left: [
            "ArrowLeft"
        ],
        right: [
            "ArrowRight"
        ]
    },
    preventActivation (event, source) {
        var _a5;
        const target = (_a5 = source.handle) != null ? _a5 : source.element;
        return event.target !== target;
    }
});
var $4e1e107797f01458$var$_cleanupFunctions;
var $4e1e107797f01458$var$_KeyboardSensor = class _KeyboardSensor extends (0, $9636818b04ce7da6$export$f5fe6b3a9dfe845b) {
    constructor(manager, options){
        super(manager);
        this.manager = manager;
        this.options = options;
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_cleanupFunctions, []);
        this.listeners = new (0, $501f8c524dad2740$export$3bcecaeba2732bae)();
        this.handleSourceKeyDown = (event, source, options)=>{
            if (this.disabled || event.defaultPrevented) return;
            if (!(0, $501f8c524dad2740$export$45a5e7f76e0caa8d)(event.target)) return;
            if (source.disabled) return;
            const { keyboardCodes: keyboardCodes = $4e1e107797f01458$var$defaults.keyboardCodes, preventActivation: preventActivation = $4e1e107797f01458$var$defaults.preventActivation } = options != null ? options : {};
            if (!keyboardCodes.start.includes(event.code)) return;
            if (!this.manager.dragOperation.status.idle) return;
            if (preventActivation == null ? void 0 : preventActivation(event, source)) return;
            this.handleStart(event, source, options);
        };
    }
    bind(source, options = this.options) {
        const unbind = (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            var _a5;
            const target = (_a5 = source.handle) != null ? _a5 : source.element;
            const listener = (event)=>{
                if ((0, $501f8c524dad2740$export$130b789831072f4c)(event)) this.handleSourceKeyDown(event, source, options);
            };
            if (target) {
                target.addEventListener("keydown", listener);
                return ()=>{
                    target.removeEventListener("keydown", listener);
                };
            }
        });
        return unbind;
    }
    handleStart(event, source, options) {
        const { element: element } = source;
        if (!element) throw new Error("Source draggable does not have an associated element");
        event.preventDefault();
        event.stopImmediatePropagation();
        (0, $501f8c524dad2740$export$9657601bf1e130ee)(element);
        const { center: center } = new (0, $501f8c524dad2740$export$9be488f2d210405c)(element);
        const controller = this.manager.actions.start({
            event: event,
            coordinates: {
                x: center.x,
                y: center.y
            },
            source: source
        });
        if (controller.signal.aborted) return this.cleanup();
        this.sideEffects();
        const sourceDocument = (0, $501f8c524dad2740$export$f65ca476c09acec0)(element);
        const listeners = [
            this.listeners.bind(sourceDocument, [
                {
                    type: "keydown",
                    listener: (event2)=>this.handleKeyDown(event2, source, options),
                    options: {
                        capture: true
                    }
                }
            ])
        ];
        $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_cleanupFunctions).push(...listeners);
    }
    handleKeyDown(event, _source, options) {
        const { keyboardCodes: keyboardCodes = $4e1e107797f01458$var$defaults.keyboardCodes } = options != null ? options : {};
        if ($4e1e107797f01458$var$isKeycode(event, [
            ...keyboardCodes.end,
            ...keyboardCodes.cancel
        ])) {
            event.preventDefault();
            const canceled = $4e1e107797f01458$var$isKeycode(event, keyboardCodes.cancel);
            this.handleEnd(event, canceled);
            return;
        }
        if ($4e1e107797f01458$var$isKeycode(event, keyboardCodes.up)) this.handleMove("up", event);
        else if ($4e1e107797f01458$var$isKeycode(event, keyboardCodes.down)) this.handleMove("down", event);
        if ($4e1e107797f01458$var$isKeycode(event, keyboardCodes.left)) this.handleMove("left", event);
        else if ($4e1e107797f01458$var$isKeycode(event, keyboardCodes.right)) this.handleMove("right", event);
    }
    handleEnd(event, canceled) {
        this.manager.actions.stop({
            event: event,
            canceled: canceled
        });
        this.cleanup();
    }
    handleMove(direction, event) {
        var _a5, _b2;
        const { shape: shape } = this.manager.dragOperation;
        const factor = event.shiftKey ? 5 : 1;
        let by = {
            x: 0,
            y: 0
        };
        let offset = (_b2 = (_a5 = this.options) == null ? void 0 : _a5.offset) != null ? _b2 : $4e1e107797f01458$var$defaults.offset;
        if (typeof offset === "number") offset = {
            x: offset,
            y: offset
        };
        if (!shape) return;
        switch(direction){
            case "up":
                by = {
                    x: 0,
                    y: -offset.y * factor
                };
                break;
            case "down":
                by = {
                    x: 0,
                    y: offset.y * factor
                };
                break;
            case "left":
                by = {
                    x: -offset.x * factor,
                    y: 0
                };
                break;
            case "right":
                by = {
                    x: offset.x * factor,
                    y: 0
                };
                break;
        }
        if (by.x || by.y) {
            event.preventDefault();
            this.manager.actions.move({
                event: event,
                by: by
            });
        }
    }
    sideEffects() {
        const autoScroller = this.manager.registry.plugins.get($4e1e107797f01458$export$305ce2ba97930a0b);
        if ((autoScroller == null ? void 0 : autoScroller.disabled) === false) {
            autoScroller.disable();
            $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_cleanupFunctions).push(()=>{
                autoScroller.enable();
            });
        }
    }
    cleanup() {
        $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_cleanupFunctions).forEach((cleanup)=>cleanup());
        $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_cleanupFunctions, []);
    }
    destroy() {
        this.cleanup();
        this.listeners.clear();
    }
};
$4e1e107797f01458$var$_cleanupFunctions = new WeakMap();
$4e1e107797f01458$var$_KeyboardSensor.configure = (0, $9636818b04ce7da6$export$adf416f00cca6418)($4e1e107797f01458$var$_KeyboardSensor);
$4e1e107797f01458$var$_KeyboardSensor.defaults = $4e1e107797f01458$var$defaults;
var $4e1e107797f01458$export$44d67f2a438aeba9 = $4e1e107797f01458$var$_KeyboardSensor;
function $4e1e107797f01458$var$isKeycode(event, codes) {
    return codes.includes(event.code);
}
var $4e1e107797f01458$var$_coordinates;
var $4e1e107797f01458$var$DistanceConstraint = class extends (0, $9636818b04ce7da6$export$6b6cd3704757e071) {
    constructor(){
        super(...arguments);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_coordinates);
    }
    onEvent(event) {
        switch(event.type){
            case "pointerdown":
                $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_coordinates, (0, $501f8c524dad2740$export$36195c8aa1517e04)(event));
                break;
            case "pointermove":
                if (!$4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_coordinates)) return;
                const { x: x1, y: y } = (0, $501f8c524dad2740$export$36195c8aa1517e04)(event);
                const delta = {
                    x: x1 - $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_coordinates).x,
                    y: y - $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_coordinates).y
                };
                const { tolerance: tolerance } = this.options;
                if (tolerance && (0, $ce41d7a96a1e68fd$export$5f766be895d17cfc)(delta, tolerance)) {
                    this.abort();
                    return;
                }
                if ((0, $ce41d7a96a1e68fd$export$5f766be895d17cfc)(delta, this.options.value)) this.activate(event);
                break;
            case "pointerup":
                this.abort();
                break;
        }
    }
    abort() {
        $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_coordinates, void 0);
    }
};
$4e1e107797f01458$var$_coordinates = new WeakMap();
var $4e1e107797f01458$var$_timeout2, $4e1e107797f01458$var$_coordinates2;
var $4e1e107797f01458$var$DelayConstraint = class extends (0, $9636818b04ce7da6$export$6b6cd3704757e071) {
    constructor(){
        super(...arguments);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_timeout2);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_coordinates2);
    }
    onEvent(event) {
        switch(event.type){
            case "pointerdown":
                $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_coordinates2, (0, $501f8c524dad2740$export$36195c8aa1517e04)(event));
                $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_timeout2, setTimeout(()=>this.activate(event), this.options.value));
                break;
            case "pointermove":
                if (!$4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_coordinates2)) return;
                const { x: x1, y: y } = (0, $501f8c524dad2740$export$36195c8aa1517e04)(event);
                const delta = {
                    x: x1 - $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_coordinates2).x,
                    y: y - $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_coordinates2).y
                };
                if ((0, $ce41d7a96a1e68fd$export$5f766be895d17cfc)(delta, this.options.tolerance)) this.abort();
                break;
            case "pointerup":
                this.abort();
                break;
        }
    }
    abort() {
        if ($4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_timeout2)) {
            clearTimeout($4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_timeout2));
            $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_coordinates2, void 0);
            $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_timeout2, void 0);
        }
    }
};
$4e1e107797f01458$var$_timeout2 = new WeakMap();
$4e1e107797f01458$var$_coordinates2 = new WeakMap();
// src/core/sensors/pointer/PointerActivationConstraints.ts
var $4e1e107797f01458$export$863a6e64d6b9f7f4 = class {
};
$4e1e107797f01458$export$863a6e64d6b9f7f4.Delay = $4e1e107797f01458$var$DelayConstraint;
$4e1e107797f01458$export$863a6e64d6b9f7f4.Distance = $4e1e107797f01458$var$DistanceConstraint;
// src/core/sensors/pointer/PointerSensor.ts
var $4e1e107797f01458$var$defaults2 = Object.freeze({
    activationConstraints (event, source) {
        var _a5;
        const { pointerType: pointerType, target: target } = event;
        if (pointerType === "mouse" && (0, $501f8c524dad2740$export$45a5e7f76e0caa8d)(target) && (source.handle === target || ((_a5 = source.handle) == null ? void 0 : _a5.contains(target)))) return void 0;
        if (pointerType === "touch") return [
            new $4e1e107797f01458$export$863a6e64d6b9f7f4.Delay({
                value: 250,
                tolerance: 5
            })
        ];
        if ((0, $501f8c524dad2740$export$3e6057b9bf6b0bbb)(target) && !event.defaultPrevented) return [
            new $4e1e107797f01458$export$863a6e64d6b9f7f4.Delay({
                value: 200,
                tolerance: 0
            })
        ];
        return [
            new $4e1e107797f01458$export$863a6e64d6b9f7f4.Delay({
                value: 200,
                tolerance: 10
            }),
            new $4e1e107797f01458$export$863a6e64d6b9f7f4.Distance({
                value: 5
            })
        ];
    },
    preventActivation (event, source) {
        var _a5;
        const { target: target } = event;
        if (target === source.element) return false;
        if (target === source.handle) return false;
        if (!(0, $501f8c524dad2740$export$45a5e7f76e0caa8d)(target)) return false;
        if ((_a5 = source.handle) == null ? void 0 : _a5.contains(target)) return false;
        return (0, $501f8c524dad2740$export$3dee5e4542c672d9)(target);
    }
});
var $4e1e107797f01458$var$_cleanup;
var $4e1e107797f01458$var$_PointerSensor = class _PointerSensor extends (0, $9636818b04ce7da6$export$f5fe6b3a9dfe845b) {
    constructor(manager, options){
        super(manager);
        this.manager = manager;
        this.options = options;
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_cleanup, /* @__PURE__ */ new Set());
        this.listeners = new (0, $501f8c524dad2740$export$3bcecaeba2732bae)();
        this.latest = {
            event: void 0,
            coordinates: void 0
        };
        this.handleMove = ()=>{
            const { event: event, coordinates: to } = this.latest;
            if (!event || !to) return;
            this.manager.actions.move({
                event: event,
                to: to
            });
        };
        this.handleCancel = this.handleCancel.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    activationConstraints(event, source, options = this.options) {
        const { activationConstraints: activationConstraints = $4e1e107797f01458$var$defaults2.activationConstraints } = options != null ? options : {};
        const constraints = typeof activationConstraints === "function" ? activationConstraints(event, source) : activationConstraints;
        return constraints;
    }
    bind(source, options = this.options) {
        const unbind = (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            var _a5;
            const controller = new AbortController();
            const { signal: signal3 } = controller;
            const listener = (event)=>{
                if ((0, $501f8c524dad2740$export$1d0a87a519049f8c)(event)) this.handlePointerDown(event, source, options);
            };
            let targets = [
                (_a5 = source.handle) != null ? _a5 : source.element
            ];
            if (options == null ? void 0 : options.activatorElements) {
                if (Array.isArray(options.activatorElements)) targets = options.activatorElements;
                else targets = options.activatorElements(source);
            }
            for (const target of targets){
                if (!target) continue;
                $4e1e107797f01458$var$patchWindow(target.ownerDocument.defaultView);
                target.addEventListener("pointerdown", listener, {
                    signal: signal3
                });
            }
            return ()=>controller.abort();
        });
        return unbind;
    }
    handlePointerDown(event, source, options) {
        if (this.disabled || !event.isPrimary || event.button !== 0 || !(0, $501f8c524dad2740$export$45a5e7f76e0caa8d)(event.target) || source.disabled || $4e1e107797f01458$var$isCapturedBySensor(event) || !this.manager.dragOperation.status.idle) return;
        const { preventActivation: preventActivation = $4e1e107797f01458$var$defaults2.preventActivation } = options != null ? options : {};
        if (preventActivation == null ? void 0 : preventActivation(event, source)) return;
        const { target: target } = event;
        const isNativeDraggable = (0, $501f8c524dad2740$export$1b3bfaa9684536aa)(target) && target.draggable && target.getAttribute("draggable") === "true";
        const offset = (0, $501f8c524dad2740$export$f7bade9204ccdfdf)(source.element);
        const { x: x1, y: y } = (0, $501f8c524dad2740$export$36195c8aa1517e04)(event);
        this.initialCoordinates = {
            x: x1 * offset.scaleX + offset.x,
            y: y * offset.scaleY + offset.y
        };
        const constraints = this.activationConstraints(event, source, options);
        event.sensor = this;
        const controller = new (0, $9636818b04ce7da6$export$cc3d5f129cc7a240)(constraints, (event2)=>this.handleStart(source, event2));
        controller.signal.onabort = ()=>this.handleCancel(event);
        controller.onEvent(event);
        this.controller = controller;
        const documents = (0, $501f8c524dad2740$export$782f6f8dc0feb7b3)();
        const unbindListeners = this.listeners.bind(documents, [
            {
                type: "pointermove",
                listener: (event2)=>this.handlePointerMove(event2, source)
            },
            {
                type: "pointerup",
                listener: this.handlePointerUp,
                options: {
                    capture: true
                }
            },
            {
                type: "pointercancel",
                listener: this.handleCancel
            },
            {
                // Cancel activation if there is a competing Drag and Drop interaction
                type: "dragstart",
                listener: isNativeDraggable ? this.handleCancel : $4e1e107797f01458$var$preventDefault,
                options: {
                    capture: true
                }
            }
        ]);
        const cleanup = ()=>{
            unbindListeners();
            this.initialCoordinates = void 0;
        };
        $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_cleanup).add(cleanup);
    }
    handlePointerMove(event, source) {
        var _a5, _b2;
        if (((_a5 = this.controller) == null ? void 0 : _a5.activated) === false) {
            (_b2 = this.controller) == null || _b2.onEvent(event);
            return;
        }
        if (this.manager.dragOperation.status.dragging) {
            const coordinates = (0, $501f8c524dad2740$export$36195c8aa1517e04)(event);
            const offset = (0, $501f8c524dad2740$export$f7bade9204ccdfdf)(source.element);
            coordinates.x = coordinates.x * offset.scaleX + offset.x;
            coordinates.y = coordinates.y * offset.scaleY + offset.y;
            event.preventDefault();
            event.stopPropagation();
            this.latest.event = event;
            this.latest.coordinates = coordinates;
            (0, $501f8c524dad2740$export$d30788f2c20241cd).schedule(this.handleMove);
        }
    }
    handlePointerUp(event) {
        const { status: status } = this.manager.dragOperation;
        if (!status.idle) {
            event.preventDefault();
            event.stopPropagation();
            const canceled = !status.initialized;
            this.manager.actions.stop({
                event: event,
                canceled: canceled
            });
        }
        this.cleanup();
    }
    handleKeyDown(event) {
        if (event.key === "Escape") {
            event.preventDefault();
            this.handleCancel(event);
        }
    }
    handleStart(source, event) {
        const { manager: manager, initialCoordinates: initialCoordinates } = this;
        if (!initialCoordinates || !manager.dragOperation.status.idle) return;
        if (event.defaultPrevented) return;
        const controller = manager.actions.start({
            coordinates: initialCoordinates,
            event: event,
            source: source
        });
        if (controller.signal.aborted) return this.cleanup();
        event.preventDefault();
        const ownerDocument = (0, $501f8c524dad2740$export$f65ca476c09acec0)(event.target);
        const pointerCaptureTarget = ownerDocument.body;
        try {
            pointerCaptureTarget.setPointerCapture(event.pointerId);
        } catch (e) {
            this.handleCancel(event);
            return;
        }
        const listenerTargets = (0, $501f8c524dad2740$export$45a5e7f76e0caa8d)(event.target) ? [
            event.target,
            pointerCaptureTarget
        ] : pointerCaptureTarget;
        const unbind = this.listeners.bind(listenerTargets, [
            {
                // Prevent scrolling on touch devices
                type: "touchmove",
                listener: $4e1e107797f01458$var$preventDefault,
                options: {
                    passive: false
                }
            },
            {
                // Prevent click events
                type: "click",
                listener: $4e1e107797f01458$var$preventDefault
            },
            {
                type: "contextmenu",
                listener: $4e1e107797f01458$var$preventDefault
            },
            {
                type: "keydown",
                listener: this.handleKeyDown
            }
        ]);
        $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_cleanup).add(unbind);
    }
    handleCancel(event) {
        const { dragOperation: dragOperation } = this.manager;
        if (dragOperation.status.initialized) this.manager.actions.stop({
            event: event,
            canceled: true
        });
        this.cleanup();
    }
    cleanup() {
        const { controller: controller } = this;
        this.controller = void 0;
        if (controller && !controller.signal.aborted) controller.abort();
        this.latest = {
            event: void 0,
            coordinates: void 0
        };
        $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_cleanup).forEach((cleanup)=>cleanup());
        $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_cleanup).clear();
    }
    destroy() {
        this.cleanup();
        this.listeners.clear();
    }
};
$4e1e107797f01458$var$_cleanup = new WeakMap();
$4e1e107797f01458$var$_PointerSensor.configure = (0, $9636818b04ce7da6$export$adf416f00cca6418)($4e1e107797f01458$var$_PointerSensor);
$4e1e107797f01458$var$_PointerSensor.defaults = $4e1e107797f01458$var$defaults2;
var $4e1e107797f01458$export$b26af955418d6638 = $4e1e107797f01458$var$_PointerSensor;
function $4e1e107797f01458$var$isCapturedBySensor(event) {
    return "sensor" in event;
}
function $4e1e107797f01458$var$preventDefault(event) {
    event.preventDefault();
}
function $4e1e107797f01458$var$noop() {}
var $4e1e107797f01458$var$windows = /* @__PURE__ */ new WeakSet();
function $4e1e107797f01458$var$patchWindow(window) {
    if (!window || $4e1e107797f01458$var$windows.has(window)) return;
    window.addEventListener("touchmove", $4e1e107797f01458$var$noop, {
        capture: false,
        passive: false
    });
    $4e1e107797f01458$var$windows.add(window);
}
// src/core/manager/manager.ts
var $4e1e107797f01458$export$233f63763fc1033c = {
    modifiers: [],
    plugins: [
        $4e1e107797f01458$export$ea0f6181e3388ffd,
        $4e1e107797f01458$export$305ce2ba97930a0b,
        $4e1e107797f01458$export$b6a79797ad180576,
        $4e1e107797f01458$export$175e500a48a60fd2,
        $4e1e107797f01458$export$9fe7600bdd252902
    ],
    sensors: [
        $4e1e107797f01458$export$b26af955418d6638,
        $4e1e107797f01458$export$44d67f2a438aeba9
    ]
};
var $4e1e107797f01458$export$67a2a1e978b42388 = class extends (0, $9636818b04ce7da6$export$67a2a1e978b42388) {
    constructor(input = {}){
        const plugins = (0, $9636818b04ce7da6$export$7158c2daed5164d3)(input.plugins, $4e1e107797f01458$export$233f63763fc1033c.plugins);
        const sensors = (0, $9636818b04ce7da6$export$7158c2daed5164d3)(input.sensors, $4e1e107797f01458$export$233f63763fc1033c.sensors);
        const modifiers = (0, $9636818b04ce7da6$export$7158c2daed5164d3)(input.modifiers, $4e1e107797f01458$export$233f63763fc1033c.modifiers);
        super($4e1e107797f01458$var$__spreadProps($4e1e107797f01458$var$__spreadValues({}, input), {
            plugins: [
                $4e1e107797f01458$export$1f8bfdc257fcba53,
                $4e1e107797f01458$export$76d6749d1cf8513c,
                $4e1e107797f01458$export$41faeb3470f9cb1,
                ...plugins
            ],
            sensors: sensors,
            modifiers: modifiers
        }));
    }
};
var $4e1e107797f01458$var$_element_dec, $4e1e107797f01458$var$_handle_dec, $4e1e107797f01458$var$_c, $4e1e107797f01458$var$_init5, $4e1e107797f01458$var$_handle, $4e1e107797f01458$var$_element;
var $4e1e107797f01458$export$f2a139e5d18b9882 = class extends ($4e1e107797f01458$var$_c = (0, $9636818b04ce7da6$export$f2a139e5d18b9882), $4e1e107797f01458$var$_handle_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $4e1e107797f01458$var$_element_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $4e1e107797f01458$var$_c) {
    constructor(_a5, manager){
        var _b2 = _a5, { element: element, effects: effects2 = ()=>[], handle: handle } = _b2, input = $4e1e107797f01458$var$__objRest(_b2, [
            "element",
            "effects",
            "handle"
        ]);
        super($4e1e107797f01458$var$__spreadValues({
            effects: ()=>[
                    ...effects2(),
                    ()=>{
                        var _a6, _b3;
                        const { manager: manager2 } = this;
                        if (!manager2) return;
                        const sensors = (_b3 = (_a6 = this.sensors) == null ? void 0 : _a6.map((0, $9636818b04ce7da6$export$480024ae1501d25a))) != null ? _b3 : [
                            ...manager2.sensors
                        ];
                        const unbindFunctions = sensors.map((entry)=>{
                            const sensorInstance = entry instanceof (0, $9636818b04ce7da6$export$f5fe6b3a9dfe845b) ? entry : manager2.registry.register(entry.plugin);
                            const options = entry instanceof (0, $9636818b04ce7da6$export$f5fe6b3a9dfe845b) ? void 0 : entry.options;
                            const unbind = sensorInstance.bind(this, options);
                            return unbind;
                        });
                        return function cleanup() {
                            unbindFunctions.forEach((unbind)=>unbind());
                        };
                    }
                ]
        }, input), manager);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_handle, $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init5, 8, this)), $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init5, 11, this);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_element, $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init5, 12, this)), $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init5, 15, this);
        this.element = element;
        this.handle = handle;
    }
};
$4e1e107797f01458$var$_init5 = $4e1e107797f01458$var$__decoratorStart($4e1e107797f01458$var$_c);
$4e1e107797f01458$var$_handle = new WeakMap();
$4e1e107797f01458$var$_element = new WeakMap();
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init5, 4, "handle", $4e1e107797f01458$var$_handle_dec, $4e1e107797f01458$export$f2a139e5d18b9882, $4e1e107797f01458$var$_handle);
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init5, 4, "element", $4e1e107797f01458$var$_element_dec, $4e1e107797f01458$export$f2a139e5d18b9882, $4e1e107797f01458$var$_element);
$4e1e107797f01458$var$__decoratorMetadata($4e1e107797f01458$var$_init5, $4e1e107797f01458$export$f2a139e5d18b9882);
var $4e1e107797f01458$var$_proxy_dec, $4e1e107797f01458$var$_element_dec2, $4e1e107797f01458$var$_c2, $4e1e107797f01458$var$_init6, $4e1e107797f01458$var$_element2, $4e1e107797f01458$var$_d, $4e1e107797f01458$var$element_get, $4e1e107797f01458$var$element_set, $4e1e107797f01458$var$_Droppable_instances, $4e1e107797f01458$var$_proxy;
var $4e1e107797f01458$export$423ec2075359570a = class extends ($4e1e107797f01458$var$_c2 = (0, $9636818b04ce7da6$export$423ec2075359570a), $4e1e107797f01458$var$_element_dec2 = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $4e1e107797f01458$var$_proxy_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $4e1e107797f01458$var$_c2) {
    constructor(_a5, manager){
        var _b2 = _a5, { element: element, effects: effects2 = ()=>[] } = _b2, input = $4e1e107797f01458$var$__objRest(_b2, [
            "element",
            "effects"
        ]);
        const { collisionDetector: collisionDetector = (0, $c970db14647306d6$export$459d48c6d804bc59) } = input;
        const updateShape = (boundingClientRect)=>{
            const { manager: manager2, element: element2 } = this;
            if (!element2 || boundingClientRect === null) {
                this.shape = void 0;
                return void 0;
            }
            if (!manager2) return;
            const updatedShape = new (0, $501f8c524dad2740$export$9be488f2d210405c)(element2);
            const shape = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>this.shape);
            if (updatedShape && (shape == null ? void 0 : shape.equals(updatedShape))) return shape;
            this.shape = updatedShape;
            return updatedShape;
        };
        const observePosition = (0, $c60338eb080e669a$export$e2ef10f86a8d60e8)(false);
        super($4e1e107797f01458$var$__spreadProps($4e1e107797f01458$var$__spreadValues({}, input), {
            collisionDetector: collisionDetector,
            effects: ()=>[
                    ...effects2(),
                    ()=>{
                        const { element: element2, manager: manager2 } = this;
                        if (!manager2) return;
                        const { dragOperation: dragOperation } = manager2;
                        const { source: source } = dragOperation;
                        observePosition.value = Boolean(source && dragOperation.status.initialized && element2 && !this.disabled && this.accepts(source));
                    },
                    ()=>{
                        const { element: element2 } = this;
                        if (observePosition.value && element2) {
                            const positionObserver = new (0, $501f8c524dad2740$export$4c9bdd7ce9d9c507)(element2, updateShape);
                            return ()=>{
                                positionObserver.disconnect();
                                this.shape = void 0;
                            };
                        }
                    },
                    ()=>{
                        var _a6;
                        if ((_a6 = this.manager) == null ? void 0 : _a6.dragOperation.status.initialized) return ()=>{
                            this.shape = void 0;
                        };
                    }
                ]
        }), manager);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_Droppable_instances);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_element2, $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init6, 8, this)), $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init6, 11, this);
        $4e1e107797f01458$var$__privateAdd(this, $4e1e107797f01458$var$_proxy, $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init6, 12, this)), $4e1e107797f01458$var$__runInitializers($4e1e107797f01458$var$_init6, 15, this);
        this.element = element;
        this.refreshShape = ()=>updateShape();
    }
    set element(element) {
        $4e1e107797f01458$var$__privateSet(this, $4e1e107797f01458$var$_Droppable_instances, element, $4e1e107797f01458$var$element_set);
    }
    get element() {
        var _a5;
        return (_a5 = this.proxy) != null ? _a5 : $4e1e107797f01458$var$__privateGet(this, $4e1e107797f01458$var$_Droppable_instances, $4e1e107797f01458$var$element_get);
    }
};
$4e1e107797f01458$var$_init6 = $4e1e107797f01458$var$__decoratorStart($4e1e107797f01458$var$_c2);
$4e1e107797f01458$var$_element2 = new WeakMap();
$4e1e107797f01458$var$_Droppable_instances = new WeakSet();
$4e1e107797f01458$var$_proxy = new WeakMap();
$4e1e107797f01458$var$_d = $4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init6, 20, "#element", $4e1e107797f01458$var$_element_dec2, $4e1e107797f01458$var$_Droppable_instances, $4e1e107797f01458$var$_element2), $4e1e107797f01458$var$element_get = $4e1e107797f01458$var$_d.get, $4e1e107797f01458$var$element_set = $4e1e107797f01458$var$_d.set;
$4e1e107797f01458$var$__decorateElement($4e1e107797f01458$var$_init6, 4, "proxy", $4e1e107797f01458$var$_proxy_dec, $4e1e107797f01458$export$423ec2075359570a, $4e1e107797f01458$var$_proxy);
$4e1e107797f01458$var$__decoratorMetadata($4e1e107797f01458$var$_init6, $4e1e107797f01458$export$423ec2075359570a);
 //# sourceMappingURL=index.js.map



var $63Xef = parcelRequire("63Xef");


// src/utilities/currentValue.ts
function $6e7add91e106627e$var$isRef(value) {
    return value != null && typeof value === "object" && "current" in value;
}
function $6e7add91e106627e$export$6cd4326f683953cc(value) {
    var _a;
    if (value == null) return void 0;
    if ($6e7add91e106627e$var$isRef(value)) return (_a = value.current) != null ? _a : void 0;
    return value;
}
 //# sourceMappingURL=utilities.js.map
 //# sourceMappingURL=utilities.js.map


function $7bd703b0876c5b19$export$fe4300aa8eebea86(initializer) {
    const ref = (0, $63Xef.useRef)(null);
    if (!ref.current) ref.current = initializer();
    return ref.current;
}
var $7bd703b0876c5b19$var$canUseDOM = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $7bd703b0876c5b19$export$700979bc83e7db82 = $7bd703b0876c5b19$var$canUseDOM ? (0, $63Xef.useLayoutEffect) : (0, $63Xef.useEffect);
function $7bd703b0876c5b19$var$useForceUpdate() {
    const setState = (0, $63Xef.useState)(0)[1];
    return (0, $63Xef.useCallback)(()=>{
        setState((value)=>value + 1);
    }, [
        setState
    ]);
}
// src/hooks/useSignal.ts
function $7bd703b0876c5b19$var$useSignal(signal, sync = false) {
    const previous = (0, $63Xef.useRef)(signal.peek());
    const read = (0, $63Xef.useRef)(false);
    const forceUpdate = $7bd703b0876c5b19$var$useForceUpdate();
    $7bd703b0876c5b19$export$700979bc83e7db82(()=>(0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            const previousValue = previous.current;
            const currentValue2 = signal.value;
            if (previousValue !== currentValue2) {
                previous.current = currentValue2;
                if (!read.current) return;
                if (sync) (0, $6b3cbfe7ceb06ab6$exports.flushSync)(forceUpdate);
                else forceUpdate();
            }
        }), [
        signal,
        sync,
        forceUpdate
    ]);
    return {
        get value () {
            read.current = true;
            return signal.peek();
        }
    };
}
// src/hooks/useComputed.ts
function $7bd703b0876c5b19$export$e3d20747ab930783(compute, dependencies = [], sync = false) {
    const $compute = (0, $63Xef.useRef)(compute);
    $compute.current = compute;
    return $7bd703b0876c5b19$var$useSignal((0, $63Xef.useMemo)(()=>(0, $eb0d2ed00918af28$export$2983e091f1a1e8e2)(()=>$compute.current()), dependencies), sync);
}
function $7bd703b0876c5b19$export$e772c6c16497c511(target, synchronous) {
    const tracked = (0, $63Xef.useRef)(/* @__PURE__ */ new Map());
    const forceUpdate = $7bd703b0876c5b19$var$useForceUpdate();
    $7bd703b0876c5b19$export$700979bc83e7db82(()=>{
        if (!target) {
            tracked.current.clear();
            return;
        }
        return (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            var _a;
            let stale = false;
            let sync = false;
            for (const entry of tracked.current){
                const [key] = entry;
                const value = (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>entry[1]);
                const latestValue = target[key];
                if (value !== latestValue) {
                    stale = true;
                    tracked.current.set(key, latestValue);
                    sync = (_a = synchronous == null ? void 0 : synchronous(key, value, latestValue)) != null ? _a : false;
                }
            }
            if (stale) {
                if (sync) queueMicrotask(()=>(0, $6b3cbfe7ceb06ab6$exports.flushSync)(forceUpdate));
                else forceUpdate();
            }
        });
    }, [
        target
    ]);
    return (0, $63Xef.useMemo)(()=>target ? new Proxy(target, {
            get (target2, key) {
                const value = target2[key];
                tracked.current.set(key, value);
                return value;
            }
        }) : target, [
        target
    ]);
}
// src/hooks/useImmediateEffect.ts
function $7bd703b0876c5b19$export$3f1c0a9c9a084c1d(callback, _) {
    callback();
}
function $7bd703b0876c5b19$export$d4b699e2c1148419(value) {
    const valueRef = (0, $63Xef.useRef)(value);
    $7bd703b0876c5b19$export$700979bc83e7db82(()=>{
        valueRef.current = value;
    }, [
        value
    ]);
    return valueRef;
}
function $7bd703b0876c5b19$export$938b73b4a74ac57a(value, onChange, effect3 = (0, $63Xef.useEffect), compare = Object.is) {
    const tracked = (0, $63Xef.useRef)(value);
    effect3(()=>{
        const oldValue = tracked.current;
        if (!compare(value, oldValue)) {
            tracked.current = value;
            onChange(value, oldValue);
        }
    }, [
        onChange,
        value
    ]);
}
function $7bd703b0876c5b19$export$e167ec28bc041c4d(value, onChange) {
    const previous = (0, $63Xef.useRef)((0, $6e7add91e106627e$export$6cd4326f683953cc)(value));
    $7bd703b0876c5b19$export$700979bc83e7db82(()=>{
        const current = (0, $6e7add91e106627e$export$6cd4326f683953cc)(value);
        if (current !== previous.current) {
            previous.current = current;
            onChange(current);
        }
    });
}
 //# sourceMappingURL=hooks.js.map
 //# sourceMappingURL=hooks.js.map






var $7d57415ac2032ee5$var$__defProp = Object.defineProperty;
var $7d57415ac2032ee5$var$__defProps = Object.defineProperties;
var $7d57415ac2032ee5$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7d57415ac2032ee5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7d57415ac2032ee5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7d57415ac2032ee5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7d57415ac2032ee5$var$__defNormalProp = (obj, key, value)=>key in obj ? $7d57415ac2032ee5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7d57415ac2032ee5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7d57415ac2032ee5$var$__hasOwnProp.call(b, prop)) $7d57415ac2032ee5$var$__defNormalProp(a, prop, b[prop]);
    if ($7d57415ac2032ee5$var$__getOwnPropSymbols) {
        for (var prop of $7d57415ac2032ee5$var$__getOwnPropSymbols(b))if ($7d57415ac2032ee5$var$__propIsEnum.call(b, prop)) $7d57415ac2032ee5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7d57415ac2032ee5$var$__spreadProps = (a, b)=>$7d57415ac2032ee5$var$__defProps(a, $7d57415ac2032ee5$var$__getOwnPropDescs(b));
var $7d57415ac2032ee5$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($7d57415ac2032ee5$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $7d57415ac2032ee5$var$__getOwnPropSymbols) {
        for (var prop of $7d57415ac2032ee5$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $7d57415ac2032ee5$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $7d57415ac2032ee5$var$defaultManager = new (0, $4e1e107797f01458$export$67a2a1e978b42388)();
var $7d57415ac2032ee5$var$DragDropContext = (0, $63Xef.createContext)($7d57415ac2032ee5$var$defaultManager);
var $7d57415ac2032ee5$var$Renderer = (0, $63Xef.memo)((0, $63Xef.forwardRef)(({ children: children }, ref)=>{
    const [transitionCount, setTransitionCount] = (0, $63Xef.useState)(0);
    const rendering = (0, $63Xef.useRef)(null);
    const resolver = (0, $63Xef.useRef)(null);
    const renderer = (0, $63Xef.useMemo)(()=>({
            renderer: {
                get rendering () {
                    var _a2;
                    return (_a2 = rendering.current) != null ? _a2 : Promise.resolve();
                }
            },
            trackRendering (callback) {
                if (!rendering.current) rendering.current = new Promise((resolve)=>{
                    resolver.current = resolve;
                });
                (0, $63Xef.startTransition)(()=>{
                    callback();
                    setTransitionCount((count)=>count + 1);
                });
            }
        }), []);
    (0, $7bd703b0876c5b19$export$700979bc83e7db82)(()=>{
        var _a2;
        (_a2 = resolver.current) == null || _a2.call(resolver);
        rendering.current = null;
    }, [
        children,
        transitionCount
    ]);
    (0, $63Xef.useImperativeHandle)(ref, ()=>renderer);
    return null;
}));
var $7d57415ac2032ee5$var$options = [
    void 0,
    (0, $eb0d2ed00918af28$export$9cb4719e2e525b7a)
];
function $7d57415ac2032ee5$export$a6431530a8ce8288(_a2) {
    var _b = _a2, { children: children, onCollision: onCollision, onBeforeDragStart: onBeforeDragStart, onDragStart: onDragStart, onDragMove: onDragMove, onDragOver: onDragOver, onDragEnd: onDragEnd } = _b, input = $7d57415ac2032ee5$var$__objRest(_b, [
        "children",
        "onCollision",
        "onBeforeDragStart",
        "onDragStart",
        "onDragMove",
        "onDragOver",
        "onDragEnd"
    ]);
    const rendererRef = (0, $63Xef.useRef)(null);
    const { plugins: pluginsInput, modifiers: modifiersInput, sensors: sensorsInput } = input;
    const plugins = (0, $9636818b04ce7da6$export$7158c2daed5164d3)(pluginsInput, (0, $4e1e107797f01458$export$233f63763fc1033c).plugins);
    const sensors = (0, $9636818b04ce7da6$export$7158c2daed5164d3)(sensorsInput, (0, $4e1e107797f01458$export$233f63763fc1033c).sensors);
    const modifiers = (0, $9636818b04ce7da6$export$7158c2daed5164d3)(modifiersInput, (0, $4e1e107797f01458$export$233f63763fc1033c).modifiers);
    const handleBeforeDragStart = (0, $7bd703b0876c5b19$export$d4b699e2c1148419)(onBeforeDragStart);
    const handleDragStart = (0, $7bd703b0876c5b19$export$d4b699e2c1148419)(onDragStart);
    const handleDragOver = (0, $7bd703b0876c5b19$export$d4b699e2c1148419)(onDragOver);
    const handleDragMove = (0, $7bd703b0876c5b19$export$d4b699e2c1148419)(onDragMove);
    const handleDragEnd = (0, $7bd703b0876c5b19$export$d4b699e2c1148419)(onDragEnd);
    const handleCollision = (0, $7bd703b0876c5b19$export$d4b699e2c1148419)(onCollision);
    const manager = $7d57415ac2032ee5$var$useStableInstance(()=>{
        var _a3;
        return (_a3 = input.manager) != null ? _a3 : new (0, $4e1e107797f01458$export$67a2a1e978b42388)(input);
    });
    (0, $63Xef.useEffect)(()=>{
        if (!rendererRef.current) throw new Error("Renderer not found");
        const { renderer: renderer, trackRendering: trackRendering } = rendererRef.current;
        const { monitor: monitor } = manager;
        manager.renderer = renderer;
        const listeners = [
            monitor.addEventListener("beforedragstart", (event)=>{
                const callback = handleBeforeDragStart.current;
                if (callback) trackRendering(()=>callback(event, manager));
            }),
            monitor.addEventListener("dragstart", (event)=>{
                var _a3;
                return (_a3 = handleDragStart.current) == null ? void 0 : _a3.call(handleDragStart, event, manager);
            }),
            monitor.addEventListener("dragover", (event)=>{
                const callback = handleDragOver.current;
                if (callback) trackRendering(()=>callback(event, manager));
            }),
            monitor.addEventListener("dragmove", (event)=>{
                const callback = handleDragMove.current;
                if (callback) trackRendering(()=>callback(event, manager));
            }),
            monitor.addEventListener("dragend", (event)=>{
                const callback = handleDragEnd.current;
                if (callback) trackRendering(()=>callback(event, manager));
            }),
            monitor.addEventListener("collision", (event)=>{
                var _a3;
                return (_a3 = handleCollision.current) == null ? void 0 : _a3.call(handleCollision, event, manager);
            })
        ];
        return ()=>listeners.forEach((dispose)=>dispose());
    }, [
        manager
    ]);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(plugins, ()=>manager && (manager.plugins = plugins), ...$7d57415ac2032ee5$var$options);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(sensors, ()=>manager && (manager.sensors = sensors), ...$7d57415ac2032ee5$var$options);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(modifiers, ()=>manager && (manager.modifiers = modifiers), ...$7d57415ac2032ee5$var$options);
    return /* @__PURE__ */ (0, $d297014a5c3795d0$exports.jsxs)($7d57415ac2032ee5$var$DragDropContext.Provider, {
        value: manager,
        children: [
            /* @__PURE__ */ (0, $d297014a5c3795d0$exports.jsx)($7d57415ac2032ee5$var$Renderer, {
                ref: rendererRef,
                children: children
            }),
            children
        ]
    });
}
function $7d57415ac2032ee5$var$useStableInstance(create) {
    const ref = (0, $63Xef.useRef)(null);
    if (!ref.current) ref.current = create();
    (0, $63Xef.useInsertionEffect)(()=>{
        return ()=>{
            var _a2;
            return (_a2 = ref.current) == null ? void 0 : _a2.destroy();
        };
    }, []);
    return ref.current;
}
function $7d57415ac2032ee5$export$49db7e1a057ab0fa() {
    return (0, $63Xef.useContext)($7d57415ac2032ee5$var$DragDropContext);
}
// src/core/hooks/useInstance.ts
function $7d57415ac2032ee5$export$f4a5c5dcfe1bba82(initializer) {
    var _a2;
    const manager = (_a2 = $7d57415ac2032ee5$export$49db7e1a057ab0fa()) != null ? _a2 : void 0;
    const [instance] = (0, $63Xef.useState)(()=>initializer(manager));
    if (instance.manager !== manager) instance.manager = manager;
    (0, $7bd703b0876c5b19$export$700979bc83e7db82)(instance.register, [
        manager,
        instance
    ]);
    return instance;
}
// src/core/draggable/useDraggable.ts
function $7d57415ac2032ee5$export$df30c81f5aa01ff7(input) {
    const { disabled: disabled, data: data, element: element, handle: handle, id: id, modifiers: modifiers, sensors: sensors, plugins: plugins } = input;
    const draggable = $7d57415ac2032ee5$export$f4a5c5dcfe1bba82((manager)=>new (0, $4e1e107797f01458$export$f2a139e5d18b9882)($7d57415ac2032ee5$var$__spreadProps($7d57415ac2032ee5$var$__spreadValues({}, input), {
            register: false,
            handle: (0, $6e7add91e106627e$export$6cd4326f683953cc)(handle),
            element: (0, $6e7add91e106627e$export$6cd4326f683953cc)(element)
        }), manager));
    const trackedDraggable = (0, $7bd703b0876c5b19$export$e772c6c16497c511)(draggable, $7d57415ac2032ee5$var$shouldUpdateSynchronously);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(id, ()=>draggable.id = id);
    (0, $7bd703b0876c5b19$export$e167ec28bc041c4d)(handle, (handle2)=>draggable.handle = handle2);
    (0, $7bd703b0876c5b19$export$e167ec28bc041c4d)(element, (element2)=>draggable.element = element2);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(data, ()=>data && (draggable.data = data));
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(disabled, ()=>draggable.disabled = disabled === true);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(sensors, ()=>draggable.sensors = sensors);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(modifiers, ()=>draggable.modifiers = modifiers, void 0, (0, $eb0d2ed00918af28$export$9cb4719e2e525b7a));
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(plugins, ()=>draggable.plugins = plugins, void 0, (0, $eb0d2ed00918af28$export$9cb4719e2e525b7a));
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(input.alignment, ()=>draggable.alignment = input.alignment);
    return {
        draggable: trackedDraggable,
        get isDragging () {
            return trackedDraggable.isDragging;
        },
        get isDropping () {
            return trackedDraggable.isDropping;
        },
        get isDragSource () {
            return trackedDraggable.isDragSource;
        },
        handleRef: (0, $63Xef.useCallback)((element2)=>{
            draggable.handle = element2 != null ? element2 : void 0;
        }, [
            draggable
        ]),
        ref: (0, $63Xef.useCallback)((element2)=>{
            var _a2, _b;
            if (!element2 && ((_a2 = draggable.element) == null ? void 0 : _a2.isConnected) && !((_b = draggable.manager) == null ? void 0 : _b.dragOperation.status.idle)) return;
            draggable.element = element2 != null ? element2 : void 0;
        }, [
            draggable
        ])
    };
}
function $7d57415ac2032ee5$var$shouldUpdateSynchronously(key, oldValue, newValue) {
    if (key === "isDragSource" && !newValue && oldValue) return true;
    return false;
}
function $7d57415ac2032ee5$export$aca73479aa40659d({ children: children, className: className, dropAnimation: dropAnimation, style: style, tag: tag, disabled: disabled }) {
    var _a2;
    const ref = (0, $63Xef.useRef)(null);
    const manager = $7d57415ac2032ee5$export$49db7e1a057ab0fa();
    const source = (_a2 = (0, $7bd703b0876c5b19$export$e3d20747ab930783)(()=>manager == null ? void 0 : manager.dragOperation.source, [
        manager
    ]).value) != null ? _a2 : null;
    const isDisabled = typeof disabled === "function" ? disabled(source) : disabled;
    (0, $63Xef.useEffect)(()=>{
        if (!ref.current || !manager || isDisabled) return;
        const feedback = manager.plugins.find((plugin)=>plugin instanceof (0, $4e1e107797f01458$export$175e500a48a60fd2));
        if (!feedback) return;
        feedback.overlay = ref.current;
        return ()=>{
            feedback.overlay = void 0;
        };
    }, [
        manager,
        isDisabled
    ]);
    (0, $63Xef.useEffect)(()=>{
        if (!manager) return;
        const feedback = manager.plugins.find((plugin)=>plugin instanceof (0, $4e1e107797f01458$export$175e500a48a60fd2));
        if (!feedback) return;
        feedback.dropAnimation = dropAnimation;
        return ()=>{
            feedback.dropAnimation = void 0;
        };
    }, [
        manager,
        dropAnimation
    ]);
    const patchedManager = (0, $63Xef.useMemo)(()=>{
        if (!manager) return null;
        const patchedRegistry = new Proxy(manager.registry, {
            get (target, property) {
                if (property === "register" || property === "unregister") return $7d57415ac2032ee5$var$noop;
                return target[property];
            }
        });
        return new Proxy(manager, {
            get (target, property) {
                if (property === "registry") return patchedRegistry;
                return target[property];
            }
        });
    }, [
        manager
    ]);
    return /* @__PURE__ */ (0, $d297014a5c3795d0$exports.jsx)($7d57415ac2032ee5$var$DragDropContext.Provider, {
        value: patchedManager,
        children: (0, $63Xef.createElement)(tag || "div", {
            ref: ref,
            className: className,
            style: style,
            "data-dnd-overlay": true
        }, renderChildren())
    });
    function renderChildren() {
        if (!source || isDisabled) return null;
        if (typeof children === "function") return /* @__PURE__ */ (0, $d297014a5c3795d0$exports.jsx)($7d57415ac2032ee5$var$Children, {
            source: source,
            children: children
        });
        return children;
    }
}
function $7d57415ac2032ee5$var$noop() {
    return ()=>{};
}
function $7d57415ac2032ee5$var$Children({ children: children, source: source }) {
    return children((0, $7bd703b0876c5b19$export$e772c6c16497c511)(source));
}
var $7d57415ac2032ee5$var$__create = Object.create;
var $7d57415ac2032ee5$var$__defProp2 = Object.defineProperty;
var $7d57415ac2032ee5$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $7d57415ac2032ee5$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $7d57415ac2032ee5$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $7d57415ac2032ee5$var$__defNormalProp2 = (obj, key, value)=>key in obj ? $7d57415ac2032ee5$var$__defProp2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7d57415ac2032ee5$var$__decoratorStart = (base)=>{
    var _a2;
    return [
        ,
        ,
        ,
        $7d57415ac2032ee5$var$__create((_a2 = base == null ? void 0 : base[$7d57415ac2032ee5$var$__knownSymbol("metadata")]) != null ? _a2 : null)
    ];
};
var $7d57415ac2032ee5$var$__decoratorStrings = [
    "class",
    "method",
    "getter",
    "setter",
    "accessor",
    "field",
    "value",
    "get",
    "set"
];
var $7d57415ac2032ee5$var$__expectFn = (fn)=>fn !== void 0 && typeof fn !== "function" ? $7d57415ac2032ee5$var$__typeError("Function expected") : fn;
var $7d57415ac2032ee5$var$__decoratorContext = (kind, name, done, metadata, fns)=>({
        kind: $7d57415ac2032ee5$var$__decoratorStrings[kind],
        name: name,
        metadata: metadata,
        addInitializer: (fn)=>done._ ? $7d57415ac2032ee5$var$__typeError("Already initialized") : fns.push($7d57415ac2032ee5$var$__expectFn(fn || null))
    });
var $7d57415ac2032ee5$var$__decoratorMetadata = (array, target)=>$7d57415ac2032ee5$var$__defNormalProp2(target, $7d57415ac2032ee5$var$__knownSymbol("metadata"), array[3]);
var $7d57415ac2032ee5$var$__runInitializers = (array, flags, self, value)=>{
    for(var i = 0, fns = array[flags >> 1], n = fns && fns.length; i < n; i++)fns[i].call(self);
    return value;
};
var $7d57415ac2032ee5$var$__decorateElement = (array, flags, name, decorators, target, extra)=>{
    var it, done, ctx, access, k = flags & 7, s = false, p = false;
    var j = 2, key = $7d57415ac2032ee5$var$__decoratorStrings[k + 5];
    var extraInitializers = array[j] || (array[j] = []);
    var desc = (target = target.prototype, $7d57415ac2032ee5$var$__getOwnPropDesc(target, name));
    for(var i = decorators.length - 1; i >= 0; i--){
        ctx = $7d57415ac2032ee5$var$__decoratorContext(k, name, done = {}, array[3], extraInitializers);
        ctx.static = s, ctx.private = p, access = ctx.access = {
            has: (x)=>name in x
        };
        access.get = (x)=>x[name];
        it = (0, decorators[i])(desc[key], ctx), done._ = 1;
        $7d57415ac2032ee5$var$__expectFn(it) && (desc[key] = it);
    }
    return desc && $7d57415ac2032ee5$var$__defProp2(target, name, desc), target;
};
var $7d57415ac2032ee5$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $7d57415ac2032ee5$var$__typeError("Cannot " + msg);
var $7d57415ac2032ee5$var$__privateGet = (obj, member, getter)=>($7d57415ac2032ee5$var$__accessCheck(obj, member, "read from private field"), member.get(obj));
var $7d57415ac2032ee5$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $7d57415ac2032ee5$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $7d57415ac2032ee5$var$__privateSet = (obj, member, value, setter)=>($7d57415ac2032ee5$var$__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var $7d57415ac2032ee5$var$Point = class _Point {
    /**
   * @param {number} Coordinate of the point on the horizontal axis
   * @param {number} Coordinate of the point on the vertical axis
   */ constructor(x, y){
        this.x = x;
        this.y = y;
    }
    /**
   * Returns the delta between this point and another point.
   *
   * @param {Point} a - A point
   * @param {Point} b - Another point
   */ static delta(a, b) {
        return new _Point(a.x - b.x, a.y - b.y);
    }
    /**
   * Returns the distance (hypotenuse) between this point and another point.
   *
   * @param {Point} a - A point
   * @param {Point} b - Another point
   */ static distance(a, b) {
        return Math.hypot(a.x - b.x, a.y - b.y);
    }
    /**
   * Returns true if both points are equal.
   *
   * @param {Point} a - A point
   * @param {Point} b - Another point
   */ static equals(a, b) {
        return a.x === b.x && a.y === b.y;
    }
    static from({ x: x, y: y }) {
        return new _Point(x, y);
    }
};
var $7d57415ac2032ee5$var$_direction_dec;
var $7d57415ac2032ee5$var$_delta_dec;
var $7d57415ac2032ee5$var$_a;
var $7d57415ac2032ee5$var$_timestamp;
var $7d57415ac2032ee5$var$_init;
var $7d57415ac2032ee5$var$Position = class extends ($7d57415ac2032ee5$var$_a = (0, $eb0d2ed00918af28$export$b054dd6fcf79fa19), $7d57415ac2032ee5$var$_delta_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $7d57415ac2032ee5$var$_direction_dec = [
    (0, $eb0d2ed00918af28$export$90b0b54dab0a340a)
], $7d57415ac2032ee5$var$_a) {
    constructor(initialValue){
        const point = $7d57415ac2032ee5$var$Point.from(initialValue);
        super(point, (a, b)=>$7d57415ac2032ee5$var$Point.equals(a, b));
        $7d57415ac2032ee5$var$__runInitializers($7d57415ac2032ee5$var$_init, 5, this);
        $7d57415ac2032ee5$var$__privateAdd(this, $7d57415ac2032ee5$var$_timestamp, 0);
        this.velocity = {
            x: 0,
            y: 0
        };
    }
    get delta() {
        return $7d57415ac2032ee5$var$Point.delta(this.current, this.initial);
    }
    get direction() {
        const { current: current, previous: previous } = this;
        if (!previous) return null;
        const delta = {
            x: current.x - previous.x,
            y: current.y - previous.y
        };
        if (!delta.x && !delta.y) return null;
        if (Math.abs(delta.x) > Math.abs(delta.y)) return delta.x > 0 ? "right" : "left";
        return delta.y > 0 ? "down" : "up";
    }
    get current() {
        return super.current;
    }
    set current(coordinates) {
        const { current: current } = this;
        const point = $7d57415ac2032ee5$var$Point.from(coordinates);
        const delta = {
            x: point.x - current.x,
            y: point.y - current.y
        };
        const timestamp = Date.now();
        const timeDelta = timestamp - $7d57415ac2032ee5$var$__privateGet(this, $7d57415ac2032ee5$var$_timestamp);
        const velocity = (delta2)=>Math.round(delta2 / timeDelta * 100);
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            $7d57415ac2032ee5$var$__privateSet(this, $7d57415ac2032ee5$var$_timestamp, timestamp);
            this.velocity = {
                x: velocity(delta.x),
                y: velocity(delta.y)
            };
            super.current = point;
        });
    }
    reset(coordinates = this.defaultValue) {
        super.reset($7d57415ac2032ee5$var$Point.from(coordinates));
        this.velocity = {
            x: 0,
            y: 0
        };
    }
};
$7d57415ac2032ee5$var$_init = $7d57415ac2032ee5$var$__decoratorStart($7d57415ac2032ee5$var$_a);
$7d57415ac2032ee5$var$_timestamp = /* @__PURE__ */ new WeakMap();
$7d57415ac2032ee5$var$__decorateElement($7d57415ac2032ee5$var$_init, 2, "delta", $7d57415ac2032ee5$var$_delta_dec, $7d57415ac2032ee5$var$Position);
$7d57415ac2032ee5$var$__decorateElement($7d57415ac2032ee5$var$_init, 2, "direction", $7d57415ac2032ee5$var$_direction_dec, $7d57415ac2032ee5$var$Position);
$7d57415ac2032ee5$var$__decoratorMetadata($7d57415ac2032ee5$var$_init, $7d57415ac2032ee5$var$Position);
var $7d57415ac2032ee5$var$Axis = /* @__PURE__ */ ((Axis2)=>{
    Axis2["Horizontal"] = "x";
    Axis2["Vertical"] = "y";
    return Axis2;
})($7d57415ac2032ee5$var$Axis || {});
Object.values($7d57415ac2032ee5$var$Axis);
var $7d57415ac2032ee5$var$pointerIntersection = ({ dragOperation: dragOperation, droppable: droppable })=>{
    const pointerCoordinates = dragOperation.position.current;
    if (!pointerCoordinates) return null;
    const { id: id } = droppable;
    if (!droppable.shape) return null;
    if (droppable.shape.containsPoint(pointerCoordinates)) {
        const distance = $7d57415ac2032ee5$var$Point.distance(droppable.shape.center, pointerCoordinates);
        return {
            id: id,
            value: 1 / distance,
            type: (0, $9636818b04ce7da6$export$ddb2ed749236e720).PointerIntersection,
            priority: (0, $9636818b04ce7da6$export$f477ca1dcaa3e6e6).High
        };
    }
    return null;
};
var $7d57415ac2032ee5$var$shapeIntersection = ({ dragOperation: dragOperation, droppable: droppable })=>{
    const { shape: shape } = dragOperation;
    if (!droppable.shape || !(shape == null ? void 0 : shape.current)) return null;
    const intersectionArea = shape.current.intersectionArea(droppable.shape);
    if (intersectionArea) {
        const { position: position } = dragOperation;
        const distance = $7d57415ac2032ee5$var$Point.distance(droppable.shape.center, position.current);
        const intersectionRatio = intersectionArea / (shape.current.area + droppable.shape.area - intersectionArea);
        const value = intersectionRatio / distance;
        return {
            id: droppable.id,
            value: value,
            type: (0, $9636818b04ce7da6$export$ddb2ed749236e720).ShapeIntersection,
            priority: (0, $9636818b04ce7da6$export$f477ca1dcaa3e6e6).Normal
        };
    }
    return null;
};
var $7d57415ac2032ee5$var$defaultCollisionDetection = (args)=>{
    var _a2;
    return (_a2 = $7d57415ac2032ee5$var$pointerIntersection(args)) != null ? _a2 : $7d57415ac2032ee5$var$shapeIntersection(args);
};
// src/core/droppable/useDroppable.ts
function $7d57415ac2032ee5$export$d74e5d67dc2b3176(input) {
    const { collisionDetector: collisionDetector, data: data, disabled: disabled, element: element, id: id, accept: accept, type: type } = input;
    const droppable = $7d57415ac2032ee5$export$f4a5c5dcfe1bba82((manager)=>new (0, $4e1e107797f01458$export$423ec2075359570a)($7d57415ac2032ee5$var$__spreadProps($7d57415ac2032ee5$var$__spreadValues({}, input), {
            register: false,
            element: (0, $6e7add91e106627e$export$6cd4326f683953cc)(element)
        }), manager));
    const trackedDroppalbe = (0, $7bd703b0876c5b19$export$e772c6c16497c511)(droppable);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(id, ()=>droppable.id = id);
    (0, $7bd703b0876c5b19$export$e167ec28bc041c4d)(element, (element2)=>droppable.element = element2);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(accept, ()=>droppable.accept = accept, void 0, (0, $eb0d2ed00918af28$export$9cb4719e2e525b7a));
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(collisionDetector, ()=>droppable.collisionDetector = collisionDetector != null ? collisionDetector : $7d57415ac2032ee5$var$defaultCollisionDetection);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(data, ()=>data && (droppable.data = data));
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(disabled, ()=>droppable.disabled = disabled === true);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(type, ()=>droppable.type = type);
    return {
        droppable: trackedDroppalbe,
        get isDropTarget () {
            return trackedDroppalbe.isDropTarget;
        },
        ref: (0, $63Xef.useCallback)((element2)=>{
            var _a2, _b;
            if (!element2 && ((_a2 = droppable.element) == null ? void 0 : _a2.isConnected) && !((_b = droppable.manager) == null ? void 0 : _b.dragOperation.status.idle)) return;
            droppable.element = element2 != null ? element2 : void 0;
        }, [
            droppable
        ])
    };
}
function $7d57415ac2032ee5$export$602210aed46cbcc4(handlers) {
    const manager = $7d57415ac2032ee5$export$49db7e1a057ab0fa();
    (0, $63Xef.useEffect)(()=>{
        if (!manager) {
            console.warn("useDndMonitor hook was called outside of a DragDropProvider. Make sure your app is wrapped in a DragDropProvider component.");
            return;
        }
        const cleanupFns = Object.entries(handlers).reduce((acc, [handlerName, handler])=>{
            if (handler) {
                const eventName = handlerName.replace(/^on/, "").toLowerCase();
                const unsubscribe = manager.monitor.addEventListener(eventName, handler);
                acc.push(unsubscribe);
            }
            return acc;
        }, []);
        return ()=>cleanupFns.forEach((cleanup)=>cleanup == null ? void 0 : cleanup());
    }, [
        manager,
        handlers
    ]);
}
function $7d57415ac2032ee5$export$358172be6af83810() {
    const manager = $7d57415ac2032ee5$export$49db7e1a057ab0fa();
    const source = (0, $7bd703b0876c5b19$export$e3d20747ab930783)(()=>manager == null ? void 0 : manager.dragOperation.source, [
        manager
    ]);
    const target = (0, $7bd703b0876c5b19$export$e3d20747ab930783)(()=>manager == null ? void 0 : manager.dragOperation.target, [
        manager
    ]);
    return {
        get source () {
            return source.value;
        },
        get target () {
            return target.value;
        }
    };
}
 //# sourceMappingURL=index.js.map
 //# sourceMappingURL=index.js.map








var $0d4c5512f6ac0f65$var$__create = Object.create;
var $0d4c5512f6ac0f65$var$__defProp = Object.defineProperty;
var $0d4c5512f6ac0f65$var$__defProps = Object.defineProperties;
var $0d4c5512f6ac0f65$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $0d4c5512f6ac0f65$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0d4c5512f6ac0f65$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0d4c5512f6ac0f65$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0d4c5512f6ac0f65$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0d4c5512f6ac0f65$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $0d4c5512f6ac0f65$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $0d4c5512f6ac0f65$var$__defNormalProp = (obj, key, value)=>key in obj ? $0d4c5512f6ac0f65$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0d4c5512f6ac0f65$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0d4c5512f6ac0f65$var$__hasOwnProp.call(b, prop)) $0d4c5512f6ac0f65$var$__defNormalProp(a, prop, b[prop]);
    if ($0d4c5512f6ac0f65$var$__getOwnPropSymbols) {
        for (var prop of $0d4c5512f6ac0f65$var$__getOwnPropSymbols(b))if ($0d4c5512f6ac0f65$var$__propIsEnum.call(b, prop)) $0d4c5512f6ac0f65$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0d4c5512f6ac0f65$var$__spreadProps = (a, b)=>$0d4c5512f6ac0f65$var$__defProps(a, $0d4c5512f6ac0f65$var$__getOwnPropDescs(b));
var $0d4c5512f6ac0f65$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0d4c5512f6ac0f65$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0d4c5512f6ac0f65$var$__getOwnPropSymbols) {
        for (var prop of $0d4c5512f6ac0f65$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0d4c5512f6ac0f65$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $0d4c5512f6ac0f65$var$__decoratorStart = (base)=>{
    var _a;
    return [
        ,
        ,
        ,
        $0d4c5512f6ac0f65$var$__create((_a = void 0, null))
    ];
};
var $0d4c5512f6ac0f65$var$__decoratorStrings = [
    "class",
    "method",
    "getter",
    "setter",
    "accessor",
    "field",
    "value",
    "get",
    "set"
];
var $0d4c5512f6ac0f65$var$__expectFn = (fn)=>fn !== void 0 && typeof fn !== "function" ? $0d4c5512f6ac0f65$var$__typeError("Function expected") : fn;
var $0d4c5512f6ac0f65$var$__decoratorContext = (kind, name, done, metadata, fns)=>({
        kind: $0d4c5512f6ac0f65$var$__decoratorStrings[kind],
        name: name,
        metadata: metadata,
        addInitializer: (fn)=>done._ ? $0d4c5512f6ac0f65$var$__typeError("Already initialized") : fns.push($0d4c5512f6ac0f65$var$__expectFn(fn || null))
    });
var $0d4c5512f6ac0f65$var$__decoratorMetadata = (array, target)=>$0d4c5512f6ac0f65$var$__defNormalProp(target, $0d4c5512f6ac0f65$var$__knownSymbol("metadata"), array[3]);
var $0d4c5512f6ac0f65$var$__runInitializers = (array, flags, self, value)=>{
    for(var i = 0, fns = array[flags >> 1], n = fns && fns.length; i < n; i++)flags & 1 ? fns[i].call(self) : value = fns[i].call(self, value);
    return value;
};
var $0d4c5512f6ac0f65$var$__decorateElement = (array, flags, name, decorators, target, extra)=>{
    var fn, it, done, ctx, access, k = flags & 7, s = false, p = false;
    var j = array.length + 1, key = $0d4c5512f6ac0f65$var$__decoratorStrings[k + 5];
    var initializers = array[j - 1] = [], extraInitializers = array[j] || (array[j] = []);
    var desc = (target = target.prototype, $0d4c5512f6ac0f65$var$__getOwnPropDesc({
        get [name] () {
            return $0d4c5512f6ac0f65$var$__privateGet(this, extra);
        },
        set [name] (x){
            return $0d4c5512f6ac0f65$var$__privateSet(this, extra, x);
        }
    }, name));
    for(var i = decorators.length - 1; i >= 0; i--){
        ctx = $0d4c5512f6ac0f65$var$__decoratorContext(k, name, done = {}, array[3], extraInitializers);
        ctx.static = s, ctx.private = p, access = ctx.access = {
            has: (x1)=>name in x1
        };
        access.get = (x1)=>x1[name];
        access.set = (x1, y)=>x1[name] = y;
        it = (0, decorators[i])({
            get: desc.get,
            set: desc.set
        }, ctx), done._ = 1;
        if (it === void 0) $0d4c5512f6ac0f65$var$__expectFn(it) && (desc[key] = it);
        else if (typeof it !== "object" || it === null) $0d4c5512f6ac0f65$var$__typeError("Object expected");
        else $0d4c5512f6ac0f65$var$__expectFn(fn = it.get) && (desc.get = fn), $0d4c5512f6ac0f65$var$__expectFn(fn = it.set) && (desc.set = fn), $0d4c5512f6ac0f65$var$__expectFn(fn = it.init) && initializers.unshift(fn);
    }
    return desc && $0d4c5512f6ac0f65$var$__defProp(target, name, desc), target;
};
var $0d4c5512f6ac0f65$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $0d4c5512f6ac0f65$var$__typeError("Cannot " + msg);
var $0d4c5512f6ac0f65$var$__privateGet = (obj, member, getter)=>($0d4c5512f6ac0f65$var$__accessCheck(obj, member, "read from private field"), member.get(obj));
var $0d4c5512f6ac0f65$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $0d4c5512f6ac0f65$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $0d4c5512f6ac0f65$var$__privateSet = (obj, member, value, setter)=>($0d4c5512f6ac0f65$var$__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
// src/sortable/utilities.ts
function $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f(element) {
    return element instanceof $0d4c5512f6ac0f65$export$2a6316104b6c69c9 || element instanceof $0d4c5512f6ac0f65$export$aacefb37d6963ced;
}
function $0d4c5512f6ac0f65$export$8293aa530a33d551(operation) {
    return $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f(operation.source) && $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f(operation.target);
}
// src/sortable/plugins/SortableKeyboardPlugin.ts
var $0d4c5512f6ac0f65$var$TOLERANCE = 10;
var $0d4c5512f6ac0f65$export$772495ad80b642a5 = class extends (0, $9636818b04ce7da6$export$901cf72dabf2112a) {
    constructor(manager){
        super(manager);
        const cleanupEffect = (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            const { dragOperation: dragOperation } = manager;
            if (!(0, $501f8c524dad2740$export$130b789831072f4c)(dragOperation.activatorEvent)) return;
            if (!$0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f(dragOperation.source)) return;
            if (dragOperation.status.initialized) {
                const scroller = manager.registry.plugins.get((0, $4e1e107797f01458$export$76d6749d1cf8513c));
                if (scroller) {
                    scroller.disable();
                    return ()=>scroller.enable();
                }
            }
        });
        const unsubscribe = manager.monitor.addEventListener("dragmove", (event, manager2)=>{
            queueMicrotask(()=>{
                if (this.disabled || event.defaultPrevented || !event.nativeEvent) return;
                const { dragOperation: dragOperation } = manager2;
                if (!(0, $501f8c524dad2740$export$130b789831072f4c)(event.nativeEvent)) return;
                if (!$0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f(dragOperation.source)) return;
                if (!dragOperation.shape) return;
                const { actions: actions, collisionObserver: collisionObserver, registry: registry } = manager2;
                const { by: by } = event;
                if (!by) return;
                const direction = $0d4c5512f6ac0f65$var$getDirection(by);
                const { source: source, target: target } = dragOperation;
                const { center: center } = dragOperation.shape.current;
                const potentialTargets = [];
                const cleanup = [];
                (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
                    for (const droppable of registry.droppables){
                        const { id: id2 } = droppable;
                        if (!droppable.accepts(source) || id2 === (target == null ? void 0 : target.id) && $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f(droppable) || !droppable.element) continue;
                        let previousShape = droppable.shape;
                        const shape = new (0, $501f8c524dad2740$export$9be488f2d210405c)(droppable.element, {
                            getBoundingClientRect: (element)=>(0, $501f8c524dad2740$export$6b7c986976ac6b22)(element, void 0, 0.2)
                        });
                        if (!shape.height || !shape.width) continue;
                        if (direction == "down" && center.y + $0d4c5512f6ac0f65$var$TOLERANCE < shape.center.y || direction == "up" && center.y - $0d4c5512f6ac0f65$var$TOLERANCE > shape.center.y || direction == "left" && center.x - $0d4c5512f6ac0f65$var$TOLERANCE > shape.center.x || direction == "right" && center.x + $0d4c5512f6ac0f65$var$TOLERANCE < shape.center.x) {
                            potentialTargets.push(droppable);
                            droppable.shape = shape;
                            cleanup.push(()=>droppable.shape = previousShape);
                        }
                    }
                });
                event.preventDefault();
                collisionObserver.disable();
                const collisions = collisionObserver.computeCollisions(potentialTargets, (0, $c970db14647306d6$export$c3a6c1c7122b31c9));
                (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>cleanup.forEach((clean)=>clean()));
                const [firstCollision] = collisions;
                if (!firstCollision) return;
                const { id: id } = firstCollision;
                const { index: index, group: group } = source.sortable;
                actions.setDropTarget(id).then(()=>{
                    const { source: source2, target: target2, shape: shape } = dragOperation;
                    if (!source2 || !$0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f(source2) || !shape) return;
                    const { index: newIndex, group: newGroup, target: targetElement } = source2.sortable;
                    const updated = index !== newIndex || group !== newGroup;
                    const element = updated ? targetElement : target2 == null ? void 0 : target2.element;
                    if (!element) return;
                    (0, $501f8c524dad2740$export$9657601bf1e130ee)(element);
                    const updatedShape = new (0, $501f8c524dad2740$export$9be488f2d210405c)(element);
                    if (!updatedShape) return;
                    const delta = (0, $ce41d7a96a1e68fd$export$4617fb02663045ef).delta(updatedShape, (0, $ce41d7a96a1e68fd$export$4617fb02663045ef).from(shape.current.boundingRectangle), source2.alignment);
                    actions.move({
                        by: delta
                    });
                    if (updated) actions.setDropTarget(source2.id).then(()=>collisionObserver.enable());
                    else collisionObserver.enable();
                });
            });
        });
        this.destroy = ()=>{
            unsubscribe();
            cleanupEffect();
        };
    }
};
function $0d4c5512f6ac0f65$var$getDirection(delta) {
    const { x: x1, y: y } = delta;
    if (x1 > 0) return "right";
    else if (x1 < 0) return "left";
    else if (y > 0) return "down";
    else if (y < 0) return "up";
}
// ../helpers/dist/index.js
var $0d4c5512f6ac0f65$var$__defProp2 = Object.defineProperty;
var $0d4c5512f6ac0f65$var$__defProps2 = Object.defineProperties;
var $0d4c5512f6ac0f65$var$__getOwnPropDescs2 = Object.getOwnPropertyDescriptors;
var $0d4c5512f6ac0f65$var$__getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var $0d4c5512f6ac0f65$var$__hasOwnProp2 = Object.prototype.hasOwnProperty;
var $0d4c5512f6ac0f65$var$__propIsEnum2 = Object.prototype.propertyIsEnumerable;
var $0d4c5512f6ac0f65$var$__defNormalProp2 = (obj, key, value)=>key in obj ? $0d4c5512f6ac0f65$var$__defProp2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0d4c5512f6ac0f65$var$__spreadValues2 = (a, b)=>{
    for(var prop in b || (b = {}))if ($0d4c5512f6ac0f65$var$__hasOwnProp2.call(b, prop)) $0d4c5512f6ac0f65$var$__defNormalProp2(a, prop, b[prop]);
    if ($0d4c5512f6ac0f65$var$__getOwnPropSymbols2) {
        for (var prop of $0d4c5512f6ac0f65$var$__getOwnPropSymbols2(b))if ($0d4c5512f6ac0f65$var$__propIsEnum2.call(b, prop)) $0d4c5512f6ac0f65$var$__defNormalProp2(a, prop, b[prop]);
    }
    return a;
};
var $0d4c5512f6ac0f65$var$__spreadProps2 = (a, b)=>$0d4c5512f6ac0f65$var$__defProps2(a, $0d4c5512f6ac0f65$var$__getOwnPropDescs2(b));
function $0d4c5512f6ac0f65$var$arrayMove(array, from, to) {
    if (from === to) return array;
    const newArray = array.slice();
    newArray.splice(to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
function $0d4c5512f6ac0f65$var$hasSortableIndices(source) {
    return "initialIndex" in source && typeof source.initialIndex === "number" && "index" in source && typeof source.index === "number";
}
function $0d4c5512f6ac0f65$var$mutate(items, event, mutation) {
    var _a, _b, _c;
    const { source: source, target: target, canceled: canceled } = event.operation;
    if (!source || !target || canceled) {
        if ("preventDefault" in event) event.preventDefault();
        return items;
    }
    const findIndex = (item, id)=>item === id || typeof item === "object" && "id" in item && item.id === id;
    if (Array.isArray(items)) {
        const sourceIndex2 = items.findIndex((item)=>findIndex(item, source.id));
        const targetIndex2 = items.findIndex((item)=>findIndex(item, target.id));
        if (sourceIndex2 === -1 || targetIndex2 === -1) {
            if ($0d4c5512f6ac0f65$var$hasSortableIndices(source)) {
                const from = source.initialIndex;
                const to = source.index;
                if (from === to || from < 0 || from >= items.length) {
                    if ("preventDefault" in event) event.preventDefault();
                    return items;
                }
                return mutation(items, from, to);
            }
            return items;
        }
        if (!canceled && "index" in source && typeof source.index === "number") {
            const projectedSourceIndex = source.index;
            if (projectedSourceIndex !== sourceIndex2) return mutation(items, sourceIndex2, projectedSourceIndex);
        }
        return mutation(items, sourceIndex2, targetIndex2);
    }
    const entries = Object.entries(items);
    let sourceIndex = -1;
    let sourceParent;
    let targetIndex = -1;
    let targetParent;
    for (const [id, children] of entries){
        if (sourceIndex === -1) {
            sourceIndex = children.findIndex((item)=>findIndex(item, source.id));
            if (sourceIndex !== -1) sourceParent = id;
        }
        if (targetIndex === -1) {
            targetIndex = children.findIndex((item)=>findIndex(item, target.id));
            if (targetIndex !== -1) targetParent = id;
        }
        if (sourceIndex !== -1 && targetIndex !== -1) break;
    }
    if (sourceIndex === -1 && $0d4c5512f6ac0f65$var$hasSortableIndices(source)) {
        const srcParent = source.initialGroup;
        const srcIndex = source.initialIndex;
        const tgtParent = source.group;
        const tgtIndex = source.index;
        if (srcParent == null || tgtParent == null || !(srcParent in items) || !(tgtParent in items)) {
            if ("preventDefault" in event) event.preventDefault();
            return items;
        }
        if (srcParent === tgtParent && srcIndex === tgtIndex) {
            if ("preventDefault" in event) event.preventDefault();
            return items;
        }
        if (srcParent === tgtParent) return $0d4c5512f6ac0f65$var$__spreadProps2($0d4c5512f6ac0f65$var$__spreadValues2({}, items), {
            [srcParent]: mutation(items[srcParent], srcIndex, tgtIndex)
        });
        const sourceItem2 = items[srcParent][srcIndex];
        return $0d4c5512f6ac0f65$var$__spreadProps2($0d4c5512f6ac0f65$var$__spreadValues2({}, items), {
            [srcParent]: [
                ...items[srcParent].slice(0, srcIndex),
                ...items[srcParent].slice(srcIndex + 1)
            ],
            [tgtParent]: [
                ...items[tgtParent].slice(0, tgtIndex),
                sourceItem2,
                ...items[tgtParent].slice(tgtIndex)
            ]
        });
    }
    if (!source.manager) return items;
    const { dragOperation: dragOperation } = source.manager;
    const position = (_b = (_a = dragOperation.shape) == null ? void 0 : _a.current.center) != null ? _b : dragOperation.position.current;
    if (targetParent == null) {
        if (target.id in items) {
            const insertionIndex = target.shape && position.y > target.shape.center.y ? items[target.id].length : 0;
            targetParent = target.id;
            targetIndex = insertionIndex;
        }
    }
    if (sourceParent == null || targetParent == null || sourceParent === targetParent && sourceIndex === targetIndex) {
        if (sourceParent != null && sourceParent === targetParent && sourceIndex === targetIndex && $0d4c5512f6ac0f65$var$hasSortableIndices(source)) {
            const hasGroupChanged = source.group != null && source.group !== sourceParent;
            const hasIndexChanged = source.index !== sourceIndex;
            if (hasGroupChanged || hasIndexChanged) {
                const reconciledTargetParent = (_c = source.group) != null ? _c : sourceParent;
                if (reconciledTargetParent in items) {
                    if (sourceParent === reconciledTargetParent) return $0d4c5512f6ac0f65$var$__spreadProps2($0d4c5512f6ac0f65$var$__spreadValues2({}, items), {
                        [sourceParent]: mutation(items[sourceParent], sourceIndex, source.index)
                    });
                    const sourceItem2 = items[sourceParent][sourceIndex];
                    return $0d4c5512f6ac0f65$var$__spreadProps2($0d4c5512f6ac0f65$var$__spreadValues2({}, items), {
                        [sourceParent]: [
                            ...items[sourceParent].slice(0, sourceIndex),
                            ...items[sourceParent].slice(sourceIndex + 1)
                        ],
                        [reconciledTargetParent]: [
                            ...items[reconciledTargetParent].slice(0, source.index),
                            sourceItem2,
                            ...items[reconciledTargetParent].slice(source.index)
                        ]
                    });
                }
            }
        }
        if ("preventDefault" in event) event.preventDefault();
        return items;
    }
    if (sourceParent === targetParent) return $0d4c5512f6ac0f65$var$__spreadProps2($0d4c5512f6ac0f65$var$__spreadValues2({}, items), {
        [sourceParent]: mutation(items[sourceParent], sourceIndex, targetIndex)
    });
    const isBelowTarget = target.shape && Math.round(position.y) > Math.round(target.shape.center.y);
    const modifier = isBelowTarget ? 1 : 0;
    const sourceItem = items[sourceParent][sourceIndex];
    return $0d4c5512f6ac0f65$var$__spreadProps2($0d4c5512f6ac0f65$var$__spreadValues2({}, items), {
        [sourceParent]: [
            ...items[sourceParent].slice(0, sourceIndex),
            ...items[sourceParent].slice(sourceIndex + 1)
        ],
        [targetParent]: [
            ...items[targetParent].slice(0, targetIndex + modifier),
            sourceItem,
            ...items[targetParent].slice(targetIndex + modifier)
        ]
    });
}
function $0d4c5512f6ac0f65$var$move(items, event) {
    return $0d4c5512f6ac0f65$var$mutate(items, event, $0d4c5512f6ac0f65$var$arrayMove);
}
var $0d4c5512f6ac0f65$var$defaultGroup = "__default__";
var $0d4c5512f6ac0f65$export$142f7d8426595470 = class extends (0, $9636818b04ce7da6$export$901cf72dabf2112a) {
    constructor(manager){
        super(manager);
        const getSortableInstances = ()=>{
            const sortableInstances = /* @__PURE__ */ new Map();
            for (const droppable of manager.registry.droppables)if (droppable instanceof $0d4c5512f6ac0f65$export$2a6316104b6c69c9) {
                const { sortable: sortable } = droppable;
                const { group: group } = sortable;
                let instances = sortableInstances.get(group);
                if (!instances) {
                    instances = /* @__PURE__ */ new Set();
                    sortableInstances.set(group, instances);
                }
                instances.add(sortable);
            }
            for (const [group, instances] of sortableInstances)sortableInstances.set(group, new Set($0d4c5512f6ac0f65$var$sort(instances)));
            return sortableInstances;
        };
        const unsubscribe = [
            manager.monitor.addEventListener("dragover", (event, manager2)=>{
                if (this.disabled) return;
                const { dragOperation: dragOperation } = manager2;
                const { source: source, target: target } = dragOperation;
                if (!$0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f(source) || !$0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f(target)) return;
                if (source.sortable === target.sortable) return;
                const instances = getSortableInstances();
                const sameGroup = source.sortable.group === target.sortable.group;
                const sourceInstances = instances.get(source.sortable.group);
                const targetInstances = sameGroup ? sourceInstances : instances.get(target.sortable.group);
                if (!sourceInstances || !targetInstances) return;
                queueMicrotask(()=>{
                    if (event.defaultPrevented) return;
                    manager2.renderer.rendering.then(()=>{
                        var _a, _b, _c;
                        const newInstances = getSortableInstances();
                        for (const [group, sortableInstances] of instances.entries()){
                            const entries = Array.from(sortableInstances).entries();
                            for (const [index, sortable] of entries){
                                if (sortable.index !== index || sortable.group !== group || !((_a = newInstances.get(group)) == null ? void 0 : _a.has(sortable))) return;
                            }
                        }
                        const sourceElement = source.sortable.element;
                        const targetElement = target.sortable.element;
                        if (!targetElement || !sourceElement) return;
                        if (!sameGroup && target.id === source.sortable.group) return;
                        const orderedSourceSortables = $0d4c5512f6ac0f65$var$sort(sourceInstances);
                        const orderedTargetSortables = sameGroup ? orderedSourceSortables : $0d4c5512f6ac0f65$var$sort(targetInstances);
                        const sourceGroup = (_b = source.sortable.group) != null ? _b : $0d4c5512f6ac0f65$var$defaultGroup;
                        const targetGroup = (_c = target.sortable.group) != null ? _c : $0d4c5512f6ac0f65$var$defaultGroup;
                        const state = {
                            [sourceGroup]: orderedSourceSortables,
                            [targetGroup]: orderedTargetSortables
                        };
                        const newState = $0d4c5512f6ac0f65$var$move(state, event);
                        if (state === newState) return;
                        const sourceIndex = newState[targetGroup].indexOf(source.sortable);
                        const targetIndex = newState[targetGroup].indexOf(target.sortable);
                        manager2.collisionObserver.disable();
                        $0d4c5512f6ac0f65$var$reorder(sourceElement, sourceIndex, targetElement, targetIndex);
                        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
                            for (const [index, sortable] of newState[sourceGroup].entries())sortable.index = index;
                            if (!sameGroup) for (const [index, sortable] of newState[targetGroup].entries()){
                                sortable.group = target.sortable.group;
                                sortable.index = index;
                            }
                        });
                        manager2.actions.setDropTarget(source.id).then(()=>manager2.collisionObserver.enable());
                    });
                });
            }),
            manager.monitor.addEventListener("dragend", (event, manager2)=>{
                if (!event.canceled) return;
                const { dragOperation: dragOperation } = manager2;
                const { source: source } = dragOperation;
                if (!$0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f(source)) return;
                if (source.sortable.initialIndex === source.sortable.index && source.sortable.initialGroup === source.sortable.group) return;
                queueMicrotask(()=>{
                    const instances = getSortableInstances();
                    const initialGroupInstances = instances.get(source.sortable.initialGroup);
                    if (!initialGroupInstances) return;
                    manager2.renderer.rendering.then(()=>{
                        for (const [group, sortableInstances] of instances.entries()){
                            const entries = Array.from(sortableInstances).entries();
                            for (const [index, sortable] of entries){
                                if (sortable.index !== index || sortable.group !== group) return;
                            }
                        }
                        const initialGroup = $0d4c5512f6ac0f65$var$sort(initialGroupInstances);
                        const sourceElement = source.sortable.element;
                        const target = initialGroup[source.sortable.initialIndex];
                        const targetElement = target == null ? void 0 : target.element;
                        if (!target || !targetElement || !sourceElement) return;
                        $0d4c5512f6ac0f65$var$reorder(sourceElement, target.index, targetElement, source.index);
                        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
                            for (const [_, sortableInstances] of instances.entries()){
                                const entries = Array.from(sortableInstances).values();
                                for (const sortable of entries){
                                    sortable.index = sortable.initialIndex;
                                    sortable.group = sortable.initialGroup;
                                }
                            }
                        });
                    });
                });
            })
        ];
        this.destroy = ()=>{
            for (const unsubscribeListener of unsubscribe)unsubscribeListener();
        };
    }
};
function $0d4c5512f6ac0f65$var$reorder(sourceElement, sourceIndex, targetElement, targetIndex) {
    const position = targetIndex < sourceIndex ? "afterend" : "beforebegin";
    targetElement.insertAdjacentElement(position, sourceElement);
}
function $0d4c5512f6ac0f65$var$sortByIndex(a, b) {
    return a.index - b.index;
}
function $0d4c5512f6ac0f65$var$sort(instances) {
    return Array.from(instances).sort($0d4c5512f6ac0f65$var$sortByIndex);
}
// src/sortable/sortable.ts
var $0d4c5512f6ac0f65$var$defaultPlugins = [
    $0d4c5512f6ac0f65$export$772495ad80b642a5,
    $0d4c5512f6ac0f65$export$142f7d8426595470
];
var $0d4c5512f6ac0f65$export$f787c7f92b2d7bab = {
    duration: 250,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    idle: false
};
var $0d4c5512f6ac0f65$var$store = new (0, $eb0d2ed00918af28$export$b62288191c5a7f4)();
var $0d4c5512f6ac0f65$var$_group_dec, $0d4c5512f6ac0f65$var$_index_dec, $0d4c5512f6ac0f65$var$_init, $0d4c5512f6ac0f65$var$_index, $0d4c5512f6ac0f65$var$_previousGroup, $0d4c5512f6ac0f65$var$_previousIndex, $0d4c5512f6ac0f65$var$_group, $0d4c5512f6ac0f65$var$_element;
$0d4c5512f6ac0f65$var$_index_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
], $0d4c5512f6ac0f65$var$_group_dec = [
    (0, $eb0d2ed00918af28$export$90a44edba14e47be)
];
var $0d4c5512f6ac0f65$export$31b3ca70d8f57423 = class {
    constructor(_a, manager){
        $0d4c5512f6ac0f65$var$__privateAdd(this, $0d4c5512f6ac0f65$var$_index, $0d4c5512f6ac0f65$var$__runInitializers($0d4c5512f6ac0f65$var$_init, 8, this)), $0d4c5512f6ac0f65$var$__runInitializers($0d4c5512f6ac0f65$var$_init, 11, this);
        $0d4c5512f6ac0f65$var$__privateAdd(this, $0d4c5512f6ac0f65$var$_previousGroup);
        $0d4c5512f6ac0f65$var$__privateAdd(this, $0d4c5512f6ac0f65$var$_previousIndex);
        $0d4c5512f6ac0f65$var$__privateAdd(this, $0d4c5512f6ac0f65$var$_group, $0d4c5512f6ac0f65$var$__runInitializers($0d4c5512f6ac0f65$var$_init, 12, this)), $0d4c5512f6ac0f65$var$__runInitializers($0d4c5512f6ac0f65$var$_init, 15, this);
        $0d4c5512f6ac0f65$var$__privateAdd(this, $0d4c5512f6ac0f65$var$_element);
        this.register = ()=>{
            (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
                var _a, _b;
                (_a = this.manager) == null || _a.registry.register(this.droppable);
                (_b = this.manager) == null || _b.registry.register(this.draggable);
            });
            return ()=>this.unregister();
        };
        this.unregister = ()=>{
            (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
                var _a, _b;
                (_a = this.manager) == null || _a.registry.unregister(this.droppable);
                (_b = this.manager) == null || _b.registry.unregister(this.draggable);
            });
        };
        this.destroy = ()=>{
            (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
                this.droppable.destroy();
                this.draggable.destroy();
            });
        };
        var _b = _a, { effects: inputEffects = ()=>[], group: group, index: index, sensors: sensors, type: type, transition: transition = $0d4c5512f6ac0f65$export$f787c7f92b2d7bab, plugins: pluginsInput } = _b, input = $0d4c5512f6ac0f65$var$__objRest(_b, [
            "effects",
            "group",
            "index",
            "sensors",
            "type",
            "transition",
            "plugins"
        ]);
        const plugins = (0, $9636818b04ce7da6$export$7158c2daed5164d3)(pluginsInput, $0d4c5512f6ac0f65$var$defaultPlugins);
        this.droppable = new $0d4c5512f6ac0f65$export$2a6316104b6c69c9(input, manager, this);
        this.draggable = new $0d4c5512f6ac0f65$export$aacefb37d6963ced($0d4c5512f6ac0f65$var$__spreadProps($0d4c5512f6ac0f65$var$__spreadValues({}, input), {
            plugins: plugins,
            effects: ()=>[
                    ()=>{
                        var _a2, _b2, _c;
                        const status = (_a2 = this.manager) == null ? void 0 : _a2.dragOperation.status;
                        if ((status == null ? void 0 : status.initializing) && this.id === ((_c = (_b2 = this.manager) == null ? void 0 : _b2.dragOperation.source) == null ? void 0 : _c.id)) $0d4c5512f6ac0f65$var$store.clear(this.manager);
                        if (status == null ? void 0 : status.dragging) $0d4c5512f6ac0f65$var$store.set(this.manager, this.id, (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>({
                                initialIndex: this.index,
                                initialGroup: this.group
                            })));
                    },
                    ()=>{
                        const { index: index2, group: group2, manager: _ } = this;
                        const previousIndex = $0d4c5512f6ac0f65$var$__privateGet(this, $0d4c5512f6ac0f65$var$_previousIndex);
                        const previousGroup = $0d4c5512f6ac0f65$var$__privateGet(this, $0d4c5512f6ac0f65$var$_previousGroup);
                        if (index2 !== previousIndex || group2 !== previousGroup) {
                            $0d4c5512f6ac0f65$var$__privateSet(this, $0d4c5512f6ac0f65$var$_previousIndex, index2);
                            $0d4c5512f6ac0f65$var$__privateSet(this, $0d4c5512f6ac0f65$var$_previousGroup, group2);
                            this.animate();
                        }
                    },
                    ()=>{
                        var _a2, _b2;
                        const { target: target } = this;
                        const { isDragSource: isDragSource } = this.draggable;
                        const feedback = (_b2 = (_a2 = this.draggable.pluginConfig((0, $4e1e107797f01458$export$175e500a48a60fd2))) == null ? void 0 : _a2.feedback) != null ? _b2 : "default";
                        if (feedback === "move" && isDragSource) this.droppable.disabled = !target;
                    },
                    ...inputEffects()
                ],
            type: type,
            sensors: sensors
        }), manager, this);
        $0d4c5512f6ac0f65$var$__privateSet(this, $0d4c5512f6ac0f65$var$_element, input.element);
        this.manager = manager;
        this.index = index;
        $0d4c5512f6ac0f65$var$__privateSet(this, $0d4c5512f6ac0f65$var$_previousIndex, index);
        this.group = group;
        $0d4c5512f6ac0f65$var$__privateSet(this, $0d4c5512f6ac0f65$var$_previousGroup, group);
        this.type = type;
        this.transition = transition;
    }
    get initialIndex() {
        var _a, _b;
        return (_b = (_a = $0d4c5512f6ac0f65$var$store.get(this.manager, this.id)) == null ? void 0 : _a.initialIndex) != null ? _b : this.index;
    }
    get initialGroup() {
        var _a, _b;
        return (_b = (_a = $0d4c5512f6ac0f65$var$store.get(this.manager, this.id)) == null ? void 0 : _a.initialGroup) != null ? _b : this.group;
    }
    animate() {
        (0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
            const { manager: manager, transition: transition } = this;
            const { shape: shape } = this.droppable;
            if (!manager) return;
            const { idle: idle } = manager.dragOperation.status;
            if (!shape || !transition || idle && !transition.idle) return;
            manager.renderer.rendering.then(()=>{
                const { element: element } = this;
                if (!element) return;
                for (const animation of element.getAnimations())if ("transitionProperty" in animation && (animation.transitionProperty === "transform" || animation.transitionProperty === "translate" || animation.transitionProperty === "scale")) animation.cancel();
                const updatedShape = this.refreshShape();
                if (!updatedShape) return;
                const delta = {
                    x: shape.boundingRectangle.left - updatedShape.boundingRectangle.left,
                    y: shape.boundingRectangle.top - updatedShape.boundingRectangle.top
                };
                const { translate: translate } = (0, $501f8c524dad2740$export$8ef593ce41855f7f)(element);
                const currentTranslate = (0, $501f8c524dad2740$export$512056b882a0a591)(element, translate, false);
                const finalTranslate = (0, $501f8c524dad2740$export$512056b882a0a591)(element, translate);
                if (delta.x || delta.y) {
                    const resolvedTransition = (0, $501f8c524dad2740$export$ff7706047246b98b)((0, $501f8c524dad2740$export$38b2d434cce3ea22)(element)) ? $0d4c5512f6ac0f65$var$__spreadProps($0d4c5512f6ac0f65$var$__spreadValues({}, transition), {
                        duration: 0
                    }) : transition;
                    (0, $501f8c524dad2740$export$729fc4eb9847864b)({
                        element: element,
                        keyframes: {
                            translate: [
                                `${currentTranslate.x + delta.x}px ${currentTranslate.y + delta.y}px ${currentTranslate.z}`,
                                `${finalTranslate.x}px ${finalTranslate.y}px ${finalTranslate.z}`
                            ]
                        },
                        options: resolvedTransition
                    }).then(()=>{
                        if (!manager.dragOperation.status.dragging) this.droppable.shape = void 0;
                    });
                }
            });
        });
    }
    get manager() {
        return this.draggable.manager;
    }
    set manager(manager) {
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            this.draggable.manager = manager;
            this.droppable.manager = manager;
        });
    }
    set element(element) {
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            const previousElement = $0d4c5512f6ac0f65$var$__privateGet(this, $0d4c5512f6ac0f65$var$_element);
            const droppableElement = this.droppable.element;
            const draggableElement = this.draggable.element;
            if (!droppableElement || droppableElement === previousElement) this.droppable.element = element;
            if (!draggableElement || draggableElement === previousElement) this.draggable.element = element;
            $0d4c5512f6ac0f65$var$__privateSet(this, $0d4c5512f6ac0f65$var$_element, element);
        });
    }
    get element() {
        var _a, _b;
        const element = $0d4c5512f6ac0f65$var$__privateGet(this, $0d4c5512f6ac0f65$var$_element);
        if (!element) return;
        return (_b = (_a = (0, $501f8c524dad2740$export$83d4521ded5863e3).get(element)) != null ? _a : element) != null ? _b : this.droppable.element;
    }
    set target(target) {
        this.droppable.element = target;
    }
    get target() {
        return this.droppable.element;
    }
    set source(source) {
        this.draggable.element = source;
    }
    get source() {
        return this.draggable.element;
    }
    get disabled() {
        return this.draggable.disabled && this.droppable.disabled;
    }
    set plugins(value) {
        this.draggable.plugins = (0, $9636818b04ce7da6$export$7158c2daed5164d3)(value, $0d4c5512f6ac0f65$var$defaultPlugins);
    }
    set disabled(value) {
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            this.droppable.disabled = value;
            this.draggable.disabled = value;
        });
    }
    set data(data) {
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            this.droppable.data = data;
            this.draggable.data = data;
        });
    }
    set handle(handle) {
        this.draggable.handle = handle;
    }
    set id(id) {
        this.droppable.id = id;
        this.draggable.id = id;
    }
    get id() {
        return this.droppable.id;
    }
    set sensors(value) {
        this.draggable.sensors = value;
    }
    set modifiers(value) {
        this.draggable.modifiers = value;
    }
    set collisionPriority(value) {
        this.droppable.collisionPriority = value;
    }
    set collisionDetector(value) {
        this.droppable.collisionDetector = value != null ? value : (0, $c970db14647306d6$export$459d48c6d804bc59);
    }
    set alignment(value) {
        this.draggable.alignment = value;
    }
    get alignment() {
        return this.draggable.alignment;
    }
    set type(type) {
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            this.droppable.type = type;
            this.draggable.type = type;
        });
    }
    get type() {
        return this.draggable.type;
    }
    set accept(value) {
        this.droppable.accept = value;
    }
    get accept() {
        return this.droppable.accept;
    }
    get isDropTarget() {
        return this.droppable.isDropTarget;
    }
    /**
   * A boolean indicating whether the sortable item is the source of a drag operation.
   */ get isDragSource() {
        return this.draggable.isDragSource;
    }
    /**
   * A boolean indicating whether the sortable item is being dragged.
   */ get isDragging() {
        return this.draggable.isDragging;
    }
    /**
   * A boolean indicating whether the sortable item is being dropped.
   */ get isDropping() {
        return this.draggable.isDropping;
    }
    get status() {
        return this.draggable.status;
    }
    refreshShape() {
        return this.droppable.refreshShape();
    }
    accepts(draggable) {
        return this.droppable.accepts(draggable);
    }
};
$0d4c5512f6ac0f65$var$_init = $0d4c5512f6ac0f65$var$__decoratorStart();
$0d4c5512f6ac0f65$var$_index = new WeakMap();
$0d4c5512f6ac0f65$var$_previousGroup = new WeakMap();
$0d4c5512f6ac0f65$var$_previousIndex = new WeakMap();
$0d4c5512f6ac0f65$var$_group = new WeakMap();
$0d4c5512f6ac0f65$var$_element = new WeakMap();
$0d4c5512f6ac0f65$var$__decorateElement($0d4c5512f6ac0f65$var$_init, 4, "index", $0d4c5512f6ac0f65$var$_index_dec, $0d4c5512f6ac0f65$export$31b3ca70d8f57423, $0d4c5512f6ac0f65$var$_index);
$0d4c5512f6ac0f65$var$__decorateElement($0d4c5512f6ac0f65$var$_init, 4, "group", $0d4c5512f6ac0f65$var$_group_dec, $0d4c5512f6ac0f65$export$31b3ca70d8f57423, $0d4c5512f6ac0f65$var$_group);
$0d4c5512f6ac0f65$var$__decoratorMetadata($0d4c5512f6ac0f65$var$_init, $0d4c5512f6ac0f65$export$31b3ca70d8f57423);
var $0d4c5512f6ac0f65$export$aacefb37d6963ced = class extends (0, $4e1e107797f01458$export$f2a139e5d18b9882) {
    constructor(input, manager, sortable){
        super(input, manager);
        this.sortable = sortable;
    }
    get index() {
        return this.sortable.index;
    }
    get initialIndex() {
        return this.sortable.initialIndex;
    }
    get group() {
        return this.sortable.group;
    }
    get initialGroup() {
        return this.sortable.initialGroup;
    }
};
var $0d4c5512f6ac0f65$export$2a6316104b6c69c9 = class extends (0, $4e1e107797f01458$export$423ec2075359570a) {
    constructor(input, manager, sortable){
        super(input, manager);
        this.sortable = sortable;
    }
    get index() {
        return this.sortable.index;
    }
    get group() {
        return this.sortable.group;
    }
};
 //# sourceMappingURL=sortable.js.map



var $b2d051ff65b2716c$var$__defProp = Object.defineProperty;
var $b2d051ff65b2716c$var$__defProps = Object.defineProperties;
var $b2d051ff65b2716c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b2d051ff65b2716c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b2d051ff65b2716c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b2d051ff65b2716c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b2d051ff65b2716c$var$__defNormalProp = (obj, key, value)=>key in obj ? $b2d051ff65b2716c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b2d051ff65b2716c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b2d051ff65b2716c$var$__hasOwnProp.call(b, prop)) $b2d051ff65b2716c$var$__defNormalProp(a, prop, b[prop]);
    if ($b2d051ff65b2716c$var$__getOwnPropSymbols) {
        for (var prop of $b2d051ff65b2716c$var$__getOwnPropSymbols(b))if ($b2d051ff65b2716c$var$__propIsEnum.call(b, prop)) $b2d051ff65b2716c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b2d051ff65b2716c$var$__spreadProps = (a, b)=>$b2d051ff65b2716c$var$__defProps(a, $b2d051ff65b2716c$var$__getOwnPropDescs(b));
var $b2d051ff65b2716c$var$_AxisModifier = class _AxisModifier extends (0, $9636818b04ce7da6$export$5acd5e6efc9671b7) {
    /**
   * Applies the axis restriction to the drag operation.
   *
   * @param operation - The current drag operation
   * @returns The modified transform with the axis restriction applied
   */ apply({ transform: transform }) {
        if (!this.options) return transform;
        const { axis: axis, value: value } = this.options;
        return $b2d051ff65b2716c$var$__spreadProps($b2d051ff65b2716c$var$__spreadValues({}, transform), {
            [axis]: value
        });
    }
};
/**
 * Creates a configured instance of the AxisModifier.
 *
 * @param options - The axis restriction options
 * @returns A configured AxisModifier instance
 */ $b2d051ff65b2716c$var$_AxisModifier.configure = (0, $9636818b04ce7da6$export$adf416f00cca6418)($b2d051ff65b2716c$var$_AxisModifier);
var $b2d051ff65b2716c$export$5c43c4dec18d6ef4 = $b2d051ff65b2716c$var$_AxisModifier;
var $b2d051ff65b2716c$export$2d8564a14f5fec69 = $b2d051ff65b2716c$export$5c43c4dec18d6ef4.configure({
    axis: "x",
    value: 0
});
var $b2d051ff65b2716c$export$35828f5146a69550 = $b2d051ff65b2716c$export$5c43c4dec18d6ef4.configure({
    axis: "y",
    value: 0
});
// src/modifiers/boundingRectangle.ts
function $b2d051ff65b2716c$export$6db2c94cc5d05406(shape, transform, boundingRect) {
    const value = $b2d051ff65b2716c$var$__spreadValues({}, transform);
    if (shape.boundingRectangle.top + transform.y <= boundingRect.top) value.y = boundingRect.top - shape.boundingRectangle.top;
    else if (shape.boundingRectangle.bottom + transform.y >= boundingRect.top + boundingRect.height) value.y = boundingRect.top + boundingRect.height - shape.boundingRectangle.bottom;
    if (shape.boundingRectangle.left + transform.x <= boundingRect.left) value.x = boundingRect.left - shape.boundingRectangle.left;
    else if (shape.boundingRectangle.right + transform.x >= boundingRect.left + boundingRect.width) value.x = boundingRect.left + boundingRect.width - shape.boundingRectangle.right;
    return value;
}
var $b2d051ff65b2716c$var$_SnapModifier = class _SnapModifier extends (0, $9636818b04ce7da6$export$5acd5e6efc9671b7) {
    /**
   * Applies the snap grid to the drag operation.
   *
   * @param operation - The current drag operation
   * @returns The modified transform with coordinates snapped to the grid
   */ apply({ transform: transform }) {
        var _a;
        const { size: size = 20 } = (_a = this.options) != null ? _a : {};
        const x = typeof size === "number" ? size : size.x;
        const y = typeof size === "number" ? size : size.y;
        return $b2d051ff65b2716c$var$__spreadProps($b2d051ff65b2716c$var$__spreadValues({}, transform), {
            x: Math.ceil(transform.x / x) * x,
            y: Math.ceil(transform.y / y) * y
        });
    }
};
/**
 * Creates a configured instance of the SnapModifier.
 *
 * @param options - The snap grid options
 * @returns A configured SnapModifier instance
 */ $b2d051ff65b2716c$var$_SnapModifier.configure = (0, $9636818b04ce7da6$export$adf416f00cca6418)($b2d051ff65b2716c$var$_SnapModifier);
var $b2d051ff65b2716c$export$c106ade1854285b6 = $b2d051ff65b2716c$var$_SnapModifier;
 //# sourceMappingURL=modifiers.js.map


var $d9ca3e6570e7a9a7$var$__defProp = Object.defineProperty;
var $d9ca3e6570e7a9a7$var$__defProps = Object.defineProperties;
var $d9ca3e6570e7a9a7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d9ca3e6570e7a9a7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d9ca3e6570e7a9a7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d9ca3e6570e7a9a7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d9ca3e6570e7a9a7$var$__defNormalProp = (obj, key, value)=>key in obj ? $d9ca3e6570e7a9a7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d9ca3e6570e7a9a7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d9ca3e6570e7a9a7$var$__hasOwnProp.call(b, prop)) $d9ca3e6570e7a9a7$var$__defNormalProp(a, prop, b[prop]);
    if ($d9ca3e6570e7a9a7$var$__getOwnPropSymbols) {
        for (var prop of $d9ca3e6570e7a9a7$var$__getOwnPropSymbols(b))if ($d9ca3e6570e7a9a7$var$__propIsEnum.call(b, prop)) $d9ca3e6570e7a9a7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d9ca3e6570e7a9a7$var$__spreadProps = (a, b)=>$d9ca3e6570e7a9a7$var$__defProps(a, $d9ca3e6570e7a9a7$var$__getOwnPropDescs(b));
// src/move.ts
function $d9ca3e6570e7a9a7$export$5d49d615ad5ea2b0(array, from, to) {
    if (from === to) return array;
    const newArray = array.slice();
    newArray.splice(to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
function $d9ca3e6570e7a9a7$export$5d3a3e794fd2dcef(array, from, to) {
    if (from === to) return array;
    const newArray = array.slice();
    const item = newArray[from];
    newArray[from] = newArray[to];
    newArray[to] = item;
    return newArray;
}
function $d9ca3e6570e7a9a7$var$hasSortableIndices(source) {
    return "initialIndex" in source && typeof source.initialIndex === "number" && "index" in source && typeof source.index === "number";
}
function $d9ca3e6570e7a9a7$var$mutate(items, event, mutation) {
    var _a, _b, _c;
    const { source: source, target: target, canceled: canceled } = event.operation;
    if (!source || !target || canceled) {
        if ("preventDefault" in event) event.preventDefault();
        return items;
    }
    const findIndex = (item, id)=>item === id || typeof item === "object" && "id" in item && item.id === id;
    if (Array.isArray(items)) {
        const sourceIndex2 = items.findIndex((item)=>findIndex(item, source.id));
        const targetIndex2 = items.findIndex((item)=>findIndex(item, target.id));
        if (sourceIndex2 === -1 || targetIndex2 === -1) {
            if ($d9ca3e6570e7a9a7$var$hasSortableIndices(source)) {
                const from = source.initialIndex;
                const to = source.index;
                if (from === to || from < 0 || from >= items.length) {
                    if ("preventDefault" in event) event.preventDefault();
                    return items;
                }
                return mutation(items, from, to);
            }
            return items;
        }
        if (!canceled && "index" in source && typeof source.index === "number") {
            const projectedSourceIndex = source.index;
            if (projectedSourceIndex !== sourceIndex2) return mutation(items, sourceIndex2, projectedSourceIndex);
        }
        return mutation(items, sourceIndex2, targetIndex2);
    }
    const entries = Object.entries(items);
    let sourceIndex = -1;
    let sourceParent;
    let targetIndex = -1;
    let targetParent;
    for (const [id, children] of entries){
        if (sourceIndex === -1) {
            sourceIndex = children.findIndex((item)=>findIndex(item, source.id));
            if (sourceIndex !== -1) sourceParent = id;
        }
        if (targetIndex === -1) {
            targetIndex = children.findIndex((item)=>findIndex(item, target.id));
            if (targetIndex !== -1) targetParent = id;
        }
        if (sourceIndex !== -1 && targetIndex !== -1) break;
    }
    if (sourceIndex === -1 && $d9ca3e6570e7a9a7$var$hasSortableIndices(source)) {
        const srcParent = source.initialGroup;
        const srcIndex = source.initialIndex;
        const tgtParent = source.group;
        const tgtIndex = source.index;
        if (srcParent == null || tgtParent == null || !(srcParent in items) || !(tgtParent in items)) {
            if ("preventDefault" in event) event.preventDefault();
            return items;
        }
        if (srcParent === tgtParent && srcIndex === tgtIndex) {
            if ("preventDefault" in event) event.preventDefault();
            return items;
        }
        if (srcParent === tgtParent) return $d9ca3e6570e7a9a7$var$__spreadProps($d9ca3e6570e7a9a7$var$__spreadValues({}, items), {
            [srcParent]: mutation(items[srcParent], srcIndex, tgtIndex)
        });
        const sourceItem2 = items[srcParent][srcIndex];
        return $d9ca3e6570e7a9a7$var$__spreadProps($d9ca3e6570e7a9a7$var$__spreadValues({}, items), {
            [srcParent]: [
                ...items[srcParent].slice(0, srcIndex),
                ...items[srcParent].slice(srcIndex + 1)
            ],
            [tgtParent]: [
                ...items[tgtParent].slice(0, tgtIndex),
                sourceItem2,
                ...items[tgtParent].slice(tgtIndex)
            ]
        });
    }
    if (!source.manager) return items;
    const { dragOperation: dragOperation } = source.manager;
    const position = (_b = (_a = dragOperation.shape) == null ? void 0 : _a.current.center) != null ? _b : dragOperation.position.current;
    if (targetParent == null) {
        if (target.id in items) {
            const insertionIndex = target.shape && position.y > target.shape.center.y ? items[target.id].length : 0;
            targetParent = target.id;
            targetIndex = insertionIndex;
        }
    }
    if (sourceParent == null || targetParent == null || sourceParent === targetParent && sourceIndex === targetIndex) {
        if (sourceParent != null && sourceParent === targetParent && sourceIndex === targetIndex && $d9ca3e6570e7a9a7$var$hasSortableIndices(source)) {
            const hasGroupChanged = source.group != null && source.group !== sourceParent;
            const hasIndexChanged = source.index !== sourceIndex;
            if (hasGroupChanged || hasIndexChanged) {
                const reconciledTargetParent = (_c = source.group) != null ? _c : sourceParent;
                if (reconciledTargetParent in items) {
                    if (sourceParent === reconciledTargetParent) return $d9ca3e6570e7a9a7$var$__spreadProps($d9ca3e6570e7a9a7$var$__spreadValues({}, items), {
                        [sourceParent]: mutation(items[sourceParent], sourceIndex, source.index)
                    });
                    const sourceItem2 = items[sourceParent][sourceIndex];
                    return $d9ca3e6570e7a9a7$var$__spreadProps($d9ca3e6570e7a9a7$var$__spreadValues({}, items), {
                        [sourceParent]: [
                            ...items[sourceParent].slice(0, sourceIndex),
                            ...items[sourceParent].slice(sourceIndex + 1)
                        ],
                        [reconciledTargetParent]: [
                            ...items[reconciledTargetParent].slice(0, source.index),
                            sourceItem2,
                            ...items[reconciledTargetParent].slice(source.index)
                        ]
                    });
                }
            }
        }
        if ("preventDefault" in event) event.preventDefault();
        return items;
    }
    if (sourceParent === targetParent) return $d9ca3e6570e7a9a7$var$__spreadProps($d9ca3e6570e7a9a7$var$__spreadValues({}, items), {
        [sourceParent]: mutation(items[sourceParent], sourceIndex, targetIndex)
    });
    const isBelowTarget = target.shape && Math.round(position.y) > Math.round(target.shape.center.y);
    const modifier = isBelowTarget ? 1 : 0;
    const sourceItem = items[sourceParent][sourceIndex];
    return $d9ca3e6570e7a9a7$var$__spreadProps($d9ca3e6570e7a9a7$var$__spreadValues({}, items), {
        [sourceParent]: [
            ...items[sourceParent].slice(0, sourceIndex),
            ...items[sourceParent].slice(sourceIndex + 1)
        ],
        [targetParent]: [
            ...items[targetParent].slice(0, targetIndex + modifier),
            sourceItem,
            ...items[targetParent].slice(targetIndex + modifier)
        ]
    });
}
function $d9ca3e6570e7a9a7$export$d947e5f4f4c48d48(items, event) {
    return $d9ca3e6570e7a9a7$var$mutate(items, event, $d9ca3e6570e7a9a7$export$5d49d615ad5ea2b0);
}
function $d9ca3e6570e7a9a7$export$b0e76d9850c64156(items, event) {
    return $d9ca3e6570e7a9a7$var$mutate(items, event, $d9ca3e6570e7a9a7$export$5d3a3e794fd2dcef);
}



var $e6dde9a6c7b22e79$exports = {};
// shim for using process in browser
var $e6dde9a6c7b22e79$var$process = $e6dde9a6c7b22e79$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e6dde9a6c7b22e79$var$cachedSetTimeout;
var $e6dde9a6c7b22e79$var$cachedClearTimeout;
function $e6dde9a6c7b22e79$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $e6dde9a6c7b22e79$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $e6dde9a6c7b22e79$var$cachedSetTimeout = setTimeout;
        else $e6dde9a6c7b22e79$var$cachedSetTimeout = $e6dde9a6c7b22e79$var$defaultSetTimout;
    } catch (e) {
        $e6dde9a6c7b22e79$var$cachedSetTimeout = $e6dde9a6c7b22e79$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $e6dde9a6c7b22e79$var$cachedClearTimeout = clearTimeout;
        else $e6dde9a6c7b22e79$var$cachedClearTimeout = $e6dde9a6c7b22e79$var$defaultClearTimeout;
    } catch (e) {
        $e6dde9a6c7b22e79$var$cachedClearTimeout = $e6dde9a6c7b22e79$var$defaultClearTimeout;
    }
})();
function $e6dde9a6c7b22e79$var$runTimeout(fun) {
    if ($e6dde9a6c7b22e79$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e6dde9a6c7b22e79$var$cachedSetTimeout === $e6dde9a6c7b22e79$var$defaultSetTimout || !$e6dde9a6c7b22e79$var$cachedSetTimeout) && setTimeout) {
        $e6dde9a6c7b22e79$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e6dde9a6c7b22e79$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e6dde9a6c7b22e79$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e6dde9a6c7b22e79$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e6dde9a6c7b22e79$var$runClearTimeout(marker) {
    if ($e6dde9a6c7b22e79$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e6dde9a6c7b22e79$var$cachedClearTimeout === $e6dde9a6c7b22e79$var$defaultClearTimeout || !$e6dde9a6c7b22e79$var$cachedClearTimeout) && clearTimeout) {
        $e6dde9a6c7b22e79$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e6dde9a6c7b22e79$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e6dde9a6c7b22e79$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e6dde9a6c7b22e79$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e6dde9a6c7b22e79$var$queue = [];
var $e6dde9a6c7b22e79$var$draining = false;
var $e6dde9a6c7b22e79$var$currentQueue;
var $e6dde9a6c7b22e79$var$queueIndex = -1;
function $e6dde9a6c7b22e79$var$cleanUpNextTick() {
    if (!$e6dde9a6c7b22e79$var$draining || !$e6dde9a6c7b22e79$var$currentQueue) return;
    $e6dde9a6c7b22e79$var$draining = false;
    if ($e6dde9a6c7b22e79$var$currentQueue.length) $e6dde9a6c7b22e79$var$queue = $e6dde9a6c7b22e79$var$currentQueue.concat($e6dde9a6c7b22e79$var$queue);
    else $e6dde9a6c7b22e79$var$queueIndex = -1;
    if ($e6dde9a6c7b22e79$var$queue.length) $e6dde9a6c7b22e79$var$drainQueue();
}
function $e6dde9a6c7b22e79$var$drainQueue() {
    if ($e6dde9a6c7b22e79$var$draining) return;
    var timeout = $e6dde9a6c7b22e79$var$runTimeout($e6dde9a6c7b22e79$var$cleanUpNextTick);
    $e6dde9a6c7b22e79$var$draining = true;
    var len = $e6dde9a6c7b22e79$var$queue.length;
    while(len){
        $e6dde9a6c7b22e79$var$currentQueue = $e6dde9a6c7b22e79$var$queue;
        $e6dde9a6c7b22e79$var$queue = [];
        while(++$e6dde9a6c7b22e79$var$queueIndex < len)if ($e6dde9a6c7b22e79$var$currentQueue) $e6dde9a6c7b22e79$var$currentQueue[$e6dde9a6c7b22e79$var$queueIndex].run();
        $e6dde9a6c7b22e79$var$queueIndex = -1;
        len = $e6dde9a6c7b22e79$var$queue.length;
    }
    $e6dde9a6c7b22e79$var$currentQueue = null;
    $e6dde9a6c7b22e79$var$draining = false;
    $e6dde9a6c7b22e79$var$runClearTimeout(timeout);
}
$e6dde9a6c7b22e79$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e6dde9a6c7b22e79$var$queue.push(new $e6dde9a6c7b22e79$var$Item(fun, args));
    if ($e6dde9a6c7b22e79$var$queue.length === 1 && !$e6dde9a6c7b22e79$var$draining) $e6dde9a6c7b22e79$var$runTimeout($e6dde9a6c7b22e79$var$drainQueue);
};
// v8 likes predictible objects
function $e6dde9a6c7b22e79$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e6dde9a6c7b22e79$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e6dde9a6c7b22e79$var$process.title = 'browser';
$e6dde9a6c7b22e79$var$process.browser = true;
$e6dde9a6c7b22e79$var$process.env = {};
$e6dde9a6c7b22e79$var$process.argv = [];
$e6dde9a6c7b22e79$var$process.version = ''; // empty string to avoid regexp issues
$e6dde9a6c7b22e79$var$process.versions = {};
function $e6dde9a6c7b22e79$var$noop() {}
$e6dde9a6c7b22e79$var$process.on = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.addListener = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.once = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.off = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.removeListener = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.removeAllListeners = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.emit = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.prependListener = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.prependOnceListener = $e6dde9a6c7b22e79$var$noop;
$e6dde9a6c7b22e79$var$process.listeners = function(name) {
    return [];
};
$e6dde9a6c7b22e79$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$e6dde9a6c7b22e79$var$process.cwd = function() {
    return '/';
};
$e6dde9a6c7b22e79$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$e6dde9a6c7b22e79$var$process.umask = function() {
    return 0;
};


function $7d03b637065da5d5$export$f85c16a6d62f7d63(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) return url;
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) return window.location.protocol + url;
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) return url;
    const doc = document.implementation.createHTMLDocument();
    const base = doc.createElement('base');
    const a = doc.createElement('a');
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) base.href = baseUrl;
    a.href = url;
    return a.href;
}
const $7d03b637065da5d5$export$31b40729666a4ae0 = (()=>{
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    let counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    const random = ()=>// eslint-disable-next-line no-bitwise
        `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
    return ()=>{
        counter += 1;
        return `u${random()}${counter}`;
    };
})();
function $7d03b637065da5d5$export$1391212d75b2ee65(ms) {
    return (args)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(args), ms);
        });
}
function $7d03b637065da5d5$export$45b10814cc054894(arrayLike) {
    const arr = [];
    for(let i = 0, l = arrayLike.length; i < l; i++)arr.push(arrayLike[i]);
    return arr;
}
let $7d03b637065da5d5$var$styleProps = null;
function $7d03b637065da5d5$export$be6bf80faea8d5af(options = {}) {
    if ($7d03b637065da5d5$var$styleProps) return $7d03b637065da5d5$var$styleProps;
    if (options.includeStyleProperties) {
        $7d03b637065da5d5$var$styleProps = options.includeStyleProperties;
        return $7d03b637065da5d5$var$styleProps;
    }
    $7d03b637065da5d5$var$styleProps = $7d03b637065da5d5$export$45b10814cc054894(window.getComputedStyle(document.documentElement));
    return $7d03b637065da5d5$var$styleProps;
}
function $7d03b637065da5d5$var$px(node, styleProperty) {
    const win = node.ownerDocument.defaultView || window;
    const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace('px', '')) : 0;
}
function $7d03b637065da5d5$var$getNodeWidth(node) {
    const leftBorder = $7d03b637065da5d5$var$px(node, 'border-left-width');
    const rightBorder = $7d03b637065da5d5$var$px(node, 'border-right-width');
    return node.clientWidth + leftBorder + rightBorder;
}
function $7d03b637065da5d5$var$getNodeHeight(node) {
    const topBorder = $7d03b637065da5d5$var$px(node, 'border-top-width');
    const bottomBorder = $7d03b637065da5d5$var$px(node, 'border-bottom-width');
    return node.clientHeight + topBorder + bottomBorder;
}
function $7d03b637065da5d5$export$ada5537b2c061996(targetNode, options = {}) {
    const width = options.width || $7d03b637065da5d5$var$getNodeWidth(targetNode);
    const height = options.height || $7d03b637065da5d5$var$getNodeHeight(targetNode);
    return {
        width: width,
        height: height
    };
}
function $7d03b637065da5d5$export$d39ce20a37bba061() {
    let ratio;
    let FINAL_PROCESS;
    try {
        FINAL_PROCESS = $e6dde9a6c7b22e79$exports;
    } catch (e) {
    // pass
    }
    const val = FINAL_PROCESS && FINAL_PROCESS.env ? FINAL_PROCESS.env.devicePixelRatio : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) ratio = 1;
    }
    return ratio || window.devicePixelRatio || 1;
}
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
const $7d03b637065da5d5$var$canvasDimensionLimit = 16384;
function $7d03b637065da5d5$export$c2c809a2fe6b0f1a(canvas) {
    if (canvas.width > $7d03b637065da5d5$var$canvasDimensionLimit || canvas.height > $7d03b637065da5d5$var$canvasDimensionLimit) {
        if (canvas.width > $7d03b637065da5d5$var$canvasDimensionLimit && canvas.height > $7d03b637065da5d5$var$canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= $7d03b637065da5d5$var$canvasDimensionLimit / canvas.width;
                canvas.width = $7d03b637065da5d5$var$canvasDimensionLimit;
            } else {
                canvas.width *= $7d03b637065da5d5$var$canvasDimensionLimit / canvas.height;
                canvas.height = $7d03b637065da5d5$var$canvasDimensionLimit;
            }
        } else if (canvas.width > $7d03b637065da5d5$var$canvasDimensionLimit) {
            canvas.height *= $7d03b637065da5d5$var$canvasDimensionLimit / canvas.width;
            canvas.width = $7d03b637065da5d5$var$canvasDimensionLimit;
        } else {
            canvas.width *= $7d03b637065da5d5$var$canvasDimensionLimit / canvas.height;
            canvas.height = $7d03b637065da5d5$var$canvasDimensionLimit;
        }
    }
}
function $7d03b637065da5d5$export$403d539f215df596(canvas, options = {}) {
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, options.type ? options.type : 'image/png', options.quality ? options.quality : 1);
    });
    return new Promise((resolve)=>{
        const binaryString = window.atob(canvas.toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined).split(',')[1]);
        const len = binaryString.length;
        const binaryArray = new Uint8Array(len);
        for(let i = 0; i < len; i += 1)binaryArray[i] = binaryString.charCodeAt(i);
        resolve(new Blob([
            binaryArray
        ], {
            type: options.type ? options.type : 'image/png'
        }));
    });
}
function $7d03b637065da5d5$export$ec664d7487540b(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            img.decode().then(()=>{
                requestAnimationFrame(()=>resolve(img));
            });
        };
        img.onerror = reject;
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.src = url;
    });
}
async function $7d03b637065da5d5$export$fe77aa9c02de4599(svg) {
    return Promise.resolve().then(()=>new XMLSerializer().serializeToString(svg)).then(encodeURIComponent).then((html)=>`data:image/svg+xml;charset=utf-8,${html}`);
}
async function $7d03b637065da5d5$export$b62810fb8ca515fa(node, width, height) {
    const xmlns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(xmlns, 'svg');
    const foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttribute('width', `${width}`);
    svg.setAttribute('height', `${height}`);
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    foreignObject.setAttribute('width', '100%');
    foreignObject.setAttribute('height', '100%');
    foreignObject.setAttribute('x', '0');
    foreignObject.setAttribute('y', '0');
    foreignObject.setAttribute('externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return $7d03b637065da5d5$export$fe77aa9c02de4599(svg);
}
const $7d03b637065da5d5$export$3a92fc9ec83ef360 = (node, instance)=>{
    if (node instanceof instance) return true;
    const nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null) return false;
    return nodePrototype.constructor.name === instance.name || $7d03b637065da5d5$export$3a92fc9ec83ef360(nodePrototype, instance);
};


function $7ec5573f2cdabf03$var$formatCSSText(style) {
    const content = style.getPropertyValue('content');
    return `${style.cssText} content: '${content.replace(/'|"/g, '')}';`;
}
function $7ec5573f2cdabf03$var$formatCSSProperties(style, options) {
    return (0, $7d03b637065da5d5$export$be6bf80faea8d5af)(options).map((name)=>{
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        return `${name}: ${value}${priority ? ' !important' : ''};`;
    }).join(' ');
}
function $7ec5573f2cdabf03$var$getPseudoElementStyle(className, pseudo, style, options) {
    const selector = `.${className}:${pseudo}`;
    const cssText = style.cssText ? $7ec5573f2cdabf03$var$formatCSSText(style) : $7ec5573f2cdabf03$var$formatCSSProperties(style, options);
    return document.createTextNode(`${selector}{${cssText}}`);
}
function $7ec5573f2cdabf03$var$clonePseudoElement(nativeNode, clonedNode, pseudo, options) {
    const style = window.getComputedStyle(nativeNode, pseudo);
    const content = style.getPropertyValue('content');
    if (content === '' || content === 'none') return;
    const className = (0, $7d03b637065da5d5$export$31b40729666a4ae0)();
    try {
        clonedNode.className = `${clonedNode.className} ${className}`;
    } catch (err) {
        return;
    }
    const styleElement = document.createElement('style');
    styleElement.appendChild($7ec5573f2cdabf03$var$getPseudoElementStyle(className, pseudo, style, options));
    clonedNode.appendChild(styleElement);
}
function $7ec5573f2cdabf03$export$8df63687a708ed2e(nativeNode, clonedNode, options) {
    $7ec5573f2cdabf03$var$clonePseudoElement(nativeNode, clonedNode, ':before', options);
    $7ec5573f2cdabf03$var$clonePseudoElement(nativeNode, clonedNode, ':after', options);
}



const $78ea1b6fcfb0b990$var$WOFF = 'application/font-woff';
const $78ea1b6fcfb0b990$var$JPEG = 'image/jpeg';
const $78ea1b6fcfb0b990$var$mimes = {
    woff: $78ea1b6fcfb0b990$var$WOFF,
    woff2: $78ea1b6fcfb0b990$var$WOFF,
    ttf: 'application/font-truetype',
    eot: 'application/vnd.ms-fontobject',
    png: 'image/png',
    jpg: $78ea1b6fcfb0b990$var$JPEG,
    jpeg: $78ea1b6fcfb0b990$var$JPEG,
    gif: 'image/gif',
    tiff: 'image/tiff',
    svg: 'image/svg+xml',
    webp: 'image/webp'
};
function $78ea1b6fcfb0b990$var$getExtension(url) {
    const match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : '';
}
function $78ea1b6fcfb0b990$export$200548c990602f61(url) {
    const extension = $78ea1b6fcfb0b990$var$getExtension(url).toLowerCase();
    return $78ea1b6fcfb0b990$var$mimes[extension] || '';
}


function $5922f0136d660589$var$getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function $5922f0136d660589$export$f8a05efa20ffd5a(url) {
    return url.search(/^(data:)/) !== -1;
}
function $5922f0136d660589$export$68336ea1617fa80a(content, mimeType) {
    return `data:${mimeType};base64,${content}`;
}
async function $5922f0136d660589$export$c20a8b76c95b0d41(url, init, process) {
    const res = await fetch(url, init);
    if (res.status === 404) throw new Error(`Resource "${res.url}" not found`);
    const blob = await res.blob();
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = ()=>{
            try {
                resolve(process({
                    res: res,
                    result: reader.result
                }));
            } catch (error) {
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
const $5922f0136d660589$var$cache = {};
function $5922f0136d660589$var$getCacheKey(url, contentType, includeQueryParams) {
    let key = url.replace(/\?.*/, '');
    if (includeQueryParams) key = url;
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) key = key.replace(/.*\//, '');
    return contentType ? `[${contentType}]${key}` : key;
}
async function $5922f0136d660589$export$bdf0422c029b202a(resourceUrl, contentType, options) {
    const cacheKey = $5922f0136d660589$var$getCacheKey(resourceUrl, contentType, options.includeQueryParams);
    if ($5922f0136d660589$var$cache[cacheKey] != null) return $5922f0136d660589$var$cache[cacheKey];
    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
    if (options.cacheBust) // eslint-disable-next-line no-param-reassign
    resourceUrl += (/\?/.test(resourceUrl) ? '&' : '?') + new Date().getTime();
    let dataURL;
    try {
        const content = await $5922f0136d660589$export$c20a8b76c95b0d41(resourceUrl, options.fetchRequestInit, ({ res: res, result: result })=>{
            if (!contentType) // eslint-disable-next-line no-param-reassign
            contentType = res.headers.get('Content-Type') || '';
            return $5922f0136d660589$var$getContentFromDataUrl(result);
        });
        dataURL = $5922f0136d660589$export$68336ea1617fa80a(content, contentType);
    } catch (error) {
        dataURL = options.imagePlaceholder || '';
        let msg = `Failed to fetch resource: ${resourceUrl}`;
        if (error) msg = typeof error === 'string' ? error : error.message;
        if (msg) console.warn(msg);
    }
    $5922f0136d660589$var$cache[cacheKey] = dataURL;
    return dataURL;
}


async function $d2f2a41e8b24c38a$var$cloneCanvasElement(canvas) {
    const dataURL = canvas.toDataURL();
    if (dataURL === 'data:,') return canvas.cloneNode(false);
    return (0, $7d03b637065da5d5$export$ec664d7487540b)(dataURL);
}
async function $d2f2a41e8b24c38a$var$cloneVideoElement(video, options) {
    if (video.currentSrc) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        ctx === null || ctx === void 0 || ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL();
        return (0, $7d03b637065da5d5$export$ec664d7487540b)(dataURL);
    }
    const poster = video.poster;
    const contentType = (0, $78ea1b6fcfb0b990$export$200548c990602f61)(poster);
    const dataURL = await (0, $5922f0136d660589$export$bdf0422c029b202a)(poster, contentType, options);
    return (0, $7d03b637065da5d5$export$ec664d7487540b)(dataURL);
}
async function $d2f2a41e8b24c38a$var$cloneIFrameElement(iframe, options) {
    var _a;
    try {
        if ((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body) return await $d2f2a41e8b24c38a$export$ae8e35ea29ddac22(iframe.contentDocument.body, options, true);
    } catch (_b) {
    // Failed to clone iframe
    }
    return iframe.cloneNode(false);
}
async function $d2f2a41e8b24c38a$var$cloneSingleNode(node, options) {
    if ((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(node, HTMLCanvasElement)) return $d2f2a41e8b24c38a$var$cloneCanvasElement(node);
    if ((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(node, HTMLVideoElement)) return $d2f2a41e8b24c38a$var$cloneVideoElement(node, options);
    if ((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(node, HTMLIFrameElement)) return $d2f2a41e8b24c38a$var$cloneIFrameElement(node, options);
    return node.cloneNode($d2f2a41e8b24c38a$var$isSVGElement(node));
}
const $d2f2a41e8b24c38a$var$isSlotElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
const $d2f2a41e8b24c38a$var$isSVGElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SVG';
async function $d2f2a41e8b24c38a$var$cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    if ($d2f2a41e8b24c38a$var$isSVGElement(clonedNode)) return clonedNode;
    let children = [];
    if ($d2f2a41e8b24c38a$var$isSlotElement(nativeNode) && nativeNode.assignedNodes) children = (0, $7d03b637065da5d5$export$45b10814cc054894)(nativeNode.assignedNodes());
    else if ((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) children = (0, $7d03b637065da5d5$export$45b10814cc054894)(nativeNode.contentDocument.body.childNodes);
    else children = (0, $7d03b637065da5d5$export$45b10814cc054894)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
    if (children.length === 0 || (0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(nativeNode, HTMLVideoElement)) return clonedNode;
    await children.reduce((deferred, child)=>deferred.then(()=>$d2f2a41e8b24c38a$export$ae8e35ea29ddac22(child, options)).then((clonedChild)=>{
            if (clonedChild) clonedNode.appendChild(clonedChild);
        }), Promise.resolve());
    return clonedNode;
}
function $d2f2a41e8b24c38a$var$cloneCSSStyle(nativeNode, clonedNode, options) {
    const targetStyle = clonedNode.style;
    if (!targetStyle) return;
    const sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    } else (0, $7d03b637065da5d5$export$be6bf80faea8d5af)(options).forEach((name)=>{
        let value = sourceStyle.getPropertyValue(name);
        if (name === 'font-size' && value.endsWith('px')) {
            const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
            value = `${reducedFont}px`;
        }
        if ((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && name === 'display' && value === 'inline') value = 'block';
        if (name === 'd' && clonedNode.getAttribute('d')) value = `path(${clonedNode.getAttribute('d')})`;
        targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
}
function $d2f2a41e8b24c38a$var$cloneInputValue(nativeNode, clonedNode) {
    if ((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(nativeNode, HTMLTextAreaElement)) clonedNode.innerHTML = nativeNode.value;
    if ((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(nativeNode, HTMLInputElement)) clonedNode.setAttribute('value', nativeNode.value);
}
function $d2f2a41e8b24c38a$var$cloneSelectValue(nativeNode, clonedNode) {
    if ((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(nativeNode, HTMLSelectElement)) {
        const clonedSelect = clonedNode;
        const selectedOption = Array.from(clonedSelect.children).find((child)=>nativeNode.value === child.getAttribute('value'));
        if (selectedOption) selectedOption.setAttribute('selected', '');
    }
}
function $d2f2a41e8b24c38a$var$decorate(nativeNode, clonedNode, options) {
    if ((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        $d2f2a41e8b24c38a$var$cloneCSSStyle(nativeNode, clonedNode, options);
        (0, $7ec5573f2cdabf03$export$8df63687a708ed2e)(nativeNode, clonedNode, options);
        $d2f2a41e8b24c38a$var$cloneInputValue(nativeNode, clonedNode);
        $d2f2a41e8b24c38a$var$cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
async function $d2f2a41e8b24c38a$var$ensureSVGSymbols(clone, options) {
    const uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
    if (uses.length === 0) return clone;
    const processedDefs = {};
    for(let i = 0; i < uses.length; i++){
        const use = uses[i];
        const id = use.getAttribute('xlink:href');
        if (id) {
            const exist = clone.querySelector(id);
            const definition = document.querySelector(id);
            if (!exist && definition && !processedDefs[id]) // eslint-disable-next-line no-await-in-loop
            processedDefs[id] = await $d2f2a41e8b24c38a$export$ae8e35ea29ddac22(definition, options, true);
        }
    }
    const nodes = Object.values(processedDefs);
    if (nodes.length) {
        const ns = 'http://www.w3.org/1999/xhtml';
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('xmlns', ns);
        svg.style.position = 'absolute';
        svg.style.width = '0';
        svg.style.height = '0';
        svg.style.overflow = 'hidden';
        svg.style.display = 'none';
        const defs = document.createElementNS(ns, 'defs');
        svg.appendChild(defs);
        for(let i = 0; i < nodes.length; i++)defs.appendChild(nodes[i]);
        clone.appendChild(svg);
    }
    return clone;
}
async function $d2f2a41e8b24c38a$export$ae8e35ea29ddac22(node, options, isRoot) {
    if (!isRoot && options.filter && !options.filter(node)) return null;
    return Promise.resolve(node).then((clonedNode)=>$d2f2a41e8b24c38a$var$cloneSingleNode(clonedNode, options)).then((clonedNode)=>$d2f2a41e8b24c38a$var$cloneChildren(node, clonedNode, options)).then((clonedNode)=>$d2f2a41e8b24c38a$var$decorate(node, clonedNode, options)).then((clonedNode)=>$d2f2a41e8b24c38a$var$ensureSVGSymbols(clonedNode, options));
}





const $db71d1e03f6aefdb$var$URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
const $db71d1e03f6aefdb$var$URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const $db71d1e03f6aefdb$var$FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function $db71d1e03f6aefdb$var$toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, 'g');
}
function $db71d1e03f6aefdb$export$d04549d631b8762d(cssText) {
    const urls = [];
    cssText.replace($db71d1e03f6aefdb$var$URL_REGEX, (raw, quotation, url)=>{
        urls.push(url);
        return raw;
    });
    return urls.filter((url)=>!(0, $5922f0136d660589$export$f8a05efa20ffd5a)(url));
}
async function $db71d1e03f6aefdb$export$2be46bb7e96db87f(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    try {
        const resolvedURL = baseURL ? (0, $7d03b637065da5d5$export$f85c16a6d62f7d63)(resourceURL, baseURL) : resourceURL;
        const contentType = (0, $78ea1b6fcfb0b990$export$200548c990602f61)(resourceURL);
        let dataURL;
        if (getContentFromUrl) {
            const content = await getContentFromUrl(resolvedURL);
            dataURL = (0, $5922f0136d660589$export$68336ea1617fa80a)(content, contentType);
        } else dataURL = await (0, $5922f0136d660589$export$bdf0422c029b202a)(resolvedURL, contentType, options);
        return cssText.replace($db71d1e03f6aefdb$var$toRegex(resourceURL), `$1${dataURL}$3`);
    } catch (error) {
    // pass
    }
    return cssText;
}
function $db71d1e03f6aefdb$var$filterPreferredFontFormat(str, { preferredFontFormat: preferredFontFormat }) {
    return !preferredFontFormat ? str : str.replace($db71d1e03f6aefdb$var$FONT_SRC_REGEX, (match)=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            const [src, , format] = $db71d1e03f6aefdb$var$URL_WITH_FORMAT_REGEX.exec(match) || [];
            if (!format) return '';
            if (format === preferredFontFormat) return `src: ${src};`;
        }
    });
}
function $db71d1e03f6aefdb$export$7b668369e5eab853(url) {
    return url.search($db71d1e03f6aefdb$var$URL_REGEX) !== -1;
}
async function $db71d1e03f6aefdb$export$3d88803585cbbc21(cssText, baseUrl, options) {
    if (!$db71d1e03f6aefdb$export$7b668369e5eab853(cssText)) return cssText;
    const filteredCSSText = $db71d1e03f6aefdb$var$filterPreferredFontFormat(cssText, options);
    const urls = $db71d1e03f6aefdb$export$d04549d631b8762d(filteredCSSText);
    return urls.reduce((deferred, url)=>deferred.then((css)=>$db71d1e03f6aefdb$export$2be46bb7e96db87f(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}





async function $47d1a2421a150914$var$embedProp(propName, node, options) {
    var _a;
    const propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
    if (propValue) {
        const cssString = await (0, $db71d1e03f6aefdb$export$3d88803585cbbc21)(propValue, null, options);
        node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
        return true;
    }
    return false;
}
async function $47d1a2421a150914$var$embedBackground(clonedNode, options) {
    await $47d1a2421a150914$var$embedProp('background', clonedNode, options) || await $47d1a2421a150914$var$embedProp('background-image', clonedNode, options);
    await $47d1a2421a150914$var$embedProp('mask', clonedNode, options) || await $47d1a2421a150914$var$embedProp('-webkit-mask', clonedNode, options) || await $47d1a2421a150914$var$embedProp('mask-image', clonedNode, options) || await $47d1a2421a150914$var$embedProp('-webkit-mask-image', clonedNode, options);
}
async function $47d1a2421a150914$var$embedImageNode(clonedNode, options) {
    const isImageElement = (0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(clonedNode, HTMLImageElement);
    if (!(isImageElement && !(0, $5922f0136d660589$export$f8a05efa20ffd5a)(clonedNode.src)) && !((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(clonedNode, SVGImageElement) && !(0, $5922f0136d660589$export$f8a05efa20ffd5a)(clonedNode.href.baseVal))) return;
    const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
    const dataURL = await (0, $5922f0136d660589$export$bdf0422c029b202a)(url, (0, $78ea1b6fcfb0b990$export$200548c990602f61)(url), options);
    await new Promise((resolve, reject)=>{
        clonedNode.onload = resolve;
        clonedNode.onerror = options.onImageErrorHandler ? (...attributes)=>{
            try {
                resolve(options.onImageErrorHandler(...attributes));
            } catch (error) {
                reject(error);
            }
        } : reject;
        const image = clonedNode;
        if (image.decode) image.decode = resolve;
        if (image.loading === 'lazy') image.loading = 'eager';
        if (isImageElement) {
            clonedNode.srcset = '';
            clonedNode.src = dataURL;
        } else clonedNode.href.baseVal = dataURL;
    });
}
async function $47d1a2421a150914$var$embedChildren(clonedNode, options) {
    const children = (0, $7d03b637065da5d5$export$45b10814cc054894)(clonedNode.childNodes);
    const deferreds = children.map((child)=>$47d1a2421a150914$export$6660fa8dd20e53aa(child, options));
    await Promise.all(deferreds).then(()=>clonedNode);
}
async function $47d1a2421a150914$export$6660fa8dd20e53aa(clonedNode, options) {
    if ((0, $7d03b637065da5d5$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        await $47d1a2421a150914$var$embedBackground(clonedNode, options);
        await $47d1a2421a150914$var$embedImageNode(clonedNode, options);
        await $47d1a2421a150914$var$embedChildren(clonedNode, options);
    }
}


function $fb6f01e6fe554ea5$export$d63a6b7859608045(node, options) {
    const { style: style } = node;
    if (options.backgroundColor) style.backgroundColor = options.backgroundColor;
    if (options.width) style.width = `${options.width}px`;
    if (options.height) style.height = `${options.height}px`;
    const manual = options.style;
    if (manual != null) Object.keys(manual).forEach((key)=>{
        style[key] = manual[key];
    });
    return node;
}





const $8adf7a11b4111594$var$cssFetchCache = {};
async function $8adf7a11b4111594$var$fetchCSS(url) {
    let cache = $8adf7a11b4111594$var$cssFetchCache[url];
    if (cache != null) return cache;
    const res = await fetch(url);
    const cssText = await res.text();
    cache = {
        url: url,
        cssText: cssText
    };
    $8adf7a11b4111594$var$cssFetchCache[url] = cache;
    return cache;
}
async function $8adf7a11b4111594$var$embedFonts(data, options) {
    let cssText = data.cssText;
    const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
    const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
    const loadFonts = fontLocs.map(async (loc)=>{
        let url = loc.replace(regexUrl, '$1');
        if (!url.startsWith('https://')) url = new URL(url, data.url).href;
        return (0, $5922f0136d660589$export$c20a8b76c95b0d41)(url, options.fetchRequestInit, ({ result: result })=>{
            cssText = cssText.replace(loc, `url(${result})`);
            return [
                loc,
                result
            ];
        });
    });
    return Promise.all(loadFonts).then(()=>cssText);
}
function $8adf7a11b4111594$var$parseCSS(source) {
    if (source == null) return [];
    const result = [];
    const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    let cssText = source.replace(commentsRegex, '');
    // eslint-disable-next-line prefer-regex-literals
    const keyframesRegex = new RegExp('((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})', 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        const matches = keyframesRegex.exec(cssText);
        if (matches === null) break;
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, '');
    const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    const combinedCSSRegex = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})";
    // unified regex
    const unifiedRegex = new RegExp(combinedCSSRegex, 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        let matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) break;
            else importRegex.lastIndex = unifiedRegex.lastIndex;
        } else unifiedRegex.lastIndex = importRegex.lastIndex;
        result.push(matches[0]);
    }
    return result;
}
async function $8adf7a11b4111594$var$getCSSRules(styleSheets, options) {
    const ret = [];
    const deferreds = [];
    // First loop inlines imports
    styleSheets.forEach((sheet)=>{
        if ('cssRules' in sheet) try {
            (0, $7d03b637065da5d5$export$45b10814cc054894)(sheet.cssRules || []).forEach((item, index)=>{
                if (item.type === CSSRule.IMPORT_RULE) {
                    let importIndex = index + 1;
                    const url = item.href;
                    const deferred = $8adf7a11b4111594$var$fetchCSS(url).then((metadata)=>$8adf7a11b4111594$var$embedFonts(metadata, options)).then((cssText)=>$8adf7a11b4111594$var$parseCSS(cssText).forEach((rule)=>{
                            try {
                                sheet.insertRule(rule, rule.startsWith('@import') ? importIndex += 1 : sheet.cssRules.length);
                            } catch (error) {
                                console.error('Error inserting rule from remote css', {
                                    rule: rule,
                                    error: error
                                });
                            }
                        })).catch((e)=>{
                        console.error('Error loading remote css', e.toString());
                    });
                    deferreds.push(deferred);
                }
            });
        } catch (e) {
            const inline = styleSheets.find((a)=>a.href == null) || document.styleSheets[0];
            if (sheet.href != null) deferreds.push($8adf7a11b4111594$var$fetchCSS(sheet.href).then((metadata)=>$8adf7a11b4111594$var$embedFonts(metadata, options)).then((cssText)=>$8adf7a11b4111594$var$parseCSS(cssText).forEach((rule)=>{
                    inline.insertRule(rule, inline.cssRules.length);
                })).catch((err)=>{
                console.error('Error loading remote stylesheet', err);
            }));
            console.error('Error inlining remote css file', e);
        }
    });
    return Promise.all(deferreds).then(()=>{
        // Second loop parses rules
        styleSheets.forEach((sheet)=>{
            if ('cssRules' in sheet) try {
                (0, $7d03b637065da5d5$export$45b10814cc054894)(sheet.cssRules || []).forEach((item)=>{
                    ret.push(item);
                });
            } catch (e) {
                console.error(`Error while reading CSS rules from ${sheet.href}`, e);
            }
        });
        return ret;
    });
}
function $8adf7a11b4111594$var$getWebFontRules(cssRules) {
    return cssRules.filter((rule)=>rule.type === CSSRule.FONT_FACE_RULE).filter((rule)=>(0, $db71d1e03f6aefdb$export$7b668369e5eab853)(rule.style.getPropertyValue('src')));
}
async function $8adf7a11b4111594$var$parseWebFontRules(node, options) {
    if (node.ownerDocument == null) throw new Error('Provided element is not within a Document');
    const styleSheets = (0, $7d03b637065da5d5$export$45b10814cc054894)(node.ownerDocument.styleSheets);
    const cssRules = await $8adf7a11b4111594$var$getCSSRules(styleSheets, options);
    return $8adf7a11b4111594$var$getWebFontRules(cssRules);
}
function $8adf7a11b4111594$var$normalizeFontFamily(font) {
    return font.trim().replace(/["']/g, '');
}
function $8adf7a11b4111594$var$getUsedFonts(node) {
    const fonts = new Set();
    function traverse(node) {
        const fontFamily = node.style.fontFamily || getComputedStyle(node).fontFamily;
        fontFamily.split(',').forEach((font)=>{
            fonts.add($8adf7a11b4111594$var$normalizeFontFamily(font));
        });
        Array.from(node.children).forEach((child)=>{
            if (child instanceof HTMLElement) traverse(child);
        });
    }
    traverse(node);
    return fonts;
}
async function $8adf7a11b4111594$export$253c9aa3d83a57b6(node, options) {
    const rules = await $8adf7a11b4111594$var$parseWebFontRules(node, options);
    const usedFonts = $8adf7a11b4111594$var$getUsedFonts(node);
    const cssTexts = await Promise.all(rules.filter((rule)=>usedFonts.has($8adf7a11b4111594$var$normalizeFontFamily(rule.style.fontFamily))).map((rule)=>{
        const baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
        return (0, $db71d1e03f6aefdb$export$3d88803585cbbc21)(rule.cssText, baseUrl, options);
    }));
    return cssTexts.join('\n');
}
async function $8adf7a11b4111594$export$2c2c83b77c8cb421(clonedNode, options) {
    const cssText = options.fontEmbedCSS != null ? options.fontEmbedCSS : options.skipFonts ? null : await $8adf7a11b4111594$export$253c9aa3d83a57b6(clonedNode, options);
    if (cssText) {
        const styleNode = document.createElement('style');
        const sytleContent = document.createTextNode(cssText);
        styleNode.appendChild(sytleContent);
        if (clonedNode.firstChild) clonedNode.insertBefore(styleNode, clonedNode.firstChild);
        else clonedNode.appendChild(styleNode);
    }
}



async function $ce7b66f3f228e494$export$20d300cb2d558b7(node, options = {}) {
    const { width: width, height: height } = (0, $7d03b637065da5d5$export$ada5537b2c061996)(node, options);
    const clonedNode = await (0, $d2f2a41e8b24c38a$export$ae8e35ea29ddac22)(node, options, true);
    await (0, $8adf7a11b4111594$export$2c2c83b77c8cb421)(clonedNode, options);
    await (0, $47d1a2421a150914$export$6660fa8dd20e53aa)(clonedNode, options);
    (0, $fb6f01e6fe554ea5$export$d63a6b7859608045)(clonedNode, options);
    const datauri = await (0, $7d03b637065da5d5$export$b62810fb8ca515fa)(clonedNode, width, height);
    return datauri;
}
async function $ce7b66f3f228e494$export$f87f6982d1fd4f81(node, options = {}) {
    const { width: width, height: height } = (0, $7d03b637065da5d5$export$ada5537b2c061996)(node, options);
    const svg = await $ce7b66f3f228e494$export$20d300cb2d558b7(node, options);
    const img = await (0, $7d03b637065da5d5$export$ec664d7487540b)(svg);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const ratio = options.pixelRatio || (0, $7d03b637065da5d5$export$d39ce20a37bba061)();
    const canvasWidth = options.canvasWidth || width;
    const canvasHeight = options.canvasHeight || height;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    if (!options.skipAutoScale) (0, $7d03b637065da5d5$export$c2c809a2fe6b0f1a)(canvas);
    canvas.style.width = `${canvasWidth}`;
    canvas.style.height = `${canvasHeight}`;
    if (options.backgroundColor) {
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
}
async function $ce7b66f3f228e494$export$6f9e32581c0cde11(node, options = {}) {
    const { width: width, height: height } = (0, $7d03b637065da5d5$export$ada5537b2c061996)(node, options);
    const canvas = await $ce7b66f3f228e494$export$f87f6982d1fd4f81(node, options);
    const ctx = canvas.getContext('2d');
    return ctx.getImageData(0, 0, width, height).data;
}
async function $ce7b66f3f228e494$export$aba256f33615c92e(node, options = {}) {
    const canvas = await $ce7b66f3f228e494$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL();
}
async function $ce7b66f3f228e494$export$ed218bd2440d33a5(node, options = {}) {
    const canvas = await $ce7b66f3f228e494$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL('image/jpeg', options.quality || 1);
}
async function $ce7b66f3f228e494$export$b20f4ee19ffa0668(node, options = {}) {
    const canvas = await $ce7b66f3f228e494$export$f87f6982d1fd4f81(node, options);
    const blob = await (0, $7d03b637065da5d5$export$403d539f215df596)(canvas);
    return blob;
}
async function $ce7b66f3f228e494$export$92678bad7eef403b(node, options = {}) {
    return (0, $8adf7a11b4111594$export$253c9aa3d83a57b6)(node, options);
}


/* eslint-disable import/no-extraneous-dependencies */ 
parcelRequire("63Xef");

var $63Xef = parcelRequire("63Xef");





var $8fb99f389d88a056$var$__defProp = Object.defineProperty;
var $8fb99f389d88a056$var$__defProps = Object.defineProperties;
var $8fb99f389d88a056$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8fb99f389d88a056$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8fb99f389d88a056$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8fb99f389d88a056$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8fb99f389d88a056$var$__defNormalProp = (obj, key, value)=>key in obj ? $8fb99f389d88a056$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8fb99f389d88a056$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8fb99f389d88a056$var$__hasOwnProp.call(b, prop)) $8fb99f389d88a056$var$__defNormalProp(a, prop, b[prop]);
    if ($8fb99f389d88a056$var$__getOwnPropSymbols) {
        for (var prop of $8fb99f389d88a056$var$__getOwnPropSymbols(b))if ($8fb99f389d88a056$var$__propIsEnum.call(b, prop)) $8fb99f389d88a056$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8fb99f389d88a056$var$__spreadProps = (a, b)=>$8fb99f389d88a056$var$__defProps(a, $8fb99f389d88a056$var$__getOwnPropDescs(b));
function $8fb99f389d88a056$export$4ebcb6201122185a(input) {
    const { accept: accept, collisionDetector: collisionDetector, collisionPriority: collisionPriority, id: id, data: data, element: element, handle: handle, index: index, group: group, disabled: disabled, modifiers: modifiers, sensors: sensors, target: target, type: type, plugins: plugins } = input;
    const transition = $8fb99f389d88a056$var$__spreadValues($8fb99f389d88a056$var$__spreadValues({}, (0, $0d4c5512f6ac0f65$export$f787c7f92b2d7bab)), input.transition);
    const sortable = (0, $7d57415ac2032ee5$export$f4a5c5dcfe1bba82)((manager)=>{
        return new (0, $0d4c5512f6ac0f65$export$31b3ca70d8f57423)($8fb99f389d88a056$var$__spreadProps($8fb99f389d88a056$var$__spreadValues({}, input), {
            transition: transition,
            register: false,
            handle: (0, $6e7add91e106627e$export$6cd4326f683953cc)(handle),
            element: (0, $6e7add91e106627e$export$6cd4326f683953cc)(element),
            target: (0, $6e7add91e106627e$export$6cd4326f683953cc)(target)
        }), manager);
    });
    const trackedSortable = (0, $7bd703b0876c5b19$export$e772c6c16497c511)(sortable, $8fb99f389d88a056$var$shouldUpdateSynchronously);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(id, ()=>sortable.id = id);
    (0, $7bd703b0876c5b19$export$700979bc83e7db82)(()=>{
        (0, $c60338eb080e669a$export$712ea50be43a7858)(()=>{
            sortable.group = group;
            sortable.index = index;
        });
    }, [
        sortable,
        group,
        index
    ]);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(type, ()=>sortable.type = type);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(accept, ()=>sortable.accept = accept, void 0, (0, $eb0d2ed00918af28$export$9cb4719e2e525b7a));
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(data, ()=>data && (sortable.data = data));
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(index, ()=>{
        var _a;
        if (((_a = sortable.manager) == null ? void 0 : _a.dragOperation.status.idle) && (transition == null ? void 0 : transition.idle)) sortable.refreshShape();
    }, (0, $7bd703b0876c5b19$export$3f1c0a9c9a084c1d));
    (0, $7bd703b0876c5b19$export$e167ec28bc041c4d)(handle, (handle2)=>sortable.handle = handle2);
    (0, $7bd703b0876c5b19$export$e167ec28bc041c4d)(element, (element2)=>sortable.element = element2);
    (0, $7bd703b0876c5b19$export$e167ec28bc041c4d)(target, (target2)=>sortable.target = target2);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(disabled, ()=>sortable.disabled = disabled === true);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(sensors, ()=>sortable.sensors = sensors);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(collisionDetector, ()=>sortable.collisionDetector = collisionDetector);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(collisionPriority, ()=>sortable.collisionPriority = collisionPriority);
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(plugins, ()=>sortable.plugins = plugins, void 0, (0, $eb0d2ed00918af28$export$9cb4719e2e525b7a));
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(transition, ()=>sortable.transition = transition, void 0, (0, $eb0d2ed00918af28$export$9cb4719e2e525b7a));
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(modifiers, ()=>sortable.modifiers = modifiers, void 0, (0, $eb0d2ed00918af28$export$9cb4719e2e525b7a));
    (0, $7bd703b0876c5b19$export$938b73b4a74ac57a)(input.alignment, ()=>sortable.alignment = input.alignment);
    return {
        sortable: trackedSortable,
        get isDragging () {
            return trackedSortable.isDragging;
        },
        get isDropping () {
            return trackedSortable.isDropping;
        },
        get isDragSource () {
            return trackedSortable.isDragSource;
        },
        get isDropTarget () {
            return trackedSortable.isDropTarget;
        },
        handleRef: (0, $63Xef.useCallback)((element2)=>{
            sortable.handle = element2 != null ? element2 : void 0;
        }, [
            sortable
        ]),
        ref: (0, $63Xef.useCallback)((element2)=>{
            var _a, _b;
            if (!element2 && ((_a = sortable.element) == null ? void 0 : _a.isConnected) && !((_b = sortable.manager) == null ? void 0 : _b.dragOperation.status.idle)) return;
            sortable.element = element2 != null ? element2 : void 0;
        }, [
            sortable
        ]),
        sourceRef: (0, $63Xef.useCallback)((element2)=>{
            var _a, _b;
            if (!element2 && ((_a = sortable.source) == null ? void 0 : _a.isConnected) && !((_b = sortable.manager) == null ? void 0 : _b.dragOperation.status.idle)) return;
            sortable.source = element2 != null ? element2 : void 0;
        }, [
            sortable
        ]),
        targetRef: (0, $63Xef.useCallback)((element2)=>{
            var _a, _b;
            if (!element2 && ((_a = sortable.target) == null ? void 0 : _a.isConnected) && !((_b = sortable.manager) == null ? void 0 : _b.dragOperation.status.idle)) return;
            sortable.target = element2 != null ? element2 : void 0;
        }, [
            sortable
        ])
    };
}
function $8fb99f389d88a056$var$shouldUpdateSynchronously(key, oldValue, newValue) {
    if (key === "isDragSource" && !newValue && oldValue) return true;
    return false;
}
 //# sourceMappingURL=sortable.js.map
 //# sourceMappingURL=sortable.js.map









// src/modifiers/RestrictToWindow.ts
var $d3cb3928b7a9aca1$export$24827f5036c5e001 = class extends (0, $9636818b04ce7da6$export$5acd5e6efc9671b7) {
    constructor(manager){
        super(manager);
        const { dragOperation: dragOperation } = manager;
        const getWindowBoundingRectangle = ()=>(0, $c60338eb080e669a$export$8c437e4d572e2f99)(()=>{
                var _a;
                const { source: source } = dragOperation;
                this.windowBoundingRectangle = (0, $501f8c524dad2740$export$89e37bf39ea801ef)((_a = source == null ? void 0 : source.element) != null ? _a : document.documentElement);
            });
        this.destroy = (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            if (dragOperation.status.idle) return;
            getWindowBoundingRectangle();
            window.addEventListener("resize", getWindowBoundingRectangle);
            return ()=>{
                window.removeEventListener("resize", getWindowBoundingRectangle);
            };
        });
    }
    apply({ shape: shape, transform: transform }) {
        if (!this.windowBoundingRectangle || !shape) return transform;
        const { initial: initial, current: current } = shape;
        const { height: height, width: width } = current.boundingRectangle;
        const left = initial.center.x - width / 2;
        const top = initial.center.y - height / 2;
        const restrictedTransform = (0, $b2d051ff65b2716c$export$6db2c94cc5d05406)(new (0, $ce41d7a96a1e68fd$export$4617fb02663045ef)(left, top, width, height), transform, this.windowBoundingRectangle);
        return restrictedTransform;
    }
};
var $d3cb3928b7a9aca1$var$_RestrictToElement = class _RestrictToElement extends (0, $9636818b04ce7da6$export$5acd5e6efc9671b7) {
    constructor(manager, options){
        super(manager, options);
        this.boundingRectangle = (0, $c60338eb080e669a$export$e2ef10f86a8d60e8)(null);
        this.destroy = (0, $c60338eb080e669a$export$dc573d8a6576cdb3)(()=>{
            if (!this.options) return;
            const { dragOperation: dragOperation } = manager;
            const { status: status } = dragOperation;
            if (status.initialized) {
                const { element: element } = this.options;
                const target = typeof element === "function" ? element(dragOperation) : element;
                if (!target) return;
                let timeout;
                const updateBoundingRectangle = ()=>{
                    this.boundingRectangle.value = (0, $501f8c524dad2740$export$50877a281fd7d4c4)(target);
                };
                const handleScroll = ()=>{
                    if (timeout) return;
                    timeout = setTimeout(()=>{
                        updateBoundingRectangle();
                        timeout = void 0;
                    }, 25);
                };
                const resizeObserver = new ResizeObserver(updateBoundingRectangle);
                resizeObserver.observe(target);
                document.addEventListener("scroll", handleScroll, {
                    passive: true,
                    capture: true
                });
                return ()=>{
                    document.removeEventListener("scroll", handleScroll, {
                        capture: true
                    });
                    resizeObserver.disconnect();
                    this.boundingRectangle.value = null;
                };
            }
        });
    }
    apply(operation) {
        const { shape: shape, transform: transform } = operation;
        if (!shape) return transform;
        const boundingRectangle = this.boundingRectangle.value;
        if (!boundingRectangle) return transform;
        const { initial: initial, current: current } = shape;
        const { height: height, width: width } = current.boundingRectangle;
        const left = initial.center.x - width / 2;
        const top = initial.center.y - height / 2;
        const restrictedTransform = (0, $b2d051ff65b2716c$export$6db2c94cc5d05406)(new (0, $ce41d7a96a1e68fd$export$4617fb02663045ef)(left, top, width, height), transform, boundingRectangle);
        return restrictedTransform;
    }
};
$d3cb3928b7a9aca1$var$_RestrictToElement.configure = (0, $9636818b04ce7da6$export$adf416f00cca6418)($d3cb3928b7a9aca1$var$_RestrictToElement);
var $d3cb3928b7a9aca1$export$ff382f5758d583cb = $d3cb3928b7a9aca1$var$_RestrictToElement;
 //# sourceMappingURL=modifiers.js.map


/* eslint-disable import/prefer-default-export */ function $04a5fa283868a70b$export$fe2a25f382920ce5(isDragging, isDropping, isHoriz, xOffset, yOffset) {
    const currentX = isHoriz ? `calc(${xOffset}px + var(--translate-x, 0px))` : `${xOffset}px`;
    const currentY = isHoriz ? `${yOffset}px` : `calc(${yOffset}px + var(--translate-y, 0px))`;
    const style = {
        cursor: isDragging ? 'grabbing' : 'grab',
        opacity: isDragging ? 0.6 : 1,
        // translate: isHoriz
        //     ? `var(--translate-x, 0px) 0px`
        //     : `0px var(--translate-y, 0px)`,
        transform: `translate3d(${currentX}, ${currentY}, 0)`,
        transition: isDragging ? 'none' : 'translate 250ms cubic-bezier(0.2, 0, 0, 1), transform 250ms cubic-bezier(0.2, 0, 0, 1)',
        filter: isDragging || isDropping ? 'drop-shadow(0px 5px 10px rgba(0,0,0,0.3))' : 'none',
        touchAction: 'none',
        zIndex: isDragging || isDropping ? 1000 : 1
    };
    return style;
}


function $2f9510a59088c740$var$SortableWrapper(props) {
    const { id: id, index: index, offset: offset, children: children, type: type } = props;
    let groupName;
    let container;
    let maxSliderWidth;
    let bottomMostYVal;
    const isHoriz = [
        'player',
        'player-modal'
    ].includes(type);
    if (type === 'stat') ({ groupName: groupName, container: container } = props);
    else if (type === 'player') ({ maxSliderWidth: maxSliderWidth, bottomMostYVal: bottomMostYVal } = props);
    const useSortableArgs = {
        id: id,
        index: index,
        group: type === 'stat' ? groupName : `sortable-${type}-list`,
        collisionDetector: (0, $c970db14647306d6$export$c8e785ae6b74bab8)
    };
    if (type === 'stat') useSortableArgs.modifiers = [
        (0, $b2d051ff65b2716c$export$2d8564a14f5fec69),
        (0, $d3cb3928b7a9aca1$export$ff382f5758d583cb).configure({
            element: container
        })
    ];
    const { ref: ref, handleRef: handleRef, isDragging: isDragging, isDropping: isDropping } = (0, $8fb99f389d88a056$export$4ebcb6201122185a)(useSortableArgs);
    const xOffset = isHoriz ? offset : 0;
    const yOffset = isHoriz ? 0 : offset;
    const style = (0, $04a5fa283868a70b$export$fe2a25f382920ce5)(isDragging, isDropping, isHoriz, xOffset, yOffset);
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
        ref: ref,
        // transform={`translate(${xOffset}, ${yOffset})`}
        style: style,
        children: [
            isDragging && type === 'player' && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                width: maxSliderWidth + 10,
                height: bottomMostYVal + 20,
                x: -5,
                y: 0,
                fill: isDragging ? 'white' : 'transparent',
                fillOpacity: 0.9,
                rx: 8
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                ref: handleRef,
                children: children
            })
        ]
    });
}
var $2f9510a59088c740$export$2e2bcd8739ae039 = $2f9510a59088c740$var$SortableWrapper;


// eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");

/* eslint-disable no-nested-ternary */ // eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");
// eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");
var $3cfe79d709e6baf3$exports = {};
// grand unified formatting function
/**
 *
 * @param {number} val
 * @param {number} digits
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$toFixed(val, digits) {
    const string = Number(val).toFixed(digits);
    // Ditch -0.0
    return 1 / Number(string) === -Infinity ? 0..toFixed(digits) : string;
}
// Realistically, we have too many changes of spellings and things to not do this, sadly
/**
 *
 * @param {string} type
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$getStandardizedType(type) {
    // of the form { alt: standard }
    /** @type {Record<string, string>} */ const altSpellings = {
        abs: 'ab',
        avg_swing_length: 'swing_length_qualified',
        avg_swing_speed: 'swing_speed_qualified',
        barrels: 'barrel',
        barrels_per_bbe_percent: 'barrel_batted_rate',
        barrels_per_pa_percent: 'barrels_per_pa',
        batting_avg: 'ba',
        bb: 'walk',
        dbls: 'double',
        ev: 'launch_speed',
        hardhit_percent: 'hard_hit_percent',
        hits: 'hit',
        hrs: 'home_run',
        isolated_power: 'iso',
        on_base_percent: 'obp',
        on_base_plus_slg: 'ops',
        pitch_speed: 'pitch_velocity',
        singles: 'single',
        slg_percent: 'slg',
        so: 'strikeout',
        triples: 'triple',
        attack_angle: 'bat_path_angle',
        attack_angle_asc: 'bat_path_angle',
        attack_direction: 'bat_path_angle',
        attack_direction_pullopp: 'bat_path_angle',
        swing_path_tilt: 'bat_path_angle',
        avg_plane_vertical_angle: 'bat_path_angle',
        avg_plane_vertical_angle_asc: 'bat_path_angle',
        vertical_swing_path: 'bat_path_angle',
        bat_minus_plate_pos_y_inches: 'dist_in_inches',
        intercept_ball_minus_plate_pos_y_inches: 'dist_in_inches',
        intercept_ball_minus_batter_pos_y_inches: 'dist_in_inches',
        bat_minus_plate_pos_x_inches: 'dist_in_inches',
        intercept_ball_minus_plate_pos_x_inches: 'dist_in_inches',
        intercept_ball_minus_batter_pos_x_inches: 'dist_in_inches',
        pull_percent_airballs: 'airballs_percent',
        // Hack for top performers
        swing_timing_miss_distance: 'miss_distance',
        swing_timing_miss_distance_ff: 'miss_distance',
        swing_timing_miss_distance_cu: 'miss_distance',
        swing_timing_miss_distance_ch: 'miss_distance',
        swing_timing_late_percent: 'swing_timing_percent',
        swing_timing_late_percent_ff: 'swing_timing_percent',
        swing_timing_late_percent_cu: 'swing_timing_percent',
        swing_timing_late_percent_ch: 'swing_timing_percent',
        swing_timing_early_percent: 'swing_timing_percent',
        swing_timing_early_percent_ff: 'swing_timing_percent',
        swing_timing_early_percent_cu: 'swing_timing_percent',
        swing_timing_early_percent_ch: 'swing_timing_percent',
        swing_timing_tied_up_percent: 'swing_timing_percent',
        swing_timing_tied_up_percent_ff: 'swing_timing_percent',
        swing_timing_tied_up_percent_cu: 'swing_timing_percent',
        swing_timing_tied_up_percent_ch: 'swing_timing_percent',
        swing_timing_flailed_percent: 'swing_timing_percent',
        swing_timing_flailed_percent_ff: 'swing_timing_percent',
        swing_timing_flailed_percent_cu: 'swing_timing_percent',
        swing_timing_flailed_percent_ch: 'swing_timing_percent',
        swing_timing_over_percent: 'swing_timing_percent',
        swing_timing_over_percent_ff: 'swing_timing_percent',
        swing_timing_over_percent_cu: 'swing_timing_percent',
        swing_timing_over_percent_ch: 'swing_timing_percent',
        swing_timing_under_percent: 'swing_timing_percent',
        swing_timing_under_percent_ff: 'swing_timing_percent',
        swing_timing_under_percent_cu: 'swing_timing_percent',
        swing_timing_under_percent_ch: 'swing_timing_percent',
        swing_timing_lined_up_percent_ff: 'swing_timing_percent',
        swing_timing_lined_up_percent: 'swing_timing_percent',
        swing_timing_lined_up_percent_cu: 'swing_timing_percent',
        swing_timing_lined_up_percent_ch: 'swing_timing_percent',
        swing_timing_on_time_percent: 'swing_timing_percent',
        swing_timing_on_time_percent_ff: 'swing_timing_percent',
        swing_timing_on_time_percent_cu: 'swing_timing_percent',
        swing_timing_on_time_percent_ch: 'swing_timing_percent',
        swing_timing_centered_percent: 'swing_timing_percent',
        swing_timing_centered_percent_ff: 'swing_timing_percent',
        swing_timing_centered_percent_cu: 'swing_timing_percent',
        swing_timing_centered_percent_ch: 'swing_timing_percent',
        swing_timing_perfect_percent: 'swing_timing_percent',
        swing_timing_perfect_percent_ff: 'swing_timing_percent',
        swing_timing_perfect_percent_cu: 'swing_timing_percent',
        swing_timing_perfect_percent_ch: 'swing_timing_percent',
        swing_timing_flawed_percent: 'swing_timing_percent',
        swing_timing_flawed_percent_ff: 'swing_timing_percent',
        swing_timing_flawed_percent_cu: 'swing_timing_percent',
        swing_timing_flawed_percent_ch: 'swing_timing_percent',
        // bit of a hack
        spin_rate: '_avg_spin',
        pitch_velo: 'pitch_velocity',
        pitch_spin: '_avg_spin',
        pitch_extension: 'fastball_extension',
        pitch_run_value: 'run_value',
        pitch_whiff_percent: 'whiff_percent',
        pitch_break_x: 'api_break_x_arm',
        pitch_break_z: 'api_break_z_with_gravity',
        pitch_break_z_induced: 'api_break_z_induced',
        pitch_usage: 'metric-percent'
    };
    return altSpellings[type] || type;
}
/**
 *
 * @param {number|string} val
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$threeDigitFormat(val) {
    const num = Number(val);
    if (num >= 0 && num < 1) return num.toFixed(3).slice(-4);
    if (num < 0 && num > -1) return `-${Math.abs(num).toFixed(3).slice(-4)}`;
    return num.toFixed(3);
}
const $3cfe79d709e6baf3$var$threeDigitTypes = [
    'ba',
    'xba',
    'est_ba',
    'obp',
    'xobp',
    'est_obp',
    'slg',
    'xslg',
    'est_slg',
    'iso',
    'xiso',
    'est_iso',
    'ops',
    'babip',
    'est_babip',
    'woba',
    'xwoba',
    'est_woba',
    'wobacon',
    'xwobacon',
    'est_wobacon',
    'bacon',
    'xbacon',
    'est_bacon'
];
const $3cfe79d709e6baf3$var$thousandthTypes = [
    'delta_pitcher_run_exp',
    'delta_run_exp',
    'unadj_delta_pitcher_run_exp',
    'unadj_delta_run_exp',
    'delev_delta_pitcher_run_exp',
    'delev_delta_run_exp'
];
const $3cfe79d709e6baf3$var$hundredthTypes = [
    'catcher_exchange',
    'catcher_poptime',
    'pop_2b',
    'pop_2b_sba',
    'home_to_first',
    'running_splits',
    'era',
    'xera',
    'exchange_time',
    'pop_time',
    'rate_cs_aa',
    'runner_stealing_runs_drawer',
    'avg_hr_trot',
    'home_runs_per_nine',
    'runs_gained_per_chal'
];
const $3cfe79d709e6baf3$var$tenthTypes = [
    'hard_hit_percent',
    'launch_speed',
    'exit_velocity_avg',
    'exit_velocity_max',
    'avg_best_speed',
    'hyper_speed',
    'avg_hyper_speed',
    'pitch_tempo_empty',
    'sweet_spot_percent',
    'barrel_batted_rate',
    'barrels_per_pa',
    'launch_angle_avg',
    // Pitch metrics
    'fastball_velo',
    'breaking_velo',
    'offspeed_velo',
    'ff_avg_speed',
    'fastball_extension',
    'pitch_type_percent',
    'pitch_velocity',
    'api_break_z_with_gravity',
    'api_break_z_induced',
    'api_break_x_arm',
    'api_break_x_batter_in',
    'active_spin_percent',
    'pitch_usage_fastball',
    'pitch_usage_offspeed',
    'pitch_usage_breaking',
    // Bat tracking
    'sweetspot_speed_mph',
    'swing_speed',
    'swing_speed_qualified',
    'swing_length',
    'swing_length_qualified',
    'bat_speed_avg',
    'metric-percent',
    'ideal_angle_rate',
    'miss_distance',
    'swing_timing_dist',
    'acceleration',
    // bat tracking from sortable stats
    'squared_up_contact',
    'squared_up_swing',
    'blasts_swing',
    'blasts_contact',
    'fast_swing_rate',
    'accel_time_ms',
    // Batted Ball
    'popups_percent',
    'flyballs_percent',
    'linedrives_percent',
    'groundballs_percent',
    'airballs_percent',
    'pull_percent',
    'straightaway_percent',
    'opposite_percent',
    'poorlyweak_percent',
    'poorlytopped_percent',
    'poorlyunder_percent',
    'flareburner_percent',
    'solidcontact_percent',
    'hr_flyballs_percent',
    'dist_in_inches',
    // Plate disc
    'in_zone_percent',
    'out_zone_percent',
    'edge_percent',
    'z_swing_percent',
    'oz_swing_percent',
    'iz_contact_percent',
    'oz_contact_percent',
    'whiff_percent',
    'chase_percent',
    'f_strike_percent',
    'f_swing_percent',
    'swing_percent',
    'meatball_swing_percent',
    'meatball_percent',
    'z_swing_miss_percent',
    'oz_swing_miss_percent',
    'swing_miss_percent',
    // Basics
    'k_percent',
    'bb_percent',
    'putaway_percent',
    // catcher arm
    'catcher_arm',
    'arm_cs_2b',
    // Fielding
    'arm_strength_inf',
    'arm_strength_of',
    'arm_overall',
    'arm_max',
    'max_arm_strength',
    'outfield_jump',
    'jump_out_percent',
    'receiving_oaa',
    // Basestealing
    'r_sec_minus_prim_lead',
    'r_sec_minus_prim_lead_sbx',
    // Baserunning
    'sprint_speed',
    'jump',
    'runs_stolen_on_running_act_drawer',
    // Pitcher Stealing
    'r_primary_lead',
    'r_secondary_lead',
    'r_sec_minus_prim_lead',
    'r_primary_lead_sbx',
    'r_secondary_lead_sbx',
    'r_sec_minus_prim_lead_sbx',
    // Catcher framing
    'strike_rate',
    // Catcher throwing
    'arm_strength',
    'distance_to_target',
    'seasonal_sprint_speed',
    // Other
    'game_score',
    'batter_run_value_per_100',
    'pitcher_run_value_per_100',
    'arm_angle',
    'strike_zone_distance',
    'run_value_zone',
    'exp_abs_chals',
    'batter_run_exp_contact',
    'batter_run_exp_take',
    'batter_run_exp_swing',
    'batter_run_exp',
    'pitcher_run_exp_contact',
    'pitcher_run_exp_take',
    'pitcher_run_exp_swing',
    'pitcher_run_exp',
    'edge_dist',
    'abs_chal_runs',
    'xhr',
    // ABS
    'overturns_vs_exp',
    'net_net_chal',
    'net_net_chal_against',
    'exp_chal',
    'exp_chal_against',
    'exp_chal_gained_against',
    'exp_chal_gained',
    'exp_chal_lost_against',
    'exp_chal_lost',
    'net_chal_gained_against',
    'net_chal_gained',
    'net_chal_lost_against',
    'net_chal_lost'
];
// Should these be noops? Eh.
const $3cfe79d709e6baf3$var$wholeTypes = [
    'barrel',
    'popups',
    'flyballs',
    'linedrives',
    'groundballs',
    'launch_angle',
    'bbdist',
    // Plate disc.
    'in_zone',
    'out_zone',
    'edge',
    'in_zone_swing',
    'out_zone_swing',
    'in_zone_swing_miss',
    'out_zone_swing_miss',
    // Basic
    'pitch_count',
    'pa',
    'ab',
    'bip',
    'hit',
    'single',
    'double',
    'triple',
    'home_run',
    'walk',
    'strikeout',
    'hbp',
    'batted_ball',
    'pitch_count_fastball',
    'pitch_count_offspeed',
    'pitch_count_breaking',
    'whiffs',
    'swings',
    'opportunities',
    // Total baserunning
    'runner_runs_sb',
    'runner_runs_xb',
    // Baserunning
    'baserunning',
    'fielder_runs',
    'runner_runs',
    'runner_runs_swipe',
    'runner_runs_snipe',
    'runner_runs_freeze',
    'fielder_runs_swipe',
    'fielder_runs_snipe',
    'fielder_runs_freeze',
    'bolts',
    // Basestealing
    'runs_stolen_on_running_act',
    'simple_stolen_on_running_act',
    'net_act_plus',
    'net_act_minus',
    'n_init',
    'n_plus',
    'n_minus',
    // Baserunning Top Performers
    'baserunning_runs',
    'basestealing',
    'extra_bases_taken',
    // Pitcher Stealing
    'runs_prevented_on_running_attr',
    'simple_prevented_on_running_attr',
    'net_attr_plus',
    'net_attr_minus',
    // Runner Stealing
    'runs_stolen_on_running_act',
    'simple_stolen_on_running_act',
    'net_act_plus',
    'net_act_minus',
    // Fielding Runs
    'runs_prevented',
    // Run Value
    'run_value',
    'swing_take_run_value',
    'run_exp',
    'pitcher_run_exp',
    'unadj_run_exp',
    'unadj_pitcher_run_exp',
    'delev_run_exp',
    'delev_pitcher_run_exp',
    'runner_run_value',
    'fielding_run_value',
    'fielding_run_value_arm',
    'pitch_run_value_fastball',
    'pitch_run_value_breaking',
    'pitch_run_value_offspeed',
    'pitcher_stealing_runs',
    'runner_stealing_runs',
    //
    'oaa',
    'outs_above_average',
    'cs_above_average',
    'blocks_above_average',
    'catcher_blocking',
    'catcher_throwing',
    'fielding_run_value',
    'fielding_run_value_framing',
    'framing',
    'player_age',
    'arm_angle_viz',
    // Bat tracking
    'swords',
    'num_swings',
    'peak_accel_ms',
    // Catcher throwing
    'n_xcs_with_untracked_over_xcs',
    'n_xcs_with_onfly_other_over_xcs',
    'n_xcs_with_ground_other_over_xcs',
    'n_xcs_with_accuracy_over_xcs',
    'n_xcs_with_exchange_over_xcs',
    'n_xcs_with_flight_over_xcs',
    'n_xcs',
    'n_cs_aa',
    'cs_raa',
    'venue_fence_distance',
    'venue_square_footage',
    'venue_fence_height',
    'pitch_spin_search',
    'abs_challenges',
    'attack_angle_zone',
    'attack_direction_pullopp_zone',
    'swing_path_tilt_zone'
];
// Presenting zero indexed data
const $3cfe79d709e6baf3$var$offByOneTypes = [
    'n_priorpa_thisgame_player_at_bat'
];
const $3cfe79d709e6baf3$var$percentWhole = [
    // Baserunning
    'rate_att_xb',
    'est_rate_att_generic_runner',
    'est_rate_att_generic_fielder',
    'rate_att_xb_diff_runner',
    'rate_att_xb_diff_fielder',
    'base_running_rate_safe',
    'base_running_rate_safe_per_attempt',
    'rate_xcs',
    'rate_cs',
    'knee_percent',
    'cs_percent',
    // bat tracking
    'swing_timing_percent',
    // player page pitch percent
    'handed_pitch_percent',
    // ABS
    'abs_chal_percent',
    // gamefeed pitch percent
    'gamefeed_pitch_percent',
    // ABS
    'rate_overturns',
    'rate_overturns_against',
    'exp_rate_overturns',
    'exp_rate_overturns_against',
    'rate_chal_reasonable',
    'rate_chal_reasonable_against',
    'rate_reasonable_opp_taken',
    'rate_reasonable_opp_taken_against'
];
const $3cfe79d709e6baf3$var$percentTenth = [
    // Pitcher Steal
    'rate_sbx',
    // bat tracking
    'swings_qualified_percent',
    'avg_is_sweetspot_speed_high_qualified',
    'squared_up_per_bat_contact',
    'squared_up_per_swing',
    'squared_up_with_speed_per_swing',
    'squared_up_with_speed_per_bat_contact',
    // Batted ball
    'batted_ball_rate',
    'rate_ideal_attack_angle',
    // Basestealing
    'rate_sbx',
    // Pitching
    'pitch_percent',
    'whiff_rate_percent',
    'take_percent',
    // Other
    'called_strike_prob',
    'venue_square_footage_diff',
    'home_run_percent',
    'receiving_expected_rate',
    // ABS
    'abs_chal_rate_percent',
    'exp_rate_challenges_diff',
    'exp_rate_challenges_diff_against',
    'exp_rate_challenges',
    'exp_rate_challenges_against',
    'rate_challenges',
    'rate_challenges_against',
    'n_chal_reasonable_opps',
    'n_chal_reasonable_opps_against',
    'n_chal_reasonable',
    'n_chal_reasonable_against'
];
const $3cfe79d709e6baf3$var$angleWhole = [
    'bat_path_angle',
    'launch_angle_search'
];
const $3cfe79d709e6baf3$var$inchesToFeetInches = [
    'height_in_inches'
];
const $3cfe79d709e6baf3$var$defaultOpts = {
    placeholder: '--',
    isMissingFn: (val)=>[
            null,
            undefined,
            ''
        ].includes(val),
    isDiff: false,
    ignoreExtremaHandling: false
};
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isMovementType(type) {
    return type.includes('movement_vertical_') || type.includes('movement_horizontal_');
}
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isAvgSpeed(type) {
    return type.includes('_avg_speed');
}
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isAvgSpin(type) {
    return type.includes('_avg_spin');
}
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isActiveSpin(type) {
    return type.includes('formatted_active_spin_');
}
// grand unified formatting function
/**
 *
 * @param {string|number|null|undefined} val
 * @param {string} rawType
 * @param {{ placeholder?: any, isMissingFn?: function, isDiff?: boolean, removePercent?: boolean }} [opts]
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$guff(val, rawType, opts = $3cfe79d709e6baf3$var$defaultOpts) {
    const mergedOpts = {
        ...$3cfe79d709e6baf3$var$defaultOpts,
        ...opts
    };
    const type = $3cfe79d709e6baf3$var$getStandardizedType(rawType);
    try {
        // Add some extra checks to pacify typescript
        if (mergedOpts.isMissingFn(val) || val === undefined || val === null) // How is TS okay with turning any here?
        return mergedOpts.placeholder;
        const numberVal = Number(val);
        if (Number.isNaN(numberVal)) return mergedOpts.placeholder;
        // Three Digit Formats (with diffs)
        if ($3cfe79d709e6baf3$var$threeDigitTypes.includes(type) && mergedOpts.isDiff) {
            if (numberVal > -1 && numberVal < 1) {
                const formattedVal = $3cfe79d709e6baf3$var$threeDigitFormat(numberVal);
                if (Number(formattedVal) > 0) return `+${formattedVal}`;
                return formattedVal;
            }
            const formattedVal = $3cfe79d709e6baf3$var$toFixed(numberVal, 3);
            if (Number(formattedVal) > 0) return `+${formattedVal}`;
            if (Number(formattedVal) < 0) return formattedVal;
            return formattedVal;
        }
        if ($3cfe79d709e6baf3$var$threeDigitTypes.includes(type)) return $3cfe79d709e6baf3$var$threeDigitFormat(numberVal);
        if ($3cfe79d709e6baf3$var$thousandthTypes.includes(type)) {
            const formattedValue = $3cfe79d709e6baf3$var$toFixed(numberVal, 3);
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue}` : formattedValue;
        }
        if ($3cfe79d709e6baf3$var$hundredthTypes.includes(type)) {
            const formattedValue = $3cfe79d709e6baf3$var$toFixed(numberVal, 2);
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue}` : formattedValue;
        }
        if ($3cfe79d709e6baf3$var$tenthTypes.includes(type) || $3cfe79d709e6baf3$var$isMovementType(type) || $3cfe79d709e6baf3$var$isActiveSpin(type) || $3cfe79d709e6baf3$var$isAvgSpeed(type)) {
            const formattedValue = $3cfe79d709e6baf3$var$toFixed(numberVal, 1);
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue}` : formattedValue;
        }
        if ($3cfe79d709e6baf3$var$wholeTypes.includes(type) || $3cfe79d709e6baf3$var$isAvgSpin(type)) {
            const formattedValue = Math.round(numberVal) || 0;
            // FWIW - This avoids the -0 problem because String(-0) => '0' and -0 || 0 => 0
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue.toLocaleString()}` : formattedValue.toLocaleString() // for consistently returning a string
            ;
        }
        if ($3cfe79d709e6baf3$var$offByOneTypes.includes(type)) return String(Math.round(numberVal) + 1);
        if ($3cfe79d709e6baf3$var$percentWhole.includes(type)) {
            const roundedNumber = Math.round(numberVal * 100);
            let formattedValue = String(roundedNumber);
            if (roundedNumber === 100 && numberVal < 1) formattedValue = '>99';
            else if (roundedNumber === 0 && numberVal > 0) formattedValue = '<1';
            const suffix = mergedOpts.removePercent ? '' : '%';
            // FWIW - This avoids the -0 problem because String(-0) => '0'
            return roundedNumber > 0 && mergedOpts.isDiff ? `+${formattedValue}${suffix}` : formattedValue + suffix;
        }
        if ($3cfe79d709e6baf3$var$percentTenth.includes(type)) {
            let formattedValue = (numberVal * 100).toFixed(1);
            const suffix = mergedOpts.removePercent ? '' : '%';
            if (!mergedOpts.ignoreExtremaHandling) {
                if (formattedValue === '100.0' && numberVal < 1) formattedValue = '>99.9';
                else if (formattedValue === '0.0' && numberVal > 0) formattedValue = '<0.1';
            }
            // FWIW - This avoids the -0 problem because String(-0) => '0'
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue}${suffix}` : formattedValue + suffix;
        }
        if ($3cfe79d709e6baf3$var$angleWhole.includes(type)) {
            const formattedValue = Math.round(numberVal);
            // FWIW - This avoids the -0 problem because String(-0) => '0'
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue}\xb0` : `${formattedValue}\xb0`;
        }
        if ($3cfe79d709e6baf3$var$inchesToFeetInches.includes(type)) {
            const feet = Math.floor(numberVal / 12);
            const inches = Math.round(numberVal % 12);
            return `${feet}'${inches}"`;
        }
        throw new Error(`type: ${type} not found`);
    } catch (e) {
        console.error('GUFF ERROR', e, val, type);
        return String(val);
    }
}
const $3cfe79d709e6baf3$var$validTypes = [
    ...$3cfe79d709e6baf3$var$threeDigitTypes,
    ...$3cfe79d709e6baf3$var$thousandthTypes,
    ...$3cfe79d709e6baf3$var$hundredthTypes,
    ...$3cfe79d709e6baf3$var$tenthTypes,
    ...$3cfe79d709e6baf3$var$wholeTypes,
    ...$3cfe79d709e6baf3$var$percentWhole,
    ...$3cfe79d709e6baf3$var$percentTenth,
    ...$3cfe79d709e6baf3$var$angleWhole,
    ...$3cfe79d709e6baf3$var$offByOneTypes,
    ...$3cfe79d709e6baf3$var$inchesToFeetInches
];
const $3cfe79d709e6baf3$var$validTypeMap = $3cfe79d709e6baf3$var$validTypes.reduce((acc, curr)=>{
    acc[curr] = true;
    return acc;
}, {});
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isGuffable(type) {
    const standardType = $3cfe79d709e6baf3$var$getStandardizedType(type);
    return Boolean($3cfe79d709e6baf3$var$validTypeMap[standardType]) || $3cfe79d709e6baf3$var$isAvgSpeed(standardType) || $3cfe79d709e6baf3$var$isMovementType(standardType) || $3cfe79d709e6baf3$var$isActiveSpin(standardType) || $3cfe79d709e6baf3$var$isAvgSpin(standardType);
}
// table
/**
 *
 * @param {string|number|null|undefined} val
 * @param {any} _
 * @param {{ field: string}} column
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$displayFn(val, _, { field: field }) {
    return $3cfe79d709e6baf3$var$guff(val, field);
}
// table
/**
 *
 */ /**
 *
 * @param {string} type
 * @returns {(val: string|number|null|undefined) => string}
 */ function $3cfe79d709e6baf3$var$displayFnFactory(type) {
    return function displayFunc(val) {
        return $3cfe79d709e6baf3$var$guff(val, type);
    };
}
$3cfe79d709e6baf3$exports = {
    displayFn: $3cfe79d709e6baf3$var$displayFn,
    displayFnFactory: $3cfe79d709e6baf3$var$displayFnFactory,
    guff: $3cfe79d709e6baf3$var$guff,
    isGuffable: $3cfe79d709e6baf3$var$isGuffable
};



const $c30e918aac675a8e$export$eacc6a6ba638282d = 800;
const $c30e918aac675a8e$export$b1b9c9c1bf44cff1 = 800;
const $c30e918aac675a8e$export$f319e446de6e041 = 55;
const $c30e918aac675a8e$export$98534f2dc7b0e417 = 16;
const $c30e918aac675a8e$export$58c41d28e8c50092 = 12;
const $c30e918aac675a8e$export$aa4eace044cdfdbf = 8 // Width of rect for 0%
;
const $c30e918aac675a8e$export$4bdbd8698c928034 = '#b2dfdb';
const $c30e918aac675a8e$export$3ee53c4f03a98a9b = '#399098';
const $c30e918aac675a8e$export$2200862f6453cab4 = '#2f716b';
const $c30e918aac675a8e$export$ab7c035b277489a5 = '#e7c53a';
const $c30e918aac675a8e$export$f6c69cbacf7186ef = 48;
const $c30e918aac675a8e$export$32080fe92cae43a2 = 45;
const $c30e918aac675a8e$export$ffbf6d1bcd3c71b1 = 2;
const $c30e918aac675a8e$export$5027f20781e606c3 = 70;
const $c30e918aac675a8e$export$ef1d362f57cb3f41 = 120;
const $c30e918aac675a8e$export$42510bee89f29ff9 = $c30e918aac675a8e$export$98534f2dc7b0e417 + 4;
const $c30e918aac675a8e$export$c7679cfd1e53fc2c = $c30e918aac675a8e$export$42510bee89f29ff9 - $c30e918aac675a8e$export$98534f2dc7b0e417;
const $c30e918aac675a8e$export$306b9e34fb186dbb = 12;
const $c30e918aac675a8e$export$b33658ea466e9e34 = 10;
const $c30e918aac675a8e$export$c532d128cda1c211 = 30;
const $c30e918aac675a8e$export$a81aeb18486886da = 100;
const $c30e918aac675a8e$export$c0cd3fec8bd9f20f = 90;
const $c30e918aac675a8e$export$5bd7984ead021b84 = ($c30e918aac675a8e$export$98534f2dc7b0e417 - $c30e918aac675a8e$export$306b9e34fb186dbb) / 2;
const $c30e918aac675a8e$export$d6d08bc1d460e04d = 10;
const $c30e918aac675a8e$export$26c6dc3ec54fa401 = 5;
const $c30e918aac675a8e$export$bd7d0fbfe6662a05 = 9;
const $c30e918aac675a8e$export$b658f6c26dddf72b = 80;
const $c30e918aac675a8e$export$e9c958d09f7b22f1 = 20;
const $c30e918aac675a8e$export$d08a6aed81c42d1e = 5;
const $c30e918aac675a8e$export$3a86ee677b160b4e = 15;
const $c30e918aac675a8e$export$a205dee2dee736da = 6;
const $c30e918aac675a8e$export$891f57ac696b84d7 = 14;
const $c30e918aac675a8e$export$17314496a27dca07 = 15;
const $c30e918aac675a8e$export$d2ef3ba77a060487 = 14;
const $c30e918aac675a8e$export$8edc5e5e0c0397c2 = ($c30e918aac675a8e$export$eacc6a6ba638282d - $c30e918aac675a8e$export$5027f20781e606c3 - $c30e918aac675a8e$export$a81aeb18486886da - $c30e918aac675a8e$export$b33658ea466e9e34 - $c30e918aac675a8e$export$c532d128cda1c211) / $c30e918aac675a8e$export$26c6dc3ec54fa401 - $c30e918aac675a8e$export$d6d08bc1d460e04d // Width of rect for 100% plus buffer
;
const $c30e918aac675a8e$export$c4b7c3b74d82c671 = 660271;
const $c30e918aac675a8e$export$e48da51a507cf709 = 100;
const $c30e918aac675a8e$export$3e244b48f79f0cf9 = 80;
const $c30e918aac675a8e$export$82a3eb79c2e1839b = 5;
const $c30e918aac675a8e$export$1db8ac72413eadca = $c30e918aac675a8e$export$e48da51a507cf709 - 2 * $c30e918aac675a8e$export$82a3eb79c2e1839b;
const $c30e918aac675a8e$export$49070b443b7f066a = 30;
const $c30e918aac675a8e$export$7b55e8884adb489 = 5;
const $c30e918aac675a8e$export$55ed14d99ea72130 = 24;
const $c30e918aac675a8e$export$3d67df41657f4f21 = 22;
const $c30e918aac675a8e$export$ea30c0fd072f0798 = 150;
const $c30e918aac675a8e$export$3f2ddb112ca520d8 = 22;
const $c30e918aac675a8e$export$db73444eab1db51b = 25;
const $c30e918aac675a8e$export$814b8053e322886a = 3;
const $c30e918aac675a8e$export$aa2a010d1dfd7cc8 = 180;
const $c30e918aac675a8e$export$efd0951432a78968 = 14;
const $c30e918aac675a8e$export$541a2ce73b441465 = {
    1: 'P',
    2: 'C',
    3: '1B',
    4: '2B',
    5: '3B',
    6: 'SS',
    7: 'LF',
    8: 'CF',
    9: 'RF',
    10: 'DH'
};
const $c30e918aac675a8e$export$88e6c5bab2ff80e8 = 35;
const $c30e918aac675a8e$export$cdb7fd9d999c7168 = 25;


// eslint-disable-next-line import/no-extraneous-dependencies


var $63Xef = parcelRequire("63Xef");
const $274a679b157dfc10$var$ModeContext = /*#__PURE__*/ (0, $63Xef.createContext)('interactive');
function $274a679b157dfc10$export$db312fdadd91e8fe({ mode: mode, children: children }) {
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)($274a679b157dfc10$var$ModeContext.Provider, {
        value: mode,
        children: children
    });
}
function $274a679b157dfc10$export$b06374babe9615a7() {
    return (0, $63Xef.useContext)($274a679b157dfc10$var$ModeContext);
}


function $4ddfbdfbdf119a2f$var$ValueElement(props) {
    const { value: value, type: type, isNarrow: isNarrow, maxSliderWidth: maxSliderWidth, fill: fill, boldWinner: boldWinner, isUnqualified: isUnqualified, isFake: isFake, playerId: playerId } = props;
    const mode = (0, $274a679b157dfc10$export$b06374babe9615a7)();
    const guffType = (0, $b9c7b02947e449f9$export$46118f863c8123c6)(type);
    const isValueNull = value === null;
    let guffedVal = String(value);
    if ((0, $b9c7b02947e449f9$export$138ac6cd166d22dc).includes(guffType) || (0, $b9c7b02947e449f9$export$453fe672ce4b2f38).includes(guffType) || (0, $b9c7b02947e449f9$export$2ce867a7e1378570).includes(guffType)) guffedVal = (0, $3cfe79d709e6baf3$exports.guff)(Number(value), guffType);
    else if ((0, $b9c7b02947e449f9$export$5be31645a946ce43).includes(type)) {
        const [, stat] = type.split('_percent_rank_');
        guffedVal = (0, $3cfe79d709e6baf3$exports.guff)(Number(value), stat);
    }
    if (isValueNull) guffedVal = '';
    return !isNarrow ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
        x: 0,
        y: ((0, $c30e918aac675a8e$export$98534f2dc7b0e417) - (0, $c30e918aac675a8e$export$58c41d28e8c50092)) / 2 + 2,
        className: "label-value-number",
        textAnchor: "end",
        dominantBaseline: "hanging",
        fill: "#666666",
        fontSize: "9",
        fontWeight: boldWinner ? 'bold' : 'normal',
        children: guffedVal
    }) : /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                x: 0,
                y: 0,
                width: maxSliderWidth,
                height: (0, $c30e918aac675a8e$export$98534f2dc7b0e417),
                stroke: fill,
                strokeWidth: isValueNull ? 0 : 2,
                fill: isUnqualified || isFake ? `url(#${mode}-diagonal-hatch-${playerId}-${type})` : fill
            }),
            isFake ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                x: maxSliderWidth / 2 - (0, $c30e918aac675a8e$export$49070b443b7f066a) / 2,
                y: 2,
                width: (0, $c30e918aac675a8e$export$49070b443b7f066a),
                height: (0, $c30e918aac675a8e$export$98534f2dc7b0e417) - 4,
                fill: fill
            }) : null,
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                x: maxSliderWidth / 2,
                y: (0, $c30e918aac675a8e$export$98534f2dc7b0e417) / 2,
                className: "label-value-number-big",
                textAnchor: "middle",
                dominantBaseline: "central",
                fill: "white",
                fontWeight: "bold",
                fontSize: "9",
                children: guffedVal
            })
        ]
    });
}
var $4ddfbdfbdf119a2f$export$2e2bcd8739ae039 = $4ddfbdfbdf119a2f$var$ValueElement;



/* eslint-disable import/prefer-default-export */ parcelRequire("6uGhf");
var $aSvrg = parcelRequire("aSvrg");

// eslint-disable-next-line import/extensions
var $7da8d4b21cb48d39$exports = {};
/* eslint-disable import/prefer-default-export */ const $d95d8b439f5daf31$var$pitchTypeGroups = {
    FF: 'FASTBALL',
    CU: 'BREAKING',
    CH: 'OFFSPEED'
};
function $d95d8b439f5daf31$export$f123e17152c6376a(pitchType) {
    const upperPitchType = String(pitchType || '').toUpperCase();
    return $d95d8b439f5daf31$var$pitchTypeGroups[upperPitchType] || null;
}


var $7da8d4b21cb48d39$require$getPitchTypeGroup = $d95d8b439f5daf31$export$f123e17152c6376a;
const $7da8d4b21cb48d39$var$pitchNames = {
    ALL: 'All Pitches',
    Fastball: 'Fastball',
    Offspeed: 'Offspeed',
    Breaking: 'Breaking',
    FASTBALL: 'Fastball',
    OFFSPEED: 'Offspeed',
    BREAKING: 'Breaking',
    CHFS: 'Changeup',
    CUKC: 'Curve',
    SIFT: 'Sinker',
    FF: 'Four Seamer',
    FT: 'Two Seamer',
    SI: 'Sinker',
    FC: 'Cutter',
    FA: 'Other',
    CH: 'Changeup',
    FS: 'Split Finger',
    SC: 'Screwball',
    FO: 'Forkball',
    SL: 'Slider',
    ST: 'Sweeper',
    SV: 'Slurve',
    GY: 'Gyro',
    CU: 'Curveball',
    KC: 'Knuckle Curve',
    CS: 'Slow Curve',
    KN: 'Knuckleball',
    EP: 'Eephus',
    IN: 'Intentional Ball',
    PO: 'Pitch Out',
    UN: 'Unknown'
};
function $7da8d4b21cb48d39$var$getPitchName(pitchType) {
    try {
        return $7da8d4b21cb48d39$var$pitchNames[pitchType.toUpperCase()] || pitchType;
    } catch (e) {
        return '';
    }
}
function $7da8d4b21cb48d39$var$getPitchNameGrouping(pitchType) {
    const pitchTypeGroup = $7da8d4b21cb48d39$require$getPitchTypeGroup(pitchType);
    if (!pitchTypeGroup) // TODO: WHATTODO?
    return 'Unknown';
    return $7da8d4b21cb48d39$var$getPitchName(pitchTypeGroup);
}
function $7da8d4b21cb48d39$var$orderPitchTypes(typesArr) {
    const pitchOrder = Object.keys($7da8d4b21cb48d39$var$pitchNames);
    return typesArr.sort((a, b)=>pitchOrder.indexOf(a) - pitchOrder.indexOf(b));
}
// These subgroups combines offspeed -> changeup but also fastballs.
function $7da8d4b21cb48d39$var$orderPitchTypeSubgroups(typesArr) {
    const pitchOrder = [
        'Fastball',
        'Cutter',
        'Slider',
        'Curve',
        'Changeup',
        'Knuckleball'
    ];
    return typesArr.sort((a, b)=>pitchOrder.indexOf(a) - pitchOrder.indexOf(b));
}
$7da8d4b21cb48d39$exports = {
    pitchNames: $7da8d4b21cb48d39$var$pitchNames,
    getPitchName: $7da8d4b21cb48d39$var$getPitchName,
    getPitchNameGrouping: $7da8d4b21cb48d39$var$getPitchNameGrouping,
    orderPitchTypes: $7da8d4b21cb48d39$var$orderPitchTypes,
    orderPitchTypeSubgroups: $7da8d4b21cb48d39$var$orderPitchTypeSubgroups
};


function $8546d2747a982d8c$export$2e2bcd8739ae039(type, useShort = false) {
    if (!type) {
        console.warn('No pitch type found');
        return '';
    }
    if (useShort) return type.toUpperCase();
    switch(type.toLowerCase()){
        case 'ff':
            return '4-Seam';
        case 'cu':
            return 'Curve';
        case 'fs':
            return 'Split';
        case 'ch':
            return 'Change';
        case 'kn':
            return 'Knuckle';
        case 'kc':
            return 'Kn. Curve';
        case 'in':
            return 'Int. Ball';
        default:
            return (0, $7da8d4b21cb48d39$exports.getPitchName)(type);
    }
}


const $89d260932605bcde$export$df7dc322347a4e4 = new Set([
    'percent_rank_xwoba',
    'percent_rank_xera',
    'percent_rank_woba',
    'percent_rank_xwobacon',
    'percent_rank_wobacon',
    'percent_rank_xba',
    'percent_rank_ba',
    'percent_rank_xobp',
    'percent_rank_obp',
    'percent_rank_xslg',
    'percent_rank_slg',
    'percent_rank_bacon',
    'percent_rank_xbacon',
    'percent_rank_babip',
    'percent_rank_xiso',
    'percent_rank_iso',
    'percent_rank_exit_velocity_avg',
    'percent_rank_exit_velocity_max',
    'percent_rank_distance_hr_avg',
    'percent_rank_xhr',
    'percent_rank_barrel',
    'percent_rank_barrel_batted_rate',
    'percent_rank_launch_angle_avg',
    'percent_rank_hard_hit_percent',
    'percent_rank_sweet_spot_percent',
    'percent_rank_swing_speed',
    'percent_rank_swing_length',
    'percent_rank_squared_up_swing',
    'percent_rank_blasts_swing',
    'percent_rank_chase_percent',
    'percent_rank_whiff_percent',
    'percent_rank_k_percent',
    'percent_rank_bb_percent',
    'percent_rank_groundballs_percent',
    'percent_rank_airballs_percent',
    'percent_rank_pull_percent_airballs',
    'percent_rank_avg_hyper_speed',
    'percent_rank_avg_best_speed',
    'percent_rank_attack_angle',
    'percent_rank_vertical_swing_path',
    // 'percent_rank_acceleration',
    'percent_rank_ideal_angle_rate'
]);
const $89d260932605bcde$export$a9bbcba9ef9c1cff = new Set([
    'percent_rank_speed_order',
    'percent_rank_runner_runs_sb',
    'percent_rank_runner_runs_xb'
]);
const $89d260932605bcde$export$cc6a5b8d3a554add = new Set([
    'percent_rank_blocks_above_average',
    'percent_rank_cs_above_average',
    'percent_rank_fielding_run_value_framing',
    'percent_rank_framing',
    'percent_rank_pop_2b',
    'percent_rank_arm_cs_2b'
]);
const $89d260932605bcde$export$71a12d28e1e4bb77 = new Set([
    'percent_rank_oaa',
    'percent_rank_fielding_run_value_arm',
    'percent_rank_arm_overall',
    'percent_rank_arm_max',
    'percent_rank_jump'
]);
const $89d260932605bcde$export$b01e88d60a874712 = new Set([
    'percent_rank_swing_take_run_value',
    'percent_rank_fielding_run_value',
    'percent_rank_runner_run_value',
    'percent_rank_pitch_run_value_fastball',
    'percent_rank_pitch_run_value_breaking',
    'percent_rank_pitch_run_value_offspeed'
]);
const $89d260932605bcde$export$7137f82dfb412109 = new Set((0, $b9c7b02947e449f9$export$c6722944e73e432c).flatMap((pitch)=>(0, $b9c7b02947e449f9$export$9a758514bd1283e0).map((category)=>`${pitch}_percent_rank_${category}`)));
const $89d260932605bcde$export$afc614470417f70b = new Set([
    ...$89d260932605bcde$export$7137f82dfb412109
].filter((d)=>d.includes('pitch_run_value') || d.includes('pitch_usage') || d.includes('pitch_whiff_percent')));
function $89d260932605bcde$export$f03f2f56ee474855(selects, currType = 'batter') {
    const groupedStats = {
        value: [],
        batting: [],
        pitching: [],
        fielding: [],
        catching: [],
        running: [],
        pitch_arsenal: []
    };
    selects.forEach((stat)=>{
        if ($89d260932605bcde$export$df7dc322347a4e4.has(stat)) {
            if (currType === 'batter') {
                if (stat !== 'percent_rank_xera') groupedStats.batting.push(stat);
            } else if (stat !== 'percent_rank_xwoba') groupedStats.pitching.push(stat);
        } else if ($89d260932605bcde$export$a9bbcba9ef9c1cff.has(stat)) groupedStats.running.push(stat);
        else if ($89d260932605bcde$export$cc6a5b8d3a554add.has(stat)) groupedStats.catching.push(stat);
        else if ($89d260932605bcde$export$71a12d28e1e4bb77.has(stat)) groupedStats.fielding.push(stat);
        else if ($89d260932605bcde$export$b01e88d60a874712.has(stat)) groupedStats.value.push(stat);
        else if ($89d260932605bcde$export$7137f82dfb412109.has(stat) && currType === 'pitcher' || $89d260932605bcde$export$afc614470417f70b.has(stat) && currType === 'batter') groupedStats.pitch_arsenal.push(stat);
    });
    return groupedStats;
}
const $89d260932605bcde$export$b04545738ece254a = {
    pitch_velo: 'Velocity',
    pitch_spin: 'Spin Rate',
    pitch_extension: 'Extension',
    pitch_run_value: 'Run Value',
    pitch_whiff_percent: 'Whiff %',
    pitch_break_x: 'Horiz. Break',
    pitch_break_z: 'Drop',
    pitch_break_z_induced: 'IVB',
    pitch_usage: 'Usage %'
};
const $89d260932605bcde$export$25e732bb1f0af07a = {
    pitch_velo: 'Velo.',
    pitch_spin: 'Spin',
    pitch_extension: 'Ext.',
    pitch_run_value: 'RV',
    pitch_whiff_percent: 'Whiff',
    pitch_break_x: 'HBreak',
    pitch_break_z: 'Drop',
    pitch_break_z_induced: 'IVB',
    pitch_usage: 'Usage'
};
const $89d260932605bcde$var$pitchArsenalCombinations = Object.fromEntries((0, $b9c7b02947e449f9$export$c6722944e73e432c).flatMap((pitch)=>(0, $b9c7b02947e449f9$export$9a758514bd1283e0).map((category)=>{
        const key = `${pitch}_percent_rank_${category}`;
        const value = `${(0, $8546d2747a982d8c$export$2e2bcd8739ae039)(pitch)} ${$89d260932605bcde$export$b04545738ece254a[category]}`;
        return [
            key,
            value
        ];
    })));
const $89d260932605bcde$var$mobilePitchArsenalCombinations = Object.fromEntries((0, $b9c7b02947e449f9$export$c6722944e73e432c).flatMap((pitch)=>(0, $b9c7b02947e449f9$export$9a758514bd1283e0).map((category)=>{
        const key = `${pitch}_percent_rank_${category}`;
        const value = `${(0, $8546d2747a982d8c$export$2e2bcd8739ae039)(pitch)} ${$89d260932605bcde$export$25e732bb1f0af07a[category]}`;
        return [
            key,
            value
        ];
    })));
const $89d260932605bcde$export$7b1f6a215293eaeb = {
    percent_rank_barrel: 'Barrels',
    percent_rank_barrel_batted_rate: 'Barrel %',
    percent_rank_exit_velocity_avg: 'Avg. Exit Velo.',
    percent_rank_exit_velocity_max: 'Max. Exit Velo.',
    percent_rank_launch_angle_avg: 'Avg. Launch Angle',
    percent_rank_xba: 'xBA',
    percent_rank_xslg: 'xSLG',
    percent_rank_xwoba: 'xwOBA',
    percent_rank_woba: 'wOBA',
    percent_rank_hard_hit_percent: 'Hard-Hit %',
    percent_rank_xwobacon: 'xwOBAcon',
    percent_rank_wobacon: 'wOBAcon',
    percent_rank_k_percent: 'K %',
    percent_rank_bb_percent: 'BB %',
    percent_rank_whiff_percent: 'Whiff %',
    percent_rank_chase_percent: 'Chase %',
    percent_rank_ba: 'BA',
    percent_rank_bacon: 'BAcon',
    percent_rank_xbacon: 'xBAcon',
    percent_rank_babip: 'BABIP',
    percent_rank_obp: 'OBP',
    percent_rank_slg: 'SLG',
    percent_rank_xobp: 'xOBP',
    percent_rank_iso: 'ISO',
    percent_rank_xiso: 'xISO',
    percent_rank_sweet_spot_percent: 'LA Sweet Spot %',
    percent_rank_distance_hr_avg: 'Avg. HR Distance',
    percent_rank_groundballs_percent: 'GB %',
    percent_rank_airballs_percent: 'AIR %',
    percent_rank_pull_percent_airballs: 'Pull AIR %',
    percent_rank_avg_hyper_speed: 'Adjusted EV',
    percent_rank_avg_best_speed: 'EV50',
    percent_rank_pitch_run_value_fastball: 'Fastballs',
    percent_rank_pitch_run_value_breaking: 'Breaking',
    percent_rank_pitch_run_value_offspeed: 'Offspeed',
    percent_rank_arm_cs_2b: 'Catcher Arm Strength 2B',
    percent_rank_swing_speed: 'Bat Speed',
    percent_rank_swing_length: 'Swing Length',
    percent_rank_squared_up_swing: 'Squared-Up %',
    percent_rank_blasts_swing: 'Blast %',
    percent_rank_attack_angle: 'Attack Angle',
    percent_rank_vertical_swing_path: 'Swing Tilt',
    // percent_rank_acceleration: 'Bat Acceleration',
    percent_rank_speed_order: 'Sprint Speed',
    percent_rank_pop_2b: 'Catcher Pop 2B',
    percent_rank_framing: 'Catcher Framing',
    percent_rank_jump: 'Outfield Jump',
    percent_rank_oaa: 'Outs Above Average',
    percent_rank_arm_max: 'Max. Arm Strength',
    percent_rank_arm_overall: 'INF/OF Arm Strength',
    percent_rank_fastball_velo: 'Avg. FB Velo.',
    percent_rank_fastball_spin: 'Avg. FB Spin',
    percent_rank_fastball_extension: 'Avg. FB Extension',
    percent_rank_cu_spin: 'Avg. CU Spin',
    percent_rank_xera: 'xERA',
    percent_rank_xhr: 'xHR',
    percent_rank_swing_take_run_value: 'Batting',
    percent_rank_blocks_above_average: 'Blocks Above Avg',
    percent_rank_cs_above_average: 'CS Above Avg',
    percent_rank_fielding_run_value: 'Fielding',
    percent_rank_runner_run_value: 'Baserunning',
    percent_rank_runner_runs_sb: 'SB Runs',
    percent_rank_runner_runs_xb: 'XB Taken Runs',
    percent_rank_fielding_run_value_arm: 'OF Arm Value',
    percent_rank_fielding_run_value_framing: 'Catcher Framing',
    percent_rank_ideal_angle_rate: 'Ideal Attack Angle %',
    ...$89d260932605bcde$var$pitchArsenalCombinations
};
const $89d260932605bcde$export$fecc1e7a239dc298 = {
    percent_rank_barrel: 'Barrels',
    percent_rank_barrel_batted_rate: 'Barrel %',
    percent_rank_exit_velocity_avg: 'Avg. EV',
    percent_rank_exit_velocity_max: 'Max. EV',
    percent_rank_launch_angle_avg: 'Avg. LA',
    percent_rank_xba: 'xBA',
    percent_rank_xslg: 'xSLG',
    percent_rank_xwoba: 'xwOBA',
    percent_rank_woba: 'wOBA',
    percent_rank_hard_hit_percent: 'Hard-Hit %',
    percent_rank_xwobacon: 'xwOBAcon',
    percent_rank_wobacon: 'wOBAcon',
    percent_rank_k_percent: 'K %',
    percent_rank_bb_percent: 'BB %',
    percent_rank_whiff_percent: 'Whiff %',
    percent_rank_chase_percent: 'Chase %',
    percent_rank_ba: 'BA',
    percent_rank_bacon: 'BAcon',
    percent_rank_xbacon: 'xBAcon',
    percent_rank_babip: 'BABIP',
    percent_rank_obp: 'OBP',
    percent_rank_slg: 'SLG',
    percent_rank_xobp: 'xOBP',
    percent_rank_iso: 'ISO',
    percent_rank_xiso: 'xISO',
    percent_rank_sweet_spot_percent: 'LA SwSp %',
    percent_rank_distance_hr_avg: 'Avg. HR Dist.',
    percent_rank_groundballs_percent: 'GB %',
    percent_rank_airballs_percent: 'AIR %',
    percent_rank_pull_percent_airballs: 'Pull AIR %',
    percent_rank_avg_hyper_speed: 'Adj. EV',
    percent_rank_avg_best_speed: 'EV50',
    percent_rank_pitch_run_value_fastball: 'Fastballs',
    percent_rank_pitch_run_value_breaking: 'Breaking',
    percent_rank_pitch_run_value_offspeed: 'Offspeed',
    percent_rank_arm_cs_2b: 'Arm Str. 2B',
    percent_rank_swing_speed: 'Bat Speed',
    percent_rank_swing_length: 'Swing Length',
    percent_rank_squared_up_swing: 'Squared-Up %',
    percent_rank_blasts_swing: 'Blast %',
    percent_rank_attack_angle: 'Attack Angle',
    percent_rank_vertical_swing_path: 'Swing Tilt',
    // percent_rank_acceleration: 'Bat Accel.',
    percent_rank_speed_order: 'Sprint Speed',
    percent_rank_pop_2b: 'Pop 2B',
    percent_rank_framing: 'Framing',
    percent_rank_jump: 'OF Jump',
    percent_rank_oaa: 'OAA',
    percent_rank_arm_max: 'Max. Arm Str.',
    percent_rank_arm_overall: 'INF/OF Arm Str.',
    percent_rank_fastball_velo: 'FB Velo.',
    percent_rank_fastball_spin: 'FB Spin',
    percent_rank_fastball_extension: 'FB Ext.',
    percent_rank_cu_spin: 'CU Spin',
    percent_rank_xera: 'xERA',
    percent_rank_xhr: 'xHR',
    percent_rank_swing_take_run_value: 'Batting',
    percent_rank_blocks_above_average: 'Blocks Above Avg.',
    percent_rank_cs_above_average: 'CS Above Avg.',
    percent_rank_fielding_run_value: 'Fielding',
    percent_rank_runner_run_value: 'Baserunning',
    percent_rank_runner_runs_sb: 'SB Runs',
    percent_rank_runner_runs_xb: 'XB Taken Runs',
    percent_rank_fielding_run_value_arm: 'OF Arm Value',
    percent_rank_fielding_run_value_framing: 'Framing',
    percent_rank_ideal_angle_rate: 'Ideal Att. Ang. %',
    ...$89d260932605bcde$var$mobilePitchArsenalCombinations
};



const $3bbd855fb8f896f2$export$d21ad1cbd4c1ee64 = $aSvrg.default().domain([
    5,
    45,
    55,
    95
]).range([
    '#3661AD',
    '#B4CFD1',
    '#B4CFD1',
    '#D82129'
]);
function $3bbd855fb8f896f2$export$88f1fdfae738af54(selectedPlayers, selectedStats, showWinner, showValues, showTeams, showTitle, title) {
    const params = new URLSearchParams();
    selectedPlayers.forEach((player)=>params.append('player', player));
    selectedStats.forEach((stat)=>params.append('stat', stat));
    if (showWinner) params.append('showWinner', 'true');
    if (showValues) params.append('showValues', 'true');
    if (!showTeams) params.append('hideTeams', 'true');
    if (showTitle && title.length > 0) {
        params.append('showTitle', 'true');
        params.append('title', title);
    }
    window.history.pushState({}, '', `?${params.toString()}`);
}
function $3bbd855fb8f896f2$export$aa1a1894961eafab(player) {
    return `${player.id}-${player.year}-${player.grouping_cat.toLowerCase()}`;
}
function $3bbd855fb8f896f2$var$estimatePercentile(z) {
    // zScore == number of standard deviations from the mean
    // if z is greater than 6.5 standard deviations from the mean
    // the number of significant digits will be outside of a reasonable
    // range
    const min = 1;
    if (z < -6.5) return min;
    if (z > 6.5) return 100;
    let factK = 1;
    let sum = 0;
    let term = 1;
    let k = 0;
    const loopStop = Math.exp(-23);
    while(Math.abs(term) > loopStop){
        term = 0.3989422804 * (-1) ** k * z ** k / (2 * k + 1) / 2 ** k * z ** (k + 1) / factK;
        sum += term;
        k += 1;
        factK *= k;
    }
    sum += 0.5;
    return Math.max(min, Math.round(sum * 100));
}
function $3bbd855fb8f896f2$export$dfaaa4770195b933(value, avg, stdev, inverse) {
    if (!avg || !stdev) return 50;
    const diff = inverse ? avg - value : value - avg;
    const zScore = diff / stdev;
    return $3bbd855fb8f896f2$var$estimatePercentile(zScore);
}
function $3bbd855fb8f896f2$export$e2b5c5db9e2009fd(selectedData) {
    if (!selectedData.players.length) return 'batter';
    const possibleType = selectedData.players[0].id.split('-')[2];
    return possibleType === 'pitcher' ? 'pitcher' : 'batter';
}
function $3bbd855fb8f896f2$export$4942fc4b735d021a(selectedStats, currentType, showTitle, showTeams, ignoreAddButton, dimensions) {
    const { ADD_BUTTON_DIM: ADD_BUTTON_DIM, TOP_BUFFER: TOP_BUFFER } = dimensions;
    const groupedStats = (0, $89d260932605bcde$export$f03f2f56ee474855)(selectedStats, currentType);
    const numGroups = Object.entries(groupedStats).filter(([, stats])=>stats.length > 0).length;
    const numStats = selectedStats.length;
    const titleOffset = showTitle ? (0, $c30e918aac675a8e$export$3d67df41657f4f21) : 0;
    const addButtonOffset = ignoreAddButton ? 10 : ADD_BUTTON_DIM;
    const teamOffset = showTeams ? 0 : -(0, $c30e918aac675a8e$export$efd0951432a78968);
    const currHeight = TOP_BUFFER + ((0, $c30e918aac675a8e$export$ffbf6d1bcd3c71b1) + (0, $c30e918aac675a8e$export$32080fe92cae43a2)) * numGroups + (0, $c30e918aac675a8e$export$42510bee89f29ff9) * numStats + addButtonOffset + titleOffset + teamOffset;
    return currHeight >= (0, $c30e918aac675a8e$export$b1b9c9c1bf44cff1);
}
function $3bbd855fb8f896f2$export$1ebd64b07433c46(id, pos, type) {
    if (Number(id) === 660271) {
        if (type === 'Batter') return 'DH';
        return 'P';
    }
    return (0, $c30e918aac675a8e$export$541a2ce73b441465)[Number(pos)];
}


/* eslint-disable no-nested-ternary */ // eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");

function $88c07ae8c1d79293$var$DiagonalHatchDef(props) {
    const { playerId: playerId, statName: statName, color: color } = props;
    const mode = (0, $274a679b157dfc10$export$b06374babe9615a7)();
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("pattern", {
        id: `${mode}-diagonal-hatch-${playerId}-${statName}`,
        patternUnits: "userSpaceOnUse",
        width: "4",
        height: "4",
        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
            d: "M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2",
            style: {
                stroke: color,
                strokeWidth: 1
            }
        })
    });
}
var $88c07ae8c1d79293$export$2e2bcd8739ae039 = $88c07ae8c1d79293$var$DiagonalHatchDef;



// const NO_SCALE_COLOR = '#b4cfd1'
// const NO_SCALE_COLOR = '#777777'
function $c1120651771b9cf0$var$StatSlider(props) {
    const { statName: statName, percentile: percentile, maxSliderWidth: maxSliderWidth, showValues: showValues, showWinner: showWinner, isWinner: isWinner, value: value, isNarrow: isNarrow, isFake: isFake, uniqueId: uniqueId } = props;
    const mode = (0, $274a679b157dfc10$export$b06374babe9615a7)();
    const isNull = percentile === null;
    const isValueNull = value === null;
    const colWidth = showValues ? maxSliderWidth - 2 * (0, $c30e918aac675a8e$export$aa4eace044cdfdbf) - (0, $c30e918aac675a8e$export$49070b443b7f066a) : maxSliderWidth - 2 * (0, $c30e918aac675a8e$export$aa4eace044cdfdbf);
    const scaledVal = isNull ? 0 : percentile / 100 * colWidth;
    const rectWidth = showValues ? maxSliderWidth - (0, $c30e918aac675a8e$export$49070b443b7f066a) : maxSliderWidth;
    const valueXOffset = isNarrow ? 0 : maxSliderWidth - (0, $c30e918aac675a8e$export$7b55e8884adb489);
    let colorToUse;
    if (isNull) colorToUse = '#aaaaaa';
    else colorToUse = !showWinner || showWinner && isWinner ? String((0, $3bbd855fb8f896f2$export$d21ad1cbd4c1ee64)(percentile)) : '#aaaaaa';
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
        children: [
            isFake || isNull ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $88c07ae8c1d79293$export$2e2bcd8739ae039), {
                playerId: uniqueId,
                statName: statName,
                color: colorToUse
            }) : null,
            isWinner && showWinner ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                x: "-1",
                y: "-1",
                width: maxSliderWidth + 2,
                height: (0, $c30e918aac675a8e$export$98534f2dc7b0e417) + 2,
                stroke: "gold",
                strokeWidth: "3",
                fill: "gold"
            }) : null,
            !(isNarrow && showValues) ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                x: "0",
                y: (0, $c30e918aac675a8e$export$98534f2dc7b0e417) / 3,
                width: rectWidth,
                height: (0, $c30e918aac675a8e$export$98534f2dc7b0e417) / 3,
                stroke: isNull ? 'gray' : (0, $c30e918aac675a8e$export$4bdbd8698c928034),
                fill: isNull ? 'gray' : (0, $c30e918aac675a8e$export$4bdbd8698c928034),
                opacity: isNull ? 0.4 : 1
            }, `${statName}_baseline_rect`) : null,
            !(showValues && isNarrow) && !isValueNull && !isFake ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                        x: "0",
                        y: "0",
                        width: scaledVal + (0, $c30e918aac675a8e$export$aa4eace044cdfdbf),
                        height: (0, $c30e918aac675a8e$export$98534f2dc7b0e417),
                        stroke: colorToUse,
                        fill: colorToUse
                    }, `${statName}_rect`),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("circle", {
                        cx: scaledVal + (0, $c30e918aac675a8e$export$aa4eace044cdfdbf),
                        cy: (0, $c30e918aac675a8e$export$98534f2dc7b0e417) / 2,
                        r: (0, $c30e918aac675a8e$export$98534f2dc7b0e417) / 2,
                        stroke: showWinner && isWinner ? (0, $c30e918aac675a8e$export$ab7c035b277489a5) : 'white',
                        strokeWidth: "2",
                        fill: colorToUse
                    }, `${statName}_circle`),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                        className: "label-text-value",
                        x: scaledVal + (0, $c30e918aac675a8e$export$aa4eace044cdfdbf),
                        y: ((0, $c30e918aac675a8e$export$98534f2dc7b0e417) - (0, $c30e918aac675a8e$export$58c41d28e8c50092)) / 2 + 2,
                        fill: "white",
                        textAnchor: "middle",
                        dominantBaseline: "hanging",
                        fontWeight: "800",
                        fontSize: "9",
                        style: {
                            fontFamily: 'Roboto Condensed'
                        },
                        textLength: percentile === 100 ? 14 : undefined,
                        children: percentile
                    }, `${statName}_value_text`)
                ]
            }) : null,
            !(showValues && isNarrow) && !isValueNull && isFake && percentile ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                        x: "0",
                        y: "0",
                        width: scaledVal + (0, $c30e918aac675a8e$export$aa4eace044cdfdbf),
                        height: (0, $c30e918aac675a8e$export$98534f2dc7b0e417),
                        stroke: "none",
                        fill: `url(#${mode}-diagonal-hatch-${uniqueId}-${statName})`
                    }, `${statName}_rect`),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("circle", {
                        cx: scaledVal + (0, $c30e918aac675a8e$export$aa4eace044cdfdbf),
                        cy: (0, $c30e918aac675a8e$export$98534f2dc7b0e417) / 2,
                        r: (0, $c30e918aac675a8e$export$98534f2dc7b0e417) / 2,
                        stroke: showWinner && isWinner ? (0, $c30e918aac675a8e$export$ab7c035b277489a5) : colorToUse,
                        strokeWidth: "2",
                        strokeOpacity: "0.6",
                        fill: `url(#${mode}-diagonal-hatch-${uniqueId}-${statName})`
                    }, `${statName}_circle`)
                ]
            }) : null,
            showValues ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                transform: `translate(${valueXOffset}, 0)`,
                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $4ddfbdfbdf119a2f$export$2e2bcd8739ae039), {
                    value: value,
                    type: statName,
                    isNarrow: isNarrow,
                    maxSliderWidth: maxSliderWidth,
                    fill: colorToUse,
                    boldWinner: showValues && showWinner && isWinner && !isNarrow,
                    isUnqualified: percentile === null,
                    isFake: isFake,
                    playerId: uniqueId
                })
            }) : null,
            isWinner && showWinner ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                x: "-1",
                y: "-1",
                width: maxSliderWidth + 2,
                height: (0, $c30e918aac675a8e$export$98534f2dc7b0e417) + 2,
                stroke: (0, $c30e918aac675a8e$export$ab7c035b277489a5),
                strokeWidth: "3",
                fill: "transparent"
            }) : null
        ]
    });
}
var $c1120651771b9cf0$export$2e2bcd8739ae039 = $c1120651771b9cf0$var$StatSlider;


// eslint-disable-next-line import/no-extraneous-dependencies


var $63Xef = parcelRequire("63Xef");



var $63Xef = parcelRequire("63Xef");
const $116a259e7f6314e7$export$103f79687e655697 = 800;
function $116a259e7f6314e7$export$d1aa971bf69c7e87(width) {
    const isMobile = width < 768;
    const SVG_WIDTH = Math.min(width, $116a259e7f6314e7$export$103f79687e655697);
    const MAX_FULL_PLAYERS = isMobile ? 2 : 5;
    const MAX_TOTAL_PLAYERS = isMobile ? 9 : 9;
    const ADD_BUTTON_DIM = isMobile ? 20 : 25;
    const SLIDER_OFFSET_FROM_TEXT = isMobile ? 40 : 100;
    const TEXT_RIGHT_SIDE = SLIDER_OFFSET_FROM_TEXT - 10;
    const IMG_WIDTH = isMobile ? 52 : 65;
    const IMG_TOP_BUFFER = 15;
    const BETWEEN_PLAYERS_BUFFER = isMobile ? 5 : 10;
    const LOGO_WIDTH = isMobile ? 40 : 55;
    const TOP_BUFFER = isMobile ? 100 : 115;
    const TITLE_TOP_BUFFER = isMobile ? 7 : 15;
    const REMOVE_STAT_OFFSET = isMobile ? 18 : 78;
    const SETTINGS_MENU_DIM = isMobile ? 16 : 24;
    const SETTINGS_TRIANGLE_PATH = isMobile ? '5,6 11,6 8,10' : '8,9 16,9 12,14';
    const STAT_DRAG_RECT_WIDTH = isMobile ? 126 : 176;
    const REMOVE_BUTTON_X = STAT_DRAG_RECT_WIDTH - 4;
    return {
        isMobile: isMobile,
        SVG_WIDTH: SVG_WIDTH,
        MAX_FULL_PLAYERS: MAX_FULL_PLAYERS,
        MAX_TOTAL_PLAYERS: MAX_TOTAL_PLAYERS,
        ADD_BUTTON_DIM: ADD_BUTTON_DIM,
        TEXT_RIGHT_SIDE: TEXT_RIGHT_SIDE,
        SLIDER_OFFSET_FROM_TEXT: SLIDER_OFFSET_FROM_TEXT,
        IMG_WIDTH: IMG_WIDTH,
        IMG_TOP_BUFFER: IMG_TOP_BUFFER,
        BETWEEN_PLAYERS_BUFFER: BETWEEN_PLAYERS_BUFFER,
        LOGO_WIDTH: LOGO_WIDTH,
        TOP_BUFFER: TOP_BUFFER,
        REMOVE_STAT_OFFSET: REMOVE_STAT_OFFSET,
        SETTINGS_MENU_DIM: SETTINGS_MENU_DIM,
        SETTINGS_TRIANGLE_PATH: SETTINGS_TRIANGLE_PATH,
        TITLE_TOP_BUFFER: TITLE_TOP_BUFFER,
        STAT_DRAG_RECT_WIDTH: STAT_DRAG_RECT_WIDTH,
        REMOVE_BUTTON_X: REMOVE_BUTTON_X
    };
}
const $116a259e7f6314e7$var$DimensionsContext = /*#__PURE__*/ (0, $63Xef.createContext)(null);
function $116a259e7f6314e7$export$a31e22a91fd34dd9({ width: width, children: children }) {
    const value = (0, $63Xef.useMemo)(()=>$116a259e7f6314e7$export$d1aa971bf69c7e87(width), [
        width
    ]);
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)($116a259e7f6314e7$var$DimensionsContext.Provider, {
        value: value,
        children: children
    });
}
function $116a259e7f6314e7$export$d04af0e501fb729f() {
    const dimensions = (0, $63Xef.useContext)($116a259e7f6314e7$var$DimensionsContext);
    if (dimensions === null) throw new Error('useDimensions must be used within a DimensionsProvider');
    return dimensions;
}
function $116a259e7f6314e7$export$52797c36be27ec5f() {
    const [windowWidth, setWindowWidth] = (0, $63Xef.useState)(typeof window !== 'undefined' ? document.documentElement.clientWidth : $116a259e7f6314e7$export$103f79687e655697);
    (0, $63Xef.useEffect)(()=>{
        const handleResize = ()=>setWindowWidth(document.documentElement.clientWidth);
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    return windowWidth;
}
function $116a259e7f6314e7$export$7ed924c3d8496d63(ref, fallback = $116a259e7f6314e7$export$103f79687e655697) {
    const [width, setWidth] = (0, $63Xef.useState)(fallback);
    (0, $63Xef.useLayoutEffect)(()=>{
        const element = ref.current;
        if (!element || typeof ResizeObserver === 'undefined') return undefined;
        const update = ()=>setWidth(element.clientWidth);
        update();
        const observer = new ResizeObserver(update);
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        ref
    ]);
    return width;
}
function $116a259e7f6314e7$export$2e2bcd8739ae039() {
    return $116a259e7f6314e7$export$d1aa971bf69c7e87($116a259e7f6314e7$export$52797c36be27ec5f());
}


const $2efaf09ca6b9466c$var$BASE_NAME_FONT_SIZE = 14;
const $2efaf09ca6b9466c$var$MIN_NAME_FONT_SIZE = 12;
// Reuse a single off-DOM canvas context for text measurement
let $2efaf09ca6b9466c$var$measureCtx = null;
const $2efaf09ca6b9466c$var$getMeasureCtx = ()=>{
    if (!$2efaf09ca6b9466c$var$measureCtx) $2efaf09ca6b9466c$var$measureCtx = document.createElement('canvas').getContext('2d');
    return $2efaf09ca6b9466c$var$measureCtx;
};
const $2efaf09ca6b9466c$var$measureWidth = (ctx, text, fontSize)=>{
    // eslint-disable-next-line no-param-reassign
    ctx.font = `${fontSize}px 'Roboto Condensed'`;
    return ctx.measureText(text).width;
};
// Trim a string with a trailing ellipsis so it fits within maxWidth
const $2efaf09ca6b9466c$var$truncateToWidth = (ctx, text, maxWidth, fontSize)=>{
    const ellipsis = '\u2026';
    // binary search for the longest prefix that fits with the ellipsis
    let lo = 0;
    let hi = text.length;
    while(lo < hi){
        const mid = Math.ceil((lo + hi) / 2);
        const candidate = text.slice(0, mid).trimEnd() + ellipsis;
        if ($2efaf09ca6b9466c$var$measureWidth(ctx, candidate, fontSize) <= maxWidth) lo = mid;
        else hi = mid - 1;
    }
    return text.slice(0, lo).trimEnd() + ellipsis;
};
// Fit text within maxWidth: try the base size, shrink to the min size,
// then fall back to an ellipsis at the min size.
const $2efaf09ca6b9466c$var$fitText = (text, maxWidth)=>{
    const ctx = $2efaf09ca6b9466c$var$getMeasureCtx();
    if (!ctx) return {
        text: text,
        fontSize: $2efaf09ca6b9466c$var$BASE_NAME_FONT_SIZE
    };
    if ($2efaf09ca6b9466c$var$measureWidth(ctx, text, $2efaf09ca6b9466c$var$BASE_NAME_FONT_SIZE) <= maxWidth) return {
        text: text,
        fontSize: $2efaf09ca6b9466c$var$BASE_NAME_FONT_SIZE
    };
    if ($2efaf09ca6b9466c$var$measureWidth(ctx, text, $2efaf09ca6b9466c$var$MIN_NAME_FONT_SIZE) <= maxWidth) return {
        text: text,
        fontSize: $2efaf09ca6b9466c$var$MIN_NAME_FONT_SIZE
    };
    return {
        text: $2efaf09ca6b9466c$var$truncateToWidth(ctx, text, maxWidth, $2efaf09ca6b9466c$var$MIN_NAME_FONT_SIZE),
        fontSize: $2efaf09ca6b9466c$var$MIN_NAME_FONT_SIZE
    };
};
function $2efaf09ca6b9466c$var$PlayerHeader(props) {
    const { IMG_WIDTH: IMG_WIDTH, IMG_TOP_BUFFER: IMG_TOP_BUFFER } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    const { data: data, maxSliderWidth: maxSliderWidth, showTeams: showTeams, isHidden: isHidden } = props;
    const { id: id, player_name: player_name, year: year, teams: teams } = data;
    // const imgUrl = `https://midfield.mlbstatic.com/v1/people/${id}/mlb/120?circle=true`
    // const proxyUrl = `/comparison-tool/services/api/${encodeURIComponent(
    //     imgUrl
    // )}`
    const teamsToDisplay = teams ?? [];
    const teamLogoGap = 2;
    const teamLogoStep = (0, $c30e918aac675a8e$export$efd0951432a78968) + teamLogoGap;
    const totalTeamsWidth = teamsToDisplay.length > 0 ? teamsToDisplay.length * (0, $c30e918aac675a8e$export$efd0951432a78968) + (teamsToDisplay.length - 1) * teamLogoGap : 0;
    const nameTokens = player_name.split(', ');
    const firstName = nameTokens[1];
    const lastName = nameTokens[0];
    // The name is centered, so it can use the full per-player slot including
    // half of the gap on each side before touching a neighboring player.
    const availableWidth = maxSliderWidth + (0, $c30e918aac675a8e$export$d6d08bc1d460e04d) - 2;
    const displayFirst = $2efaf09ca6b9466c$var$fitText(firstName, availableWidth);
    const displayLast = $2efaf09ca6b9466c$var$fitText(lastName, availableWidth);
    const imgX = (maxSliderWidth - IMG_WIDTH) / 2;
    const [headshotBase64, setHeadshotBase64] = (0, $63Xef.useState)(null);
    const [teamLogosBase64, setTeamLogosBase64] = (0, $63Xef.useState)({});
    (0, $63Xef.useEffect)(()=>{
        const mlbUrl = `https://midfield.mlbstatic.com/v1/people/${isHidden ? 'generic' : id}/mlb/120?circle=true`;
        const proxyUrl = `/comparison-tool/services/api/${encodeURIComponent(mlbUrl)}`;
        fetch(proxyUrl).then((response)=>response.blob()) // Get the raw binary blob
        .then((blob)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>{
                setHeadshotBase64(reader.result);
            };
            reader.readAsDataURL(blob);
        }).catch((err)=>console.error('Failed to load headshot', err));
        // --- FETCH TEAM LOGOS (Using Promise.all for speed) ---
        const fetchTeamLogos = async ()=>{
            const logoMap = {};
            await Promise.all(teamsToDisplay.map(async (teamId)=>{
                const teamUrl = `https://www.mlbstatic.com/team-logos/${teamId}.svg`;
                const teamProxy = `/comparison-tool/services/api/${encodeURIComponent(teamUrl)}`;
                try {
                    const res = await fetch(teamProxy);
                    const blob = await res.blob();
                    const base64 = await new Promise((resolve)=>{
                        const reader = new FileReader();
                        reader.onloadend = ()=>resolve(reader.result);
                        reader.readAsDataURL(blob);
                    });
                    logoMap[teamId] = base64;
                } catch (err) {
                    console.error(`Failed to load team ${teamId}`, err);
                }
            }));
            if (isHidden) setTeamLogosBase64({});
            else setTeamLogosBase64(logoMap);
        };
        if (teamsToDisplay.length > 0) fetchTeamLogos();
    }, [
        id,
        teamsToDisplay,
        isHidden
    ]);
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("circle", {
                cx: maxSliderWidth / 2,
                cy: IMG_TOP_BUFFER + IMG_WIDTH / 2,
                r: IMG_WIDTH / 2,
                strokeWidth: 4,
                stroke: (0, $c30e918aac675a8e$export$4bdbd8698c928034),
                fill: (0, $c30e918aac675a8e$export$4bdbd8698c928034)
            }),
            headshotBase64 && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("image", {
                x: imgX,
                y: IMG_TOP_BUFFER,
                href: headshotBase64,
                width: IMG_WIDTH,
                height: IMG_WIDTH
            }),
            isHidden ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                x: maxSliderWidth / 2,
                y: IMG_TOP_BUFFER + IMG_WIDTH + (0, $c30e918aac675a8e$export$a205dee2dee736da) + (0, $c30e918aac675a8e$export$891f57ac696b84d7) / 2,
                className: "player-name",
                style: {
                    fontFamily: 'Roboto Condensed',
                    fontSize: '14px'
                },
                children: "????????"
            }) : /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                        x: maxSliderWidth / 2,
                        y: IMG_TOP_BUFFER + IMG_WIDTH + (0, $c30e918aac675a8e$export$a205dee2dee736da),
                        className: "player-name",
                        style: {
                            fontFamily: 'Roboto Condensed',
                            fontSize: displayFirst.fontSize
                        },
                        children: displayFirst.text
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                        x: maxSliderWidth / 2,
                        y: IMG_TOP_BUFFER + IMG_WIDTH + (0, $c30e918aac675a8e$export$a205dee2dee736da) + (0, $c30e918aac675a8e$export$891f57ac696b84d7),
                        className: "player-name",
                        style: {
                            fontFamily: 'Roboto Condensed',
                            fontSize: displayLast.fontSize
                        },
                        children: displayLast.text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                x: maxSliderWidth / 2,
                y: IMG_TOP_BUFFER + IMG_WIDTH + (0, $c30e918aac675a8e$export$a205dee2dee736da) + (0, $c30e918aac675a8e$export$891f57ac696b84d7) + (0, $c30e918aac675a8e$export$17314496a27dca07),
                className: "player-year",
                style: {
                    fontFamily: 'Roboto Condensed'
                },
                children: year
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                transform: `translate(${maxSliderWidth / 2 - totalTeamsWidth / 2}, ${IMG_TOP_BUFFER + IMG_WIDTH + (0, $c30e918aac675a8e$export$a205dee2dee736da) + (0, $c30e918aac675a8e$export$891f57ac696b84d7) + (0, $c30e918aac675a8e$export$17314496a27dca07) + (0, $c30e918aac675a8e$export$d2ef3ba77a060487)})`,
                children: showTeams && teamsToDisplay.map((team, idx)=>{
                    const logoData = teamLogosBase64[team];
                    return logoData ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("image", {
                        x: idx * teamLogoStep,
                        y: 0,
                        href: logoData,
                        width: (0, $c30e918aac675a8e$export$efd0951432a78968),
                        height: (0, $c30e918aac675a8e$export$efd0951432a78968)
                    }, team) : null;
                })
            })
        ]
    });
}
var $2efaf09ca6b9466c$export$2e2bcd8739ae039 = $2efaf09ca6b9466c$var$PlayerHeader;





function $75531e5f44085736$var$PlayerComponent(props) {
    const selectedData = {};
    const selectedValues = {};
    const { selects: selects, playerData: playerData, groupedSelects: groupedSelects, existingTypes: existingTypes, maxSliderWidth: maxSliderWidth, showValues: showValues, showTeams: showTeams, showWinner: showWinner, isNarrow: isNarrow, winners: winners, summaryStats: summaryStats, currentType: currentType, winnerStats: winnerStats, isHidden: isHidden } = props;
    const { TOP_BUFFER: TOP_BUFFER } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    function getFakeRank(key, value) {
        const { year: year, grouping_code: grouping_code } = playerData;
        const strippedName = (0, $b9c7b02947e449f9$export$46118f863c8123c6)(key);
        const thisYearSummary = summaryStats.find((dat)=>Number(dat.year) === Number(year) && dat.grouping_code === grouping_code);
        if (!thisYearSummary) return null;
        const avg = Number(thisYearSummary[`avg_${strippedName}`]);
        const stdev = Number(thisYearSummary[`stdev_${strippedName}`]);
        const invert = (0, $b9c7b02947e449f9$export$d7b39d8a41476f9).includes(key) && currentType === 'batter' || (0, $b9c7b02947e449f9$export$f861e6885e7b9ed2).includes(key) && currentType === 'pitcher';
        return (0, $3bbd855fb8f896f2$export$dfaaa4770195b933)(Number(value), avg, stdev, invert);
    }
    selects.forEach((select)=>{
        selectedData[select] = playerData[select];
        const valColumn = (0, $b9c7b02947e449f9$export$46118f863c8123c6)(select);
        selectedValues[select] = playerData[valColumn] === null ? null : Number(playerData[valColumn]);
    });
    let numStatsSeen = 0;
    const componentGroupings = existingTypes.map((type, groupingsSeen)=>{
        const statSliders = groupedSelects[type].map((key, i)=>{
            const rank = selectedData[key];
            const statWinner = winners[key];
            const value = selectedValues[key];
            const isFake = rank === null && value !== null;
            const fakeRank = isFake ? getFakeRank(key, value) : null;
            let percentileToUse = null;
            if (rank !== null) percentileToUse = Number(rank);
            else if (isFake) percentileToUse = fakeRank;
            return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                transform: `translate(0, ${i * (0, $c30e918aac675a8e$export$42510bee89f29ff9)})`,
                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $c1120651771b9cf0$export$2e2bcd8739ae039), {
                    statName: key,
                    percentile: percentileToUse,
                    value: value,
                    maxSliderWidth: maxSliderWidth,
                    showValues: showValues,
                    showWinner: showWinner || winnerStats?.includes(key),
                    isNarrow: isNarrow,
                    isWinner: playerData.uniqueId === statWinner,
                    isFake: isFake,
                    uniqueId: String(playerData.uniqueId)
                }, `${key}_${playerData.id}_slider`)
            }, `${key}_${playerData.id}`);
        });
        const headersOffset = (groupingsSeen + 1) * (0, $c30e918aac675a8e$export$ffbf6d1bcd3c71b1) + (groupingsSeen + 1) * (0, $c30e918aac675a8e$export$32080fe92cae43a2);
        const statsOffset = numStatsSeen * (0, $c30e918aac675a8e$export$42510bee89f29ff9);
        const teamOffset = showTeams ? 0 : -(0, $c30e918aac675a8e$export$efd0951432a78968);
        const slidersGroup = /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
            transform: `translate(0,${headersOffset + statsOffset + TOP_BUFFER + teamOffset})`,
            children: statSliders
        }, `${type}_slider_grouping`);
        numStatsSeen += groupedSelects[type].length;
        return slidersGroup;
    });
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $2efaf09ca6b9466c$export$2e2bcd8739ae039), {
                data: playerData,
                maxSliderWidth: maxSliderWidth,
                showTeams: showTeams,
                isHidden: isHidden
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                className: `player-wrapper-${playerData.id}`,
                children: componentGroupings
            })
        ]
    });
}
var $75531e5f44085736$export$2e2bcd8739ae039 = $75531e5f44085736$var$PlayerComponent;


/* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 

var $63Xef = parcelRequire("63Xef");





var $d797fa0caa0b0f8e$exports = {};
/**
 *
 * @param {string} str
 * @returns string
 */ function $d797fa0caa0b0f8e$var$normalizeAccents(str) {
    try {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replaceAll('.', '').toLowerCase();
    } catch (e) {
        console._log('normalize failed for', str) // eslint-disable-line no-console, no-underscore-dangle
        ;
        return str;
    }
}
$d797fa0caa0b0f8e$exports = {
    normalizeAccents: $d797fa0caa0b0f8e$var$normalizeAccents
};


var $d729c943390d67ec$exports = {};
function $d729c943390d67ec$var$generateYearArray(maxYear, minYear) {
    if (minYear > maxYear) throw new Error('Min year must be less than max year');
    let year = maxYear;
    const years = [];
    while(year >= minYear){
        years.push(year);
        year -= 1;
    }
    return years;
}
const $d729c943390d67ec$var$minBatTrackingDate = '2023-07-14';
// This will potentially be out of date until the next time the pod restarts after the new year, hence "ish"
const $d729c943390d67ec$var$currentYearIsh = new Date().getFullYear();
const $d729c943390d67ec$var$minStatcastYear = 2015;
const $d729c943390d67ec$var$minPitchFxYear = 2008;
const $d729c943390d67ec$var$thresholds = {
    // We'll use actual months rather than JS zero indexed
    spring: [
        2,
        16
    ],
    first: [
        3,
        27
    ],
    firstMinors: [
        3,
        28
    ],
    second: [
        3,
        31
    ],
    third: [
        4,
        10
    ],
    fourth: [
        5,
        1
    ]
};
function $d729c943390d67ec$var$getThresholdYear(type) {
    const [month, day] = $d729c943390d67ec$var$thresholds[type];
    if (!month || !day) throw new Error(`no threshold of type ${type}`);
    const now = new Date();
    const currentYear = now.getFullYear();
    // EDT is 4 hours behind UTC. So 8 o'clock there gets us to about 4am EDT, about when the nightly load might be finishing up running
    const thresholdUnix = Date.UTC(currentYear, month - 1, day, 8, 0, 0, 0);
    const thresholdYear = thresholdUnix < now ? currentYear : currentYear - 1;
    return thresholdYear;
}
function $d729c943390d67ec$var$getFirstThresholdDate() {
    const now = new Date();
    const currentYear = now.getFullYear();
    return new Date(currentYear, 2, 27) // March 27th
    ;
}
const $d729c943390d67ec$var$appSettings = {
    // Home page
    SETTINGS_TOP_PERFORMERS: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    dragDashboard: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('third');
        }
    },
    // Batting
    batTracking: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            return $d729c943390d67ec$var$generateYearArray($d729c943390d67ec$var$getThresholdYear('first'), 2023);
        },
        minBatTrackingDate: $d729c943390d67ec$var$minBatTrackingDate
    },
    battedBall: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    exitVelocity: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    expectedStats: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    homeRunTracking: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2019);
        }
    },
    percentileRankings: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    pitchArsenalStats: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        min: 1,
        minPitches: 'q',
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2019);
        }
    },
    pitcherArmAngles: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2020);
        }
    },
    pitcherTempo: {
        baseState: 'Bases Empty',
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        minPitches: 'q',
        isTake: 1,
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2010);
        }
    },
    swingTake: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    SETTINGS_YEAR_TO_YEAR: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, firstThresholdYear - 8);
        },
        get allYears () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        },
        useCache: true
    },
    // Pitchers
    // Takes 100 pitches to show up, so don't have 2025 show up as an option early
    activeSpin: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('third');
        },
        useCache: true,
        get years () {
            const thirdThresholdYear = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(thirdThresholdYear, 2020);
        },
        min: 50
    },
    pitchArsenals: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        spinCutoffYear: 2015,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    pitchMovement: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2017);
        }
    },
    // Handles comparison as well
    spinAxis: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2020);
        }
    },
    // FIELDING
    armStrength: {
        // Set because 1B is the longest to qualify @100 throws.
        minThrows: 50,
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        },
        useCache: true,
        // Start exposing the new year option later than on other leaderboards
        get years () {
            const thirdThresholdYear = $d729c943390d67ec$var$getThresholdYear('third');
            return $d729c943390d67ec$var$generateYearArray(thirdThresholdYear, 2020);
        }
    },
    catcherBlocking: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2018);
        }
    },
    catcherFraming: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    catcherFramingOld: {
        year: 2017,
        useCache: true,
        years: $d729c943390d67ec$var$generateYearArray(2017, 2015)
    },
    catcherFramingNew: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2018);
        }
    },
    catcherThrowing: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    SETTINGS_CATCHER_STANCE: {
        firstDate: '2020-07-23',
        firstYear: 2020,
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2020);
        }
    },
    pitcherRunningGame: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    fieldingRuns: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    SETTINGS_FIELDING_RUN_VALUE: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2018);
        },
        firstYear: 2018,
        firstDate: '2018-03-29'
    },
    poptime: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        },
        useCache: true,
        min: 5
    },
    catchProbability: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    directionalCatchProbability: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    infieldDefense: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        min: 10,
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    jump: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    baseRunning: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    baseRunningRunValue: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    basestealingRunningGame: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    sprintSpeed: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        },
        min: 10
    },
    runningSplits: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        },
        get playerYear () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        },
        useCache: true,
        min: 5,
        get years () {
            const thirdThresholdYear = $d729c943390d67ec$var$getThresholdYear('third');
            return $d729c943390d67ec$var$generateYearArray(thirdThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    SETTINGS_SLBI: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        dateMin: `${$d729c943390d67ec$var$currentYearIsh}-03-22`,
        dateMax: `${$d729c943390d67ec$var$currentYearIsh}-11-01`
    },
    // This is only powering an old URL that's kept around for scrapers
    oaa: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        useCache: true
    },
    parkFactors: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        firstWallChangeYear: 2022,
        secondWallChangeYear: 2025,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 1969);
        },
        get statcastyYears () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        },
        get dimensionYears () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2015);
        },
        earliestParkFactorYear: 1969,
        wallChangeDefault: 2024,
        wallChangeYears: $d729c943390d67ec$var$generateYearArray(2024, 2022),
        get secondWallChangeYears () {
            const secondThresholdYear = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(secondThresholdYear, 2025);
        }
    },
    sortableStats: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 1950);
        }
    },
    // /statcast_hit_probability
    breakdown: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    pitchTimerInfractions: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2023);
        }
    },
    // /replay
    replay: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        useCache: true,
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2014);
        }
    },
    // NON LEADERBOARD PLACES
    SETTINGS_STATISTICS_MENU: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, firstThresholdYear - 5);
        },
        get statcastYears () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    SETTINGS_DERBY: {
        year: 2026,
        years: $d729c943390d67ec$var$generateYearArray(2026, 2017)
    },
    draft: {
        year: 2026,
        years: $d729c943390d67ec$var$generateYearArray(2026, 1965)
    },
    games: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        }
    },
    illustrator: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const springThresholdYear = $d729c943390d67ec$var$getThresholdYear('spring');
            return $d729c943390d67ec$var$generateYearArray(springThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    league: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    team: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    playerScroll: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        }
    },
    // I feel like these should always have a year selected, but perhaps I'm wrong.
    searchCharts: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        }
    },
    SETTINGS_METRICS_CONTEXT: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        },
        minBatTrackingDate: $d729c943390d67ec$var$minBatTrackingDate,
        minBatTrackingYear: 2023
    },
    // Okay if this is slow, so an injured player could trend
    trending: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        }
    },
    weightedGameScore: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        }
    },
    // VISUALS imported
    brushing: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    SETTINGS_AFFINITY: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        }
    },
    SETTINGS_HITTING_SIGNATURE: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minStatcastYear);
        }
    },
    SETTINGS_PLAYER_COMPARISON: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    // Flip When Schedule Comes Out
    map: {
        currentYear: 2025,
        years: $d729c943390d67ec$var$generateYearArray(2026, 1974)
    },
    oaaVisual: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    pitchPercent: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    pitchPlinko: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('third');
        },
        get years () {
            const thirdThresholdYear = $d729c943390d67ec$var$getThresholdYear('third');
            return $d729c943390d67ec$var$generateYearArray(thirdThresholdYear, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    positioning: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2016);
        }
    },
    swingMissProfile: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const secondThresholdYear = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(secondThresholdYear, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    swingTakeVisual: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const secondThresholdYear = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(secondThresholdYear, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    textureHeatMap: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const secondThresholdYear = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(secondThresholdYear, $d729c943390d67ec$var$minPitchFxYear);
        }
    },
    SETTINGS_HOT_STOVE: {
        currentYear: 2026,
        years: $d729c943390d67ec$var$generateYearArray(2026, 2020),
        yearsOptions: $d729c943390d67ec$var$generateYearArray(2026, 2020).map((d)=>({
                label: `${d - 1} - ${d}`,
                value: d
            })),
        get statYears () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2019);
        },
        minPa: 100,
        minIp: 20,
        // Magic Numbers
        MAGIC: {
            unsigned: 99887766,
            sameTeam: 99998888,
            diffTeam: 99997777
        }
    },
    // GAMES
    SETTINGS_SPRAY_CHART_GAME: {
        get year () {
            return $d729c943390d67ec$var$getThresholdYear('fourth');
        }
    },
    // INTERNAL PAGES
    SETTINGS_PLAYER_RANKING: {
        lastTwoYears: $d729c943390d67ec$var$generateYearArray($d729c943390d67ec$var$currentYearIsh, $d729c943390d67ec$var$currentYearIsh - 1)
    },
    // PLAYER PAGE
    SETTINGS_PLAYER_PAGE: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        }
    },
    SETTINGS_VENUE_INFO: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('first');
        },
        get years () {
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, 2015);
        }
    },
    // CHANGELOG
    SETTINGS_CHANGELOG: {
        currentYear: $d729c943390d67ec$var$currentYearIsh,
        years: $d729c943390d67ec$var$generateYearArray($d729c943390d67ec$var$currentYearIsh, 2025)
    },
    // ABS
    SETTINGS_ABS: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('spring');
        },
        get regSeasonFlipDate () {
            return $d729c943390d67ec$var$getFirstThresholdDate();
        },
        firstMajorsYear: 2026,
        firstMinorsYear: 2025,
        // TODO: Change when threshold year flips
        get majorsYears () {
            const springThresholdYear = $d729c943390d67ec$var$getThresholdYear('spring');
            return $d729c943390d67ec$var$generateYearArray(springThresholdYear, 2025);
        },
        get minorsYears () {
            const springThresholdYear = $d729c943390d67ec$var$getThresholdYear('spring');
            return $d729c943390d67ec$var$generateYearArray(springThresholdYear, 2025);
        }
    },
    PIPELINE_PROSPECTS_CRON: {
        // Used for team history join
        currentYear: 2026
    },
    SETTINGS_SEARCH: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('spring');
        },
        get currentMinorsYear () {
            return $d729c943390d67ec$var$getThresholdYear('firstMinors');
        },
        firstMinorsYear: 2021,
        firstStatcastYear: 2015,
        firstMajorsYear: 2008,
        wbcYears: [
            2026,
            2023
        ]
    },
    SETTINGS_COMPARISON_TOOL: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            const currentYear = $d729c943390d67ec$var$getThresholdYear('second');
            return $d729c943390d67ec$var$generateYearArray(currentYear, 2015);
        }
    },
    SETTINGS_SCOOPS: {
        get currentYear () {
            return $d729c943390d67ec$var$getThresholdYear('second');
        },
        get years () {
            // Per Mike's request to remove earlier years and not use Statcast years
            const MIN_SCOOPS_YEAR = 2021;
            const firstThresholdYear = $d729c943390d67ec$var$getThresholdYear('first');
            return $d729c943390d67ec$var$generateYearArray(firstThresholdYear, MIN_SCOOPS_YEAR);
        }
    }
};
$d729c943390d67ec$exports = {
    appSettings: $d729c943390d67ec$var$appSettings,
    minPitchFxYear: $d729c943390d67ec$var$minPitchFxYear,
    minStatcastYear: $d729c943390d67ec$var$minStatcastYear,
    // Most things default to this
    currentYear: $d729c943390d67ec$var$getThresholdYear('second')
};


var $4599fed479aad8e8$exports = {};
/* eslint-disable no-param-reassign */ // Attempt to standardize all the teams/names in the app. Someday.
const $4599fed479aad8e8$var$teamMap = {
    108: {
        name: 'Angels',
        fullName: 'Los Angeles Angels',
        locationName: 'Los Angeles',
        id: 108,
        abbrev: 'LAA',
        venue_name: 'Angel Stadium',
        venue_id: 1,
        teamColor: '#CE1141',
        division: 'AL West'
    },
    109: {
        name: 'Diamondbacks',
        fullName: 'Arizona Diamondbacks',
        locationName: 'Arizona',
        id: 109,
        abbrev: 'AZ',
        venue_name: 'Chase Field',
        venue_id: 15,
        teamColor: '#C51230',
        division: 'NL West'
    },
    110: {
        name: 'Orioles',
        fullName: 'Baltimore Orioles',
        locationName: 'Baltimore',
        id: 110,
        abbrev: 'BAL',
        venue_name: 'Oriole Park at Camden Yards',
        venue_id: 2,
        teamColor: '#DF4601',
        division: 'AL East'
    },
    111: {
        name: 'Red Sox',
        fullName: 'Boston Red Sox',
        locationName: 'Boston',
        id: 111,
        abbrev: 'BOS',
        venue_name: 'Fenway Park',
        venue_id: 3,
        teamColor: '#BD3039',
        division: 'AL East'
    },
    112: {
        name: 'Cubs',
        fullName: 'Chicago Cubs',
        locationName: 'Chicago',
        id: 112,
        abbrev: 'CHC',
        venue_name: 'Wrigley Field',
        venue_id: 17,
        teamColor: '#0E3386',
        division: 'NL Central'
    },
    113: {
        name: 'Reds',
        fullName: 'Cincinnati Reds',
        locationName: 'Cincinnati',
        id: 113,
        abbrev: 'CIN',
        venue_name: 'Great American Ball Park',
        venue_id: 2602,
        teamColor: '#EB184B',
        division: 'NL Central'
    },
    114: {
        name: 'Guardians',
        fullName: 'Cleveland Guardians',
        locationName: 'Cleveland',
        id: 114,
        abbrev: 'CLE',
        venue_name: 'Progressive Field',
        venue_id: 5,
        teamColor: '#023465',
        division: 'AL Central'
    },
    115: {
        name: 'Rockies',
        fullName: 'Colorado Rockies',
        locationName: 'Colorado',
        id: 115,
        abbrev: 'COL',
        venue_name: 'Coors Field',
        venue_id: 19,
        teamColor: '#333366',
        division: 'NL West'
    },
    116: {
        name: 'Tigers',
        fullName: 'Detroit Tigers',
        locationName: 'Detroit',
        id: 116,
        abbrev: 'DET',
        venue_name: 'Comerica Park',
        venue_id: 2394,
        teamColor: '#10293F',
        division: 'AL Central'
    },
    117: {
        name: 'Astros',
        fullName: 'Houston Astros',
        locationName: 'Houston',
        id: 117,
        abbrev: 'HOU',
        venue_name: 'Daikin Park',
        venue_id: 2392,
        teamColor: '#F59317',
        division: 'AL West'
    },
    118: {
        name: 'Royals',
        fullName: 'Kansas City Royals',
        locationName: 'Kansas City',
        id: 118,
        abbrev: 'KC',
        venue_name: 'Kauffman Stadium',
        venue_id: 7,
        teamColor: '#000572',
        division: 'AL Central'
    },
    119: {
        name: 'Dodgers',
        fullName: 'Los Angeles Dodgers',
        locationName: 'Los Angeles',
        id: 119,
        abbrev: 'LAD',
        venue_name: 'Dodger Stadium',
        venue_id: 22,
        teamColor: '#005596',
        division: 'NL West'
    },
    120: {
        name: 'Nationals',
        fullName: 'Washington Nationals',
        locationName: 'Washington',
        id: 120,
        abbrev: 'WSH',
        venue_name: 'Nationals Park',
        venue_id: 3309,
        teamColor: '#BA122B',
        division: 'NL East'
    },
    121: {
        name: 'Mets',
        fullName: 'New York Mets',
        locationName: 'New York',
        id: 121,
        abbrev: 'NYM',
        venue_name: 'Citi Field',
        venue_id: 3289,
        teamColor: '#004685',
        division: 'NL East'
    },
    133: {
        name: 'Athletics',
        fullName: 'Athletics',
        locationName: 'Athletics',
        id: 133,
        abbrev: 'ATH',
        venue_name: 'Sutter Health Park',
        venue_id: 2529,
        teamColor: '#00483A',
        division: 'AL West'
    },
    134: {
        name: 'Pirates',
        fullName: 'Pittsburgh Pirates',
        locationName: 'Pittsburgh',
        id: 134,
        abbrev: 'PIT',
        venue_name: 'PNC Park',
        venue_id: 31,
        teamColor: '#FFB40B',
        division: 'NL Central'
    },
    135: {
        name: 'Padres',
        fullName: 'San Diego Padres',
        locationName: 'San Diego',
        id: 135,
        abbrev: 'SD',
        venue_name: 'Petco Park',
        venue_id: 2680,
        teamColor: '#2F241D',
        division: 'NL West'
    },
    136: {
        name: 'Mariners',
        fullName: 'Seattle Mariners',
        locationName: 'Seattle',
        id: 136,
        abbrev: 'SEA',
        venue_name: 'T-Mobile Park',
        venue_id: 680,
        teamColor: '#1C8B85',
        division: 'AL West'
    },
    137: {
        name: 'Giants',
        fullName: 'San Francisco Giants',
        locationName: 'San Francisco',
        id: 137,
        abbrev: 'SF',
        venue_name: 'Oracle Park',
        venue_id: 2395,
        teamColor: '#FB5B1F',
        division: 'NL West'
    },
    138: {
        name: 'Cardinals',
        fullName: 'St. Louis Cardinals',
        locationName: 'St. Louis',
        id: 138,
        abbrev: 'STL',
        venue_name: 'Busch Stadium',
        venue_id: 2889,
        teamColor: '#C41E3A',
        division: 'NL Central'
    },
    139: {
        name: 'Rays',
        fullName: 'Tampa Bay Rays',
        locationName: 'Tampa Bay',
        id: 139,
        abbrev: 'TB',
        venue_name: 'Steinbrenner Field',
        venue_id: 2523,
        teamColor: '#79BDEE',
        division: 'AL East'
    },
    140: {
        name: 'Rangers',
        fullName: 'Texas Rangers',
        locationName: 'Texas',
        id: 140,
        abbrev: 'TEX',
        venue_name: 'Globe Life Field',
        venue_id: 2396,
        teamColor: '#01317B',
        division: 'AL West'
    },
    141: {
        name: 'Blue Jays',
        fullName: 'Toronto Blue Jays',
        locationName: 'Toronto',
        id: 141,
        abbrev: 'TOR',
        venue_name: 'Rogers Centre',
        venue_id: 14,
        teamColor: '#0067A6',
        division: 'AL East'
    },
    142: {
        name: 'Twins',
        fullName: 'Minnesota Twins',
        locationName: 'Minnesota',
        id: 142,
        abbrev: 'MIN',
        venue_name: 'Target Field',
        venue_id: 3312,
        teamColor: '#042462',
        division: 'AL Central'
    },
    143: {
        name: 'Phillies',
        fullName: 'Philadelphia Phillies',
        locationName: 'Philadelphia',
        id: 143,
        abbrev: 'PHI',
        venue_name: 'Citizens Bank Park',
        venue_id: 2681,
        teamColor: '#CA1F2C',
        division: 'NL East'
    },
    144: {
        name: 'Braves',
        fullName: 'Atlanta Braves',
        locationName: 'Atlanta',
        id: 144,
        abbrev: 'ATL',
        venue_name: 'Truist Park',
        venue_id: 4705,
        teamColor: '#01487E',
        division: 'NL East'
    },
    145: {
        name: 'White Sox',
        fullName: 'Chicago White Sox',
        locationName: 'Chicago White',
        id: 145,
        abbrev: 'CWS',
        venue_name: 'Rate Field',
        venue_id: 4,
        teamColor: '#000000',
        division: 'AL Central'
    },
    146: {
        name: 'Marlins',
        fullName: 'Miami Marlins',
        locationName: 'Miami',
        id: 146,
        abbrev: 'MIA',
        venue_name: 'Marlins Park',
        venue_id: 4169,
        teamColor: '#00A3E0',
        division: 'NL East'
    },
    147: {
        name: 'Yankees',
        fullName: 'New York Yankees',
        locationName: 'New York',
        id: 147,
        abbrev: 'NYY',
        venue_name: 'Yankee Stadium',
        venue_id: 3313,
        teamColor: '#132448',
        division: 'AL East'
    },
    158: {
        name: 'Brewers',
        fullName: 'Milwaukee Brewers',
        locationName: 'Milwaukee',
        id: 158,
        abbrev: 'MIL',
        venue_name: 'American Family Field',
        venue_id: 32,
        teamColor: '#C4953B',
        division: 'NL Central'
    }
};
const $4599fed479aad8e8$var$teamMapAbbrev = Object.values($4599fed479aad8e8$var$teamMap).reduce((acc, team)=>{
    acc[team.abbrev] = team;
    return acc;
}, {});
// OLD ABBREVS TO SUPPORT
$4599fed479aad8e8$var$teamMapAbbrev.ARI = $4599fed479aad8e8$var$teamMapAbbrev.AZ;
$4599fed479aad8e8$var$teamMapAbbrev.OAK = $4599fed479aad8e8$var$teamMapAbbrev.ATH;
// This isn't meant to be perfect
function $4599fed479aad8e8$var$findBySearch(name = '') {
    const lowerName = name.toLowerCase();
    const needle = Object.values($4599fed479aad8e8$var$teamMap).find((team)=>team.fullName.toLowerCase().includes(lowerName));
    return needle;
}
function $4599fed479aad8e8$var$abbrToFullName(abbr) {
    if (abbr.length === 0) return '';
    return Object.values($4599fed479aad8e8$var$teamMap).find((team)=>team.abbrev === abbr)?.name || '';
}
function $4599fed479aad8e8$var$idToFullName(id) {
    if (id.length === 0) return '';
    return Object.values($4599fed479aad8e8$var$teamMap).find((team)=>team.id === Number(id))?.name || '';
}
function $4599fed479aad8e8$var$safeHandleTeam(team) {
    // Should allow us to handle both a team ID (our new standard) or the
    // tricode (outdated) properly for querying
    if (Object.keys($4599fed479aad8e8$var$teamMapAbbrev).includes(team)) return $4599fed479aad8e8$var$teamMapAbbrev[team].id;
    if (Object.keys($4599fed479aad8e8$var$teamMap).includes(team)) return team;
    // This may be a terrible idea, but I guess since we had a leaderboard where
    // the team param was the actual name, I suppose I can handle that
    if ($4599fed479aad8e8$var$findBySearch(team)) return $4599fed479aad8e8$var$findBySearch(team).id;
    return 0;
}
function $4599fed479aad8e8$var$safeHandleIllustratorTeam(team) {
    // We need this because the safeHandleTeam expects just an ID value...
    // but the way illustrator stores state, the team praameters are formatted as
    // '["team_id1","team_id2"]' (a string), necessitating surgery
    if (!team || team === '[]') return team;
    try {
        const returnString = JSON.stringify(JSON.parse(team).map((tm)=>$4599fed479aad8e8$var$safeHandleTeam(tm).toString()));
        return returnString;
    } catch (e) {
        return undefined;
    }
}
function $4599fed479aad8e8$var$safeHandleTeamQueryString(query, isIllustrator = false) {
    if (query.team) query.team = $4599fed479aad8e8$var$safeHandleTeam(query.team) || $4599fed479aad8e8$var$findBySearch(query.team)?.id || 0;
    if (isIllustrator) {
        query.homeTeam = $4599fed479aad8e8$var$safeHandleIllustratorTeam(query.homeTeam);
        query.awayTeam = $4599fed479aad8e8$var$safeHandleIllustratorTeam(query.awayTeam);
        query.vsTeam = $4599fed479aad8e8$var$safeHandleIllustratorTeam(query.vsTeam);
    }
    return query;
}
$4599fed479aad8e8$exports = {
    findBySearch: $4599fed479aad8e8$var$findBySearch,
    abbrToFullName: $4599fed479aad8e8$var$abbrToFullName,
    idToFullName: $4599fed479aad8e8$var$idToFullName,
    teamMap: $4599fed479aad8e8$var$teamMap,
    teamMapAbbrev: $4599fed479aad8e8$var$teamMapAbbrev,
    safeHandleTeam: $4599fed479aad8e8$var$safeHandleTeam,
    safeHandleTeamQueryString: $4599fed479aad8e8$var$safeHandleTeamQueryString
};





// eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");

function $8b7368d9d0f8b6cd$var$PlayerSearchSelectedCard(props) {
    const { player: player, uniqueId: uniqueId } = props;
    const [id, year] = uniqueId.split('-');
    const imageSize = 40;
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                x: 0,
                y: 0,
                width: (0, $c30e918aac675a8e$export$3e244b48f79f0cf9),
                height: (0, $c30e918aac675a8e$export$1db8ac72413eadca),
                rx: 5,
                stroke: (0, $c30e918aac675a8e$export$4bdbd8698c928034),
                fill: (0, $c30e918aac675a8e$export$4bdbd8698c928034)
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("image", {
                href: `https://midfield.mlbstatic.com/v1/people/${id}/spots/${imageSize * 3}`,
                height: imageSize,
                width: imageSize,
                x: (0, $c30e918aac675a8e$export$3e244b48f79f0cf9) / 2 - imageSize / 2,
                y: 7
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                className: "player-search-card-text",
                x: (0, $c30e918aac675a8e$export$3e244b48f79f0cf9) / 2,
                y: 52,
                textLength: player.name.split(',')[0].length > 13 ? (0, $c30e918aac675a8e$export$3e244b48f79f0cf9) - 4 : undefined,
                children: player.name.split(',')[0]
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                className: "player-search-card-text player-search-card-year",
                x: (0, $c30e918aac675a8e$export$3e244b48f79f0cf9) / 2,
                y: 67,
                children: year
            })
        ]
    });
}
var $8b7368d9d0f8b6cd$export$2e2bcd8739ae039 = $8b7368d9d0f8b6cd$var$PlayerSearchSelectedCard;



/* eslint-disable import/prefer-default-export */ 
const $29b39cb5b170338a$var$INFIELD_TYPES = [
    3,
    4,
    5,
    6
];
const $29b39cb5b170338a$var$OUTFIELD_TYPES = [
    7,
    8,
    9
];
const $29b39cb5b170338a$var$PITCHER_TYPE = 1;
const $29b39cb5b170338a$var$CATCHER_TYPE = 2;
function $29b39cb5b170338a$var$getDiffYears(allPlayers, firstPlayer) {
    const { currentYear: currentYear } = (0, $d729c943390d67ec$exports.appSettings).SETTINGS_COMPARISON_TOOL;
    const diffYearArr = [];
    const playerDiffYears = allPlayers.filter((player)=>Number(player.id) === Number(firstPlayer.id) && Number(player.year) !== Number(firstPlayer.year) && player.grouping_code === firstPlayer.grouping_code).sort((a, b)=>b.year - a.year);
    if (playerDiffYears.length === 0) return diffYearArr;
    const otherYears = playerDiffYears.map((d)=>d.year);
    const firstYear = Math.min(...otherYears);
    if (firstPlayer.year - firstYear <= 3) return playerDiffYears.slice(-3);
    if (currentYear - firstPlayer.year <= 3) return playerDiffYears.slice(0, 3);
    if (otherYears.includes(currentYear)) {
        const currYear = playerDiffYears.find((d)=>d.year === currentYear);
        if (currYear) diffYearArr.push(currYear);
    }
    if (firstPlayer.year + 1 !== currentYear) {
        const nextYear = playerDiffYears.find((d)=>d.year === firstPlayer.year + 1 && d.year !== currentYear);
        if (nextYear) diffYearArr.push(nextYear);
    } else {
        const twoYears = playerDiffYears.find((d)=>d.year === firstPlayer.year + 2 && d.year !== currentYear);
        if (twoYears) diffYearArr.push(twoYears);
    }
    if (firstPlayer.year - 1 !== currentYear) {
        const nextYear = playerDiffYears.find((d)=>d.year === firstPlayer.year - 1);
        if (nextYear) diffYearArr.push(nextYear);
    } else {
        const twoYears = playerDiffYears.find((d)=>d.year === firstPlayer.year - 2);
        if (twoYears) diffYearArr.push(twoYears);
    }
    return diffYearArr;
}
function $29b39cb5b170338a$var$getTeammates(allPlayers, firstPlayer) {
    if (!firstPlayer.teams || firstPlayer.teams.length === 0) return [];
    const latestTeam = firstPlayer.teams[firstPlayer.teams.length - 1];
    const searchYear = firstPlayer.year;
    const teammates = allPlayers.filter((d)=>{
        const teamArr = d.teams;
        if (!teamArr || teamArr.length === 0) return false;
        return teamArr[teamArr.length - 1] === latestTeam && d.year === searchYear && d.uniqueId !== firstPlayer.uniqueId && d.grouping_code === firstPlayer.grouping_code;
    });
    let filteredTeammates;
    if (Number(firstPlayer.pos) === $29b39cb5b170338a$var$PITCHER_TYPE) filteredTeammates = teammates.filter((player)=>Number(player.pos) === $29b39cb5b170338a$var$PITCHER_TYPE);
    else if (Number(firstPlayer.pos) === $29b39cb5b170338a$var$CATCHER_TYPE) filteredTeammates = teammates.filter((player)=>Number(player.pos) === $29b39cb5b170338a$var$CATCHER_TYPE);
    else if ($29b39cb5b170338a$var$INFIELD_TYPES.includes(Number(firstPlayer.pos))) filteredTeammates = teammates.filter((player)=>$29b39cb5b170338a$var$INFIELD_TYPES.includes(Number(player.pos)));
    else if ($29b39cb5b170338a$var$OUTFIELD_TYPES.includes(Number(firstPlayer.pos))) filteredTeammates = teammates.filter((player)=>$29b39cb5b170338a$var$OUTFIELD_TYPES.includes(Number(player.pos)));
    else filteredTeammates = [];
    return filteredTeammates.sort((a, b)=>Number(b.pos_opps) - Number(a.pos_opps)).slice(0, 4);
}
function $29b39cb5b170338a$var$getPositionMates(allPlayers, firstPlayer) {
    if (!firstPlayer.pos) return [];
    const positionGuys = allPlayers.filter((player)=>player.pos === firstPlayer.pos && player.year === firstPlayer.year && player.uniqueId !== firstPlayer.uniqueId && player.grouping_code === firstPlayer.grouping_code);
    return positionGuys.sort((a, b)=>Number(b.pos_opps) - Number(a.pos_opps)).slice(0, 3);
}
function $29b39cb5b170338a$export$6c18ab58ce1d8a98(allPlayers, firstPlayer) {
    const playerDiffYears = $29b39cb5b170338a$var$getDiffYears(allPlayers, firstPlayer);
    const teammates = $29b39cb5b170338a$var$getTeammates(allPlayers, firstPlayer);
    const positionMates = $29b39cb5b170338a$var$getPositionMates(allPlayers, firstPlayer);
    return [
        ...new Set([
            ...playerDiffYears,
            ...teammates,
            ...positionMates
        ])
    ];
}


const $56a6ed9b655689a9$var$validYears = (0, $d729c943390d67ec$exports.appSettings).SETTINGS_COMPARISON_TOOL.years;
const $56a6ed9b655689a9$var$BIG_PAGE_SIZE = 10;
function $56a6ed9b655689a9$export$2e2bcd8739ae039({ searchRef: searchRef, data: data, preloadedData: preloadedData, trendingBatters: trendingBatters, trendingPitchers: trendingPitchers, onAdd: onAdd }) {
    const { MAX_TOTAL_PLAYERS: MAX_TOTAL_PLAYERS, isMobile: isMobile } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    const PAGE_SIZE = isMobile ? 6 : 7;
    const preloadedPlayers = preloadedData.players;
    const scrollContainerRef = (0, $63Xef.useRef)(null);
    const prevPlayerCount = (0, $63Xef.useRef)(preloadedPlayers.length);
    const [searchFilter, setSearchFilter] = (0, $63Xef.useState)('');
    const [yearFilter, setYearFilter] = (0, $63Xef.useState)(2026);
    const [pageNumber, setPageNumber] = (0, $63Xef.useState)(0);
    const [teamFilter, setTeamFilter] = (0, $63Xef.useState)('0');
    const [posFilter, setPosFilter] = (0, $63Xef.useState)(0);
    const [hoveredPlayer, setHoveredPlayer] = (0, $63Xef.useState)(null);
    const [flashingPlayer, setFlashingPlayer] = (0, $63Xef.useState)(null);
    const [activeTab, setActiveTab] = (0, $63Xef.useState)('trending');
    const [isChronological, setIsChronological] = (0, $63Xef.useState)(false);
    const preloadedPlayerObjs = preloadedPlayers.sort((a, b)=>a.displayOrder - b.displayOrder).map((playerObj)=>{
        const [id, year, type] = playerObj.id.split('-');
        const playerData = data.find((d)=>Number(d.id) === Number(id) && Number(d.year) === Number(year) && d.grouping_cat.toLowerCase() === type);
        const dataObj = preloadedData.dataToUse.find((d)=>d.uniqueId === playerObj.id);
        if (dataObj) playerData.teams = dataObj.teams;
        return {
            playerData: playerData,
            displayOrder: playerObj.displayOrder
        };
    });
    const [selectedPlayers, setSelectedPlayers] = (0, $63Xef.useState)(preloadedPlayerObjs);
    const defaultType = preloadedPlayerObjs.length ? preloadedPlayerObjs[0].playerData.grouping_cat.toLowerCase() : '';
    const [typeFilter, setTypeFilter] = (0, $63Xef.useState)(defaultType);
    (0, $63Xef.useEffect)(()=>{
        if (selectedPlayers.length) setTypeFilter(selectedPlayers[0]?.playerData.grouping_cat.toLowerCase());
    }, [
        selectedPlayers
    ]);
    (0, $63Xef.useEffect)(()=>{
        setSelectedPlayers(preloadedPlayerObjs);
    }, [
        preloadedPlayers
    ]);
    (0, $63Xef.useEffect)(()=>{
        setPageNumber(0);
    }, [
        activeTab
    ]);
    (0, $63Xef.useEffect)(()=>{
        if (selectedPlayers.length > prevPlayerCount.current) {
            if (scrollContainerRef.current) setTimeout(()=>{
                if (scrollContainerRef.current) scrollContainerRef.current.scrollTo({
                    left: scrollContainerRef.current.scrollWidth,
                    behavior: 'smooth'
                });
            }, 10);
        }
        prevPlayerCount.current = selectedPlayers.length;
    }, [
        selectedPlayers.length
    ]);
    (0, $63Xef.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const shouldOpenSearch = urlParams.get('openSearch') === 'true';
        const hasActiveTab = urlParams.get('activeSearchTab');
        if (shouldOpenSearch) {
            if (!hasActiveTab || hasActiveTab === 'suggested') setActiveTab('suggested');
            else if (hasActiveTab === 'all') setActiveTab('all');
            else setActiveTab('trending');
        }
    }, []);
    const handleAddBatchRef = (0, $63Xef.useRef)(handleAddBatch);
    (0, $63Xef.useEffect)(()=>{
        handleAddBatchRef.current = handleAddBatch;
    });
    (0, $63Xef.useEffect)(()=>{
        if (!searchRef.current) return;
        searchRef.current.addEventListener('toggle', (e)=>{
            if (e.newState !== 'closed') return;
            handleAddBatchRef.current();
        });
    }, [
        searchRef
    ]);
    const sensors = (0, $63Xef.useMemo)(()=>[
            (0, $4e1e107797f01458$export$b26af955418d6638).configure({
                activationConstraints: [
                    new (0, $4e1e107797f01458$export$863a6e64d6b9f7f4).Distance({
                        value: 8
                    })
                ]
            })
        ], []);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleDragOver = (event)=>{
        const { operation: operation } = event;
        const { source: source, target: target } = operation;
        if ((0, $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f)(source) && (0, $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f)(target)) {
            const overIndex = target.sortable.index;
            const activeIndex = source.sortable.index;
            if (activeIndex !== overIndex) setSelectedPlayers((prev)=>{
                const currentVisualOrder = [
                    ...prev
                ].sort((a, b)=>a.displayOrder - b.displayOrder);
                const reordered = (0, $d9ca3e6570e7a9a7$export$5d49d615ad5ea2b0)(currentVisualOrder, activeIndex, overIndex);
                return reordered.map((p, i)=>({
                        ...p,
                        displayOrder: i
                    }));
            });
        }
    };
    const similarPlayers = (0, $63Xef.useMemo)(()=>selectedPlayers.length > 0 ? (0, $29b39cb5b170338a$export$6c18ab58ce1d8a98)(data, selectedPlayers[0]?.playerData) : [], [
        data,
        selectedPlayers
    ]);
    const needle = (0, $d797fa0caa0b0f8e$exports.normalizeAccents)(searchFilter);
    const filtered = (0, $63Xef.useMemo)(()=>{
        let baseSlice = [
            ...data
        ];
        if (activeTab === 'trending') {
            baseSlice = typeFilter === 'pitcher' ? [
                ...trendingPitchers
            ] : [
                ...trendingBatters
            ];
            baseSlice = baseSlice.slice(0, -1);
        } else if (activeTab === 'suggested') baseSlice = [
            ...similarPlayers
        ];
        if (activeTab !== 'all') return baseSlice;
        return baseSlice.sort((a, b)=>{
            // Most recent first
            if (a.year !== b.year) return a.year < b.year ? 1 : -1;
            if (a.name.toUpperCase() !== b.name.toUpperCase()) return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1;
            // same name, be consistent
            return Number(a.id) - Number(b.id);
        }).filter((d)=>{
            if (!yearFilter) return true;
            return d.year === yearFilter;
        }).filter((d)=>{
            if (typeFilter === '') return true;
            if (typeFilter === 'pitcher') return d.grouping_cat.toLowerCase() === 'pitcher' && (Number(d.pos) === 1 || d.pos === 'Y' || Number(d.pos) === 10);
            return d.grouping_cat.toLowerCase() === 'batter';
        }).filter((d)=>{
            if (teamFilter === '0') return true;
            return d.teams?.includes(Number(teamFilter));
        }).filter((d)=>{
            if (posFilter === 0) return true;
            return Number(d.pos) === posFilter;
        }).filter((d)=>{
            if (searchFilter === '') return true;
            const haystack = (0, $d797fa0caa0b0f8e$exports.normalizeAccents)(d.name);
            return haystack.includes(needle);
        });
    }, [
        data,
        similarPlayers,
        activeTab,
        yearFilter,
        typeFilter,
        teamFilter,
        searchFilter,
        posFilter,
        needle
    ]);
    const pageSizeToUse = activeTab === 'all' ? PAGE_SIZE : $56a6ed9b655689a9$var$BIG_PAGE_SIZE;
    const sliced = filtered.slice(pageNumber * pageSizeToUse, pageNumber * pageSizeToUse + pageSizeToUse);
    const pages = Math.ceil(filtered.length / pageSizeToUse);
    function randomize() {
        setSelectedPlayers([]);
        const allData = [
            ...data
        ];
        const typeToCompare = typeFilter !== 'pitcher' ? 'batter' : 'pitcher';
        let thisYearData = allData.filter((d)=>Number(d.year) === Number(yearFilter) && d.grouping_cat.toLowerCase() === typeToCompare && Number(d.is_qualified) === 1);
        if (typeToCompare === 'pitcher') thisYearData = thisYearData.filter((d)=>d.pos === '1');
        const numTotalPlayers = thisYearData.length;
        const numRandomPlayers = 6;
        const randomIndices = new Set();
        while(randomIndices.size < numRandomPlayers){
            const randomInt = Math.floor(Math.random() * numTotalPlayers);
            randomIndices.add(randomInt);
        }
        const randomArr = Array.from(randomIndices);
        const randomPlayers = [];
        for(let i = 0; i < numRandomPlayers; i++)randomPlayers.push({
            playerData: thisYearData[randomArr[i]],
            displayOrder: i
        });
        setSelectedPlayers(randomPlayers);
    }
    function handleSelect(d) {
        if (selectedPlayers.map((player)=>player.playerData).includes(d) || selectedPlayers.length === MAX_TOTAL_PLAYERS) return;
        const latestSelect = Math.max(...selectedPlayers.map((player)=>player.displayOrder));
        const newSelects = [
            ...selectedPlayers,
            {
                playerData: d,
                displayOrder: latestSelect + 1
            }
        ];
        setSelectedPlayers(newSelects);
    }
    function handleFilter(type, value) {
        switch(type){
            case 'year':
                setYearFilter(Number(value));
                break;
            case 'type':
                setTypeFilter(String(value));
                break;
            case 'team':
                setTeamFilter(String(value));
                break;
            case 'pos':
                setPosFilter(Number(value));
                break;
            case 'search':
            default:
                setSearchFilter(String(value));
                break;
        }
        setPageNumber(0);
    }
    function handleAddBatch() {
        if (searchRef.current) searchRef.current.hidePopover();
        onAdd(selectedPlayers);
        setYearFilter((0, $d729c943390d67ec$exports.appSettings).SETTINGS_COMPARISON_TOOL.currentYear);
        setPageNumber(0);
    }
    function removePlayer(player) {
        setSelectedPlayers(selectedPlayers.filter((pl)=>pl.playerData !== player));
        setHoveredPlayer(null);
    }
    function handleTeamClick(team) {
        if (teamFilter === team) setTeamFilter('0');
        else setTeamFilter(team);
        setPageNumber(0);
    }
    const prevPage = pageNumber !== 0;
    const nextPage = pageNumber + 1 !== pages;
    const svgWidth = selectedPlayers.length * ((0, $c30e918aac675a8e$export$82a3eb79c2e1839b) + (0, $c30e918aac675a8e$export$3e244b48f79f0cf9)) - (0, $c30e918aac675a8e$export$82a3eb79c2e1839b);
    function getTabStyle(tabName) {
        return {
            fontWeight: activeTab === tabName ? 'bold' : 'normal',
            color: activeTab === tabName ? '#ffffff' : '#aaaaaa',
            backgroundColor: activeTab === tabName ? (0, $c30e918aac675a8e$export$2200862f6453cab4) : 'transparent',
            paddingTop: '3px',
            paddingBottom: '3px'
        };
    }
    function handleToggleSort() {
        const nextChronological = !isChronological;
        setIsChronological(nextChronological);
        setSelectedPlayers((prev)=>{
            const sorted = [
                ...prev
            ].sort((a, b)=>{
                const yearA = Number(a.playerData.year);
                const yearB = Number(b.playerData.year);
                return nextChronological ? yearA - yearB : yearB - yearA;
            });
            return sorted.map((p, i)=>({
                    ...p,
                    displayOrder: i
                }));
        });
    }
    const isSamePlayerMultiSeason = selectedPlayers.length > 1 && selectedPlayers.every((p)=>Number(p.playerData.id) === Number(selectedPlayers[0].playerData.id));
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
        popover: 'auto',
        id: "player-search",
        ref: searchRef,
        className: "comp-tool-popover player-search-popover",
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("style", {
                children: `
                .player-search-popover {
                    flex-direction: column;
                    height: 80vh;
                    max-height: 690px;
                    box-sizing: border-box;
                }

                .player-search-popover:popover-open {
                    display: flex !important;
                }

                ${isMobile ? `
                        .player-search-dropdown-wrapper {
                            flex-wrap: wrap;
                            gap: 0.25rem;
                        }
                        .player-search-dropdown {
                            flex-grow: 1;
                            flex-basis: 30%; 
                        }
                        .player-search-dropdown select {
                            font-size: 12px;
                            padding: 2px 4px;
                            height: 28px;
                        }
                        #team-search-dropdown {
                            margin-bottom: 0.5rem;
                        }
                        #pos-search-dropdown {
                            margin-bottom: 0.5rem;
                        }
                        #year-search-dropdown {
                            margin-bottom: 0.5rem;
                        }
                        #type-search-dropdown {
                            margin-bottom: 0.5rem;
                        }
                    ` : ''}
            `
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    overflowY: 'auto',
                    paddingRight: '4px'
                },
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '0.5rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '2rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("h3", {
                                        style: {
                                            fontSize: isMobile ? '18px' : 'auto',
                                            margin: 0,
                                            whiteSpace: 'nowrap'
                                        },
                                        children: "Select Player(s)"
                                    }),
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("button", {
                                        type: "button",
                                        className: "btn btn-default",
                                        onClick: ()=>{
                                            setSelectedPlayers([]);
                                            setTypeFilter(typeFilter === 'pitcher' ? 'batter' : 'pitcher');
                                            setPageNumber(0);
                                        },
                                        style: {
                                            borderRadius: '4px',
                                            padding: '2px 4px 2px 4px',
                                            fontSize: '12px',
                                            marginTop: '4px',
                                            height: isMobile ? '24px' : 'auto'
                                        },
                                        children: [
                                            "\u21C4 Switch to",
                                            ' ',
                                            typeFilter === 'pitcher' ? 'Batters' : 'Pitchers'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    const popover = document.getElementById('player-search');
                                    if (popover && 'hidePopover' in popover) popover.hidePopover();
                                },
                                className: "modal-close-button",
                                "aria-label": "Close Popover",
                                children: "\xd7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                        className: "player-search-tabs",
                        style: {
                            display: 'flex',
                            marginBottom: '8px',
                            width: '100%',
                            paddingTop: '2px',
                            paddingBottom: '2px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                style: getTabStyle('all'),
                                className: "player-search-tab-button",
                                onClick: ()=>setActiveTab('all'),
                                children: "All Players"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                style: getTabStyle('trending'),
                                className: "player-search-tab-button",
                                onClick: ()=>setActiveTab('trending'),
                                children: "Trending"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                style: getTabStyle('suggested'),
                                className: "player-search-tab-button",
                                onClick: ()=>setActiveTab('suggested'),
                                children: "Suggested"
                            })
                        ]
                    }),
                    activeTab === 'all' ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("input", {
                                    className: "form-control comp-tool-search",
                                    type: "text",
                                    value: searchFilter,
                                    onChange: (e)=>handleFilter('search', e.target.value),
                                    placeholder: "Search by player name"
                                })
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                                className: "form-group player-search-dropdown-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                        className: "savant-select player-search-dropdown",
                                        id: "year-search-dropdown",
                                        "data-title": "Year",
                                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("select", {
                                            id: "ddlYearSearch",
                                            value: yearFilter,
                                            onChange: (e)=>handleFilter('year', Number(e.target.value)),
                                            children: [
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("option", {
                                                    value: 0,
                                                    children: "Any"
                                                }),
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("hr", {}),
                                                $56a6ed9b655689a9$var$validYears.map((year)=>/*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("option", {
                                                        value: Number(year),
                                                        children: year
                                                    }, year))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                        className: "savant-select player-search-dropdown",
                                        id: "type-search-dropdown",
                                        "data-title": "Type",
                                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("select", {
                                            id: "ddlTypeSearch",
                                            value: typeFilter,
                                            onChange: (e)=>handleFilter('type', e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("option", {
                                                    value: "",
                                                    disabled: selectedPlayers.length > 0,
                                                    children: "Any"
                                                }),
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("hr", {}),
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("option", {
                                                    value: "batter",
                                                    disabled: selectedPlayers.length > 0 && selectedPlayers[0]?.playerData.grouping_cat.toLowerCase() === 'pitcher',
                                                    children: "Batter"
                                                }),
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("option", {
                                                    value: "pitcher",
                                                    disabled: selectedPlayers.length > 0 && selectedPlayers[0]?.playerData.grouping_cat.toLowerCase() === 'batter',
                                                    children: "Pitcher"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                        className: "savant-select player-search-dropdown",
                                        id: "team-search-dropdown",
                                        "data-title": "Team",
                                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("select", {
                                            id: "ddlTeamSearch",
                                            value: teamFilter,
                                            onChange: (e)=>handleFilter('team', e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("option", {
                                                    value: "0",
                                                    children: "Any"
                                                }),
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("hr", {}),
                                                Object.entries((0, $4599fed479aad8e8$exports.teamMap)).sort(([, val1], [, val2])=>val1.abbrev < val2.abbrev ? -1 : 1).map(([key, value])=>/*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("option", {
                                                        value: key,
                                                        children: value.abbrev
                                                    }, key))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                        className: "savant-select player-search-dropdown",
                                        id: "pos-search-dropdown",
                                        "data-title": "Pos",
                                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("select", {
                                            id: "ddlPosSearch",
                                            value: posFilter,
                                            onChange: (e)=>handleFilter('pos', e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("option", {
                                                    value: 0,
                                                    children: "Any"
                                                }),
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("hr", {}),
                                                Object.keys((0, $c30e918aac675a8e$export$541a2ce73b441465)).sort((val1, val2)=>Number(val1) < Number(val2) ? -1 : 1).map((key)=>/*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("option", {
                                                        value: Number(key),
                                                        disabled: selectedPlayers[0]?.playerData.grouping_cat.toLowerCase() === 'batter' && Number(key) === 1 || selectedPlayers[0]?.playerData.grouping_cat.toLowerCase() === 'pitcher' && Number(key) !== 1,
                                                        children: (0, $c30e918aac675a8e$export$541a2ce73b441465)[Number(key)]
                                                    }, key))
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : '',
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                        children: sliced.map((d)=>{
                            const imageSize = 30;
                            const uniqueId = (0, $3bbd855fb8f896f2$export$aa1a1894961eafab)(d);
                            const isSelected = selectedPlayers.some((p)=>(0, $3bbd855fb8f896f2$export$aa1a1894961eafab)(p.playerData) === uniqueId);
                            const isMaxedOut = selectedPlayers.length >= MAX_TOTAL_PLAYERS;
                            const isFlashing = flashingPlayer === uniqueId;
                            let bgColor = 'white';
                            if (isFlashing) bgColor = 'rgba(57, 144, 152, 0.4)' // A Savant-green flash
                            ;
                            else if (isSelected) bgColor = '#e6e6e6' // Shaded grey for already selected
                            ;
                            return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                                className: "player-search-element",
                                style: {
                                    background: bgColor,
                                    cursor: isSelected || isMaxedOut ? 'default' : 'pointer',
                                    opacity: isSelected ? 0.5 : 1
                                },
                                onClick: ()=>{
                                    if (isSelected) {
                                        removePlayer(d);
                                        return;
                                    }
                                    if (isMaxedOut) return;
                                    setFlashingPlayer(uniqueId);
                                    setTimeout(()=>setFlashingPlayer(null), 150);
                                    handleSelect(d);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("img", {
                                        alt: d.name,
                                        src: `https://midfield.mlbstatic.com/v1/people/${d.id}/spots/${imageSize * 3}`,
                                        height: imageSize * 1,
                                        width: imageSize * 1
                                    }),
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                        className: "player-search-element-name",
                                        children: d.name
                                    }),
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                        className: "player-search-element-teams",
                                        children: d.teams?.map((team)=>/*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                                className: "player-search-element-team",
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    handleTeamClick(String(team));
                                                },
                                                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("img", {
                                                    alt: String(team),
                                                    src: `https://www.mlbstatic.com/team-logos/${team}.svg`,
                                                    width: 12,
                                                    height: 12
                                                }, team)
                                            }, team))
                                    }),
                                    d.pos ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                        className: "player-search-element-pos",
                                        children: (0, $3bbd855fb8f896f2$export$1ebd64b07433c46)(d.id, d.pos, d.grouping_cat)
                                    }) : /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                        className: "player-search-element-pos",
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                        className: "player-search-element-year",
                                        children: d.year
                                    }),
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                        className: "player-search-grouping-category",
                                        children: d.grouping_cat
                                    })
                                ]
                            }, uniqueId);
                        })
                    }),
                    activeTab === 'all' ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                        style: {
                            textAlign: 'center',
                            margin: '0.7rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setPageNumber(0),
                                disabled: !prevPage,
                                style: {
                                    cursor: prevPage ? 'pointer' : 'not-allowed'
                                },
                                children: '<<'
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setPageNumber(pageNumber - 1),
                                disabled: !prevPage,
                                style: {
                                    cursor: prevPage ? 'pointer' : 'not-allowed'
                                },
                                children: "\u2190"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("span", {
                                style: {
                                    display: 'inline-block',
                                    margin: '0 1rem'
                                },
                                children: [
                                    "Page ",
                                    pageNumber + 1
                                ]
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setPageNumber(pageNumber + 1),
                                disabled: !nextPage,
                                style: {
                                    cursor: nextPage ? 'pointer' : 'not-allowed'
                                },
                                children: "\u2192"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setPageNumber(pages - 1),
                                disabled: !nextPage,
                                style: {
                                    cursor: nextPage ? 'pointer' : 'not-allowed'
                                },
                                children: '>>'
                            })
                        ]
                    }) : '',
                    activeTab === 'trending' && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                        style: {
                            textAlign: 'center',
                            margin: '0.7rem'
                        },
                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn-default",
                            onClick: randomize,
                            style: {
                                padding: '5px'
                            },
                            children: "Select Random Players!"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                style: {
                    flexShrink: 0,
                    backgroundColor: 'inherit'
                },
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("hr", {
                        style: {
                            margin: '0.7rem',
                            borderTop: '1px solid #555555'
                        }
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            marginBottom: '8px',
                            paddingLeft: '0.7rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("h5", {
                                style: {
                                    fontSize: '16px',
                                    margin: 0
                                },
                                children: "Selected Player(s)"
                            }),
                            isSamePlayerMultiSeason && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("button", {
                                type: "button",
                                className: "btn btn-default",
                                style: {
                                    padding: '2px 6px',
                                    fontSize: '12px'
                                },
                                onClick: handleToggleSort,
                                children: [
                                    "Sort",
                                    ' ',
                                    isChronological ? 'Backwards' : 'Chronologically'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                        ref: scrollContainerRef,
                        className: "player-search-staging-box",
                        style: {
                            height: `${(0, $c30e918aac675a8e$export$e48da51a507cf709)}px`
                        },
                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $7d57415ac2032ee5$export$a6431530a8ce8288), {
                            sensors: sensors,
                            onDragOver: handleDragOver,
                            modifiers: [
                                (0, $b2d051ff65b2716c$export$35828f5146a69550)
                            ],
                            plugins: (defaults)=>defaults.filter((plugin)=>plugin !== (0, $4e1e107797f01458$export$305ce2ba97930a0b)),
                            children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("svg", {
                                style: {
                                    width: `${svgWidth}px`,
                                    height: '100%'
                                },
                                children: selectedPlayers.sort((a, b)=>a.displayOrder - b.displayOrder).map((player, i)=>{
                                    const uniqueId = (0, $3bbd855fb8f896f2$export$aa1a1894961eafab)(player.playerData);
                                    const xVal = i * ((0, $c30e918aac675a8e$export$82a3eb79c2e1839b) + (0, $c30e918aac675a8e$export$3e244b48f79f0cf9));
                                    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $2f9510a59088c740$export$2e2bcd8739ae039), {
                                        id: uniqueId,
                                        index: i,
                                        offset: xVal,
                                        type: "player-modal",
                                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                            onMouseEnter: ()=>setHoveredPlayer(uniqueId),
                                            onMouseLeave: ()=>setHoveredPlayer(null),
                                            children: [
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $8b7368d9d0f8b6cd$export$2e2bcd8739ae039), {
                                                    player: player.playerData,
                                                    uniqueId: uniqueId
                                                }),
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                                    transform: `translate(${(0, $c30e918aac675a8e$export$3e244b48f79f0cf9) - 19}, 2)`,
                                                    onPointerDown: (e)=>e.stopPropagation(),
                                                    onMouseDown: (e)=>e.stopPropagation(),
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        removePlayer(player.playerData);
                                                    },
                                                    className: "remove-button-x-elem",
                                                    style: {
                                                        opacity: hoveredPlayer === uniqueId ? 1 : 0,
                                                        pointerEvents: hoveredPlayer === uniqueId ? 'auto' : 'none'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("circle", {
                                                            cx: 9,
                                                            cy: 9,
                                                            r: 9,
                                                            fill: (0, $c30e918aac675a8e$export$2200862f6453cab4),
                                                            stroke: (0, $c30e918aac675a8e$export$2200862f6453cab4)
                                                        }),
                                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                                                            x: 9,
                                                            y: 13,
                                                            textAnchor: "middle",
                                                            fontSize: "12",
                                                            fontWeight: "bold",
                                                            fill: "white",
                                                            pointerEvents: "none",
                                                            children: "\u2716"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, uniqueId);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                        className: "player-search-button-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                id: "btn-add-players",
                                className: "btn btn-default",
                                style: {
                                    padding: '5px',
                                    marginRight: '0.5rem'
                                },
                                onClick: ()=>setSelectedPlayers([]),
                                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("span", {
                                    style: {
                                        fontSize: '13px'
                                    },
                                    children: "Clear Players"
                                })
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                id: "btn-add-players",
                                className: "btn btn-default",
                                style: {
                                    padding: '5px'
                                },
                                onClick: ()=>handleAddBatch(),
                                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("span", {
                                    style: {
                                        fontSize: '13px'
                                    },
                                    children: "Compare These Players!"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable import/no-extraneous-dependencies */ 

var $63Xef = parcelRequire("63Xef");



parcelRequire("63Xef");
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 
parcelRequire("63Xef");
var $12ed0c91dd1ed4e8$exports = {};
// @ts-check
var $0f5b164ab16c4920$export$a8ff84c12d48cfa6 = "d3";
var $0f5b164ab16c4920$export$83d89fbfd8236492 = "6.7.0";
var $0f5b164ab16c4920$export$6d59db4903f20f7d = "Data-Driven Documents";
var $0f5b164ab16c4920$export$eebaaf2b24d91f63 = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var $0f5b164ab16c4920$export$4cec2234a9c7ce6d = "https://d3js.org";
var $0f5b164ab16c4920$export$7ff87ebdb8ccbf20 = "BSD-3-Clause";
var $0f5b164ab16c4920$export$571b02044ddb2ab3 = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var $0f5b164ab16c4920$export$f22da7240b7add18 = "dist/d3.node.js";
var $0f5b164ab16c4920$export$101358e655b23e68 = "dist/d3.min.js";
var $0f5b164ab16c4920$export$a2877c4988dda7ec = "dist/d3.min.js";
var $0f5b164ab16c4920$export$130be424786e852f = "index.js";
var $0f5b164ab16c4920$export$69a68d0c8baaec49 = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var $0f5b164ab16c4920$export$3a444357c5f65f65 = [
    "dist/**/*.js",
    "index.js"
];
var $0f5b164ab16c4920$export$e0fef70db1fd3806 = {
    "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "yarn test",
    "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v${npm_package_version%%.*}.js && cp ../d3/dist/d3.min.js d3.v${npm_package_version%%.*}.min.js && git add d3.v${npm_package_version%%.*}.js d3.v${npm_package_version%%.*}.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"
};
var $0f5b164ab16c4920$export$6dbeb9fdb5a4bbaa = {
    "json2module": "0.0",
    "rimraf": "3",
    "rollup": "2",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "5",
    "rollup-plugin-terser": "7",
    "tape": "4",
    "tape-await": "0.1"
};
var $0f5b164ab16c4920$export$b74ff737e0e298b5 = {
    "d3-array": "2",
    "d3-axis": "2",
    "d3-brush": "2",
    "d3-chord": "2",
    "d3-color": "2",
    "d3-contour": "2",
    "d3-delaunay": "5",
    "d3-dispatch": "2",
    "d3-drag": "2",
    "d3-dsv": "2",
    "d3-ease": "2",
    "d3-fetch": "2",
    "d3-force": "2",
    "d3-format": "2",
    "d3-geo": "2",
    "d3-hierarchy": "2",
    "d3-interpolate": "2",
    "d3-path": "2",
    "d3-polygon": "2",
    "d3-quadtree": "2",
    "d3-random": "2",
    "d3-scale": "3",
    "d3-scale-chromatic": "2",
    "d3-selection": "2",
    "d3-shape": "2",
    "d3-time": "2",
    "d3-time-format": "3",
    "d3-timer": "2",
    "d3-transition": "2",
    "d3-zoom": "2"
};




var $202926d84f9eb26c$var$noop = {
    value: ()=>{}
};
function $202926d84f9eb26c$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $202926d84f9eb26c$var$Dispatch(_);
}
function $202926d84f9eb26c$var$Dispatch(_) {
    this._ = _;
}
function $202926d84f9eb26c$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$202926d84f9eb26c$var$Dispatch.prototype = $202926d84f9eb26c$var$dispatch.prototype = {
    constructor: $202926d84f9eb26c$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $202926d84f9eb26c$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $202926d84f9eb26c$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $202926d84f9eb26c$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $202926d84f9eb26c$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $202926d84f9eb26c$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $202926d84f9eb26c$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $202926d84f9eb26c$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $202926d84f9eb26c$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $202926d84f9eb26c$export$2e2bcd8739ae039 = $202926d84f9eb26c$var$dispatch;



function $1eb11220c0df6fba$var$none() {}
function $1eb11220c0df6fba$export$2e2bcd8739ae039(selector) {
    return selector == null ? $1eb11220c0df6fba$var$none : function() {
        return this.querySelector(selector);
    };
}


function $c4869a60ffcedcc8$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $1eb11220c0df6fba$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $37c8fa7d5de8e53a$export$52baac22726c72bf)(subgroups, this._parents);
}



function $e0e59aa4c770e5f3$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}


function $35296398f5f08b14$var$empty() {
    return [];
}
function $35296398f5f08b14$export$2e2bcd8739ae039(selector) {
    return selector == null ? $35296398f5f08b14$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $1859921b5009b8a8$var$arrayAll(select) {
    return function() {
        var group = select.apply(this, arguments);
        return group == null ? [] : (0, $e0e59aa4c770e5f3$export$2e2bcd8739ae039)(group);
    };
}
function $1859921b5009b8a8$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $1859921b5009b8a8$var$arrayAll(select);
    else select = (0, $35296398f5f08b14$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $37c8fa7d5de8e53a$export$52baac22726c72bf)(subgroups, parents);
}


function $2c974644544610bf$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $2c974644544610bf$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $9e865efb2db100ca$var$find = Array.prototype.find;
function $9e865efb2db100ca$var$childFind(match) {
    return function() {
        return $9e865efb2db100ca$var$find.call(this.children, match);
    };
}
function $9e865efb2db100ca$var$childFirst() {
    return this.firstElementChild;
}
function $9e865efb2db100ca$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $9e865efb2db100ca$var$childFirst : $9e865efb2db100ca$var$childFind(typeof match === "function" ? match : (0, $2c974644544610bf$export$90c2759c036528)(match)));
}



var $3abfe3b3bab936a2$var$filter = Array.prototype.filter;
function $3abfe3b3bab936a2$var$children() {
    return this.children;
}
function $3abfe3b3bab936a2$var$childrenFilter(match) {
    return function() {
        return $3abfe3b3bab936a2$var$filter.call(this.children, match);
    };
}
function $3abfe3b3bab936a2$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $3abfe3b3bab936a2$var$children : $3abfe3b3bab936a2$var$childrenFilter(typeof match === "function" ? match : (0, $2c974644544610bf$export$90c2759c036528)(match)));
}




function $dd8de9327f9b4bee$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $2c974644544610bf$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $37c8fa7d5de8e53a$export$52baac22726c72bf)(subgroups, this._parents);
}



function $d2dd1e4699e2bab8$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $a660ba455f4c25d9$export$2e2bcd8739ae039() {
    return new (0, $37c8fa7d5de8e53a$export$52baac22726c72bf)(this._enter || this._groups.map((0, $d2dd1e4699e2bab8$export$2e2bcd8739ae039)), this._parents);
}
function $a660ba455f4c25d9$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$a660ba455f4c25d9$export$67b01759a14cf6a4.prototype = {
    constructor: $a660ba455f4c25d9$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};



function $cb1d61e5b917df77$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $6ce699ef026be5ba$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $a660ba455f4c25d9$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $6ce699ef026be5ba$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $a660ba455f4c25d9$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $6ce699ef026be5ba$var$datum(node) {
    return node.__data__;
}
function $6ce699ef026be5ba$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $6ce699ef026be5ba$var$datum);
    var bind = key ? $6ce699ef026be5ba$var$bindKey : $6ce699ef026be5ba$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $cb1d61e5b917df77$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = (0, $e0e59aa4c770e5f3$export$2e2bcd8739ae039)(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $37c8fa7d5de8e53a$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}





function $e37d429e6ee20412$export$2e2bcd8739ae039() {
    return new (0, $37c8fa7d5de8e53a$export$52baac22726c72bf)(this._exit || this._groups.map((0, $d2dd1e4699e2bab8$export$2e2bcd8739ae039)), this._parents);
}


function $4a0a638312565382$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $fce4f54fc901af6e$export$2e2bcd8739ae039(selection) {
    if (!(selection instanceof (0, $37c8fa7d5de8e53a$export$52baac22726c72bf))) throw new Error("invalid merge");
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $37c8fa7d5de8e53a$export$52baac22726c72bf)(merges, this._parents);
}


function $2b40acab8a6e5339$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $8c2baeed5e8519df$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $8c2baeed5e8519df$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $37c8fa7d5de8e53a$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $8c2baeed5e8519df$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $3cbe2bb0fbfbc492$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $2402e8d45219fe31$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $cb24931c2e13001d$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $fb5c990f621cbc31$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $b6e539c56aac262b$export$2e2bcd8739ae039() {
    return !this.node();
}


function $c72c25cfd594e701$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $5d836c69637356d2$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $5d836c69637356d2$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $5d836c69637356d2$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $05db7c66aecd909a$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $5d836c69637356d2$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $5d836c69637356d2$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $ced583e5a728fccf$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $ced583e5a728fccf$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $ced583e5a728fccf$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $ced583e5a728fccf$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $ced583e5a728fccf$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $ced583e5a728fccf$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $ced583e5a728fccf$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $05db7c66aecd909a$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $ced583e5a728fccf$var$attrRemoveNS : $ced583e5a728fccf$var$attrRemove : typeof value === "function" ? fullname.local ? $ced583e5a728fccf$var$attrFunctionNS : $ced583e5a728fccf$var$attrFunction : fullname.local ? $ced583e5a728fccf$var$attrConstantNS : $ced583e5a728fccf$var$attrConstant)(fullname, value));
}


function $4fb50d4df15a5dbd$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $b9b7e2f0730f1bd4$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $b9b7e2f0730f1bd4$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $b9b7e2f0730f1bd4$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $b9b7e2f0730f1bd4$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $b9b7e2f0730f1bd4$var$styleRemove : typeof value === "function" ? $b9b7e2f0730f1bd4$var$styleFunction : $b9b7e2f0730f1bd4$var$styleConstant)(name, value, priority == null ? "" : priority)) : $b9b7e2f0730f1bd4$export$5e3cec964f0b5efd(this.node(), name);
}
function $b9b7e2f0730f1bd4$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $4fb50d4df15a5dbd$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $75f5f28dc7285710$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $75f5f28dc7285710$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $75f5f28dc7285710$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $75f5f28dc7285710$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $75f5f28dc7285710$var$propertyRemove : typeof value === "function" ? $75f5f28dc7285710$var$propertyFunction : $75f5f28dc7285710$var$propertyConstant)(name, value)) : this.node()[name];
}


function $f2d29f7fce70ee8a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $f2d29f7fce70ee8a$var$classList(node) {
    return node.classList || new $f2d29f7fce70ee8a$var$ClassList(node);
}
function $f2d29f7fce70ee8a$var$ClassList(node) {
    this._node = node;
    this._names = $f2d29f7fce70ee8a$var$classArray(node.getAttribute("class") || "");
}
$f2d29f7fce70ee8a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $f2d29f7fce70ee8a$var$classedAdd(node, names) {
    var list = $f2d29f7fce70ee8a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $f2d29f7fce70ee8a$var$classedRemove(node, names) {
    var list = $f2d29f7fce70ee8a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $f2d29f7fce70ee8a$var$classedTrue(names) {
    return function() {
        $f2d29f7fce70ee8a$var$classedAdd(this, names);
    };
}
function $f2d29f7fce70ee8a$var$classedFalse(names) {
    return function() {
        $f2d29f7fce70ee8a$var$classedRemove(this, names);
    };
}
function $f2d29f7fce70ee8a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $f2d29f7fce70ee8a$var$classedAdd : $f2d29f7fce70ee8a$var$classedRemove)(this, names);
    };
}
function $f2d29f7fce70ee8a$export$2e2bcd8739ae039(name, value) {
    var names = $f2d29f7fce70ee8a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $f2d29f7fce70ee8a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $f2d29f7fce70ee8a$var$classedFunction : value ? $f2d29f7fce70ee8a$var$classedTrue : $f2d29f7fce70ee8a$var$classedFalse)(names, value));
}


function $124e12be4e036f2d$var$textRemove() {
    this.textContent = "";
}
function $124e12be4e036f2d$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $124e12be4e036f2d$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $124e12be4e036f2d$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $124e12be4e036f2d$var$textRemove : (typeof value === "function" ? $124e12be4e036f2d$var$textFunction : $124e12be4e036f2d$var$textConstant)(value)) : this.node().textContent;
}


function $528897a0215e3bc7$var$htmlRemove() {
    this.innerHTML = "";
}
function $528897a0215e3bc7$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $528897a0215e3bc7$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $528897a0215e3bc7$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $528897a0215e3bc7$var$htmlRemove : (typeof value === "function" ? $528897a0215e3bc7$var$htmlFunction : $528897a0215e3bc7$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $f3e42992a2a034a4$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $f3e42992a2a034a4$export$2e2bcd8739ae039() {
    return this.each($f3e42992a2a034a4$var$raise);
}


function $3a8eb643c39635f8$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $3a8eb643c39635f8$export$2e2bcd8739ae039() {
    return this.each($3a8eb643c39635f8$var$lower);
}




function $34fb713b367a11f3$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $5d836c69637356d2$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $5d836c69637356d2$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $34fb713b367a11f3$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $34fb713b367a11f3$export$2e2bcd8739ae039(name) {
    var fullname = (0, $05db7c66aecd909a$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $34fb713b367a11f3$var$creatorFixed : $34fb713b367a11f3$var$creatorInherit)(fullname);
}


function $77627e894347281e$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $34fb713b367a11f3$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $9f782bbe06836b26$var$constantNull() {
    return null;
}
function $9f782bbe06836b26$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $34fb713b367a11f3$export$2e2bcd8739ae039)(name), select = before == null ? $9f782bbe06836b26$var$constantNull : typeof before === "function" ? before : (0, $1eb11220c0df6fba$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $a5884629119a54d6$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $a5884629119a54d6$export$2e2bcd8739ae039() {
    return this.each($a5884629119a54d6$var$remove);
}


function $1c7472d506ae9d40$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $1c7472d506ae9d40$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $1c7472d506ae9d40$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $1c7472d506ae9d40$var$selection_cloneDeep : $1c7472d506ae9d40$var$selection_cloneShallow);
}


function $7c8e1a318d26686d$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $3d2e0bafdbc91f83$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $3d2e0bafdbc91f83$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $3d2e0bafdbc91f83$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $3d2e0bafdbc91f83$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $3d2e0bafdbc91f83$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $3d2e0bafdbc91f83$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $3d2e0bafdbc91f83$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $3d2e0bafdbc91f83$var$onAdd : $3d2e0bafdbc91f83$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $3005993bf96415b3$var$dispatchEvent(node, type, params) {
    var window = (0, $4fb50d4df15a5dbd$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $3005993bf96415b3$var$dispatchConstant(type, params) {
    return function() {
        return $3005993bf96415b3$var$dispatchEvent(this, type, params);
    };
}
function $3005993bf96415b3$var$dispatchFunction(type, params) {
    return function() {
        return $3005993bf96415b3$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $3005993bf96415b3$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $3005993bf96415b3$var$dispatchFunction : $3005993bf96415b3$var$dispatchConstant)(type, params));
}


function* $dbcc3e94759a2b80$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $37c8fa7d5de8e53a$export$e8e78c978b129247 = [
    null
];
function $37c8fa7d5de8e53a$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $37c8fa7d5de8e53a$var$selection() {
    return new $37c8fa7d5de8e53a$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $37c8fa7d5de8e53a$export$e8e78c978b129247);
}
function $37c8fa7d5de8e53a$var$selection_selection() {
    return this;
}
$37c8fa7d5de8e53a$export$52baac22726c72bf.prototype = $37c8fa7d5de8e53a$var$selection.prototype = {
    constructor: $37c8fa7d5de8e53a$export$52baac22726c72bf,
    select: (0, $c4869a60ffcedcc8$export$2e2bcd8739ae039),
    selectAll: (0, $1859921b5009b8a8$export$2e2bcd8739ae039),
    selectChild: (0, $9e865efb2db100ca$export$2e2bcd8739ae039),
    selectChildren: (0, $3abfe3b3bab936a2$export$2e2bcd8739ae039),
    filter: (0, $dd8de9327f9b4bee$export$2e2bcd8739ae039),
    data: (0, $6ce699ef026be5ba$export$2e2bcd8739ae039),
    enter: (0, $a660ba455f4c25d9$export$2e2bcd8739ae039),
    exit: (0, $e37d429e6ee20412$export$2e2bcd8739ae039),
    join: (0, $4a0a638312565382$export$2e2bcd8739ae039),
    merge: (0, $fce4f54fc901af6e$export$2e2bcd8739ae039),
    selection: $37c8fa7d5de8e53a$var$selection_selection,
    order: (0, $2b40acab8a6e5339$export$2e2bcd8739ae039),
    sort: (0, $8c2baeed5e8519df$export$2e2bcd8739ae039),
    call: (0, $3cbe2bb0fbfbc492$export$2e2bcd8739ae039),
    nodes: (0, $2402e8d45219fe31$export$2e2bcd8739ae039),
    node: (0, $cb24931c2e13001d$export$2e2bcd8739ae039),
    size: (0, $fb5c990f621cbc31$export$2e2bcd8739ae039),
    empty: (0, $b6e539c56aac262b$export$2e2bcd8739ae039),
    each: (0, $c72c25cfd594e701$export$2e2bcd8739ae039),
    attr: (0, $ced583e5a728fccf$export$2e2bcd8739ae039),
    style: (0, $b9b7e2f0730f1bd4$export$2e2bcd8739ae039),
    property: (0, $75f5f28dc7285710$export$2e2bcd8739ae039),
    classed: (0, $f2d29f7fce70ee8a$export$2e2bcd8739ae039),
    text: (0, $124e12be4e036f2d$export$2e2bcd8739ae039),
    html: (0, $528897a0215e3bc7$export$2e2bcd8739ae039),
    raise: (0, $f3e42992a2a034a4$export$2e2bcd8739ae039),
    lower: (0, $3a8eb643c39635f8$export$2e2bcd8739ae039),
    append: (0, $77627e894347281e$export$2e2bcd8739ae039),
    insert: (0, $9f782bbe06836b26$export$2e2bcd8739ae039),
    remove: (0, $a5884629119a54d6$export$2e2bcd8739ae039),
    clone: (0, $1c7472d506ae9d40$export$2e2bcd8739ae039),
    datum: (0, $7c8e1a318d26686d$export$2e2bcd8739ae039),
    on: (0, $3d2e0bafdbc91f83$export$2e2bcd8739ae039),
    dispatch: (0, $3005993bf96415b3$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $dbcc3e94759a2b80$export$2e2bcd8739ae039)
};
var $37c8fa7d5de8e53a$export$2e2bcd8739ae039 = $37c8fa7d5de8e53a$var$selection;


function $90191c63f6c0937e$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $37c8fa7d5de8e53a$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $37c8fa7d5de8e53a$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $37c8fa7d5de8e53a$export$e8e78c978b129247));
}


function $6851f954aa290e90$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $6851f954aa290e90$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $0b8040ae2b576907$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $6851f954aa290e90$export$2e2bcd8739ae039), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $6851f954aa290e90$export$2e2bcd8739ae039), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $0b8040ae2b576907$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $6851f954aa290e90$export$2e2bcd8739ae039), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $bxlao = parcelRequire("bxlao");

var $bxlao = parcelRequire("bxlao");
function $04d865e42d90ee8a$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $04d865e42d90ee8a$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $04d865e42d90ee8a$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $5f9f93c773f83a3b$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $04d865e42d90ee8a$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $72330e37709385c9$export$2e2bcd8739ae039 = (x)=>()=>x;


function $77138572fdc11224$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $77138572fdc11224$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $77138572fdc11224$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $77138572fdc11224$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $72330e37709385c9$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $77138572fdc11224$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $77138572fdc11224$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $77138572fdc11224$var$exponential(a, b, y) : (0, $72330e37709385c9$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $77138572fdc11224$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $77138572fdc11224$var$linear(a, d) : (0, $72330e37709385c9$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $4125a1f7550a0949$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $77138572fdc11224$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bxlao.rgb)(start)).r, (end = (0, $bxlao.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $77138572fdc11224$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $4125a1f7550a0949$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bxlao.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $4125a1f7550a0949$export$2c0e28f2e2852d3f = $4125a1f7550a0949$var$rgbSpline((0, $04d865e42d90ee8a$export$2e2bcd8739ae039));
var $4125a1f7550a0949$export$53d5214f625ccd4c = $4125a1f7550a0949$var$rgbSpline((0, $5f9f93c773f83a3b$export$2e2bcd8739ae039));



function $254532d7e68385b0$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $254532d7e68385b0$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $5f2bde7a416918d7$export$2e2bcd8739ae039(a, b) {
    return ((0, $254532d7e68385b0$export$5cd576d1827d40c8)(b) ? (0, $254532d7e68385b0$export$2e2bcd8739ae039) : $5f2bde7a416918d7$export$15d09067c6a5ee49)(a, b);
}
function $5f2bde7a416918d7$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $385a14c856d32e86$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $26c7d274b1004e2c$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $bd7205726919eb40$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $a2ef4130a24d9f4b$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $385a14c856d32e86$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $ce25afa52e53938c$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $ce25afa52e53938c$var$reB = new RegExp($ce25afa52e53938c$var$reA.source, "g");
function $ce25afa52e53938c$var$zero(b) {
    return function() {
        return b;
    };
}
function $ce25afa52e53938c$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $ce25afa52e53938c$export$2e2bcd8739ae039(a, b) {
    var bi = $ce25afa52e53938c$var$reA.lastIndex = $ce25afa52e53938c$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $ce25afa52e53938c$var$reA.exec(a)) && (bm = $ce25afa52e53938c$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $bd7205726919eb40$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $ce25afa52e53938c$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $ce25afa52e53938c$var$one(q[0].x) : $ce25afa52e53938c$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $385a14c856d32e86$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $72330e37709385c9$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $bd7205726919eb40$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $bxlao.default)(b)) ? (b = c, $4125a1f7550a0949$export$2e2bcd8739ae039) : (0, $ce25afa52e53938c$export$2e2bcd8739ae039) : b instanceof (0, $bxlao.default) ? (0, $4125a1f7550a0949$export$2e2bcd8739ae039) : b instanceof Date ? (0, $26c7d274b1004e2c$export$2e2bcd8739ae039) : (0, $254532d7e68385b0$export$5cd576d1827d40c8)(b) ? (0, $254532d7e68385b0$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $5f2bde7a416918d7$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $a2ef4130a24d9f4b$export$2e2bcd8739ae039) : (0, $bd7205726919eb40$export$2e2bcd8739ae039))(a, b);
}


function $d0c90f2f1cfd0eb2$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $1f5822687e66fdad$export$2e2bcd8739ae039(event, node) {
    event = (0, $d0c90f2f1cfd0eb2$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $ed6282f03875f8f7$var$frame = 0, $ed6282f03875f8f7$var$timeout = 0, $ed6282f03875f8f7$var$interval = 0, $ed6282f03875f8f7$var$pokeDelay = 1000, $ed6282f03875f8f7$var$taskHead, $ed6282f03875f8f7$var$taskTail, $ed6282f03875f8f7$var$clockLast = 0, $ed6282f03875f8f7$var$clockNow = 0, $ed6282f03875f8f7$var$clockSkew = 0, $ed6282f03875f8f7$var$clock = typeof performance === "object" && performance.now ? performance : Date, $ed6282f03875f8f7$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $ed6282f03875f8f7$export$461939dd4422153() {
    return $ed6282f03875f8f7$var$clockNow || ($ed6282f03875f8f7$var$setFrame($ed6282f03875f8f7$var$clearNow), $ed6282f03875f8f7$var$clockNow = $ed6282f03875f8f7$var$clock.now() + $ed6282f03875f8f7$var$clockSkew);
}
function $ed6282f03875f8f7$var$clearNow() {
    $ed6282f03875f8f7$var$clockNow = 0;
}
function $ed6282f03875f8f7$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$ed6282f03875f8f7$export$c57e9b2d8b9e4de.prototype = $ed6282f03875f8f7$export$9dc4ecf953986f04.prototype = {
    constructor: $ed6282f03875f8f7$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $ed6282f03875f8f7$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $ed6282f03875f8f7$var$taskTail !== this) {
            if ($ed6282f03875f8f7$var$taskTail) $ed6282f03875f8f7$var$taskTail._next = this;
            else $ed6282f03875f8f7$var$taskHead = this;
            $ed6282f03875f8f7$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $ed6282f03875f8f7$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $ed6282f03875f8f7$var$sleep();
        }
    }
};
function $ed6282f03875f8f7$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $ed6282f03875f8f7$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $ed6282f03875f8f7$export$d60154c1d7f3990e() {
    $ed6282f03875f8f7$export$461939dd4422153(); // Get the current time, if not already set.
    ++$ed6282f03875f8f7$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $ed6282f03875f8f7$var$taskHead, e;
    while(t){
        if ((e = $ed6282f03875f8f7$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$ed6282f03875f8f7$var$frame;
}
function $ed6282f03875f8f7$var$wake() {
    $ed6282f03875f8f7$var$clockNow = ($ed6282f03875f8f7$var$clockLast = $ed6282f03875f8f7$var$clock.now()) + $ed6282f03875f8f7$var$clockSkew;
    $ed6282f03875f8f7$var$frame = $ed6282f03875f8f7$var$timeout = 0;
    try {
        $ed6282f03875f8f7$export$d60154c1d7f3990e();
    } finally{
        $ed6282f03875f8f7$var$frame = 0;
        $ed6282f03875f8f7$var$nap();
        $ed6282f03875f8f7$var$clockNow = 0;
    }
}
function $ed6282f03875f8f7$var$poke() {
    var now = $ed6282f03875f8f7$var$clock.now(), delay = now - $ed6282f03875f8f7$var$clockLast;
    if (delay > $ed6282f03875f8f7$var$pokeDelay) $ed6282f03875f8f7$var$clockSkew -= delay, $ed6282f03875f8f7$var$clockLast = now;
}
function $ed6282f03875f8f7$var$nap() {
    var t0, t1 = $ed6282f03875f8f7$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $ed6282f03875f8f7$var$taskHead = t2;
    }
    $ed6282f03875f8f7$var$taskTail = t0;
    $ed6282f03875f8f7$var$sleep(time);
}
function $ed6282f03875f8f7$var$sleep(time) {
    if ($ed6282f03875f8f7$var$frame) return; // Soonest alarm already set, or will be.
    if ($ed6282f03875f8f7$var$timeout) $ed6282f03875f8f7$var$timeout = clearTimeout($ed6282f03875f8f7$var$timeout);
    var delay = time - $ed6282f03875f8f7$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $ed6282f03875f8f7$var$timeout = setTimeout($ed6282f03875f8f7$var$wake, time - $ed6282f03875f8f7$var$clock.now() - $ed6282f03875f8f7$var$clockSkew);
        if ($ed6282f03875f8f7$var$interval) $ed6282f03875f8f7$var$interval = clearInterval($ed6282f03875f8f7$var$interval);
    } else {
        if (!$ed6282f03875f8f7$var$interval) $ed6282f03875f8f7$var$clockLast = $ed6282f03875f8f7$var$clock.now(), $ed6282f03875f8f7$var$interval = setInterval($ed6282f03875f8f7$var$poke, $ed6282f03875f8f7$var$pokeDelay);
        $ed6282f03875f8f7$var$frame = 1, $ed6282f03875f8f7$var$setFrame($ed6282f03875f8f7$var$wake);
    }
}


function $0de55e089ddef178$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $ed6282f03875f8f7$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $ec3dd76e362215c0$var$emptyOn = (0, $202926d84f9eb26c$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $ec3dd76e362215c0$var$emptyTween = [];
var $ec3dd76e362215c0$export$ff39ebd4bb12b718 = 0;
var $ec3dd76e362215c0$export$584530fe98d14a84 = 1;
var $ec3dd76e362215c0$export$a5d151aee16efd42 = 2;
var $ec3dd76e362215c0$export$fb935ab5849a0db9 = 3;
var $ec3dd76e362215c0$export$1573e22b087389af = 4;
var $ec3dd76e362215c0$export$a2e792214ded83b2 = 5;
var $ec3dd76e362215c0$export$9d38167254403955 = 6;
function $ec3dd76e362215c0$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $ec3dd76e362215c0$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $ec3dd76e362215c0$var$emptyOn,
        tween: $ec3dd76e362215c0$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $ec3dd76e362215c0$export$ff39ebd4bb12b718
    });
}
function $ec3dd76e362215c0$export$2cd8252107eb640b(node, id) {
    var schedule = $ec3dd76e362215c0$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $ec3dd76e362215c0$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $ec3dd76e362215c0$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $ec3dd76e362215c0$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $ec3dd76e362215c0$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $ec3dd76e362215c0$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $ec3dd76e362215c0$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $ed6282f03875f8f7$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $ec3dd76e362215c0$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $ec3dd76e362215c0$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $ec3dd76e362215c0$export$fb935ab5849a0db9) return (0, $0de55e089ddef178$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $ec3dd76e362215c0$export$1573e22b087389af) {
                o.state = $ec3dd76e362215c0$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $ec3dd76e362215c0$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $0de55e089ddef178$export$2e2bcd8739ae039)(function() {
            if (self.state === $ec3dd76e362215c0$export$fb935ab5849a0db9) {
                self.state = $ec3dd76e362215c0$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $ec3dd76e362215c0$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $ec3dd76e362215c0$export$a5d151aee16efd42) return; // interrupted
        self.state = $ec3dd76e362215c0$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $ec3dd76e362215c0$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $ec3dd76e362215c0$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $ec3dd76e362215c0$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $970c1db1cc92ab03$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $ec3dd76e362215c0$export$a5d151aee16efd42) && schedule.state < (0, $ec3dd76e362215c0$export$a2e792214ded83b2);
        schedule.state = (0, $ec3dd76e362215c0$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $0ab754491a6057f1$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $970c1db1cc92ab03$export$2e2bcd8739ae039)(this, name);
    });
}




var $6c24eebe0efa54be$var$degrees = 180 / Math.PI;
var $6c24eebe0efa54be$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $6c24eebe0efa54be$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $6c24eebe0efa54be$var$degrees,
        skewX: Math.atan(skewX) * $6c24eebe0efa54be$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $160b23dc7ba1d4f8$var$svgNode;
function $160b23dc7ba1d4f8$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $6c24eebe0efa54be$export$f0954fd7d5368655) : (0, $6c24eebe0efa54be$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $160b23dc7ba1d4f8$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $6c24eebe0efa54be$export$f0954fd7d5368655;
    if (!$160b23dc7ba1d4f8$var$svgNode) $160b23dc7ba1d4f8$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $160b23dc7ba1d4f8$var$svgNode.setAttribute("transform", value);
    if (!(value = $160b23dc7ba1d4f8$var$svgNode.transform.baseVal.consolidate())) return 0, $6c24eebe0efa54be$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $6c24eebe0efa54be$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $6860bf3d8f30166d$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $bd7205726919eb40$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bd7205726919eb40$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $bd7205726919eb40$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $bd7205726919eb40$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $bd7205726919eb40$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bd7205726919eb40$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $6860bf3d8f30166d$export$56bec7123bb3589a = $6860bf3d8f30166d$var$interpolateTransform((0, $160b23dc7ba1d4f8$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $6860bf3d8f30166d$export$da8cba906d64c082 = $6860bf3d8f30166d$var$interpolateTransform((0, $160b23dc7ba1d4f8$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $20849ede6b5aef58$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $ec3dd76e362215c0$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $20849ede6b5aef58$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $ec3dd76e362215c0$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $20849ede6b5aef58$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $ec3dd76e362215c0$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $20849ede6b5aef58$var$tweenRemove : $20849ede6b5aef58$var$tweenFunction)(id, name, value));
}
function $20849ede6b5aef58$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $ec3dd76e362215c0$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $ec3dd76e362215c0$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $bxlao = parcelRequire("bxlao");

function $b908bc440aa7da76$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $bd7205726919eb40$export$2e2bcd8739ae039) : b instanceof (0, $bxlao.default) ? (0, $4125a1f7550a0949$export$2e2bcd8739ae039) : (c = (0, $bxlao.default)(b)) ? (b = c, $4125a1f7550a0949$export$2e2bcd8739ae039) : (0, $ce25afa52e53938c$export$2e2bcd8739ae039))(a, b);
}


function $b811cbd300b30749$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $b811cbd300b30749$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $b811cbd300b30749$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $b811cbd300b30749$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $b811cbd300b30749$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $b811cbd300b30749$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $b811cbd300b30749$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $05db7c66aecd909a$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $6860bf3d8f30166d$export$da8cba906d64c082) : (0, $b908bc440aa7da76$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $b811cbd300b30749$var$attrFunctionNS : $b811cbd300b30749$var$attrFunction)(fullname, i, (0, $20849ede6b5aef58$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $b811cbd300b30749$var$attrRemoveNS : $b811cbd300b30749$var$attrRemove)(fullname) : (fullname.local ? $b811cbd300b30749$var$attrConstantNS : $b811cbd300b30749$var$attrConstant)(fullname, i, value));
}



function $1b7f614745d671e8$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $1b7f614745d671e8$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $1b7f614745d671e8$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $1b7f614745d671e8$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $1b7f614745d671e8$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $1b7f614745d671e8$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $1b7f614745d671e8$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $05db7c66aecd909a$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $1b7f614745d671e8$var$attrTweenNS : $1b7f614745d671e8$var$attrTween)(fullname, value));
}



function $3094d63d1610a34e$var$delayFunction(id, value) {
    return function() {
        (0, $ec3dd76e362215c0$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $3094d63d1610a34e$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $ec3dd76e362215c0$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $3094d63d1610a34e$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $3094d63d1610a34e$var$delayFunction : $3094d63d1610a34e$var$delayConstant)(id, value)) : (0, $ec3dd76e362215c0$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $fecf773811012fc0$var$durationFunction(id, value) {
    return function() {
        (0, $ec3dd76e362215c0$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $fecf773811012fc0$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $ec3dd76e362215c0$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $fecf773811012fc0$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $fecf773811012fc0$var$durationFunction : $fecf773811012fc0$var$durationConstant)(id, value)) : (0, $ec3dd76e362215c0$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $17a2d48292061c51$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $ec3dd76e362215c0$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $17a2d48292061c51$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($17a2d48292061c51$var$easeConstant(id, value)) : (0, $ec3dd76e362215c0$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $d2ce5d15218789a1$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $ec3dd76e362215c0$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $d2ce5d15218789a1$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($d2ce5d15218789a1$var$easeVarying(this._id, value));
}




function $9aeb2865eedd2e89$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $2c974644544610bf$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $0bfbdc865a41e63d$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $3388d24e4977753f$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $0bfbdc865a41e63d$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $ce68b585666bb98e$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $ce68b585666bb98e$var$onFunction(id, name, listener) {
    var on0, on1, sit = $ce68b585666bb98e$var$start(name) ? (0, $ec3dd76e362215c0$export$2cd8252107eb640b) : (0, $ec3dd76e362215c0$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $ce68b585666bb98e$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $ec3dd76e362215c0$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($ce68b585666bb98e$var$onFunction(id, name, listener));
}


function $adfdcf6692d21379$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $adfdcf6692d21379$export$2e2bcd8739ae039() {
    return this.on("end.remove", $adfdcf6692d21379$var$removeFunction(this._id));
}





function $50454e8103d76419$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $1eb11220c0df6fba$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $ec3dd76e362215c0$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $ec3dd76e362215c0$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $0bfbdc865a41e63d$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $c4cd43840974036c$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $35296398f5f08b14$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $ec3dd76e362215c0$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $ec3dd76e362215c0$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $0bfbdc865a41e63d$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $0ce5047e8669f4d4$var$Selection = (0, $37c8fa7d5de8e53a$export$2e2bcd8739ae039).prototype.constructor;
function $0ce5047e8669f4d4$export$2e2bcd8739ae039() {
    return new $0ce5047e8669f4d4$var$Selection(this._groups, this._parents);
}







function $e07420bb4c337cc2$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $b9b7e2f0730f1bd4$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $b9b7e2f0730f1bd4$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $e07420bb4c337cc2$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $e07420bb4c337cc2$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $b9b7e2f0730f1bd4$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $e07420bb4c337cc2$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $b9b7e2f0730f1bd4$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $b9b7e2f0730f1bd4$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $e07420bb4c337cc2$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $ec3dd76e362215c0$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $e07420bb4c337cc2$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $e07420bb4c337cc2$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $6860bf3d8f30166d$export$56bec7123bb3589a) : (0, $b908bc440aa7da76$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $e07420bb4c337cc2$var$styleNull(name, i)).on("end.style." + name, $e07420bb4c337cc2$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $e07420bb4c337cc2$var$styleFunction(name, i, (0, $20849ede6b5aef58$export$f78ce6ab10405d82)(this, "style." + name, value))).each($e07420bb4c337cc2$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $e07420bb4c337cc2$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $ad5a045fba1137e4$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $ad5a045fba1137e4$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $ad5a045fba1137e4$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $ad5a045fba1137e4$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $ad5a045fba1137e4$var$styleTween(name, value, priority == null ? "" : priority));
}



function $7b39908a348d0cbb$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $7b39908a348d0cbb$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $7b39908a348d0cbb$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $7b39908a348d0cbb$var$textFunction((0, $20849ede6b5aef58$export$f78ce6ab10405d82)(this, "text", value)) : $7b39908a348d0cbb$var$textConstant(value == null ? "" : value + ""));
}


function $85950362d0b400c3$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $85950362d0b400c3$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $85950362d0b400c3$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $85950362d0b400c3$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $85950362d0b400c3$var$textTween(value));
}




function $a7c841b4114413dc$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $0bfbdc865a41e63d$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $ec3dd76e362215c0$export$3988ae62b71be9a3)(node, id0);
            (0, $ec3dd76e362215c0$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $0bfbdc865a41e63d$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $f1f3d3dd75a82e46$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $ec3dd76e362215c0$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $0bfbdc865a41e63d$var$id = 0;
function $0bfbdc865a41e63d$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $0bfbdc865a41e63d$export$2e2bcd8739ae039(name) {
    return (0, $37c8fa7d5de8e53a$export$2e2bcd8739ae039)().transition(name);
}
function $0bfbdc865a41e63d$export$9ffd10a3fbdc175b() {
    return ++$0bfbdc865a41e63d$var$id;
}
var $0bfbdc865a41e63d$var$selection_prototype = (0, $37c8fa7d5de8e53a$export$2e2bcd8739ae039).prototype;
$0bfbdc865a41e63d$export$be58926105124dd4.prototype = $0bfbdc865a41e63d$export$2e2bcd8739ae039.prototype = {
    constructor: $0bfbdc865a41e63d$export$be58926105124dd4,
    select: (0, $50454e8103d76419$export$2e2bcd8739ae039),
    selectAll: (0, $c4cd43840974036c$export$2e2bcd8739ae039),
    filter: (0, $9aeb2865eedd2e89$export$2e2bcd8739ae039),
    merge: (0, $3388d24e4977753f$export$2e2bcd8739ae039),
    selection: (0, $0ce5047e8669f4d4$export$2e2bcd8739ae039),
    transition: (0, $a7c841b4114413dc$export$2e2bcd8739ae039),
    call: $0bfbdc865a41e63d$var$selection_prototype.call,
    nodes: $0bfbdc865a41e63d$var$selection_prototype.nodes,
    node: $0bfbdc865a41e63d$var$selection_prototype.node,
    size: $0bfbdc865a41e63d$var$selection_prototype.size,
    empty: $0bfbdc865a41e63d$var$selection_prototype.empty,
    each: $0bfbdc865a41e63d$var$selection_prototype.each,
    on: (0, $ce68b585666bb98e$export$2e2bcd8739ae039),
    attr: (0, $b811cbd300b30749$export$2e2bcd8739ae039),
    attrTween: (0, $1b7f614745d671e8$export$2e2bcd8739ae039),
    style: (0, $e07420bb4c337cc2$export$2e2bcd8739ae039),
    styleTween: (0, $ad5a045fba1137e4$export$2e2bcd8739ae039),
    text: (0, $7b39908a348d0cbb$export$2e2bcd8739ae039),
    textTween: (0, $85950362d0b400c3$export$2e2bcd8739ae039),
    remove: (0, $adfdcf6692d21379$export$2e2bcd8739ae039),
    tween: (0, $20849ede6b5aef58$export$2e2bcd8739ae039),
    delay: (0, $3094d63d1610a34e$export$2e2bcd8739ae039),
    duration: (0, $fecf773811012fc0$export$2e2bcd8739ae039),
    ease: (0, $17a2d48292061c51$export$2e2bcd8739ae039),
    easeVarying: (0, $d2ce5d15218789a1$export$2e2bcd8739ae039),
    end: (0, $f1f3d3dd75a82e46$export$2e2bcd8739ae039),
    [Symbol.iterator]: $0bfbdc865a41e63d$var$selection_prototype[Symbol.iterator]
};



function $8a05ac3b967f900c$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $8a05ac3b967f900c$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $8a05ac3b967f900c$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $cc6d65fe96485f27$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $8a05ac3b967f900c$export$89238d3bc79d3ada)
};
function $cc6d65fe96485f27$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $cc6d65fe96485f27$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $0bfbdc865a41e63d$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $0bfbdc865a41e63d$export$9ffd10a3fbdc175b)(), (timing = $cc6d65fe96485f27$var$defaultTiming).time = (0, $ed6282f03875f8f7$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $ec3dd76e362215c0$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $cc6d65fe96485f27$var$inherit(node, id));
    }
    return new (0, $0bfbdc865a41e63d$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $37c8fa7d5de8e53a$export$2e2bcd8739ae039).prototype.interrupt = (0, $0ab754491a6057f1$export$2e2bcd8739ae039);
(0, $37c8fa7d5de8e53a$export$2e2bcd8739ae039).prototype.transition = (0, $cc6d65fe96485f27$export$2e2bcd8739ae039);





var $1b615eabfb312a22$var$root = [
    null
];
function $1b615eabfb312a22$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $ec3dd76e362215c0$export$584530fe98d14a84) && schedule.name === name) return new (0, $0bfbdc865a41e63d$export$be58926105124dd4)([
                [
                    node
                ]
            ], $1b615eabfb312a22$var$root, name, +i);
        }
    }
    return null;
}





var $a513b3fc7344dc0b$export$2e2bcd8739ae039 = (x)=>()=>x;


function $89764d737e0f558c$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $ad1a15f3efa60bb1$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $ad1a15f3efa60bb1$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $be8ef7207c2c73a5$var$MODE_DRAG = {
    name: "drag"
}, $be8ef7207c2c73a5$var$MODE_SPACE = {
    name: "space"
}, $be8ef7207c2c73a5$var$MODE_HANDLE = {
    name: "handle"
}, $be8ef7207c2c73a5$var$MODE_CENTER = {
    name: "center"
};
const { abs: $be8ef7207c2c73a5$var$abs, max: $be8ef7207c2c73a5$var$max, min: $be8ef7207c2c73a5$var$min } = Math;
function $be8ef7207c2c73a5$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $be8ef7207c2c73a5$var$number2(e) {
    return [
        $be8ef7207c2c73a5$var$number1(e[0]),
        $be8ef7207c2c73a5$var$number1(e[1])
    ];
}
var $be8ef7207c2c73a5$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($be8ef7207c2c73a5$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $be8ef7207c2c73a5$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($be8ef7207c2c73a5$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $be8ef7207c2c73a5$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($be8ef7207c2c73a5$var$type),
    input: function(xy) {
        return xy == null ? null : $be8ef7207c2c73a5$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $be8ef7207c2c73a5$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $be8ef7207c2c73a5$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $be8ef7207c2c73a5$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $be8ef7207c2c73a5$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $be8ef7207c2c73a5$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $be8ef7207c2c73a5$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $be8ef7207c2c73a5$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $be8ef7207c2c73a5$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $be8ef7207c2c73a5$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $be8ef7207c2c73a5$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $be8ef7207c2c73a5$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $be8ef7207c2c73a5$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $be8ef7207c2c73a5$export$979ace6c88860aa8() {
    return $be8ef7207c2c73a5$var$brush($be8ef7207c2c73a5$var$X);
}
function $be8ef7207c2c73a5$export$468748b530991c54() {
    return $be8ef7207c2c73a5$var$brush($be8ef7207c2c73a5$var$Y);
}
function $be8ef7207c2c73a5$export$2e2bcd8739ae039() {
    return $be8ef7207c2c73a5$var$brush($be8ef7207c2c73a5$var$XY);
}
function $be8ef7207c2c73a5$var$brush(dim) {
    var extent = $be8ef7207c2c73a5$var$defaultExtent, filter = $be8ef7207c2c73a5$var$defaultFilter, touchable = $be8ef7207c2c73a5$var$defaultTouchable, keys = true, listeners = (0, $202926d84f9eb26c$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $be8ef7207c2c73a5$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $be8ef7207c2c73a5$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $be8ef7207c2c73a5$var$local(this).extent;
            (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $be8ef7207c2c73a5$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $be8ef7207c2c73a5$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $be8ef7207c2c73a5$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $385a14c856d32e86$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $970c1db1cc92ab03$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(this), selection = $be8ef7207c2c73a5$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $89764d737e0f558c$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $be8ef7207c2c73a5$var$MODE_DRAG : keys && event.altKey ? $be8ef7207c2c73a5$var$MODE_CENTER : $be8ef7207c2c73a5$var$MODE_HANDLE, signX = dim === $be8ef7207c2c73a5$var$Y ? null : $be8ef7207c2c73a5$var$signsX[type], signY = dim === $be8ef7207c2c73a5$var$X ? null : $be8ef7207c2c73a5$var$signsY[type], state = $be8ef7207c2c73a5$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $1f5822687e66fdad$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $be8ef7207c2c73a5$var$Y ? W : $be8ef7207c2c73a5$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $be8ef7207c2c73a5$var$X ? N : $be8ef7207c2c73a5$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $be8ef7207c2c73a5$var$Y ? E : $be8ef7207c2c73a5$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $be8ef7207c2c73a5$var$X ? S : $be8ef7207c2c73a5$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move();
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $be8ef7207c2c73a5$var$cursors[type]);
        (0, $970c1db1cc92ab03$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $0b8040ae2b576907$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $1f5822687e66fdad$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($be8ef7207c2c73a5$var$abs(point.cur[0] - point[0]) > $be8ef7207c2c73a5$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $ad1a15f3efa60bb1$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $be8ef7207c2c73a5$var$MODE_SPACE:
                case $be8ef7207c2c73a5$var$MODE_DRAG:
                    if (signX) dx = $be8ef7207c2c73a5$var$max(W - w0, $be8ef7207c2c73a5$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $be8ef7207c2c73a5$var$max(N - n0, $be8ef7207c2c73a5$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $be8ef7207c2c73a5$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $be8ef7207c2c73a5$var$max(W, $be8ef7207c2c73a5$var$min(E, points[0][0])), e1 = $be8ef7207c2c73a5$var$max(W, $be8ef7207c2c73a5$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $be8ef7207c2c73a5$var$max(N, $be8ef7207c2c73a5$var$min(S, points[0][1])), s1 = $be8ef7207c2c73a5$var$max(N, $be8ef7207c2c73a5$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $be8ef7207c2c73a5$var$max(W - w0, $be8ef7207c2c73a5$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $be8ef7207c2c73a5$var$max(W - e0, $be8ef7207c2c73a5$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $be8ef7207c2c73a5$var$max(N - n0, $be8ef7207c2c73a5$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $be8ef7207c2c73a5$var$max(N - s0, $be8ef7207c2c73a5$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $be8ef7207c2c73a5$var$MODE_CENTER:
                    if (signX) w1 = $be8ef7207c2c73a5$var$max(W, $be8ef7207c2c73a5$var$min(E, w0 - dx * signX)), e1 = $be8ef7207c2c73a5$var$max(W, $be8ef7207c2c73a5$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $be8ef7207c2c73a5$var$max(N, $be8ef7207c2c73a5$var$min(S, n0 - dy * signY)), s1 = $be8ef7207c2c73a5$var$max(N, $be8ef7207c2c73a5$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $be8ef7207c2c73a5$var$flipX) overlay.attr("cursor", $be8ef7207c2c73a5$var$cursors[type = $be8ef7207c2c73a5$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $be8ef7207c2c73a5$var$flipY) overlay.attr("cursor", $be8ef7207c2c73a5$var$cursors[type = $be8ef7207c2c73a5$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $ad1a15f3efa60bb1$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $0b8040ae2b576907$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $be8ef7207c2c73a5$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($be8ef7207c2c73a5$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $be8ef7207c2c73a5$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $be8ef7207c2c73a5$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $be8ef7207c2c73a5$var$MODE_HANDLE || mode === $be8ef7207c2c73a5$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $be8ef7207c2c73a5$var$MODE_SPACE;
                        overlay.attr("cursor", $be8ef7207c2c73a5$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $ad1a15f3efa60bb1$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $be8ef7207c2c73a5$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $be8ef7207c2c73a5$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $be8ef7207c2c73a5$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $be8ef7207c2c73a5$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $be8ef7207c2c73a5$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $be8ef7207c2c73a5$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $ad1a15f3efa60bb1$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $be8ef7207c2c73a5$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $a513b3fc7344dc0b$export$2e2bcd8739ae039)($be8ef7207c2c73a5$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $a513b3fc7344dc0b$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $a513b3fc7344dc0b$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}






var $bxlao = parcelRequire("bxlao");


























var $782f4d66cab6427f$var$epsilon2 = 1e-12;
function $782f4d66cab6427f$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $782f4d66cab6427f$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $782f4d66cab6427f$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $782f4d66cab6427f$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $782f4d66cab6427f$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $782f4d66cab6427f$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $782f4d66cab6427f$var$tanh(rho * s + r0) - $782f4d66cab6427f$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $782f4d66cab6427f$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $9a32edfc289e30de$export$2e2bcd8739ae039 = (x)=>()=>x;


function $af17f31e0702a6ae$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $19aa24db5d4d0b85$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$19aa24db5d4d0b85$export$563a914cafbdc389.prototype = {
    constructor: $19aa24db5d4d0b85$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $19aa24db5d4d0b85$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $19aa24db5d4d0b85$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $19aa24db5d4d0b85$export$f0954fd7d5368655 = new $19aa24db5d4d0b85$export$563a914cafbdc389(1, 0, 0);
$19aa24db5d4d0b85$export$2e2bcd8739ae039.prototype = $19aa24db5d4d0b85$export$563a914cafbdc389.prototype;
function $19aa24db5d4d0b85$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $19aa24db5d4d0b85$export$f0954fd7d5368655;
    return node.__zoom;
}


function $391caa1c424f1341$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $391caa1c424f1341$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $31060fc2a93034e9$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $31060fc2a93034e9$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $31060fc2a93034e9$var$defaultTransform() {
    return this.__zoom || (0, $19aa24db5d4d0b85$export$f0954fd7d5368655);
}
function $31060fc2a93034e9$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $31060fc2a93034e9$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $31060fc2a93034e9$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $31060fc2a93034e9$export$2e2bcd8739ae039() {
    var filter = $31060fc2a93034e9$var$defaultFilter, extent = $31060fc2a93034e9$var$defaultExtent, constrain = $31060fc2a93034e9$var$defaultConstrain, wheelDelta = $31060fc2a93034e9$var$defaultWheelDelta, touchable = $31060fc2a93034e9$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $782f4d66cab6427f$export$2e2bcd8739ae039), listeners = (0, $202926d84f9eb26c$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $31060fc2a93034e9$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $31060fc2a93034e9$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $19aa24db5d4d0b85$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $19aa24db5d4d0b85$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $19aa24db5d4d0b85$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $19aa24db5d4d0b85$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $af17f31e0702a6ae$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $1f5822687e66fdad$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $970c1db1cc92ab03$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $391caa1c424f1341$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, args, true).event(event), v = (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $1f5822687e66fdad$export$2e2bcd8739ae039)(event, currentTarget), currentTarget = event.currentTarget, x0 = event.clientX, y0 = event.clientY;
        (0, $0b8040ae2b576907$export$2e2bcd8739ae039)(event.view);
        (0, $391caa1c424f1341$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $970c1db1cc92ab03$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $391caa1c424f1341$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $1f5822687e66fdad$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $0b8040ae2b576907$export$833237748009e1e1)(event.view, g.moved);
            (0, $391caa1c424f1341$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $1f5822687e66fdad$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $391caa1c424f1341$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $391caa1c424f1341$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1f5822687e66fdad$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $970c1db1cc92ab03$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $391caa1c424f1341$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1f5822687e66fdad$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $391caa1c424f1341$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $1f5822687e66fdad$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $90191c63f6c0937e$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $9a32edfc289e30de$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $9a32edfc289e30de$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $9a32edfc289e30de$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $9a32edfc289e30de$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}







var $bxlao = parcelRequire("bxlao");

var $12ed0c91dd1ed4e8$require$getPitchTypeGroup = $d95d8b439f5daf31$export$f123e17152c6376a;
// There is another file: bam-node-bdata-charts/utils/colors.js which has some colors and helper functions
// This is DB's attempt to standardize pitch type colors in one place
/**
 * @type {Object.<string, string>}
 */ const $12ed0c91dd1ed4e8$var$pitchTypeAbbrevMap = {
    '4-SEAM FASTBALL': 'FF',
    'FOUR SEAMER': 'FF',
    '2-SEAM FASTBALL': 'FT',
    SINKER: 'SI',
    CUTTER: 'FC',
    CHANGEUP: 'CH',
    'SPLIT FINGER': 'FS',
    'SPLIT-FINGER': 'FS',
    SPLITTER: 'FS',
    SCREWBALL: 'SC',
    FORKBALL: 'FO',
    SWEEPER: 'ST',
    SLIDER: 'SL',
    SLURVE: 'SV',
    CURVEBALL: 'CU',
    'KNUCKLE CURVE': 'KC',
    'KNUCKLE BALL': 'KN',
    KNUCKLEBALL: 'KN',
    'SLOW CURVE': 'CS',
    FF: 'FF',
    FT: 'FT',
    SI: 'SI',
    FC: 'FC',
    CH: 'CH',
    FS: 'FS',
    SC: 'SC',
    FO: 'FO',
    ST: 'ST',
    SL: 'SL',
    SV: 'SV',
    CU: 'CU',
    KC: 'KC',
    KN: 'KN',
    CS: 'CS',
    GY: 'GY',
    // Special ones?
    SIFT: 'FT',
    CHFS: 'CH',
    CUKC: 'CU',
    ALL: 'ALL',
    FASTBALL: 'FASTBALL',
    OFFSPEED: 'OFFSPEED',
    BREAKING: 'BREAKING'
};
/**
 * @typedef { { textColor: string, vizColor?: string } } PitchTypeColorObj
 */ // Always provide textColor, optionally provide vizColor
/**
 * @type Object.<string, PitchTypeColorObj>
 */ const $12ed0c91dd1ed4e8$var$pitchTypeColors = {
    FF: {
        textColor: '#D22D49'
    },
    FT: {
        textColor: '#DE6A04'
    },
    SI: {
        textColor: '#FE9D00'
    },
    FC: {
        textColor: '#933F2C'
    },
    CH: {
        textColor: '#1DBE3A'
    },
    FS: {
        textColor: '#3BACAC'
    },
    SC: {
        textColor: '#60DB33'
    },
    FO: {
        textColor: '#55CCAB'
    },
    ST: {
        textColor: '#DDB33A'
    },
    SL: {
        textColor: '#C3BD0E',
        vizColor: '#EEE716'
    },
    SV: {
        textColor: '#93AFD4'
    },
    GY: {
        textColor: '#FFFF99'
    },
    CU: {
        textColor: '#00D1ED'
    },
    KC: {
        textColor: '#6236CD'
    },
    KN: {
        textColor: '#3C44CD'
    },
    CS: {
        textColor: '#0068FF'
    },
    ALL: {
        textColor: '#f00'
    },
    FASTBALL: {
        textColor: '#f00'
    },
    OFFSPEED: {
        vizColor: '#0f0',
        textColor: '#24CA24'
    },
    BREAKING: {
        textColor: '#00f'
    }
};
/**
 *
 * @param {string} pitchType
 * @param {boolean} useTextColor
 * @returns {string}
 */ function $12ed0c91dd1ed4e8$var$getPitchTypeColor(pitchType = '', useTextColor = true) {
    const upperPitchType = String(pitchType).toUpperCase();
    const pitchAbbrev = $12ed0c91dd1ed4e8$var$pitchTypeAbbrevMap[upperPitchType];
    if (!pitchAbbrev) {
        // eslint-disable-next-line no-console
        console.log('pitchAbbrev not found for pitchType:', pitchType);
        return '#888888';
    }
    const { textColor: textColor, vizColor: vizColor } = $12ed0c91dd1ed4e8$var$pitchTypeColors[pitchAbbrev];
    return useTextColor ? textColor : vizColor || textColor;
}
/**
 * @param {string} pitchType
 * @param {boolean} useTextColor
 * @returns {string}
 */ function $12ed0c91dd1ed4e8$var$getPitchTypeColorGrouping(pitchType, useTextColor = true) {
    const pitchTypeGroup = $12ed0c91dd1ed4e8$require$getPitchTypeGroup(pitchType);
    if (!pitchTypeGroup) // TODO: WHATTODO?
    return 'Unknown';
    return $12ed0c91dd1ed4e8$var$getPitchTypeColor(pitchTypeGroup, useTextColor);
}
/**
 * @param {string} pitchType
 * @param {boolean} useTextColor
 * @param {number} darkerRatio
 */ function $12ed0c91dd1ed4e8$var$getPitchTypeOutlineColor(pitchType, useTextColor = true, darkerRatio = 1) {
    const upperPitchType = String(pitchType).toUpperCase();
    const pitchAbbrev = $12ed0c91dd1ed4e8$var$pitchTypeAbbrevMap[upperPitchType];
    if (!pitchAbbrev) {
        // eslint-disable-next-line no-console
        console.log('pitchAbbrev not found for pitchType:', pitchType);
        return '#888888';
    }
    const { textColor: textColor, vizColor: vizColor } = $12ed0c91dd1ed4e8$var$pitchTypeColors[pitchAbbrev];
    const returnColor = useTextColor ? textColor : vizColor || textColor;
    const color = $bxlao.default(returnColor);
    return color ? color.darker(darkerRatio).formatHex() : '#ccc';
}
/**
 * @param {string} pitchType
 * @param {boolean} useTextColor
 * @param {number} darkerRatio
 * @returns {string}
 */ function $12ed0c91dd1ed4e8$var$getPitchTypeOutlineColorGrouping(pitchType, useTextColor = true, darkerRatio = 1) {
    const pitchTypeGroup = $12ed0c91dd1ed4e8$require$getPitchTypeGroup(pitchType);
    if (!pitchTypeGroup) return '#888888';
    return $12ed0c91dd1ed4e8$var$getPitchTypeOutlineColor(pitchTypeGroup, useTextColor, darkerRatio);
}
$12ed0c91dd1ed4e8$exports = {
    getPitchTypeColor: $12ed0c91dd1ed4e8$var$getPitchTypeColor,
    getPitchTypeColorGrouping: $12ed0c91dd1ed4e8$var$getPitchTypeColorGrouping,
    getPitchTypeOutlineColor: $12ed0c91dd1ed4e8$var$getPitchTypeOutlineColor,
    getPitchTypeOutlineColorGrouping: $12ed0c91dd1ed4e8$var$getPitchTypeOutlineColorGrouping
};




function $2992065d54e107bf$export$2e2bcd8739ae039({ pitch: pitch, togglePitchDrawer: togglePitchDrawer, pitchersWithPitch: pitchersWithPitch, isExpanded: isExpanded, pitchStats: pitchStats, renderStatNode: renderStatNode }) {
    const { isMobile: isMobile } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
        className: "stat-picker-drawer-div",
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                onClick: ()=>togglePitchDrawer(pitch),
                className: "stat-picker-arsenal-drawer",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("span", {
                                style: {
                                    borderRadius: '4px',
                                    padding: '1px 4px',
                                    backgroundColor: (0, $12ed0c91dd1ed4e8$exports.getPitchTypeColor)(pitch.toUpperCase()),
                                    color: pitch === 'sl' ? 'black' : 'white'
                                },
                                children: (0, $8546d2747a982d8c$export$2e2bcd8739ae039)(pitch)
                            }),
                            pitchersWithPitch.length > 0 && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center'
                                },
                                children: pitchersWithPitch.map((player, idx)=>{
                                    const leftSideMargin = isMobile && pitchersWithPitch.length > 7 ? '-10px' : '-8px';
                                    const playerId = player.uniqueId;
                                    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("img", {
                                        src: `https://midfield.mlbstatic.com/v1/people/${player.id}/mlb/120?circle=true`,
                                        alt: "player headshot",
                                        title: player.id.toString() || '',
                                        style: {
                                            width: '20px',
                                            height: '20px',
                                            borderRadius: '50%',
                                            border: '1px solid #aaaaaa',
                                            backgroundColor: '#e6e6e6',
                                            marginLeft: idx === 0 ? '0px' : leftSideMargin,
                                            zIndex: pitchersWithPitch.length - idx
                                        }
                                    }, playerId);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("span", {
                        children: isExpanded ? "\u25BE" : "\u25B8"
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                className: "stat-picker-drawer-stat",
                children: pitchStats.map((stat)=>renderStatNode(stat))
            })
        ]
    }, pitch);
}


function $936844e92beee7ef$var$getGroupedArsenalStats(arsenalStats) {
    return arsenalStats.reduce((acc, stat)=>{
        const prefix = stat.split('_')[0];
        if (!acc[prefix]) acc[prefix] = [];
        acc[prefix].push(stat);
        return acc;
    }, {});
}
function $936844e92beee7ef$export$2e2bcd8739ae039({ keyName: keyName, sectionTitle: sectionTitle, statsInGroup: statsInGroup, expandedPitches: expandedPitches, searchFilter: searchFilter, selectedPlayers: selectedPlayers, togglePitchDrawer: togglePitchDrawer, renderStatNode: renderStatNode }) {
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                className: "stat-picker-scroll-subheader",
                children: sectionTitle
            }),
            keyName === 'pitch_arsenal' ? (()=>{
                const pitchGroups = $936844e92beee7ef$var$getGroupedArsenalStats(statsInGroup);
                return Object.entries(pitchGroups).map(([pitch, pitchStats])=>{
                    const isExpanded = expandedPitches.includes(pitch) || searchFilter !== '';
                    const runValueKey = `${pitch}_percent_rank_pitch_usage`;
                    const pitchersWithPitch = selectedPlayers.filter((p)=>p[runValueKey] !== null && p[runValueKey] !== undefined && p.grouping_cat === 'Pitcher');
                    const seenIds = new Set();
                    const uniquePlayers = pitchersWithPitch.filter((player)=>{
                        if (seenIds.has(Number(player.id))) return false;
                        seenIds.add(Number(player.id));
                        return true;
                    });
                    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $2992065d54e107bf$export$2e2bcd8739ae039), {
                        pitch: pitch,
                        pitchStats: pitchStats,
                        pitchersWithPitch: uniquePlayers,
                        isExpanded: isExpanded,
                        togglePitchDrawer: togglePitchDrawer,
                        renderStatNode: renderStatNode
                    }, pitch);
                });
            })() : statsInGroup.map((stat)=>renderStatNode(stat))
        ]
    }, keyName);
}


/* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable jsx-a11y/label-has-associated-control */ 

var $63Xef = parcelRequire("63Xef");







/* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
parcelRequire("63Xef");
// eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");




function $e21cf1d0016f27b0$var$PitchPillElement(props) {
    const { pitchType: pitchType, statName: statName, flipOrder: flipOrder, x: x, y: y, textClass: textClass, rightJustify: rightJustify } = props;
    const BOX_WIDTH = 250;
    const { isMobile: isMobile } = (0, $116a259e7f6314e7$export$2e2bcd8739ae039)();
    const mapToUse = isMobile ? (0, $89d260932605bcde$export$25e732bb1f0af07a) : (0, $89d260932605bcde$export$b04545738ece254a);
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("foreignObject", {
        x: rightJustify ? x - BOX_WIDTH : x,
        y: y - 9,
        width: BOX_WIDTH,
        height: 30,
        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
            className: `${textClass} comp-tool-pitch-pill-container`,
            xmlns: 'http://www.w3.org/1999/xhtml',
            style: {
                justifyContent: rightJustify ? 'flex-end' : 'flex-start'
            },
            children: [
                flipOrder && mapToUse[statName],
                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                    className: "comp-tool-pitch-pill-text",
                    style: {
                        backgroundColor: (0, $12ed0c91dd1ed4e8$exports.getPitchTypeColor)(pitchType),
                        color: pitchType === 'sl' ? 'black' : 'white',
                        WebkitTextFillColor: pitchType === 'sl' ? 'black' : 'white',
                        marginRight: flipOrder ? '4px' : '0px',
                        marginLeft: !flipOrder ? '4px' : '0px'
                    },
                    children: (0, $8546d2747a982d8c$export$2e2bcd8739ae039)(pitchType)
                }),
                !flipOrder && mapToUse[statName]
            ]
        })
    });
}
var $e21cf1d0016f27b0$export$2e2bcd8739ae039 = $e21cf1d0016f27b0$var$PitchPillElement;



/* eslint-disable no-nested-ternary */ // eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");

const $5d4181c52df08ae8$var$OPEN_EYE = /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
    stroke: "white",
    strokeWidth: "1",
    fill: "none",
    children: [
        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
            d: "M -4.5 0 C -2 -3.5, 2 -3.5, 4.5 0 C 2 3.5, -2 3.5, -4.5 0 Z"
        }),
        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("circle", {
            cx: 0,
            cy: 0,
            r: 1.5,
            fill: "white"
        })
    ]
});
const $5d4181c52df08ae8$var$CROSS_EYE = /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
    stroke: "white",
    strokeWidth: "1",
    fill: "none",
    children: [
        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
            d: "M -4.5 0 C -2 -3.5, 2 -3.5, 4.5 0 C 2 3.5, -2 3.5, -4.5 0 Z"
        }),
        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("circle", {
            cx: 0,
            cy: 0,
            r: 1.5,
            fill: "white"
        }),
        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("line", {
            x1: "-4.5",
            y1: "-3.5",
            x2: "4.5",
            y2: "3.5",
            strokeWidth: "1.5"
        })
    ]
});
function $5d4181c52df08ae8$export$2e2bcd8739ae039({ x: x, y: y, symbol: symbol, isEye: isEye, isCrossed: isCrossed }) {
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
        transform: `translate(${x}, ${y})`,
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("circle", {
                cx: 0,
                cy: 0,
                r: 6,
                fill: (0, $c30e918aac675a8e$export$2200862f6453cab4),
                stroke: (0, $c30e918aac675a8e$export$2200862f6453cab4),
                strokeWidth: "2"
            }),
            isEye ? isCrossed ? $5d4181c52df08ae8$var$CROSS_EYE : $5d4181c52df08ae8$var$OPEN_EYE : /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                x: 0,
                y: 1,
                textAnchor: "middle",
                dominantBaseline: "middle",
                fontSize: "16",
                fontWeight: "bold",
                fill: "white",
                children: symbol
            })
        ]
    });
}





function $e24093eca76cedb8$export$2e2bcd8739ae039({ stat: stat, draftSelected: draftSelected, type: type, index: index, groupRefs: groupRefs, currentType: currentType, handleToggleStat: handleToggleStat }) {
    const { STAT_DRAG_RECT_WIDTH: STAT_DRAG_RECT_WIDTH, REMOVE_BUTTON_X: REMOVE_BUTTON_X } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    const globalIndex = draftSelected.indexOf(stat);
    const relativeY = index * (0, $c30e918aac675a8e$export$88e6c5bab2ff80e8);
    const prettyStatName = stat === 'percent_rank_swing_take_run_value' && currentType === 'pitcher' ? 'Pitching' : (0, $89d260932605bcde$export$7b1f6a215293eaeb)[stat];
    const isArsenal = (0, $89d260932605bcde$export$7137f82dfb412109).has(stat);
    let arsenalPitchType;
    let arsenalPitchStat;
    if (isArsenal) [arsenalPitchType, arsenalPitchStat] = stat.split('_percent_rank_');
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $2f9510a59088c740$export$2e2bcd8739ae039), {
        id: stat,
        index: globalIndex,
        offset: relativeY,
        groupName: `draft-stats-${type}`,
        type: "stat",
        container: groupRefs.current[type],
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                width: STAT_DRAG_RECT_WIDTH,
                height: 30,
                x: 8,
                rx: 4,
                className: "stat-picker-sortable-rect"
            }),
            !isArsenal && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                x: 16,
                y: 20,
                className: "stat-picker-sortable-text",
                children: prettyStatName.length > (0, $c30e918aac675a8e$export$db73444eab1db51b) ? `${prettyStatName.substring(0, (0, $c30e918aac675a8e$export$3f2ddb112ca520d8))}...` : prettyStatName
            }),
            isArsenal && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $e21cf1d0016f27b0$export$2e2bcd8739ae039), {
                x: 10,
                y: 9,
                textClass: "stat-picker-sortable-text",
                pitchType: arsenalPitchType,
                statName: arsenalPitchStat,
                flipOrder: false,
                rightJustify: false
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                x: 8,
                y: 0,
                width: (0, $c30e918aac675a8e$export$ea30c0fd072f0798),
                height: 30,
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                onPointerDown: (e)=>e.stopPropagation(),
                onMouseDown: (e)=>e.stopPropagation(),
                onClick: (e)=>{
                    e.stopPropagation();
                    handleToggleStat(stat);
                },
                style: {
                    cursor: 'pointer'
                },
                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $5d4181c52df08ae8$export$2e2bcd8739ae039), {
                    x: REMOVE_BUTTON_X,
                    y: 15,
                    symbol: "\xd7"
                })
            })
        ]
    }, stat);
}



function $6e144ceb09804690$export$2e2bcd8739ae039({ draftSelected: draftSelected, setDraftSelected: setDraftSelected, existingDraftTypes: existingDraftTypes, currentType: currentType, handleToggleStat: handleToggleStat }) {
    const groupRefs = (0, $63Xef.useRef)({});
    const groupedDraft = (0, $89d260932605bcde$export$f03f2f56ee474855)(draftSelected, currentType);
    const { isMobile: isMobile } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    const rightSideSvgHeight = draftSelected.length * (0, $c30e918aac675a8e$export$88e6c5bab2ff80e8) + existingDraftTypes.length * (0, $c30e918aac675a8e$export$cdb7fd9d999c7168) + 10;
    const handleDragOver = (event)=>{
        const { operation: operation } = event;
        const { source: source, target: target } = operation;
        if ((0, $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f)(source) && (0, $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f)(target)) {
            const overIndex = target.sortable.index;
            const activeIndex = source.sortable.index;
            if (activeIndex !== overIndex) setDraftSelected((prev)=>(0, $d9ca3e6570e7a9a7$export$5d49d615ad5ea2b0)([
                    ...prev
                ], activeIndex, overIndex));
        }
    };
    const sensors = (0, $63Xef.useMemo)(()=>[
            (0, $4e1e107797f01458$export$b26af955418d6638).configure({
                activationConstraints: [
                    new (0, $4e1e107797f01458$export$863a6e64d6b9f7f4).Distance({
                        value: 8
                    }),
                    new (0, $4e1e107797f01458$export$863a6e64d6b9f7f4).Delay({
                        value: isMobile ? 800 : 200,
                        tolerance: isMobile ? 5 : 10
                    })
                ]
            })
        ], []);
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
        className: "stat-picker-right-side-wrapper",
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("label", {
                className: "stat-picker-right-side-title",
                children: "Selected Stats (drag to reorder)"
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                className: "stat-picker-right-side-scroll",
                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $7d57415ac2032ee5$export$a6431530a8ce8288), {
                    sensors: sensors,
                    onDragOver: handleDragOver,
                    modifiers: [
                        (0, $b2d051ff65b2716c$export$2d8564a14f5fec69)
                    ],
                    plugins: (defaults)=>defaults.filter((plugin)=>plugin !== (0, $4e1e107797f01458$export$305ce2ba97930a0b)),
                    children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("svg", {
                        style: {
                            width: '100%',
                            height: `${rightSideSvgHeight}px`
                        },
                        children: (()=>{
                            let currentY = 5;
                            return existingDraftTypes.map((type)=>{
                                const groupStats = groupedDraft[type];
                                if (groupStats.length === 0) return null;
                                const headerY = currentY;
                                currentY += (0, $c30e918aac675a8e$export$cdb7fd9d999c7168);
                                const groupStartY = currentY;
                                const statNodes = groupStats.map((stat, i)=>/*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $e24093eca76cedb8$export$2e2bcd8739ae039), {
                                        stat: stat,
                                        draftSelected: draftSelected,
                                        type: type,
                                        index: i,
                                        groupRefs: groupRefs,
                                        currentType: currentType,
                                        handleToggleStat: handleToggleStat
                                    }, stat));
                                currentY += groupStats.length * (0, $c30e918aac675a8e$export$88e6c5bab2ff80e8);
                                let sectionTitle = type;
                                if (type === 'batting') sectionTitle = 'BATTING/PITCHING';
                                else if (type === 'pitch_arsenal') sectionTitle = 'PITCH ARSENAL';
                                return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                    children: [
                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                                            x: 8,
                                            y: headerY + 16,
                                            className: "stat-picker-drag-header-text",
                                            children: sectionTitle
                                        }),
                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                                            ref: (el)=>{
                                                groupRefs.current[type] = el;
                                            },
                                            transform: `translate(0, ${groupStartY})`,
                                            children: statNodes
                                        })
                                    ]
                                }, `draft-group-${type}`);
                            });
                        })()
                    })
                })
            })
        ]
    });
}




const $0ab6c81ecb67ced0$var$PITCH_NAMES = {
    ff: '4-Seam Fastball',
    si: 'Sinker',
    fc: 'Cutter',
    ch: 'Changeup',
    fs: 'Splitter',
    fo: 'Forkball',
    sc: 'Screwball',
    cu: 'Curveball',
    sl: 'Slider',
    st: 'Sweeper',
    sv: 'Slurve',
    kn: 'Knuckleball'
};
function $0ab6c81ecb67ced0$export$2e2bcd8739ae039({ statRef: statRef, stats: stats, selected: selected, currentType: currentType, showTitle: showTitle, showTeams: showTeams, selectedPlayers: selectedPlayers, onAdd: onAdd }) {
    const [searchFilter, setSearchFilter] = (0, $63Xef.useState)('');
    const [draftSelected, setDraftSelected] = (0, $63Xef.useState)(selected);
    const [flashingStat, setFlashingStat] = (0, $63Xef.useState)(null);
    const [expandedPitches, setExpandedPitches] = (0, $63Xef.useState)([]);
    const togglePitchDrawer = (pitch)=>{
        setExpandedPitches((prev)=>prev.includes(pitch) ? prev.filter((p)=>p !== pitch) : [
                ...prev,
                pitch
            ]);
    };
    // Force a re-render once the DOM is painted (allows for the g elements defining
    // drag-drop groups to actually exist)
    const [, setIsMounted] = (0, $63Xef.useState)(false);
    (0, $63Xef.useEffect)(()=>{
        setIsMounted(true);
    }, []);
    (0, $63Xef.useEffect)(()=>{
        setDraftSelected(selected);
        const activePitchPrefixes = new Set();
        selected.forEach((stat)=>{
            const prefix = stat.split('_')[0];
            if ($0ab6c81ecb67ced0$var$PITCH_NAMES[prefix]) activePitchPrefixes.add(prefix);
        });
        setExpandedPitches(Array.from(activePitchPrefixes));
    }, [
        selected
    ]);
    const handleApplyRef = (0, $63Xef.useRef)(()=>onAdd(draftSelected));
    (0, $63Xef.useEffect)(()=>{
        handleApplyRef.current = ()=>onAdd(draftSelected);
    });
    (0, $63Xef.useEffect)(()=>{
        if (!statRef.current) return;
        statRef.current.addEventListener('toggle', (e)=>{
            if (e.newState !== 'closed') return;
            handleApplyRef.current();
        });
    }, [
        statRef
    ]);
    const dimensions = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    const { isMobile: isMobile } = dimensions;
    const isFull = (0, $3bbd855fb8f896f2$export$4942fc4b735d021a)(draftSelected, currentType, showTitle, showTeams, false, dimensions);
    const filteredStats = stats.filter((d)=>{
        if (searchFilter === '') return true;
        if (!(0, $89d260932605bcde$export$7b1f6a215293eaeb)[d]) return true;
        return (0, $89d260932605bcde$export$7b1f6a215293eaeb)[d].toLowerCase().includes(searchFilter.toLowerCase());
    });
    const handleToggleStat = (stat)=>{
        const isSelected = draftSelected.includes(stat);
        // If it's not already selected and the picker is full, don't allow adding.
        if (!isSelected && isFull) return;
        if (isSelected) setDraftSelected((prev)=>prev.filter((s)=>s !== stat));
        else {
            setFlashingStat(stat);
            setTimeout(()=>setFlashingStat(null), 150);
            setDraftSelected((prev)=>[
                    ...prev,
                    stat
                ]);
        }
    };
    const groupedStats = (0, $89d260932605bcde$export$f03f2f56ee474855)(filteredStats, currentType);
    const handleSelectDefaults = (0, $63Xef.useCallback)((defaultStats)=>{
        const availableStats = stats;
        const applicableDefaults = defaultStats.filter((stat)=>availableStats.includes(stat));
        setDraftSelected(applicableDefaults);
    }, [
        stats
    ]);
    const groupedDraft = (0, $89d260932605bcde$export$f03f2f56ee474855)(draftSelected, currentType);
    const existingDraftTypes = Object.keys(groupedDraft).filter((type)=>groupedDraft[type].length > 0);
    const renderStatNode = (stat)=>{
        const isSelected = draftSelected.includes(stat);
        const isFlashing = flashingStat === stat;
        let backgroundColor = 'white';
        if (isSelected) backgroundColor = '#e6e6e6';
        if (isFlashing) backgroundColor = 'rgba(57, 144, 152, 0.4)';
        return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
            onClick: ()=>handleToggleStat(stat),
            className: "stat-picker-scroll-element",
            style: {
                cursor: isSelected || isFull ? 'default' : 'pointer',
                background: backgroundColor,
                opacity: isSelected ? 0.6 : 1
            },
            children: stat === 'percent_rank_swing_take_run_value' && currentType === 'pitcher' ? 'Pitching' : (0, $89d260932605bcde$export$7b1f6a215293eaeb)[stat]
        }, stat);
    };
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
        popover: 'auto',
        id: "stat-search",
        ref: statRef,
        className: "stat-picker-popover comp-tool-popover",
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("style", {
                children: `
                ${isMobile ? `
                    .stat-picker-popover {
                        width: 95vw !important;
                        padding: 10px;
                    }
                    .stat-picker-overall-wrapper {
                        gap: 10px; 
                    }
                    .stat-picker-left-side-wrapper {
                        flex: 0 0 190px;
                    }
                    .stat-picker-right-side-wrapper {
                        flex: 1;
                        min-width: 0;
                    }
                    .stat-picker-button-wrapper {
                        flex-direction: column; 
                        gap: 2px;
                    }
                    .stat-picker-default-button {
                        font-size: 10px; 
                        padding: 4px;
                        margin-top: 0;
                    }
                    .stat-picker-scroll-element {
                        font-size: 10px;
                        padding: 6px 10px 4px; 
                        word-break: break-word;
                    }
                    #stat-picker-search-bar {
                        font-size: 10px;
                    }
                ` : ''}
            `
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("h3", {
                        style: {
                            margin: '5px'
                        },
                        children: "Choose & Order Stats"
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            const popover = document.getElementById('stat-search');
                            if (popover && 'hidePopover' in popover) popover.hidePopover();
                        },
                        className: "modal-close-button",
                        "aria-label": "Close Popover",
                        children: "\xd7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                className: "stat-picker-overall-wrapper",
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                        className: "stat-picker-left-side-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                                className: "stat-picker-button-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn-default stat-picker-default-button",
                                        onClick: ()=>handleSelectDefaults((0, $b9c7b02947e449f9$export$e390961395122d59)),
                                        children: "Batting Defaults"
                                    }),
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn-default stat-picker-default-button",
                                        onClick: ()=>handleSelectDefaults((0, $b9c7b02947e449f9$export$6566ad5760f0adbd)),
                                        children: "Pitching Defaults"
                                    }),
                                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn-default stat-picker-default-button",
                                        onClick: ()=>handleSelectDefaults((0, $b9c7b02947e449f9$export$774c5be6702fcac5)),
                                        children: "Catching Defaults"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("input", {
                                className: "form-control comp-tool-search",
                                id: "stat-picker-search-bar",
                                type: "text",
                                placeholder: "Search by stat name",
                                value: searchFilter,
                                onChange: (e)=>setSearchFilter(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                                className: "stat-picker-scroll-menu",
                                children: Object.keys(groupedStats).filter((key)=>{
                                    if (currentType === 'batter') return [
                                        'batting',
                                        'fielding',
                                        'catching',
                                        'running',
                                        'value',
                                        'pitch_arsenal'
                                    ].includes(key);
                                    return [
                                        'batting',
                                        'pitching',
                                        'value',
                                        'pitch_arsenal'
                                    ].includes(key);
                                }).map((groupKey)=>{
                                    const key = groupKey;
                                    const statsInGroup = groupedStats[key];
                                    // Only render the group if it contains stats matching the filter
                                    if (statsInGroup.length === 0) return null;
                                    let sectionTitle = key;
                                    if (key === 'batting') sectionTitle = 'BATTING/PITCHING';
                                    else if (key === 'pitch_arsenal') sectionTitle = currentType === 'batter' ? 'PITCH ARSENAL (OPP. PITCHERS)' : 'PITCH ARSENAL';
                                    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $936844e92beee7ef$export$2e2bcd8739ae039), {
                                        keyName: key,
                                        sectionTitle: sectionTitle,
                                        statsInGroup: statsInGroup,
                                        expandedPitches: expandedPitches,
                                        searchFilter: searchFilter,
                                        selectedPlayers: selectedPlayers,
                                        togglePitchDrawer: togglePitchDrawer,
                                        renderStatNode: renderStatNode
                                    }, key);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $6e144ceb09804690$export$2e2bcd8739ae039), {
                        draftSelected: draftSelected,
                        setDraftSelected: setDraftSelected,
                        existingDraftTypes: existingDraftTypes,
                        currentType: currentType,
                        handleToggleStat: handleToggleStat
                    })
                ]
            }),
            isFull ? /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                style: {
                    textAlign: 'center',
                    color: 'red',
                    marginTop: '4px',
                    fontSize: '12px'
                },
                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                    children: "Your stats menu is full. To add other stats, deselect one or more selected items."
                })
            }) : null,
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                style: {
                    marginTop: isFull ? '4px' : '15px',
                    textAlign: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn-default",
                        style: {
                            padding: '5px',
                            marginRight: '0.5rem'
                        },
                        onClick: ()=>setDraftSelected([]),
                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("span", {
                            children: "Clear Stats"
                        })
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn-default",
                        style: {
                            padding: '5px'
                        },
                        onClick: ()=>{
                            statRef.current?.hidePopover();
                            onAdd(draftSelected);
                        },
                        children: "Apply Changes"
                    })
                ]
            })
        ]
    });
}


/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable import/no-extraneous-dependencies */ 

var $63Xef = parcelRequire("63Xef");









function $57dcd83b3f7f2771$var$getLabelToUse(strippedKey, isMobile, currentType) {
    const mapToUse = isMobile ? (0, $89d260932605bcde$export$fecc1e7a239dc298) : (0, $89d260932605bcde$export$7b1f6a215293eaeb);
    return currentType === 'pitcher' && strippedKey === 'percent_rank_swing_take_run_value' ? 'Pitching' : mapToUse[strippedKey];
}
function $57dcd83b3f7f2771$var$StatColumn(props) {
    const { groupedSelects: groupedSelects, currentType: currentType, existingTypes: existingTypes, onRemoveStat: onRemoveStat, onStatReorder: onStatReorder, selectedStats: selectedStats, showTeams: showTeams, winnerStats: winnerStats, onAddWinnerStat: onAddWinnerStat } = props;
    const { TEXT_RIGHT_SIDE: TEXT_RIGHT_SIDE, TOP_BUFFER: TOP_BUFFER, isMobile: isMobile } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    const [hoveredStat, setHoveredStat] = (0, $63Xef.useState)(null);
    const groupRefs = (0, $63Xef.useRef)({});
    const sensors = (0, $63Xef.useMemo)(()=>[
            (0, $4e1e107797f01458$export$b26af955418d6638).configure({
                activationConstraints: [
                    new (0, $4e1e107797f01458$export$863a6e64d6b9f7f4).Distance({
                        value: 8
                    }),
                    new (0, $4e1e107797f01458$export$863a6e64d6b9f7f4).Delay({
                        value: isMobile ? 800 : 200,
                        tolerance: isMobile ? 5 : 10
                    })
                ]
            })
        ], []);
    let numStatsSeen = 0;
    const statGroupings = existingTypes.map((type, groupingsSeen)=>{
        const statLabels = groupedSelects[type].map((strippedKey, i)=>{
            const globalIndex = selectedStats.indexOf(strippedKey);
            const yVal = i * (0, $c30e918aac675a8e$export$42510bee89f29ff9);
            let arsenalPitchType;
            let arsenalPitchStat;
            const isArsenal = (0, $89d260932605bcde$export$7137f82dfb412109).has(strippedKey);
            if (isArsenal) [arsenalPitchType, arsenalPitchStat] = strippedKey.split('_percent_rank_');
            const isWinnerStat = winnerStats?.includes(strippedKey);
            return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $2f9510a59088c740$export$2e2bcd8739ae039), {
                id: strippedKey,
                index: globalIndex,
                groupName: `stats-${type}`,
                offset: yVal,
                container: groupRefs.current[type],
                type: "stat",
                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                    onMouseEnter: ()=>setHoveredStat(strippedKey),
                    onMouseLeave: ()=>setHoveredStat(null),
                    style: {
                        cursor: 'pointer'
                    },
                    children: [
                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                            x: -55,
                            y: 0,
                            width: TEXT_RIGHT_SIDE + 40,
                            height: (0, $c30e918aac675a8e$export$42510bee89f29ff9),
                            fill: "transparent"
                        }),
                        isArsenal && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $e21cf1d0016f27b0$export$2e2bcd8739ae039), {
                            x: TEXT_RIGHT_SIDE + 4,
                            y: (0, $c30e918aac675a8e$export$5bd7984ead021b84),
                            pitchType: arsenalPitchType,
                            statName: arsenalPitchStat,
                            flipOrder: true,
                            textClass: "label-text",
                            rightJustify: true
                        }),
                        !isArsenal && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                            x: TEXT_RIGHT_SIDE,
                            y: (0, $c30e918aac675a8e$export$5bd7984ead021b84),
                            className: "label-text",
                            style: {
                                fontFamily: 'Roboto Condensed'
                            },
                            children: $57dcd83b3f7f2771$var$getLabelToUse(strippedKey, isMobile, currentType)
                        }),
                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                            x: isMobile ? -79 : -56,
                            y: 12,
                            fill: isWinnerStat ? '#FFD700' : '#a0a0a0',
                            style: {
                                opacity: hoveredStat === strippedKey ? 1 : 0,
                                pointerEvents: hoveredStat === strippedKey || isWinnerStat ? 'auto' : 'none'
                            },
                            className: "winner-button-star-elem",
                            onClick: (e)=>{
                                e.stopPropagation();
                                if (onAddWinnerStat) onAddWinnerStat(strippedKey);
                            },
                            children: isWinnerStat ? "\u2605" : "\u2606"
                        }),
                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                            onClick: (e)=>{
                                e.stopPropagation();
                                onRemoveStat(strippedKey);
                            },
                            style: {
                                opacity: hoveredStat === strippedKey ? 1 : 0,
                                pointerEvents: hoveredStat === strippedKey ? 'auto' : 'none'
                            },
                            className: "remove-button-x-elem",
                            children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $5d4181c52df08ae8$export$2e2bcd8739ae039), {
                                x: isMobile ? -57 : -30,
                                y: (0, $c30e918aac675a8e$export$5bd7984ead021b84) + 5,
                                symbol: "\xd7"
                            })
                        })
                    ]
                })
            }, strippedKey);
        });
        // const headersOffset = STAT_HEADER_GAP * (groupingsSeen + 1)
        const headersOffset = (groupingsSeen + 1) * (0, $c30e918aac675a8e$export$ffbf6d1bcd3c71b1) + (groupingsSeen + 1) * (0, $c30e918aac675a8e$export$32080fe92cae43a2);
        const statsOffset = numStatsSeen * (0, $c30e918aac675a8e$export$42510bee89f29ff9);
        const teamOffset = showTeams ? 0 : -(0, $c30e918aac675a8e$export$efd0951432a78968);
        numStatsSeen += groupedSelects[type].length;
        const labels = /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
            ref: (el)=>{
                groupRefs.current[type] = el;
            },
            transform: `translate(0,${headersOffset + statsOffset + teamOffset})`,
            children: statLabels
        }, `${type}_stat_grouping`);
        return labels;
    });
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $7d57415ac2032ee5$export$a6431530a8ce8288), {
        sensors: sensors,
        onDragOver: onStatReorder,
        modifiers: [
            (0, $b2d051ff65b2716c$export$2d8564a14f5fec69)
        ],
        plugins: (defaults)=>defaults.filter((plugin)=>plugin !== (0, $4e1e107797f01458$export$305ce2ba97930a0b)),
        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
            transform: `translate(${(0, $c30e918aac675a8e$export$b33658ea466e9e34)}, ${TOP_BUFFER})`,
            children: statGroupings
        })
    });
}
var $57dcd83b3f7f2771$export$2e2bcd8739ae039 = $57dcd83b3f7f2771$var$StatColumn;


// eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");
// eslint-disable-next-line import/no-extraneous-dependencies


var $63Xef = parcelRequire("63Xef");


const $b90893832bf2e332$var$VALUE_IMAGE_PATH = '/sections/player-update/images/sliders/slider-trophy.png';
const $b90893832bf2e332$var$BATTING_IMAGE_PATH = '/sections/player-update/images/sliders/slider-batter.png';
const $b90893832bf2e332$var$CATCHING_IMAGE_PATH = '/sections/player-update/images/sliders/slider-catcher.png';
const $b90893832bf2e332$var$RUNNING_IMAGE_PATH = '/sections/player-update/images/sliders/slider-runner.png';
const $b90893832bf2e332$var$FIELDING_IMAGE_PATH = '/sections/player-update/images/sliders/slider-fielder.png';
const $b90893832bf2e332$var$PITCHING_IMAGE_PATH = '/sections/player-update/images/sliders/slider-pitcher.png';
const $b90893832bf2e332$var$pathVarMap = {
    value: $b90893832bf2e332$var$VALUE_IMAGE_PATH,
    batting: $b90893832bf2e332$var$BATTING_IMAGE_PATH,
    catching: $b90893832bf2e332$var$CATCHING_IMAGE_PATH,
    running: $b90893832bf2e332$var$RUNNING_IMAGE_PATH,
    fielding: $b90893832bf2e332$var$FIELDING_IMAGE_PATH,
    pitching: $b90893832bf2e332$var$PITCHING_IMAGE_PATH,
    pitch_arsenal: $b90893832bf2e332$var$PITCHING_IMAGE_PATH
};
function $b90893832bf2e332$var$getSectionName(type, currentType, onlyArsenal, isMobile) {
    if (type === 'value') return 'Run Value';
    if (type === 'pitch_arsenal') {
        if (currentType === 'batter') {
            if (onlyArsenal) return 'Pitch Arsenal';
            return 'Pitch Arsenal (Opp. Pitchers)';
        }
        return onlyArsenal && isMobile ? 'Arsenal' : 'Pitch Arsenal';
    }
    return `${type.charAt(0).toUpperCase() + type.slice(1)}`;
}
function $b90893832bf2e332$var$SectionHeader(props) {
    const { type: type, numPlayers: numPlayers, maxSliderWidth: maxSliderWidth, currentType: currentType, onlyArsenal: onlyArsenal, isMobile: isMobile } = props;
    const { SLIDER_OFFSET_FROM_TEXT: SLIDER_OFFSET_FROM_TEXT, BETWEEN_PLAYERS_BUFFER: BETWEEN_PLAYERS_BUFFER } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    const pathVar = $b90893832bf2e332$var$pathVarMap[type];
    const [imageBase64, setImageBase64] = (0, $63Xef.useState)(null);
    (0, $63Xef.useEffect)(()=>{
        fetch(pathVar).then((response)=>{
            if (!response.ok) throw new Error('Failed to fetch local image');
            return response.blob();
        }).then((blob)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>{
                setImageBase64(reader.result);
            };
            reader.readAsDataURL(blob);
        }).catch((err)=>console.error('Failed to load section image', err));
    }, [
        pathVar
    ]);
    const rightSideX = (0, $c30e918aac675a8e$export$5027f20781e606c3) + SLIDER_OFFSET_FROM_TEXT + numPlayers * (BETWEEN_PLAYERS_BUFFER + maxSliderWidth) - BETWEEN_PLAYERS_BUFFER;
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
        children: [
            imageBase64 && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("image", {
                href: imageBase64,
                "aria-label": `${type} logo`,
                x: "7",
                y: "0",
                width: "45",
                height: "45",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                x: "50",
                y: "35",
                className: "section-header-text-label",
                style: {
                    fontFamily: 'Roboto Condensed'
                },
                children: $b90893832bf2e332$var$getSectionName(type, currentType, onlyArsenal, isMobile)
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("line", {
                x1: (0, $c30e918aac675a8e$export$b33658ea466e9e34),
                x2: rightSideX,
                y1: "42",
                y2: "42",
                className: "section-header-line"
            })
        ]
    });
}
var $b90893832bf2e332$export$2e2bcd8739ae039 = $b90893832bf2e332$var$SectionHeader;




function $1265ce229938dbe6$var$SectionHeaders(props) {
    const { numPlayers: numPlayers, groupedSelects: groupedSelects, existingTypes: existingTypes, maxSliderWidth: maxSliderWidth, showTeams: showTeams, currentType: currentType, isMobile: isMobile } = props;
    const { TOP_BUFFER: TOP_BUFFER } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    let statsSeen = 0;
    const typeHeaders = existingTypes.map((type, i)=>{
        const headersOffset = i * ((0, $c30e918aac675a8e$export$ffbf6d1bcd3c71b1) + (0, $c30e918aac675a8e$export$32080fe92cae43a2));
        const statsOffset = statsSeen * (0, $c30e918aac675a8e$export$42510bee89f29ff9);
        const teamOffset = showTeams ? 0 : -(0, $c30e918aac675a8e$export$efd0951432a78968);
        const yOffset = headersOffset + statsOffset + teamOffset;
        const header = /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
            transform: `translate(0,${yOffset})`,
            children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $b90893832bf2e332$export$2e2bcd8739ae039), {
                type: type,
                numPlayers: numPlayers,
                maxSliderWidth: maxSliderWidth,
                currentType: currentType,
                isMobile: isMobile,
                onlyArsenal: existingTypes.length === 1 && type === 'pitch_arsenal'
            }, `${type}_section_header`)
        }, type);
        statsSeen += groupedSelects[type].length;
        return header;
    });
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
        transform: `translate(${(0, $c30e918aac675a8e$export$b33658ea466e9e34)},${TOP_BUFFER})`,
        children: typeHeaders
    });
}
var $1265ce229938dbe6$export$2e2bcd8739ae039 = $1265ce229938dbe6$var$SectionHeaders;



// eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");
function $4a03643c08dcc28d$var$SavantLogo(props) {
    const { width: width } = props;
    const mainFontSize = width * 0.4;
    const subFontSize = width * 0.2;
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("svg", {
                x: -width / 2,
                y: 0,
                width: width,
                height: width,
                viewBox: "0 0 870 870",
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("style", {
                        children: `.st0{fill:#FFFFFF;}
                    .st1{fill:#EF4C28;}
                    .st2{fill:#B4B4B5;}
                    .st3{fill:#489299;}`
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("circle", {
                        className: "st0",
                        cx: "430.67",
                        cy: "431.42",
                        r: "397.03"
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M702.07,165.14l-24.36,16.93l-5.5-44.43c0.18-0.2,0.3-0.46,0.54-0.66c10.67,9,21.92,19.73,29.22,26.89    L702.07,165.14z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M608.58,218.87l-0.29-33.19c11.21-5.35,21.2-11.33,30.31-17.89l0.29,38.06L608.58,218.87z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M526.71,240.43l10.21-33.08c12.63-2.15,24.24-4.71,35.09-7.92l-10.53,33.89L526.71,240.43z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M479.64,244.99l0.14,0.14l-31.72,1.68l20.29-33.55c11.64-0.26,22.67-0.83,33.06-1.6l-20.1,33.12    L479.64,244.99z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M375.03,243.14l23.96-32.04c10.18,0.73,19.91,1.22,29.39,1.66l-26.02,34.95L375.03,243.14z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M306.89,231.95l29.16-30.37c9.18,2.05,18.44,3.82,27.75,5.27l-29.37,30.61L306.89,231.95z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M245.64,208.97l29.84-25.14c8.07,2.91,16.2,5.58,24.38,8.11l-30.72,25.95L245.64,208.97z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M194.93,181.64l30.15-18.72c7.57,3.54,15.27,6.89,22.98,10.26l-32.96,20.42L194.93,181.64z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M150.3,151.93l29.16-12.59c7.21,4.03,14.54,7.94,21.87,11.81l-33.19,14.49L150.3,151.93z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M676.63,185.55l49.37,11.98c-10.11,7.55-20.57,14.61-31.38,21.24l-53.83-13.54L676.63,185.55z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M605.88,220.36l50.34,19.12c-12.25,5.79-24.81,10.98-37.62,15.68l-55.47-21.84L605.88,220.36z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M481.16,245.07l0.15-0.28l44.78-3.85l41.6,29.56c-13.87,3.23-27.99,5.98-42.05,7.97l-45.86-33.34    L481.16,245.07z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M444.23,246.94l26.23,35.98c-7.36,0.2-14.64,0.16-21.9-0.08c-6.91-0.25-13.59-0.76-20.34-1.17l-24.59-34.79    L444.23,246.94z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M372.39,245l23.38,33.59c-12.61-1.66-25.14-3.5-37.25-5.89l-22.9-33.9L372.39,245z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M305.92,231.84l18.05,32.66c-11.41-3.07-22.52-6.5-33.28-10.21l-18.13-33.96L305.92,231.84z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M243.31,208.2l11.37,32.37c-9.73-4.16-19.08-8.45-28.12-13.07l-11.25-33.38L243.31,208.2z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M192.42,181.16l5.4,30.92c-8.26-4.81-16.26-9.66-23.95-14.73l-5.23-31.17L192.42,181.16z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M206.77,744.94l0.23,0l-0.07,0.01l26.8-10.14l0.25,0.21l0.13-0.04l1.94,32.72    c-8.9,3.27-17.82,5.74-26.84,7.65L206.77,744.94L206.77,744.94z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M285.59,702.62l1.57,39.27c-7.96,5.06-15.99,9.78-24.15,13.99l-1.53-36.31L285.59,702.62z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M327.37,664.81l6.22,42.16c-6.98,6.01-14.15,11.84-21.29,17.28l-5.75-38.76L327.37,664.81z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M365.89,623.21l11.72,42.28c-6.52,6.65-13.22,13.22-20.04,19.77l-11.15-39.78L365.89,623.21z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M440.77,533.15L454,581.91c-6.09,6.82-12.77,14.22-19.63,21.92l-13.31-48.78L440.77,533.15z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M480.8,496.46l11.71,47.75c-4.95,4.22-9.86,8.53-14.72,13.14c-2.07,1.94-4.42,4.19-6.64,6.5l-12.02-49.52    L480.8,496.46z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M535.07,464.09l5.11,47.17c-9.15,4.93-18.04,10.68-26.84,16.97l-5.55-50.18L535.07,464.09z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M598.97,445.76l0.93,45.04c-10.57,1.85-20.86,4.28-30.71,7.76l-0.92-46.49L598.97,445.76z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M675.66,443.76l-10.93,47.71c-10.8-1.86-21.09-2.68-31.11-2.91l10.69-46.77L675.66,443.76z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M750.25,462.97l-23.47,47.14c-10.63-4.4-20.81-7.99-30.77-10.98l23.56-47.17L750.25,462.97z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M788.38,483.72l-0.23-0.37l24.78,15.68l-34.42,36.48c-9.43-5.25-18.49-10.04-27.39-14.46l35.93-38.04    L788.38,483.72z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M402.33,578.22l14.5,45.27c-6.11,6.83-12.52,13.9-19.16,20.93l-13.85-43.51L402.33,578.22z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M206.77,744.94l-32.59,2.46l-45.67-40.36c9.91,1.23,20.4,2.13,31.21,2.35c2.7-0.01,5.29-0.3,7.88-0.44    l39.32,35.99L206.77,744.94z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M234.11,734.97l0.01-0.26l-0.39,0.1l-41.28-29.88c10.07-2.97,20.03-7.39,29.8-12.86l38.76,28.36    L234.11,734.97z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M327.3,664.73l-42.99-22.11c6.39-6.36,12.64-13.12,18.84-19.9l43.22,22.2L327.3,664.73z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M285.6,702.52l-39.64-26.06c7.18-5.43,14.37-11.21,21.36-17.54l39.38,25.88L285.6,702.52z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M365.33,623.03l-45.4-19.31c5.96-6.96,11.87-13.99,17.78-21.11l45.41,19.3L365.33,623.03z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M402.51,576.83l-43.53-20.07c5.86-7.19,11.58-14.17,17.29-21.09l44.5,20.59L402.51,576.83z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M439.41,532.45l-40.2-23.33c6.26-6.92,12.51-13.38,18.96-19.59l41.47,24.05L439.41,532.45z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M480.56,496.04l-43.84-23.19c7.51-6.35,15.17-12.27,22.97-17.8l46.49,24.37L480.56,496.04z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M535.09,463.92l-34.96-33.78c9.25-4.83,18.45-9.09,27.76-12.86l35.62,34.87L535.09,463.92z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M602.33,444.16l-38.06-38.75c12.08-3.09,24.2-5.47,36.23-6.93l41.84,43.12L602.33,444.16z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M677.64,443.7l-35.48-47.17c12.77,0.32,25.22,1.63,37.58,3.75l38.54,52.04L677.64,443.7z"
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                                className: "st1",
                                d: "M787.26,482.76l-0.21,0.25l-36.09-20.37l-20.18-48.11c12.74,5.17,24.9,11.27,36.54,18.39l20.83,50.44    L787.26,482.76z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                        className: "st2",
                        d: "M849.08,404.16l-0.41-6.4l-53.12,3.41l0.41,6.4c0.51,7.89,0.76,15.91,0.76,23.85   c0,45.56-8.17,89.76-24.28,131.4c-43.2,113-139.99,197.2-258.92,225.24l-6.22,1.47l12,51.86l6.27-1.48   c136.2-32.11,247.06-128.56,296.54-257.98c18.47-47.72,27.83-98.36,27.83-150.51C849.95,422.31,849.66,413.14,849.08,404.16z"
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                        className: "st1",
                        d: "M848.11,404.22L848.11,404.22c-5.29-82.65-35.06-161.26-86.08-227.35c-50-64.75-116.97-113.27-193.68-140.32   l-5.15-1.82l-16.96,48.41l5.13,1.81c67.32,23.74,126.12,66.36,170.06,123.27c44.75,57.95,70.86,126.87,75.49,199.28l0.35,5.44   l51.19-3.29L848.11,404.22z"
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                        className: "st3",
                        d: "M568.49,36.09c-44.71-15.57-91.08-23.47-137.83-23.47c-230.93,0-418.8,187.87-418.8,418.8   c0,230.93,187.87,418.8,418.8,418.8c30.94,0,63.7-3.73,94.75-10.77l5.81-1.32l-11.78-50.92l-5.76,1.31   c-27.19,6.17-55.9,9.44-83.01,9.44c-202.11,0-366.54-164.43-366.54-366.54c0-202.11,164.43-366.54,366.54-366.54   c40.88,0,81.44,6.91,120.56,20.53l5.59,1.95l17.29-49.32L568.49,36.09z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                x: 0,
                y: width,
                className: "comp-tool-logo-text comp-tool-logo-main-text",
                style: {
                    fontSize: `${mainFontSize}px`,
                    fontFamily: 'Roboto Condensed'
                },
                children: "savant"
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                x: 0,
                y: width * 7 / 5,
                className: "comp-tool-logo-text comp-tool-logo-sub-text",
                style: {
                    fontSize: `${subFontSize}px`,
                    fontFamily: 'Roboto Condensed'
                },
                children: "Player Comparison Tool"
            })
        ]
    });
}
var $4a03643c08dcc28d$export$2e2bcd8739ae039 = $4a03643c08dcc28d$var$SavantLogo;


/* eslint-disable react/jsx-props-no-spreading */ 
parcelRequire("63Xef");
/* eslint-disable jsx-a11y/label-has-associated-control */ // eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");
function $7c08a8a7de1f4ab1$export$2e2bcd8739ae039({ name: name, type: type, val: val, onClick: onClick, disabled: disabled }) {
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.25rem',
            opacity: disabled ? 0.5 : 1
        },
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("label", {
                htmlFor: `show-${type}-toggle`,
                style: {
                    fontWeight: 'bold',
                    lineHeight: '24px',
                    margin: 0,
                    cursor: disabled ? 'not-allowed' : 'pointer'
                },
                children: name
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                id: `show-${type}-toggle`,
                type: "button",
                onClick: ()=>{
                    if (!disabled) onClick(!val);
                },
                style: {
                    width: '44px',
                    height: '24px',
                    backgroundColor: val ? '#399098' : '#ccc',
                    borderRadius: '12px',
                    border: 'none',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    padding: '2px',
                    position: 'relative',
                    transition: 'background-color 0.3s',
                    display: 'flex',
                    alignItems: 'center',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                    style: {
                        width: '20px',
                        height: '20px',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        transition: 'transform 0.3s',
                        transform: val ? 'translateX(20px)' : 'translateX(0px)'
                    }
                })
            })
        ]
    });
}


function $f3ae1b4b7becc640$export$2e2bcd8739ae039({ showWinner: showWinner, setShowWinner: setShowWinner, showValues: showValues, setShowValues: setShowValues, showTitle: showTitle, setShowTitle: setShowTitle, showTeams: showTeams, setShowTeams: setShowTeams, title: title, setTitle: setTitle, handleDownload: handleDownload, disableToggleTitle: disableToggleTitle }) {
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
        popover: 'auto',
        id: "settings-popover",
        className: "comp-tool-popover",
        style: {
            backgroundColor: '#ffffff',
            color: '#111111',
            border: '4px solid #333333',
            padding: '1.5rem',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.5)',
            width: '280px',
            height: '350px',
            boxSizing: 'border-box'
        },
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("h3", {
                        style: {
                            margin: 0
                        },
                        children: "Settings"
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            const popover = document.getElementById('settings-popover');
                            if (popover && 'hidePopover' in popover) popover.hidePopover();
                        },
                        className: "modal-close-button",
                        "aria-label": "Close Settings",
                        children: "\xd7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("hr", {
                style: {
                    borderTop: '1px solid #555555',
                    marginBottom: '1rem',
                    marginTop: '0'
                }
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $7c08a8a7de1f4ab1$export$2e2bcd8739ae039), {
                        name: "Highlight Winner",
                        type: "winner",
                        val: showWinner,
                        onClick: setShowWinner
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $7c08a8a7de1f4ab1$export$2e2bcd8739ae039), {
                        name: "Show Values",
                        type: "values",
                        val: showValues,
                        onClick: setShowValues
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $7c08a8a7de1f4ab1$export$2e2bcd8739ae039), {
                        name: "Show Teams",
                        type: "teams",
                        val: showTeams,
                        onClick: setShowTeams
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $7c08a8a7de1f4ab1$export$2e2bcd8739ae039), {
                        name: "Add Title",
                        type: "title",
                        val: showTitle,
                        onClick: setShowTitle,
                        disabled: disableToggleTitle
                    }),
                    !showTitle && disableToggleTitle && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                        style: {
                            fontSize: '11px',
                            color: 'red'
                        },
                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                            children: "Too many stats selected to add title; remove some to make room."
                        })
                    }),
                    showTitle && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.2rem',
                            marginBottom: '0.5rem'
                        },
                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("input", {
                            id: "custom-title-input",
                            type: "text",
                            value: title,
                            onChange: (e)=>setTitle(e.target.value),
                            placeholder: "Enter chart title...",
                            maxLength: 50,
                            style: {
                                padding: '0.4rem',
                                border: '1px solid #cccccc',
                                borderRadius: '4px',
                                fontSize: '0.9rem',
                                fontFamily: 'inherit'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn-default",
                        onClick: ()=>{
                            const popover = document.getElementById('settings-popover');
                            if (popover && 'hidePopover' in popover) popover.hidePopover();
                            handleDownload();
                        },
                        style: {
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            marginBottom: '0px'
                        },
                        children: "Download Image (Square)"
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn-default",
                        onClick: ()=>{
                            const popover = document.getElementById('settings-popover');
                            if (popover && 'hidePopover' in popover) popover.hidePopover();
                            handleDownload(true);
                        },
                        style: {
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            marginTop: '0px'
                        },
                        children: "Download Image (16 x 9)"
                    })
                ]
            })
        ]
    });
}







// eslint-disable-next-line import/no-extraneous-dependencies

parcelRequire("63Xef");

function $8269aba2020fb66f$var$ExportDateStamp({ width: width, height: height }) {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const formattedDate = yesterday.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                x: 30,
                y: height - 15,
                textAnchor: "start",
                fontSize: "11px",
                fill: (0, $c30e918aac675a8e$export$2200862f6453cab4),
                children: "Slashed bars with no numbers indicate that the player has not qualified in that metric."
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("text", {
                x: width - 30,
                y: height - 15,
                textAnchor: "end",
                fontSize: "11px",
                fill: (0, $c30e918aac675a8e$export$2200862f6453cab4),
                children: [
                    "Data reflects games up to: ",
                    formattedDate
                ]
            })
        ]
    });
}
var $8269aba2020fb66f$export$2e2bcd8739ae039 = $8269aba2020fb66f$var$ExportDateStamp;


// eslint-disable-next-line import/no-extraneous-dependencies


var $63Xef = parcelRequire("63Xef");


function $ffe32689a08c22af$var$SettingsToggle() {
    const { SETTINGS_MENU_DIM: SETTINGS_MENU_DIM } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    const [hovered, setHovered] = (0, $63Xef.useState)(false);
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
        id: "comp-tool-settings-toggle",
        transform: `translate(${(0, $c30e918aac675a8e$export$e9c958d09f7b22f1)}, ${(0, $c30e918aac675a8e$export$e9c958d09f7b22f1)})`,
        style: {
            cursor: 'pointer',
            opacity: 0.5
        },
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        onClick: ()=>{
            const popover = document.getElementById('settings-popover');
            if (popover && 'showPopover' in popover) popover.showPopover();
        },
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                x: 0,
                y: 0,
                width: SETTINGS_MENU_DIM,
                height: SETTINGS_MENU_DIM,
                rx: 2,
                fill: hovered ? (0, $c30e918aac675a8e$export$2200862f6453cab4) : '#ffffff',
                stroke: (0, $c30e918aac675a8e$export$2200862f6453cab4),
                strokeWidth: 1,
                style: {
                    transition: 'fill 0.2s ease-in-out'
                }
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("svg", {
                x: 0,
                y: 0,
                width: SETTINGS_MENU_DIM,
                height: SETTINGS_MENU_DIM,
                viewBox: "-4 -4 32 32",
                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.5,
                    d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z",
                    stroke: hovered ? '#ffffff' : (0, $c30e918aac675a8e$export$2200862f6453cab4),
                    fill: "none",
                    style: {
                        transition: 'stroke 0.2s ease-in-out'
                    }
                })
            })
        ]
    });
}
var $ffe32689a08c22af$export$2e2bcd8739ae039 = $ffe32689a08c22af$var$SettingsToggle;


// eslint-disable-next-line import/no-extraneous-dependencies


var $63Xef = parcelRequire("63Xef");


function $c3d23191c71b1579$var$ShareButton({ isEmpty: isEmpty, onDownload: onDownload }) {
    const { SETTINGS_MENU_DIM: SETTINGS_MENU_DIM } = (0, $116a259e7f6314e7$export$d04af0e501fb729f)();
    const [hovered, setHovered] = (0, $63Xef.useState)(false);
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
        id: "comp-tool-share-button",
        // Shifted Y instead of X:
        transform: `translate(${(0, $c30e918aac675a8e$export$e9c958d09f7b22f1)}, ${(0, $c30e918aac675a8e$export$e9c958d09f7b22f1) + SETTINGS_MENU_DIM + 5})`,
        style: {
            cursor: 'pointer',
            opacity: 0.5
        },
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        onClick: ()=>{
            if (!isEmpty) onDownload();
        },
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                x: 0,
                y: 0,
                width: SETTINGS_MENU_DIM,
                height: SETTINGS_MENU_DIM,
                rx: 2,
                fill: hovered ? (0, $c30e918aac675a8e$export$2200862f6453cab4) : '#ffffff',
                stroke: (0, $c30e918aac675a8e$export$2200862f6453cab4),
                strokeWidth: 1,
                style: {
                    transition: 'fill 0.2s ease-in-out'
                }
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("svg", {
                x: 0,
                y: 0,
                width: SETTINGS_MENU_DIM,
                height: SETTINGS_MENU_DIM,
                viewBox: "-4 -4 32 32",
                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.5,
                    d: "M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M12 15V3m0 0L8 7m4-4l4 4",
                    stroke: hovered ? '#ffffff' : (0, $c30e918aac675a8e$export$2200862f6453cab4),
                    fill: "none",
                    style: {
                        transition: 'stroke 0.2s ease-in-out'
                    }
                })
            })
        ]
    });
}
var $c3d23191c71b1579$export$2e2bcd8739ae039 = $c3d23191c71b1579$var$ShareButton;


const $73d0d5c3cc042e8a$var$explicitInlineStyles = (originalElem, cloneElem)=>{
    const svgProperties = [
        'fill',
        'stroke',
        'stroke-width',
        'font-family',
        'font-size',
        'font-weight',
        'opacity',
        'display',
        'text-anchor',
        'dominant-baseline',
        'align-items',
        'justify-content',
        'gap',
        'text-transform',
        'color',
        'background-color',
        'border-radius',
        'border-top-left-radius',
        'border-top-right-radius',
        'border-bottom-left-radius',
        'border-bottom-right-radius',
        'width',
        'height',
        'padding',
        'padding-top',
        'padding-bottom',
        'padding-left',
        'padding-right',
        'margin-top',
        'margin-bottom',
        'margin-left',
        'margin-right',
        'white-space'
    ];
    const applyStylesRecursively = (orig, clone)=>{
        if (!(clone instanceof HTMLElement || clone instanceof SVGElement)) return;
        const computedStyles = window.getComputedStyle(orig);
        svgProperties.forEach((prop)=>{
            const value = computedStyles.getPropertyValue(prop);
            if (value) clone.style.setProperty(prop, value);
        });
        const origChildren = Array.from(orig.children);
        const cloneChildren = Array.from(clone.children);
        origChildren.forEach((origChild, index)=>{
            const cloneChild = cloneChildren[index];
            if (cloneChild) applyStylesRecursively(origChild, cloneChild);
        });
    };
    applyStylesRecursively(originalElem, cloneElem);
};
function $73d0d5c3cc042e8a$var$useComparisonState() {
    const initialDataToUse = [
        ...initialData
    ];
    const [selectedData, setSelectedData] = (0, $63Xef.useState)({
        players: initialDataToUse.map((dat, idx)=>({
                id: dat.uniqueId,
                displayOrder: idx
            })),
        dataToUse: initialDataToUse
    });
    const [selectedStats, setSelectedStats] = (0, $63Xef.useState)(initialStats);
    const [showWinner, setShowWinner] = (0, $63Xef.useState)(false);
    const [showValues, setShowValues] = (0, $63Xef.useState)(false);
    const [showTitle, setShowTitle] = (0, $63Xef.useState)(false);
    const [showTeams, setShowTeams] = (0, $63Xef.useState)(true);
    const [title, setTitle] = (0, $63Xef.useState)('');
    const [triggerSearchOpen, setTriggerSearchOpen] = (0, $63Xef.useState)(false);
    const [winnerStats, setWinnerStats] = (0, $63Xef.useState)([]);
    const [hiddenPlayers, setHiddenPlayers] = (0, $63Xef.useState)([]);
    // Parse URL params once on load to seed the title and optionally open search
    (0, $63Xef.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const presetTitle = urlParams.get('showTitle') === 'true';
        const presetTitleText = urlParams.get('title');
        if (presetTitle && presetTitleText && presetTitleText.length > 0) {
            setShowTitle(true);
            setTitle(presetTitleText);
        }
        const shouldOpenSearch = urlParams.get('openSearch') === 'true';
        const shouldShowWinners = urlParams.get('showWinner') === 'true';
        const shouldShowValues = urlParams.get('showValues') === 'true';
        const shouldHideTeams = urlParams.get('hideTeams') === 'true';
        if (shouldOpenSearch) setTriggerSearchOpen(true);
        if (shouldShowWinners) setShowWinner(true);
        if (shouldShowValues) setShowValues(true);
        if (shouldHideTeams) setShowTeams(false);
    }, []);
    // Keep the URL in sync with the current selection
    (0, $63Xef.useEffect)(()=>{
        const sortedIds = [
            ...selectedData.players
        ].sort((a, b)=>a.displayOrder - b.displayOrder).map((p)=>p.id);
        (0, $3bbd855fb8f896f2$export$88f1fdfae738af54)(sortedIds, selectedStats, showWinner, showValues, showTeams, showTitle, title);
    }, [
        selectedData,
        selectedStats,
        showWinner,
        showValues,
        showTitle,
        showTeams,
        title
    ]);
    // Open the player search whenever there are no players selected
    (0, $63Xef.useEffect)(()=>{
        if (selectedData.players.length === 0) setTriggerSearchOpen(true);
    }, [
        selectedData.players.length
    ]);
    return {
        selectedData: selectedData,
        setSelectedData: setSelectedData,
        selectedStats: selectedStats,
        setSelectedStats: setSelectedStats,
        showWinner: showWinner,
        setShowWinner: setShowWinner,
        showValues: showValues,
        setShowValues: setShowValues,
        showTitle: showTitle,
        setShowTitle: setShowTitle,
        title: title,
        setTitle: setTitle,
        showTeams: showTeams,
        setShowTeams: setShowTeams,
        triggerSearchOpen: triggerSearchOpen,
        setTriggerSearchOpen: setTriggerSearchOpen,
        winnerStats: winnerStats,
        setWinnerStats: setWinnerStats,
        hiddenPlayers: hiddenPlayers,
        setHiddenPlayers: setHiddenPlayers
    };
}
function $73d0d5c3cc042e8a$var$ComparisonToolView({ layoutWidth: layoutWidth, shared: shared, exportSvgRef: exportSvgRef, handleDownload: handleDownload, isDownloading: isDownloading }) {
    const mode = (0, $274a679b157dfc10$export$b06374babe9615a7)();
    const windowWidth = layoutWidth;
    const isExport = mode === 'export';
    const dimensions = (0, $116a259e7f6314e7$export$d1aa971bf69c7e87)(windowWidth);
    const { SVG_WIDTH: SVG_WIDTH, MAX_FULL_PLAYERS: MAX_FULL_PLAYERS, MAX_TOTAL_PLAYERS: MAX_TOTAL_PLAYERS, ADD_BUTTON_DIM: ADD_BUTTON_DIM, TEXT_RIGHT_SIDE: TEXT_RIGHT_SIDE, SLIDER_OFFSET_FROM_TEXT: SLIDER_OFFSET_FROM_TEXT, BETWEEN_PLAYERS_BUFFER: BETWEEN_PLAYERS_BUFFER, LOGO_WIDTH: LOGO_WIDTH, TOP_BUFFER: TOP_BUFFER, TITLE_TOP_BUFFER: TITLE_TOP_BUFFER, isMobile: isMobile } = dimensions;
    const { selectedData: selectedData, setSelectedData: setSelectedData, selectedStats: selectedStats, setSelectedStats: setSelectedStats, showWinner: showWinner, setShowWinner: setShowWinner, showValues: showValues, setShowValues: setShowValues, showTitle: showTitle, setShowTitle: setShowTitle, title: title, setTitle: setTitle, showTeams: showTeams, setShowTeams: setShowTeams, triggerSearchOpen: triggerSearchOpen, setTriggerSearchOpen: setTriggerSearchOpen, winnerStats: winnerStats, setWinnerStats: setWinnerStats, hiddenPlayers: hiddenPlayers, setHiddenPlayers: setHiddenPlayers } = shared;
    const [hoveredPlayer, setHoveredPlayer] = (0, $63Xef.useState)(null);
    const [hoveredAddPlayer, setHoveredAddPlayer] = (0, $63Xef.useState)(false);
    const [hoveredPanRight, setHoveredPanRight] = (0, $63Xef.useState)(false);
    const [hoveredPanLeft, setHoveredPanLeft] = (0, $63Xef.useState)(false);
    const [hoveredAddStat, setHoveredAddStat] = (0, $63Xef.useState)(false);
    const [mobilePageIndex, setMobilePageIndex] = (0, $63Xef.useState)(0);
    const [maxMobileIndex, setMaxMobileIndex] = (0, $63Xef.useState)(0);
    const searchRef = (0, $63Xef.useRef)(null);
    const statRef = (0, $63Xef.useRef)(null);
    (0, $63Xef.useEffect)(()=>{
        if (triggerSearchOpen && searchRef.current) {
            searchRef.current.showPopover();
            setTriggerSearchOpen(false);
        }
    }, [
        triggerSearchOpen,
        shared
    ]);
    (0, $63Xef.useEffect)(()=>{
        setMaxMobileIndex(Math.max(0, selectedData.players.length - (0, $c30e918aac675a8e$export$814b8053e322886a)));
    }, [
        selectedData
    ]);
    const possibleStats = (0, $b9c7b02947e449f9$export$4fe8a8e93e7610e3).filter((field)=>field.includes('percent_rank_'));
    const dataMappedByPlayer = selectedData.dataToUse.reduce((acc, curr)=>{
        acc[`${curr.id}-${curr.year}-${curr.grouping_cat?.toLowerCase()}`] = curr;
        return acc;
    }, {});
    const isEmpty = selectedData.players.length === 0;
    const isFull = selectedData.players.length === MAX_TOTAL_PLAYERS;
    const isNarrow = selectedData.players.length > MAX_FULL_PLAYERS;
    const currentType = (0, $3bbd855fb8f896f2$export$e2b5c5db9e2009fd)(selectedData);
    const lastActiveType = (0, $63Xef.useRef)(currentType);
    (0, $63Xef.useEffect)(()=>{
        if (!isEmpty && currentType) lastActiveType.current = currentType;
    }, [
        currentType,
        isEmpty
    ]);
    const groupedSelects = (0, $89d260932605bcde$export$f03f2f56ee474855)(selectedStats, currentType);
    const existingTypes = Object.keys(groupedSelects).filter((type)=>groupedSelects[type].length > 0);
    const winners = {};
    if (!isEmpty) selectedStats.forEach((stat)=>{
        const valueKey = (0, $b9c7b02947e449f9$export$46118f863c8123c6)(stat);
        let winner = selectedData.players[0].id;
        selectedData.players.forEach((playerObj)=>{
            const player = playerObj.id;
            const flipType = (0, $b9c7b02947e449f9$export$d7b39d8a41476f9).includes(stat) && currentType === 'batter' || (0, $b9c7b02947e449f9$export$f861e6885e7b9ed2).includes(stat) && currentType === 'pitcher';
            if (Number(dataMappedByPlayer[player][valueKey]) >= Number(dataMappedByPlayer[winner][valueKey]) && !flipType && dataMappedByPlayer[player][stat] !== null) winner = player;
            if (Number(dataMappedByPlayer[player][valueKey]) < Number(dataMappedByPlayer[winner][valueKey]) && flipType && dataMappedByPlayer[player][stat] !== null) winner = player;
            if (dataMappedByPlayer[player][valueKey] !== null && dataMappedByPlayer[winner][valueKey] === null) winner = player;
        });
        if (dataMappedByPlayer[winner][stat] !== null) winners[stat] = winner;
    });
    const handleAddWinnerStat = (0, $63Xef.useCallback)((thisStat)=>{
        setWinnerStats((prev)=>prev.includes(thisStat) ? prev.filter((stat)=>stat !== thisStat) : [
                ...prev,
                thisStat
            ]);
    }, [
        setWinnerStats
    ]);
    const handleAddPlayer = (0, $63Xef.useCallback)(async (row)=>{
        if (row.length === 0) {
            setSelectedData({
                dataToUse: [],
                players: []
            });
            return;
        }
        const newType = row[0].playerData.grouping_cat.toLowerCase();
        const newPos = row[0].playerData.pos;
        const isAllInfielders = row.map((elem)=>elem.playerData.pos).every((pos)=>pos && ![
                '7',
                '8',
                '9'
            ].includes(pos));
        if (newType !== lastActiveType.current) {
            setSelectedStats(newType === 'pitcher' ? (0, $b9c7b02947e449f9$export$6566ad5760f0adbd) : (0, $b9c7b02947e449f9$export$e390961395122d59));
            lastActiveType.current = newType;
        }
        const sortedSelectedStats = [
            ...selectedStats
        ].sort();
        const sortedDefaultStats = [
            ...(0, $b9c7b02947e449f9$export$e390961395122d59)
        ].sort();
        const isDefaultBattingStats = sortedSelectedStats.every((val, index)=>val === sortedDefaultStats[index]);
        if (newPos && newPos === '2') setSelectedStats((0, $b9c7b02947e449f9$export$774c5be6702fcac5));
        else if (isAllInfielders && isDefaultBattingStats && newType === 'batter') setSelectedStats((0, $b9c7b02947e449f9$export$e390961395122d59).filter((stat)=>stat !== 'percent_rank_fielding_run_value_arm'));
        let url = `/comparison-tool/services/`;
        let objString = ``;
        row.forEach((player)=>{
            objString += `${(0, $3bbd855fb8f896f2$export$aa1a1894961eafab)(player.playerData)},`;
        });
        objString = objString.slice(0, -1);
        url += objString;
        const { playerData: playerData } = await fetch(url).then((res)=>res.json());
        const newPlayers = row.map((newRow)=>({
                id: newRow.playerData.uniqueId,
                displayOrder: newRow.displayOrder
            })).sort((a, b)=>a.displayOrder - b.displayOrder);
        setSelectedData({
            players: newPlayers,
            dataToUse: playerData
        });
        if (isMobile) setMobilePageIndex(maxMobileIndex);
    }, [
        selectedData
    ]);
    const handleAddStat = (0, $63Xef.useCallback)((row)=>{
        setSelectedStats(row);
    }, [
        selectedStats
    ]);
    const handleRemoveStat = (0, $63Xef.useCallback)((thisStat)=>{
        setSelectedStats((prev)=>prev.filter((stat)=>stat !== thisStat));
    }, [
        selectedStats
    ]);
    function handleRemovePlayer(player) {
        const players = selectedData.players.filter((p)=>p.id !== player);
        const dataToUse = selectedData.dataToUse.filter((d)=>d.uniqueId !== player);
        setSelectedData({
            players: players,
            dataToUse: dataToUse
        });
    }
    function toggleHidePlayer(playerId) {
        setHiddenPlayers((prev)=>prev.includes(playerId) ? prev.filter((id)=>id !== playerId) : [
                ...prev,
                playerId
            ]);
    }
    let rightBufferToUse = isMobile ? (0, $c30e918aac675a8e$export$c532d128cda1c211) : (0, $c30e918aac675a8e$export$c532d128cda1c211) + 10;
    if (!isMobile && isFull) // No add button, okay to squeeze
    rightBufferToUse -= 20;
    (0, $63Xef.useEffect)(()=>{
        if (mobilePageIndex > maxMobileIndex) setMobilePageIndex(maxMobileIndex);
    }, [
        maxMobileIndex,
        mobilePageIndex
    ]);
    // Sort players by displayOrder for rendering
    const sortedPlayers = [
        ...selectedData.players
    ].sort((a, b)=>a.displayOrder - b.displayOrder);
    const displayedPlayers = !isExport && isMobile && selectedData.players.length > (0, $c30e918aac675a8e$export$814b8053e322886a) ? sortedPlayers.slice(mobilePageIndex, mobilePageIndex + (0, $c30e918aac675a8e$export$814b8053e322886a)) : sortedPlayers;
    const showPanRightButton = !isExport && isMobile;
    const fillPanRightButton = showPanRightButton && selectedData.players.length > (0, $c30e918aac675a8e$export$814b8053e322886a) && mobilePageIndex < maxMobileIndex;
    const showPanLeftButton = !isExport && isMobile;
    const fillPanLeftButton = showPanLeftButton && selectedData.players.length > (0, $c30e918aac675a8e$export$814b8053e322886a) && mobilePageIndex > 0;
    const showAddButton = !isExport && (!isFull || isMobile) && !isEmpty;
    const fillAddButton = isMobile && !isFull;
    let panRightOpacity = hoveredPanRight ? 1 : 0.2;
    let panLeftOpacity = hoveredPanLeft ? 1 : 0.2;
    let addOpacity = hoveredAddPlayer ? 1 : 0.2;
    if (fillPanRightButton) panRightOpacity = 0.5;
    if (fillPanLeftButton) panLeftOpacity = 0.5;
    if (fillAddButton) addOpacity = 0.5;
    const showAddStatButton = !isExport && !isEmpty && !(0, $3bbd855fb8f896f2$export$4942fc4b735d021a)(selectedStats, currentType, showTitle, showTeams, false, dimensions);
    const safeDenom = isEmpty ? 1 : displayedPlayers.length;
    const totalSliderPixelsAvailable = SVG_WIDTH - (0, $c30e918aac675a8e$export$5027f20781e606c3) - SLIDER_OFFSET_FROM_TEXT - (0, $c30e918aac675a8e$export$b33658ea466e9e34) - rightBufferToUse;
    // N sliders and N-1 gaps
    const maxSliderWidth = (totalSliderPixelsAvailable - (safeDenom - 1) * BETWEEN_PLAYERS_BUFFER) / safeDenom;
    const rightMostXVal = (0, $c30e918aac675a8e$export$b33658ea466e9e34) + SLIDER_OFFSET_FROM_TEXT + totalSliderPixelsAvailable;
    const buttonStart = rightMostXVal + (rightBufferToUse - ADD_BUTTON_DIM) / 2;
    const bottomMostYVal = existingTypes.length * ((0, $c30e918aac675a8e$export$ffbf6d1bcd3c71b1) + (0, $c30e918aac675a8e$export$32080fe92cae43a2)) + selectedStats.length * (0, $c30e918aac675a8e$export$42510bee89f29ff9) + TOP_BUFFER + 5;
    const logoXVal = ((0, $c30e918aac675a8e$export$5027f20781e606c3) + (0, $c30e918aac675a8e$export$b33658ea466e9e34) + SLIDER_OFFSET_FROM_TEXT) / 2 + (0, $c30e918aac675a8e$export$b33658ea466e9e34);
    const handleDragOver = (event)=>{
        const { operation: operation } = event;
        const { source: source, target: target } = operation;
        if ((0, $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f)(source) && (0, $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f)(target)) {
            const overIndex = target.sortable.index;
            const activeIndex = source.sortable.index;
            if (activeIndex !== overIndex) setSelectedData((prev)=>{
                // Get visual order and perform the move
                const currentVisualOrder = [
                    ...prev.players
                ].sort((a, b)=>a.displayOrder - b.displayOrder);
                const reordered = (0, $d9ca3e6570e7a9a7$export$5d49d615ad5ea2b0)(currentVisualOrder, activeIndex, overIndex);
                // Re-map displayOrder so the indices match the new slots
                const newPlayers = reordered.map((p, i)=>({
                        ...p,
                        displayOrder: i
                    }));
                return {
                    ...prev,
                    players: newPlayers
                };
            });
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleStatReorder = (event)=>{
        const { operation: operation } = event;
        const { source: source, target: target } = operation;
        if ((0, $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f)(source) && (0, $0d4c5512f6ac0f65$export$3ddbb0dc85c62e5f)(target)) {
            const activeId = source.id;
            const overId = target.id;
            const sourceGroup = source.sortable.group;
            const targetGroup = target.sortable.group;
            if (sourceGroup !== targetGroup) return;
            if (activeId !== overId) setSelectedStats((prev)=>{
                const oldIndex = prev.indexOf(activeId);
                const newIndex = prev.indexOf(overId);
                return (0, $d9ca3e6570e7a9a7$export$5d49d615ad5ea2b0)(prev, oldIndex, newIndex);
            });
        }
    };
    const teamOffset = showTeams ? 0 : -(0, $c30e918aac675a8e$export$efd0951432a78968);
    const titleOffset = showTitle && title.trim() !== '' ? (0, $c30e918aac675a8e$export$3d67df41657f4f21) : 0;
    const titleWillOverflow = (0, $3bbd855fb8f896f2$export$4942fc4b735d021a)(selectedStats, currentType, true, showTeams, true, dimensions);
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
        className: "App",
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $116a259e7f6314e7$export$a31e22a91fd34dd9), {
                width: windowWidth,
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $7d57415ac2032ee5$export$a6431530a8ce8288), {
                        plugins: (defaults)=>defaults.filter((plugin)=>plugin !== (0, $4e1e107797f01458$export$305ce2ba97930a0b)),
                        onDragStart: ()=>{
                            document.body.style.overflow = 'hidden';
                        },
                        onDragEnd: ()=>{
                            document.body.style.overflow = '';
                        },
                        onDragOver: handleDragOver,
                        modifiers: [
                            (0, $b2d051ff65b2716c$export$35828f5146a69550)
                        ],
                        sensors: (defaults)=>[
                                ...defaults.filter((sensor)=>sensor !== (0, $4e1e107797f01458$export$b26af955418d6638)),
                                (0, $4e1e107797f01458$export$b26af955418d6638).configure({
                                    activationConstraints: [
                                        new (0, $4e1e107797f01458$export$863a6e64d6b9f7f4).Distance({
                                            value: 12
                                        }),
                                        new (0, $4e1e107797f01458$export$863a6e64d6b9f7f4).Delay({
                                            value: 300,
                                            tolerance: 10
                                        })
                                    ]
                                })
                            ],
                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("svg", {
                            className: "comp-tool-canvas",
                            width: SVG_WIDTH,
                            height: (0, $c30e918aac675a8e$export$b1b9c9c1bf44cff1),
                            ref: isExport ? exportSvgRef : undefined,
                            viewBox: `0 0 ${SVG_WIDTH} ${(0, $c30e918aac675a8e$export$b1b9c9c1bf44cff1)}`,
                            children: [
                                showTitle && title.trim() !== '' && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                                    id: `${mode}-comp-tool-title`,
                                    transform: `translate(${SVG_WIDTH / 2}, ${TITLE_TOP_BUFFER})`,
                                    children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                                        textAnchor: "middle" // This perfectly centers the text on the X coordinate
                                        ,
                                        dominantBaseline: "hanging",
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                        fill: "#333333",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                    transform: `translate(0, ${titleOffset})`,
                                    style: {
                                        transition: 'transform 0.2s ease-in-out'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                                            id: `${mode}-comp-tool-logo`,
                                            transform: `translate(${logoXVal}, ${(0, $c30e918aac675a8e$export$e9c958d09f7b22f1)})`,
                                            children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $4a03643c08dcc28d$export$2e2bcd8739ae039), {
                                                width: showTeams ? LOGO_WIDTH : LOGO_WIDTH - 4
                                            })
                                        }),
                                        !isExport && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $ffe32689a08c22af$export$2e2bcd8739ae039), {}),
                                        !isExport && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $c3d23191c71b1579$export$2e2bcd8739ae039), {
                                            isEmpty: isEmpty,
                                            onDownload: ()=>handleDownload()
                                        }),
                                        !isEmpty && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                                            id: `${mode}-comp-tool-section-headers`,
                                            children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $1265ce229938dbe6$export$2e2bcd8739ae039), {
                                                numPlayers: displayedPlayers.length,
                                                groupedSelects: groupedSelects,
                                                existingTypes: existingTypes,
                                                maxSliderWidth: maxSliderWidth,
                                                showTeams: showTeams,
                                                currentType: currentType,
                                                isMobile: isMobile
                                            })
                                        }),
                                        isEmpty && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                            transform: `translate(${SVG_WIDTH / 2}, ${(0, $c30e918aac675a8e$export$b1b9c9c1bf44cff1) / 2})`,
                                            onClick: ()=>{
                                                searchRef.current?.showPopover();
                                            },
                                            style: {
                                                cursor: 'pointer',
                                                transition: 'opacity 0.2s'
                                            },
                                            onMouseEnter: (e)=>{
                                                e.currentTarget.style.opacity = '0.7';
                                            },
                                            onMouseLeave: (e)=>{
                                                e.currentTarget.style.opacity = '1';
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                                                    x: -(0, $c30e918aac675a8e$export$aa2a010d1dfd7cc8) / 2,
                                                    y: -TOP_BUFFER / 2,
                                                    width: (0, $c30e918aac675a8e$export$aa2a010d1dfd7cc8),
                                                    height: TOP_BUFFER,
                                                    rx: 8,
                                                    fill: (0, $c30e918aac675a8e$export$4bdbd8698c928034),
                                                    fillOpacity: 0.05,
                                                    stroke: (0, $c30e918aac675a8e$export$4bdbd8698c928034),
                                                    strokeWidth: 1.5
                                                }),
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                                                    x: 0,
                                                    y: -12,
                                                    fill: (0, $c30e918aac675a8e$export$2200862f6453cab4),
                                                    className: "no-players-text",
                                                    children: "No players selected!"
                                                }),
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("text", {
                                                    x: 0,
                                                    y: 12,
                                                    fill: (0, $c30e918aac675a8e$export$2200862f6453cab4),
                                                    className: "no-players-text",
                                                    children: "Click to select players"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                            transform: `translate(${(0, $c30e918aac675a8e$export$5027f20781e606c3)}, 0)`,
                                            children: [
                                                !isEmpty && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $57dcd83b3f7f2771$export$2e2bcd8739ae039), {
                                                    groupedSelects: groupedSelects,
                                                    existingTypes: existingTypes,
                                                    currentType: currentType,
                                                    onRemoveStat: handleRemoveStat,
                                                    onStatReorder: handleStatReorder,
                                                    selectedStats: selectedStats,
                                                    showTeams: showTeams,
                                                    winnerStats: winnerStats,
                                                    onAddWinnerStat: handleAddWinnerStat
                                                }),
                                                displayedPlayers.map((playerObj, i)=>{
                                                    const player = playerObj.id;
                                                    const thisData = dataMappedByPlayer[player];
                                                    const xVal = (0, $c30e918aac675a8e$export$b33658ea466e9e34) + SLIDER_OFFSET_FROM_TEXT + i * (BETWEEN_PLAYERS_BUFFER + maxSliderWidth);
                                                    const xButtonOffset = isMobile ? 18 : 28;
                                                    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $2f9510a59088c740$export$2e2bcd8739ae039), {
                                                        id: player,
                                                        index: i,
                                                        offset: xVal,
                                                        type: "player",
                                                        maxSliderWidth: maxSliderWidth,
                                                        bottomMostYVal: bottomMostYVal,
                                                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                                            onMouseEnter: ()=>setHoveredPlayer(player),
                                                            onMouseLeave: ()=>setHoveredPlayer(null),
                                                            pointerEvents: "auto",
                                                            children: [
                                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                                                                    x: 0,
                                                                    y: 0,
                                                                    width: maxSliderWidth,
                                                                    height: bottomMostYVal,
                                                                    fill: "transparent",
                                                                    pointerEvents: "all" // Forces the empty space to catch hover events
                                                                }),
                                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $75531e5f44085736$export$2e2bcd8739ae039), {
                                                                    selects: selectedStats,
                                                                    playerData: thisData,
                                                                    groupedSelects: groupedSelects,
                                                                    existingTypes: existingTypes,
                                                                    maxSliderWidth: maxSliderWidth,
                                                                    showValues: showValues,
                                                                    showWinner: showWinner,
                                                                    winners: winners,
                                                                    isNarrow: isNarrow,
                                                                    summaryStats: summaryStats,
                                                                    currentType: currentType,
                                                                    showTeams: showTeams,
                                                                    winnerStats: winnerStats,
                                                                    isHidden: hiddenPlayers.includes(player)
                                                                }, player),
                                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                                                                    x: 0,
                                                                    y: (0, $c30e918aac675a8e$export$e9c958d09f7b22f1),
                                                                    width: maxSliderWidth,
                                                                    height: TOP_BUFFER,
                                                                    stroke: "none",
                                                                    fill: "transparent",
                                                                    strokeWidth: "1px"
                                                                }),
                                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                                                                    onPointerDown: (e)=>{
                                                                        e.stopPropagation();
                                                                    },
                                                                    onMouseDown: (e)=>{
                                                                        e.stopPropagation();
                                                                    },
                                                                    onClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        handleRemovePlayer(player);
                                                                    },
                                                                    style: {
                                                                        opacity: hoveredPlayer === player ? 1 : 0,
                                                                        pointerEvents: hoveredPlayer === player ? 'auto' : 'none'
                                                                    },
                                                                    className: "remove-button-x-elem",
                                                                    children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $5d4181c52df08ae8$export$2e2bcd8739ae039), {
                                                                        x: maxSliderWidth / 2 + xButtonOffset,
                                                                        y: (0, $c30e918aac675a8e$export$e9c958d09f7b22f1) + 2,
                                                                        symbol: "\xd7"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                                                                    onPointerDown: (e)=>{
                                                                        e.stopPropagation();
                                                                    },
                                                                    onMouseDown: (e)=>{
                                                                        e.stopPropagation();
                                                                    },
                                                                    onClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        toggleHidePlayer(player);
                                                                    },
                                                                    style: {
                                                                        opacity: hoveredPlayer === player ? 1 : 0,
                                                                        pointerEvents: hoveredPlayer === player ? 'auto' : 'none'
                                                                    },
                                                                    className: "remove-button-x-elem",
                                                                    children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $5d4181c52df08ae8$export$2e2bcd8739ae039), {
                                                                        x: maxSliderWidth / 2 - xButtonOffset,
                                                                        y: (0, $c30e918aac675a8e$export$e9c958d09f7b22f1) + 2,
                                                                        symbol: "H",
                                                                        isEye: true,
                                                                        isCrossed: !hiddenPlayers.includes(player)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, player);
                                                }),
                                                showAddButton && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                                    transform: `translate(${buttonStart}, 0)`,
                                                    onMouseEnter: ()=>setHoveredAddPlayer(true),
                                                    onMouseLeave: ()=>setHoveredAddPlayer(false),
                                                    onClick: ()=>{
                                                        setHoveredAddPlayer(false);
                                                        if (!isFull) searchRef.current?.showPopover();
                                                    },
                                                    id: `${mode}-comp-tool-add-player-wrapper`,
                                                    style: {
                                                        cursor: 'pointer',
                                                        opacity: addOpacity,
                                                        transition: 'opacity 0.2s ease-in-out'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                                                            x: 0,
                                                            y: isMobile ? (0, $c30e918aac675a8e$export$e9c958d09f7b22f1) + (TOP_BUFFER + (0, $c30e918aac675a8e$export$d08a6aed81c42d1e)) / 3 : (0, $c30e918aac675a8e$export$e9c958d09f7b22f1),
                                                            width: ADD_BUTTON_DIM,
                                                            height: isMobile ? (TOP_BUFFER - 2 * (0, $c30e918aac675a8e$export$d08a6aed81c42d1e)) / 3 : TOP_BUFFER,
                                                            rx: 8,
                                                            stroke: (0, $c30e918aac675a8e$export$4bdbd8698c928034),
                                                            fill: (0, $c30e918aac675a8e$export$4bdbd8698c928034)
                                                        }),
                                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $5d4181c52df08ae8$export$2e2bcd8739ae039), {
                                                            x: ADD_BUTTON_DIM / 2,
                                                            y: (0, $c30e918aac675a8e$export$e9c958d09f7b22f1) + TOP_BUFFER / 2,
                                                            symbol: "+"
                                                        })
                                                    ]
                                                }),
                                                showPanRightButton && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                                    transform: `translate(${buttonStart}, 0)`,
                                                    onMouseEnter: ()=>{
                                                        if (fillPanRightButton) setHoveredPanRight(true);
                                                    },
                                                    onMouseLeave: ()=>setHoveredPanRight(false),
                                                    onClick: ()=>{
                                                        setHoveredPanRight(false);
                                                        if (mobilePageIndex < maxMobileIndex) setMobilePageIndex((prev)=>prev + 1);
                                                    },
                                                    id: `${mode}-comp-tool-pan-player-right-wrapper`,
                                                    className: "remove-button-x-elem",
                                                    style: {
                                                        opacity: panRightOpacity
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                                                            x: 0,
                                                            y: (0, $c30e918aac675a8e$export$e9c958d09f7b22f1) + 2 * TOP_BUFFER / 3 + (0, $c30e918aac675a8e$export$d08a6aed81c42d1e) / 2,
                                                            width: ADD_BUTTON_DIM,
                                                            height: (TOP_BUFFER - 2 * (0, $c30e918aac675a8e$export$d08a6aed81c42d1e)) / 3,
                                                            rx: 8,
                                                            stroke: (0, $c30e918aac675a8e$export$4bdbd8698c928034),
                                                            fill: (0, $c30e918aac675a8e$export$4bdbd8698c928034)
                                                        }),
                                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $5d4181c52df08ae8$export$2e2bcd8739ae039), {
                                                            x: ADD_BUTTON_DIM / 2,
                                                            y: (0, $c30e918aac675a8e$export$e9c958d09f7b22f1) + (5 * TOP_BUFFER + 2 * (0, $c30e918aac675a8e$export$d08a6aed81c42d1e)) / 6,
                                                            symbol: ">"
                                                        })
                                                    ]
                                                }),
                                                showPanLeftButton && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                                    transform: `translate(${buttonStart}, 0)`,
                                                    onMouseEnter: ()=>{
                                                        if (fillPanLeftButton) setHoveredPanLeft(true);
                                                    },
                                                    onMouseLeave: ()=>setHoveredPanLeft(false),
                                                    onClick: ()=>{
                                                        setHoveredPanLeft(false);
                                                        if (mobilePageIndex > 0) setMobilePageIndex((prev)=>prev - 1);
                                                    },
                                                    id: `${mode}-comp-tool-pan-player-left-wrapper`,
                                                    className: "remove-button-x-elem",
                                                    style: {
                                                        opacity: panLeftOpacity
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                                                            x: 0,
                                                            y: (0, $c30e918aac675a8e$export$e9c958d09f7b22f1),
                                                            width: ADD_BUTTON_DIM,
                                                            height: (TOP_BUFFER - 2 * (0, $c30e918aac675a8e$export$d08a6aed81c42d1e)) / 3,
                                                            rx: 8,
                                                            stroke: (0, $c30e918aac675a8e$export$4bdbd8698c928034),
                                                            fill: (0, $c30e918aac675a8e$export$4bdbd8698c928034)
                                                        }),
                                                        /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $5d4181c52df08ae8$export$2e2bcd8739ae039), {
                                                            x: ADD_BUTTON_DIM / 2,
                                                            y: (0, $c30e918aac675a8e$export$e9c958d09f7b22f1) + (TOP_BUFFER - 2 * (0, $c30e918aac675a8e$export$d08a6aed81c42d1e)) / 6,
                                                            symbol: "<"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        showAddStatButton && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("g", {
                                            transform: `translate(${(0, $c30e918aac675a8e$export$b33658ea466e9e34)}, ${bottomMostYVal + teamOffset - 3})`,
                                            onMouseEnter: ()=>setHoveredAddStat(true),
                                            onMouseLeave: ()=>setHoveredAddStat(false),
                                            onClick: ()=>{
                                                statRef.current?.showPopover();
                                            },
                                            style: {
                                                cursor: 'pointer',
                                                opacity: hoveredAddStat ? 1 : 0.5,
                                                transition: 'opacity 0.2s ease-in-out'
                                            },
                                            id: `${mode}-comp-tool-add-stat-wrapper`,
                                            children: [
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("rect", {
                                                    x: 0,
                                                    y: 0,
                                                    width: TEXT_RIGHT_SIDE + (0, $c30e918aac675a8e$export$5027f20781e606c3),
                                                    height: (0, $c30e918aac675a8e$export$55ed14d99ea72130),
                                                    rx: 8,
                                                    stroke: (0, $c30e918aac675a8e$export$4bdbd8698c928034),
                                                    fill: (0, $c30e918aac675a8e$export$4bdbd8698c928034)
                                                }),
                                                /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $5d4181c52df08ae8$export$2e2bcd8739ae039), {
                                                    x: (TEXT_RIGHT_SIDE + (0, $c30e918aac675a8e$export$5027f20781e606c3)) / 2,
                                                    y: (0, $c30e918aac675a8e$export$55ed14d99ea72130) / 2,
                                                    symbol: "+"
                                                })
                                            ]
                                        }),
                                        isMobile && (showPanLeftButton || showPanRightButton) && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("g", {
                                            transform: `translate(${SVG_WIDTH - 20}, ${(0, $c30e918aac675a8e$export$e9c958d09f7b22f1) - 10})`,
                                            id: `${mode}-mobile-overflow-selection-label`,
                                            children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("text", {
                                                style: {
                                                    textAnchor: 'end',
                                                    fontSize: '11px'
                                                },
                                                children: [
                                                    "Showing",
                                                    ' ',
                                                    `${mobilePageIndex + 1}-${mobilePageIndex + (0, $c30e918aac675a8e$export$814b8053e322886a)}`,
                                                    ' ',
                                                    "of ",
                                                    sortedPlayers.length
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                isExport && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $8269aba2020fb66f$export$2e2bcd8739ae039), {
                                    width: SVG_WIDTH,
                                    height: (0, $c30e918aac675a8e$export$b1b9c9c1bf44cff1)
                                })
                            ]
                        })
                    }),
                    !isExport && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $56a6ed9b655689a9$export$2e2bcd8739ae039), {
                                searchRef: searchRef,
                                data: playerSeasons,
                                preloadedData: selectedData,
                                trendingBatters: trendingBatters.slice(0, 10),
                                trendingPitchers: trendingPitchers.slice(0, 10),
                                onAdd: handleAddPlayer
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $0ab6c81ecb67ced0$export$2e2bcd8739ae039), {
                                statRef: statRef,
                                stats: possibleStats,
                                selected: selectedStats,
                                currentType: currentType,
                                showTitle: showTitle,
                                showTeams: showTeams,
                                selectedPlayers: selectedData.dataToUse,
                                onAdd: handleAddStat
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $f3ae1b4b7becc640$export$2e2bcd8739ae039), {
                                showWinner: showWinner,
                                setShowWinner: setShowWinner,
                                showValues: showValues,
                                setShowValues: setShowValues,
                                showTitle: showTitle,
                                setShowTitle: setShowTitle,
                                title: title,
                                setTitle: setTitle,
                                showTeams: showTeams,
                                setShowTeams: setShowTeams,
                                handleDownload: handleDownload,
                                disableToggleTitle: !showTitle && titleWillOverflow
                            })
                        ]
                    })
                ]
            }),
            isDownloading && /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                className: "comp-tool-download-dialog-container",
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                        className: "comp-tool-download-spinner"
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                        className: "comp-tool-download-text",
                        children: "Generating Image..."
                    })
                ]
            })
        ]
    });
}
function $73d0d5c3cc042e8a$var$App() {
    const containerRef = (0, $63Xef.useRef)(null);
    const layoutWidth = (0, $116a259e7f6314e7$export$7ed924c3d8496d63)(containerRef);
    const shared = $73d0d5c3cc042e8a$var$useComparisonState();
    const exportSvgRef = (0, $63Xef.useRef)(null);
    const { isMobile: isMobile } = (0, $116a259e7f6314e7$export$d1aa971bf69c7e87)(layoutWidth);
    const [isDownloading, setIsDownloading] = (0, $63Xef.useState)(false);
    const handleDownload = (0, $63Xef.useCallback)((is16x9 = false)=>{
        // Always export from the hidden desktop-width view so mobile users get
        // the full desktop layout regardless of the current on-screen size.
        const exportSvg = exportSvgRef.current;
        if (exportSvg === null) return;
        setIsDownloading(true);
        // Rudimentary click analytics
        if (window.s) {
            const downloadType = `Comp tool ${isMobile ? 'mobile' : 'desktop'} download`;
            window.s.prop31 = downloadType;
            window.s.tl(true, 'd', downloadType);
        }
        // Size the export from the viewBox coordinate numbers, NOT clientWidth:
        // with `max-width: 100%` the painted width no longer equals the viewBox
        // width, so clientWidth/clientHeight are unreliable.
        const exportWidth = is16x9 ? (0, $116a259e7f6314e7$export$d1aa971bf69c7e87)((0, $116a259e7f6314e7$export$103f79687e655697)).SVG_WIDTH * (16 / 9) : (0, $116a259e7f6314e7$export$d1aa971bf69c7e87)((0, $116a259e7f6314e7$export$103f79687e655697)).SVG_WIDTH;
        const exportHeight = (0, $c30e918aac675a8e$export$b1b9c9c1bf44cff1);
        const svgClone = exportSvg.cloneNode(true);
        $73d0d5c3cc042e8a$var$explicitInlineStyles(exportSvg, svgClone);
        const styleNode = document.createElementNS('http://www.w3.org/2000/svg', 'style');
        styleNode.textContent = `
            .comp-tool-canvas text { font-family: 'Roboto Condensed', sans-serif !important; }
        `;
        svgClone.prepend(styleNode);
        // Paint at the viewBox aspect ratio (SVG_WIDTH:SVG_HEIGHT); pixelRatio
        // below controls the actual output resolution.
        svgClone.style.width = `${exportWidth}px`;
        svgClone.style.height = `${exportHeight}px`;
        svgClone.setAttribute('width', `${exportWidth}`);
        svgClone.setAttribute('height', `${exportHeight}`);
        const hiddenDiv = document.createElement('div');
        hiddenDiv.style.position = 'absolute';
        hiddenDiv.style.top = '0px';
        hiddenDiv.style.left = '0px';
        hiddenDiv.style.zIndex = '-1000';
        hiddenDiv.style.opacity = '0';
        hiddenDiv.style.pointerEvents = 'none';
        hiddenDiv.style.width = `${exportWidth}px`;
        hiddenDiv.style.height = `${exportHeight}px`;
        hiddenDiv.style.backgroundColor = '#ffffff';
        document.body.appendChild(hiddenDiv);
        hiddenDiv.appendChild(svgClone);
        (0, $ce7b66f3f228e494$export$aba256f33615c92e)(hiddenDiv, {
            quality: 0.95,
            pixelRatio: 3,
            backgroundColor: '#ffffff',
            style: {
                opacity: '1'
            }
        }).then(async (dataUrl)=>{
            if (isMobile && navigator.canShare) try {
                const response = await fetch(dataUrl);
                const blob = await response.blob();
                const file = new File([
                    blob
                ], 'savant-comparison.png', {
                    type: 'image/png'
                });
                if (navigator.canShare({
                    files: [
                        file
                    ]
                })) {
                    await navigator.share({
                        title: 'Baseball Savant Comparison',
                        text: 'Check out this player comparison from Baseball Savant!',
                        files: [
                            file
                        ]
                    });
                    return;
                }
            } catch (error) {
                console.error('Sharing failed or was aborted:', error);
            }
            const link = document.createElement('a');
            link.download = 'savant-comparison-tool.png';
            link.href = dataUrl;
            link.click();
        }).catch((error)=>{
            console.error('png generation failed', error);
        }).finally(()=>{
            setIsDownloading(false);
            if (document.body.contains(hiddenDiv)) document.body.removeChild(hiddenDiv);
        });
    }, [
        exportSvgRef,
        isMobile
    ]);
    return /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)((0, $d297014a5c3795d0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                ref: containerRef,
                className: "comp-tool-container",
                children: [
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsxs)("div", {
                        style: {
                            maxWidth: `${(0, $116a259e7f6314e7$export$103f79687e655697)}px`,
                            margin: '0 auto',
                            width: '100%',
                            marginBottom: '5px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn-default",
                                onClick: ()=>handleDownload(),
                                style: {
                                    marginRight: '5px'
                                },
                                children: `${isMobile ? 'Share' : 'Download'} Image`
                            }),
                            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn-default",
                                onClick: ()=>shared.setSelectedData({
                                        dataToUse: [],
                                        players: []
                                    }),
                                children: "Clear Players"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $274a679b157dfc10$export$db312fdadd91e8fe), {
                        mode: "interactive",
                        children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)($73d0d5c3cc042e8a$var$ComparisonToolView, {
                            layoutWidth: layoutWidth,
                            shared: shared,
                            exportSvgRef: exportSvgRef,
                            handleDownload: handleDownload,
                            isDownloading: isDownloading
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)("div", {
                "aria-hidden": "true",
                style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    opacity: 0,
                    pointerEvents: 'none',
                    zIndex: -1000,
                    overflow: 'hidden'
                },
                children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $274a679b157dfc10$export$db312fdadd91e8fe), {
                    mode: "export",
                    children: /*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)($73d0d5c3cc042e8a$var$ComparisonToolView, {
                        layoutWidth: (0, $116a259e7f6314e7$export$103f79687e655697),
                        shared: shared,
                        exportSvgRef: exportSvgRef,
                        handleDownload: handleDownload,
                        isDownloading: isDownloading
                    })
                })
            })
        ]
    });
}
var $73d0d5c3cc042e8a$export$2e2bcd8739ae039 = $73d0d5c3cc042e8a$var$App;


const $097ffa89ba357c34$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8bad1b53a8edf91c$exports))).createRoot(document.getElementById('root'));
$097ffa89ba357c34$var$root.render(/*#__PURE__*/ (0, $d297014a5c3795d0$exports.jsx)((0, $73d0d5c3cc042e8a$export$2e2bcd8739ae039), {}));



})();
//# sourceMappingURL=comparison-tool.js.map
